;(function() {
      function Ww(i) {
        return i &&
          i.__esModule &&
          Object.prototype.hasOwnProperty.call(i, 'default')
          ? i.default
          : i;
      }
      var ip = { exports: {} },
        pu = {},
        lp = { exports: {} },
        hu = { exports: {} },
        J1;
      function $w() {
        return (
          J1 ||
            ((J1 = 1),
            (function (i, l) {
              /**
               * @license React
               * react.development.js
               *
               * Copyright (c) Meta Platforms, Inc. and affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */ (function () {
                function o(N, O) {
                  Object.defineProperty(d.prototype, N, {
                    get: function () {
                      console.warn(
                        '%s(...) is deprecated in plain JavaScript React classes. %s',
                        O[0],
                        O[1]
                      );
                    },
                  });
                }
                function r(N) {
                  return N === null || typeof N != 'object'
                    ? null
                    : ((N = (Bi && N[Bi]) || N['@@iterator']),
                      typeof N == 'function' ? N : null);
                }
                function u(N, O) {
                  N =
                    ((N = N.constructor) && (N.displayName || N.name)) ||
                    'ReactClass';
                  var ne = N + '.' + O;
                  Os[ne] ||
                    (console.error(
                      "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
                      O,
                      N
                    ),
                    (Os[ne] = !0));
                }
                function d(N, O, ne) {
                  ((this.props = N),
                    (this.context = O),
                    (this.refs = ks),
                    (this.updater = ne || Za));
                }
                function p() {}
                function h(N, O, ne) {
                  ((this.props = N),
                    (this.context = O),
                    (this.refs = ks),
                    (this.updater = ne || Za));
                }
                function m(N) {
                  return '' + N;
                }
                function y(N) {
                  try {
                    var O = !1;
                  } catch {
                    O = !0;
                  }
                  if (O) {
                    O = console;
                    var ne = O.error,
                      ie =
                        (typeof Symbol == 'function' &&
                          Symbol.toStringTag &&
                          N[Symbol.toStringTag]) ||
                        N.constructor.name ||
                        'Object';
                    return (
                      ne.call(
                        O,
                        'The provided key is an unsupported type %s. This value must be coerced to a string before using it here.',
                        ie
                      ),
                      m(N)
                    );
                  }
                }
                function E(N) {
                  if (N == null) return null;
                  if (typeof N == 'function')
                    return N.$$typeof === Ou
                      ? null
                      : N.displayName || N.name || null;
                  if (typeof N == 'string') return N;
                  switch (N) {
                    case W:
                      return 'Fragment';
                    case ue:
                      return 'Profiler';
                    case re:
                      return 'StrictMode';
                    case Le:
                      return 'Suspense';
                    case Vi:
                      return 'SuspenseList';
                    case Dn:
                      return 'Activity';
                  }
                  if (typeof N == 'object')
                    switch (
                      (typeof N.tag == 'number' &&
                        console.error(
                          'Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.'
                        ),
                      N.$$typeof)
                    ) {
                      case me:
                        return 'Portal';
                      case et:
                        return (N.displayName || 'Context') + '.Provider';
                      case Ue:
                        return (
                          (N._context.displayName || 'Context') + '.Consumer'
                        );
                      case zt:
                        var O = N.render;
                        return (
                          (N = N.displayName),
                          N ||
                            ((N = O.displayName || O.name || ''),
                            (N =
                              N !== ''
                                ? 'ForwardRef(' + N + ')'
                                : 'ForwardRef')),
                          N
                        );
                      case lt:
                        return (
                          (O = N.displayName || null),
                          O !== null ? O : E(N.type) || 'Memo'
                        );
                      case Mt:
                        ((O = N._payload), (N = N._init));
                        try {
                          return E(N(O));
                        } catch {}
                    }
                  return null;
                }
                function v(N) {
                  if (N === W) return '<>';
                  if (typeof N == 'object' && N !== null && N.$$typeof === Mt)
                    return '<...>';
                  try {
                    var O = E(N);
                    return O ? '<' + O + '>' : '<...>';
                  } catch {
                    return '<...>';
                  }
                }
                function S() {
                  var N = Me.A;
                  return N === null ? null : N.getOwner();
                }
                function x() {
                  return Error('react-stack-top-frame');
                }
                function D(N) {
                  if (Li.call(N, 'key')) {
                    var O = Object.getOwnPropertyDescriptor(N, 'key').get;
                    if (O && O.isReactWarning) return !1;
                  }
                  return N.key !== void 0;
                }
                function M(N, O) {
                  function ne() {
                    Ka ||
                      ((Ka = !0),
                      console.error(
                        '%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)',
                        O
                      ));
                  }
                  ((ne.isReactWarning = !0),
                    Object.defineProperty(N, 'key', {
                      get: ne,
                      configurable: !0,
                    }));
                }
                function k() {
                  var N = E(this.type);
                  return (
                    _s[N] ||
                      ((_s[N] = !0),
                      console.error(
                        'Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.'
                      )),
                    (N = this.props.ref),
                    N !== void 0 ? N : null
                  );
                }
                function V(N, O, ne, ie, pe, Ae, De, ze) {
                  return (
                    (ne = Ae.ref),
                    (N = {
                      $$typeof: F,
                      type: N,
                      key: O,
                      props: Ae,
                      _owner: pe,
                    }),
                    (ne !== void 0 ? ne : null) !== null
                      ? Object.defineProperty(N, 'ref', {
                          enumerable: !1,
                          get: k,
                        })
                      : Object.defineProperty(N, 'ref', {
                          enumerable: !1,
                          value: null,
                        }),
                    (N._store = {}),
                    Object.defineProperty(N._store, 'validated', {
                      configurable: !1,
                      enumerable: !1,
                      writable: !0,
                      value: 0,
                    }),
                    Object.defineProperty(N, '_debugInfo', {
                      configurable: !1,
                      enumerable: !1,
                      writable: !0,
                      value: null,
                    }),
                    Object.defineProperty(N, '_debugStack', {
                      configurable: !1,
                      enumerable: !1,
                      writable: !0,
                      value: De,
                    }),
                    Object.defineProperty(N, '_debugTask', {
                      configurable: !1,
                      enumerable: !1,
                      writable: !0,
                      value: ze,
                    }),
                    Object.freeze && (Object.freeze(N.props), Object.freeze(N)),
                    N
                  );
                }
                function L(N, O) {
                  return (
                    (O = V(
                      N.type,
                      O,
                      void 0,
                      void 0,
                      N._owner,
                      N.props,
                      N._debugStack,
                      N._debugTask
                    )),
                    N._store && (O._store.validated = N._store.validated),
                    O
                  );
                }
                function U(N) {
                  return typeof N == 'object' && N !== null && N.$$typeof === F;
                }
                function Y(N) {
                  var O = { '=': '=0', ':': '=2' };
                  return (
                    '$' +
                    N.replace(/[=:]/g, function (ne) {
                      return O[ne];
                    })
                  );
                }
                function G(N, O) {
                  return typeof N == 'object' && N !== null && N.key != null
                    ? (y(N.key), Y('' + N.key))
                    : O.toString(36);
                }
                function P() {}
                function Q(N) {
                  switch (N.status) {
                    case 'fulfilled':
                      return N.value;
                    case 'rejected':
                      throw N.reason;
                    default:
                      switch (
                        (typeof N.status == 'string'
                          ? N.then(P, P)
                          : ((N.status = 'pending'),
                            N.then(
                              function (O) {
                                N.status === 'pending' &&
                                  ((N.status = 'fulfilled'), (N.value = O));
                              },
                              function (O) {
                                N.status === 'pending' &&
                                  ((N.status = 'rejected'), (N.reason = O));
                              }
                            )),
                        N.status)
                      ) {
                        case 'fulfilled':
                          return N.value;
                        case 'rejected':
                          throw N.reason;
                      }
                  }
                  throw N;
                }
                function X(N, O, ne, ie, pe) {
                  var Ae = typeof N;
                  (Ae === 'undefined' || Ae === 'boolean') && (N = null);
                  var De = !1;
                  if (N === null) De = !0;
                  else
                    switch (Ae) {
                      case 'bigint':
                      case 'string':
                      case 'number':
                        De = !0;
                        break;
                      case 'object':
                        switch (N.$$typeof) {
                          case F:
                          case me:
                            De = !0;
                            break;
                          case Mt:
                            return (
                              (De = N._init),
                              X(De(N._payload), O, ne, ie, pe)
                            );
                        }
                    }
                  if (De) {
                    ((De = N), (pe = pe(De)));
                    var ze = ie === '' ? '.' + G(De, 0) : ie;
                    return (
                      Fa(pe)
                        ? ((ne = ''),
                          ze != null && (ne = ze.replace(Bs, '$&/') + '/'),
                          X(pe, O, ne, '', function (Dt) {
                            return Dt;
                          }))
                        : pe != null &&
                          (U(pe) &&
                            (pe.key != null &&
                              ((De && De.key === pe.key) || y(pe.key)),
                            (ne = L(
                              pe,
                              ne +
                                (pe.key == null || (De && De.key === pe.key)
                                  ? ''
                                  : ('' + pe.key).replace(Bs, '$&/') + '/') +
                                ze
                            )),
                            ie !== '' &&
                              De != null &&
                              U(De) &&
                              De.key == null &&
                              De._store &&
                              !De._store.validated &&
                              (ne._store.validated = 2),
                            (pe = ne)),
                          O.push(pe)),
                      1
                    );
                  }
                  if (((De = 0), (ze = ie === '' ? '.' : ie + ':'), Fa(N)))
                    for (var Te = 0; Te < N.length; Te++)
                      ((ie = N[Te]),
                        (Ae = ze + G(ie, Te)),
                        (De += X(ie, O, ne, Ae, pe)));
                  else if (((Te = r(N)), typeof Te == 'function'))
                    for (
                      Te === N.entries &&
                        (Vs ||
                          console.warn(
                            'Using Maps as children is not supported. Use an array of keyed ReactElements instead.'
                          ),
                        (Vs = !0)),
                        N = Te.call(N),
                        Te = 0;
                      !(ie = N.next()).done;
                    )
                      ((ie = ie.value),
                        (Ae = ze + G(ie, Te++)),
                        (De += X(ie, O, ne, Ae, pe)));
                  else if (Ae === 'object') {
                    if (typeof N.then == 'function')
                      return X(Q(N), O, ne, ie, pe);
                    throw (
                      (O = String(N)),
                      Error(
                        'Objects are not valid as a React child (found: ' +
                          (O === '[object Object]'
                            ? 'object with keys {' +
                              Object.keys(N).join(', ') +
                              '}'
                            : O) +
                          '). If you meant to render a collection of children, use an array instead.'
                      )
                    );
                  }
                  return De;
                }
                function J(N, O, ne) {
                  if (N == null) return N;
                  var ie = [],
                    pe = 0;
                  return (
                    X(N, ie, '', '', function (Ae) {
                      return O.call(ne, Ae, pe++);
                    }),
                    ie
                  );
                }
                function ee(N) {
                  if (N._status === -1) {
                    var O = N._result;
                    ((O = O()),
                      O.then(
                        function (ne) {
                          (N._status === 0 || N._status === -1) &&
                            ((N._status = 1), (N._result = ne));
                        },
                        function (ne) {
                          (N._status === 0 || N._status === -1) &&
                            ((N._status = 2), (N._result = ne));
                        }
                      ),
                      N._status === -1 && ((N._status = 0), (N._result = O)));
                  }
                  if (N._status === 1)
                    return (
                      (O = N._result),
                      O === void 0 &&
                        console.error(
                          `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
                          O
                        ),
                      'default' in O ||
                        console.error(
                          `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
                          O
                        ),
                      O.default
                    );
                  throw N._result;
                }
                function q() {
                  var N = Me.H;
                  return (
                    N === null &&
                      console.error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`),
                    N
                  );
                }
                function se() {}
                function ge(N) {
                  if (Cl === null)
                    try {
                      var O = ('require' + Math.random()).slice(0, 7);
                      Cl = (i && i[O]).call(i, 'timers').setImmediate;
                    } catch {
                      Cl = function (ie) {
                        Ls === !1 &&
                          ((Ls = !0),
                          typeof MessageChannel > 'u' &&
                            console.error(
                              'This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.'
                            ));
                        var pe = new MessageChannel();
                        ((pe.port1.onmessage = ie),
                          pe.port2.postMessage(void 0));
                      };
                    }
                  return Cl(N);
                }
                function we(N) {
                  return 1 < N.length && typeof AggregateError == 'function'
                    ? new AggregateError(N)
                    : N[0];
                }
                function We(N, O) {
                  (O !== Ja - 1 &&
                    console.error(
                      'You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. '
                    ),
                    (Ja = O));
                }
                function K(N, O, ne) {
                  var ie = Me.actQueue;
                  if (ie !== null)
                    if (ie.length !== 0)
                      try {
                        (ce(ie),
                          ge(function () {
                            return K(N, O, ne);
                          }));
                        return;
                      } catch (pe) {
                        Me.thrownErrors.push(pe);
                      }
                    else Me.actQueue = null;
                  0 < Me.thrownErrors.length
                    ? ((ie = we(Me.thrownErrors)),
                      (Me.thrownErrors.length = 0),
                      ne(ie))
                    : O(N);
                }
                function ce(N) {
                  if (!Gn) {
                    Gn = !0;
                    var O = 0;
                    try {
                      for (; O < N.length; O++) {
                        var ne = N[O];
                        do {
                          Me.didUsePromise = !1;
                          var ie = ne(!1);
                          if (ie !== null) {
                            if (Me.didUsePromise) {
                              ((N[O] = ne), N.splice(0, O));
                              return;
                            }
                            ne = ie;
                          } else break;
                        } while (!0);
                      }
                      N.length = 0;
                    } catch (pe) {
                      (N.splice(0, O + 1), Me.thrownErrors.push(pe));
                    } finally {
                      Gn = !1;
                    }
                  }
                }
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                    'function' &&
                  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                    Error()
                  );
                var F = Symbol.for('react.transitional.element'),
                  me = Symbol.for('react.portal'),
                  W = Symbol.for('react.fragment'),
                  re = Symbol.for('react.strict_mode'),
                  ue = Symbol.for('react.profiler'),
                  Ue = Symbol.for('react.consumer'),
                  et = Symbol.for('react.context'),
                  zt = Symbol.for('react.forward_ref'),
                  Le = Symbol.for('react.suspense'),
                  Vi = Symbol.for('react.suspense_list'),
                  lt = Symbol.for('react.memo'),
                  Mt = Symbol.for('react.lazy'),
                  Dn = Symbol.for('react.activity'),
                  Bi = Symbol.iterator,
                  Os = {},
                  Za = {
                    isMounted: function () {
                      return !1;
                    },
                    enqueueForceUpdate: function (N) {
                      u(N, 'forceUpdate');
                    },
                    enqueueReplaceState: function (N) {
                      u(N, 'replaceState');
                    },
                    enqueueSetState: function (N) {
                      u(N, 'setState');
                    },
                  },
                  br = Object.assign,
                  ks = {};
                (Object.freeze(ks),
                  (d.prototype.isReactComponent = {}),
                  (d.prototype.setState = function (N, O) {
                    if (
                      typeof N != 'object' &&
                      typeof N != 'function' &&
                      N != null
                    )
                      throw Error(
                        'takes an object of state variables to update or a function which returns an object of state variables.'
                      );
                    this.updater.enqueueSetState(this, N, O, 'setState');
                  }),
                  (d.prototype.forceUpdate = function (N) {
                    this.updater.enqueueForceUpdate(this, N, 'forceUpdate');
                  }));
                var bt = {
                    isMounted: [
                      'isMounted',
                      'Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.',
                    ],
                    replaceState: [
                      'replaceState',
                      'Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236).',
                    ],
                  },
                  xa;
                for (xa in bt) bt.hasOwnProperty(xa) && o(xa, bt[xa]);
                ((p.prototype = d.prototype),
                  (bt = h.prototype = new p()),
                  (bt.constructor = h),
                  br(bt, d.prototype),
                  (bt.isPureReactComponent = !0));
                var Fa = Array.isArray,
                  Ou = Symbol.for('react.client.reference'),
                  Me = {
                    H: null,
                    A: null,
                    T: null,
                    S: null,
                    V: null,
                    actQueue: null,
                    isBatchingLegacy: !1,
                    didScheduleLegacyUpdate: !1,
                    didUsePromise: !1,
                    thrownErrors: [],
                    getCurrentStack: null,
                    recentlyCreatedOwnerStacks: 0,
                  },
                  Li = Object.prototype.hasOwnProperty,
                  Dl = console.createTask
                    ? console.createTask
                    : function () {
                        return null;
                      };
                bt = {
                  react_stack_bottom_frame: function (N) {
                    return N();
                  },
                };
                var Ka,
                  yr,
                  _s = {},
                  vr = bt.react_stack_bottom_frame.bind(bt, x)(),
                  js = Dl(v(x)),
                  Vs = !1,
                  Bs = /\/+/g,
                  Tl =
                    typeof reportError == 'function'
                      ? reportError
                      : function (N) {
                          if (
                            typeof window == 'object' &&
                            typeof window.ErrorEvent == 'function'
                          ) {
                            var O = new window.ErrorEvent('error', {
                              bubbles: !0,
                              cancelable: !0,
                              message:
                                typeof N == 'object' &&
                                N !== null &&
                                typeof N.message == 'string'
                                  ? String(N.message)
                                  : String(N),
                              error: N,
                            });
                            if (!window.dispatchEvent(O)) return;
                          } else if (
                            typeof process == 'object' &&
                            typeof process.emit == 'function'
                          ) {
                            process.emit('uncaughtException', N);
                            return;
                          }
                          console.error(N);
                        },
                  Ls = !1,
                  Cl = null,
                  Ja = 0,
                  Pn = !1,
                  Gn = !1,
                  ei =
                    typeof queueMicrotask == 'function'
                      ? function (N) {
                          queueMicrotask(function () {
                            return queueMicrotask(N);
                          });
                        }
                      : ge;
                ((bt = Object.freeze({
                  __proto__: null,
                  c: function (N) {
                    return q().useMemoCache(N);
                  },
                })),
                  (l.Children = {
                    map: J,
                    forEach: function (N, O, ne) {
                      J(
                        N,
                        function () {
                          O.apply(this, arguments);
                        },
                        ne
                      );
                    },
                    count: function (N) {
                      var O = 0;
                      return (
                        J(N, function () {
                          O++;
                        }),
                        O
                      );
                    },
                    toArray: function (N) {
                      return (
                        J(N, function (O) {
                          return O;
                        }) || []
                      );
                    },
                    only: function (N) {
                      if (!U(N))
                        throw Error(
                          'React.Children.only expected to receive a single React element child.'
                        );
                      return N;
                    },
                  }),
                  (l.Component = d),
                  (l.Fragment = W),
                  (l.Profiler = ue),
                  (l.PureComponent = h),
                  (l.StrictMode = re),
                  (l.Suspense = Le),
                  (l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
                    Me),
                  (l.__COMPILER_RUNTIME = bt),
                  (l.act = function (N) {
                    var O = Me.actQueue,
                      ne = Ja;
                    Ja++;
                    var ie = (Me.actQueue = O !== null ? O : []),
                      pe = !1;
                    try {
                      var Ae = N();
                    } catch (Te) {
                      Me.thrownErrors.push(Te);
                    }
                    if (0 < Me.thrownErrors.length)
                      throw (
                        We(O, ne),
                        (N = we(Me.thrownErrors)),
                        (Me.thrownErrors.length = 0),
                        N
                      );
                    if (
                      Ae !== null &&
                      typeof Ae == 'object' &&
                      typeof Ae.then == 'function'
                    ) {
                      var De = Ae;
                      return (
                        ei(function () {
                          pe ||
                            Pn ||
                            ((Pn = !0),
                            console.error(
                              'You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);'
                            ));
                        }),
                        {
                          then: function (Te, Dt) {
                            ((pe = !0),
                              De.then(
                                function (Na) {
                                  if ((We(O, ne), ne === 0)) {
                                    try {
                                      (ce(ie),
                                        ge(function () {
                                          return K(Na, Te, Dt);
                                        }));
                                    } catch (_u) {
                                      Me.thrownErrors.push(_u);
                                    }
                                    if (0 < Me.thrownErrors.length) {
                                      var ku = we(Me.thrownErrors);
                                      ((Me.thrownErrors.length = 0), Dt(ku));
                                    }
                                  } else Te(Na);
                                },
                                function (Na) {
                                  (We(O, ne),
                                    0 < Me.thrownErrors.length &&
                                      ((Na = we(Me.thrownErrors)),
                                      (Me.thrownErrors.length = 0)),
                                    Dt(Na));
                                }
                              ));
                          },
                        }
                      );
                    }
                    var ze = Ae;
                    if (
                      (We(O, ne),
                      ne === 0 &&
                        (ce(ie),
                        ie.length !== 0 &&
                          ei(function () {
                            pe ||
                              Pn ||
                              ((Pn = !0),
                              console.error(
                                'A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)'
                              ));
                          }),
                        (Me.actQueue = null)),
                      0 < Me.thrownErrors.length)
                    )
                      throw (
                        (N = we(Me.thrownErrors)),
                        (Me.thrownErrors.length = 0),
                        N
                      );
                    return {
                      then: function (Te, Dt) {
                        ((pe = !0),
                          ne === 0
                            ? ((Me.actQueue = ie),
                              ge(function () {
                                return K(ze, Te, Dt);
                              }))
                            : Te(ze));
                      },
                    };
                  }),
                  (l.cache = function (N) {
                    return function () {
                      return N.apply(null, arguments);
                    };
                  }),
                  (l.captureOwnerStack = function () {
                    var N = Me.getCurrentStack;
                    return N === null ? null : N();
                  }),
                  (l.cloneElement = function (N, O, ne) {
                    if (N == null)
                      throw Error(
                        'The argument must be a React element, but you passed ' +
                          N +
                          '.'
                      );
                    var ie = br({}, N.props),
                      pe = N.key,
                      Ae = N._owner;
                    if (O != null) {
                      var De;
                      e: {
                        if (
                          Li.call(O, 'ref') &&
                          (De = Object.getOwnPropertyDescriptor(
                            O,
                            'ref'
                          ).get) &&
                          De.isReactWarning
                        ) {
                          De = !1;
                          break e;
                        }
                        De = O.ref !== void 0;
                      }
                      (De && (Ae = S()), D(O) && (y(O.key), (pe = '' + O.key)));
                      for (ze in O)
                        !Li.call(O, ze) ||
                          ze === 'key' ||
                          ze === '__self' ||
                          ze === '__source' ||
                          (ze === 'ref' && O.ref === void 0) ||
                          (ie[ze] = O[ze]);
                    }
                    var ze = arguments.length - 2;
                    if (ze === 1) ie.children = ne;
                    else if (1 < ze) {
                      De = Array(ze);
                      for (var Te = 0; Te < ze; Te++)
                        De[Te] = arguments[Te + 2];
                      ie.children = De;
                    }
                    for (
                      ie = V(
                        N.type,
                        pe,
                        void 0,
                        void 0,
                        Ae,
                        ie,
                        N._debugStack,
                        N._debugTask
                      ),
                        pe = 2;
                      pe < arguments.length;
                      pe++
                    )
                      ((Ae = arguments[pe]),
                        U(Ae) && Ae._store && (Ae._store.validated = 1));
                    return ie;
                  }),
                  (l.createContext = function (N) {
                    return (
                      (N = {
                        $$typeof: et,
                        _currentValue: N,
                        _currentValue2: N,
                        _threadCount: 0,
                        Provider: null,
                        Consumer: null,
                      }),
                      (N.Provider = N),
                      (N.Consumer = { $$typeof: Ue, _context: N }),
                      (N._currentRenderer = null),
                      (N._currentRenderer2 = null),
                      N
                    );
                  }),
                  (l.createElement = function (N, O, ne) {
                    for (var ie = 2; ie < arguments.length; ie++) {
                      var pe = arguments[ie];
                      U(pe) && pe._store && (pe._store.validated = 1);
                    }
                    if (((ie = {}), (pe = null), O != null))
                      for (Te in (yr ||
                        !('__self' in O) ||
                        'key' in O ||
                        ((yr = !0),
                        console.warn(
                          'Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform'
                        )),
                      D(O) && (y(O.key), (pe = '' + O.key)),
                      O))
                        Li.call(O, Te) &&
                          Te !== 'key' &&
                          Te !== '__self' &&
                          Te !== '__source' &&
                          (ie[Te] = O[Te]);
                    var Ae = arguments.length - 2;
                    if (Ae === 1) ie.children = ne;
                    else if (1 < Ae) {
                      for (var De = Array(Ae), ze = 0; ze < Ae; ze++)
                        De[ze] = arguments[ze + 2];
                      (Object.freeze && Object.freeze(De), (ie.children = De));
                    }
                    if (N && N.defaultProps)
                      for (Te in ((Ae = N.defaultProps), Ae))
                        ie[Te] === void 0 && (ie[Te] = Ae[Te]);
                    pe &&
                      M(
                        ie,
                        typeof N == 'function'
                          ? N.displayName || N.name || 'Unknown'
                          : N
                      );
                    var Te = 1e4 > Me.recentlyCreatedOwnerStacks++;
                    return V(
                      N,
                      pe,
                      void 0,
                      void 0,
                      S(),
                      ie,
                      Te ? Error('react-stack-top-frame') : vr,
                      Te ? Dl(v(N)) : js
                    );
                  }),
                  (l.createRef = function () {
                    var N = { current: null };
                    return (Object.seal(N), N);
                  }),
                  (l.forwardRef = function (N) {
                    (N != null && N.$$typeof === lt
                      ? console.error(
                          'forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).'
                        )
                      : typeof N != 'function'
                        ? console.error(
                            'forwardRef requires a render function but was given %s.',
                            N === null ? 'null' : typeof N
                          )
                        : N.length !== 0 &&
                          N.length !== 2 &&
                          console.error(
                            'forwardRef render functions accept exactly two parameters: props and ref. %s',
                            N.length === 1
                              ? 'Did you forget to use the ref parameter?'
                              : 'Any additional parameter will be undefined.'
                          ),
                      N != null &&
                        N.defaultProps != null &&
                        console.error(
                          'forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?'
                        ));
                    var O = { $$typeof: zt, render: N },
                      ne;
                    return (
                      Object.defineProperty(O, 'displayName', {
                        enumerable: !1,
                        configurable: !0,
                        get: function () {
                          return ne;
                        },
                        set: function (ie) {
                          ((ne = ie),
                            N.name ||
                              N.displayName ||
                              (Object.defineProperty(N, 'name', { value: ie }),
                              (N.displayName = ie)));
                        },
                      }),
                      O
                    );
                  }),
                  (l.isValidElement = U),
                  (l.lazy = function (N) {
                    return {
                      $$typeof: Mt,
                      _payload: { _status: -1, _result: N },
                      _init: ee,
                    };
                  }),
                  (l.memo = function (N, O) {
                    (N == null &&
                      console.error(
                        'memo: The first argument must be a component. Instead received: %s',
                        N === null ? 'null' : typeof N
                      ),
                      (O = {
                        $$typeof: lt,
                        type: N,
                        compare: O === void 0 ? null : O,
                      }));
                    var ne;
                    return (
                      Object.defineProperty(O, 'displayName', {
                        enumerable: !1,
                        configurable: !0,
                        get: function () {
                          return ne;
                        },
                        set: function (ie) {
                          ((ne = ie),
                            N.name ||
                              N.displayName ||
                              (Object.defineProperty(N, 'name', { value: ie }),
                              (N.displayName = ie)));
                        },
                      }),
                      O
                    );
                  }),
                  (l.startTransition = function (N) {
                    var O = Me.T,
                      ne = {};
                    ((Me.T = ne), (ne._updatedFibers = new Set()));
                    try {
                      var ie = N(),
                        pe = Me.S;
                      (pe !== null && pe(ne, ie),
                        typeof ie == 'object' &&
                          ie !== null &&
                          typeof ie.then == 'function' &&
                          ie.then(se, Tl));
                    } catch (Ae) {
                      Tl(Ae);
                    } finally {
                      (O === null &&
                        ne._updatedFibers &&
                        ((N = ne._updatedFibers.size),
                        ne._updatedFibers.clear(),
                        10 < N &&
                          console.warn(
                            'Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.'
                          )),
                        (Me.T = O));
                    }
                  }),
                  (l.unstable_useCacheRefresh = function () {
                    return q().useCacheRefresh();
                  }),
                  (l.use = function (N) {
                    return q().use(N);
                  }),
                  (l.useActionState = function (N, O, ne) {
                    return q().useActionState(N, O, ne);
                  }),
                  (l.useCallback = function (N, O) {
                    return q().useCallback(N, O);
                  }),
                  (l.useContext = function (N) {
                    var O = q();
                    return (
                      N.$$typeof === Ue &&
                        console.error(
                          'Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?'
                        ),
                      O.useContext(N)
                    );
                  }),
                  (l.useDebugValue = function (N, O) {
                    return q().useDebugValue(N, O);
                  }),
                  (l.useDeferredValue = function (N, O) {
                    return q().useDeferredValue(N, O);
                  }),
                  (l.useEffect = function (N, O, ne) {
                    N == null &&
                      console.warn(
                        'React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?'
                      );
                    var ie = q();
                    if (typeof ne == 'function')
                      throw Error(
                        'useEffect CRUD overload is not enabled in this build of React.'
                      );
                    return ie.useEffect(N, O);
                  }),
                  (l.useId = function () {
                    return q().useId();
                  }),
                  (l.useImperativeHandle = function (N, O, ne) {
                    return q().useImperativeHandle(N, O, ne);
                  }),
                  (l.useInsertionEffect = function (N, O) {
                    return (
                      N == null &&
                        console.warn(
                          'React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?'
                        ),
                      q().useInsertionEffect(N, O)
                    );
                  }),
                  (l.useLayoutEffect = function (N, O) {
                    return (
                      N == null &&
                        console.warn(
                          'React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?'
                        ),
                      q().useLayoutEffect(N, O)
                    );
                  }),
                  (l.useMemo = function (N, O) {
                    return q().useMemo(N, O);
                  }),
                  (l.useOptimistic = function (N, O) {
                    return q().useOptimistic(N, O);
                  }),
                  (l.useReducer = function (N, O, ne) {
                    return q().useReducer(N, O, ne);
                  }),
                  (l.useRef = function (N) {
                    return q().useRef(N);
                  }),
                  (l.useState = function (N) {
                    return q().useState(N);
                  }),
                  (l.useSyncExternalStore = function (N, O, ne) {
                    return q().useSyncExternalStore(N, O, ne);
                  }),
                  (l.useTransition = function () {
                    return q().useTransition();
                  }),
                  (l.version = '19.1.1'),
                  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                      'function' &&
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                      Error()
                    ));
              })();
            })(hu, hu.exports)),
          hu.exports
        );
      }
      var e0;
      function Au() {
        return (e0 || ((e0 = 1), (lp.exports = $w())), lp.exports);
      }
      var t0;
      function Pw() {
        if (t0) return pu;
        t0 = 1;
        /**
         * @license React
         * react-jsx-dev-runtime.development.js
         *
         * Copyright (c) Meta Platforms, Inc. and affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */ return (
          (function () {
            function i(W) {
              if (W == null) return null;
              if (typeof W == 'function')
                return W.$$typeof === ee
                  ? null
                  : W.displayName || W.name || null;
              if (typeof W == 'string') return W;
              switch (W) {
                case M:
                  return 'Fragment';
                case V:
                  return 'Profiler';
                case k:
                  return 'StrictMode';
                case G:
                  return 'Suspense';
                case P:
                  return 'SuspenseList';
                case J:
                  return 'Activity';
              }
              if (typeof W == 'object')
                switch (
                  (typeof W.tag == 'number' &&
                    console.error(
                      'Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.'
                    ),
                  W.$$typeof)
                ) {
                  case D:
                    return 'Portal';
                  case U:
                    return (W.displayName || 'Context') + '.Provider';
                  case L:
                    return (W._context.displayName || 'Context') + '.Consumer';
                  case Y:
                    var re = W.render;
                    return (
                      (W = W.displayName),
                      W ||
                        ((W = re.displayName || re.name || ''),
                        (W =
                          W !== '' ? 'ForwardRef(' + W + ')' : 'ForwardRef')),
                      W
                    );
                  case Q:
                    return (
                      (re = W.displayName || null),
                      re !== null ? re : i(W.type) || 'Memo'
                    );
                  case X:
                    ((re = W._payload), (W = W._init));
                    try {
                      return i(W(re));
                    } catch {}
                }
              return null;
            }
            function l(W) {
              return '' + W;
            }
            function o(W) {
              try {
                var re = !1;
              } catch {
                re = !0;
              }
              if (re) {
                re = console;
                var ue = re.error,
                  Ue =
                    (typeof Symbol == 'function' &&
                      Symbol.toStringTag &&
                      W[Symbol.toStringTag]) ||
                    W.constructor.name ||
                    'Object';
                return (
                  ue.call(
                    re,
                    'The provided key is an unsupported type %s. This value must be coerced to a string before using it here.',
                    Ue
                  ),
                  l(W)
                );
              }
            }
            function r(W) {
              if (W === M) return '<>';
              if (typeof W == 'object' && W !== null && W.$$typeof === X)
                return '<...>';
              try {
                var re = i(W);
                return re ? '<' + re + '>' : '<...>';
              } catch {
                return '<...>';
              }
            }
            function u() {
              var W = q.A;
              return W === null ? null : W.getOwner();
            }
            function d() {
              return Error('react-stack-top-frame');
            }
            function p(W) {
              if (se.call(W, 'key')) {
                var re = Object.getOwnPropertyDescriptor(W, 'key').get;
                if (re && re.isReactWarning) return !1;
              }
              return W.key !== void 0;
            }
            function h(W, re) {
              function ue() {
                We ||
                  ((We = !0),
                  console.error(
                    '%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)',
                    re
                  ));
              }
              ((ue.isReactWarning = !0),
                Object.defineProperty(W, 'key', { get: ue, configurable: !0 }));
            }
            function m() {
              var W = i(this.type);
              return (
                K[W] ||
                  ((K[W] = !0),
                  console.error(
                    'Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.'
                  )),
                (W = this.props.ref),
                W !== void 0 ? W : null
              );
            }
            function y(W, re, ue, Ue, et, zt, Le, Vi) {
              return (
                (ue = zt.ref),
                (W = { $$typeof: x, type: W, key: re, props: zt, _owner: et }),
                (ue !== void 0 ? ue : null) !== null
                  ? Object.defineProperty(W, 'ref', { enumerable: !1, get: m })
                  : Object.defineProperty(W, 'ref', {
                      enumerable: !1,
                      value: null,
                    }),
                (W._store = {}),
                Object.defineProperty(W._store, 'validated', {
                  configurable: !1,
                  enumerable: !1,
                  writable: !0,
                  value: 0,
                }),
                Object.defineProperty(W, '_debugInfo', {
                  configurable: !1,
                  enumerable: !1,
                  writable: !0,
                  value: null,
                }),
                Object.defineProperty(W, '_debugStack', {
                  configurable: !1,
                  enumerable: !1,
                  writable: !0,
                  value: Le,
                }),
                Object.defineProperty(W, '_debugTask', {
                  configurable: !1,
                  enumerable: !1,
                  writable: !0,
                  value: Vi,
                }),
                Object.freeze && (Object.freeze(W.props), Object.freeze(W)),
                W
              );
            }
            function E(W, re, ue, Ue, et, zt, Le, Vi) {
              var lt = re.children;
              if (lt !== void 0)
                if (Ue)
                  if (ge(lt)) {
                    for (Ue = 0; Ue < lt.length; Ue++) v(lt[Ue]);
                    Object.freeze && Object.freeze(lt);
                  } else
                    console.error(
                      'React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.'
                    );
                else v(lt);
              if (se.call(re, 'key')) {
                lt = i(W);
                var Mt = Object.keys(re).filter(function (Bi) {
                  return Bi !== 'key';
                });
                ((Ue =
                  0 < Mt.length
                    ? '{key: someKey, ' + Mt.join(': ..., ') + ': ...}'
                    : '{key: someKey}'),
                  me[lt + Ue] ||
                    ((Mt =
                      0 < Mt.length
                        ? '{' + Mt.join(': ..., ') + ': ...}'
                        : '{}'),
                    console.error(
                      `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
                      Ue,
                      lt,
                      Mt,
                      lt
                    ),
                    (me[lt + Ue] = !0)));
              }
              if (
                ((lt = null),
                ue !== void 0 && (o(ue), (lt = '' + ue)),
                p(re) && (o(re.key), (lt = '' + re.key)),
                'key' in re)
              ) {
                ue = {};
                for (var Dn in re) Dn !== 'key' && (ue[Dn] = re[Dn]);
              } else ue = re;
              return (
                lt &&
                  h(
                    ue,
                    typeof W == 'function'
                      ? W.displayName || W.name || 'Unknown'
                      : W
                  ),
                y(W, lt, zt, et, u(), ue, Le, Vi)
              );
            }
            function v(W) {
              typeof W == 'object' &&
                W !== null &&
                W.$$typeof === x &&
                W._store &&
                (W._store.validated = 1);
            }
            var S = Au(),
              x = Symbol.for('react.transitional.element'),
              D = Symbol.for('react.portal'),
              M = Symbol.for('react.fragment'),
              k = Symbol.for('react.strict_mode'),
              V = Symbol.for('react.profiler'),
              L = Symbol.for('react.consumer'),
              U = Symbol.for('react.context'),
              Y = Symbol.for('react.forward_ref'),
              G = Symbol.for('react.suspense'),
              P = Symbol.for('react.suspense_list'),
              Q = Symbol.for('react.memo'),
              X = Symbol.for('react.lazy'),
              J = Symbol.for('react.activity'),
              ee = Symbol.for('react.client.reference'),
              q =
                S.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
              se = Object.prototype.hasOwnProperty,
              ge = Array.isArray,
              we = console.createTask
                ? console.createTask
                : function () {
                    return null;
                  };
            S = {
              react_stack_bottom_frame: function (W) {
                return W();
              },
            };
            var We,
              K = {},
              ce = S.react_stack_bottom_frame.bind(S, d)(),
              F = we(r(d)),
              me = {};
            ((pu.Fragment = M),
              (pu.jsxDEV = function (W, re, ue, Ue, et, zt) {
                var Le = 1e4 > q.recentlyCreatedOwnerStacks++;
                return E(
                  W,
                  re,
                  ue,
                  Ue,
                  et,
                  zt,
                  Le ? Error('react-stack-top-frame') : ce,
                  Le ? we(r(W)) : F
                );
              }));
          })(),
          pu
        );
      }
      var n0;
      function Gw() {
        return (n0 || ((n0 = 1), (ip.exports = Pw())), ip.exports);
      }
      var g = Gw(),
        Z = Au();
      const Et = Ww(Z);
      var sp = { exports: {} },
        or = {},
        op = { exports: {} },
        rp = {},
        a0;
      function qw() {
        return (
          a0 ||
            ((a0 = 1),
            (function (i) {
              /**
               * @license React
               * scheduler.development.js
               *
               * Copyright (c) Meta Platforms, Inc. and affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */ (function () {
                function l() {
                  if (((G = !1), J)) {
                    var K = i.unstable_now();
                    se = K;
                    var ce = !0;
                    try {
                      e: {
                        ((U = !1), Y && ((Y = !1), Q(ee), (ee = -1)), (L = !0));
                        var F = V;
                        try {
                          t: {
                            for (
                              p(K), k = r(x);
                              k !== null && !(k.expirationTime > K && m());
                            ) {
                              var me = k.callback;
                              if (typeof me == 'function') {
                                ((k.callback = null), (V = k.priorityLevel));
                                var W = me(k.expirationTime <= K);
                                if (
                                  ((K = i.unstable_now()),
                                  typeof W == 'function')
                                ) {
                                  ((k.callback = W), p(K), (ce = !0));
                                  break t;
                                }
                                (k === r(x) && u(x), p(K));
                              } else u(x);
                              k = r(x);
                            }
                            if (k !== null) ce = !0;
                            else {
                              var re = r(D);
                              (re !== null && y(h, re.startTime - K),
                                (ce = !1));
                            }
                          }
                          break e;
                        } finally {
                          ((k = null), (V = F), (L = !1));
                        }
                        ce = void 0;
                      }
                    } finally {
                      ce ? ge() : (J = !1);
                    }
                  }
                }
                function o(K, ce) {
                  var F = K.length;
                  K.push(ce);
                  e: for (; 0 < F; ) {
                    var me = (F - 1) >>> 1,
                      W = K[me];
                    if (0 < d(W, ce)) ((K[me] = ce), (K[F] = W), (F = me));
                    else break e;
                  }
                }
                function r(K) {
                  return K.length === 0 ? null : K[0];
                }
                function u(K) {
                  if (K.length === 0) return null;
                  var ce = K[0],
                    F = K.pop();
                  if (F !== ce) {
                    K[0] = F;
                    e: for (var me = 0, W = K.length, re = W >>> 1; me < re; ) {
                      var ue = 2 * (me + 1) - 1,
                        Ue = K[ue],
                        et = ue + 1,
                        zt = K[et];
                      if (0 > d(Ue, F))
                        et < W && 0 > d(zt, Ue)
                          ? ((K[me] = zt), (K[et] = F), (me = et))
                          : ((K[me] = Ue), (K[ue] = F), (me = ue));
                      else if (et < W && 0 > d(zt, F))
                        ((K[me] = zt), (K[et] = F), (me = et));
                      else break e;
                    }
                  }
                  return ce;
                }
                function d(K, ce) {
                  var F = K.sortIndex - ce.sortIndex;
                  return F !== 0 ? F : K.id - ce.id;
                }
                function p(K) {
                  for (var ce = r(D); ce !== null; ) {
                    if (ce.callback === null) u(D);
                    else if (ce.startTime <= K)
                      (u(D), (ce.sortIndex = ce.expirationTime), o(x, ce));
                    else break;
                    ce = r(D);
                  }
                }
                function h(K) {
                  if (((Y = !1), p(K), !U))
                    if (r(x) !== null) ((U = !0), J || ((J = !0), ge()));
                    else {
                      var ce = r(D);
                      ce !== null && y(h, ce.startTime - K);
                    }
                }
                function m() {
                  return G ? !0 : !(i.unstable_now() - se < q);
                }
                function y(K, ce) {
                  ee = P(function () {
                    K(i.unstable_now());
                  }, ce);
                }
                if (
                  (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                      'function' &&
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                      Error()
                    ),
                  (i.unstable_now = void 0),
                  typeof performance == 'object' &&
                    typeof performance.now == 'function')
                ) {
                  var E = performance;
                  i.unstable_now = function () {
                    return E.now();
                  };
                } else {
                  var v = Date,
                    S = v.now();
                  i.unstable_now = function () {
                    return v.now() - S;
                  };
                }
                var x = [],
                  D = [],
                  M = 1,
                  k = null,
                  V = 3,
                  L = !1,
                  U = !1,
                  Y = !1,
                  G = !1,
                  P = typeof setTimeout == 'function' ? setTimeout : null,
                  Q = typeof clearTimeout == 'function' ? clearTimeout : null,
                  X = typeof setImmediate < 'u' ? setImmediate : null,
                  J = !1,
                  ee = -1,
                  q = 5,
                  se = -1;
                if (typeof X == 'function')
                  var ge = function () {
                    X(l);
                  };
                else if (typeof MessageChannel < 'u') {
                  var we = new MessageChannel(),
                    We = we.port2;
                  ((we.port1.onmessage = l),
                    (ge = function () {
                      We.postMessage(null);
                    }));
                } else
                  ge = function () {
                    P(l, 0);
                  };
                ((i.unstable_IdlePriority = 5),
                  (i.unstable_ImmediatePriority = 1),
                  (i.unstable_LowPriority = 4),
                  (i.unstable_NormalPriority = 3),
                  (i.unstable_Profiling = null),
                  (i.unstable_UserBlockingPriority = 2),
                  (i.unstable_cancelCallback = function (K) {
                    K.callback = null;
                  }),
                  (i.unstable_forceFrameRate = function (K) {
                    0 > K || 125 < K
                      ? console.error(
                          'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                        )
                      : (q = 0 < K ? Math.floor(1e3 / K) : 5);
                  }),
                  (i.unstable_getCurrentPriorityLevel = function () {
                    return V;
                  }),
                  (i.unstable_next = function (K) {
                    switch (V) {
                      case 1:
                      case 2:
                      case 3:
                        var ce = 3;
                        break;
                      default:
                        ce = V;
                    }
                    var F = V;
                    V = ce;
                    try {
                      return K();
                    } finally {
                      V = F;
                    }
                  }),
                  (i.unstable_requestPaint = function () {
                    G = !0;
                  }),
                  (i.unstable_runWithPriority = function (K, ce) {
                    switch (K) {
                      case 1:
                      case 2:
                      case 3:
                      case 4:
                      case 5:
                        break;
                      default:
                        K = 3;
                    }
                    var F = V;
                    V = K;
                    try {
                      return ce();
                    } finally {
                      V = F;
                    }
                  }),
                  (i.unstable_scheduleCallback = function (K, ce, F) {
                    var me = i.unstable_now();
                    switch (
                      (typeof F == 'object' && F !== null
                        ? ((F = F.delay),
                          (F = typeof F == 'number' && 0 < F ? me + F : me))
                        : (F = me),
                      K)
                    ) {
                      case 1:
                        var W = -1;
                        break;
                      case 2:
                        W = 250;
                        break;
                      case 5:
                        W = 1073741823;
                        break;
                      case 4:
                        W = 1e4;
                        break;
                      default:
                        W = 5e3;
                    }
                    return (
                      (W = F + W),
                      (K = {
                        id: M++,
                        callback: ce,
                        priorityLevel: K,
                        startTime: F,
                        expirationTime: W,
                        sortIndex: -1,
                      }),
                      F > me
                        ? ((K.sortIndex = F),
                          o(D, K),
                          r(x) === null &&
                            K === r(D) &&
                            (Y ? (Q(ee), (ee = -1)) : (Y = !0), y(h, F - me)))
                        : ((K.sortIndex = W),
                          o(x, K),
                          U || L || ((U = !0), J || ((J = !0), ge()))),
                      K
                    );
                  }),
                  (i.unstable_shouldYield = m),
                  (i.unstable_wrapCallback = function (K) {
                    var ce = V;
                    return function () {
                      var F = V;
                      V = ce;
                      try {
                        return K.apply(this, arguments);
                      } finally {
                        V = F;
                      }
                    };
                  }),
                  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                      'function' &&
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                      Error()
                    ));
              })();
            })(rp)),
          rp
        );
      }
      var i0;
      function Yw() {
        return (i0 || ((i0 = 1), (op.exports = qw())), op.exports);
      }
      var cp = { exports: {} },
        Wt = {},
        l0;
      function Xw() {
        if (l0) return Wt;
        l0 = 1;
        /**
         * @license React
         * react-dom.development.js
         *
         * Copyright (c) Meta Platforms, Inc. and affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */ return (
          (function () {
            function i() {}
            function l(v) {
              return '' + v;
            }
            function o(v, S, x) {
              var D =
                3 < arguments.length && arguments[3] !== void 0
                  ? arguments[3]
                  : null;
              try {
                var M = !1;
              } catch {
                M = !0;
              }
              return (
                M &&
                  (console.error(
                    'The provided key is an unsupported type %s. This value must be coerced to a string before using it here.',
                    (typeof Symbol == 'function' &&
                      Symbol.toStringTag &&
                      D[Symbol.toStringTag]) ||
                      D.constructor.name ||
                      'Object'
                  ),
                  l(D)),
                {
                  $$typeof: y,
                  key: D == null ? null : '' + D,
                  children: v,
                  containerInfo: S,
                  implementation: x,
                }
              );
            }
            function r(v, S) {
              if (v === 'font') return '';
              if (typeof S == 'string') return S === 'use-credentials' ? S : '';
            }
            function u(v) {
              return v === null
                ? '`null`'
                : v === void 0
                  ? '`undefined`'
                  : v === ''
                    ? 'an empty string'
                    : 'something with type "' + typeof v + '"';
            }
            function d(v) {
              return v === null
                ? '`null`'
                : v === void 0
                  ? '`undefined`'
                  : v === ''
                    ? 'an empty string'
                    : typeof v == 'string'
                      ? JSON.stringify(v)
                      : typeof v == 'number'
                        ? '`' + v + '`'
                        : 'something with type "' + typeof v + '"';
            }
            function p() {
              var v = E.H;
              return (
                v === null &&
                  console.error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`),
                v
              );
            }
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                'function' &&
              __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                Error()
              );
            var h = Au(),
              m = {
                d: {
                  f: i,
                  r: function () {
                    throw Error(
                      'Invalid form element. requestFormReset must be passed a form that was rendered by React.'
                    );
                  },
                  D: i,
                  C: i,
                  L: i,
                  m: i,
                  X: i,
                  S: i,
                  M: i,
                },
                p: 0,
                findDOMNode: null,
              },
              y = Symbol.for('react.portal'),
              E =
                h.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
            ((typeof Map == 'function' &&
              Map.prototype != null &&
              typeof Map.prototype.forEach == 'function' &&
              typeof Set == 'function' &&
              Set.prototype != null &&
              typeof Set.prototype.clear == 'function' &&
              typeof Set.prototype.forEach == 'function') ||
              console.error(
                'React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills'
              ),
              (Wt.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
                m),
              (Wt.createPortal = function (v, S) {
                var x =
                  2 < arguments.length && arguments[2] !== void 0
                    ? arguments[2]
                    : null;
                if (
                  !S ||
                  (S.nodeType !== 1 && S.nodeType !== 9 && S.nodeType !== 11)
                )
                  throw Error('Target container is not a DOM element.');
                return o(v, S, null, x);
              }),
              (Wt.flushSync = function (v) {
                var S = E.T,
                  x = m.p;
                try {
                  if (((E.T = null), (m.p = 2), v)) return v();
                } finally {
                  ((E.T = S),
                    (m.p = x),
                    m.d.f() &&
                      console.error(
                        'flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.'
                      ));
                }
              }),
              (Wt.preconnect = function (v, S) {
                (typeof v == 'string' && v
                  ? S != null && typeof S != 'object'
                    ? console.error(
                        'ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.',
                        d(S)
                      )
                    : S != null &&
                      typeof S.crossOrigin != 'string' &&
                      console.error(
                        'ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.',
                        u(S.crossOrigin)
                      )
                  : console.error(
                      'ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.',
                      u(v)
                    ),
                  typeof v == 'string' &&
                    (S
                      ? ((S = S.crossOrigin),
                        (S =
                          typeof S == 'string'
                            ? S === 'use-credentials'
                              ? S
                              : ''
                            : void 0))
                      : (S = null),
                    m.d.C(v, S)));
              }),
              (Wt.prefetchDNS = function (v) {
                if (typeof v != 'string' || !v)
                  console.error(
                    'ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.',
                    u(v)
                  );
                else if (1 < arguments.length) {
                  var S = arguments[1];
                  typeof S == 'object' && S.hasOwnProperty('crossOrigin')
                    ? console.error(
                        'ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.',
                        d(S)
                      )
                    : console.error(
                        'ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.',
                        d(S)
                      );
                }
                typeof v == 'string' && m.d.D(v);
              }),
              (Wt.preinit = function (v, S) {
                if (
                  (typeof v == 'string' && v
                    ? S == null || typeof S != 'object'
                      ? console.error(
                          'ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.',
                          d(S)
                        )
                      : S.as !== 'style' &&
                        S.as !== 'script' &&
                        console.error(
                          'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
                          d(S.as)
                        )
                    : console.error(
                        'ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.',
                        u(v)
                      ),
                  typeof v == 'string' && S && typeof S.as == 'string')
                ) {
                  var x = S.as,
                    D = r(x, S.crossOrigin),
                    M = typeof S.integrity == 'string' ? S.integrity : void 0,
                    k =
                      typeof S.fetchPriority == 'string'
                        ? S.fetchPriority
                        : void 0;
                  x === 'style'
                    ? m.d.S(
                        v,
                        typeof S.precedence == 'string' ? S.precedence : void 0,
                        { crossOrigin: D, integrity: M, fetchPriority: k }
                      )
                    : x === 'script' &&
                      m.d.X(v, {
                        crossOrigin: D,
                        integrity: M,
                        fetchPriority: k,
                        nonce: typeof S.nonce == 'string' ? S.nonce : void 0,
                      });
                }
              }),
              (Wt.preinitModule = function (v, S) {
                var x = '';
                if (
                  ((typeof v == 'string' && v) ||
                    (x += ' The `href` argument encountered was ' + u(v) + '.'),
                  S !== void 0 && typeof S != 'object'
                    ? (x +=
                        ' The `options` argument encountered was ' + u(S) + '.')
                    : S &&
                      'as' in S &&
                      S.as !== 'script' &&
                      (x +=
                        ' The `as` option encountered was ' + d(S.as) + '.'),
                  x)
                )
                  console.error(
                    'ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s',
                    x
                  );
                else
                  switch (
                    ((x = S && typeof S.as == 'string' ? S.as : 'script'), x)
                  ) {
                    case 'script':
                      break;
                    default:
                      ((x = d(x)),
                        console.error(
                          'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
                          x,
                          v
                        ));
                  }
                typeof v == 'string' &&
                  (typeof S == 'object' && S !== null
                    ? (S.as == null || S.as === 'script') &&
                      ((x = r(S.as, S.crossOrigin)),
                      m.d.M(v, {
                        crossOrigin: x,
                        integrity:
                          typeof S.integrity == 'string' ? S.integrity : void 0,
                        nonce: typeof S.nonce == 'string' ? S.nonce : void 0,
                      }))
                    : S == null && m.d.M(v));
              }),
              (Wt.preload = function (v, S) {
                var x = '';
                if (
                  ((typeof v == 'string' && v) ||
                    (x += ' The `href` argument encountered was ' + u(v) + '.'),
                  S == null || typeof S != 'object'
                    ? (x +=
                        ' The `options` argument encountered was ' + u(S) + '.')
                    : (typeof S.as == 'string' && S.as) ||
                      (x +=
                        ' The `as` option encountered was ' + u(S.as) + '.'),
                  x &&
                    console.error(
                      'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
                      x
                    ),
                  typeof v == 'string' &&
                    typeof S == 'object' &&
                    S !== null &&
                    typeof S.as == 'string')
                ) {
                  x = S.as;
                  var D = r(x, S.crossOrigin);
                  m.d.L(v, x, {
                    crossOrigin: D,
                    integrity:
                      typeof S.integrity == 'string' ? S.integrity : void 0,
                    nonce: typeof S.nonce == 'string' ? S.nonce : void 0,
                    type: typeof S.type == 'string' ? S.type : void 0,
                    fetchPriority:
                      typeof S.fetchPriority == 'string'
                        ? S.fetchPriority
                        : void 0,
                    referrerPolicy:
                      typeof S.referrerPolicy == 'string'
                        ? S.referrerPolicy
                        : void 0,
                    imageSrcSet:
                      typeof S.imageSrcSet == 'string' ? S.imageSrcSet : void 0,
                    imageSizes:
                      typeof S.imageSizes == 'string' ? S.imageSizes : void 0,
                    media: typeof S.media == 'string' ? S.media : void 0,
                  });
                }
              }),
              (Wt.preloadModule = function (v, S) {
                var x = '';
                ((typeof v == 'string' && v) ||
                  (x += ' The `href` argument encountered was ' + u(v) + '.'),
                  S !== void 0 && typeof S != 'object'
                    ? (x +=
                        ' The `options` argument encountered was ' + u(S) + '.')
                    : S &&
                      'as' in S &&
                      typeof S.as != 'string' &&
                      (x +=
                        ' The `as` option encountered was ' + u(S.as) + '.'),
                  x &&
                    console.error(
                      'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
                      x
                    ),
                  typeof v == 'string' &&
                    (S
                      ? ((x = r(S.as, S.crossOrigin)),
                        m.d.m(v, {
                          as:
                            typeof S.as == 'string' && S.as !== 'script'
                              ? S.as
                              : void 0,
                          crossOrigin: x,
                          integrity:
                            typeof S.integrity == 'string'
                              ? S.integrity
                              : void 0,
                        }))
                      : m.d.m(v)));
              }),
              (Wt.requestFormReset = function (v) {
                m.d.r(v);
              }),
              (Wt.unstable_batchedUpdates = function (v, S) {
                return v(S);
              }),
              (Wt.useFormState = function (v, S, x) {
                return p().useFormState(v, S, x);
              }),
              (Wt.useFormStatus = function () {
                return p().useHostTransitionStatus();
              }),
              (Wt.version = '19.1.1'),
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                  'function' &&
                __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                  Error()
                ));
          })(),
          Wt
        );
      }
      var s0;
      function W0() {
        return (s0 || ((s0 = 1), (cp.exports = Xw())), cp.exports);
      }
      var o0;
      function Qw() {
        if (o0) return or;
        o0 = 1;
        /**
         * @license React
         * react-dom-client.development.js
         *
         * Copyright (c) Meta Platforms, Inc. and affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */ return (
          (function () {
            function i(e, t) {
              for (e = e.memoizedState; e !== null && 0 < t; )
                ((e = e.next), t--);
              return e;
            }
            function l(e, t, n, a) {
              if (n >= t.length) return a;
              var s = t[n],
                c = jt(e) ? e.slice() : Re({}, e);
              return ((c[s] = l(e[s], t, n + 1, a)), c);
            }
            function o(e, t, n) {
              if (t.length !== n.length)
                console.warn(
                  'copyWithRename() expects paths of the same length'
                );
              else {
                for (var a = 0; a < n.length - 1; a++)
                  if (t[a] !== n[a]) {
                    console.warn(
                      'copyWithRename() expects paths to be the same except for the deepest key'
                    );
                    return;
                  }
                return r(e, t, n, 0);
              }
            }
            function r(e, t, n, a) {
              var s = t[a],
                c = jt(e) ? e.slice() : Re({}, e);
              return (
                a + 1 === t.length
                  ? ((c[n[a]] = c[s]), jt(c) ? c.splice(s, 1) : delete c[s])
                  : (c[s] = r(e[s], t, n, a + 1)),
                c
              );
            }
            function u(e, t, n) {
              var a = t[n],
                s = jt(e) ? e.slice() : Re({}, e);
              return n + 1 === t.length
                ? (jt(s) ? s.splice(a, 1) : delete s[a], s)
                : ((s[a] = u(e[a], t, n + 1)), s);
            }
            function d() {
              return !1;
            }
            function p() {
              return null;
            }
            function h() {}
            function m() {
              console.error(
                'Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks'
              );
            }
            function y() {
              console.error(
                'Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().'
              );
            }
            function E() {}
            function v(e) {
              var t = [];
              return (
                e.forEach(function (n) {
                  t.push(n);
                }),
                t.sort().join(', ')
              );
            }
            function S(e, t, n, a) {
              return new US(e, t, n, a);
            }
            function x(e, t) {
              e.context === gi && (Mf(e.current, 2, t, e, null, null), zl());
            }
            function D(e, t) {
              if (_n !== null) {
                var n = t.staleFamilies;
                ((t = t.updatedFamilies), co(), Xu(e.current, t, n), zl());
              }
            }
            function M(e) {
              _n = e;
            }
            function k(e) {
              return !(
                !e ||
                (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11)
              );
            }
            function V(e) {
              var t = e,
                n = e;
              if (e.alternate) for (; t.return; ) t = t.return;
              else {
                e = t;
                do
                  ((t = e),
                    (t.flags & 4098) !== 0 && (n = t.return),
                    (e = t.return));
                while (e);
              }
              return t.tag === 3 ? n : null;
            }
            function L(e) {
              if (e.tag === 13) {
                var t = e.memoizedState;
                if (
                  (t === null &&
                    ((e = e.alternate), e !== null && (t = e.memoizedState)),
                  t !== null)
                )
                  return t.dehydrated;
              }
              return null;
            }
            function U(e) {
              if (V(e) !== e)
                throw Error('Unable to find node on an unmounted component.');
            }
            function Y(e) {
              var t = e.alternate;
              if (!t) {
                if (((t = V(e)), t === null))
                  throw Error('Unable to find node on an unmounted component.');
                return t !== e ? null : e;
              }
              for (var n = e, a = t; ; ) {
                var s = n.return;
                if (s === null) break;
                var c = s.alternate;
                if (c === null) {
                  if (((a = s.return), a !== null)) {
                    n = a;
                    continue;
                  }
                  break;
                }
                if (s.child === c.child) {
                  for (c = s.child; c; ) {
                    if (c === n) return (U(s), e);
                    if (c === a) return (U(s), t);
                    c = c.sibling;
                  }
                  throw Error('Unable to find node on an unmounted component.');
                }
                if (n.return !== a.return) ((n = s), (a = c));
                else {
                  for (var f = !1, b = s.child; b; ) {
                    if (b === n) {
                      ((f = !0), (n = s), (a = c));
                      break;
                    }
                    if (b === a) {
                      ((f = !0), (a = s), (n = c));
                      break;
                    }
                    b = b.sibling;
                  }
                  if (!f) {
                    for (b = c.child; b; ) {
                      if (b === n) {
                        ((f = !0), (n = c), (a = s));
                        break;
                      }
                      if (b === a) {
                        ((f = !0), (a = c), (n = s));
                        break;
                      }
                      b = b.sibling;
                    }
                    if (!f)
                      throw Error(
                        'Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.'
                      );
                  }
                }
                if (n.alternate !== a)
                  throw Error(
                    "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
                  );
              }
              if (n.tag !== 3)
                throw Error('Unable to find node on an unmounted component.');
              return n.stateNode.current === n ? e : t;
            }
            function G(e) {
              var t = e.tag;
              if (t === 5 || t === 26 || t === 27 || t === 6) return e;
              for (e = e.child; e !== null; ) {
                if (((t = G(e)), t !== null)) return t;
                e = e.sibling;
              }
              return null;
            }
            function P(e) {
              return e === null || typeof e != 'object'
                ? null
                : ((e = (Ny && e[Ny]) || e['@@iterator']),
                  typeof e == 'function' ? e : null);
            }
            function Q(e) {
              if (e == null) return null;
              if (typeof e == 'function')
                return e.$$typeof === nN
                  ? null
                  : e.displayName || e.name || null;
              if (typeof e == 'string') return e;
              switch (e) {
                case Gl:
                  return 'Fragment';
                case Lf:
                  return 'Profiler';
                case Sc:
                  return 'StrictMode';
                case Hf:
                  return 'Suspense';
                case Uf:
                  return 'SuspenseList';
                case If:
                  return 'Activity';
              }
              if (typeof e == 'object')
                switch (
                  (typeof e.tag == 'number' &&
                    console.error(
                      'Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.'
                    ),
                  e.$$typeof)
                ) {
                  case Pl:
                    return 'Portal';
                  case ra:
                    return (e.displayName || 'Context') + '.Provider';
                  case zf:
                    return (e._context.displayName || 'Context') + '.Consumer';
                  case vo:
                    var t = e.render;
                    return (
                      (e = e.displayName),
                      e ||
                        ((e = t.displayName || t.name || ''),
                        (e =
                          e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
                      e
                    );
                  case xc:
                    return (
                      (t = e.displayName || null),
                      t !== null ? t : Q(e.type) || 'Memo'
                    );
                  case gn:
                    ((t = e._payload), (e = e._init));
                    try {
                      return Q(e(t));
                    } catch {}
                }
              return null;
            }
            function X(e) {
              return typeof e.tag == 'number'
                ? J(e)
                : typeof e.name == 'string'
                  ? e.name
                  : null;
            }
            function J(e) {
              var t = e.type;
              switch (e.tag) {
                case 31:
                  return 'Activity';
                case 24:
                  return 'Cache';
                case 9:
                  return (t._context.displayName || 'Context') + '.Consumer';
                case 10:
                  return (t.displayName || 'Context') + '.Provider';
                case 18:
                  return 'DehydratedFragment';
                case 11:
                  return (
                    (e = t.render),
                    (e = e.displayName || e.name || ''),
                    t.displayName ||
                      (e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')
                  );
                case 7:
                  return 'Fragment';
                case 26:
                case 27:
                case 5:
                  return t;
                case 4:
                  return 'Portal';
                case 3:
                  return 'Root';
                case 6:
                  return 'Text';
                case 16:
                  return Q(t);
                case 8:
                  return t === Sc ? 'StrictMode' : 'Mode';
                case 22:
                  return 'Offscreen';
                case 12:
                  return 'Profiler';
                case 21:
                  return 'Scope';
                case 13:
                  return 'Suspense';
                case 19:
                  return 'SuspenseList';
                case 25:
                  return 'TracingMarker';
                case 1:
                case 0:
                case 14:
                case 15:
                  if (typeof t == 'function')
                    return t.displayName || t.name || null;
                  if (typeof t == 'string') return t;
                  break;
                case 29:
                  if (((t = e._debugInfo), t != null)) {
                    for (var n = t.length - 1; 0 <= n; n--)
                      if (typeof t[n].name == 'string') return t[n].name;
                  }
                  if (e.return !== null) return J(e.return);
              }
              return null;
            }
            function ee(e) {
              return { current: e };
            }
            function q(e, t) {
              0 > ka
                ? console.error('Unexpected pop.')
                : (t !== $f[ka] && console.error('Unexpected Fiber popped.'),
                  (e.current = Wf[ka]),
                  (Wf[ka] = null),
                  ($f[ka] = null),
                  ka--);
            }
            function se(e, t, n) {
              (ka++, (Wf[ka] = e.current), ($f[ka] = n), (e.current = t));
            }
            function ge(e) {
              return (
                e === null &&
                  console.error(
                    'Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.'
                  ),
                e
              );
            }
            function we(e, t) {
              (se(fi, t, e), se(So, e, e), se(di, null, e));
              var n = t.nodeType;
              switch (n) {
                case 9:
                case 11:
                  ((n = n === 9 ? '#document' : '#fragment'),
                    (t =
                      (t = t.documentElement) && (t = t.namespaceURI)
                        ? Zb(t)
                        : Pa));
                  break;
                default:
                  if (((n = t.tagName), (t = t.namespaceURI)))
                    ((t = Zb(t)), (t = Fb(t, n)));
                  else
                    switch (n) {
                      case 'svg':
                        t = Ts;
                        break;
                      case 'math':
                        t = ou;
                        break;
                      default:
                        t = Pa;
                    }
              }
              ((n = n.toLowerCase()),
                (n = sh(null, n)),
                (n = { context: t, ancestorInfo: n }),
                q(di, e),
                se(di, n, e));
            }
            function We(e) {
              (q(di, e), q(So, e), q(fi, e));
            }
            function K() {
              return ge(di.current);
            }
            function ce(e) {
              e.memoizedState !== null && se(Nc, e, e);
              var t = ge(di.current),
                n = e.type,
                a = Fb(t.context, n);
              ((n = sh(t.ancestorInfo, n)),
                (a = { context: a, ancestorInfo: n }),
                t !== a && (se(So, e, e), se(di, a, e)));
            }
            function F(e) {
              (So.current === e && (q(di, e), q(So, e)),
                Nc.current === e && (q(Nc, e), (ir._currentValue = vl)));
            }
            function me(e) {
              return (
                (typeof Symbol == 'function' &&
                  Symbol.toStringTag &&
                  e[Symbol.toStringTag]) ||
                e.constructor.name ||
                'Object'
              );
            }
            function W(e) {
              try {
                return !1;
              } catch {
                return !0;
              }
            }
            function re(e) {
              return '' + e;
            }
            function ue(e, t) {
              if (W())
                return (
                  console.error(
                    'The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.',
                    t,
                    me(e)
                  ),
                  re(e)
                );
            }
            function Ue(e, t) {
              if (W())
                return (
                  console.error(
                    'The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.',
                    t,
                    me(e)
                  ),
                  re(e)
                );
            }
            function et(e) {
              if (W())
                return (
                  console.error(
                    'Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.',
                    me(e)
                  ),
                  re(e)
                );
            }
            function zt(e) {
              if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u') return !1;
              var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
              if (t.isDisabled) return !0;
              if (!t.supportsFiber)
                return (
                  console.error(
                    'The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools'
                  ),
                  !0
                );
              try {
                ((Yl = t.inject(e)), (Ht = t));
              } catch (n) {
                console.error(
                  'React instrumentation encountered an error: %s.',
                  n
                );
              }
              return !!t.checkDCE;
            }
            function Le(e) {
              if (
                (typeof cN == 'function' && uN(e),
                Ht && typeof Ht.setStrictMode == 'function')
              )
                try {
                  Ht.setStrictMode(Yl, e);
                } catch (t) {
                  ua ||
                    ((ua = !0),
                    console.error(
                      'React instrumentation encountered an error: %s',
                      t
                    ));
                }
            }
            function Vi(e) {
              oe = e;
            }
            function lt() {
              oe !== null &&
                typeof oe.markCommitStopped == 'function' &&
                oe.markCommitStopped();
            }
            function Mt(e) {
              oe !== null &&
                typeof oe.markComponentRenderStarted == 'function' &&
                oe.markComponentRenderStarted(e);
            }
            function Dn() {
              oe !== null &&
                typeof oe.markComponentRenderStopped == 'function' &&
                oe.markComponentRenderStopped();
            }
            function Bi(e) {
              oe !== null &&
                typeof oe.markRenderStarted == 'function' &&
                oe.markRenderStarted(e);
            }
            function Os() {
              oe !== null &&
                typeof oe.markRenderStopped == 'function' &&
                oe.markRenderStopped();
            }
            function Za(e, t) {
              oe !== null &&
                typeof oe.markStateUpdateScheduled == 'function' &&
                oe.markStateUpdateScheduled(e, t);
            }
            function br(e) {
              return ((e >>>= 0), e === 0 ? 32 : (31 - ((dN(e) / fN) | 0)) | 0);
            }
            function ks(e) {
              if (e & 1) return 'SyncHydrationLane';
              if (e & 2) return 'Sync';
              if (e & 4) return 'InputContinuousHydration';
              if (e & 8) return 'InputContinuous';
              if (e & 16) return 'DefaultHydration';
              if (e & 32) return 'Default';
              if (e & 128) return 'TransitionHydration';
              if (e & 4194048) return 'Transition';
              if (e & 62914560) return 'Retry';
              if (e & 67108864) return 'SelectiveHydration';
              if (e & 134217728) return 'IdleHydration';
              if (e & 268435456) return 'Idle';
              if (e & 536870912) return 'Offscreen';
              if (e & 1073741824) return 'Deferred';
            }
            function bt(e) {
              var t = e & 42;
              if (t !== 0) return t;
              switch (e & -e) {
                case 1:
                  return 1;
                case 2:
                  return 2;
                case 4:
                  return 4;
                case 8:
                  return 8;
                case 16:
                  return 16;
                case 32:
                  return 32;
                case 64:
                  return 64;
                case 128:
                  return 128;
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                  return e & 4194048;
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                  return e & 62914560;
                case 67108864:
                  return 67108864;
                case 134217728:
                  return 134217728;
                case 268435456:
                  return 268435456;
                case 536870912:
                  return 536870912;
                case 1073741824:
                  return 0;
                default:
                  return (
                    console.error(
                      'Should have found matching lanes. This is a bug in React.'
                    ),
                    e
                  );
              }
            }
            function xa(e, t, n) {
              var a = e.pendingLanes;
              if (a === 0) return 0;
              var s = 0,
                c = e.suspendedLanes,
                f = e.pingedLanes;
              e = e.warmLanes;
              var b = a & 134217727;
              return (
                b !== 0
                  ? ((a = b & ~c),
                    a !== 0
                      ? (s = bt(a))
                      : ((f &= b),
                        f !== 0
                          ? (s = bt(f))
                          : n || ((n = b & ~e), n !== 0 && (s = bt(n)))))
                  : ((b = a & ~c),
                    b !== 0
                      ? (s = bt(b))
                      : f !== 0
                        ? (s = bt(f))
                        : n || ((n = a & ~e), n !== 0 && (s = bt(n)))),
                s === 0
                  ? 0
                  : t !== 0 &&
                      t !== s &&
                      (t & c) === 0 &&
                      ((c = s & -s),
                      (n = t & -t),
                      c >= n || (c === 32 && (n & 4194048) !== 0))
                    ? t
                    : s
              );
            }
            function Fa(e, t) {
              return (
                (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) ===
                0
              );
            }
            function Ou(e, t) {
              switch (e) {
                case 1:
                case 2:
                case 4:
                case 8:
                case 64:
                  return t + 250;
                case 16:
                case 32:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                  return t + 5e3;
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                  return -1;
                case 67108864:
                case 134217728:
                case 268435456:
                case 536870912:
                case 1073741824:
                  return -1;
                default:
                  return (
                    console.error(
                      'Should have found matching lanes. This is a bug in React.'
                    ),
                    -1
                  );
              }
            }
            function Me() {
              var e = wc;
              return ((wc <<= 1), (wc & 4194048) === 0 && (wc = 256), e);
            }
            function Li() {
              var e = Ec;
              return ((Ec <<= 1), (Ec & 62914560) === 0 && (Ec = 4194304), e);
            }
            function Dl(e) {
              for (var t = [], n = 0; 31 > n; n++) t.push(e);
              return t;
            }
            function Ka(e, t) {
              ((e.pendingLanes |= t),
                t !== 268435456 &&
                  ((e.suspendedLanes = 0),
                  (e.pingedLanes = 0),
                  (e.warmLanes = 0)));
            }
            function yr(e, t, n, a, s, c) {
              var f = e.pendingLanes;
              ((e.pendingLanes = n),
                (e.suspendedLanes = 0),
                (e.pingedLanes = 0),
                (e.warmLanes = 0),
                (e.expiredLanes &= n),
                (e.entangledLanes &= n),
                (e.errorRecoveryDisabledLanes &= n),
                (e.shellSuspendCounter = 0));
              var b = e.entanglements,
                w = e.expirationTimes,
                T = e.hiddenUpdates;
              for (n = f & ~n; 0 < n; ) {
                var j = 31 - $t(n),
                  H = 1 << j;
                ((b[j] = 0), (w[j] = -1));
                var _ = T[j];
                if (_ !== null)
                  for (T[j] = null, j = 0; j < _.length; j++) {
                    var I = _[j];
                    I !== null && (I.lane &= -536870913);
                  }
                n &= ~H;
              }
              (a !== 0 && _s(e, a, 0),
                c !== 0 &&
                  s === 0 &&
                  e.tag !== 0 &&
                  (e.suspendedLanes |= c & ~(f & ~t)));
            }
            function _s(e, t, n) {
              ((e.pendingLanes |= t), (e.suspendedLanes &= ~t));
              var a = 31 - $t(t);
              ((e.entangledLanes |= t),
                (e.entanglements[a] =
                  e.entanglements[a] | 1073741824 | (n & 4194090)));
            }
            function vr(e, t) {
              var n = (e.entangledLanes |= t);
              for (e = e.entanglements; n; ) {
                var a = 31 - $t(n),
                  s = 1 << a;
                ((s & t) | (e[a] & t) && (e[a] |= t), (n &= ~s));
              }
            }
            function js(e) {
              switch (e) {
                case 2:
                  e = 1;
                  break;
                case 8:
                  e = 4;
                  break;
                case 32:
                  e = 16;
                  break;
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                  e = 128;
                  break;
                case 268435456:
                  e = 134217728;
                  break;
                default:
                  e = 0;
              }
              return e;
            }
            function Vs(e, t, n) {
              if (Xn)
                for (e = e.pendingUpdatersLaneMap; 0 < n; ) {
                  var a = 31 - $t(n),
                    s = 1 << a;
                  (e[a].add(t), (n &= ~s));
                }
            }
            function Bs(e, t) {
              if (Xn)
                for (
                  var n = e.pendingUpdatersLaneMap, a = e.memoizedUpdaters;
                  0 < t;
                ) {
                  var s = 31 - $t(t);
                  ((e = 1 << s),
                    (s = n[s]),
                    0 < s.size &&
                      (s.forEach(function (c) {
                        var f = c.alternate;
                        (f !== null && a.has(f)) || a.add(c);
                      }),
                      s.clear()),
                    (t &= ~e));
                }
            }
            function Tl(e) {
              return (
                (e &= -e),
                On < e ? (da < e ? ((e & 134217727) !== 0 ? ja : Dc) : da) : On
              );
            }
            function Ls() {
              var e = $e.p;
              return e !== 0
                ? e
                : ((e = window.event), e === void 0 ? ja : gy(e.type));
            }
            function Cl(e, t) {
              var n = $e.p;
              try {
                return (($e.p = e), t());
              } finally {
                $e.p = n;
              }
            }
            function Ja(e) {
              (delete e[Ut],
                delete e[an],
                delete e[Xf],
                delete e[mN],
                delete e[pN]);
            }
            function Pn(e) {
              var t = e[Ut];
              if (t) return t;
              for (var n = e.parentNode; n; ) {
                if ((t = n[pi] || n[Ut])) {
                  if (
                    ((n = t.alternate),
                    t.child !== null || (n !== null && n.child !== null))
                  )
                    for (e = ay(e); e !== null; ) {
                      if ((n = e[Ut])) return n;
                      e = ay(e);
                    }
                  return t;
                }
                ((e = n), (n = e.parentNode));
              }
              return null;
            }
            function Gn(e) {
              if ((e = e[Ut] || e[pi])) {
                var t = e.tag;
                if (
                  t === 5 ||
                  t === 6 ||
                  t === 13 ||
                  t === 26 ||
                  t === 27 ||
                  t === 3
                )
                  return e;
              }
              return null;
            }
            function ei(e) {
              var t = e.tag;
              if (t === 5 || t === 26 || t === 27 || t === 6)
                return e.stateNode;
              throw Error('getNodeFromInstance: Invalid argument.');
            }
            function N(e) {
              var t = e[wy];
              return (
                t ||
                  (t = e[wy] =
                    {
                      hoistableStyles: new Map(),
                      hoistableScripts: new Map(),
                    }),
                t
              );
            }
            function O(e) {
              e[xo] = !0;
            }
            function ne(e, t) {
              (ie(e, t), ie(e + 'Capture', t));
            }
            function ie(e, t) {
              (el[e] &&
                console.error(
                  'EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.',
                  e
                ),
                (el[e] = t));
              var n = e.toLowerCase();
              for (
                Qf[n] = e, e === 'onDoubleClick' && (Qf.ondblclick = e), e = 0;
                e < t.length;
                e++
              )
                Ey.add(t[e]);
            }
            function pe(e, t) {
              (hN[t.type] ||
                t.onChange ||
                t.onInput ||
                t.readOnly ||
                t.disabled ||
                t.value == null ||
                console.error(
                  e === 'select'
                    ? 'You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`.'
                    : 'You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.'
                ),
                t.onChange ||
                  t.readOnly ||
                  t.disabled ||
                  t.checked == null ||
                  console.error(
                    'You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.'
                  ));
            }
            function Ae(e) {
              return _a.call(Ty, e)
                ? !0
                : _a.call(Dy, e)
                  ? !1
                  : gN.test(e)
                    ? (Ty[e] = !0)
                    : ((Dy[e] = !0),
                      console.error('Invalid attribute name: `%s`', e),
                      !1);
            }
            function De(e, t, n) {
              if (Ae(t)) {
                if (!e.hasAttribute(t)) {
                  switch (typeof n) {
                    case 'symbol':
                    case 'object':
                      return n;
                    case 'function':
                      return n;
                    case 'boolean':
                      if (n === !1) return n;
                  }
                  return n === void 0 ? void 0 : null;
                }
                return (
                  (e = e.getAttribute(t)),
                  e === '' && n === !0 ? !0 : (ue(n, t), e === '' + n ? n : e)
                );
              }
            }
            function ze(e, t, n) {
              if (Ae(t))
                if (n === null) e.removeAttribute(t);
                else {
                  switch (typeof n) {
                    case 'undefined':
                    case 'function':
                    case 'symbol':
                      e.removeAttribute(t);
                      return;
                    case 'boolean':
                      var a = t.toLowerCase().slice(0, 5);
                      if (a !== 'data-' && a !== 'aria-') {
                        e.removeAttribute(t);
                        return;
                      }
                  }
                  (ue(n, t), e.setAttribute(t, '' + n));
                }
            }
            function Te(e, t, n) {
              if (n === null) e.removeAttribute(t);
              else {
                switch (typeof n) {
                  case 'undefined':
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    e.removeAttribute(t);
                    return;
                }
                (ue(n, t), e.setAttribute(t, '' + n));
              }
            }
            function Dt(e, t, n, a) {
              if (a === null) e.removeAttribute(n);
              else {
                switch (typeof a) {
                  case 'undefined':
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    e.removeAttribute(n);
                    return;
                }
                (ue(a, n), e.setAttributeNS(t, n, '' + a));
              }
            }
            function Na() {}
            function ku() {
              if (No === 0) {
                ((Cy = console.log),
                  (Ay = console.info),
                  (Ry = console.warn),
                  (My = console.error),
                  (Oy = console.group),
                  (ky = console.groupCollapsed),
                  (_y = console.groupEnd));
                var e = {
                  configurable: !0,
                  enumerable: !0,
                  value: Na,
                  writable: !0,
                };
                Object.defineProperties(console, {
                  info: e,
                  log: e,
                  warn: e,
                  error: e,
                  group: e,
                  groupCollapsed: e,
                  groupEnd: e,
                });
              }
              No++;
            }
            function _u() {
              if ((No--, No === 0)) {
                var e = { configurable: !0, enumerable: !0, writable: !0 };
                Object.defineProperties(console, {
                  log: Re({}, e, { value: Cy }),
                  info: Re({}, e, { value: Ay }),
                  warn: Re({}, e, { value: Ry }),
                  error: Re({}, e, { value: My }),
                  group: Re({}, e, { value: Oy }),
                  groupCollapsed: Re({}, e, { value: ky }),
                  groupEnd: Re({}, e, { value: _y }),
                });
              }
              0 > No &&
                console.error(
                  'disabledDepth fell below zero. This is a bug in React. Please file an issue.'
                );
            }
            function Tn(e) {
              if (Zf === void 0)
                try {
                  throw Error();
                } catch (n) {
                  var t = n.stack.trim().match(/\n( *(at )?)/);
                  ((Zf = (t && t[1]) || ''),
                    (jy =
                      -1 <
                      n.stack.indexOf(`
    at`)
                        ? ' (<anonymous>)'
                        : -1 < n.stack.indexOf('@')
                          ? '@unknown:0:0'
                          : ''));
                }
              return (
                `
` +
                Zf +
                e +
                jy
              );
            }
            function ju(e, t) {
              if (!e || Ff) return '';
              var n = Kf.get(e);
              if (n !== void 0) return n;
              ((Ff = !0),
                (n = Error.prepareStackTrace),
                (Error.prepareStackTrace = void 0));
              var a = null;
              ((a = z.H), (z.H = null), ku());
              try {
                var s = {
                  DetermineComponentFrameRoot: function () {
                    try {
                      if (t) {
                        var _ = function () {
                          throw Error();
                        };
                        if (
                          (Object.defineProperty(_.prototype, 'props', {
                            set: function () {
                              throw Error();
                            },
                          }),
                          typeof Reflect == 'object' && Reflect.construct)
                        ) {
                          try {
                            Reflect.construct(_, []);
                          } catch (fe) {
                            var I = fe;
                          }
                          Reflect.construct(e, [], _);
                        } else {
                          try {
                            _.call();
                          } catch (fe) {
                            I = fe;
                          }
                          e.call(_.prototype);
                        }
                      } else {
                        try {
                          throw Error();
                        } catch (fe) {
                          I = fe;
                        }
                        (_ = e()) &&
                          typeof _.catch == 'function' &&
                          _.catch(function () {});
                      }
                    } catch (fe) {
                      if (fe && I && typeof fe.stack == 'string')
                        return [fe.stack, I.stack];
                    }
                    return [null, null];
                  },
                };
                s.DetermineComponentFrameRoot.displayName =
                  'DetermineComponentFrameRoot';
                var c = Object.getOwnPropertyDescriptor(
                  s.DetermineComponentFrameRoot,
                  'name'
                );
                c &&
                  c.configurable &&
                  Object.defineProperty(s.DetermineComponentFrameRoot, 'name', {
                    value: 'DetermineComponentFrameRoot',
                  });
                var f = s.DetermineComponentFrameRoot(),
                  b = f[0],
                  w = f[1];
                if (b && w) {
                  var T = b.split(`
`),
                    j = w.split(`
`);
                  for (
                    f = c = 0;
                    c < T.length &&
                    !T[c].includes('DetermineComponentFrameRoot');
                  )
                    c++;
                  for (
                    ;
                    f < j.length &&
                    !j[f].includes('DetermineComponentFrameRoot');
                  )
                    f++;
                  if (c === T.length || f === j.length)
                    for (
                      c = T.length - 1, f = j.length - 1;
                      1 <= c && 0 <= f && T[c] !== j[f];
                    )
                      f--;
                  for (; 1 <= c && 0 <= f; c--, f--)
                    if (T[c] !== j[f]) {
                      if (c !== 1 || f !== 1)
                        do
                          if ((c--, f--, 0 > f || T[c] !== j[f])) {
                            var H =
                              `
` + T[c].replace(' at new ', ' at ');
                            return (
                              e.displayName &&
                                H.includes('<anonymous>') &&
                                (H = H.replace('<anonymous>', e.displayName)),
                              typeof e == 'function' && Kf.set(e, H),
                              H
                            );
                          }
                        while (1 <= c && 0 <= f);
                      break;
                    }
                }
              } finally {
                ((Ff = !1), (z.H = a), _u(), (Error.prepareStackTrace = n));
              }
              return (
                (T = (T = e ? e.displayName || e.name : '') ? Tn(T) : ''),
                typeof e == 'function' && Kf.set(e, T),
                T
              );
            }
            function $p(e) {
              var t = Error.prepareStackTrace;
              if (
                ((Error.prepareStackTrace = void 0),
                (e = e.stack),
                (Error.prepareStackTrace = t),
                e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)),
                (t = e.indexOf(`
`)),
                t !== -1 && (e = e.slice(t + 1)),
                (t = e.indexOf('react_stack_bottom_frame')),
                t !== -1 &&
                  (t = e.lastIndexOf(
                    `
`,
                    t
                  )),
                t !== -1)
              )
                e = e.slice(0, t);
              else return '';
              return e;
            }
            function vS(e) {
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  return Tn(e.type);
                case 16:
                  return Tn('Lazy');
                case 13:
                  return Tn('Suspense');
                case 19:
                  return Tn('SuspenseList');
                case 0:
                case 15:
                  return ju(e.type, !1);
                case 11:
                  return ju(e.type.render, !1);
                case 1:
                  return ju(e.type, !0);
                case 31:
                  return Tn('Activity');
                default:
                  return '';
              }
            }
            function Pp(e) {
              try {
                var t = '';
                do {
                  t += vS(e);
                  var n = e._debugInfo;
                  if (n)
                    for (var a = n.length - 1; 0 <= a; a--) {
                      var s = n[a];
                      if (typeof s.name == 'string') {
                        var c = t,
                          f = s.env,
                          b = Tn(s.name + (f ? ' [' + f + ']' : ''));
                        t = c + b;
                      }
                    }
                  e = e.return;
                } while (e);
                return t;
              } catch (w) {
                return (
                  `
Error generating stack: ` +
                  w.message +
                  `
` +
                  w.stack
                );
              }
            }
            function Gp(e) {
              return (e = e ? e.displayName || e.name : '') ? Tn(e) : '';
            }
            function Sr() {
              if (bn === null) return null;
              var e = bn._debugOwner;
              return e != null ? X(e) : null;
            }
            function SS() {
              if (bn === null) return '';
              var e = bn;
              try {
                var t = '';
                switch ((e.tag === 6 && (e = e.return), e.tag)) {
                  case 26:
                  case 27:
                  case 5:
                    t += Tn(e.type);
                    break;
                  case 13:
                    t += Tn('Suspense');
                    break;
                  case 19:
                    t += Tn('SuspenseList');
                    break;
                  case 31:
                    t += Tn('Activity');
                    break;
                  case 30:
                  case 0:
                  case 15:
                  case 1:
                    e._debugOwner || t !== '' || (t += Gp(e.type));
                    break;
                  case 11:
                    e._debugOwner || t !== '' || (t += Gp(e.type.render));
                }
                for (; e; )
                  if (typeof e.tag == 'number') {
                    var n = e;
                    e = n._debugOwner;
                    var a = n._debugStack;
                    e &&
                      a &&
                      (typeof a != 'string' && (n._debugStack = a = $p(a)),
                      a !== '' &&
                        (t +=
                          `
` + a));
                  } else if (e.debugStack != null) {
                    var s = e.debugStack;
                    (e = e.owner) &&
                      s &&
                      (t +=
                        `
` + $p(s));
                  } else break;
                var c = t;
              } catch (f) {
                c =
                  `
Error generating stack: ` +
                  f.message +
                  `
` +
                  f.stack;
              }
              return c;
            }
            function he(e, t, n, a, s, c, f) {
              var b = bn;
              Vu(e);
              try {
                return e !== null && e._debugTask
                  ? e._debugTask.run(t.bind(null, n, a, s, c, f))
                  : t(n, a, s, c, f);
              } finally {
                Vu(b);
              }
              throw Error(
                'runWithFiberInDEV should never be called in production. This is a bug in React.'
              );
            }
            function Vu(e) {
              ((z.getCurrentStack = e === null ? null : SS),
                (fa = !1),
                (bn = e));
            }
            function Cn(e) {
              switch (typeof e) {
                case 'bigint':
                case 'boolean':
                case 'number':
                case 'string':
                case 'undefined':
                  return e;
                case 'object':
                  return (et(e), e);
                default:
                  return '';
              }
            }
            function qp(e) {
              var t = e.type;
              return (
                (e = e.nodeName) &&
                e.toLowerCase() === 'input' &&
                (t === 'checkbox' || t === 'radio')
              );
            }
            function xS(e) {
              var t = qp(e) ? 'checked' : 'value',
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
              et(e[t]);
              var a = '' + e[t];
              if (
                !e.hasOwnProperty(t) &&
                typeof n < 'u' &&
                typeof n.get == 'function' &&
                typeof n.set == 'function'
              ) {
                var s = n.get,
                  c = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return s.call(this);
                    },
                    set: function (f) {
                      (et(f), (a = '' + f), c.call(this, f));
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return a;
                    },
                    setValue: function (f) {
                      (et(f), (a = '' + f));
                    },
                    stopTracking: function () {
                      ((e._valueTracker = null), delete e[t]);
                    },
                  }
                );
              }
            }
            function xr(e) {
              e._valueTracker || (e._valueTracker = xS(e));
            }
            function Yp(e) {
              if (!e) return !1;
              var t = e._valueTracker;
              if (!t) return !0;
              var n = t.getValue(),
                a = '';
              return (
                e && (a = qp(e) ? (e.checked ? 'true' : 'false') : e.value),
                (e = a),
                e !== n ? (t.setValue(e), !0) : !1
              );
            }
            function Nr(e) {
              if (
                ((e = e || (typeof document < 'u' ? document : void 0)),
                typeof e > 'u')
              )
                return null;
              try {
                return e.activeElement || e.body;
              } catch {
                return e.body;
              }
            }
            function An(e) {
              return e.replace(bN, function (t) {
                return '\\' + t.charCodeAt(0).toString(16) + ' ';
              });
            }
            function Xp(e, t) {
              (t.checked === void 0 ||
                t.defaultChecked === void 0 ||
                By ||
                (console.error(
                  '%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components',
                  Sr() || 'A component',
                  t.type
                ),
                (By = !0)),
                t.value === void 0 ||
                  t.defaultValue === void 0 ||
                  Vy ||
                  (console.error(
                    '%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components',
                    Sr() || 'A component',
                    t.type
                  ),
                  (Vy = !0)));
            }
            function Bu(e, t, n, a, s, c, f, b) {
              ((e.name = ''),
                f != null &&
                typeof f != 'function' &&
                typeof f != 'symbol' &&
                typeof f != 'boolean'
                  ? (ue(f, 'type'), (e.type = f))
                  : e.removeAttribute('type'),
                t != null
                  ? f === 'number'
                    ? ((t === 0 && e.value === '') || e.value != t) &&
                      (e.value = '' + Cn(t))
                    : e.value !== '' + Cn(t) && (e.value = '' + Cn(t))
                  : (f !== 'submit' && f !== 'reset') ||
                    e.removeAttribute('value'),
                t != null
                  ? Lu(e, f, Cn(t))
                  : n != null
                    ? Lu(e, f, Cn(n))
                    : a != null && e.removeAttribute('value'),
                s == null && c != null && (e.defaultChecked = !!c),
                s != null &&
                  (e.checked =
                    s && typeof s != 'function' && typeof s != 'symbol'),
                b != null &&
                typeof b != 'function' &&
                typeof b != 'symbol' &&
                typeof b != 'boolean'
                  ? (ue(b, 'name'), (e.name = '' + Cn(b)))
                  : e.removeAttribute('name'));
            }
            function Qp(e, t, n, a, s, c, f, b) {
              if (
                (c != null &&
                  typeof c != 'function' &&
                  typeof c != 'symbol' &&
                  typeof c != 'boolean' &&
                  (ue(c, 'type'), (e.type = c)),
                t != null || n != null)
              ) {
                if (!((c !== 'submit' && c !== 'reset') || t != null)) return;
                ((n = n != null ? '' + Cn(n) : ''),
                  (t = t != null ? '' + Cn(t) : n),
                  b || t === e.value || (e.value = t),
                  (e.defaultValue = t));
              }
              ((a = a ?? s),
                (a = typeof a != 'function' && typeof a != 'symbol' && !!a),
                (e.checked = b ? e.checked : !!a),
                (e.defaultChecked = !!a),
                f != null &&
                  typeof f != 'function' &&
                  typeof f != 'symbol' &&
                  typeof f != 'boolean' &&
                  (ue(f, 'name'), (e.name = f)));
            }
            function Lu(e, t, n) {
              (t === 'number' && Nr(e.ownerDocument) === e) ||
                e.defaultValue === '' + n ||
                (e.defaultValue = '' + n);
            }
            function Zp(e, t) {
              (t.value == null &&
                (typeof t.children == 'object' && t.children !== null
                  ? Bf.Children.forEach(t.children, function (n) {
                      n == null ||
                        typeof n == 'string' ||
                        typeof n == 'number' ||
                        typeof n == 'bigint' ||
                        zy ||
                        ((zy = !0),
                        console.error(
                          'Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.'
                        ));
                    })
                  : t.dangerouslySetInnerHTML == null ||
                    Hy ||
                    ((Hy = !0),
                    console.error(
                      'Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.'
                    ))),
                t.selected == null ||
                  Ly ||
                  (console.error(
                    'Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.'
                  ),
                  (Ly = !0)));
            }
            function Fp() {
              var e = Sr();
              return e
                ? `

Check the render method of \`` +
                    e +
                    '`.'
                : '';
            }
            function Al(e, t, n, a) {
              if (((e = e.options), t)) {
                t = {};
                for (var s = 0; s < n.length; s++) t['$' + n[s]] = !0;
                for (n = 0; n < e.length; n++)
                  ((s = t.hasOwnProperty('$' + e[n].value)),
                    e[n].selected !== s && (e[n].selected = s),
                    s && a && (e[n].defaultSelected = !0));
              } else {
                for (n = '' + Cn(n), t = null, s = 0; s < e.length; s++) {
                  if (e[s].value === n) {
                    ((e[s].selected = !0), a && (e[s].defaultSelected = !0));
                    return;
                  }
                  t !== null || e[s].disabled || (t = e[s]);
                }
                t !== null && (t.selected = !0);
              }
            }
            function Kp(e, t) {
              for (e = 0; e < Iy.length; e++) {
                var n = Iy[e];
                if (t[n] != null) {
                  var a = jt(t[n]);
                  t.multiple && !a
                    ? console.error(
                        'The `%s` prop supplied to <select> must be an array if `multiple` is true.%s',
                        n,
                        Fp()
                      )
                    : !t.multiple &&
                      a &&
                      console.error(
                        'The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s',
                        n,
                        Fp()
                      );
                }
              }
              t.value === void 0 ||
                t.defaultValue === void 0 ||
                Uy ||
                (console.error(
                  'Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components'
                ),
                (Uy = !0));
            }
            function Jp(e, t) {
              (t.value === void 0 ||
                t.defaultValue === void 0 ||
                Wy ||
                (console.error(
                  '%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components',
                  Sr() || 'A component'
                ),
                (Wy = !0)),
                t.children != null &&
                  t.value == null &&
                  console.error(
                    'Use the `defaultValue` or `value` props instead of setting children on <textarea>.'
                  ));
            }
            function eh(e, t, n) {
              if (
                t != null &&
                ((t = '' + Cn(t)), t !== e.value && (e.value = t), n == null)
              ) {
                e.defaultValue !== t && (e.defaultValue = t);
                return;
              }
              e.defaultValue = n != null ? '' + Cn(n) : '';
            }
            function th(e, t, n, a) {
              if (t == null) {
                if (a != null) {
                  if (n != null)
                    throw Error(
                      'If you supply `defaultValue` on a <textarea>, do not pass children.'
                    );
                  if (jt(a)) {
                    if (1 < a.length)
                      throw Error(
                        '<textarea> can only have at most one child.'
                      );
                    a = a[0];
                  }
                  n = a;
                }
                (n == null && (n = ''), (t = n));
              }
              ((n = Cn(t)),
                (e.defaultValue = n),
                (a = e.textContent),
                a === n && a !== '' && a !== null && (e.value = a));
            }
            function nh(e, t) {
              return e.serverProps === void 0 &&
                e.serverTail.length === 0 &&
                e.children.length === 1 &&
                3 < e.distanceFromLeaf &&
                e.distanceFromLeaf > 15 - t
                ? nh(e.children[0], t)
                : e;
            }
            function dn(e) {
              return '  ' + '  '.repeat(e);
            }
            function Rl(e) {
              return '+ ' + '  '.repeat(e);
            }
            function zi(e) {
              return '- ' + '  '.repeat(e);
            }
            function ah(e) {
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  return e.type;
                case 16:
                  return 'Lazy';
                case 13:
                  return 'Suspense';
                case 19:
                  return 'SuspenseList';
                case 0:
                case 15:
                  return ((e = e.type), e.displayName || e.name || null);
                case 11:
                  return ((e = e.type.render), e.displayName || e.name || null);
                case 1:
                  return ((e = e.type), e.displayName || e.name || null);
                default:
                  return null;
              }
            }
            function zs(e, t) {
              return $y.test(e)
                ? ((e = JSON.stringify(e)),
                  e.length > t - 2
                    ? 8 > t
                      ? '{"..."}'
                      : '{' + e.slice(0, t - 7) + '..."}'
                    : '{' + e + '}')
                : e.length > t
                  ? 5 > t
                    ? '{"..."}'
                    : e.slice(0, t - 3) + '...'
                  : e;
            }
            function wr(e, t, n) {
              var a = 120 - 2 * n;
              if (t === null)
                return (
                  Rl(n) +
                  zs(e, a) +
                  `
`
                );
              if (typeof t == 'string') {
                for (
                  var s = 0;
                  s < t.length &&
                  s < e.length &&
                  t.charCodeAt(s) === e.charCodeAt(s);
                  s++
                );
                return (
                  s > a - 8 &&
                    10 < s &&
                    ((e = '...' + e.slice(s - 8)),
                    (t = '...' + t.slice(s - 8))),
                  Rl(n) +
                    zs(e, a) +
                    `
` +
                    zi(n) +
                    zs(t, a) +
                    `
`
                );
              }
              return (
                dn(n) +
                zs(e, a) +
                `
`
              );
            }
            function zu(e) {
              return Object.prototype.toString
                .call(e)
                .replace(/^\[object (.*)\]$/, function (t, n) {
                  return n;
                });
            }
            function Hs(e, t) {
              switch (typeof e) {
                case 'string':
                  return (
                    (e = JSON.stringify(e)),
                    e.length > t
                      ? 5 > t
                        ? '"..."'
                        : e.slice(0, t - 4) + '..."'
                      : e
                  );
                case 'object':
                  if (e === null) return 'null';
                  if (jt(e)) return '[...]';
                  if (e.$$typeof === ui)
                    return (t = Q(e.type)) ? '<' + t + '>' : '<...>';
                  var n = zu(e);
                  if (n === 'Object') {
                    ((n = ''), (t -= 2));
                    for (var a in e)
                      if (e.hasOwnProperty(a)) {
                        var s = JSON.stringify(a);
                        if (
                          (s !== '"' + a + '"' && (a = s),
                          (t -= a.length - 2),
                          (s = Hs(e[a], 15 > t ? t : 15)),
                          (t -= s.length),
                          0 > t)
                        ) {
                          n += n === '' ? '...' : ', ...';
                          break;
                        }
                        n += (n === '' ? '' : ',') + a + ':' + s;
                      }
                    return '{' + n + '}';
                  }
                  return n;
                case 'function':
                  return (t = e.displayName || e.name)
                    ? 'function ' + t
                    : 'function';
                default:
                  return String(e);
              }
            }
            function Ml(e, t) {
              return typeof e != 'string' || $y.test(e)
                ? '{' + Hs(e, t - 2) + '}'
                : e.length > t - 2
                  ? 5 > t
                    ? '"..."'
                    : '"' + e.slice(0, t - 5) + '..."'
                  : '"' + e + '"';
            }
            function Hu(e, t, n) {
              var a = 120 - n.length - e.length,
                s = [],
                c;
              for (c in t)
                if (t.hasOwnProperty(c) && c !== 'children') {
                  var f = Ml(t[c], 120 - n.length - c.length - 1);
                  ((a -= c.length + f.length + 2), s.push(c + '=' + f));
                }
              return s.length === 0
                ? n +
                    '<' +
                    e +
                    `>
`
                : 0 < a
                  ? n +
                    '<' +
                    e +
                    ' ' +
                    s.join(' ') +
                    `>
`
                  : n +
                    '<' +
                    e +
                    `
` +
                    n +
                    '  ' +
                    s.join(
                      `
` +
                        n +
                        '  '
                    ) +
                    `
` +
                    n +
                    `>
`;
            }
            function NS(e, t, n) {
              var a = '',
                s = Re({}, t),
                c;
              for (c in e)
                if (e.hasOwnProperty(c)) {
                  delete s[c];
                  var f = 120 - 2 * n - c.length - 2,
                    b = Hs(e[c], f);
                  t.hasOwnProperty(c)
                    ? ((f = Hs(t[c], f)),
                      (a +=
                        Rl(n) +
                        c +
                        ': ' +
                        b +
                        `
`),
                      (a +=
                        zi(n) +
                        c +
                        ': ' +
                        f +
                        `
`))
                    : (a +=
                        Rl(n) +
                        c +
                        ': ' +
                        b +
                        `
`);
                }
              for (var w in s)
                s.hasOwnProperty(w) &&
                  ((e = Hs(s[w], 120 - 2 * n - w.length - 2)),
                  (a +=
                    zi(n) +
                    w +
                    ': ' +
                    e +
                    `
`));
              return a;
            }
            function wS(e, t, n, a) {
              var s = '',
                c = new Map();
              for (T in n) n.hasOwnProperty(T) && c.set(T.toLowerCase(), T);
              if (c.size === 1 && c.has('children')) s += Hu(e, t, dn(a));
              else {
                for (var f in t)
                  if (t.hasOwnProperty(f) && f !== 'children') {
                    var b = 120 - 2 * (a + 1) - f.length - 1,
                      w = c.get(f.toLowerCase());
                    if (w !== void 0) {
                      c.delete(f.toLowerCase());
                      var T = t[f];
                      w = n[w];
                      var j = Ml(T, b);
                      ((b = Ml(w, b)),
                        typeof T == 'object' &&
                        T !== null &&
                        typeof w == 'object' &&
                        w !== null &&
                        zu(T) === 'Object' &&
                        zu(w) === 'Object' &&
                        (2 < Object.keys(T).length ||
                          2 < Object.keys(w).length ||
                          -1 < j.indexOf('...') ||
                          -1 < b.indexOf('...'))
                          ? (s +=
                              dn(a + 1) +
                              f +
                              `={{
` +
                              NS(T, w, a + 2) +
                              dn(a + 1) +
                              `}}
`)
                          : ((s +=
                              Rl(a + 1) +
                              f +
                              '=' +
                              j +
                              `
`),
                            (s +=
                              zi(a + 1) +
                              f +
                              '=' +
                              b +
                              `
`)));
                    } else
                      s +=
                        dn(a + 1) +
                        f +
                        '=' +
                        Ml(t[f], b) +
                        `
`;
                  }
                (c.forEach(function (H) {
                  if (H !== 'children') {
                    var _ = 120 - 2 * (a + 1) - H.length - 1;
                    s +=
                      zi(a + 1) +
                      H +
                      '=' +
                      Ml(n[H], _) +
                      `
`;
                  }
                }),
                  (s =
                    s === ''
                      ? dn(a) +
                        '<' +
                        e +
                        `>
`
                      : dn(a) +
                        '<' +
                        e +
                        `
` +
                        s +
                        dn(a) +
                        `>
`));
              }
              return (
                (e = n.children),
                (t = t.children),
                typeof e == 'string' ||
                typeof e == 'number' ||
                typeof e == 'bigint'
                  ? ((c = ''),
                    (typeof t == 'string' ||
                      typeof t == 'number' ||
                      typeof t == 'bigint') &&
                      (c = '' + t),
                    (s += wr(c, '' + e, a + 1)))
                  : (typeof t == 'string' ||
                      typeof t == 'number' ||
                      typeof t == 'bigint') &&
                    (s =
                      e == null
                        ? s + wr('' + t, null, a + 1)
                        : s + wr('' + t, void 0, a + 1)),
                s
              );
            }
            function ih(e, t) {
              var n = ah(e);
              if (n === null) {
                for (n = '', e = e.child; e; )
                  ((n += ih(e, t)), (e = e.sibling));
                return n;
              }
              return (
                dn(t) +
                '<' +
                n +
                `>
`
              );
            }
            function Uu(e, t) {
              var n = nh(e, t);
              if (n !== e && (e.children.length !== 1 || e.children[0] !== n))
                return (
                  dn(t) +
                  `...
` +
                  Uu(n, t + 1)
                );
              n = '';
              var a = e.fiber._debugInfo;
              if (a)
                for (var s = 0; s < a.length; s++) {
                  var c = a[s].name;
                  typeof c == 'string' &&
                    ((n +=
                      dn(t) +
                      '<' +
                      c +
                      `>
`),
                    t++);
                }
              if (((a = ''), (s = e.fiber.pendingProps), e.fiber.tag === 6))
                ((a = wr(s, e.serverProps, t)), t++);
              else if (((c = ah(e.fiber)), c !== null))
                if (e.serverProps === void 0) {
                  a = t;
                  var f = 120 - 2 * a - c.length - 2,
                    b = '';
                  for (T in s)
                    if (s.hasOwnProperty(T) && T !== 'children') {
                      var w = Ml(s[T], 15);
                      if (((f -= T.length + w.length + 2), 0 > f)) {
                        b += ' ...';
                        break;
                      }
                      b += ' ' + T + '=' + w;
                    }
                  ((a =
                    dn(a) +
                    '<' +
                    c +
                    b +
                    `>
`),
                    t++);
                } else
                  e.serverProps === null
                    ? ((a = Hu(c, s, Rl(t))), t++)
                    : typeof e.serverProps == 'string'
                      ? console.error(
                          'Should not have matched a non HostText fiber to a Text node. This is a bug in React.'
                        )
                      : ((a = wS(c, s, e.serverProps, t)), t++);
              var T = '';
              for (s = e.fiber.child, c = 0; s && c < e.children.length; )
                ((f = e.children[c]),
                  f.fiber === s ? ((T += Uu(f, t)), c++) : (T += ih(s, t)),
                  (s = s.sibling));
              for (
                s &&
                  0 < e.children.length &&
                  (T +=
                    dn(t) +
                    `...
`),
                  s = e.serverTail,
                  e.serverProps === null && t--,
                  e = 0;
                e < s.length;
                e++
              )
                ((c = s[e]),
                  (T =
                    typeof c == 'string'
                      ? T +
                        (zi(t) +
                          zs(c, 120 - 2 * t) +
                          `
`)
                      : T + Hu(c.type, c.props, zi(t))));
              return n + a + T;
            }
            function Iu(e) {
              try {
                return (
                  `

` + Uu(e, 0)
                );
              } catch {
                return '';
              }
            }
            function lh(e, t, n) {
              for (var a = t, s = null, c = 0; a; )
                (a === e && (c = 0),
                  (s = {
                    fiber: a,
                    children: s !== null ? [s] : [],
                    serverProps: a === t ? n : a === e ? null : void 0,
                    serverTail: [],
                    distanceFromLeaf: c,
                  }),
                  c++,
                  (a = a.return));
              return s !== null ? Iu(s).replaceAll(/^[+-]/gm, '>') : '';
            }
            function sh(e, t) {
              var n = Re({}, e || Gy),
                a = { tag: t };
              return (
                Py.indexOf(t) !== -1 &&
                  ((n.aTagInScope = null),
                  (n.buttonTagInScope = null),
                  (n.nobrTagInScope = null)),
                vN.indexOf(t) !== -1 && (n.pTagInButtonScope = null),
                yN.indexOf(t) !== -1 &&
                  t !== 'address' &&
                  t !== 'div' &&
                  t !== 'p' &&
                  ((n.listItemTagAutoclosing = null),
                  (n.dlItemTagAutoclosing = null)),
                (n.current = a),
                t === 'form' && (n.formTag = a),
                t === 'a' && (n.aTagInScope = a),
                t === 'button' && (n.buttonTagInScope = a),
                t === 'nobr' && (n.nobrTagInScope = a),
                t === 'p' && (n.pTagInButtonScope = a),
                t === 'li' && (n.listItemTagAutoclosing = a),
                (t === 'dd' || t === 'dt') && (n.dlItemTagAutoclosing = a),
                t === '#document' || t === 'html'
                  ? (n.containerTagInScope = null)
                  : n.containerTagInScope || (n.containerTagInScope = a),
                e !== null ||
                (t !== '#document' && t !== 'html' && t !== 'body')
                  ? n.implicitRootScope === !0 && (n.implicitRootScope = !1)
                  : (n.implicitRootScope = !0),
                n
              );
            }
            function oh(e, t, n) {
              switch (t) {
                case 'select':
                  return (
                    e === 'hr' ||
                    e === 'option' ||
                    e === 'optgroup' ||
                    e === 'script' ||
                    e === 'template' ||
                    e === '#text'
                  );
                case 'optgroup':
                  return e === 'option' || e === '#text';
                case 'option':
                  return e === '#text';
                case 'tr':
                  return (
                    e === 'th' ||
                    e === 'td' ||
                    e === 'style' ||
                    e === 'script' ||
                    e === 'template'
                  );
                case 'tbody':
                case 'thead':
                case 'tfoot':
                  return (
                    e === 'tr' ||
                    e === 'style' ||
                    e === 'script' ||
                    e === 'template'
                  );
                case 'colgroup':
                  return e === 'col' || e === 'template';
                case 'table':
                  return (
                    e === 'caption' ||
                    e === 'colgroup' ||
                    e === 'tbody' ||
                    e === 'tfoot' ||
                    e === 'thead' ||
                    e === 'style' ||
                    e === 'script' ||
                    e === 'template'
                  );
                case 'head':
                  return (
                    e === 'base' ||
                    e === 'basefont' ||
                    e === 'bgsound' ||
                    e === 'link' ||
                    e === 'meta' ||
                    e === 'title' ||
                    e === 'noscript' ||
                    e === 'noframes' ||
                    e === 'style' ||
                    e === 'script' ||
                    e === 'template'
                  );
                case 'html':
                  if (n) break;
                  return e === 'head' || e === 'body' || e === 'frameset';
                case 'frameset':
                  return e === 'frame';
                case '#document':
                  if (!n) return e === 'html';
              }
              switch (e) {
                case 'h1':
                case 'h2':
                case 'h3':
                case 'h4':
                case 'h5':
                case 'h6':
                  return (
                    t !== 'h1' &&
                    t !== 'h2' &&
                    t !== 'h3' &&
                    t !== 'h4' &&
                    t !== 'h5' &&
                    t !== 'h6'
                  );
                case 'rp':
                case 'rt':
                  return SN.indexOf(t) === -1;
                case 'caption':
                case 'col':
                case 'colgroup':
                case 'frameset':
                case 'frame':
                case 'tbody':
                case 'td':
                case 'tfoot':
                case 'th':
                case 'thead':
                case 'tr':
                  return t == null;
                case 'head':
                  return n || t === null;
                case 'html':
                  return (n && t === '#document') || t === null;
                case 'body':
                  return (
                    (n && (t === '#document' || t === 'html')) || t === null
                  );
              }
              return !0;
            }
            function ES(e, t) {
              switch (e) {
                case 'address':
                case 'article':
                case 'aside':
                case 'blockquote':
                case 'center':
                case 'details':
                case 'dialog':
                case 'dir':
                case 'div':
                case 'dl':
                case 'fieldset':
                case 'figcaption':
                case 'figure':
                case 'footer':
                case 'header':
                case 'hgroup':
                case 'main':
                case 'menu':
                case 'nav':
                case 'ol':
                case 'p':
                case 'section':
                case 'summary':
                case 'ul':
                case 'pre':
                case 'listing':
                case 'table':
                case 'hr':
                case 'xmp':
                case 'h1':
                case 'h2':
                case 'h3':
                case 'h4':
                case 'h5':
                case 'h6':
                  return t.pTagInButtonScope;
                case 'form':
                  return t.formTag || t.pTagInButtonScope;
                case 'li':
                  return t.listItemTagAutoclosing;
                case 'dd':
                case 'dt':
                  return t.dlItemTagAutoclosing;
                case 'button':
                  return t.buttonTagInScope;
                case 'a':
                  return t.aTagInScope;
                case 'nobr':
                  return t.nobrTagInScope;
              }
              return null;
            }
            function rh(e, t) {
              for (; e; ) {
                switch (e.tag) {
                  case 5:
                  case 26:
                  case 27:
                    if (e.type === t) return e;
                }
                e = e.return;
              }
              return null;
            }
            function Wu(e, t) {
              t = t || Gy;
              var n = t.current;
              if (
                ((t = (n = oh(e, n && n.tag, t.implicitRootScope) ? null : n)
                  ? null
                  : ES(e, t)),
                (t = n || t),
                !t)
              )
                return !0;
              var a = t.tag;
              if (((t = String(!!n) + '|' + e + '|' + a), Tc[t])) return !1;
              Tc[t] = !0;
              var s = (t = bn) ? rh(t.return, a) : null,
                c = t !== null && s !== null ? lh(s, t, null) : '',
                f = '<' + e + '>';
              return (
                n
                  ? ((n = ''),
                    a === 'table' &&
                      e === 'tr' &&
                      (n +=
                        ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.'),
                    console.error(
                      `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
                      f,
                      a,
                      n,
                      c
                    ))
                  : console.error(
                      `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
                      f,
                      a,
                      c
                    ),
                t &&
                  ((e = t.return),
                  s === null ||
                    e === null ||
                    (s === e && e._debugOwner === t._debugOwner) ||
                    he(s, function () {
                      console.error(
                        `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
                        a,
                        f
                      );
                    })),
                !1
              );
            }
            function Er(e, t, n) {
              if (n || oh('#text', t, !1)) return !0;
              if (((n = '#text|' + t), Tc[n])) return !1;
              Tc[n] = !0;
              var a = (n = bn) ? rh(n, t) : null;
              return (
                (n =
                  n !== null && a !== null
                    ? lh(a, n, n.tag !== 6 ? { children: null } : null)
                    : ''),
                /\S/.test(e)
                  ? console.error(
                      `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
                      t,
                      n
                    )
                  : console.error(
                      `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
                      t,
                      n
                    ),
                !1
              );
            }
            function Us(e, t) {
              if (t) {
                var n = e.firstChild;
                if (n && n === e.lastChild && n.nodeType === 3) {
                  n.nodeValue = t;
                  return;
                }
              }
              e.textContent = t;
            }
            function DS(e) {
              return e.replace(wN, function (t, n) {
                return n.toUpperCase();
              });
            }
            function ch(e, t, n) {
              var a = t.indexOf('--') === 0;
              (a ||
                (-1 < t.indexOf('-')
                  ? (Xl.hasOwnProperty(t) && Xl[t]) ||
                    ((Xl[t] = !0),
                    console.error(
                      'Unsupported style property %s. Did you mean %s?',
                      t,
                      DS(t.replace(NN, 'ms-'))
                    ))
                  : xN.test(t)
                    ? (Xl.hasOwnProperty(t) && Xl[t]) ||
                      ((Xl[t] = !0),
                      console.error(
                        'Unsupported vendor-prefixed style property %s. Did you mean %s?',
                        t,
                        t.charAt(0).toUpperCase() + t.slice(1)
                      ))
                    : !Xy.test(n) ||
                      (em.hasOwnProperty(n) && em[n]) ||
                      ((em[n] = !0),
                      console.error(
                        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
                        t,
                        n.replace(Xy, '')
                      )),
                typeof n == 'number' &&
                  (isNaN(n)
                    ? Qy ||
                      ((Qy = !0),
                      console.error(
                        '`NaN` is an invalid value for the `%s` css style property.',
                        t
                      ))
                    : isFinite(n) ||
                      Zy ||
                      ((Zy = !0),
                      console.error(
                        '`Infinity` is an invalid value for the `%s` css style property.',
                        t
                      )))),
                n == null || typeof n == 'boolean' || n === ''
                  ? a
                    ? e.setProperty(t, '')
                    : t === 'float'
                      ? (e.cssFloat = '')
                      : (e[t] = '')
                  : a
                    ? e.setProperty(t, n)
                    : typeof n != 'number' || n === 0 || Fy.has(t)
                      ? t === 'float'
                        ? (e.cssFloat = n)
                        : (Ue(n, t), (e[t] = ('' + n).trim()))
                      : (e[t] = n + 'px'));
            }
            function uh(e, t, n) {
              if (t != null && typeof t != 'object')
                throw Error(
                  "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
                );
              if ((t && Object.freeze(t), (e = e.style), n != null)) {
                if (t) {
                  var a = {};
                  if (n) {
                    for (var s in n)
                      if (n.hasOwnProperty(s) && !t.hasOwnProperty(s))
                        for (var c = Jf[s] || [s], f = 0; f < c.length; f++)
                          a[c[f]] = s;
                  }
                  for (var b in t)
                    if (t.hasOwnProperty(b) && (!n || n[b] !== t[b]))
                      for (s = Jf[b] || [b], c = 0; c < s.length; c++)
                        a[s[c]] = b;
                  b = {};
                  for (var w in t)
                    for (s = Jf[w] || [w], c = 0; c < s.length; c++)
                      b[s[c]] = w;
                  w = {};
                  for (var T in a)
                    if (
                      ((s = a[T]),
                      (c = b[T]) && s !== c && ((f = s + ',' + c), !w[f]))
                    ) {
                      ((w[f] = !0), (f = console));
                      var j = t[s];
                      f.error.call(
                        f,
                        "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                        j == null || typeof j == 'boolean' || j === ''
                          ? 'Removing'
                          : 'Updating',
                        s,
                        c
                      );
                    }
                }
                for (var H in n)
                  !n.hasOwnProperty(H) ||
                    (t != null && t.hasOwnProperty(H)) ||
                    (H.indexOf('--') === 0
                      ? e.setProperty(H, '')
                      : H === 'float'
                        ? (e.cssFloat = '')
                        : (e[H] = ''));
                for (var _ in t)
                  ((T = t[_]),
                    t.hasOwnProperty(_) && n[_] !== T && ch(e, _, T));
              } else for (a in t) t.hasOwnProperty(a) && ch(e, a, t[a]);
            }
            function Is(e) {
              if (e.indexOf('-') === -1) return !1;
              switch (e) {
                case 'annotation-xml':
                case 'color-profile':
                case 'font-face':
                case 'font-face-src':
                case 'font-face-uri':
                case 'font-face-format':
                case 'font-face-name':
                case 'missing-glyph':
                  return !1;
                default:
                  return !0;
              }
            }
            function dh(e) {
              return EN.get(e) || e;
            }
            function TS(e, t) {
              if (_a.call(Zl, t) && Zl[t]) return !0;
              if (TN.test(t)) {
                if (
                  ((e = 'aria-' + t.slice(4).toLowerCase()),
                  (e = Ky.hasOwnProperty(e) ? e : null),
                  e == null)
                )
                  return (
                    console.error(
                      'Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.',
                      t
                    ),
                    (Zl[t] = !0)
                  );
                if (t !== e)
                  return (
                    console.error(
                      'Invalid ARIA attribute `%s`. Did you mean `%s`?',
                      t,
                      e
                    ),
                    (Zl[t] = !0)
                  );
              }
              if (DN.test(t)) {
                if (
                  ((e = t.toLowerCase()),
                  (e = Ky.hasOwnProperty(e) ? e : null),
                  e == null)
                )
                  return ((Zl[t] = !0), !1);
                t !== e &&
                  (console.error(
                    'Unknown ARIA attribute `%s`. Did you mean `%s`?',
                    t,
                    e
                  ),
                  (Zl[t] = !0));
              }
              return !0;
            }
            function CS(e, t) {
              var n = [],
                a;
              for (a in t) TS(e, a) || n.push(a);
              ((t = n
                .map(function (s) {
                  return '`' + s + '`';
                })
                .join(', ')),
                n.length === 1
                  ? console.error(
                      'Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props',
                      t,
                      e
                    )
                  : 1 < n.length &&
                    console.error(
                      'Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props',
                      t,
                      e
                    ));
            }
            function AS(e, t, n, a) {
              if (_a.call(Pt, t) && Pt[t]) return !0;
              var s = t.toLowerCase();
              if (s === 'onfocusin' || s === 'onfocusout')
                return (
                  console.error(
                    'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.'
                  ),
                  (Pt[t] = !0)
                );
              if (
                typeof n == 'function' &&
                ((e === 'form' && t === 'action') ||
                  (e === 'input' && t === 'formAction') ||
                  (e === 'button' && t === 'formAction'))
              )
                return !0;
              if (a != null) {
                if (
                  ((e = a.possibleRegistrationNames),
                  a.registrationNameDependencies.hasOwnProperty(t))
                )
                  return !0;
                if (((a = e.hasOwnProperty(s) ? e[s] : null), a != null))
                  return (
                    console.error(
                      'Invalid event handler property `%s`. Did you mean `%s`?',
                      t,
                      a
                    ),
                    (Pt[t] = !0)
                  );
                if (ev.test(t))
                  return (
                    console.error(
                      'Unknown event handler property `%s`. It will be ignored.',
                      t
                    ),
                    (Pt[t] = !0)
                  );
              } else if (ev.test(t))
                return (
                  CN.test(t) &&
                    console.error(
                      'Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.',
                      t
                    ),
                  (Pt[t] = !0)
                );
              if (AN.test(t) || RN.test(t)) return !0;
              if (s === 'innerhtml')
                return (
                  console.error(
                    'Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.'
                  ),
                  (Pt[t] = !0)
                );
              if (s === 'aria')
                return (
                  console.error(
                    'The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.'
                  ),
                  (Pt[t] = !0)
                );
              if (
                s === 'is' &&
                n !== null &&
                n !== void 0 &&
                typeof n != 'string'
              )
                return (
                  console.error(
                    'Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.',
                    typeof n
                  ),
                  (Pt[t] = !0)
                );
              if (typeof n == 'number' && isNaN(n))
                return (
                  console.error(
                    'Received NaN for the `%s` attribute. If this is expected, cast the value to a string.',
                    t
                  ),
                  (Pt[t] = !0)
                );
              if (Ac.hasOwnProperty(s)) {
                if (((s = Ac[s]), s !== t))
                  return (
                    console.error(
                      'Invalid DOM property `%s`. Did you mean `%s`?',
                      t,
                      s
                    ),
                    (Pt[t] = !0)
                  );
              } else if (t !== s)
                return (
                  console.error(
                    'React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.',
                    t,
                    s
                  ),
                  (Pt[t] = !0)
                );
              switch (t) {
                case 'dangerouslySetInnerHTML':
                case 'children':
                case 'style':
                case 'suppressContentEditableWarning':
                case 'suppressHydrationWarning':
                case 'defaultValue':
                case 'defaultChecked':
                case 'innerHTML':
                case 'ref':
                  return !0;
                case 'innerText':
                case 'textContent':
                  return !0;
              }
              switch (typeof n) {
                case 'boolean':
                  switch (t) {
                    case 'autoFocus':
                    case 'checked':
                    case 'multiple':
                    case 'muted':
                    case 'selected':
                    case 'contentEditable':
                    case 'spellCheck':
                    case 'draggable':
                    case 'value':
                    case 'autoReverse':
                    case 'externalResourcesRequired':
                    case 'focusable':
                    case 'preserveAlpha':
                    case 'allowFullScreen':
                    case 'async':
                    case 'autoPlay':
                    case 'controls':
                    case 'default':
                    case 'defer':
                    case 'disabled':
                    case 'disablePictureInPicture':
                    case 'disableRemotePlayback':
                    case 'formNoValidate':
                    case 'hidden':
                    case 'loop':
                    case 'noModule':
                    case 'noValidate':
                    case 'open':
                    case 'playsInline':
                    case 'readOnly':
                    case 'required':
                    case 'reversed':
                    case 'scoped':
                    case 'seamless':
                    case 'itemScope':
                    case 'capture':
                    case 'download':
                    case 'inert':
                      return !0;
                    default:
                      return (
                        (s = t.toLowerCase().slice(0, 5)),
                        s === 'data-' || s === 'aria-'
                          ? !0
                          : (n
                              ? console.error(
                                  'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                                  n,
                                  t,
                                  t,
                                  n,
                                  t
                                )
                              : console.error(
                                  'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                                  n,
                                  t,
                                  t,
                                  n,
                                  t,
                                  t,
                                  t
                                ),
                            (Pt[t] = !0))
                      );
                  }
                case 'function':
                case 'symbol':
                  return ((Pt[t] = !0), !1);
                case 'string':
                  if (n === 'false' || n === 'true') {
                    switch (t) {
                      case 'checked':
                      case 'selected':
                      case 'multiple':
                      case 'muted':
                      case 'allowFullScreen':
                      case 'async':
                      case 'autoPlay':
                      case 'controls':
                      case 'default':
                      case 'defer':
                      case 'disabled':
                      case 'disablePictureInPicture':
                      case 'disableRemotePlayback':
                      case 'formNoValidate':
                      case 'hidden':
                      case 'loop':
                      case 'noModule':
                      case 'noValidate':
                      case 'open':
                      case 'playsInline':
                      case 'readOnly':
                      case 'required':
                      case 'reversed':
                      case 'scoped':
                      case 'seamless':
                      case 'itemScope':
                      case 'inert':
                        break;
                      default:
                        return !0;
                    }
                    (console.error(
                      'Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?',
                      n,
                      t,
                      n === 'false'
                        ? 'The browser will interpret it as a truthy value.'
                        : 'Although this works, it will not work as expected if you pass the string "false".',
                      t,
                      n
                    ),
                      (Pt[t] = !0));
                  }
              }
              return !0;
            }
            function RS(e, t, n) {
              var a = [],
                s;
              for (s in t) AS(e, s, t[s], n) || a.push(s);
              ((t = a
                .map(function (c) {
                  return '`' + c + '`';
                })
                .join(', ')),
                a.length === 1
                  ? console.error(
                      'Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ',
                      t,
                      e
                    )
                  : 1 < a.length &&
                    console.error(
                      'Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ',
                      t,
                      e
                    ));
            }
            function Ws(e) {
              return MN.test('' + e)
                ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
                : e;
            }
            function $u(e) {
              return (
                (e = e.target || e.srcElement || window),
                e.correspondingUseElement && (e = e.correspondingUseElement),
                e.nodeType === 3 ? e.parentNode : e
              );
            }
            function fh(e) {
              var t = Gn(e);
              if (t && (e = t.stateNode)) {
                var n = e[an] || null;
                e: switch (((e = t.stateNode), t.type)) {
                  case 'input':
                    if (
                      (Bu(
                        e,
                        n.value,
                        n.defaultValue,
                        n.defaultValue,
                        n.checked,
                        n.defaultChecked,
                        n.type,
                        n.name
                      ),
                      (t = n.name),
                      n.type === 'radio' && t != null)
                    ) {
                      for (n = e; n.parentNode; ) n = n.parentNode;
                      for (
                        ue(t, 'name'),
                          n = n.querySelectorAll(
                            'input[name="' + An('' + t) + '"][type="radio"]'
                          ),
                          t = 0;
                        t < n.length;
                        t++
                      ) {
                        var a = n[t];
                        if (a !== e && a.form === e.form) {
                          var s = a[an] || null;
                          if (!s)
                            throw Error(
                              'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.'
                            );
                          Bu(
                            a,
                            s.value,
                            s.defaultValue,
                            s.defaultValue,
                            s.checked,
                            s.defaultChecked,
                            s.type,
                            s.name
                          );
                        }
                      }
                      for (t = 0; t < n.length; t++)
                        ((a = n[t]), a.form === e.form && Yp(a));
                    }
                    break e;
                  case 'textarea':
                    eh(e, n.value, n.defaultValue);
                    break e;
                  case 'select':
                    ((t = n.value), t != null && Al(e, !!n.multiple, t, !1));
                }
              }
            }
            function mh(e, t, n) {
              if (tm) return e(t, n);
              tm = !0;
              try {
                var a = e(t);
                return a;
              } finally {
                if (
                  ((tm = !1),
                  (Fl !== null || Kl !== null) &&
                    (zl(),
                    Fl && ((t = Fl), (e = Kl), (Kl = Fl = null), fh(t), e)))
                )
                  for (t = 0; t < e.length; t++) fh(e[t]);
              }
            }
            function $s(e, t) {
              var n = e.stateNode;
              if (n === null) return null;
              var a = n[an] || null;
              if (a === null) return null;
              n = a[t];
              e: switch (t) {
                case 'onClick':
                case 'onClickCapture':
                case 'onDoubleClick':
                case 'onDoubleClickCapture':
                case 'onMouseDown':
                case 'onMouseDownCapture':
                case 'onMouseMove':
                case 'onMouseMoveCapture':
                case 'onMouseUp':
                case 'onMouseUpCapture':
                case 'onMouseEnter':
                  ((a = !a.disabled) ||
                    ((e = e.type),
                    (a = !(
                      e === 'button' ||
                      e === 'input' ||
                      e === 'select' ||
                      e === 'textarea'
                    ))),
                    (e = !a));
                  break e;
                default:
                  e = !1;
              }
              if (e) return null;
              if (n && typeof n != 'function')
                throw Error(
                  'Expected `' +
                    t +
                    '` listener to be a function, instead got a value of `' +
                    typeof n +
                    '` type.'
                );
              return n;
            }
            function ph() {
              if (Rc) return Rc;
              var e,
                t = am,
                n = t.length,
                a,
                s = 'value' in hi ? hi.value : hi.textContent,
                c = s.length;
              for (e = 0; e < n && t[e] === s[e]; e++);
              var f = n - e;
              for (a = 1; a <= f && t[n - a] === s[c - a]; a++);
              return (Rc = s.slice(e, 1 < a ? 1 - a : void 0));
            }
            function Dr(e) {
              var t = e.keyCode;
              return (
                'charCode' in e
                  ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
                  : (e = t),
                e === 10 && (e = 13),
                32 <= e || e === 13 ? e : 0
              );
            }
            function Tr() {
              return !0;
            }
            function hh() {
              return !1;
            }
            function Jt(e) {
              function t(n, a, s, c, f) {
                ((this._reactName = n),
                  (this._targetInst = s),
                  (this.type = a),
                  (this.nativeEvent = c),
                  (this.target = f),
                  (this.currentTarget = null));
                for (var b in e)
                  e.hasOwnProperty(b) &&
                    ((n = e[b]), (this[b] = n ? n(c) : c[b]));
                return (
                  (this.isDefaultPrevented = (
                    c.defaultPrevented != null
                      ? c.defaultPrevented
                      : c.returnValue === !1
                  )
                    ? Tr
                    : hh),
                  (this.isPropagationStopped = hh),
                  this
                );
              }
              return (
                Re(t.prototype, {
                  preventDefault: function () {
                    this.defaultPrevented = !0;
                    var n = this.nativeEvent;
                    n &&
                      (n.preventDefault
                        ? n.preventDefault()
                        : typeof n.returnValue != 'unknown' &&
                          (n.returnValue = !1),
                      (this.isDefaultPrevented = Tr));
                  },
                  stopPropagation: function () {
                    var n = this.nativeEvent;
                    n &&
                      (n.stopPropagation
                        ? n.stopPropagation()
                        : typeof n.cancelBubble != 'unknown' &&
                          (n.cancelBubble = !0),
                      (this.isPropagationStopped = Tr));
                  },
                  persist: function () {},
                  isPersistent: Tr,
                }),
                t
              );
            }
            function MS(e) {
              var t = this.nativeEvent;
              return t.getModifierState
                ? t.getModifierState(e)
                : (e = $N[e])
                  ? !!t[e]
                  : !1;
            }
            function Pu() {
              return MS;
            }
            function gh(e, t) {
              switch (e) {
                case 'keyup':
                  return tw.indexOf(t.keyCode) !== -1;
                case 'keydown':
                  return t.keyCode !== iv;
                case 'keypress':
                case 'mousedown':
                case 'focusout':
                  return !0;
                default:
                  return !1;
              }
            }
            function bh(e) {
              return (
                (e = e.detail),
                typeof e == 'object' && 'data' in e ? e.data : null
              );
            }
            function OS(e, t) {
              switch (e) {
                case 'compositionend':
                  return bh(t);
                case 'keypress':
                  return t.which !== sv ? null : ((rv = !0), ov);
                case 'textInput':
                  return ((e = t.data), e === ov && rv ? null : e);
                default:
                  return null;
              }
            }
            function kS(e, t) {
              if (Jl)
                return e === 'compositionend' || (!om && gh(e, t))
                  ? ((e = ph()), (Rc = am = hi = null), (Jl = !1), e)
                  : null;
              switch (e) {
                case 'paste':
                  return null;
                case 'keypress':
                  if (
                    !(t.ctrlKey || t.altKey || t.metaKey) ||
                    (t.ctrlKey && t.altKey)
                  ) {
                    if (t.char && 1 < t.char.length) return t.char;
                    if (t.which) return String.fromCharCode(t.which);
                  }
                  return null;
                case 'compositionend':
                  return lv && t.locale !== 'ko' ? null : t.data;
                default:
                  return null;
              }
            }
            function yh(e) {
              var t = e && e.nodeName && e.nodeName.toLowerCase();
              return t === 'input' ? !!aw[e.type] : t === 'textarea';
            }
            function _S(e) {
              if (!ma) return !1;
              e = 'on' + e;
              var t = e in document;
              return (
                t ||
                  ((t = document.createElement('div')),
                  t.setAttribute(e, 'return;'),
                  (t = typeof t[e] == 'function')),
                t
              );
            }
            function vh(e, t, n, a) {
              (Fl ? (Kl ? Kl.push(a) : (Kl = [a])) : (Fl = a),
                (t = uc(t, 'onChange')),
                0 < t.length &&
                  ((n = new Mc('onChange', 'change', null, n, a)),
                  e.push({ event: n, listeners: t })));
            }
            function jS(e) {
              Ub(e, 0);
            }
            function Cr(e) {
              var t = ei(e);
              if (Yp(t)) return e;
            }
            function Sh(e, t) {
              if (e === 'change') return t;
            }
            function xh() {
              Ao && (Ao.detachEvent('onpropertychange', Nh), (Ro = Ao = null));
            }
            function Nh(e) {
              if (e.propertyName === 'value' && Cr(Ro)) {
                var t = [];
                (vh(t, Ro, e, $u(e)), mh(jS, t));
              }
            }
            function VS(e, t, n) {
              e === 'focusin'
                ? (xh(),
                  (Ao = t),
                  (Ro = n),
                  Ao.attachEvent('onpropertychange', Nh))
                : e === 'focusout' && xh();
            }
            function BS(e) {
              if (e === 'selectionchange' || e === 'keyup' || e === 'keydown')
                return Cr(Ro);
            }
            function LS(e, t) {
              if (e === 'click') return Cr(t);
            }
            function zS(e, t) {
              if (e === 'input' || e === 'change') return Cr(t);
            }
            function HS(e, t) {
              return (
                (e === t && (e !== 0 || 1 / e === 1 / t)) ||
                (e !== e && t !== t)
              );
            }
            function Ps(e, t) {
              if (Gt(e, t)) return !0;
              if (
                typeof e != 'object' ||
                e === null ||
                typeof t != 'object' ||
                t === null
              )
                return !1;
              var n = Object.keys(e),
                a = Object.keys(t);
              if (n.length !== a.length) return !1;
              for (a = 0; a < n.length; a++) {
                var s = n[a];
                if (!_a.call(t, s) || !Gt(e[s], t[s])) return !1;
              }
              return !0;
            }
            function wh(e) {
              for (; e && e.firstChild; ) e = e.firstChild;
              return e;
            }
            function Eh(e, t) {
              var n = wh(e);
              e = 0;
              for (var a; n; ) {
                if (n.nodeType === 3) {
                  if (((a = e + n.textContent.length), e <= t && a >= t))
                    return { node: n, offset: t - e };
                  e = a;
                }
                e: {
                  for (; n; ) {
                    if (n.nextSibling) {
                      n = n.nextSibling;
                      break e;
                    }
                    n = n.parentNode;
                  }
                  n = void 0;
                }
                n = wh(n);
              }
            }
            function Dh(e, t) {
              return e && t
                ? e === t
                  ? !0
                  : e && e.nodeType === 3
                    ? !1
                    : t && t.nodeType === 3
                      ? Dh(e, t.parentNode)
                      : 'contains' in e
                        ? e.contains(t)
                        : e.compareDocumentPosition
                          ? !!(e.compareDocumentPosition(t) & 16)
                          : !1
                : !1;
            }
            function Th(e) {
              e =
                e != null &&
                e.ownerDocument != null &&
                e.ownerDocument.defaultView != null
                  ? e.ownerDocument.defaultView
                  : window;
              for (var t = Nr(e.document); t instanceof e.HTMLIFrameElement; ) {
                try {
                  var n = typeof t.contentWindow.location.href == 'string';
                } catch {
                  n = !1;
                }
                if (n) e = t.contentWindow;
                else break;
                t = Nr(e.document);
              }
              return t;
            }
            function Gu(e) {
              var t = e && e.nodeName && e.nodeName.toLowerCase();
              return (
                t &&
                ((t === 'input' &&
                  (e.type === 'text' ||
                    e.type === 'search' ||
                    e.type === 'tel' ||
                    e.type === 'url' ||
                    e.type === 'password')) ||
                  t === 'textarea' ||
                  e.contentEditable === 'true')
              );
            }
            function Ch(e, t, n) {
              var a =
                n.window === n
                  ? n.document
                  : n.nodeType === 9
                    ? n
                    : n.ownerDocument;
              cm ||
                es == null ||
                es !== Nr(a) ||
                ((a = es),
                'selectionStart' in a && Gu(a)
                  ? (a = { start: a.selectionStart, end: a.selectionEnd })
                  : ((a = (
                      (a.ownerDocument && a.ownerDocument.defaultView) ||
                      window
                    ).getSelection()),
                    (a = {
                      anchorNode: a.anchorNode,
                      anchorOffset: a.anchorOffset,
                      focusNode: a.focusNode,
                      focusOffset: a.focusOffset,
                    })),
                (Mo && Ps(Mo, a)) ||
                  ((Mo = a),
                  (a = uc(rm, 'onSelect')),
                  0 < a.length &&
                    ((t = new Mc('onSelect', 'select', null, t, n)),
                    e.push({ event: t, listeners: a }),
                    (t.target = es))));
            }
            function Hi(e, t) {
              var n = {};
              return (
                (n[e.toLowerCase()] = t.toLowerCase()),
                (n['Webkit' + e] = 'webkit' + t),
                (n['Moz' + e] = 'moz' + t),
                n
              );
            }
            function Ui(e) {
              if (um[e]) return um[e];
              if (!ts[e]) return e;
              var t = ts[e],
                n;
              for (n in t)
                if (t.hasOwnProperty(n) && n in uv) return (um[e] = t[n]);
              return e;
            }
            function qn(e, t) {
              (hv.set(e, t), ne(t, [e]));
            }
            function fn(e, t) {
              if (typeof e == 'object' && e !== null) {
                var n = fm.get(e);
                return n !== void 0
                  ? n
                  : ((t = { value: e, source: t, stack: Pp(t) }),
                    fm.set(e, t),
                    t);
              }
              return { value: e, source: t, stack: Pp(t) };
            }
            function Ar() {
              for (var e = ns, t = (mm = ns = 0); t < e; ) {
                var n = kn[t];
                kn[t++] = null;
                var a = kn[t];
                kn[t++] = null;
                var s = kn[t];
                kn[t++] = null;
                var c = kn[t];
                if (((kn[t++] = null), a !== null && s !== null)) {
                  var f = a.pending;
                  (f === null
                    ? (s.next = s)
                    : ((s.next = f.next), (f.next = s)),
                    (a.pending = s));
                }
                c !== 0 && Ah(n, s, c);
              }
            }
            function Rr(e, t, n, a) {
              ((kn[ns++] = e),
                (kn[ns++] = t),
                (kn[ns++] = n),
                (kn[ns++] = a),
                (mm |= a),
                (e.lanes |= a),
                (e = e.alternate),
                e !== null && (e.lanes |= a));
            }
            function qu(e, t, n, a) {
              return (Rr(e, t, n, a), Mr(e));
            }
            function en(e, t) {
              return (Rr(e, null, null, t), Mr(e));
            }
            function Ah(e, t, n) {
              e.lanes |= n;
              var a = e.alternate;
              a !== null && (a.lanes |= n);
              for (var s = !1, c = e.return; c !== null; )
                ((c.childLanes |= n),
                  (a = c.alternate),
                  a !== null && (a.childLanes |= n),
                  c.tag === 22 &&
                    ((e = c.stateNode),
                    e === null || e._visibility & kc || (s = !0)),
                  (e = c),
                  (c = c.return));
              return e.tag === 3
                ? ((c = e.stateNode),
                  s &&
                    t !== null &&
                    ((s = 31 - $t(n)),
                    (e = c.hiddenUpdates),
                    (a = e[s]),
                    a === null ? (e[s] = [t]) : a.push(t),
                    (t.lane = n | 536870912)),
                  c)
                : null;
            }
            function Mr(e) {
              if (Ko > Tw)
                throw (
                  (pl = Ko = 0),
                  (Jo = $m = null),
                  Error(
                    'Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.'
                  )
                );
              (pl > Cw &&
                ((pl = 0),
                (Jo = null),
                console.error(
                  "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
                )),
                e.alternate === null && (e.flags & 4098) !== 0 && _b(e));
              for (var t = e, n = t.return; n !== null; )
                (t.alternate === null && (t.flags & 4098) !== 0 && _b(e),
                  (t = n),
                  (n = t.return));
              return t.tag === 3 ? t.stateNode : null;
            }
            function Ii(e) {
              if (_n === null) return e;
              var t = _n(e);
              return t === void 0 ? e : t.current;
            }
            function Yu(e) {
              if (_n === null) return e;
              var t = _n(e);
              return t === void 0
                ? e != null &&
                  typeof e.render == 'function' &&
                  ((t = Ii(e.render)), e.render !== t)
                  ? ((t = { $$typeof: vo, render: t }),
                    e.displayName !== void 0 && (t.displayName = e.displayName),
                    t)
                  : e
                : t.current;
            }
            function Rh(e, t) {
              if (_n === null) return !1;
              var n = e.elementType;
              t = t.type;
              var a = !1,
                s = typeof t == 'object' && t !== null ? t.$$typeof : null;
              switch (e.tag) {
                case 1:
                  typeof t == 'function' && (a = !0);
                  break;
                case 0:
                  (typeof t == 'function' || s === gn) && (a = !0);
                  break;
                case 11:
                  (s === vo || s === gn) && (a = !0);
                  break;
                case 14:
                case 15:
                  (s === xc || s === gn) && (a = !0);
                  break;
                default:
                  return !1;
              }
              return !!(a && ((e = _n(n)), e !== void 0 && e === _n(t)));
            }
            function Mh(e) {
              _n !== null &&
                typeof WeakSet == 'function' &&
                (as === null && (as = new WeakSet()), as.add(e));
            }
            function Xu(e, t, n) {
              var a = e.alternate,
                s = e.child,
                c = e.sibling,
                f = e.tag,
                b = e.type,
                w = null;
              switch (f) {
                case 0:
                case 15:
                case 1:
                  w = b;
                  break;
                case 11:
                  w = b.render;
              }
              if (_n === null)
                throw Error(
                  'Expected resolveFamily to be set during hot reload.'
                );
              var T = !1;
              ((b = !1),
                w !== null &&
                  ((w = _n(w)),
                  w !== void 0 &&
                    (n.has(w)
                      ? (b = !0)
                      : t.has(w) && (f === 1 ? (b = !0) : (T = !0)))),
                as !== null &&
                  (as.has(e) || (a !== null && as.has(a))) &&
                  (b = !0),
                b && (e._debugNeedsRemount = !0),
                (b || T) && ((a = en(e, 2)), a !== null && mt(a, e, 2)),
                s === null || b || Xu(s, t, n),
                c !== null && Xu(c, t, n));
            }
            function US(e, t, n, a) {
              ((this.tag = e),
                (this.key = n),
                (this.sibling =
                  this.child =
                  this.return =
                  this.stateNode =
                  this.type =
                  this.elementType =
                    null),
                (this.index = 0),
                (this.refCleanup = this.ref = null),
                (this.pendingProps = t),
                (this.dependencies =
                  this.memoizedState =
                  this.updateQueue =
                  this.memoizedProps =
                    null),
                (this.mode = a),
                (this.subtreeFlags = this.flags = 0),
                (this.deletions = null),
                (this.childLanes = this.lanes = 0),
                (this.alternate = null),
                (this.actualDuration = -0),
                (this.actualStartTime = -1.1),
                (this.treeBaseDuration = this.selfBaseDuration = -0),
                (this._debugTask =
                  this._debugStack =
                  this._debugOwner =
                  this._debugInfo =
                    null),
                (this._debugNeedsRemount = !1),
                (this._debugHookTypes = null),
                bv ||
                  typeof Object.preventExtensions != 'function' ||
                  Object.preventExtensions(this));
            }
            function Qu(e) {
              return ((e = e.prototype), !(!e || !e.isReactComponent));
            }
            function wa(e, t) {
              var n = e.alternate;
              switch (
                (n === null
                  ? ((n = S(e.tag, t, e.key, e.mode)),
                    (n.elementType = e.elementType),
                    (n.type = e.type),
                    (n.stateNode = e.stateNode),
                    (n._debugOwner = e._debugOwner),
                    (n._debugStack = e._debugStack),
                    (n._debugTask = e._debugTask),
                    (n._debugHookTypes = e._debugHookTypes),
                    (n.alternate = e),
                    (e.alternate = n))
                  : ((n.pendingProps = t),
                    (n.type = e.type),
                    (n.flags = 0),
                    (n.subtreeFlags = 0),
                    (n.deletions = null),
                    (n.actualDuration = -0),
                    (n.actualStartTime = -1.1)),
                (n.flags = e.flags & 65011712),
                (n.childLanes = e.childLanes),
                (n.lanes = e.lanes),
                (n.child = e.child),
                (n.memoizedProps = e.memoizedProps),
                (n.memoizedState = e.memoizedState),
                (n.updateQueue = e.updateQueue),
                (t = e.dependencies),
                (n.dependencies =
                  t === null
                    ? null
                    : {
                        lanes: t.lanes,
                        firstContext: t.firstContext,
                        _debugThenableState: t._debugThenableState,
                      }),
                (n.sibling = e.sibling),
                (n.index = e.index),
                (n.ref = e.ref),
                (n.refCleanup = e.refCleanup),
                (n.selfBaseDuration = e.selfBaseDuration),
                (n.treeBaseDuration = e.treeBaseDuration),
                (n._debugInfo = e._debugInfo),
                (n._debugNeedsRemount = e._debugNeedsRemount),
                n.tag)
              ) {
                case 0:
                case 15:
                  n.type = Ii(e.type);
                  break;
                case 1:
                  n.type = Ii(e.type);
                  break;
                case 11:
                  n.type = Yu(e.type);
              }
              return n;
            }
            function Oh(e, t) {
              e.flags &= 65011714;
              var n = e.alternate;
              return (
                n === null
                  ? ((e.childLanes = 0),
                    (e.lanes = t),
                    (e.child = null),
                    (e.subtreeFlags = 0),
                    (e.memoizedProps = null),
                    (e.memoizedState = null),
                    (e.updateQueue = null),
                    (e.dependencies = null),
                    (e.stateNode = null),
                    (e.selfBaseDuration = 0),
                    (e.treeBaseDuration = 0))
                  : ((e.childLanes = n.childLanes),
                    (e.lanes = n.lanes),
                    (e.child = n.child),
                    (e.subtreeFlags = 0),
                    (e.deletions = null),
                    (e.memoizedProps = n.memoizedProps),
                    (e.memoizedState = n.memoizedState),
                    (e.updateQueue = n.updateQueue),
                    (e.type = n.type),
                    (t = n.dependencies),
                    (e.dependencies =
                      t === null
                        ? null
                        : {
                            lanes: t.lanes,
                            firstContext: t.firstContext,
                            _debugThenableState: t._debugThenableState,
                          }),
                    (e.selfBaseDuration = n.selfBaseDuration),
                    (e.treeBaseDuration = n.treeBaseDuration)),
                e
              );
            }
            function Zu(e, t, n, a, s, c) {
              var f = 0,
                b = e;
              if (typeof e == 'function') (Qu(e) && (f = 1), (b = Ii(b)));
              else if (typeof e == 'string')
                ((f = K()),
                  (f = Ux(e, n, f)
                    ? 26
                    : e === 'html' || e === 'head' || e === 'body'
                      ? 27
                      : 5));
              else
                e: switch (e) {
                  case If:
                    return (
                      (t = S(31, n, t, s)),
                      (t.elementType = If),
                      (t.lanes = c),
                      t
                    );
                  case Gl:
                    return Wi(n.children, s, c, t);
                  case Sc:
                    ((f = 8), (s |= It), (s |= Qn));
                    break;
                  case Lf:
                    return (
                      (e = n),
                      (a = s),
                      typeof e.id != 'string' &&
                        console.error(
                          'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
                          typeof e.id
                        ),
                      (t = S(12, e, t, a | Vt)),
                      (t.elementType = Lf),
                      (t.lanes = c),
                      (t.stateNode = {
                        effectDuration: 0,
                        passiveEffectDuration: 0,
                      }),
                      t
                    );
                  case Hf:
                    return (
                      (t = S(13, n, t, s)),
                      (t.elementType = Hf),
                      (t.lanes = c),
                      t
                    );
                  case Uf:
                    return (
                      (t = S(19, n, t, s)),
                      (t.elementType = Uf),
                      (t.lanes = c),
                      t
                    );
                  default:
                    if (typeof e == 'object' && e !== null)
                      switch (e.$$typeof) {
                        case eN:
                        case ra:
                          f = 10;
                          break e;
                        case zf:
                          f = 9;
                          break e;
                        case vo:
                          ((f = 11), (b = Yu(b)));
                          break e;
                        case xc:
                          f = 14;
                          break e;
                        case gn:
                          ((f = 16), (b = null));
                          break e;
                      }
                    ((b = ''),
                      (e === void 0 ||
                        (typeof e == 'object' &&
                          e !== null &&
                          Object.keys(e).length === 0)) &&
                        (b +=
                          " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."),
                      e === null
                        ? (n = 'null')
                        : jt(e)
                          ? (n = 'array')
                          : e !== void 0 && e.$$typeof === ui
                            ? ((n = '<' + (Q(e.type) || 'Unknown') + ' />'),
                              (b =
                                ' Did you accidentally export a JSX literal instead of a component?'))
                            : (n = typeof e),
                      (f = a ? X(a) : null) &&
                        (b +=
                          `

Check the render method of \`` +
                          f +
                          '`.'),
                      (f = 29),
                      (n = Error(
                        'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: ' +
                          (n + '.' + b)
                      )),
                      (b = null));
                }
              return (
                (t = S(f, n, t, s)),
                (t.elementType = e),
                (t.type = b),
                (t.lanes = c),
                (t._debugOwner = a),
                t
              );
            }
            function Or(e, t, n) {
              return (
                (t = Zu(e.type, e.key, e.props, e._owner, t, n)),
                (t._debugOwner = e._owner),
                (t._debugStack = e._debugStack),
                (t._debugTask = e._debugTask),
                t
              );
            }
            function Wi(e, t, n, a) {
              return ((e = S(7, e, a, t)), (e.lanes = n), e);
            }
            function Fu(e, t, n) {
              return ((e = S(6, e, null, t)), (e.lanes = n), e);
            }
            function Ku(e, t, n) {
              return (
                (t = S(4, e.children !== null ? e.children : [], e.key, t)),
                (t.lanes = n),
                (t.stateNode = {
                  containerInfo: e.containerInfo,
                  pendingChildren: null,
                  implementation: e.implementation,
                }),
                t
              );
            }
            function $i(e, t) {
              (Pi(), (is[ls++] = jc), (is[ls++] = _c), (_c = e), (jc = t));
            }
            function kh(e, t, n) {
              (Pi(),
                (jn[Vn++] = Ba),
                (jn[Vn++] = La),
                (jn[Vn++] = nl),
                (nl = e));
              var a = Ba;
              e = La;
              var s = 32 - $t(a) - 1;
              ((a &= ~(1 << s)), (n += 1));
              var c = 32 - $t(t) + s;
              if (30 < c) {
                var f = s - (s % 5);
                ((c = (a & ((1 << f) - 1)).toString(32)),
                  (a >>= f),
                  (s -= f),
                  (Ba = (1 << (32 - $t(t) + s)) | (n << s) | a),
                  (La = c + e));
              } else ((Ba = (1 << c) | (n << s) | a), (La = e));
            }
            function Ju(e) {
              (Pi(), e.return !== null && ($i(e, 1), kh(e, 1, 0)));
            }
            function ed(e) {
              for (; e === _c; )
                ((_c = is[--ls]),
                  (is[ls] = null),
                  (jc = is[--ls]),
                  (is[ls] = null));
              for (; e === nl; )
                ((nl = jn[--Vn]),
                  (jn[Vn] = null),
                  (La = jn[--Vn]),
                  (jn[Vn] = null),
                  (Ba = jn[--Vn]),
                  (jn[Vn] = null));
            }
            function Pi() {
              He ||
                console.error(
                  'Expected to be hydrating. This is a bug in React. Please file an issue.'
                );
            }
            function Gi(e, t) {
              if (e.return === null) {
                if (Bn === null)
                  Bn = {
                    fiber: e,
                    children: [],
                    serverProps: void 0,
                    serverTail: [],
                    distanceFromLeaf: t,
                  };
                else {
                  if (Bn.fiber !== e)
                    throw Error(
                      'Saw multiple hydration diff roots in a pass. This is a bug in React.'
                    );
                  Bn.distanceFromLeaf > t && (Bn.distanceFromLeaf = t);
                }
                return Bn;
              }
              var n = Gi(e.return, t + 1).children;
              return 0 < n.length && n[n.length - 1].fiber === e
                ? ((n = n[n.length - 1]),
                  n.distanceFromLeaf > t && (n.distanceFromLeaf = t),
                  n)
                : ((t = {
                    fiber: e,
                    children: [],
                    serverProps: void 0,
                    serverTail: [],
                    distanceFromLeaf: t,
                  }),
                  n.push(t),
                  t);
            }
            function td(e, t) {
              za ||
                ((e = Gi(e, 0)),
                (e.serverProps = null),
                t !== null && ((t = ey(t)), e.serverTail.push(t)));
            }
            function qi(e) {
              var t = '',
                n = Bn;
              throw (
                n !== null && ((Bn = null), (t = Iu(n))),
                Ys(
                  fn(
                    Error(
                      `Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + t
                    ),
                    e
                  )
                ),
                pm
              );
            }
            function _h(e) {
              var t = e.stateNode,
                n = e.type,
                a = e.memoizedProps;
              switch (((t[Ut] = e), (t[an] = a), vf(n, a), n)) {
                case 'dialog':
                  (je('cancel', t), je('close', t));
                  break;
                case 'iframe':
                case 'object':
                case 'embed':
                  je('load', t);
                  break;
                case 'video':
                case 'audio':
                  for (n = 0; n < er.length; n++) je(er[n], t);
                  break;
                case 'source':
                  je('error', t);
                  break;
                case 'img':
                case 'image':
                case 'link':
                  (je('error', t), je('load', t));
                  break;
                case 'details':
                  je('toggle', t);
                  break;
                case 'input':
                  (pe('input', a),
                    je('invalid', t),
                    Xp(t, a),
                    Qp(
                      t,
                      a.value,
                      a.defaultValue,
                      a.checked,
                      a.defaultChecked,
                      a.type,
                      a.name,
                      !0
                    ),
                    xr(t));
                  break;
                case 'option':
                  Zp(t, a);
                  break;
                case 'select':
                  (pe('select', a), je('invalid', t), Kp(t, a));
                  break;
                case 'textarea':
                  (pe('textarea', a),
                    je('invalid', t),
                    Jp(t, a),
                    th(t, a.value, a.defaultValue, a.children),
                    xr(t));
              }
              ((n = a.children),
                (typeof n != 'string' &&
                  typeof n != 'number' &&
                  typeof n != 'bigint') ||
                t.textContent === '' + n ||
                a.suppressHydrationWarning === !0 ||
                Pb(t.textContent, n)
                  ? (a.popover != null &&
                      (je('beforetoggle', t), je('toggle', t)),
                    a.onScroll != null && je('scroll', t),
                    a.onScrollEnd != null && je('scrollend', t),
                    a.onClick != null && (t.onclick = dc),
                    (t = !0))
                  : (t = !1),
                t || qi(e));
            }
            function jh(e) {
              for (qt = e.return; qt; )
                switch (qt.tag) {
                  case 5:
                  case 13:
                    pa = !1;
                    return;
                  case 27:
                  case 3:
                    pa = !0;
                    return;
                  default:
                    qt = qt.return;
                }
            }
            function Gs(e) {
              if (e !== qt) return !1;
              if (!He) return (jh(e), (He = !0), !1);
              var t = e.tag,
                n;
              if (
                ((n = t !== 3 && t !== 27) &&
                  ((n = t === 5) &&
                    ((n = e.type),
                    (n =
                      !(n !== 'form' && n !== 'button') ||
                      Ef(e.type, e.memoizedProps))),
                  (n = !n)),
                n && rt)
              ) {
                for (n = rt; n; ) {
                  var a = Gi(e, 0),
                    s = ey(n);
                  (a.serverTail.push(s),
                    (n = s.type === 'Suspense' ? ny(n) : Mn(n.nextSibling)));
                }
                qi(e);
              }
              if ((jh(e), t === 13)) {
                if (
                  ((e = e.memoizedState),
                  (e = e !== null ? e.dehydrated : null),
                  !e)
                )
                  throw Error(
                    'Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.'
                  );
                rt = ny(e);
              } else
                t === 27
                  ? ((t = rt),
                    ci(e.type) ? ((e = tp), (tp = null), (rt = e)) : (rt = t))
                  : (rt = qt ? Mn(e.stateNode.nextSibling) : null);
              return !0;
            }
            function qs() {
              ((rt = qt = null), (za = He = !1));
            }
            function Vh() {
              var e = al;
              return (
                e !== null &&
                  (Qt === null ? (Qt = e) : Qt.push.apply(Qt, e), (al = null)),
                e
              );
            }
            function Ys(e) {
              al === null ? (al = [e]) : al.push(e);
            }
            function Bh() {
              var e = Bn;
              if (e !== null) {
                Bn = null;
                for (var t = Iu(e); 0 < e.children.length; ) e = e.children[0];
                he(e.fiber, function () {
                  console.error(
                    `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
                    'https://react.dev/link/hydration-mismatch',
                    t
                  );
                });
              }
            }
            function kr() {
              ((ss = Vc = null), (os = !1));
            }
            function ti(e, t, n) {
              (se(hm, t._currentValue, e),
                (t._currentValue = n),
                se(gm, t._currentRenderer, e),
                t._currentRenderer !== void 0 &&
                  t._currentRenderer !== null &&
                  t._currentRenderer !== Sv &&
                  console.error(
                    'Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.'
                  ),
                (t._currentRenderer = Sv));
            }
            function Ea(e, t) {
              e._currentValue = hm.current;
              var n = gm.current;
              (q(gm, t), (e._currentRenderer = n), q(hm, t));
            }
            function nd(e, t, n) {
              for (; e !== null; ) {
                var a = e.alternate;
                if (
                  ((e.childLanes & t) !== t
                    ? ((e.childLanes |= t), a !== null && (a.childLanes |= t))
                    : a !== null &&
                      (a.childLanes & t) !== t &&
                      (a.childLanes |= t),
                  e === n)
                )
                  break;
                e = e.return;
              }
              e !== n &&
                console.error(
                  'Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.'
                );
            }
            function ad(e, t, n, a) {
              var s = e.child;
              for (s !== null && (s.return = e); s !== null; ) {
                var c = s.dependencies;
                if (c !== null) {
                  var f = s.child;
                  c = c.firstContext;
                  e: for (; c !== null; ) {
                    var b = c;
                    c = s;
                    for (var w = 0; w < t.length; w++)
                      if (b.context === t[w]) {
                        ((c.lanes |= n),
                          (b = c.alternate),
                          b !== null && (b.lanes |= n),
                          nd(c.return, n, e),
                          a || (f = null));
                        break e;
                      }
                    c = b.next;
                  }
                } else if (s.tag === 18) {
                  if (((f = s.return), f === null))
                    throw Error(
                      'We just came from a parent so we must have had a parent. This is a bug in React.'
                    );
                  ((f.lanes |= n),
                    (c = f.alternate),
                    c !== null && (c.lanes |= n),
                    nd(f, n, e),
                    (f = null));
                } else f = s.child;
                if (f !== null) f.return = s;
                else
                  for (f = s; f !== null; ) {
                    if (f === e) {
                      f = null;
                      break;
                    }
                    if (((s = f.sibling), s !== null)) {
                      ((s.return = f.return), (f = s));
                      break;
                    }
                    f = f.return;
                  }
                s = f;
              }
            }
            function Xs(e, t, n, a) {
              e = null;
              for (var s = t, c = !1; s !== null; ) {
                if (!c) {
                  if ((s.flags & 524288) !== 0) c = !0;
                  else if ((s.flags & 262144) !== 0) break;
                }
                if (s.tag === 10) {
                  var f = s.alternate;
                  if (f === null)
                    throw Error(
                      'Should have a current fiber. This is a bug in React.'
                    );
                  if (((f = f.memoizedProps), f !== null)) {
                    var b = s.type;
                    Gt(s.pendingProps.value, f.value) ||
                      (e !== null ? e.push(b) : (e = [b]));
                  }
                } else if (s === Nc.current) {
                  if (((f = s.alternate), f === null))
                    throw Error(
                      'Should have a current fiber. This is a bug in React.'
                    );
                  f.memoizedState.memoizedState !==
                    s.memoizedState.memoizedState &&
                    (e !== null ? e.push(ir) : (e = [ir]));
                }
                s = s.return;
              }
              (e !== null && ad(t, e, n, a), (t.flags |= 262144));
            }
            function _r(e) {
              for (e = e.firstContext; e !== null; ) {
                if (!Gt(e.context._currentValue, e.memoizedValue)) return !0;
                e = e.next;
              }
              return !1;
            }
            function Yi(e) {
              ((Vc = e),
                (ss = null),
                (e = e.dependencies),
                e !== null && (e.firstContext = null));
            }
            function tt(e) {
              return (
                os &&
                  console.error(
                    'Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().'
                  ),
                Lh(Vc, e)
              );
            }
            function jr(e, t) {
              return (Vc === null && Yi(e), Lh(e, t));
            }
            function Lh(e, t) {
              var n = t._currentValue;
              if (
                ((t = { context: t, memoizedValue: n, next: null }),
                ss === null)
              ) {
                if (e === null)
                  throw Error(
                    'Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().'
                  );
                ((ss = t),
                  (e.dependencies = {
                    lanes: 0,
                    firstContext: t,
                    _debugThenableState: null,
                  }),
                  (e.flags |= 524288));
              } else ss = ss.next = t;
              return n;
            }
            function id() {
              return { controller: new dw(), data: new Map(), refCount: 0 };
            }
            function Xi(e) {
              (e.controller.signal.aborted &&
                console.warn(
                  'A cache instance was retained after it was already freed. This likely indicates a bug in React.'
                ),
                e.refCount++);
            }
            function Qs(e) {
              (e.refCount--,
                0 > e.refCount &&
                  console.warn(
                    'A cache instance was released after it was already freed. This likely indicates a bug in React.'
                  ),
                e.refCount === 0 &&
                  fw(mw, function () {
                    e.controller.abort();
                  }));
            }
            function Da() {
              var e = il;
              return ((il = 0), e);
            }
            function Vr(e) {
              var t = il;
              return ((il = e), t);
            }
            function Zs(e) {
              var t = il;
              return ((il += e), t);
            }
            function ld(e) {
              ((ln = rs()), 0 > e.actualStartTime && (e.actualStartTime = ln));
            }
            function sd(e) {
              if (0 <= ln) {
                var t = rs() - ln;
                ((e.actualDuration += t), (e.selfBaseDuration = t), (ln = -1));
              }
            }
            function zh(e) {
              if (0 <= ln) {
                var t = rs() - ln;
                ((e.actualDuration += t), (ln = -1));
              }
            }
            function ta() {
              if (0 <= ln) {
                var e = rs() - ln;
                ((ln = -1), (il += e));
              }
            }
            function na() {
              ln = rs();
            }
            function Br(e) {
              for (var t = e.child; t; )
                ((e.actualDuration += t.actualDuration), (t = t.sibling));
            }
            function IS(e, t) {
              if (Oo === null) {
                var n = (Oo = []);
                ((bm = 0),
                  (ll = hf()),
                  (cs = {
                    status: 'pending',
                    value: void 0,
                    then: function (a) {
                      n.push(a);
                    },
                  }));
              }
              return (bm++, t.then(Hh, Hh), t);
            }
            function Hh() {
              if (--bm === 0 && Oo !== null) {
                cs !== null && (cs.status = 'fulfilled');
                var e = Oo;
                ((Oo = null), (ll = 0), (cs = null));
                for (var t = 0; t < e.length; t++) (0, e[t])();
              }
            }
            function WS(e, t) {
              var n = [],
                a = {
                  status: 'pending',
                  value: null,
                  reason: null,
                  then: function (s) {
                    n.push(s);
                  },
                };
              return (
                e.then(
                  function () {
                    ((a.status = 'fulfilled'), (a.value = t));
                    for (var s = 0; s < n.length; s++) (0, n[s])(t);
                  },
                  function (s) {
                    for (
                      a.status = 'rejected', a.reason = s, s = 0;
                      s < n.length;
                      s++
                    )
                      (0, n[s])(void 0);
                  }
                ),
                a
              );
            }
            function od() {
              var e = sl.current;
              return e !== null ? e : Ze.pooledCache;
            }
            function Lr(e, t) {
              t === null ? se(sl, sl.current, e) : se(sl, t.pool, e);
            }
            function Uh() {
              var e = od();
              return e === null ? null : { parent: xt._currentValue, pool: e };
            }
            function Ih() {
              return { didWarnAboutUncachedPromise: !1, thenables: [] };
            }
            function Wh(e) {
              return ((e = e.status), e === 'fulfilled' || e === 'rejected');
            }
            function zr() {}
            function $h(e, t, n) {
              z.actQueue !== null && (z.didUsePromise = !0);
              var a = e.thenables;
              switch (
                ((n = a[n]),
                n === void 0
                  ? a.push(t)
                  : n !== t &&
                    (e.didWarnAboutUncachedPromise ||
                      ((e.didWarnAboutUncachedPromise = !0),
                      console.error(
                        'A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.'
                      )),
                    t.then(zr, zr),
                    (t = n)),
                t.status)
              ) {
                case 'fulfilled':
                  return t.value;
                case 'rejected':
                  throw ((e = t.reason), Gh(e), e);
                default:
                  if (typeof t.status == 'string') t.then(zr, zr);
                  else {
                    if (((e = Ze), e !== null && 100 < e.shellSuspendCounter))
                      throw Error(
                        "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
                      );
                    ((e = t),
                      (e.status = 'pending'),
                      e.then(
                        function (s) {
                          if (t.status === 'pending') {
                            var c = t;
                            ((c.status = 'fulfilled'), (c.value = s));
                          }
                        },
                        function (s) {
                          if (t.status === 'pending') {
                            var c = t;
                            ((c.status = 'rejected'), (c.reason = s));
                          }
                        }
                      ));
                  }
                  switch (t.status) {
                    case 'fulfilled':
                      return t.value;
                    case 'rejected':
                      throw ((e = t.reason), Gh(e), e);
                  }
                  throw ((Ho = t), (Ic = !0), zo);
              }
            }
            function Ph() {
              if (Ho === null)
                throw Error(
                  'Expected a suspended thenable. This is a bug in React. Please file an issue.'
                );
              var e = Ho;
              return ((Ho = null), (Ic = !1), e);
            }
            function Gh(e) {
              if (e === zo || e === Uc)
                throw Error(
                  "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
                );
            }
            function rd(e) {
              e.updateQueue = {
                baseState: e.memoizedState,
                firstBaseUpdate: null,
                lastBaseUpdate: null,
                shared: { pending: null, lanes: 0, hiddenCallbacks: null },
                callbacks: null,
              };
            }
            function cd(e, t) {
              ((e = e.updateQueue),
                t.updateQueue === e &&
                  (t.updateQueue = {
                    baseState: e.baseState,
                    firstBaseUpdate: e.firstBaseUpdate,
                    lastBaseUpdate: e.lastBaseUpdate,
                    shared: e.shared,
                    callbacks: null,
                  }));
            }
            function ni(e) {
              return {
                lane: e,
                tag: Dv,
                payload: null,
                callback: null,
                next: null,
              };
            }
            function ai(e, t, n) {
              var a = e.updateQueue;
              if (a === null) return null;
              if (((a = a.shared), Sm === a && !Av)) {
                var s = J(e);
                (console.error(
                  `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
                  s
                ),
                  (Av = !0));
              }
              return (Pe & Xt) !== yn
                ? ((s = a.pending),
                  s === null ? (t.next = t) : ((t.next = s.next), (s.next = t)),
                  (a.pending = t),
                  (t = Mr(e)),
                  Ah(e, null, n),
                  t)
                : (Rr(e, a, t, n), Mr(e));
            }
            function Fs(e, t, n) {
              if (
                ((t = t.updateQueue),
                t !== null && ((t = t.shared), (n & 4194048) !== 0))
              ) {
                var a = t.lanes;
                ((a &= e.pendingLanes), (n |= a), (t.lanes = n), vr(e, n));
              }
            }
            function Hr(e, t) {
              var n = e.updateQueue,
                a = e.alternate;
              if (a !== null && ((a = a.updateQueue), n === a)) {
                var s = null,
                  c = null;
                if (((n = n.firstBaseUpdate), n !== null)) {
                  do {
                    var f = {
                      lane: n.lane,
                      tag: n.tag,
                      payload: n.payload,
                      callback: null,
                      next: null,
                    };
                    (c === null ? (s = c = f) : (c = c.next = f), (n = n.next));
                  } while (n !== null);
                  c === null ? (s = c = t) : (c = c.next = t);
                } else s = c = t;
                ((n = {
                  baseState: a.baseState,
                  firstBaseUpdate: s,
                  lastBaseUpdate: c,
                  shared: a.shared,
                  callbacks: a.callbacks,
                }),
                  (e.updateQueue = n));
                return;
              }
              ((e = n.lastBaseUpdate),
                e === null ? (n.firstBaseUpdate = t) : (e.next = t),
                (n.lastBaseUpdate = t));
            }
            function Ks() {
              if (xm) {
                var e = cs;
                if (e !== null) throw e;
              }
            }
            function Js(e, t, n, a) {
              xm = !1;
              var s = e.updateQueue;
              ((bi = !1), (Sm = s.shared));
              var c = s.firstBaseUpdate,
                f = s.lastBaseUpdate,
                b = s.shared.pending;
              if (b !== null) {
                s.shared.pending = null;
                var w = b,
                  T = w.next;
                ((w.next = null), f === null ? (c = T) : (f.next = T), (f = w));
                var j = e.alternate;
                j !== null &&
                  ((j = j.updateQueue),
                  (b = j.lastBaseUpdate),
                  b !== f &&
                    (b === null ? (j.firstBaseUpdate = T) : (b.next = T),
                    (j.lastBaseUpdate = w)));
              }
              if (c !== null) {
                var H = s.baseState;
                ((f = 0), (j = T = w = null), (b = c));
                do {
                  var _ = b.lane & -536870913,
                    I = _ !== b.lane;
                  if (I ? (_e & _) === _ : (a & _) === _) {
                    (_ !== 0 && _ === ll && (xm = !0),
                      j !== null &&
                        (j = j.next =
                          {
                            lane: 0,
                            tag: b.tag,
                            payload: b.payload,
                            callback: null,
                            next: null,
                          }));
                    e: {
                      _ = e;
                      var fe = b,
                        be = t,
                        Fe = n;
                      switch (fe.tag) {
                        case Tv:
                          if (((fe = fe.payload), typeof fe == 'function')) {
                            os = !0;
                            var Ve = fe.call(Fe, H, be);
                            if (_.mode & It) {
                              Le(!0);
                              try {
                                fe.call(Fe, H, be);
                              } finally {
                                Le(!1);
                              }
                            }
                            ((os = !1), (H = Ve));
                            break e;
                          }
                          H = fe;
                          break e;
                        case vm:
                          _.flags = (_.flags & -65537) | 128;
                        case Dv:
                          if (((Ve = fe.payload), typeof Ve == 'function')) {
                            if (
                              ((os = !0),
                              (fe = Ve.call(Fe, H, be)),
                              _.mode & It)
                            ) {
                              Le(!0);
                              try {
                                Ve.call(Fe, H, be);
                              } finally {
                                Le(!1);
                              }
                            }
                            os = !1;
                          } else fe = Ve;
                          if (fe == null) break e;
                          H = Re({}, H, fe);
                          break e;
                        case Cv:
                          bi = !0;
                      }
                    }
                    ((_ = b.callback),
                      _ !== null &&
                        ((e.flags |= 64),
                        I && (e.flags |= 8192),
                        (I = s.callbacks),
                        I === null ? (s.callbacks = [_]) : I.push(_)));
                  } else
                    ((I = {
                      lane: _,
                      tag: b.tag,
                      payload: b.payload,
                      callback: b.callback,
                      next: null,
                    }),
                      j === null ? ((T = j = I), (w = H)) : (j = j.next = I),
                      (f |= _));
                  if (((b = b.next), b === null)) {
                    if (((b = s.shared.pending), b === null)) break;
                    ((I = b),
                      (b = I.next),
                      (I.next = null),
                      (s.lastBaseUpdate = I),
                      (s.shared.pending = null));
                  }
                } while (!0);
                (j === null && (w = H),
                  (s.baseState = w),
                  (s.firstBaseUpdate = T),
                  (s.lastBaseUpdate = j),
                  c === null && (s.shared.lanes = 0),
                  (xi |= f),
                  (e.lanes = f),
                  (e.memoizedState = H));
              }
              Sm = null;
            }
            function qh(e, t) {
              if (typeof e != 'function')
                throw Error(
                  'Invalid argument passed as callback. Expected a function. Instead received: ' +
                    e
                );
              e.call(t);
            }
            function $S(e, t) {
              var n = e.shared.hiddenCallbacks;
              if (n !== null)
                for (e.shared.hiddenCallbacks = null, e = 0; e < n.length; e++)
                  qh(n[e], t);
            }
            function Yh(e, t) {
              var n = e.callbacks;
              if (n !== null)
                for (e.callbacks = null, e = 0; e < n.length; e++) qh(n[e], t);
            }
            function Xh(e, t) {
              var n = ba;
              (se(Wc, n, e), se(us, t, e), (ba = n | t.baseLanes));
            }
            function ud(e) {
              (se(Wc, ba, e), se(us, us.current, e));
            }
            function dd(e) {
              ((ba = Wc.current), q(us, e), q(Wc, e));
            }
            function ke() {
              var e = B;
              Hn === null ? (Hn = [e]) : Hn.push(e);
            }
            function te() {
              var e = B;
              if (Hn !== null && (Ua++, Hn[Ua] !== e)) {
                var t = J(ye);
                if (!Rv.has(t) && (Rv.add(t), Hn !== null)) {
                  for (var n = '', a = 0; a <= Ua; a++) {
                    var s = Hn[a],
                      c = a === Ua ? e : s;
                    for (s = a + 1 + '. ' + s; 30 > s.length; ) s += ' ';
                    ((s +=
                      c +
                      `
`),
                      (n += s));
                  }
                  console.error(
                    `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
                    t,
                    n
                  );
                }
              }
            }
            function Ol(e) {
              e == null ||
                jt(e) ||
                console.error(
                  '%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.',
                  B,
                  typeof e
                );
            }
            function Ur() {
              var e = J(ye);
              Ov.has(e) ||
                (Ov.add(e),
                console.error(
                  'ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.',
                  e
                ));
            }
            function ft() {
              throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`);
            }
            function fd(e, t) {
              if (Io) return !1;
              if (t === null)
                return (
                  console.error(
                    '%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.',
                    B
                  ),
                  !1
                );
              e.length !== t.length &&
                console.error(
                  `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
                  B,
                  '[' + t.join(', ') + ']',
                  '[' + e.join(', ') + ']'
                );
              for (var n = 0; n < t.length && n < e.length; n++)
                if (!Gt(e[n], t[n])) return !1;
              return !0;
            }
            function md(e, t, n, a, s, c) {
              ((yi = c),
                (ye = t),
                (Hn = e !== null ? e._debugHookTypes : null),
                (Ua = -1),
                (Io = e !== null && e.type !== t.type),
                (Object.prototype.toString.call(n) ===
                  '[object AsyncFunction]' ||
                  Object.prototype.toString.call(n) ===
                    '[object AsyncGeneratorFunction]') &&
                  ((c = J(ye)),
                  Nm.has(c) ||
                    (Nm.add(c),
                    console.error(
                      "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
                      c === null ? 'An unknown Component' : '<' + c + '>'
                    ))),
                (t.memoizedState = null),
                (t.updateQueue = null),
                (t.lanes = 0),
                (z.H =
                  e !== null && e.memoizedState !== null
                    ? Em
                    : Hn !== null
                      ? kv
                      : wm),
                (rl = c = (t.mode & It) !== Ke));
              var f = Dm(n, a, s);
              if (((rl = !1), fs && (f = pd(t, n, a, s)), c)) {
                Le(!0);
                try {
                  f = pd(t, n, a, s);
                } finally {
                  Le(!1);
                }
              }
              return (Qh(e, t), f);
            }
            function Qh(e, t) {
              ((t._debugHookTypes = Hn),
                t.dependencies === null
                  ? Ha !== null &&
                    (t.dependencies = {
                      lanes: 0,
                      firstContext: null,
                      _debugThenableState: Ha,
                    })
                  : (t.dependencies._debugThenableState = Ha),
                (z.H = Gc));
              var n = Qe !== null && Qe.next !== null;
              if (
                ((yi = 0),
                (Hn = B = vt = Qe = ye = null),
                (Ua = -1),
                e !== null &&
                  (e.flags & 65011712) !== (t.flags & 65011712) &&
                  console.error(
                    'Internal React error: Expected static flag was missing. Please notify the React team.'
                  ),
                ($c = !1),
                (Uo = 0),
                (Ha = null),
                n)
              )
                throw Error(
                  'Rendered fewer hooks than expected. This may be caused by an accidental early return statement.'
                );
              (e === null ||
                Ct ||
                ((e = e.dependencies), e !== null && _r(e) && (Ct = !0)),
                Ic ? ((Ic = !1), (e = !0)) : (e = !1),
                e &&
                  ((t = J(t) || 'Unknown'),
                  Mv.has(t) ||
                    Nm.has(t) ||
                    (Mv.add(t),
                    console.error(
                      '`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.'
                    ))));
            }
            function pd(e, t, n, a) {
              ye = e;
              var s = 0;
              do {
                if ((fs && (Ha = null), (Uo = 0), (fs = !1), s >= hw))
                  throw Error(
                    'Too many re-renders. React limits the number of renders to prevent an infinite loop.'
                  );
                if (
                  ((s += 1), (Io = !1), (vt = Qe = null), e.updateQueue != null)
                ) {
                  var c = e.updateQueue;
                  ((c.lastEffect = null),
                    (c.events = null),
                    (c.stores = null),
                    c.memoCache != null && (c.memoCache.index = 0));
                }
                ((Ua = -1), (z.H = _v), (c = Dm(t, n, a)));
              } while (fs);
              return c;
            }
            function PS() {
              var e = z.H,
                t = e.useState()[0];
              return (
                (t = typeof t.then == 'function' ? eo(t) : t),
                (e = e.useState()[0]),
                (Qe !== null ? Qe.memoizedState : null) !== e &&
                  (ye.flags |= 1024),
                t
              );
            }
            function hd() {
              var e = Pc !== 0;
              return ((Pc = 0), e);
            }
            function gd(e, t, n) {
              ((t.updateQueue = e.updateQueue),
                (t.flags =
                  (t.mode & Qn) !== Ke
                    ? t.flags & -402655237
                    : t.flags & -2053),
                (e.lanes &= ~n));
            }
            function bd(e) {
              if ($c) {
                for (e = e.memoizedState; e !== null; ) {
                  var t = e.queue;
                  (t !== null && (t.pending = null), (e = e.next));
                }
                $c = !1;
              }
              ((yi = 0),
                (Hn = vt = Qe = ye = null),
                (Ua = -1),
                (B = null),
                (fs = !1),
                (Uo = Pc = 0),
                (Ha = null));
            }
            function tn() {
              var e = {
                memoizedState: null,
                baseState: null,
                baseQueue: null,
                queue: null,
                next: null,
              };
              return (
                vt === null ? (ye.memoizedState = vt = e) : (vt = vt.next = e),
                vt
              );
            }
            function qe() {
              if (Qe === null) {
                var e = ye.alternate;
                e = e !== null ? e.memoizedState : null;
              } else e = Qe.next;
              var t = vt === null ? ye.memoizedState : vt.next;
              if (t !== null) ((vt = t), (Qe = e));
              else {
                if (e === null)
                  throw ye.alternate === null
                    ? Error(
                        'Update hook called on initial render. This is likely a bug in React. Please file an issue.'
                      )
                    : Error(
                        'Rendered more hooks than during the previous render.'
                      );
                ((Qe = e),
                  (e = {
                    memoizedState: Qe.memoizedState,
                    baseState: Qe.baseState,
                    baseQueue: Qe.baseQueue,
                    queue: Qe.queue,
                    next: null,
                  }),
                  vt === null
                    ? (ye.memoizedState = vt = e)
                    : (vt = vt.next = e));
              }
              return vt;
            }
            function yd() {
              return {
                lastEffect: null,
                events: null,
                stores: null,
                memoCache: null,
              };
            }
            function eo(e) {
              var t = Uo;
              return (
                (Uo += 1),
                Ha === null && (Ha = Ih()),
                (e = $h(Ha, e, t)),
                (t = ye),
                (vt === null ? t.memoizedState : vt.next) === null &&
                  ((t = t.alternate),
                  (z.H = t !== null && t.memoizedState !== null ? Em : wm)),
                e
              );
            }
            function ii(e) {
              if (e !== null && typeof e == 'object') {
                if (typeof e.then == 'function') return eo(e);
                if (e.$$typeof === ra) return tt(e);
              }
              throw Error(
                'An unsupported type was passed to use(): ' + String(e)
              );
            }
            function Qi(e) {
              var t = null,
                n = ye.updateQueue;
              if ((n !== null && (t = n.memoCache), t == null)) {
                var a = ye.alternate;
                a !== null &&
                  ((a = a.updateQueue),
                  a !== null &&
                    ((a = a.memoCache),
                    a != null &&
                      (t = {
                        data: a.data.map(function (s) {
                          return s.slice();
                        }),
                        index: 0,
                      })));
              }
              if (
                (t == null && (t = { data: [], index: 0 }),
                n === null && ((n = yd()), (ye.updateQueue = n)),
                (n.memoCache = t),
                (n = t.data[t.index]),
                n === void 0 || Io)
              )
                for (n = t.data[t.index] = Array(e), a = 0; a < e; a++)
                  n[a] = tN;
              else
                n.length !== e &&
                  console.error(
                    'Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.',
                    n.length,
                    e
                  );
              return (t.index++, n);
            }
            function Yn(e, t) {
              return typeof t == 'function' ? t(e) : t;
            }
            function vd(e, t, n) {
              var a = tn();
              if (n !== void 0) {
                var s = n(t);
                if (rl) {
                  Le(!0);
                  try {
                    n(t);
                  } finally {
                    Le(!1);
                  }
                }
              } else s = t;
              return (
                (a.memoizedState = a.baseState = s),
                (e = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: s,
                }),
                (a.queue = e),
                (e = e.dispatch = XS.bind(null, ye, e)),
                [a.memoizedState, e]
              );
            }
            function kl(e) {
              var t = qe();
              return Sd(t, Qe, e);
            }
            function Sd(e, t, n) {
              var a = e.queue;
              if (a === null)
                throw Error(
                  'Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)'
                );
              a.lastRenderedReducer = n;
              var s = e.baseQueue,
                c = a.pending;
              if (c !== null) {
                if (s !== null) {
                  var f = s.next;
                  ((s.next = c.next), (c.next = f));
                }
                (t.baseQueue !== s &&
                  console.error(
                    'Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.'
                  ),
                  (t.baseQueue = s = c),
                  (a.pending = null));
              }
              if (((c = e.baseState), s === null)) e.memoizedState = c;
              else {
                t = s.next;
                var b = (f = null),
                  w = null,
                  T = t,
                  j = !1;
                do {
                  var H = T.lane & -536870913;
                  if (H !== T.lane ? (_e & H) === H : (yi & H) === H) {
                    var _ = T.revertLane;
                    if (_ === 0)
                      (w !== null &&
                        (w = w.next =
                          {
                            lane: 0,
                            revertLane: 0,
                            action: T.action,
                            hasEagerState: T.hasEagerState,
                            eagerState: T.eagerState,
                            next: null,
                          }),
                        H === ll && (j = !0));
                    else if ((yi & _) === _) {
                      ((T = T.next), _ === ll && (j = !0));
                      continue;
                    } else
                      ((H = {
                        lane: 0,
                        revertLane: T.revertLane,
                        action: T.action,
                        hasEagerState: T.hasEagerState,
                        eagerState: T.eagerState,
                        next: null,
                      }),
                        w === null ? ((b = w = H), (f = c)) : (w = w.next = H),
                        (ye.lanes |= _),
                        (xi |= _));
                    ((H = T.action),
                      rl && n(c, H),
                      (c = T.hasEagerState ? T.eagerState : n(c, H)));
                  } else
                    ((_ = {
                      lane: H,
                      revertLane: T.revertLane,
                      action: T.action,
                      hasEagerState: T.hasEagerState,
                      eagerState: T.eagerState,
                      next: null,
                    }),
                      w === null ? ((b = w = _), (f = c)) : (w = w.next = _),
                      (ye.lanes |= H),
                      (xi |= H));
                  T = T.next;
                } while (T !== null && T !== t);
                if (
                  (w === null ? (f = c) : (w.next = b),
                  !Gt(c, e.memoizedState) &&
                    ((Ct = !0), j && ((n = cs), n !== null)))
                )
                  throw n;
                ((e.memoizedState = c),
                  (e.baseState = f),
                  (e.baseQueue = w),
                  (a.lastRenderedState = c));
              }
              return (
                s === null && (a.lanes = 0),
                [e.memoizedState, a.dispatch]
              );
            }
            function to(e) {
              var t = qe(),
                n = t.queue;
              if (n === null)
                throw Error(
                  'Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)'
                );
              n.lastRenderedReducer = e;
              var a = n.dispatch,
                s = n.pending,
                c = t.memoizedState;
              if (s !== null) {
                n.pending = null;
                var f = (s = s.next);
                do ((c = e(c, f.action)), (f = f.next));
                while (f !== s);
                (Gt(c, t.memoizedState) || (Ct = !0),
                  (t.memoizedState = c),
                  t.baseQueue === null && (t.baseState = c),
                  (n.lastRenderedState = c));
              }
              return [c, a];
            }
            function xd(e, t, n) {
              var a = ye,
                s = tn();
              if (He) {
                if (n === void 0)
                  throw Error(
                    'Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.'
                  );
                var c = n();
                ds ||
                  c === n() ||
                  (console.error(
                    'The result of getServerSnapshot should be cached to avoid an infinite loop'
                  ),
                  (ds = !0));
              } else {
                if (
                  ((c = t()),
                  ds ||
                    ((n = t()),
                    Gt(c, n) ||
                      (console.error(
                        'The result of getSnapshot should be cached to avoid an infinite loop'
                      ),
                      (ds = !0))),
                  Ze === null)
                )
                  throw Error(
                    'Expected a work-in-progress root. This is a bug in React. Please file an issue.'
                  );
                (_e & 124) !== 0 || Zh(a, t, c);
              }
              return (
                (s.memoizedState = c),
                (n = { value: c, getSnapshot: t }),
                (s.queue = n),
                Gr(Kh.bind(null, a, n, e), [e]),
                (a.flags |= 2048),
                jl(zn | Nt, Pr(), Fh.bind(null, a, n, c, t), null),
                c
              );
            }
            function Ir(e, t, n) {
              var a = ye,
                s = qe(),
                c = He;
              if (c) {
                if (n === void 0)
                  throw Error(
                    'Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.'
                  );
                n = n();
              } else if (((n = t()), !ds)) {
                var f = t();
                Gt(n, f) ||
                  (console.error(
                    'The result of getSnapshot should be cached to avoid an infinite loop'
                  ),
                  (ds = !0));
              }
              ((f = !Gt((Qe || s).memoizedState, n)) &&
                ((s.memoizedState = n), (Ct = !0)),
                (s = s.queue));
              var b = Kh.bind(null, a, s, e);
              if (
                (nn(2048, Nt, b, [e]),
                s.getSnapshot !== t ||
                  f ||
                  (vt !== null && vt.memoizedState.tag & zn))
              ) {
                if (
                  ((a.flags |= 2048),
                  jl(zn | Nt, Pr(), Fh.bind(null, a, s, n, t), null),
                  Ze === null)
                )
                  throw Error(
                    'Expected a work-in-progress root. This is a bug in React. Please file an issue.'
                  );
                c || (yi & 124) !== 0 || Zh(a, t, n);
              }
              return n;
            }
            function Zh(e, t, n) {
              ((e.flags |= 16384),
                (e = { getSnapshot: t, value: n }),
                (t = ye.updateQueue),
                t === null
                  ? ((t = yd()), (ye.updateQueue = t), (t.stores = [e]))
                  : ((n = t.stores),
                    n === null ? (t.stores = [e]) : n.push(e)));
            }
            function Fh(e, t, n, a) {
              ((t.value = n), (t.getSnapshot = a), Jh(t) && eg(e));
            }
            function Kh(e, t, n) {
              return n(function () {
                Jh(t) && eg(e);
              });
            }
            function Jh(e) {
              var t = e.getSnapshot;
              e = e.value;
              try {
                var n = t();
                return !Gt(e, n);
              } catch {
                return !0;
              }
            }
            function eg(e) {
              var t = en(e, 2);
              t !== null && mt(t, e, 2);
            }
            function Nd(e) {
              var t = tn();
              if (typeof e == 'function') {
                var n = e;
                if (((e = n()), rl)) {
                  Le(!0);
                  try {
                    n();
                  } finally {
                    Le(!1);
                  }
                }
              }
              return (
                (t.memoizedState = t.baseState = e),
                (t.queue = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: Yn,
                  lastRenderedState: e,
                }),
                t
              );
            }
            function wd(e) {
              e = Nd(e);
              var t = e.queue,
                n = vg.bind(null, ye, t);
              return ((t.dispatch = n), [e.memoizedState, n]);
            }
            function Ed(e) {
              var t = tn();
              t.memoizedState = t.baseState = e;
              var n = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null,
              };
              return (
                (t.queue = n),
                (t = Ld.bind(null, ye, !0, n)),
                (n.dispatch = t),
                [e, t]
              );
            }
            function tg(e, t) {
              var n = qe();
              return ng(n, Qe, e, t);
            }
            function ng(e, t, n, a) {
              return (
                (e.baseState = n),
                Sd(e, Qe, typeof a == 'function' ? a : Yn)
              );
            }
            function ag(e, t) {
              var n = qe();
              return Qe !== null
                ? ng(n, Qe, e, t)
                : ((n.baseState = e), [e, n.queue.dispatch]);
            }
            function GS(e, t, n, a, s) {
              if (Qr(e))
                throw Error('Cannot update form state while rendering.');
              if (((e = t.action), e !== null)) {
                var c = {
                  payload: s,
                  action: e,
                  next: null,
                  isTransition: !0,
                  status: 'pending',
                  value: null,
                  reason: null,
                  listeners: [],
                  then: function (f) {
                    c.listeners.push(f);
                  },
                };
                (z.T !== null ? n(!0) : (c.isTransition = !1),
                  a(c),
                  (n = t.pending),
                  n === null
                    ? ((c.next = t.pending = c), ig(t, c))
                    : ((c.next = n.next), (t.pending = n.next = c)));
              }
            }
            function ig(e, t) {
              var n = t.action,
                a = t.payload,
                s = e.state;
              if (t.isTransition) {
                var c = z.T,
                  f = {};
                ((z.T = f), (z.T._updatedFibers = new Set()));
                try {
                  var b = n(s, a),
                    w = z.S;
                  (w !== null && w(f, b), lg(e, t, b));
                } catch (T) {
                  Dd(e, t, T);
                } finally {
                  ((z.T = c),
                    c === null &&
                      f._updatedFibers &&
                      ((e = f._updatedFibers.size),
                      f._updatedFibers.clear(),
                      10 < e &&
                        console.warn(
                          'Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.'
                        )));
                }
              } else
                try {
                  ((f = n(s, a)), lg(e, t, f));
                } catch (T) {
                  Dd(e, t, T);
                }
            }
            function lg(e, t, n) {
              n !== null && typeof n == 'object' && typeof n.then == 'function'
                ? (n.then(
                    function (a) {
                      sg(e, t, a);
                    },
                    function (a) {
                      return Dd(e, t, a);
                    }
                  ),
                  t.isTransition ||
                    console.error(
                      'An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.'
                    ))
                : sg(e, t, n);
            }
            function sg(e, t, n) {
              ((t.status = 'fulfilled'),
                (t.value = n),
                og(t),
                (e.state = n),
                (t = e.pending),
                t !== null &&
                  ((n = t.next),
                  n === t
                    ? (e.pending = null)
                    : ((n = n.next), (t.next = n), ig(e, n))));
            }
            function Dd(e, t, n) {
              var a = e.pending;
              if (((e.pending = null), a !== null)) {
                a = a.next;
                do
                  ((t.status = 'rejected'),
                    (t.reason = n),
                    og(t),
                    (t = t.next));
                while (t !== a);
              }
              e.action = null;
            }
            function og(e) {
              e = e.listeners;
              for (var t = 0; t < e.length; t++) (0, e[t])();
            }
            function rg(e, t) {
              return t;
            }
            function _l(e, t) {
              if (He) {
                var n = Ze.formState;
                if (n !== null) {
                  e: {
                    var a = ye;
                    if (He) {
                      if (rt) {
                        t: {
                          for (var s = rt, c = pa; s.nodeType !== 8; ) {
                            if (!c) {
                              s = null;
                              break t;
                            }
                            if (((s = Mn(s.nextSibling)), s === null)) {
                              s = null;
                              break t;
                            }
                          }
                          ((c = s.data), (s = c === Fm || c === O1 ? s : null));
                        }
                        if (s) {
                          ((rt = Mn(s.nextSibling)), (a = s.data === Fm));
                          break e;
                        }
                      }
                      qi(a);
                    }
                    a = !1;
                  }
                  a && (t = n[0]);
                }
              }
              return (
                (n = tn()),
                (n.memoizedState = n.baseState = t),
                (a = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: rg,
                  lastRenderedState: t,
                }),
                (n.queue = a),
                (n = vg.bind(null, ye, a)),
                (a.dispatch = n),
                (a = Nd(!1)),
                (c = Ld.bind(null, ye, !1, a.queue)),
                (a = tn()),
                (s = { state: t, dispatch: null, action: e, pending: null }),
                (a.queue = s),
                (n = GS.bind(null, ye, s, c, n)),
                (s.dispatch = n),
                (a.memoizedState = e),
                [t, n, !1]
              );
            }
            function Wr(e) {
              var t = qe();
              return cg(t, Qe, e);
            }
            function cg(e, t, n) {
              if (
                ((t = Sd(e, t, rg)[0]),
                (e = kl(Yn)[0]),
                typeof t == 'object' &&
                  t !== null &&
                  typeof t.then == 'function')
              )
                try {
                  var a = eo(t);
                } catch (f) {
                  throw f === zo ? Uc : f;
                }
              else a = t;
              t = qe();
              var s = t.queue,
                c = s.dispatch;
              return (
                n !== t.memoizedState &&
                  ((ye.flags |= 2048),
                  jl(zn | Nt, Pr(), qS.bind(null, s, n), null)),
                [a, c, e]
              );
            }
            function qS(e, t) {
              e.action = t;
            }
            function $r(e) {
              var t = qe(),
                n = Qe;
              if (n !== null) return cg(t, n, e);
              (qe(), (t = t.memoizedState), (n = qe()));
              var a = n.queue.dispatch;
              return ((n.memoizedState = e), [t, a, !1]);
            }
            function jl(e, t, n, a) {
              return (
                (e = { tag: e, create: n, deps: a, inst: t, next: null }),
                (t = ye.updateQueue),
                t === null && ((t = yd()), (ye.updateQueue = t)),
                (n = t.lastEffect),
                n === null
                  ? (t.lastEffect = e.next = e)
                  : ((a = n.next),
                    (n.next = e),
                    (e.next = a),
                    (t.lastEffect = e)),
                e
              );
            }
            function Pr() {
              return { destroy: void 0, resource: void 0 };
            }
            function Td(e) {
              var t = tn();
              return ((e = { current: e }), (t.memoizedState = e));
            }
            function Zi(e, t, n, a) {
              var s = tn();
              ((a = a === void 0 ? null : a),
                (ye.flags |= e),
                (s.memoizedState = jl(zn | t, Pr(), n, a)));
            }
            function nn(e, t, n, a) {
              var s = qe();
              a = a === void 0 ? null : a;
              var c = s.memoizedState.inst;
              Qe !== null && a !== null && fd(a, Qe.memoizedState.deps)
                ? (s.memoizedState = jl(t, c, n, a))
                : ((ye.flags |= e), (s.memoizedState = jl(zn | t, c, n, a)));
            }
            function Gr(e, t) {
              (ye.mode & Qn) !== Ke && (ye.mode & gv) === Ke
                ? Zi(276826112, Nt, e, t)
                : Zi(8390656, Nt, e, t);
            }
            function Cd(e, t) {
              var n = 4194308;
              return (
                (ye.mode & Qn) !== Ke && (n |= 134217728),
                Zi(n, Bt, e, t)
              );
            }
            function ug(e, t) {
              if (typeof t == 'function') {
                e = e();
                var n = t(e);
                return function () {
                  typeof n == 'function' ? n() : t(null);
                };
              }
              if (t != null)
                return (
                  t.hasOwnProperty('current') ||
                    console.error(
                      'Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.',
                      'an object with keys {' + Object.keys(t).join(', ') + '}'
                    ),
                  (e = e()),
                  (t.current = e),
                  function () {
                    t.current = null;
                  }
                );
            }
            function Ad(e, t, n) {
              (typeof t != 'function' &&
                console.error(
                  'Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.',
                  t !== null ? typeof t : 'null'
                ),
                (n = n != null ? n.concat([e]) : null));
              var a = 4194308;
              ((ye.mode & Qn) !== Ke && (a |= 134217728),
                Zi(a, Bt, ug.bind(null, t, e), n));
            }
            function qr(e, t, n) {
              (typeof t != 'function' &&
                console.error(
                  'Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.',
                  t !== null ? typeof t : 'null'
                ),
                (n = n != null ? n.concat([e]) : null),
                nn(4, Bt, ug.bind(null, t, e), n));
            }
            function Rd(e, t) {
              return ((tn().memoizedState = [e, t === void 0 ? null : t]), e);
            }
            function Yr(e, t) {
              var n = qe();
              t = t === void 0 ? null : t;
              var a = n.memoizedState;
              return t !== null && fd(t, a[1])
                ? a[0]
                : ((n.memoizedState = [e, t]), e);
            }
            function Md(e, t) {
              var n = tn();
              t = t === void 0 ? null : t;
              var a = e();
              if (rl) {
                Le(!0);
                try {
                  e();
                } finally {
                  Le(!1);
                }
              }
              return ((n.memoizedState = [a, t]), a);
            }
            function Xr(e, t) {
              var n = qe();
              t = t === void 0 ? null : t;
              var a = n.memoizedState;
              if (t !== null && fd(t, a[1])) return a[0];
              if (((a = e()), rl)) {
                Le(!0);
                try {
                  e();
                } finally {
                  Le(!1);
                }
              }
              return ((n.memoizedState = [a, t]), a);
            }
            function Od(e, t) {
              var n = tn();
              return kd(n, e, t);
            }
            function dg(e, t) {
              var n = qe();
              return mg(n, Qe.memoizedState, e, t);
            }
            function fg(e, t) {
              var n = qe();
              return Qe === null ? kd(n, e, t) : mg(n, Qe.memoizedState, e, t);
            }
            function kd(e, t, n) {
              return n === void 0 || (yi & 1073741824) !== 0
                ? (e.memoizedState = t)
                : ((e.memoizedState = n),
                  (e = pb()),
                  (ye.lanes |= e),
                  (xi |= e),
                  n);
            }
            function mg(e, t, n, a) {
              return Gt(n, t)
                ? n
                : us.current !== null
                  ? ((e = kd(e, n, a)), Gt(e, t) || (Ct = !0), e)
                  : (yi & 42) === 0
                    ? ((Ct = !0), (e.memoizedState = n))
                    : ((e = pb()), (ye.lanes |= e), (xi |= e), t);
            }
            function pg(e, t, n, a, s) {
              var c = $e.p;
              $e.p = c !== 0 && c < da ? c : da;
              var f = z.T,
                b = {};
              ((z.T = b), Ld(e, !1, t, n), (b._updatedFibers = new Set()));
              try {
                var w = s(),
                  T = z.S;
                if (
                  (T !== null && T(b, w),
                  w !== null &&
                    typeof w == 'object' &&
                    typeof w.then == 'function')
                ) {
                  var j = WS(w, a);
                  no(e, t, j, hn(e));
                } else no(e, t, a, hn(e));
              } catch (H) {
                no(
                  e,
                  t,
                  { then: function () {}, status: 'rejected', reason: H },
                  hn(e)
                );
              } finally {
                (($e.p = c),
                  (z.T = f),
                  f === null &&
                    b._updatedFibers &&
                    ((e = b._updatedFibers.size),
                    b._updatedFibers.clear(),
                    10 < e &&
                      console.warn(
                        'Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.'
                      )));
              }
            }
            function _d(e, t, n, a) {
              if (e.tag !== 5)
                throw Error(
                  'Expected the form instance to be a HostComponent. This is a bug in React.'
                );
              var s = hg(e).queue;
              pg(
                e,
                s,
                t,
                vl,
                n === null
                  ? E
                  : function () {
                      return (gg(e), n(a));
                    }
              );
            }
            function hg(e) {
              var t = e.memoizedState;
              if (t !== null) return t;
              t = {
                memoizedState: vl,
                baseState: vl,
                baseQueue: null,
                queue: {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: Yn,
                  lastRenderedState: vl,
                },
                next: null,
              };
              var n = {};
              return (
                (t.next = {
                  memoizedState: n,
                  baseState: n,
                  baseQueue: null,
                  queue: {
                    pending: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: Yn,
                    lastRenderedState: n,
                  },
                  next: null,
                }),
                (e.memoizedState = t),
                (e = e.alternate),
                e !== null && (e.memoizedState = t),
                t
              );
            }
            function gg(e) {
              z.T === null &&
                console.error(
                  'requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.'
                );
              var t = hg(e).next.queue;
              no(e, t, {}, hn(e));
            }
            function jd() {
              var e = Nd(!1);
              return (
                (e = pg.bind(null, ye, e.queue, !0, !1)),
                (tn().memoizedState = e),
                [!1, e]
              );
            }
            function bg() {
              var e = kl(Yn)[0],
                t = qe().memoizedState;
              return [typeof e == 'boolean' ? e : eo(e), t];
            }
            function yg() {
              var e = to(Yn)[0],
                t = qe().memoizedState;
              return [typeof e == 'boolean' ? e : eo(e), t];
            }
            function Fi() {
              return tt(ir);
            }
            function Vd() {
              var e = tn(),
                t = Ze.identifierPrefix;
              if (He) {
                var n = La,
                  a = Ba;
                ((n = (a & ~(1 << (32 - $t(a) - 1))).toString(32) + n),
                  (t = '«' + t + 'R' + n),
                  (n = Pc++),
                  0 < n && (t += 'H' + n.toString(32)),
                  (t += '»'));
              } else ((n = pw++), (t = '«' + t + 'r' + n.toString(32) + '»'));
              return (e.memoizedState = t);
            }
            function Bd() {
              return (tn().memoizedState = YS.bind(null, ye));
            }
            function YS(e, t) {
              for (var n = e.return; n !== null; ) {
                switch (n.tag) {
                  case 24:
                  case 3:
                    var a = hn(n);
                    e = ni(a);
                    var s = ai(n, e, a);
                    (s !== null && (mt(s, n, a), Fs(s, n, a)),
                      (n = id()),
                      t != null &&
                        s !== null &&
                        console.error(
                          'The seed argument is not enabled outside experimental channels.'
                        ),
                      (e.payload = { cache: n }));
                    return;
                }
                n = n.return;
              }
            }
            function XS(e, t, n) {
              var a = arguments;
              (typeof a[3] == 'function' &&
                console.error(
                  "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
                ),
                (a = hn(e)));
              var s = {
                lane: a,
                revertLane: 0,
                action: n,
                hasEagerState: !1,
                eagerState: null,
                next: null,
              };
              (Qr(e)
                ? Sg(t, s)
                : ((s = qu(e, t, s, a)),
                  s !== null && (mt(s, e, a), xg(s, t, a))),
                Za(e, a));
            }
            function vg(e, t, n) {
              var a = arguments;
              (typeof a[3] == 'function' &&
                console.error(
                  "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
                ),
                (a = hn(e)),
                no(e, t, n, a),
                Za(e, a));
            }
            function no(e, t, n, a) {
              var s = {
                lane: a,
                revertLane: 0,
                action: n,
                hasEagerState: !1,
                eagerState: null,
                next: null,
              };
              if (Qr(e)) Sg(t, s);
              else {
                var c = e.alternate;
                if (
                  e.lanes === 0 &&
                  (c === null || c.lanes === 0) &&
                  ((c = t.lastRenderedReducer), c !== null)
                ) {
                  var f = z.H;
                  z.H = Fn;
                  try {
                    var b = t.lastRenderedState,
                      w = c(b, n);
                    if (((s.hasEagerState = !0), (s.eagerState = w), Gt(w, b)))
                      return (Rr(e, t, s, 0), Ze === null && Ar(), !1);
                  } catch {
                  } finally {
                    z.H = f;
                  }
                }
                if (((n = qu(e, t, s, a)), n !== null))
                  return (mt(n, e, a), xg(n, t, a), !0);
              }
              return !1;
            }
            function Ld(e, t, n, a) {
              if (
                (z.T === null &&
                  ll === 0 &&
                  console.error(
                    'An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition.'
                  ),
                (a = {
                  lane: 2,
                  revertLane: hf(),
                  action: a,
                  hasEagerState: !1,
                  eagerState: null,
                  next: null,
                }),
                Qr(e))
              ) {
                if (t)
                  throw Error(
                    'Cannot update optimistic state while rendering.'
                  );
                console.error('Cannot call startTransition while rendering.');
              } else ((t = qu(e, n, a, 2)), t !== null && mt(t, e, 2));
              Za(e, 2);
            }
            function Qr(e) {
              var t = e.alternate;
              return e === ye || (t !== null && t === ye);
            }
            function Sg(e, t) {
              fs = $c = !0;
              var n = e.pending;
              (n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)),
                (e.pending = t));
            }
            function xg(e, t, n) {
              if ((n & 4194048) !== 0) {
                var a = t.lanes;
                ((a &= e.pendingLanes), (n |= a), (t.lanes = n), vr(e, n));
              }
            }
            function Ot(e) {
              var t = Ce;
              return (e != null && (Ce = t === null ? e : t.concat(e)), t);
            }
            function Zr(e, t, n) {
              for (var a = Object.keys(e.props), s = 0; s < a.length; s++) {
                var c = a[s];
                if (c !== 'children' && c !== 'key') {
                  (t === null &&
                    ((t = Or(e, n.mode, 0)),
                    (t._debugInfo = Ce),
                    (t.return = n)),
                    he(
                      t,
                      function (f) {
                        console.error(
                          'Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.',
                          f
                        );
                      },
                      c
                    ));
                  break;
                }
              }
            }
            function Fr(e) {
              var t = Wo;
              return ((Wo += 1), ms === null && (ms = Ih()), $h(ms, e, t));
            }
            function ao(e, t) {
              ((t = t.props.ref), (e.ref = t !== void 0 ? t : null));
            }
            function Kr(e, t) {
              throw t.$$typeof === Jx
                ? Error(`A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`)
                : ((e = Object.prototype.toString.call(t)),
                  Error(
                    'Objects are not valid as a React child (found: ' +
                      (e === '[object Object]'
                        ? 'object with keys {' + Object.keys(t).join(', ') + '}'
                        : e) +
                      '). If you meant to render a collection of children, use an array instead.'
                  ));
            }
            function Jr(e, t) {
              var n = J(e) || 'Component';
              Xv[n] ||
                ((Xv[n] = !0),
                (t = t.displayName || t.name || 'Component'),
                e.tag === 3
                  ? console.error(
                      `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
                      t,
                      t,
                      t
                    )
                  : console.error(
                      `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
                      t,
                      t,
                      n,
                      t,
                      n
                    ));
            }
            function ec(e, t) {
              var n = J(e) || 'Component';
              Qv[n] ||
                ((Qv[n] = !0),
                (t = String(t)),
                e.tag === 3
                  ? console.error(
                      `Symbols are not valid as a React child.
  root.render(%s)`,
                      t
                    )
                  : console.error(
                      `Symbols are not valid as a React child.
  <%s>%s</%s>`,
                      n,
                      t,
                      n
                    ));
            }
            function Ng(e) {
              function t(C, A) {
                if (e) {
                  var R = C.deletions;
                  R === null
                    ? ((C.deletions = [A]), (C.flags |= 16))
                    : R.push(A);
                }
              }
              function n(C, A) {
                if (!e) return null;
                for (; A !== null; ) (t(C, A), (A = A.sibling));
                return null;
              }
              function a(C) {
                for (var A = new Map(); C !== null; )
                  (C.key !== null ? A.set(C.key, C) : A.set(C.index, C),
                    (C = C.sibling));
                return A;
              }
              function s(C, A) {
                return ((C = wa(C, A)), (C.index = 0), (C.sibling = null), C);
              }
              function c(C, A, R) {
                return (
                  (C.index = R),
                  e
                    ? ((R = C.alternate),
                      R !== null
                        ? ((R = R.index),
                          R < A ? ((C.flags |= 67108866), A) : R)
                        : ((C.flags |= 67108866), A))
                    : ((C.flags |= 1048576), A)
                );
              }
              function f(C) {
                return (e && C.alternate === null && (C.flags |= 67108866), C);
              }
              function b(C, A, R, $) {
                return A === null || A.tag !== 6
                  ? ((A = Fu(R, C.mode, $)),
                    (A.return = C),
                    (A._debugOwner = C),
                    (A._debugTask = C._debugTask),
                    (A._debugInfo = Ce),
                    A)
                  : ((A = s(A, R)), (A.return = C), (A._debugInfo = Ce), A);
              }
              function w(C, A, R, $) {
                var ae = R.type;
                return ae === Gl
                  ? ((A = j(C, A, R.props.children, $, R.key)), Zr(R, A, C), A)
                  : A !== null &&
                      (A.elementType === ae ||
                        Rh(A, R) ||
                        (typeof ae == 'object' &&
                          ae !== null &&
                          ae.$$typeof === gn &&
                          vi(ae) === A.type))
                    ? ((A = s(A, R.props)),
                      ao(A, R),
                      (A.return = C),
                      (A._debugOwner = R._owner),
                      (A._debugInfo = Ce),
                      A)
                    : ((A = Or(R, C.mode, $)),
                      ao(A, R),
                      (A.return = C),
                      (A._debugInfo = Ce),
                      A);
              }
              function T(C, A, R, $) {
                return A === null ||
                  A.tag !== 4 ||
                  A.stateNode.containerInfo !== R.containerInfo ||
                  A.stateNode.implementation !== R.implementation
                  ? ((A = Ku(R, C.mode, $)),
                    (A.return = C),
                    (A._debugInfo = Ce),
                    A)
                  : ((A = s(A, R.children || [])),
                    (A.return = C),
                    (A._debugInfo = Ce),
                    A);
              }
              function j(C, A, R, $, ae) {
                return A === null || A.tag !== 7
                  ? ((A = Wi(R, C.mode, $, ae)),
                    (A.return = C),
                    (A._debugOwner = C),
                    (A._debugTask = C._debugTask),
                    (A._debugInfo = Ce),
                    A)
                  : ((A = s(A, R)), (A.return = C), (A._debugInfo = Ce), A);
              }
              function H(C, A, R) {
                if (
                  (typeof A == 'string' && A !== '') ||
                  typeof A == 'number' ||
                  typeof A == 'bigint'
                )
                  return (
                    (A = Fu('' + A, C.mode, R)),
                    (A.return = C),
                    (A._debugOwner = C),
                    (A._debugTask = C._debugTask),
                    (A._debugInfo = Ce),
                    A
                  );
                if (typeof A == 'object' && A !== null) {
                  switch (A.$$typeof) {
                    case ui:
                      return (
                        (R = Or(A, C.mode, R)),
                        ao(R, A),
                        (R.return = C),
                        (C = Ot(A._debugInfo)),
                        (R._debugInfo = Ce),
                        (Ce = C),
                        R
                      );
                    case Pl:
                      return (
                        (A = Ku(A, C.mode, R)),
                        (A.return = C),
                        (A._debugInfo = Ce),
                        A
                      );
                    case gn:
                      var $ = Ot(A._debugInfo);
                      return ((A = vi(A)), (C = H(C, A, R)), (Ce = $), C);
                  }
                  if (jt(A) || P(A))
                    return (
                      (R = Wi(A, C.mode, R, null)),
                      (R.return = C),
                      (R._debugOwner = C),
                      (R._debugTask = C._debugTask),
                      (C = Ot(A._debugInfo)),
                      (R._debugInfo = Ce),
                      (Ce = C),
                      R
                    );
                  if (typeof A.then == 'function')
                    return (
                      ($ = Ot(A._debugInfo)),
                      (C = H(C, Fr(A), R)),
                      (Ce = $),
                      C
                    );
                  if (A.$$typeof === ra) return H(C, jr(C, A), R);
                  Kr(C, A);
                }
                return (
                  typeof A == 'function' && Jr(C, A),
                  typeof A == 'symbol' && ec(C, A),
                  null
                );
              }
              function _(C, A, R, $) {
                var ae = A !== null ? A.key : null;
                if (
                  (typeof R == 'string' && R !== '') ||
                  typeof R == 'number' ||
                  typeof R == 'bigint'
                )
                  return ae !== null ? null : b(C, A, '' + R, $);
                if (typeof R == 'object' && R !== null) {
                  switch (R.$$typeof) {
                    case ui:
                      return R.key === ae
                        ? ((ae = Ot(R._debugInfo)),
                          (C = w(C, A, R, $)),
                          (Ce = ae),
                          C)
                        : null;
                    case Pl:
                      return R.key === ae ? T(C, A, R, $) : null;
                    case gn:
                      return (
                        (ae = Ot(R._debugInfo)),
                        (R = vi(R)),
                        (C = _(C, A, R, $)),
                        (Ce = ae),
                        C
                      );
                  }
                  if (jt(R) || P(R))
                    return ae !== null
                      ? null
                      : ((ae = Ot(R._debugInfo)),
                        (C = j(C, A, R, $, null)),
                        (Ce = ae),
                        C);
                  if (typeof R.then == 'function')
                    return (
                      (ae = Ot(R._debugInfo)),
                      (C = _(C, A, Fr(R), $)),
                      (Ce = ae),
                      C
                    );
                  if (R.$$typeof === ra) return _(C, A, jr(C, R), $);
                  Kr(C, R);
                }
                return (
                  typeof R == 'function' && Jr(C, R),
                  typeof R == 'symbol' && ec(C, R),
                  null
                );
              }
              function I(C, A, R, $, ae) {
                if (
                  (typeof $ == 'string' && $ !== '') ||
                  typeof $ == 'number' ||
                  typeof $ == 'bigint'
                )
                  return ((C = C.get(R) || null), b(A, C, '' + $, ae));
                if (typeof $ == 'object' && $ !== null) {
                  switch ($.$$typeof) {
                    case ui:
                      return (
                        (R = C.get($.key === null ? R : $.key) || null),
                        (C = Ot($._debugInfo)),
                        (A = w(A, R, $, ae)),
                        (Ce = C),
                        A
                      );
                    case Pl:
                      return (
                        (C = C.get($.key === null ? R : $.key) || null),
                        T(A, C, $, ae)
                      );
                    case gn:
                      var xe = Ot($._debugInfo);
                      return (
                        ($ = vi($)),
                        (A = I(C, A, R, $, ae)),
                        (Ce = xe),
                        A
                      );
                  }
                  if (jt($) || P($))
                    return (
                      (R = C.get(R) || null),
                      (C = Ot($._debugInfo)),
                      (A = j(A, R, $, ae, null)),
                      (Ce = C),
                      A
                    );
                  if (typeof $.then == 'function')
                    return (
                      (xe = Ot($._debugInfo)),
                      (A = I(C, A, R, Fr($), ae)),
                      (Ce = xe),
                      A
                    );
                  if ($.$$typeof === ra) return I(C, A, R, jr(A, $), ae);
                  Kr(A, $);
                }
                return (
                  typeof $ == 'function' && Jr(A, $),
                  typeof $ == 'symbol' && ec(A, $),
                  null
                );
              }
              function fe(C, A, R, $) {
                if (typeof R != 'object' || R === null) return $;
                switch (R.$$typeof) {
                  case ui:
                  case Pl:
                    h(C, A, R);
                    var ae = R.key;
                    if (typeof ae != 'string') break;
                    if ($ === null) {
                      (($ = new Set()), $.add(ae));
                      break;
                    }
                    if (!$.has(ae)) {
                      $.add(ae);
                      break;
                    }
                    he(A, function () {
                      console.error(
                        'Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.',
                        ae
                      );
                    });
                    break;
                  case gn:
                    ((R = vi(R)), fe(C, A, R, $));
                }
                return $;
              }
              function be(C, A, R, $) {
                for (
                  var ae = null,
                    xe = null,
                    de = null,
                    Ne = A,
                    Ee = (A = 0),
                    Je = null;
                  Ne !== null && Ee < R.length;
                  Ee++
                ) {
                  Ne.index > Ee ? ((Je = Ne), (Ne = null)) : (Je = Ne.sibling);
                  var ht = _(C, Ne, R[Ee], $);
                  if (ht === null) {
                    Ne === null && (Ne = Je);
                    break;
                  }
                  ((ae = fe(C, ht, R[Ee], ae)),
                    e && Ne && ht.alternate === null && t(C, Ne),
                    (A = c(ht, A, Ee)),
                    de === null ? (xe = ht) : (de.sibling = ht),
                    (de = ht),
                    (Ne = Je));
                }
                if (Ee === R.length) return (n(C, Ne), He && $i(C, Ee), xe);
                if (Ne === null) {
                  for (; Ee < R.length; Ee++)
                    ((Ne = H(C, R[Ee], $)),
                      Ne !== null &&
                        ((ae = fe(C, Ne, R[Ee], ae)),
                        (A = c(Ne, A, Ee)),
                        de === null ? (xe = Ne) : (de.sibling = Ne),
                        (de = Ne)));
                  return (He && $i(C, Ee), xe);
                }
                for (Ne = a(Ne); Ee < R.length; Ee++)
                  ((Je = I(Ne, C, Ee, R[Ee], $)),
                    Je !== null &&
                      ((ae = fe(C, Je, R[Ee], ae)),
                      e &&
                        Je.alternate !== null &&
                        Ne.delete(Je.key === null ? Ee : Je.key),
                      (A = c(Je, A, Ee)),
                      de === null ? (xe = Je) : (de.sibling = Je),
                      (de = Je)));
                return (
                  e &&
                    Ne.forEach(function (qa) {
                      return t(C, qa);
                    }),
                  He && $i(C, Ee),
                  xe
                );
              }
              function Fe(C, A, R, $) {
                if (R == null)
                  throw Error('An iterable object provided no iterator.');
                for (
                  var ae = null,
                    xe = null,
                    de = A,
                    Ne = (A = 0),
                    Ee = null,
                    Je = null,
                    ht = R.next();
                  de !== null && !ht.done;
                  Ne++, ht = R.next()
                ) {
                  de.index > Ne ? ((Ee = de), (de = null)) : (Ee = de.sibling);
                  var qa = _(C, de, ht.value, $);
                  if (qa === null) {
                    de === null && (de = Ee);
                    break;
                  }
                  ((Je = fe(C, qa, ht.value, Je)),
                    e && de && qa.alternate === null && t(C, de),
                    (A = c(qa, A, Ne)),
                    xe === null ? (ae = qa) : (xe.sibling = qa),
                    (xe = qa),
                    (de = Ee));
                }
                if (ht.done) return (n(C, de), He && $i(C, Ne), ae);
                if (de === null) {
                  for (; !ht.done; Ne++, ht = R.next())
                    ((de = H(C, ht.value, $)),
                      de !== null &&
                        ((Je = fe(C, de, ht.value, Je)),
                        (A = c(de, A, Ne)),
                        xe === null ? (ae = de) : (xe.sibling = de),
                        (xe = de)));
                  return (He && $i(C, Ne), ae);
                }
                for (de = a(de); !ht.done; Ne++, ht = R.next())
                  ((Ee = I(de, C, Ne, ht.value, $)),
                    Ee !== null &&
                      ((Je = fe(C, Ee, ht.value, Je)),
                      e &&
                        Ee.alternate !== null &&
                        de.delete(Ee.key === null ? Ne : Ee.key),
                      (A = c(Ee, A, Ne)),
                      xe === null ? (ae = Ee) : (xe.sibling = Ee),
                      (xe = Ee)));
                return (
                  e &&
                    de.forEach(function (Iw) {
                      return t(C, Iw);
                    }),
                  He && $i(C, Ne),
                  ae
                );
              }
              function Ve(C, A, R, $) {
                if (
                  (typeof R == 'object' &&
                    R !== null &&
                    R.type === Gl &&
                    R.key === null &&
                    (Zr(R, null, C), (R = R.props.children)),
                  typeof R == 'object' && R !== null)
                ) {
                  switch (R.$$typeof) {
                    case ui:
                      var ae = Ot(R._debugInfo);
                      e: {
                        for (var xe = R.key; A !== null; ) {
                          if (A.key === xe) {
                            if (((xe = R.type), xe === Gl)) {
                              if (A.tag === 7) {
                                (n(C, A.sibling),
                                  ($ = s(A, R.props.children)),
                                  ($.return = C),
                                  ($._debugOwner = R._owner),
                                  ($._debugInfo = Ce),
                                  Zr(R, $, C),
                                  (C = $));
                                break e;
                              }
                            } else if (
                              A.elementType === xe ||
                              Rh(A, R) ||
                              (typeof xe == 'object' &&
                                xe !== null &&
                                xe.$$typeof === gn &&
                                vi(xe) === A.type)
                            ) {
                              (n(C, A.sibling),
                                ($ = s(A, R.props)),
                                ao($, R),
                                ($.return = C),
                                ($._debugOwner = R._owner),
                                ($._debugInfo = Ce),
                                (C = $));
                              break e;
                            }
                            n(C, A);
                            break;
                          } else t(C, A);
                          A = A.sibling;
                        }
                        R.type === Gl
                          ? (($ = Wi(R.props.children, C.mode, $, R.key)),
                            ($.return = C),
                            ($._debugOwner = C),
                            ($._debugTask = C._debugTask),
                            ($._debugInfo = Ce),
                            Zr(R, $, C),
                            (C = $))
                          : (($ = Or(R, C.mode, $)),
                            ao($, R),
                            ($.return = C),
                            ($._debugInfo = Ce),
                            (C = $));
                      }
                      return ((C = f(C)), (Ce = ae), C);
                    case Pl:
                      e: {
                        for (ae = R, R = ae.key; A !== null; ) {
                          if (A.key === R)
                            if (
                              A.tag === 4 &&
                              A.stateNode.containerInfo === ae.containerInfo &&
                              A.stateNode.implementation === ae.implementation
                            ) {
                              (n(C, A.sibling),
                                ($ = s(A, ae.children || [])),
                                ($.return = C),
                                (C = $));
                              break e;
                            } else {
                              n(C, A);
                              break;
                            }
                          else t(C, A);
                          A = A.sibling;
                        }
                        (($ = Ku(ae, C.mode, $)), ($.return = C), (C = $));
                      }
                      return f(C);
                    case gn:
                      return (
                        (ae = Ot(R._debugInfo)),
                        (R = vi(R)),
                        (C = Ve(C, A, R, $)),
                        (Ce = ae),
                        C
                      );
                  }
                  if (jt(R))
                    return (
                      (ae = Ot(R._debugInfo)),
                      (C = be(C, A, R, $)),
                      (Ce = ae),
                      C
                    );
                  if (P(R)) {
                    if (
                      ((ae = Ot(R._debugInfo)),
                      (xe = P(R)),
                      typeof xe != 'function')
                    )
                      throw Error(
                        'An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.'
                      );
                    var de = xe.call(R);
                    return (
                      de === R
                        ? (C.tag !== 0 ||
                            Object.prototype.toString.call(C.type) !==
                              '[object GeneratorFunction]' ||
                            Object.prototype.toString.call(de) !==
                              '[object Generator]') &&
                          (qv ||
                            console.error(
                              'Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items.'
                            ),
                          (qv = !0))
                        : R.entries !== xe ||
                          Cm ||
                          (console.error(
                            'Using Maps as children is not supported. Use an array of keyed ReactElements instead.'
                          ),
                          (Cm = !0)),
                      (C = Fe(C, A, de, $)),
                      (Ce = ae),
                      C
                    );
                  }
                  if (typeof R.then == 'function')
                    return (
                      (ae = Ot(R._debugInfo)),
                      (C = Ve(C, A, Fr(R), $)),
                      (Ce = ae),
                      C
                    );
                  if (R.$$typeof === ra) return Ve(C, A, jr(C, R), $);
                  Kr(C, R);
                }
                return (typeof R == 'string' && R !== '') ||
                  typeof R == 'number' ||
                  typeof R == 'bigint'
                  ? ((ae = '' + R),
                    A !== null && A.tag === 6
                      ? (n(C, A.sibling),
                        ($ = s(A, ae)),
                        ($.return = C),
                        (C = $))
                      : (n(C, A),
                        ($ = Fu(ae, C.mode, $)),
                        ($.return = C),
                        ($._debugOwner = C),
                        ($._debugTask = C._debugTask),
                        ($._debugInfo = Ce),
                        (C = $)),
                    f(C))
                  : (typeof R == 'function' && Jr(C, R),
                    typeof R == 'symbol' && ec(C, R),
                    n(C, A));
              }
              return function (C, A, R, $) {
                var ae = Ce;
                Ce = null;
                try {
                  Wo = 0;
                  var xe = Ve(C, A, R, $);
                  return ((ms = null), xe);
                } catch (Je) {
                  if (Je === zo || Je === Uc) throw Je;
                  var de = S(29, Je, null, C.mode);
                  ((de.lanes = $), (de.return = C));
                  var Ne = (de._debugInfo = Ce);
                  if (
                    ((de._debugOwner = C._debugOwner),
                    (de._debugTask = C._debugTask),
                    Ne != null)
                  ) {
                    for (var Ee = Ne.length - 1; 0 <= Ee; Ee--)
                      if (typeof Ne[Ee].stack == 'string') {
                        ((de._debugOwner = Ne[Ee]),
                          (de._debugTask = Ne[Ee].debugTask));
                        break;
                      }
                  }
                  return de;
                } finally {
                  Ce = ae;
                }
              };
            }
            function li(e) {
              var t = e.alternate;
              (se(wt, wt.current & hs, e),
                se(Un, e, e),
                ga === null &&
                  (t === null ||
                    us.current !== null ||
                    t.memoizedState !== null) &&
                  (ga = e));
            }
            function wg(e) {
              if (e.tag === 22) {
                if ((se(wt, wt.current, e), se(Un, e, e), ga === null)) {
                  var t = e.alternate;
                  t !== null && t.memoizedState !== null && (ga = e);
                }
              } else si(e);
            }
            function si(e) {
              (se(wt, wt.current, e), se(Un, Un.current, e));
            }
            function Ta(e) {
              (q(Un, e), ga === e && (ga = null), q(wt, e));
            }
            function tc(e) {
              for (var t = e; t !== null; ) {
                if (t.tag === 13) {
                  var n = t.memoizedState;
                  if (
                    n !== null &&
                    ((n = n.dehydrated), n === null || n.data === $a || Tf(n))
                  )
                    return t;
                } else if (
                  t.tag === 19 &&
                  t.memoizedProps.revealOrder !== void 0
                ) {
                  if ((t.flags & 128) !== 0) return t;
                } else if (t.child !== null) {
                  ((t.child.return = t), (t = t.child));
                  continue;
                }
                if (t === e) break;
                for (; t.sibling === null; ) {
                  if (t.return === null || t.return === e) return null;
                  t = t.return;
                }
                ((t.sibling.return = t.return), (t = t.sibling));
              }
              return null;
            }
            function zd(e) {
              if (e !== null && typeof e != 'function') {
                var t = String(e);
                o1.has(t) ||
                  (o1.add(t),
                  console.error(
                    'Expected the last optional `callback` argument to be a function. Instead received: %s.',
                    e
                  ));
              }
            }
            function Hd(e, t, n, a) {
              var s = e.memoizedState,
                c = n(a, s);
              if (e.mode & It) {
                Le(!0);
                try {
                  c = n(a, s);
                } finally {
                  Le(!1);
                }
              }
              (c === void 0 &&
                ((t = Q(t) || 'Component'),
                a1.has(t) ||
                  (a1.add(t),
                  console.error(
                    '%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.',
                    t
                  ))),
                (s = c == null ? s : Re({}, s, c)),
                (e.memoizedState = s),
                e.lanes === 0 && (e.updateQueue.baseState = s));
            }
            function Eg(e, t, n, a, s, c, f) {
              var b = e.stateNode;
              if (typeof b.shouldComponentUpdate == 'function') {
                if (((n = b.shouldComponentUpdate(a, c, f)), e.mode & It)) {
                  Le(!0);
                  try {
                    n = b.shouldComponentUpdate(a, c, f);
                  } finally {
                    Le(!1);
                  }
                }
                return (
                  n === void 0 &&
                    console.error(
                      '%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.',
                      Q(t) || 'Component'
                    ),
                  n
                );
              }
              return t.prototype && t.prototype.isPureReactComponent
                ? !Ps(n, a) || !Ps(s, c)
                : !0;
            }
            function Dg(e, t, n, a) {
              var s = t.state;
              (typeof t.componentWillReceiveProps == 'function' &&
                t.componentWillReceiveProps(n, a),
                typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
                  t.UNSAFE_componentWillReceiveProps(n, a),
                t.state !== s &&
                  ((e = J(e) || 'Component'),
                  Kv.has(e) ||
                    (Kv.add(e),
                    console.error(
                      "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                      e
                    )),
                  Am.enqueueReplaceState(t, t.state, null)));
            }
            function Ki(e, t) {
              var n = t;
              if ('ref' in t) {
                n = {};
                for (var a in t) a !== 'ref' && (n[a] = t[a]);
              }
              if ((e = e.defaultProps)) {
                n === t && (n = Re({}, n));
                for (var s in e) n[s] === void 0 && (n[s] = e[s]);
              }
              return n;
            }
            function Tg(e) {
              (Rm(e),
                console.warn(
                  `%s

%s
`,
                  gs
                    ? 'An error occurred in the <' + gs + '> component.'
                    : 'An error occurred in one of your React components.',
                  `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://react.dev/link/error-boundaries to learn more about error boundaries.`
                ));
            }
            function Cg(e) {
              var t = gs
                  ? 'The above error occurred in the <' + gs + '> component.'
                  : 'The above error occurred in one of your React components.',
                n =
                  'React will try to recreate this component tree from scratch using the error boundary you provided, ' +
                  ((Mm || 'Anonymous') + '.');
              if (
                typeof e == 'object' &&
                e !== null &&
                typeof e.environmentName == 'string'
              ) {
                var a = e.environmentName;
                ((e = [
                  `%o

%s

%s
`,
                  e,
                  t,
                  n,
                ].slice(0)),
                  typeof e[0] == 'string'
                    ? e.splice(0, 1, H1 + e[0], U1, uu + a + uu, I1)
                    : e.splice(0, 0, H1, U1, uu + a + uu, I1),
                  e.unshift(console),
                  (a = Hw.apply(console.error, e)),
                  a());
              } else
                console.error(
                  `%o

%s

%s
`,
                  e,
                  t,
                  n
                );
            }
            function Ag(e) {
              Rm(e);
            }
            function nc(e, t) {
              try {
                ((gs = t.source ? J(t.source) : null), (Mm = null));
                var n = t.value;
                if (z.actQueue !== null) z.thrownErrors.push(n);
                else {
                  var a = e.onUncaughtError;
                  a(n, { componentStack: t.stack });
                }
              } catch (s) {
                setTimeout(function () {
                  throw s;
                });
              }
            }
            function Rg(e, t, n) {
              try {
                ((gs = n.source ? J(n.source) : null), (Mm = J(t)));
                var a = e.onCaughtError;
                a(n.value, {
                  componentStack: n.stack,
                  errorBoundary: t.tag === 1 ? t.stateNode : null,
                });
              } catch (s) {
                setTimeout(function () {
                  throw s;
                });
              }
            }
            function Ud(e, t, n) {
              return (
                (n = ni(n)),
                (n.tag = vm),
                (n.payload = { element: null }),
                (n.callback = function () {
                  he(t.source, nc, e, t);
                }),
                n
              );
            }
            function Id(e) {
              return ((e = ni(e)), (e.tag = vm), e);
            }
            function Wd(e, t, n, a) {
              var s = n.type.getDerivedStateFromError;
              if (typeof s == 'function') {
                var c = a.value;
                ((e.payload = function () {
                  return s(c);
                }),
                  (e.callback = function () {
                    (Mh(n), he(a.source, Rg, t, n, a));
                  }));
              }
              var f = n.stateNode;
              f !== null &&
                typeof f.componentDidCatch == 'function' &&
                (e.callback = function () {
                  (Mh(n),
                    he(a.source, Rg, t, n, a),
                    typeof s != 'function' &&
                      (wi === null ? (wi = new Set([this])) : wi.add(this)),
                    gw(this, a),
                    typeof s == 'function' ||
                      ((n.lanes & 2) === 0 &&
                        console.error(
                          '%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.',
                          J(n) || 'Unknown'
                        )));
                });
            }
            function QS(e, t, n, a, s) {
              if (
                ((n.flags |= 32768),
                Xn && uo(e, s),
                a !== null &&
                  typeof a == 'object' &&
                  typeof a.then == 'function')
              ) {
                if (
                  ((t = n.alternate),
                  t !== null && Xs(t, n, s, !0),
                  He && (za = !0),
                  (n = Un.current),
                  n !== null)
                ) {
                  switch (n.tag) {
                    case 13:
                      return (
                        ga === null
                          ? rf()
                          : n.alternate === null && ct === Wa && (ct = jm),
                        (n.flags &= -257),
                        (n.flags |= 65536),
                        (n.lanes = s),
                        a === ym
                          ? (n.flags |= 16384)
                          : ((t = n.updateQueue),
                            t === null
                              ? (n.updateQueue = new Set([a]))
                              : t.add(a),
                            df(e, a, s)),
                        !1
                      );
                    case 22:
                      return (
                        (n.flags |= 65536),
                        a === ym
                          ? (n.flags |= 16384)
                          : ((t = n.updateQueue),
                            t === null
                              ? ((t = {
                                  transitions: null,
                                  markerInstances: null,
                                  retryQueue: new Set([a]),
                                }),
                                (n.updateQueue = t))
                              : ((n = t.retryQueue),
                                n === null
                                  ? (t.retryQueue = new Set([a]))
                                  : n.add(a)),
                            df(e, a, s)),
                        !1
                      );
                  }
                  throw Error(
                    'Unexpected Suspense handler tag (' +
                      n.tag +
                      '). This is a bug in React.'
                  );
                }
                return (df(e, a, s), rf(), !1);
              }
              if (He)
                return (
                  (za = !0),
                  (t = Un.current),
                  t !== null
                    ? ((t.flags & 65536) === 0 && (t.flags |= 256),
                      (t.flags |= 65536),
                      (t.lanes = s),
                      a !== pm &&
                        Ys(
                          fn(
                            Error(
                              'There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.',
                              { cause: a }
                            ),
                            n
                          )
                        ))
                    : (a !== pm &&
                        Ys(
                          fn(
                            Error(
                              'There was an error while hydrating but React was able to recover by instead client rendering the entire root.',
                              { cause: a }
                            ),
                            n
                          )
                        ),
                      (e = e.current.alternate),
                      (e.flags |= 65536),
                      (s &= -s),
                      (e.lanes |= s),
                      (a = fn(a, n)),
                      (s = Ud(e.stateNode, a, s)),
                      Hr(e, s),
                      ct !== cl && (ct = Ss)),
                  !1
                );
              var c = fn(
                Error(
                  'There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.',
                  { cause: a }
                ),
                n
              );
              if (
                (Zo === null ? (Zo = [c]) : Zo.push(c),
                ct !== cl && (ct = Ss),
                t === null)
              )
                return !0;
              ((a = fn(a, n)), (n = t));
              do {
                switch (n.tag) {
                  case 3:
                    return (
                      (n.flags |= 65536),
                      (e = s & -s),
                      (n.lanes |= e),
                      (e = Ud(n.stateNode, a, e)),
                      Hr(n, e),
                      !1
                    );
                  case 1:
                    if (
                      ((t = n.type),
                      (c = n.stateNode),
                      (n.flags & 128) === 0 &&
                        (typeof t.getDerivedStateFromError == 'function' ||
                          (c !== null &&
                            typeof c.componentDidCatch == 'function' &&
                            (wi === null || !wi.has(c)))))
                    )
                      return (
                        (n.flags |= 65536),
                        (s &= -s),
                        (n.lanes |= s),
                        (s = Id(s)),
                        Wd(s, e, n, a),
                        Hr(n, s),
                        !1
                      );
                }
                n = n.return;
              } while (n !== null);
              return !1;
            }
            function kt(e, t, n, a) {
              t.child = e === null ? Zv(t, null, n, a) : ps(t, e.child, n, a);
            }
            function Mg(e, t, n, a, s) {
              n = n.render;
              var c = t.ref;
              if ('ref' in a) {
                var f = {};
                for (var b in a) b !== 'ref' && (f[b] = a[b]);
              } else f = a;
              return (
                Yi(t),
                Mt(t),
                (a = md(e, t, n, f, c, s)),
                (b = hd()),
                Dn(),
                e !== null && !Ct
                  ? (gd(e, t, s), Ca(e, t, s))
                  : (He && b && Ju(t), (t.flags |= 1), kt(e, t, a, s), t.child)
              );
            }
            function Og(e, t, n, a, s) {
              if (e === null) {
                var c = n.type;
                return typeof c == 'function' &&
                  !Qu(c) &&
                  c.defaultProps === void 0 &&
                  n.compare === null
                  ? ((n = Ii(c)),
                    (t.tag = 15),
                    (t.type = n),
                    Pd(t, c),
                    kg(e, t, n, a, s))
                  : ((e = Zu(n.type, null, a, t, t.mode, s)),
                    (e.ref = t.ref),
                    (e.return = t),
                    (t.child = e));
              }
              if (((c = e.child), !Zd(e, s))) {
                var f = c.memoizedProps;
                if (
                  ((n = n.compare),
                  (n = n !== null ? n : Ps),
                  n(f, a) && e.ref === t.ref)
                )
                  return Ca(e, t, s);
              }
              return (
                (t.flags |= 1),
                (e = wa(c, a)),
                (e.ref = t.ref),
                (e.return = t),
                (t.child = e)
              );
            }
            function kg(e, t, n, a, s) {
              if (e !== null) {
                var c = e.memoizedProps;
                if (Ps(c, a) && e.ref === t.ref && t.type === e.type)
                  if (((Ct = !1), (t.pendingProps = a = c), Zd(e, s)))
                    (e.flags & 131072) !== 0 && (Ct = !0);
                  else return ((t.lanes = e.lanes), Ca(e, t, s));
              }
              return $d(e, t, n, a, s);
            }
            function _g(e, t, n) {
              var a = t.pendingProps,
                s = a.children,
                c = e !== null ? e.memoizedState : null;
              if (a.mode === 'hidden') {
                if ((t.flags & 128) !== 0) {
                  if (((a = c !== null ? c.baseLanes | n : n), e !== null)) {
                    for (s = t.child = e.child, c = 0; s !== null; )
                      ((c = c | s.lanes | s.childLanes), (s = s.sibling));
                    t.childLanes = c & ~a;
                  } else ((t.childLanes = 0), (t.child = null));
                  return jg(e, t, a, n);
                }
                if ((n & 536870912) !== 0)
                  ((t.memoizedState = { baseLanes: 0, cachePool: null }),
                    e !== null && Lr(t, c !== null ? c.cachePool : null),
                    c !== null ? Xh(t, c) : ud(t),
                    wg(t));
                else
                  return (
                    (t.lanes = t.childLanes = 536870912),
                    jg(e, t, c !== null ? c.baseLanes | n : n, n)
                  );
              } else
                c !== null
                  ? (Lr(t, c.cachePool),
                    Xh(t, c),
                    si(t),
                    (t.memoizedState = null))
                  : (e !== null && Lr(t, null), ud(t), si(t));
              return (kt(e, t, s, n), t.child);
            }
            function jg(e, t, n, a) {
              var s = od();
              return (
                (s = s === null ? null : { parent: xt._currentValue, pool: s }),
                (t.memoizedState = { baseLanes: n, cachePool: s }),
                e !== null && Lr(t, null),
                ud(t),
                wg(t),
                e !== null && Xs(e, t, a, !0),
                null
              );
            }
            function ac(e, t) {
              var n = t.ref;
              if (n === null)
                e !== null && e.ref !== null && (t.flags |= 4194816);
              else {
                if (typeof n != 'function' && typeof n != 'object')
                  throw Error(
                    'Expected ref to be a function, an object returned by React.createRef(), or undefined/null.'
                  );
                (e === null || e.ref !== n) && (t.flags |= 4194816);
              }
            }
            function $d(e, t, n, a, s) {
              if (n.prototype && typeof n.prototype.render == 'function') {
                var c = Q(n) || 'Unknown';
                c1[c] ||
                  (console.error(
                    "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
                    c,
                    c
                  ),
                  (c1[c] = !0));
              }
              return (
                t.mode & It && Zn.recordLegacyContextWarning(t, null),
                e === null &&
                  (Pd(t, t.type),
                  n.contextTypes &&
                    ((c = Q(n) || 'Unknown'),
                    d1[c] ||
                      ((d1[c] = !0),
                      console.error(
                        '%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)',
                        c
                      )))),
                Yi(t),
                Mt(t),
                (n = md(e, t, n, a, void 0, s)),
                (a = hd()),
                Dn(),
                e !== null && !Ct
                  ? (gd(e, t, s), Ca(e, t, s))
                  : (He && a && Ju(t), (t.flags |= 1), kt(e, t, n, s), t.child)
              );
            }
            function Vg(e, t, n, a, s, c) {
              return (
                Yi(t),
                Mt(t),
                (Ua = -1),
                (Io = e !== null && e.type !== t.type),
                (t.updateQueue = null),
                (n = pd(t, a, n, s)),
                Qh(e, t),
                (a = hd()),
                Dn(),
                e !== null && !Ct
                  ? (gd(e, t, c), Ca(e, t, c))
                  : (He && a && Ju(t), (t.flags |= 1), kt(e, t, n, c), t.child)
              );
            }
            function Bg(e, t, n, a, s) {
              switch (p(t)) {
                case !1:
                  var c = t.stateNode,
                    f = new t.type(t.memoizedProps, c.context).state;
                  c.updater.enqueueSetState(c, f, null);
                  break;
                case !0:
                  ((t.flags |= 128),
                    (t.flags |= 65536),
                    (c = Error('Simulated error coming from DevTools')));
                  var b = s & -s;
                  if (((t.lanes |= b), (f = Ze), f === null))
                    throw Error(
                      'Expected a work-in-progress root. This is a bug in React. Please file an issue.'
                    );
                  ((b = Id(b)), Wd(b, f, t, fn(c, t)), Hr(t, b));
              }
              if ((Yi(t), t.stateNode === null)) {
                if (
                  ((f = gi),
                  (c = n.contextType),
                  'contextType' in n &&
                    c !== null &&
                    (c === void 0 || c.$$typeof !== ra) &&
                    !s1.has(n) &&
                    (s1.add(n),
                    (b =
                      c === void 0
                        ? ' However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.'
                        : typeof c != 'object'
                          ? ' However, it is set to a ' + typeof c + '.'
                          : c.$$typeof === zf
                            ? ' Did you accidentally pass the Context.Consumer instead?'
                            : ' However, it is set to an object with keys {' +
                              Object.keys(c).join(', ') +
                              '}.'),
                    console.error(
                      '%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s',
                      Q(n) || 'Component',
                      b
                    )),
                  typeof c == 'object' && c !== null && (f = tt(c)),
                  (c = new n(a, f)),
                  t.mode & It)
                ) {
                  Le(!0);
                  try {
                    c = new n(a, f);
                  } finally {
                    Le(!1);
                  }
                }
                if (
                  ((f = t.memoizedState =
                    c.state !== null && c.state !== void 0 ? c.state : null),
                  (c.updater = Am),
                  (t.stateNode = c),
                  (c._reactInternals = t),
                  (c._reactInternalInstance = Fv),
                  typeof n.getDerivedStateFromProps == 'function' &&
                    f === null &&
                    ((f = Q(n) || 'Component'),
                    Jv.has(f) ||
                      (Jv.add(f),
                      console.error(
                        '`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.',
                        f,
                        c.state === null ? 'null' : 'undefined',
                        f
                      ))),
                  typeof n.getDerivedStateFromProps == 'function' ||
                    typeof c.getSnapshotBeforeUpdate == 'function')
                ) {
                  var w = (b = f = null);
                  if (
                    (typeof c.componentWillMount == 'function' &&
                    c.componentWillMount.__suppressDeprecationWarning !== !0
                      ? (f = 'componentWillMount')
                      : typeof c.UNSAFE_componentWillMount == 'function' &&
                        (f = 'UNSAFE_componentWillMount'),
                    typeof c.componentWillReceiveProps == 'function' &&
                    c.componentWillReceiveProps.__suppressDeprecationWarning !==
                      !0
                      ? (b = 'componentWillReceiveProps')
                      : typeof c.UNSAFE_componentWillReceiveProps ==
                          'function' &&
                        (b = 'UNSAFE_componentWillReceiveProps'),
                    typeof c.componentWillUpdate == 'function' &&
                    c.componentWillUpdate.__suppressDeprecationWarning !== !0
                      ? (w = 'componentWillUpdate')
                      : typeof c.UNSAFE_componentWillUpdate == 'function' &&
                        (w = 'UNSAFE_componentWillUpdate'),
                    f !== null || b !== null || w !== null)
                  ) {
                    c = Q(n) || 'Component';
                    var T =
                      typeof n.getDerivedStateFromProps == 'function'
                        ? 'getDerivedStateFromProps()'
                        : 'getSnapshotBeforeUpdate()';
                    t1.has(c) ||
                      (t1.add(c),
                      console.error(
                        `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
                        c,
                        T,
                        f !== null
                          ? `
  ` + f
                          : '',
                        b !== null
                          ? `
  ` + b
                          : '',
                        w !== null
                          ? `
  ` + w
                          : ''
                      ));
                  }
                }
                ((c = t.stateNode),
                  (f = Q(n) || 'Component'),
                  c.render ||
                    (n.prototype && typeof n.prototype.render == 'function'
                      ? console.error(
                          'No `render` method found on the %s instance: did you accidentally return an object from the constructor?',
                          f
                        )
                      : console.error(
                          'No `render` method found on the %s instance: you may have forgotten to define `render`.',
                          f
                        )),
                  !c.getInitialState ||
                    c.getInitialState.isReactClassApproved ||
                    c.state ||
                    console.error(
                      'getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?',
                      f
                    ),
                  c.getDefaultProps &&
                    !c.getDefaultProps.isReactClassApproved &&
                    console.error(
                      'getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.',
                      f
                    ),
                  c.contextType &&
                    console.error(
                      'contextType was defined as an instance property on %s. Use a static property to define contextType instead.',
                      f
                    ),
                  n.childContextTypes &&
                    !l1.has(n) &&
                    (l1.add(n),
                    console.error(
                      '%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)',
                      f
                    )),
                  n.contextTypes &&
                    !i1.has(n) &&
                    (i1.add(n),
                    console.error(
                      '%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)',
                      f
                    )),
                  typeof c.componentShouldUpdate == 'function' &&
                    console.error(
                      '%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.',
                      f
                    ),
                  n.prototype &&
                    n.prototype.isPureReactComponent &&
                    typeof c.shouldComponentUpdate < 'u' &&
                    console.error(
                      '%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.',
                      Q(n) || 'A pure component'
                    ),
                  typeof c.componentDidUnmount == 'function' &&
                    console.error(
                      '%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?',
                      f
                    ),
                  typeof c.componentDidReceiveProps == 'function' &&
                    console.error(
                      '%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().',
                      f
                    ),
                  typeof c.componentWillRecieveProps == 'function' &&
                    console.error(
                      '%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
                      f
                    ),
                  typeof c.UNSAFE_componentWillRecieveProps == 'function' &&
                    console.error(
                      '%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?',
                      f
                    ),
                  (b = c.props !== a),
                  c.props !== void 0 &&
                    b &&
                    console.error(
                      "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
                      f
                    ),
                  c.defaultProps &&
                    console.error(
                      'Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.',
                      f,
                      f
                    ),
                  typeof c.getSnapshotBeforeUpdate != 'function' ||
                    typeof c.componentDidUpdate == 'function' ||
                    e1.has(n) ||
                    (e1.add(n),
                    console.error(
                      '%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.',
                      Q(n)
                    )),
                  typeof c.getDerivedStateFromProps == 'function' &&
                    console.error(
                      '%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.',
                      f
                    ),
                  typeof c.getDerivedStateFromError == 'function' &&
                    console.error(
                      '%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.',
                      f
                    ),
                  typeof n.getSnapshotBeforeUpdate == 'function' &&
                    console.error(
                      '%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.',
                      f
                    ),
                  (b = c.state) &&
                    (typeof b != 'object' || jt(b)) &&
                    console.error(
                      '%s.state: must be set to an object or null',
                      f
                    ),
                  typeof c.getChildContext == 'function' &&
                    typeof n.childContextTypes != 'object' &&
                    console.error(
                      '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().',
                      f
                    ),
                  (c = t.stateNode),
                  (c.props = a),
                  (c.state = t.memoizedState),
                  (c.refs = {}),
                  rd(t),
                  (f = n.contextType),
                  (c.context = typeof f == 'object' && f !== null ? tt(f) : gi),
                  c.state === a &&
                    ((f = Q(n) || 'Component'),
                    n1.has(f) ||
                      (n1.add(f),
                      console.error(
                        "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
                        f
                      ))),
                  t.mode & It && Zn.recordLegacyContextWarning(t, c),
                  Zn.recordUnsafeLifecycleWarnings(t, c),
                  (c.state = t.memoizedState),
                  (f = n.getDerivedStateFromProps),
                  typeof f == 'function' &&
                    (Hd(t, n, f, a), (c.state = t.memoizedState)),
                  typeof n.getDerivedStateFromProps == 'function' ||
                    typeof c.getSnapshotBeforeUpdate == 'function' ||
                    (typeof c.UNSAFE_componentWillMount != 'function' &&
                      typeof c.componentWillMount != 'function') ||
                    ((f = c.state),
                    typeof c.componentWillMount == 'function' &&
                      c.componentWillMount(),
                    typeof c.UNSAFE_componentWillMount == 'function' &&
                      c.UNSAFE_componentWillMount(),
                    f !== c.state &&
                      (console.error(
                        "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
                        J(t) || 'Component'
                      ),
                      Am.enqueueReplaceState(c, c.state, null)),
                    Js(t, a, c, s),
                    Ks(),
                    (c.state = t.memoizedState)),
                  typeof c.componentDidMount == 'function' &&
                    (t.flags |= 4194308),
                  (t.mode & Qn) !== Ke && (t.flags |= 134217728),
                  (c = !0));
              } else if (e === null) {
                c = t.stateNode;
                var j = t.memoizedProps;
                ((b = Ki(n, j)), (c.props = b));
                var H = c.context;
                ((w = n.contextType),
                  (f = gi),
                  typeof w == 'object' && w !== null && (f = tt(w)),
                  (T = n.getDerivedStateFromProps),
                  (w =
                    typeof T == 'function' ||
                    typeof c.getSnapshotBeforeUpdate == 'function'),
                  (j = t.pendingProps !== j),
                  w ||
                    (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                      typeof c.componentWillReceiveProps != 'function') ||
                    ((j || H !== f) && Dg(t, c, a, f)),
                  (bi = !1));
                var _ = t.memoizedState;
                ((c.state = _),
                  Js(t, a, c, s),
                  Ks(),
                  (H = t.memoizedState),
                  j || _ !== H || bi
                    ? (typeof T == 'function' &&
                        (Hd(t, n, T, a), (H = t.memoizedState)),
                      (b = bi || Eg(t, n, b, a, _, H, f))
                        ? (w ||
                            (typeof c.UNSAFE_componentWillMount != 'function' &&
                              typeof c.componentWillMount != 'function') ||
                            (typeof c.componentWillMount == 'function' &&
                              c.componentWillMount(),
                            typeof c.UNSAFE_componentWillMount == 'function' &&
                              c.UNSAFE_componentWillMount()),
                          typeof c.componentDidMount == 'function' &&
                            (t.flags |= 4194308),
                          (t.mode & Qn) !== Ke && (t.flags |= 134217728))
                        : (typeof c.componentDidMount == 'function' &&
                            (t.flags |= 4194308),
                          (t.mode & Qn) !== Ke && (t.flags |= 134217728),
                          (t.memoizedProps = a),
                          (t.memoizedState = H)),
                      (c.props = a),
                      (c.state = H),
                      (c.context = f),
                      (c = b))
                    : (typeof c.componentDidMount == 'function' &&
                        (t.flags |= 4194308),
                      (t.mode & Qn) !== Ke && (t.flags |= 134217728),
                      (c = !1)));
              } else {
                ((c = t.stateNode),
                  cd(e, t),
                  (f = t.memoizedProps),
                  (w = Ki(n, f)),
                  (c.props = w),
                  (T = t.pendingProps),
                  (_ = c.context),
                  (H = n.contextType),
                  (b = gi),
                  typeof H == 'object' && H !== null && (b = tt(H)),
                  (j = n.getDerivedStateFromProps),
                  (H =
                    typeof j == 'function' ||
                    typeof c.getSnapshotBeforeUpdate == 'function') ||
                    (typeof c.UNSAFE_componentWillReceiveProps != 'function' &&
                      typeof c.componentWillReceiveProps != 'function') ||
                    ((f !== T || _ !== b) && Dg(t, c, a, b)),
                  (bi = !1),
                  (_ = t.memoizedState),
                  (c.state = _),
                  Js(t, a, c, s),
                  Ks());
                var I = t.memoizedState;
                f !== T ||
                _ !== I ||
                bi ||
                (e !== null && e.dependencies !== null && _r(e.dependencies))
                  ? (typeof j == 'function' &&
                      (Hd(t, n, j, a), (I = t.memoizedState)),
                    (w =
                      bi ||
                      Eg(t, n, w, a, _, I, b) ||
                      (e !== null &&
                        e.dependencies !== null &&
                        _r(e.dependencies)))
                      ? (H ||
                          (typeof c.UNSAFE_componentWillUpdate != 'function' &&
                            typeof c.componentWillUpdate != 'function') ||
                          (typeof c.componentWillUpdate == 'function' &&
                            c.componentWillUpdate(a, I, b),
                          typeof c.UNSAFE_componentWillUpdate == 'function' &&
                            c.UNSAFE_componentWillUpdate(a, I, b)),
                        typeof c.componentDidUpdate == 'function' &&
                          (t.flags |= 4),
                        typeof c.getSnapshotBeforeUpdate == 'function' &&
                          (t.flags |= 1024))
                      : (typeof c.componentDidUpdate != 'function' ||
                          (f === e.memoizedProps && _ === e.memoizedState) ||
                          (t.flags |= 4),
                        typeof c.getSnapshotBeforeUpdate != 'function' ||
                          (f === e.memoizedProps && _ === e.memoizedState) ||
                          (t.flags |= 1024),
                        (t.memoizedProps = a),
                        (t.memoizedState = I)),
                    (c.props = a),
                    (c.state = I),
                    (c.context = b),
                    (c = w))
                  : (typeof c.componentDidUpdate != 'function' ||
                      (f === e.memoizedProps && _ === e.memoizedState) ||
                      (t.flags |= 4),
                    typeof c.getSnapshotBeforeUpdate != 'function' ||
                      (f === e.memoizedProps && _ === e.memoizedState) ||
                      (t.flags |= 1024),
                    (c = !1));
              }
              if (((b = c), ac(e, t), (f = (t.flags & 128) !== 0), b || f)) {
                if (
                  ((b = t.stateNode),
                  Vu(t),
                  f && typeof n.getDerivedStateFromError != 'function')
                )
                  ((n = null), (ln = -1));
                else {
                  if ((Mt(t), (n = Bv(b)), t.mode & It)) {
                    Le(!0);
                    try {
                      Bv(b);
                    } finally {
                      Le(!1);
                    }
                  }
                  Dn();
                }
                ((t.flags |= 1),
                  e !== null && f
                    ? ((t.child = ps(t, e.child, null, s)),
                      (t.child = ps(t, null, n, s)))
                    : kt(e, t, n, s),
                  (t.memoizedState = b.state),
                  (e = t.child));
              } else e = Ca(e, t, s);
              return (
                (s = t.stateNode),
                c &&
                  s.props !== a &&
                  (bs ||
                    console.error(
                      'It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.',
                      J(t) || 'a component'
                    ),
                  (bs = !0)),
                e
              );
            }
            function Lg(e, t, n, a) {
              return (qs(), (t.flags |= 256), kt(e, t, n, a), t.child);
            }
            function Pd(e, t) {
              (t &&
                t.childContextTypes &&
                console.error(
                  `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
                  t.displayName || t.name || 'Component'
                ),
                typeof t.getDerivedStateFromProps == 'function' &&
                  ((e = Q(t) || 'Unknown'),
                  f1[e] ||
                    (console.error(
                      '%s: Function components do not support getDerivedStateFromProps.',
                      e
                    ),
                    (f1[e] = !0))),
                typeof t.contextType == 'object' &&
                  t.contextType !== null &&
                  ((t = Q(t) || 'Unknown'),
                  u1[t] ||
                    (console.error(
                      '%s: Function components do not support contextType.',
                      t
                    ),
                    (u1[t] = !0))));
            }
            function Gd(e) {
              return { baseLanes: e, cachePool: Uh() };
            }
            function qd(e, t, n) {
              return (
                (e = e !== null ? e.childLanes & ~n : 0),
                t && (e |= Sn),
                e
              );
            }
            function zg(e, t, n) {
              var a,
                s = t.pendingProps;
              d(t) && (t.flags |= 128);
              var c = !1,
                f = (t.flags & 128) !== 0;
              if (
                ((a = f) ||
                  (a =
                    e !== null && e.memoizedState === null
                      ? !1
                      : (wt.current & $o) !== 0),
                a && ((c = !0), (t.flags &= -129)),
                (a = (t.flags & 32) !== 0),
                (t.flags &= -33),
                e === null)
              ) {
                if (He) {
                  if ((c ? li(t) : si(t), He)) {
                    var b = rt,
                      w;
                    if (!(w = !b)) {
                      e: {
                        var T = b;
                        for (w = pa; T.nodeType !== 8; ) {
                          if (!w) {
                            w = null;
                            break e;
                          }
                          if (((T = Mn(T.nextSibling)), T === null)) {
                            w = null;
                            break e;
                          }
                        }
                        w = T;
                      }
                      (w !== null
                        ? (Pi(),
                          (t.memoizedState = {
                            dehydrated: w,
                            treeContext:
                              nl !== null ? { id: Ba, overflow: La } : null,
                            retryLane: 536870912,
                            hydrationErrors: null,
                          }),
                          (T = S(18, null, null, Ke)),
                          (T.stateNode = w),
                          (T.return = t),
                          (t.child = T),
                          (qt = t),
                          (rt = null),
                          (w = !0))
                        : (w = !1),
                        (w = !w));
                    }
                    w && (td(t, b), qi(t));
                  }
                  if (
                    ((b = t.memoizedState),
                    b !== null && ((b = b.dehydrated), b !== null))
                  )
                    return (
                      Tf(b) ? (t.lanes = 32) : (t.lanes = 536870912),
                      null
                    );
                  Ta(t);
                }
                return (
                  (b = s.children),
                  (s = s.fallback),
                  c
                    ? (si(t),
                      (c = t.mode),
                      (b = ic({ mode: 'hidden', children: b }, c)),
                      (s = Wi(s, c, n, null)),
                      (b.return = t),
                      (s.return = t),
                      (b.sibling = s),
                      (t.child = b),
                      (c = t.child),
                      (c.memoizedState = Gd(n)),
                      (c.childLanes = qd(e, a, n)),
                      (t.memoizedState = km),
                      s)
                    : (li(t), Yd(t, b))
                );
              }
              var j = e.memoizedState;
              if (j !== null && ((b = j.dehydrated), b !== null)) {
                if (f)
                  t.flags & 256
                    ? (li(t), (t.flags &= -257), (t = Xd(e, t, n)))
                    : t.memoizedState !== null
                      ? (si(t),
                        (t.child = e.child),
                        (t.flags |= 128),
                        (t = null))
                      : (si(t),
                        (c = s.fallback),
                        (b = t.mode),
                        (s = ic({ mode: 'visible', children: s.children }, b)),
                        (c = Wi(c, b, n, null)),
                        (c.flags |= 2),
                        (s.return = t),
                        (c.return = t),
                        (s.sibling = c),
                        (t.child = s),
                        ps(t, e.child, null, n),
                        (s = t.child),
                        (s.memoizedState = Gd(n)),
                        (s.childLanes = qd(e, a, n)),
                        (t.memoizedState = km),
                        (t = c));
                else if (
                  (li(t),
                  He &&
                    console.error(
                      'We should not be hydrating here. This is a bug in React. Please file a bug.'
                    ),
                  Tf(b))
                ) {
                  if (((a = b.nextSibling && b.nextSibling.dataset), a)) {
                    w = a.dgst;
                    var H = a.msg;
                    T = a.stck;
                    var _ = a.cstck;
                  }
                  ((b = H),
                    (a = w),
                    (s = T),
                    (w = c = _),
                    (c = Error(
                      b ||
                        'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.'
                    )),
                    (c.stack = s || ''),
                    (c.digest = a),
                    (a = w === void 0 ? null : w),
                    (s = { value: c, source: null, stack: a }),
                    typeof a == 'string' && fm.set(c, s),
                    Ys(s),
                    (t = Xd(e, t, n)));
                } else if (
                  (Ct || Xs(e, t, n, !1),
                  (a = (n & e.childLanes) !== 0),
                  Ct || a)
                ) {
                  if (
                    ((a = Ze),
                    a !== null &&
                      ((s = n & -n),
                      (s = (s & 42) !== 0 ? 1 : js(s)),
                      (s = (s & (a.suspendedLanes | n)) !== 0 ? 0 : s),
                      s !== 0 && s !== j.retryLane))
                  )
                    throw ((j.retryLane = s), en(e, s), mt(a, e, s), r1);
                  (b.data === $a || rf(), (t = Xd(e, t, n)));
                } else
                  b.data === $a
                    ? ((t.flags |= 192), (t.child = e.child), (t = null))
                    : ((e = j.treeContext),
                      (rt = Mn(b.nextSibling)),
                      (qt = t),
                      (He = !0),
                      (al = null),
                      (za = !1),
                      (Bn = null),
                      (pa = !1),
                      e !== null &&
                        (Pi(),
                        (jn[Vn++] = Ba),
                        (jn[Vn++] = La),
                        (jn[Vn++] = nl),
                        (Ba = e.id),
                        (La = e.overflow),
                        (nl = t)),
                      (t = Yd(t, s.children)),
                      (t.flags |= 4096));
                return t;
              }
              return c
                ? (si(t),
                  (c = s.fallback),
                  (b = t.mode),
                  (w = e.child),
                  (T = w.sibling),
                  (s = wa(w, { mode: 'hidden', children: s.children })),
                  (s.subtreeFlags = w.subtreeFlags & 65011712),
                  T !== null
                    ? (c = wa(T, c))
                    : ((c = Wi(c, b, n, null)), (c.flags |= 2)),
                  (c.return = t),
                  (s.return = t),
                  (s.sibling = c),
                  (t.child = s),
                  (s = c),
                  (c = t.child),
                  (b = e.child.memoizedState),
                  b === null
                    ? (b = Gd(n))
                    : ((w = b.cachePool),
                      w !== null
                        ? ((T = xt._currentValue),
                          (w = w.parent !== T ? { parent: T, pool: T } : w))
                        : (w = Uh()),
                      (b = { baseLanes: b.baseLanes | n, cachePool: w })),
                  (c.memoizedState = b),
                  (c.childLanes = qd(e, a, n)),
                  (t.memoizedState = km),
                  s)
                : (li(t),
                  (n = e.child),
                  (e = n.sibling),
                  (n = wa(n, { mode: 'visible', children: s.children })),
                  (n.return = t),
                  (n.sibling = null),
                  e !== null &&
                    ((a = t.deletions),
                    a === null
                      ? ((t.deletions = [e]), (t.flags |= 16))
                      : a.push(e)),
                  (t.child = n),
                  (t.memoizedState = null),
                  n);
            }
            function Yd(e, t) {
              return (
                (t = ic({ mode: 'visible', children: t }, e.mode)),
                (t.return = e),
                (e.child = t)
              );
            }
            function ic(e, t) {
              return (
                (e = S(22, e, null, t)),
                (e.lanes = 0),
                (e.stateNode = {
                  _visibility: kc,
                  _pendingMarkers: null,
                  _retryCache: null,
                  _transitions: null,
                }),
                e
              );
            }
            function Xd(e, t, n) {
              return (
                ps(t, e.child, null, n),
                (e = Yd(t, t.pendingProps.children)),
                (e.flags |= 2),
                (t.memoizedState = null),
                e
              );
            }
            function Hg(e, t, n) {
              e.lanes |= t;
              var a = e.alternate;
              (a !== null && (a.lanes |= t), nd(e.return, t, n));
            }
            function Ug(e, t) {
              var n = jt(e);
              return (
                (e = !n && typeof P(e) == 'function'),
                n || e
                  ? ((n = n ? 'array' : 'iterable'),
                    console.error(
                      'A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>',
                      n,
                      t,
                      n
                    ),
                    !1)
                  : !0
              );
            }
            function Qd(e, t, n, a, s) {
              var c = e.memoizedState;
              c === null
                ? (e.memoizedState = {
                    isBackwards: t,
                    rendering: null,
                    renderingStartTime: 0,
                    last: a,
                    tail: n,
                    tailMode: s,
                  })
                : ((c.isBackwards = t),
                  (c.rendering = null),
                  (c.renderingStartTime = 0),
                  (c.last = a),
                  (c.tail = n),
                  (c.tailMode = s));
            }
            function Ig(e, t, n) {
              var a = t.pendingProps,
                s = a.revealOrder,
                c = a.tail;
              if (
                ((a = a.children),
                s !== void 0 &&
                  s !== 'forwards' &&
                  s !== 'backwards' &&
                  s !== 'together' &&
                  !m1[s])
              )
                if (((m1[s] = !0), typeof s == 'string'))
                  switch (s.toLowerCase()) {
                    case 'together':
                    case 'forwards':
                    case 'backwards':
                      console.error(
                        '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                        s,
                        s.toLowerCase()
                      );
                      break;
                    case 'forward':
                    case 'backward':
                      console.error(
                        '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                        s,
                        s.toLowerCase()
                      );
                      break;
                    default:
                      console.error(
                        '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                        s
                      );
                  }
                else
                  console.error(
                    '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                    s
                  );
              c === void 0 ||
                Om[c] ||
                (c !== 'collapsed' && c !== 'hidden'
                  ? ((Om[c] = !0),
                    console.error(
                      '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
                      c
                    ))
                  : s !== 'forwards' &&
                    s !== 'backwards' &&
                    ((Om[c] = !0),
                    console.error(
                      '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
                      c
                    )));
              e: if (
                (s === 'forwards' || s === 'backwards') &&
                a !== void 0 &&
                a !== null &&
                a !== !1
              )
                if (jt(a)) {
                  for (var f = 0; f < a.length; f++) if (!Ug(a[f], f)) break e;
                } else if (((f = P(a)), typeof f == 'function')) {
                  if ((f = f.call(a)))
                    for (var b = f.next(), w = 0; !b.done; b = f.next()) {
                      if (!Ug(b.value, w)) break e;
                      w++;
                    }
                } else
                  console.error(
                    'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
                    s
                  );
              if ((kt(e, t, a, n), (a = wt.current), (a & $o) !== 0))
                ((a = (a & hs) | $o), (t.flags |= 128));
              else {
                if (e !== null && (e.flags & 128) !== 0)
                  e: for (e = t.child; e !== null; ) {
                    if (e.tag === 13) e.memoizedState !== null && Hg(e, n, t);
                    else if (e.tag === 19) Hg(e, n, t);
                    else if (e.child !== null) {
                      ((e.child.return = e), (e = e.child));
                      continue;
                    }
                    if (e === t) break e;
                    for (; e.sibling === null; ) {
                      if (e.return === null || e.return === t) break e;
                      e = e.return;
                    }
                    ((e.sibling.return = e.return), (e = e.sibling));
                  }
                a &= hs;
              }
              switch ((se(wt, a, t), s)) {
                case 'forwards':
                  for (n = t.child, s = null; n !== null; )
                    ((e = n.alternate),
                      e !== null && tc(e) === null && (s = n),
                      (n = n.sibling));
                  ((n = s),
                    n === null
                      ? ((s = t.child), (t.child = null))
                      : ((s = n.sibling), (n.sibling = null)),
                    Qd(t, !1, s, n, c));
                  break;
                case 'backwards':
                  for (n = null, s = t.child, t.child = null; s !== null; ) {
                    if (((e = s.alternate), e !== null && tc(e) === null)) {
                      t.child = s;
                      break;
                    }
                    ((e = s.sibling), (s.sibling = n), (n = s), (s = e));
                  }
                  Qd(t, !0, n, null, c);
                  break;
                case 'together':
                  Qd(t, !1, null, null, void 0);
                  break;
                default:
                  t.memoizedState = null;
              }
              return t.child;
            }
            function Ca(e, t, n) {
              if (
                (e !== null && (t.dependencies = e.dependencies),
                (ln = -1),
                (xi |= t.lanes),
                (n & t.childLanes) === 0)
              )
                if (e !== null) {
                  if ((Xs(e, t, n, !1), (n & t.childLanes) === 0)) return null;
                } else return null;
              if (e !== null && t.child !== e.child)
                throw Error('Resuming work not yet implemented.');
              if (t.child !== null) {
                for (
                  e = t.child,
                    n = wa(e, e.pendingProps),
                    t.child = n,
                    n.return = t;
                  e.sibling !== null;
                )
                  ((e = e.sibling),
                    (n = n.sibling = wa(e, e.pendingProps)),
                    (n.return = t));
                n.sibling = null;
              }
              return t.child;
            }
            function Zd(e, t) {
              return (e.lanes & t) !== 0
                ? !0
                : ((e = e.dependencies), !!(e !== null && _r(e)));
            }
            function ZS(e, t, n) {
              switch (t.tag) {
                case 3:
                  (we(t, t.stateNode.containerInfo),
                    ti(t, xt, e.memoizedState.cache),
                    qs());
                  break;
                case 27:
                case 5:
                  ce(t);
                  break;
                case 4:
                  we(t, t.stateNode.containerInfo);
                  break;
                case 10:
                  ti(t, t.type, t.memoizedProps.value);
                  break;
                case 12:
                  ((n & t.childLanes) !== 0 && (t.flags |= 4),
                    (t.flags |= 2048));
                  var a = t.stateNode;
                  ((a.effectDuration = -0), (a.passiveEffectDuration = -0));
                  break;
                case 13:
                  if (((a = t.memoizedState), a !== null))
                    return a.dehydrated !== null
                      ? (li(t), (t.flags |= 128), null)
                      : (n & t.child.childLanes) !== 0
                        ? zg(e, t, n)
                        : (li(t),
                          (e = Ca(e, t, n)),
                          e !== null ? e.sibling : null);
                  li(t);
                  break;
                case 19:
                  var s = (e.flags & 128) !== 0;
                  if (
                    ((a = (n & t.childLanes) !== 0),
                    a || (Xs(e, t, n, !1), (a = (n & t.childLanes) !== 0)),
                    s)
                  ) {
                    if (a) return Ig(e, t, n);
                    t.flags |= 128;
                  }
                  if (
                    ((s = t.memoizedState),
                    s !== null &&
                      ((s.rendering = null),
                      (s.tail = null),
                      (s.lastEffect = null)),
                    se(wt, wt.current, t),
                    a)
                  )
                    break;
                  return null;
                case 22:
                case 23:
                  return ((t.lanes = 0), _g(e, t, n));
                case 24:
                  ti(t, xt, e.memoizedState.cache);
              }
              return Ca(e, t, n);
            }
            function Fd(e, t, n) {
              if (t._debugNeedsRemount && e !== null) {
                ((n = Zu(
                  t.type,
                  t.key,
                  t.pendingProps,
                  t._debugOwner || null,
                  t.mode,
                  t.lanes
                )),
                  (n._debugStack = t._debugStack),
                  (n._debugTask = t._debugTask));
                var a = t.return;
                if (a === null) throw Error('Cannot swap the root fiber.');
                if (
                  ((e.alternate = null),
                  (t.alternate = null),
                  (n.index = t.index),
                  (n.sibling = t.sibling),
                  (n.return = t.return),
                  (n.ref = t.ref),
                  (n._debugInfo = t._debugInfo),
                  t === a.child)
                )
                  a.child = n;
                else {
                  var s = a.child;
                  if (s === null)
                    throw Error('Expected parent to have a child.');
                  for (; s.sibling !== t; )
                    if (((s = s.sibling), s === null))
                      throw Error('Expected to find the previous sibling.');
                  s.sibling = n;
                }
                return (
                  (t = a.deletions),
                  t === null
                    ? ((a.deletions = [e]), (a.flags |= 16))
                    : t.push(e),
                  (n.flags |= 2),
                  n
                );
              }
              if (e !== null)
                if (e.memoizedProps !== t.pendingProps || t.type !== e.type)
                  Ct = !0;
                else {
                  if (!Zd(e, n) && (t.flags & 128) === 0)
                    return ((Ct = !1), ZS(e, t, n));
                  Ct = (e.flags & 131072) !== 0;
                }
              else
                ((Ct = !1),
                  (a = He) && (Pi(), (a = (t.flags & 1048576) !== 0)),
                  a && ((a = t.index), Pi(), kh(t, jc, a)));
              switch (((t.lanes = 0), t.tag)) {
                case 16:
                  e: if (
                    ((a = t.pendingProps),
                    (e = vi(t.elementType)),
                    (t.type = e),
                    typeof e == 'function')
                  )
                    Qu(e)
                      ? ((a = Ki(e, a)),
                        (t.tag = 1),
                        (t.type = e = Ii(e)),
                        (t = Bg(null, t, e, a, n)))
                      : ((t.tag = 0),
                        Pd(t, e),
                        (t.type = e = Ii(e)),
                        (t = $d(null, t, e, a, n)));
                  else {
                    if (e != null) {
                      if (((s = e.$$typeof), s === vo)) {
                        ((t.tag = 11),
                          (t.type = e = Yu(e)),
                          (t = Mg(null, t, e, a, n)));
                        break e;
                      } else if (s === xc) {
                        ((t.tag = 14), (t = Og(null, t, e, a, n)));
                        break e;
                      }
                    }
                    throw (
                      (t = ''),
                      e !== null &&
                        typeof e == 'object' &&
                        e.$$typeof === gn &&
                        (t =
                          ' Did you wrap a component in React.lazy() more than once?'),
                      (e = Q(e) || e),
                      Error(
                        'Element type is invalid. Received a promise that resolves to: ' +
                          e +
                          '. Lazy element type must resolve to a class or function.' +
                          t
                      )
                    );
                  }
                  return t;
                case 0:
                  return $d(e, t, t.type, t.pendingProps, n);
                case 1:
                  return (
                    (a = t.type),
                    (s = Ki(a, t.pendingProps)),
                    Bg(e, t, a, s, n)
                  );
                case 3:
                  e: {
                    if ((we(t, t.stateNode.containerInfo), e === null))
                      throw Error(
                        'Should have a current fiber. This is a bug in React.'
                      );
                    a = t.pendingProps;
                    var c = t.memoizedState;
                    ((s = c.element), cd(e, t), Js(t, a, null, n));
                    var f = t.memoizedState;
                    if (
                      ((a = f.cache),
                      ti(t, xt, a),
                      a !== c.cache && ad(t, [xt], n, !0),
                      Ks(),
                      (a = f.element),
                      c.isDehydrated)
                    )
                      if (
                        ((c = { element: a, isDehydrated: !1, cache: f.cache }),
                        (t.updateQueue.baseState = c),
                        (t.memoizedState = c),
                        t.flags & 256)
                      ) {
                        t = Lg(e, t, a, n);
                        break e;
                      } else if (a !== s) {
                        ((s = fn(
                          Error(
                            'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.'
                          ),
                          t
                        )),
                          Ys(s),
                          (t = Lg(e, t, a, n)));
                        break e;
                      } else {
                        switch (((e = t.stateNode.containerInfo), e.nodeType)) {
                          case 9:
                            e = e.body;
                            break;
                          default:
                            e =
                              e.nodeName === 'HTML' ? e.ownerDocument.body : e;
                        }
                        for (
                          rt = Mn(e.firstChild),
                            qt = t,
                            He = !0,
                            al = null,
                            za = !1,
                            Bn = null,
                            pa = !0,
                            e = Zv(t, null, a, n),
                            t.child = e;
                          e;
                        )
                          ((e.flags = (e.flags & -3) | 4096), (e = e.sibling));
                      }
                    else {
                      if ((qs(), a === s)) {
                        t = Ca(e, t, n);
                        break e;
                      }
                      kt(e, t, a, n);
                    }
                    t = t.child;
                  }
                  return t;
                case 26:
                  return (
                    ac(e, t),
                    e === null
                      ? (e = sy(t.type, null, t.pendingProps, null))
                        ? (t.memoizedState = e)
                        : He ||
                          ((e = t.type),
                          (n = t.pendingProps),
                          (a = ge(fi.current)),
                          (a = fc(a).createElement(e)),
                          (a[Ut] = t),
                          (a[an] = n),
                          _t(a, e, n),
                          O(a),
                          (t.stateNode = a))
                      : (t.memoizedState = sy(
                          t.type,
                          e.memoizedProps,
                          t.pendingProps,
                          e.memoizedState
                        )),
                    null
                  );
                case 27:
                  return (
                    ce(t),
                    e === null &&
                      He &&
                      ((a = ge(fi.current)),
                      (s = K()),
                      (a = t.stateNode = iy(t.type, t.pendingProps, a, s, !1)),
                      za ||
                        ((s = Qb(a, t.type, t.pendingProps, s)),
                        s !== null && (Gi(t, 0).serverProps = s)),
                      (qt = t),
                      (pa = !0),
                      (s = rt),
                      ci(t.type)
                        ? ((tp = s), (rt = Mn(a.firstChild)))
                        : (rt = s)),
                    kt(e, t, t.pendingProps.children, n),
                    ac(e, t),
                    e === null && (t.flags |= 4194304),
                    t.child
                  );
                case 5:
                  return (
                    e === null &&
                      He &&
                      ((c = K()),
                      (a = Wu(t.type, c.ancestorInfo)),
                      (s = rt),
                      (f = !s) ||
                        ((f = _x(s, t.type, t.pendingProps, pa)),
                        f !== null
                          ? ((t.stateNode = f),
                            za ||
                              ((c = Qb(f, t.type, t.pendingProps, c)),
                              c !== null && (Gi(t, 0).serverProps = c)),
                            (qt = t),
                            (rt = Mn(f.firstChild)),
                            (pa = !1),
                            (c = !0))
                          : (c = !1),
                        (f = !c)),
                      f && (a && td(t, s), qi(t))),
                    ce(t),
                    (s = t.type),
                    (c = t.pendingProps),
                    (f = e !== null ? e.memoizedProps : null),
                    (a = c.children),
                    Ef(s, c)
                      ? (a = null)
                      : f !== null && Ef(s, f) && (t.flags |= 32),
                    t.memoizedState !== null &&
                      ((s = md(e, t, PS, null, null, n)),
                      (ir._currentValue = s)),
                    ac(e, t),
                    kt(e, t, a, n),
                    t.child
                  );
                case 6:
                  return (
                    e === null &&
                      He &&
                      ((e = t.pendingProps),
                      (n = K()),
                      (a = n.ancestorInfo.current),
                      (e =
                        a != null
                          ? Er(e, a.tag, n.ancestorInfo.implicitRootScope)
                          : !0),
                      (n = rt),
                      (a = !n) ||
                        ((a = jx(n, t.pendingProps, pa)),
                        a !== null
                          ? ((t.stateNode = a), (qt = t), (rt = null), (a = !0))
                          : (a = !1),
                        (a = !a)),
                      a && (e && td(t, n), qi(t))),
                    null
                  );
                case 13:
                  return zg(e, t, n);
                case 4:
                  return (
                    we(t, t.stateNode.containerInfo),
                    (a = t.pendingProps),
                    e === null ? (t.child = ps(t, null, a, n)) : kt(e, t, a, n),
                    t.child
                  );
                case 11:
                  return Mg(e, t, t.type, t.pendingProps, n);
                case 7:
                  return (kt(e, t, t.pendingProps, n), t.child);
                case 8:
                  return (kt(e, t, t.pendingProps.children, n), t.child);
                case 12:
                  return (
                    (t.flags |= 4),
                    (t.flags |= 2048),
                    (a = t.stateNode),
                    (a.effectDuration = -0),
                    (a.passiveEffectDuration = -0),
                    kt(e, t, t.pendingProps.children, n),
                    t.child
                  );
                case 10:
                  return (
                    (a = t.type),
                    (s = t.pendingProps),
                    (c = s.value),
                    'value' in s ||
                      p1 ||
                      ((p1 = !0),
                      console.error(
                        'The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?'
                      )),
                    ti(t, a, c),
                    kt(e, t, s.children, n),
                    t.child
                  );
                case 9:
                  return (
                    (s = t.type._context),
                    (a = t.pendingProps.children),
                    typeof a != 'function' &&
                      console.error(
                        "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
                      ),
                    Yi(t),
                    (s = tt(s)),
                    Mt(t),
                    (a = Dm(a, s, void 0)),
                    Dn(),
                    (t.flags |= 1),
                    kt(e, t, a, n),
                    t.child
                  );
                case 14:
                  return Og(e, t, t.type, t.pendingProps, n);
                case 15:
                  return kg(e, t, t.type, t.pendingProps, n);
                case 19:
                  return Ig(e, t, n);
                case 31:
                  return (
                    (a = t.pendingProps),
                    (n = t.mode),
                    (a = { mode: a.mode, children: a.children }),
                    e === null
                      ? ((e = ic(a, n)),
                        (e.ref = t.ref),
                        (t.child = e),
                        (e.return = t),
                        (t = e))
                      : ((e = wa(e.child, a)),
                        (e.ref = t.ref),
                        (t.child = e),
                        (e.return = t),
                        (t = e)),
                    t
                  );
                case 22:
                  return _g(e, t, n);
                case 24:
                  return (
                    Yi(t),
                    (a = tt(xt)),
                    e === null
                      ? ((s = od()),
                        s === null &&
                          ((s = Ze),
                          (c = id()),
                          (s.pooledCache = c),
                          Xi(c),
                          c !== null && (s.pooledCacheLanes |= n),
                          (s = c)),
                        (t.memoizedState = { parent: a, cache: s }),
                        rd(t),
                        ti(t, xt, s))
                      : ((e.lanes & n) !== 0 &&
                          (cd(e, t), Js(t, null, null, n), Ks()),
                        (s = e.memoizedState),
                        (c = t.memoizedState),
                        s.parent !== a
                          ? ((s = { parent: a, cache: a }),
                            (t.memoizedState = s),
                            t.lanes === 0 &&
                              (t.memoizedState = t.updateQueue.baseState = s),
                            ti(t, xt, a))
                          : ((a = c.cache),
                            ti(t, xt, a),
                            a !== s.cache && ad(t, [xt], n, !0))),
                    kt(e, t, t.pendingProps.children, n),
                    t.child
                  );
                case 29:
                  throw t.pendingProps;
              }
              throw Error(
                'Unknown unit of work tag (' +
                  t.tag +
                  '). This error is likely caused by a bug in React. Please file an issue.'
              );
            }
            function Aa(e) {
              e.flags |= 4;
            }
            function Wg(e, t) {
              if (t.type !== 'stylesheet' || (t.state.loading & In) !== yl)
                e.flags &= -16777217;
              else if (((e.flags |= 16777216), !dy(t))) {
                if (
                  ((t = Un.current),
                  t !== null &&
                    ((_e & 4194048) === _e
                      ? ga !== null
                      : ((_e & 62914560) !== _e && (_e & 536870912) === 0) ||
                        t !== ga))
                )
                  throw ((Ho = ym), Ev);
                e.flags |= 8192;
              }
            }
            function lc(e, t) {
              (t !== null && (e.flags |= 4),
                e.flags & 16384 &&
                  ((t = e.tag !== 22 ? Li() : 536870912),
                  (e.lanes |= t),
                  (fl |= t)));
            }
            function io(e, t) {
              if (!He)
                switch (e.tailMode) {
                  case 'hidden':
                    t = e.tail;
                    for (var n = null; t !== null; )
                      (t.alternate !== null && (n = t), (t = t.sibling));
                    n === null ? (e.tail = null) : (n.sibling = null);
                    break;
                  case 'collapsed':
                    n = e.tail;
                    for (var a = null; n !== null; )
                      (n.alternate !== null && (a = n), (n = n.sibling));
                    a === null
                      ? t || e.tail === null
                        ? (e.tail = null)
                        : (e.tail.sibling = null)
                      : (a.sibling = null);
                }
            }
            function nt(e) {
              var t = e.alternate !== null && e.alternate.child === e.child,
                n = 0,
                a = 0;
              if (t)
                if ((e.mode & Vt) !== Ke) {
                  for (var s = e.selfBaseDuration, c = e.child; c !== null; )
                    ((n |= c.lanes | c.childLanes),
                      (a |= c.subtreeFlags & 65011712),
                      (a |= c.flags & 65011712),
                      (s += c.treeBaseDuration),
                      (c = c.sibling));
                  e.treeBaseDuration = s;
                } else
                  for (s = e.child; s !== null; )
                    ((n |= s.lanes | s.childLanes),
                      (a |= s.subtreeFlags & 65011712),
                      (a |= s.flags & 65011712),
                      (s.return = e),
                      (s = s.sibling));
              else if ((e.mode & Vt) !== Ke) {
                ((s = e.actualDuration), (c = e.selfBaseDuration));
                for (var f = e.child; f !== null; )
                  ((n |= f.lanes | f.childLanes),
                    (a |= f.subtreeFlags),
                    (a |= f.flags),
                    (s += f.actualDuration),
                    (c += f.treeBaseDuration),
                    (f = f.sibling));
                ((e.actualDuration = s), (e.treeBaseDuration = c));
              } else
                for (s = e.child; s !== null; )
                  ((n |= s.lanes | s.childLanes),
                    (a |= s.subtreeFlags),
                    (a |= s.flags),
                    (s.return = e),
                    (s = s.sibling));
              return ((e.subtreeFlags |= a), (e.childLanes = n), t);
            }
            function FS(e, t, n) {
              var a = t.pendingProps;
              switch ((ed(t), t.tag)) {
                case 31:
                case 16:
                case 15:
                case 0:
                case 11:
                case 7:
                case 8:
                case 12:
                case 9:
                case 14:
                  return (nt(t), null);
                case 1:
                  return (nt(t), null);
                case 3:
                  return (
                    (n = t.stateNode),
                    (a = null),
                    e !== null && (a = e.memoizedState.cache),
                    t.memoizedState.cache !== a && (t.flags |= 2048),
                    Ea(xt, t),
                    We(t),
                    n.pendingContext &&
                      ((n.context = n.pendingContext),
                      (n.pendingContext = null)),
                    (e === null || e.child === null) &&
                      (Gs(t)
                        ? (Bh(), Aa(t))
                        : e === null ||
                          (e.memoizedState.isDehydrated &&
                            (t.flags & 256) === 0) ||
                          ((t.flags |= 1024), Vh())),
                    nt(t),
                    null
                  );
                case 26:
                  return (
                    (n = t.memoizedState),
                    e === null
                      ? (Aa(t),
                        n !== null
                          ? (nt(t), Wg(t, n))
                          : (nt(t), (t.flags &= -16777217)))
                      : n
                        ? n !== e.memoizedState
                          ? (Aa(t), nt(t), Wg(t, n))
                          : (nt(t), (t.flags &= -16777217))
                        : (e.memoizedProps !== a && Aa(t),
                          nt(t),
                          (t.flags &= -16777217)),
                    null
                  );
                case 27:
                  (F(t), (n = ge(fi.current)));
                  var s = t.type;
                  if (e !== null && t.stateNode != null)
                    e.memoizedProps !== a && Aa(t);
                  else {
                    if (!a) {
                      if (t.stateNode === null)
                        throw Error(
                          'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.'
                        );
                      return (nt(t), null);
                    }
                    ((e = K()),
                      Gs(t)
                        ? _h(t)
                        : ((e = iy(s, a, n, e, !0)), (t.stateNode = e), Aa(t)));
                  }
                  return (nt(t), null);
                case 5:
                  if ((F(t), (n = t.type), e !== null && t.stateNode != null))
                    e.memoizedProps !== a && Aa(t);
                  else {
                    if (!a) {
                      if (t.stateNode === null)
                        throw Error(
                          'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.'
                        );
                      return (nt(t), null);
                    }
                    if (((s = K()), Gs(t))) _h(t);
                    else {
                      switch (
                        ((e = ge(fi.current)),
                        Wu(n, s.ancestorInfo),
                        (s = s.context),
                        (e = fc(e)),
                        s)
                      ) {
                        case Ts:
                          e = e.createElementNS(Ql, n);
                          break;
                        case ou:
                          e = e.createElementNS(Cc, n);
                          break;
                        default:
                          switch (n) {
                            case 'svg':
                              e = e.createElementNS(Ql, n);
                              break;
                            case 'math':
                              e = e.createElementNS(Cc, n);
                              break;
                            case 'script':
                              ((e = e.createElement('div')),
                                (e.innerHTML = '<script><\/script>'),
                                (e = e.removeChild(e.firstChild)));
                              break;
                            case 'select':
                              ((e =
                                typeof a.is == 'string'
                                  ? e.createElement('select', { is: a.is })
                                  : e.createElement('select')),
                                a.multiple
                                  ? (e.multiple = !0)
                                  : a.size && (e.size = a.size));
                              break;
                            default:
                              ((e =
                                typeof a.is == 'string'
                                  ? e.createElement(n, { is: a.is })
                                  : e.createElement(n)),
                                n.indexOf('-') === -1 &&
                                  (n !== n.toLowerCase() &&
                                    console.error(
                                      '<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.',
                                      n
                                    ),
                                  Object.prototype.toString.call(e) !==
                                    '[object HTMLUnknownElement]' ||
                                    _a.call(_1, n) ||
                                    ((_1[n] = !0),
                                    console.error(
                                      'The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.',
                                      n
                                    ))));
                          }
                      }
                      ((e[Ut] = t), (e[an] = a));
                      e: for (s = t.child; s !== null; ) {
                        if (s.tag === 5 || s.tag === 6)
                          e.appendChild(s.stateNode);
                        else if (
                          s.tag !== 4 &&
                          s.tag !== 27 &&
                          s.child !== null
                        ) {
                          ((s.child.return = s), (s = s.child));
                          continue;
                        }
                        if (s === t) break e;
                        for (; s.sibling === null; ) {
                          if (s.return === null || s.return === t) break e;
                          s = s.return;
                        }
                        ((s.sibling.return = s.return), (s = s.sibling));
                      }
                      t.stateNode = e;
                      e: switch ((_t(e, n, a), n)) {
                        case 'button':
                        case 'input':
                        case 'select':
                        case 'textarea':
                          e = !!a.autoFocus;
                          break e;
                        case 'img':
                          e = !0;
                          break e;
                        default:
                          e = !1;
                      }
                      e && Aa(t);
                    }
                  }
                  return (nt(t), (t.flags &= -16777217), null);
                case 6:
                  if (e && t.stateNode != null) e.memoizedProps !== a && Aa(t);
                  else {
                    if (typeof a != 'string' && t.stateNode === null)
                      throw Error(
                        'We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.'
                      );
                    if (((e = ge(fi.current)), (n = K()), Gs(t))) {
                      ((e = t.stateNode),
                        (n = t.memoizedProps),
                        (s = !za),
                        (a = null));
                      var c = qt;
                      if (c !== null)
                        switch (c.tag) {
                          case 3:
                            s &&
                              ((s = ty(e, n, a)),
                              s !== null && (Gi(t, 0).serverProps = s));
                            break;
                          case 27:
                          case 5:
                            ((a = c.memoizedProps),
                              s &&
                                ((s = ty(e, n, a)),
                                s !== null && (Gi(t, 0).serverProps = s)));
                        }
                      ((e[Ut] = t),
                        (e = !!(
                          e.nodeValue === n ||
                          (a !== null && a.suppressHydrationWarning === !0) ||
                          Pb(e.nodeValue, n)
                        )),
                        e || qi(t));
                    } else
                      ((s = n.ancestorInfo.current),
                        s != null &&
                          Er(a, s.tag, n.ancestorInfo.implicitRootScope),
                        (e = fc(e).createTextNode(a)),
                        (e[Ut] = t),
                        (t.stateNode = e));
                  }
                  return (nt(t), null);
                case 13:
                  if (
                    ((a = t.memoizedState),
                    e === null ||
                      (e.memoizedState !== null &&
                        e.memoizedState.dehydrated !== null))
                  ) {
                    if (((s = Gs(t)), a !== null && a.dehydrated !== null)) {
                      if (e === null) {
                        if (!s)
                          throw Error(
                            'A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.'
                          );
                        if (
                          ((s = t.memoizedState),
                          (s = s !== null ? s.dehydrated : null),
                          !s)
                        )
                          throw Error(
                            'Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.'
                          );
                        ((s[Ut] = t),
                          nt(t),
                          (t.mode & Vt) !== Ke &&
                            a !== null &&
                            ((s = t.child),
                            s !== null &&
                              (t.treeBaseDuration -= s.treeBaseDuration)));
                      } else
                        (Bh(),
                          qs(),
                          (t.flags & 128) === 0 && (t.memoizedState = null),
                          (t.flags |= 4),
                          nt(t),
                          (t.mode & Vt) !== Ke &&
                            a !== null &&
                            ((s = t.child),
                            s !== null &&
                              (t.treeBaseDuration -= s.treeBaseDuration)));
                      s = !1;
                    } else
                      ((s = Vh()),
                        e !== null &&
                          e.memoizedState !== null &&
                          (e.memoizedState.hydrationErrors = s),
                        (s = !0));
                    if (!s) return t.flags & 256 ? (Ta(t), t) : (Ta(t), null);
                  }
                  return (
                    Ta(t),
                    (t.flags & 128) !== 0
                      ? ((t.lanes = n), (t.mode & Vt) !== Ke && Br(t), t)
                      : ((n = a !== null),
                        (e = e !== null && e.memoizedState !== null),
                        n &&
                          ((a = t.child),
                          (s = null),
                          a.alternate !== null &&
                            a.alternate.memoizedState !== null &&
                            a.alternate.memoizedState.cachePool !== null &&
                            (s = a.alternate.memoizedState.cachePool.pool),
                          (c = null),
                          a.memoizedState !== null &&
                            a.memoizedState.cachePool !== null &&
                            (c = a.memoizedState.cachePool.pool),
                          c !== s && (a.flags |= 2048)),
                        n !== e && n && (t.child.flags |= 8192),
                        lc(t, t.updateQueue),
                        nt(t),
                        (t.mode & Vt) !== Ke &&
                          n &&
                          ((e = t.child),
                          e !== null &&
                            (t.treeBaseDuration -= e.treeBaseDuration)),
                        null)
                  );
                case 4:
                  return (
                    We(t),
                    e === null && bf(t.stateNode.containerInfo),
                    nt(t),
                    null
                  );
                case 10:
                  return (Ea(t.type, t), nt(t), null);
                case 19:
                  if ((q(wt, t), (s = t.memoizedState), s === null))
                    return (nt(t), null);
                  if (
                    ((a = (t.flags & 128) !== 0), (c = s.rendering), c === null)
                  )
                    if (a) io(s, !1);
                    else {
                      if (ct !== Wa || (e !== null && (e.flags & 128) !== 0))
                        for (e = t.child; e !== null; ) {
                          if (((c = tc(e)), c !== null)) {
                            for (
                              t.flags |= 128,
                                io(s, !1),
                                e = c.updateQueue,
                                t.updateQueue = e,
                                lc(t, e),
                                t.subtreeFlags = 0,
                                e = n,
                                n = t.child;
                              n !== null;
                            )
                              (Oh(n, e), (n = n.sibling));
                            return (se(wt, (wt.current & hs) | $o, t), t.child);
                          }
                          e = e.sibling;
                        }
                      s.tail !== null &&
                        ca() > Qc &&
                        ((t.flags |= 128),
                        (a = !0),
                        io(s, !1),
                        (t.lanes = 4194304));
                    }
                  else {
                    if (!a)
                      if (((e = tc(c)), e !== null)) {
                        if (
                          ((t.flags |= 128),
                          (a = !0),
                          (e = e.updateQueue),
                          (t.updateQueue = e),
                          lc(t, e),
                          io(s, !0),
                          s.tail === null &&
                            s.tailMode === 'hidden' &&
                            !c.alternate &&
                            !He)
                        )
                          return (nt(t), null);
                      } else
                        2 * ca() - s.renderingStartTime > Qc &&
                          n !== 536870912 &&
                          ((t.flags |= 128),
                          (a = !0),
                          io(s, !1),
                          (t.lanes = 4194304));
                    s.isBackwards
                      ? ((c.sibling = t.child), (t.child = c))
                      : ((e = s.last),
                        e !== null ? (e.sibling = c) : (t.child = c),
                        (s.last = c));
                  }
                  return s.tail !== null
                    ? ((e = s.tail),
                      (s.rendering = e),
                      (s.tail = e.sibling),
                      (s.renderingStartTime = ca()),
                      (e.sibling = null),
                      (n = wt.current),
                      (n = a ? (n & hs) | $o : n & hs),
                      se(wt, n, t),
                      e)
                    : (nt(t), null);
                case 22:
                case 23:
                  return (
                    Ta(t),
                    dd(t),
                    (a = t.memoizedState !== null),
                    e !== null
                      ? (e.memoizedState !== null) !== a && (t.flags |= 8192)
                      : a && (t.flags |= 8192),
                    a
                      ? (n & 536870912) !== 0 &&
                        (t.flags & 128) === 0 &&
                        (nt(t), t.subtreeFlags & 6 && (t.flags |= 8192))
                      : nt(t),
                    (n = t.updateQueue),
                    n !== null && lc(t, n.retryQueue),
                    (n = null),
                    e !== null &&
                      e.memoizedState !== null &&
                      e.memoizedState.cachePool !== null &&
                      (n = e.memoizedState.cachePool.pool),
                    (a = null),
                    t.memoizedState !== null &&
                      t.memoizedState.cachePool !== null &&
                      (a = t.memoizedState.cachePool.pool),
                    a !== n && (t.flags |= 2048),
                    e !== null && q(sl, t),
                    null
                  );
                case 24:
                  return (
                    (n = null),
                    e !== null && (n = e.memoizedState.cache),
                    t.memoizedState.cache !== n && (t.flags |= 2048),
                    Ea(xt, t),
                    nt(t),
                    null
                  );
                case 25:
                  return null;
                case 30:
                  return null;
              }
              throw Error(
                'Unknown unit of work tag (' +
                  t.tag +
                  '). This error is likely caused by a bug in React. Please file an issue.'
              );
            }
            function KS(e, t) {
              switch ((ed(t), t.tag)) {
                case 1:
                  return (
                    (e = t.flags),
                    e & 65536
                      ? ((t.flags = (e & -65537) | 128),
                        (t.mode & Vt) !== Ke && Br(t),
                        t)
                      : null
                  );
                case 3:
                  return (
                    Ea(xt, t),
                    We(t),
                    (e = t.flags),
                    (e & 65536) !== 0 && (e & 128) === 0
                      ? ((t.flags = (e & -65537) | 128), t)
                      : null
                  );
                case 26:
                case 27:
                case 5:
                  return (F(t), null);
                case 13:
                  if (
                    (Ta(t),
                    (e = t.memoizedState),
                    e !== null && e.dehydrated !== null)
                  ) {
                    if (t.alternate === null)
                      throw Error(
                        'Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.'
                      );
                    qs();
                  }
                  return (
                    (e = t.flags),
                    e & 65536
                      ? ((t.flags = (e & -65537) | 128),
                        (t.mode & Vt) !== Ke && Br(t),
                        t)
                      : null
                  );
                case 19:
                  return (q(wt, t), null);
                case 4:
                  return (We(t), null);
                case 10:
                  return (Ea(t.type, t), null);
                case 22:
                case 23:
                  return (
                    Ta(t),
                    dd(t),
                    e !== null && q(sl, t),
                    (e = t.flags),
                    e & 65536
                      ? ((t.flags = (e & -65537) | 128),
                        (t.mode & Vt) !== Ke && Br(t),
                        t)
                      : null
                  );
                case 24:
                  return (Ea(xt, t), null);
                case 25:
                  return null;
                default:
                  return null;
              }
            }
            function $g(e, t) {
              switch ((ed(t), t.tag)) {
                case 3:
                  (Ea(xt, t), We(t));
                  break;
                case 26:
                case 27:
                case 5:
                  F(t);
                  break;
                case 4:
                  We(t);
                  break;
                case 13:
                  Ta(t);
                  break;
                case 19:
                  q(wt, t);
                  break;
                case 10:
                  Ea(t.type, t);
                  break;
                case 22:
                case 23:
                  (Ta(t), dd(t), e !== null && q(sl, t));
                  break;
                case 24:
                  Ea(xt, t);
              }
            }
            function aa(e) {
              return (e.mode & Vt) !== Ke;
            }
            function Pg(e, t) {
              aa(e) ? (na(), lo(t, e), ta()) : lo(t, e);
            }
            function Kd(e, t, n) {
              aa(e) ? (na(), Vl(n, e, t), ta()) : Vl(n, e, t);
            }
            function lo(e, t) {
              try {
                var n = t.updateQueue,
                  a = n !== null ? n.lastEffect : null;
                if (a !== null) {
                  var s = a.next;
                  n = s;
                  do {
                    if (
                      (n.tag & e) === e &&
                      ((e & Nt) !== Ln
                        ? oe !== null &&
                          typeof oe.markComponentPassiveEffectMountStarted ==
                            'function' &&
                          oe.markComponentPassiveEffectMountStarted(t)
                        : (e & Bt) !== Ln &&
                          oe !== null &&
                          typeof oe.markComponentLayoutEffectMountStarted ==
                            'function' &&
                          oe.markComponentLayoutEffectMountStarted(t),
                      (a = void 0),
                      (e & Yt) !== Ln && (Es = !0),
                      (a = he(t, bw, n)),
                      (e & Yt) !== Ln && (Es = !1),
                      (e & Nt) !== Ln
                        ? oe !== null &&
                          typeof oe.markComponentPassiveEffectMountStopped ==
                            'function' &&
                          oe.markComponentPassiveEffectMountStopped()
                        : (e & Bt) !== Ln &&
                          oe !== null &&
                          typeof oe.markComponentLayoutEffectMountStopped ==
                            'function' &&
                          oe.markComponentLayoutEffectMountStopped(),
                      a !== void 0 && typeof a != 'function')
                    ) {
                      var c = void 0;
                      c =
                        (n.tag & Bt) !== 0
                          ? 'useLayoutEffect'
                          : (n.tag & Yt) !== 0
                            ? 'useInsertionEffect'
                            : 'useEffect';
                      var f = void 0;
                      ((f =
                        a === null
                          ? ' You returned null. If your effect does not require clean up, return undefined (or nothing).'
                          : typeof a.then == 'function'
                            ? `

It looks like you wrote ` +
                              c +
                              `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` +
                              c +
                              `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching`
                            : ' You returned: ' + a),
                        he(
                          t,
                          function (b, w) {
                            console.error(
                              '%s must not return anything besides a function, which is used for clean-up.%s',
                              b,
                              w
                            );
                          },
                          c,
                          f
                        ));
                    }
                    n = n.next;
                  } while (n !== s);
                }
              } catch (b) {
                Ye(t, t.return, b);
              }
            }
            function Vl(e, t, n) {
              try {
                var a = t.updateQueue,
                  s = a !== null ? a.lastEffect : null;
                if (s !== null) {
                  var c = s.next;
                  a = c;
                  do {
                    if ((a.tag & e) === e) {
                      var f = a.inst,
                        b = f.destroy;
                      b !== void 0 &&
                        ((f.destroy = void 0),
                        (e & Nt) !== Ln
                          ? oe !== null &&
                            typeof oe.markComponentPassiveEffectUnmountStarted ==
                              'function' &&
                            oe.markComponentPassiveEffectUnmountStarted(t)
                          : (e & Bt) !== Ln &&
                            oe !== null &&
                            typeof oe.markComponentLayoutEffectUnmountStarted ==
                              'function' &&
                            oe.markComponentLayoutEffectUnmountStarted(t),
                        (e & Yt) !== Ln && (Es = !0),
                        (s = t),
                        he(s, yw, s, n, b),
                        (e & Yt) !== Ln && (Es = !1),
                        (e & Nt) !== Ln
                          ? oe !== null &&
                            typeof oe.markComponentPassiveEffectUnmountStopped ==
                              'function' &&
                            oe.markComponentPassiveEffectUnmountStopped()
                          : (e & Bt) !== Ln &&
                            oe !== null &&
                            typeof oe.markComponentLayoutEffectUnmountStopped ==
                              'function' &&
                            oe.markComponentLayoutEffectUnmountStopped());
                    }
                    a = a.next;
                  } while (a !== c);
                }
              } catch (w) {
                Ye(t, t.return, w);
              }
            }
            function Gg(e, t) {
              aa(e) ? (na(), lo(t, e), ta()) : lo(t, e);
            }
            function Jd(e, t, n) {
              aa(e) ? (na(), Vl(n, e, t), ta()) : Vl(n, e, t);
            }
            function qg(e) {
              var t = e.updateQueue;
              if (t !== null) {
                var n = e.stateNode;
                e.type.defaultProps ||
                  'ref' in e.memoizedProps ||
                  bs ||
                  (n.props !== e.memoizedProps &&
                    console.error(
                      'Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                      J(e) || 'instance'
                    ),
                  n.state !== e.memoizedState &&
                    console.error(
                      'Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                      J(e) || 'instance'
                    ));
                try {
                  he(e, Yh, t, n);
                } catch (a) {
                  Ye(e, e.return, a);
                }
              }
            }
            function JS(e, t, n) {
              return e.getSnapshotBeforeUpdate(t, n);
            }
            function ex(e, t) {
              var n = t.memoizedProps,
                a = t.memoizedState;
              ((t = e.stateNode),
                e.type.defaultProps ||
                  'ref' in e.memoizedProps ||
                  bs ||
                  (t.props !== e.memoizedProps &&
                    console.error(
                      'Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                      J(e) || 'instance'
                    ),
                  t.state !== e.memoizedState &&
                    console.error(
                      'Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                      J(e) || 'instance'
                    )));
              try {
                var s = Ki(e.type, n),
                  c = he(e, JS, t, s, a);
                ((n = h1),
                  c !== void 0 ||
                    n.has(e.type) ||
                    (n.add(e.type),
                    he(e, function () {
                      console.error(
                        '%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.',
                        J(e)
                      );
                    })),
                  (t.__reactInternalSnapshotBeforeUpdate = c));
              } catch (f) {
                Ye(e, e.return, f);
              }
            }
            function Yg(e, t, n) {
              ((n.props = Ki(e.type, e.memoizedProps)),
                (n.state = e.memoizedState),
                aa(e) ? (na(), he(e, Wv, e, t, n), ta()) : he(e, Wv, e, t, n));
            }
            function tx(e) {
              var t = e.ref;
              if (t !== null) {
                switch (e.tag) {
                  case 26:
                  case 27:
                  case 5:
                    var n = e.stateNode;
                    break;
                  case 30:
                    n = e.stateNode;
                    break;
                  default:
                    n = e.stateNode;
                }
                if (typeof t == 'function')
                  if (aa(e))
                    try {
                      (na(), (e.refCleanup = t(n)));
                    } finally {
                      ta();
                    }
                  else e.refCleanup = t(n);
                else
                  (typeof t == 'string'
                    ? console.error('String refs are no longer supported.')
                    : t.hasOwnProperty('current') ||
                      console.error(
                        'Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().',
                        J(e)
                      ),
                    (t.current = n));
              }
            }
            function so(e, t) {
              try {
                he(e, tx, e);
              } catch (n) {
                Ye(e, t, n);
              }
            }
            function ia(e, t) {
              var n = e.ref,
                a = e.refCleanup;
              if (n !== null)
                if (typeof a == 'function')
                  try {
                    if (aa(e))
                      try {
                        (na(), he(e, a));
                      } finally {
                        ta();
                      }
                    else he(e, a);
                  } catch (s) {
                    Ye(e, t, s);
                  } finally {
                    ((e.refCleanup = null),
                      (e = e.alternate),
                      e != null && (e.refCleanup = null));
                  }
                else if (typeof n == 'function')
                  try {
                    if (aa(e))
                      try {
                        (na(), he(e, n, null));
                      } finally {
                        ta();
                      }
                    else he(e, n, null);
                  } catch (s) {
                    Ye(e, t, s);
                  }
                else n.current = null;
            }
            function Xg(e, t, n, a) {
              var s = e.memoizedProps,
                c = s.id,
                f = s.onCommit;
              ((s = s.onRender),
                (t = t === null ? 'mount' : 'update'),
                Lc && (t = 'nested-update'),
                typeof s == 'function' &&
                  s(
                    c,
                    t,
                    e.actualDuration,
                    e.treeBaseDuration,
                    e.actualStartTime,
                    n
                  ),
                typeof f == 'function' && f(e.memoizedProps.id, t, a, n));
            }
            function nx(e, t, n, a) {
              var s = e.memoizedProps;
              ((e = s.id),
                (s = s.onPostCommit),
                (t = t === null ? 'mount' : 'update'),
                Lc && (t = 'nested-update'),
                typeof s == 'function' && s(e, t, a, n));
            }
            function Qg(e) {
              var t = e.type,
                n = e.memoizedProps,
                a = e.stateNode;
              try {
                he(e, Ex, a, t, n, e);
              } catch (s) {
                Ye(e, e.return, s);
              }
            }
            function ef(e, t, n) {
              try {
                he(e, Dx, e.stateNode, e.type, n, t, e);
              } catch (a) {
                Ye(e, e.return, a);
              }
            }
            function Zg(e) {
              return (
                e.tag === 5 ||
                e.tag === 3 ||
                e.tag === 26 ||
                (e.tag === 27 && ci(e.type)) ||
                e.tag === 4
              );
            }
            function tf(e) {
              e: for (;;) {
                for (; e.sibling === null; ) {
                  if (e.return === null || Zg(e.return)) return null;
                  e = e.return;
                }
                for (
                  e.sibling.return = e.return, e = e.sibling;
                  e.tag !== 5 && e.tag !== 6 && e.tag !== 18;
                ) {
                  if (
                    (e.tag === 27 && ci(e.type)) ||
                    e.flags & 2 ||
                    e.child === null ||
                    e.tag === 4
                  )
                    continue e;
                  ((e.child.return = e), (e = e.child));
                }
                if (!(e.flags & 2)) return e.stateNode;
              }
            }
            function nf(e, t, n) {
              var a = e.tag;
              if (a === 5 || a === 6)
                ((e = e.stateNode),
                  t
                    ? (n.nodeType === 9
                        ? n.body
                        : n.nodeName === 'HTML'
                          ? n.ownerDocument.body
                          : n
                      ).insertBefore(e, t)
                    : ((t =
                        n.nodeType === 9
                          ? n.body
                          : n.nodeName === 'HTML'
                            ? n.ownerDocument.body
                            : n),
                      t.appendChild(e),
                      (n = n._reactRootContainer),
                      n != null || t.onclick !== null || (t.onclick = dc)));
              else if (
                a !== 4 &&
                (a === 27 && ci(e.type) && ((n = e.stateNode), (t = null)),
                (e = e.child),
                e !== null)
              )
                for (nf(e, t, n), e = e.sibling; e !== null; )
                  (nf(e, t, n), (e = e.sibling));
            }
            function sc(e, t, n) {
              var a = e.tag;
              if (a === 5 || a === 6)
                ((e = e.stateNode),
                  t ? n.insertBefore(e, t) : n.appendChild(e));
              else if (
                a !== 4 &&
                (a === 27 && ci(e.type) && (n = e.stateNode),
                (e = e.child),
                e !== null)
              )
                for (sc(e, t, n), e = e.sibling; e !== null; )
                  (sc(e, t, n), (e = e.sibling));
            }
            function ax(e) {
              for (var t, n = e.return; n !== null; ) {
                if (Zg(n)) {
                  t = n;
                  break;
                }
                n = n.return;
              }
              if (t == null)
                throw Error(
                  'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.'
                );
              switch (t.tag) {
                case 27:
                  ((t = t.stateNode), (n = tf(e)), sc(e, n, t));
                  break;
                case 5:
                  ((n = t.stateNode),
                    t.flags & 32 && (Kb(n), (t.flags &= -33)),
                    (t = tf(e)),
                    sc(e, t, n));
                  break;
                case 3:
                case 4:
                  ((t = t.stateNode.containerInfo), (n = tf(e)), nf(e, n, t));
                  break;
                default:
                  throw Error(
                    'Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.'
                  );
              }
            }
            function Fg(e) {
              var t = e.stateNode,
                n = e.memoizedProps;
              try {
                he(e, zx, e.type, n, t, e);
              } catch (a) {
                Ye(e, e.return, a);
              }
            }
            function ix(e, t) {
              if (((e = e.containerInfo), (Km = du), (e = Th(e)), Gu(e))) {
                if ('selectionStart' in e)
                  var n = { start: e.selectionStart, end: e.selectionEnd };
                else {
                  n = ((n = e.ownerDocument) && n.defaultView) || window;
                  var a = n.getSelection && n.getSelection();
                  if (a && a.rangeCount !== 0) {
                    n = a.anchorNode;
                    var s = a.anchorOffset,
                      c = a.focusNode;
                    a = a.focusOffset;
                    var f = 0,
                      b = -1,
                      w = -1,
                      T = 0,
                      j = 0,
                      H = e,
                      _ = null;
                    e: for (;;) {
                      for (
                        var I;
                        H !== n || (s !== 0 && H.nodeType !== 3) || (b = f + s),
                          H !== c ||
                            (a !== 0 && H.nodeType !== 3) ||
                            (w = f + a),
                          H.nodeType === 3 && (f += H.nodeValue.length),
                          (I = H.firstChild) !== null;
                      )
                        ((_ = H), (H = I));
                      for (;;) {
                        if (H === e) break e;
                        if (
                          (_ === n && ++T === s && (b = f),
                          _ === c && ++j === a && (w = f),
                          (I = H.nextSibling) !== null)
                        )
                          break;
                        ((H = _), (_ = H.parentNode));
                      }
                      H = I;
                    }
                    n = b === -1 || w === -1 ? null : { start: b, end: w };
                  } else n = null;
                }
                n = n || { start: 0, end: 0 };
              } else n = null;
              for (
                Jm = { focusedElem: e, selectionRange: n }, du = !1, At = t;
                At !== null;
              )
                if (
                  ((t = At),
                  (e = t.child),
                  (t.subtreeFlags & 1024) !== 0 && e !== null)
                )
                  ((e.return = t), (At = e));
                else
                  for (; At !== null; ) {
                    switch (
                      ((e = t = At), (n = e.alternate), (s = e.flags), e.tag)
                    ) {
                      case 0:
                        break;
                      case 11:
                      case 15:
                        break;
                      case 1:
                        (s & 1024) !== 0 && n !== null && ex(e, n);
                        break;
                      case 3:
                        if ((s & 1024) !== 0) {
                          if (
                            ((e = e.stateNode.containerInfo),
                            (n = e.nodeType),
                            n === 9)
                          )
                            Df(e);
                          else if (n === 1)
                            switch (e.nodeName) {
                              case 'HEAD':
                              case 'HTML':
                              case 'BODY':
                                Df(e);
                                break;
                              default:
                                e.textContent = '';
                            }
                        }
                        break;
                      case 5:
                      case 26:
                      case 27:
                      case 6:
                      case 4:
                      case 17:
                        break;
                      default:
                        if ((s & 1024) !== 0)
                          throw Error(
                            'This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.'
                          );
                    }
                    if (((e = t.sibling), e !== null)) {
                      ((e.return = t.return), (At = e));
                      break;
                    }
                    At = t.return;
                  }
            }
            function Kg(e, t, n) {
              var a = n.flags;
              switch (n.tag) {
                case 0:
                case 11:
                case 15:
                  (Ma(e, n), a & 4 && Pg(n, Bt | zn));
                  break;
                case 1:
                  if ((Ma(e, n), a & 4))
                    if (((e = n.stateNode), t === null))
                      (n.type.defaultProps ||
                        'ref' in n.memoizedProps ||
                        bs ||
                        (e.props !== n.memoizedProps &&
                          console.error(
                            'Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                            J(n) || 'instance'
                          ),
                        e.state !== n.memoizedState &&
                          console.error(
                            'Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                            J(n) || 'instance'
                          )),
                        aa(n)
                          ? (na(), he(n, Tm, n, e), ta())
                          : he(n, Tm, n, e));
                    else {
                      var s = Ki(n.type, t.memoizedProps);
                      ((t = t.memoizedState),
                        n.type.defaultProps ||
                          'ref' in n.memoizedProps ||
                          bs ||
                          (e.props !== n.memoizedProps &&
                            console.error(
                              'Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.',
                              J(n) || 'instance'
                            ),
                          e.state !== n.memoizedState &&
                            console.error(
                              'Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.',
                              J(n) || 'instance'
                            )),
                        aa(n)
                          ? (na(),
                            he(
                              n,
                              Hv,
                              n,
                              e,
                              s,
                              t,
                              e.__reactInternalSnapshotBeforeUpdate
                            ),
                            ta())
                          : he(
                              n,
                              Hv,
                              n,
                              e,
                              s,
                              t,
                              e.__reactInternalSnapshotBeforeUpdate
                            ));
                    }
                  (a & 64 && qg(n), a & 512 && so(n, n.return));
                  break;
                case 3:
                  if (
                    ((t = Da()),
                    Ma(e, n),
                    a & 64 && ((a = n.updateQueue), a !== null))
                  ) {
                    if (((s = null), n.child !== null))
                      switch (n.child.tag) {
                        case 27:
                        case 5:
                          s = n.child.stateNode;
                          break;
                        case 1:
                          s = n.child.stateNode;
                      }
                    try {
                      he(n, Yh, a, s);
                    } catch (f) {
                      Ye(n, n.return, f);
                    }
                  }
                  e.effectDuration += Vr(t);
                  break;
                case 27:
                  t === null && a & 4 && Fg(n);
                case 26:
                case 5:
                  (Ma(e, n),
                    t === null && a & 4 && Qg(n),
                    a & 512 && so(n, n.return));
                  break;
                case 12:
                  if (a & 4) {
                    ((a = Da()),
                      Ma(e, n),
                      (e = n.stateNode),
                      (e.effectDuration += Zs(a)));
                    try {
                      he(n, Xg, n, t, Bc, e.effectDuration);
                    } catch (f) {
                      Ye(n, n.return, f);
                    }
                  } else Ma(e, n);
                  break;
                case 13:
                  (Ma(e, n),
                    a & 4 && tb(e, n),
                    a & 64 &&
                      ((e = n.memoizedState),
                      e !== null &&
                        ((e = e.dehydrated),
                        e !== null && ((n = mx.bind(null, n)), Vx(e, n)))));
                  break;
                case 22:
                  if (((a = n.memoizedState !== null || Ia), !a)) {
                    ((t = (t !== null && t.memoizedState !== null) || pt),
                      (s = Ia));
                    var c = pt;
                    ((Ia = a),
                      (pt = t) && !c
                        ? Oa(e, n, (n.subtreeFlags & 8772) !== 0)
                        : Ma(e, n),
                      (Ia = s),
                      (pt = c));
                  }
                  break;
                case 30:
                  break;
                default:
                  Ma(e, n);
              }
            }
            function Jg(e) {
              var t = e.alternate;
              (t !== null && ((e.alternate = null), Jg(t)),
                (e.child = null),
                (e.deletions = null),
                (e.sibling = null),
                e.tag === 5 && ((t = e.stateNode), t !== null && Ja(t)),
                (e.stateNode = null),
                (e._debugOwner = null),
                (e.return = null),
                (e.dependencies = null),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.pendingProps = null),
                (e.stateNode = null),
                (e.updateQueue = null));
            }
            function Ra(e, t, n) {
              for (n = n.child; n !== null; ) (eb(e, t, n), (n = n.sibling));
            }
            function eb(e, t, n) {
              if (Ht && typeof Ht.onCommitFiberUnmount == 'function')
                try {
                  Ht.onCommitFiberUnmount(Yl, n);
                } catch (c) {
                  ua ||
                    ((ua = !0),
                    console.error(
                      'React instrumentation encountered an error: %s',
                      c
                    ));
                }
              switch (n.tag) {
                case 26:
                  (pt || ia(n, t),
                    Ra(e, t, n),
                    n.memoizedState
                      ? n.memoizedState.count--
                      : n.stateNode &&
                        ((n = n.stateNode), n.parentNode.removeChild(n)));
                  break;
                case 27:
                  pt || ia(n, t);
                  var a = St,
                    s = sn;
                  (ci(n.type) && ((St = n.stateNode), (sn = !1)),
                    Ra(e, t, n),
                    he(n, po, n.stateNode),
                    (St = a),
                    (sn = s));
                  break;
                case 5:
                  pt || ia(n, t);
                case 6:
                  if (
                    ((a = St),
                    (s = sn),
                    (St = null),
                    Ra(e, t, n),
                    (St = a),
                    (sn = s),
                    St !== null)
                  )
                    if (sn)
                      try {
                        he(n, Ax, St, n.stateNode);
                      } catch (c) {
                        Ye(n, t, c);
                      }
                    else
                      try {
                        he(n, Cx, St, n.stateNode);
                      } catch (c) {
                        Ye(n, t, c);
                      }
                  break;
                case 18:
                  St !== null &&
                    (sn
                      ? ((e = St),
                        Jb(
                          e.nodeType === 9
                            ? e.body
                            : e.nodeName === 'HTML'
                              ? e.ownerDocument.body
                              : e,
                          n.stateNode
                        ),
                        yo(e))
                      : Jb(St, n.stateNode));
                  break;
                case 4:
                  ((a = St),
                    (s = sn),
                    (St = n.stateNode.containerInfo),
                    (sn = !0),
                    Ra(e, t, n),
                    (St = a),
                    (sn = s));
                  break;
                case 0:
                case 11:
                case 14:
                case 15:
                  (pt || Vl(Yt, n, t), pt || Kd(n, t, Bt), Ra(e, t, n));
                  break;
                case 1:
                  (pt ||
                    (ia(n, t),
                    (a = n.stateNode),
                    typeof a.componentWillUnmount == 'function' && Yg(n, t, a)),
                    Ra(e, t, n));
                  break;
                case 21:
                  Ra(e, t, n);
                  break;
                case 22:
                  ((pt = (a = pt) || n.memoizedState !== null),
                    Ra(e, t, n),
                    (pt = a));
                  break;
                default:
                  Ra(e, t, n);
              }
            }
            function tb(e, t) {
              if (
                t.memoizedState === null &&
                ((e = t.alternate),
                e !== null &&
                  ((e = e.memoizedState),
                  e !== null && ((e = e.dehydrated), e !== null)))
              )
                try {
                  he(t, Lx, e);
                } catch (n) {
                  Ye(t, t.return, n);
                }
            }
            function lx(e) {
              switch (e.tag) {
                case 13:
                case 19:
                  var t = e.stateNode;
                  return (t === null && (t = e.stateNode = new g1()), t);
                case 22:
                  return (
                    (e = e.stateNode),
                    (t = e._retryCache),
                    t === null && (t = e._retryCache = new g1()),
                    t
                  );
                default:
                  throw Error(
                    'Unexpected Suspense handler tag (' +
                      e.tag +
                      '). This is a bug in React.'
                  );
              }
            }
            function af(e, t) {
              var n = lx(e);
              t.forEach(function (a) {
                var s = px.bind(null, e, a);
                if (!n.has(a)) {
                  if ((n.add(a), Xn))
                    if (ys !== null && vs !== null) uo(vs, ys);
                    else
                      throw Error(
                        'Expected finished root and lanes to be set. This is a bug in React.'
                      );
                  a.then(s, s);
                }
              });
            }
            function mn(e, t) {
              var n = t.deletions;
              if (n !== null)
                for (var a = 0; a < n.length; a++) {
                  var s = e,
                    c = t,
                    f = n[a],
                    b = c;
                  e: for (; b !== null; ) {
                    switch (b.tag) {
                      case 27:
                        if (ci(b.type)) {
                          ((St = b.stateNode), (sn = !1));
                          break e;
                        }
                        break;
                      case 5:
                        ((St = b.stateNode), (sn = !1));
                        break e;
                      case 3:
                      case 4:
                        ((St = b.stateNode.containerInfo), (sn = !0));
                        break e;
                    }
                    b = b.return;
                  }
                  if (St === null)
                    throw Error(
                      'Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.'
                    );
                  (eb(s, c, f),
                    (St = null),
                    (sn = !1),
                    (s = f),
                    (c = s.alternate),
                    c !== null && (c.return = null),
                    (s.return = null));
                }
              if (t.subtreeFlags & 13878)
                for (t = t.child; t !== null; ) (nb(t, e), (t = t.sibling));
            }
            function nb(e, t) {
              var n = e.alternate,
                a = e.flags;
              switch (e.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  (mn(t, e),
                    pn(e),
                    a & 4 &&
                      (Vl(Yt | zn, e, e.return),
                      lo(Yt | zn, e),
                      Kd(e, e.return, Bt | zn)));
                  break;
                case 1:
                  (mn(t, e),
                    pn(e),
                    a & 512 && (pt || n === null || ia(n, n.return)),
                    a & 64 &&
                      Ia &&
                      ((e = e.updateQueue),
                      e !== null &&
                        ((a = e.callbacks),
                        a !== null &&
                          ((n = e.shared.hiddenCallbacks),
                          (e.shared.hiddenCallbacks =
                            n === null ? a : n.concat(a))))));
                  break;
                case 26:
                  var s = Kn;
                  if (
                    (mn(t, e),
                    pn(e),
                    a & 512 && (pt || n === null || ia(n, n.return)),
                    a & 4)
                  )
                    if (
                      ((t = n !== null ? n.memoizedState : null),
                      (a = e.memoizedState),
                      n === null)
                    )
                      if (a === null)
                        if (e.stateNode === null) {
                          e: {
                            ((a = e.type),
                              (n = e.memoizedProps),
                              (t = s.ownerDocument || s));
                            t: switch (a) {
                              case 'title':
                                ((s = t.getElementsByTagName('title')[0]),
                                  (!s ||
                                    s[xo] ||
                                    s[Ut] ||
                                    s.namespaceURI === Ql ||
                                    s.hasAttribute('itemprop')) &&
                                    ((s = t.createElement(a)),
                                    t.head.insertBefore(
                                      s,
                                      t.querySelector('head > title')
                                    )),
                                  _t(s, a, n),
                                  (s[Ut] = e),
                                  O(s),
                                  (a = s));
                                break e;
                              case 'link':
                                var c = cy('link', 'href', t).get(
                                  a + (n.href || '')
                                );
                                if (c) {
                                  for (var f = 0; f < c.length; f++)
                                    if (
                                      ((s = c[f]),
                                      s.getAttribute('href') ===
                                        (n.href == null || n.href === ''
                                          ? null
                                          : n.href) &&
                                        s.getAttribute('rel') ===
                                          (n.rel == null ? null : n.rel) &&
                                        s.getAttribute('title') ===
                                          (n.title == null ? null : n.title) &&
                                        s.getAttribute('crossorigin') ===
                                          (n.crossOrigin == null
                                            ? null
                                            : n.crossOrigin))
                                    ) {
                                      c.splice(f, 1);
                                      break t;
                                    }
                                }
                                ((s = t.createElement(a)),
                                  _t(s, a, n),
                                  t.head.appendChild(s));
                                break;
                              case 'meta':
                                if (
                                  (c = cy('meta', 'content', t).get(
                                    a + (n.content || '')
                                  ))
                                ) {
                                  for (f = 0; f < c.length; f++)
                                    if (
                                      ((s = c[f]),
                                      ue(n.content, 'content'),
                                      s.getAttribute('content') ===
                                        (n.content == null
                                          ? null
                                          : '' + n.content) &&
                                        s.getAttribute('name') ===
                                          (n.name == null ? null : n.name) &&
                                        s.getAttribute('property') ===
                                          (n.property == null
                                            ? null
                                            : n.property) &&
                                        s.getAttribute('http-equiv') ===
                                          (n.httpEquiv == null
                                            ? null
                                            : n.httpEquiv) &&
                                        s.getAttribute('charset') ===
                                          (n.charSet == null
                                            ? null
                                            : n.charSet))
                                    ) {
                                      c.splice(f, 1);
                                      break t;
                                    }
                                }
                                ((s = t.createElement(a)),
                                  _t(s, a, n),
                                  t.head.appendChild(s));
                                break;
                              default:
                                throw Error(
                                  'getNodesForType encountered a type it did not expect: "' +
                                    a +
                                    '". This is a bug in React.'
                                );
                            }
                            ((s[Ut] = e), O(s), (a = s));
                          }
                          e.stateNode = a;
                        } else uy(s, e.type, e.stateNode);
                      else e.stateNode = ry(s, a, e.memoizedProps);
                    else
                      t !== a
                        ? (t === null
                            ? n.stateNode !== null &&
                              ((n = n.stateNode), n.parentNode.removeChild(n))
                            : t.count--,
                          a === null
                            ? uy(s, e.type, e.stateNode)
                            : ry(s, a, e.memoizedProps))
                        : a === null &&
                          e.stateNode !== null &&
                          ef(e, e.memoizedProps, n.memoizedProps);
                  break;
                case 27:
                  (mn(t, e),
                    pn(e),
                    a & 512 && (pt || n === null || ia(n, n.return)),
                    n !== null &&
                      a & 4 &&
                      ef(e, e.memoizedProps, n.memoizedProps));
                  break;
                case 5:
                  if (
                    (mn(t, e),
                    pn(e),
                    a & 512 && (pt || n === null || ia(n, n.return)),
                    e.flags & 32)
                  ) {
                    t = e.stateNode;
                    try {
                      he(e, Kb, t);
                    } catch (j) {
                      Ye(e, e.return, j);
                    }
                  }
                  (a & 4 &&
                    e.stateNode != null &&
                    ((t = e.memoizedProps),
                    ef(e, t, n !== null ? n.memoizedProps : t)),
                    a & 1024 &&
                      ((_m = !0),
                      e.type !== 'form' &&
                        console.error(
                          'Unexpected host component type. Expected a form. This is a bug in React.'
                        )));
                  break;
                case 6:
                  if ((mn(t, e), pn(e), a & 4)) {
                    if (e.stateNode === null)
                      throw Error(
                        'This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.'
                      );
                    ((a = e.memoizedProps),
                      (n = n !== null ? n.memoizedProps : a),
                      (t = e.stateNode));
                    try {
                      he(e, Tx, t, n, a);
                    } catch (j) {
                      Ye(e, e.return, j);
                    }
                  }
                  break;
                case 3:
                  if (
                    ((s = Da()),
                    (ru = null),
                    (c = Kn),
                    (Kn = mc(t.containerInfo)),
                    mn(t, e),
                    (Kn = c),
                    pn(e),
                    a & 4 && n !== null && n.memoizedState.isDehydrated)
                  )
                    try {
                      he(e, Bx, t.containerInfo);
                    } catch (j) {
                      Ye(e, e.return, j);
                    }
                  (_m && ((_m = !1), ab(e)), (t.effectDuration += Vr(s)));
                  break;
                case 4:
                  ((a = Kn),
                    (Kn = mc(e.stateNode.containerInfo)),
                    mn(t, e),
                    pn(e),
                    (Kn = a));
                  break;
                case 12:
                  ((a = Da()),
                    mn(t, e),
                    pn(e),
                    (e.stateNode.effectDuration += Zs(a)));
                  break;
                case 13:
                  (mn(t, e),
                    pn(e),
                    e.child.flags & 8192 &&
                      (e.memoizedState !== null) !=
                        (n !== null && n.memoizedState !== null) &&
                      (Hm = ca()),
                    a & 4 &&
                      ((a = e.updateQueue),
                      a !== null && ((e.updateQueue = null), af(e, a))));
                  break;
                case 22:
                  s = e.memoizedState !== null;
                  var b = n !== null && n.memoizedState !== null,
                    w = Ia,
                    T = pt;
                  if (
                    ((Ia = w || s),
                    (pt = T || b),
                    mn(t, e),
                    (pt = T),
                    (Ia = w),
                    pn(e),
                    a & 8192)
                  )
                    e: for (
                      t = e.stateNode,
                        t._visibility = s
                          ? t._visibility & ~kc
                          : t._visibility | kc,
                        s && (n === null || b || Ia || pt || Ji(e)),
                        n = null,
                        t = e;
                      ;
                    ) {
                      if (t.tag === 5 || t.tag === 26) {
                        if (n === null) {
                          b = n = t;
                          try {
                            ((c = b.stateNode),
                              s
                                ? he(b, Rx, c)
                                : he(b, Ox, b.stateNode, b.memoizedProps));
                          } catch (j) {
                            Ye(b, b.return, j);
                          }
                        }
                      } else if (t.tag === 6) {
                        if (n === null) {
                          b = t;
                          try {
                            ((f = b.stateNode),
                              s ? he(b, Mx, f) : he(b, kx, f, b.memoizedProps));
                          } catch (j) {
                            Ye(b, b.return, j);
                          }
                        }
                      } else if (
                        ((t.tag !== 22 && t.tag !== 23) ||
                          t.memoizedState === null ||
                          t === e) &&
                        t.child !== null
                      ) {
                        ((t.child.return = t), (t = t.child));
                        continue;
                      }
                      if (t === e) break e;
                      for (; t.sibling === null; ) {
                        if (t.return === null || t.return === e) break e;
                        (n === t && (n = null), (t = t.return));
                      }
                      (n === t && (n = null),
                        (t.sibling.return = t.return),
                        (t = t.sibling));
                    }
                  a & 4 &&
                    ((a = e.updateQueue),
                    a !== null &&
                      ((n = a.retryQueue),
                      n !== null && ((a.retryQueue = null), af(e, n))));
                  break;
                case 19:
                  (mn(t, e),
                    pn(e),
                    a & 4 &&
                      ((a = e.updateQueue),
                      a !== null && ((e.updateQueue = null), af(e, a))));
                  break;
                case 30:
                  break;
                case 21:
                  break;
                default:
                  (mn(t, e), pn(e));
              }
            }
            function pn(e) {
              var t = e.flags;
              if (t & 2) {
                try {
                  he(e, ax, e);
                } catch (n) {
                  Ye(e, e.return, n);
                }
                e.flags &= -3;
              }
              t & 4096 && (e.flags &= -4097);
            }
            function ab(e) {
              if (e.subtreeFlags & 1024)
                for (e = e.child; e !== null; ) {
                  var t = e;
                  (ab(t),
                    t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
                    (e = e.sibling));
                }
            }
            function Ma(e, t) {
              if (t.subtreeFlags & 8772)
                for (t = t.child; t !== null; )
                  (Kg(e, t.alternate, t), (t = t.sibling));
            }
            function ib(e) {
              switch (e.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  (Kd(e, e.return, Bt), Ji(e));
                  break;
                case 1:
                  ia(e, e.return);
                  var t = e.stateNode;
                  (typeof t.componentWillUnmount == 'function' &&
                    Yg(e, e.return, t),
                    Ji(e));
                  break;
                case 27:
                  he(e, po, e.stateNode);
                case 26:
                case 5:
                  (ia(e, e.return), Ji(e));
                  break;
                case 22:
                  e.memoizedState === null && Ji(e);
                  break;
                case 30:
                  Ji(e);
                  break;
                default:
                  Ji(e);
              }
            }
            function Ji(e) {
              for (e = e.child; e !== null; ) (ib(e), (e = e.sibling));
            }
            function lb(e, t, n, a) {
              var s = n.flags;
              switch (n.tag) {
                case 0:
                case 11:
                case 15:
                  (Oa(e, n, a), Pg(n, Bt));
                  break;
                case 1:
                  if (
                    (Oa(e, n, a),
                    (t = n.stateNode),
                    typeof t.componentDidMount == 'function' && he(n, Tm, n, t),
                    (t = n.updateQueue),
                    t !== null)
                  ) {
                    e = n.stateNode;
                    try {
                      he(n, $S, t, e);
                    } catch (c) {
                      Ye(n, n.return, c);
                    }
                  }
                  (a && s & 64 && qg(n), so(n, n.return));
                  break;
                case 27:
                  Fg(n);
                case 26:
                case 5:
                  (Oa(e, n, a),
                    a && t === null && s & 4 && Qg(n),
                    so(n, n.return));
                  break;
                case 12:
                  if (a && s & 4) {
                    ((s = Da()),
                      Oa(e, n, a),
                      (a = n.stateNode),
                      (a.effectDuration += Zs(s)));
                    try {
                      he(n, Xg, n, t, Bc, a.effectDuration);
                    } catch (c) {
                      Ye(n, n.return, c);
                    }
                  } else Oa(e, n, a);
                  break;
                case 13:
                  (Oa(e, n, a), a && s & 4 && tb(e, n));
                  break;
                case 22:
                  (n.memoizedState === null && Oa(e, n, a), so(n, n.return));
                  break;
                case 30:
                  break;
                default:
                  Oa(e, n, a);
              }
            }
            function Oa(e, t, n) {
              for (
                n = n && (t.subtreeFlags & 8772) !== 0, t = t.child;
                t !== null;
              )
                (lb(e, t.alternate, t, n), (t = t.sibling));
            }
            function lf(e, t) {
              var n = null;
              (e !== null &&
                e.memoizedState !== null &&
                e.memoizedState.cachePool !== null &&
                (n = e.memoizedState.cachePool.pool),
                (e = null),
                t.memoizedState !== null &&
                  t.memoizedState.cachePool !== null &&
                  (e = t.memoizedState.cachePool.pool),
                e !== n && (e != null && Xi(e), n != null && Qs(n)));
            }
            function sf(e, t) {
              ((e = null),
                t.alternate !== null && (e = t.alternate.memoizedState.cache),
                (t = t.memoizedState.cache),
                t !== e && (Xi(t), e != null && Qs(e)));
            }
            function la(e, t, n, a) {
              if (t.subtreeFlags & 10256)
                for (t = t.child; t !== null; )
                  (sb(e, t, n, a), (t = t.sibling));
            }
            function sb(e, t, n, a) {
              var s = t.flags;
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  (la(e, t, n, a), s & 2048 && Gg(t, Nt | zn));
                  break;
                case 1:
                  la(e, t, n, a);
                  break;
                case 3:
                  var c = Da();
                  (la(e, t, n, a),
                    s & 2048 &&
                      ((n = null),
                      t.alternate !== null &&
                        (n = t.alternate.memoizedState.cache),
                      (t = t.memoizedState.cache),
                      t !== n && (Xi(t), n != null && Qs(n))),
                    (e.passiveEffectDuration += Vr(c)));
                  break;
                case 12:
                  if (s & 2048) {
                    ((s = Da()),
                      la(e, t, n, a),
                      (e = t.stateNode),
                      (e.passiveEffectDuration += Zs(s)));
                    try {
                      he(t, nx, t, t.alternate, Bc, e.passiveEffectDuration);
                    } catch (b) {
                      Ye(t, t.return, b);
                    }
                  } else la(e, t, n, a);
                  break;
                case 13:
                  la(e, t, n, a);
                  break;
                case 23:
                  break;
                case 22:
                  c = t.stateNode;
                  var f = t.alternate;
                  (t.memoizedState !== null
                    ? c._visibility & Va
                      ? la(e, t, n, a)
                      : oo(e, t)
                    : c._visibility & Va
                      ? la(e, t, n, a)
                      : ((c._visibility |= Va),
                        Bl(e, t, n, a, (t.subtreeFlags & 10256) !== 0)),
                    s & 2048 && lf(f, t));
                  break;
                case 24:
                  (la(e, t, n, a), s & 2048 && sf(t.alternate, t));
                  break;
                default:
                  la(e, t, n, a);
              }
            }
            function Bl(e, t, n, a, s) {
              for (
                s = s && (t.subtreeFlags & 10256) !== 0, t = t.child;
                t !== null;
              )
                (ob(e, t, n, a, s), (t = t.sibling));
            }
            function ob(e, t, n, a, s) {
              var c = t.flags;
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  (Bl(e, t, n, a, s), Gg(t, Nt));
                  break;
                case 23:
                  break;
                case 22:
                  var f = t.stateNode;
                  (t.memoizedState !== null
                    ? f._visibility & Va
                      ? Bl(e, t, n, a, s)
                      : oo(e, t)
                    : ((f._visibility |= Va), Bl(e, t, n, a, s)),
                    s && c & 2048 && lf(t.alternate, t));
                  break;
                case 24:
                  (Bl(e, t, n, a, s), s && c & 2048 && sf(t.alternate, t));
                  break;
                default:
                  Bl(e, t, n, a, s);
              }
            }
            function oo(e, t) {
              if (t.subtreeFlags & 10256)
                for (t = t.child; t !== null; ) {
                  var n = e,
                    a = t,
                    s = a.flags;
                  switch (a.tag) {
                    case 22:
                      (oo(n, a), s & 2048 && lf(a.alternate, a));
                      break;
                    case 24:
                      (oo(n, a), s & 2048 && sf(a.alternate, a));
                      break;
                    default:
                      oo(n, a);
                  }
                  t = t.sibling;
                }
            }
            function Ll(e) {
              if (e.subtreeFlags & Po)
                for (e = e.child; e !== null; ) (rb(e), (e = e.sibling));
            }
            function rb(e) {
              switch (e.tag) {
                case 26:
                  (Ll(e),
                    e.flags & Po &&
                      e.memoizedState !== null &&
                      Wx(Kn, e.memoizedState, e.memoizedProps));
                  break;
                case 5:
                  Ll(e);
                  break;
                case 3:
                case 4:
                  var t = Kn;
                  ((Kn = mc(e.stateNode.containerInfo)), Ll(e), (Kn = t));
                  break;
                case 22:
                  e.memoizedState === null &&
                    ((t = e.alternate),
                    t !== null && t.memoizedState !== null
                      ? ((t = Po), (Po = 16777216), Ll(e), (Po = t))
                      : Ll(e));
                  break;
                default:
                  Ll(e);
              }
            }
            function cb(e) {
              var t = e.alternate;
              if (t !== null && ((e = t.child), e !== null)) {
                t.child = null;
                do ((t = e.sibling), (e.sibling = null), (e = t));
                while (e !== null);
              }
            }
            function ro(e) {
              var t = e.deletions;
              if ((e.flags & 16) !== 0) {
                if (t !== null)
                  for (var n = 0; n < t.length; n++) {
                    var a = t[n];
                    ((At = a), fb(a, e));
                  }
                cb(e);
              }
              if (e.subtreeFlags & 10256)
                for (e = e.child; e !== null; ) (ub(e), (e = e.sibling));
            }
            function ub(e) {
              switch (e.tag) {
                case 0:
                case 11:
                case 15:
                  (ro(e), e.flags & 2048 && Jd(e, e.return, Nt | zn));
                  break;
                case 3:
                  var t = Da();
                  (ro(e), (e.stateNode.passiveEffectDuration += Vr(t)));
                  break;
                case 12:
                  ((t = Da()),
                    ro(e),
                    (e.stateNode.passiveEffectDuration += Zs(t)));
                  break;
                case 22:
                  ((t = e.stateNode),
                    e.memoizedState !== null &&
                    t._visibility & Va &&
                    (e.return === null || e.return.tag !== 13)
                      ? ((t._visibility &= ~Va), oc(e))
                      : ro(e));
                  break;
                default:
                  ro(e);
              }
            }
            function oc(e) {
              var t = e.deletions;
              if ((e.flags & 16) !== 0) {
                if (t !== null)
                  for (var n = 0; n < t.length; n++) {
                    var a = t[n];
                    ((At = a), fb(a, e));
                  }
                cb(e);
              }
              for (e = e.child; e !== null; ) (db(e), (e = e.sibling));
            }
            function db(e) {
              switch (e.tag) {
                case 0:
                case 11:
                case 15:
                  (Jd(e, e.return, Nt), oc(e));
                  break;
                case 22:
                  var t = e.stateNode;
                  t._visibility & Va && ((t._visibility &= ~Va), oc(e));
                  break;
                default:
                  oc(e);
              }
            }
            function fb(e, t) {
              for (; At !== null; ) {
                var n = At,
                  a = n;
                switch (a.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Jd(a, t, Nt);
                    break;
                  case 23:
                  case 22:
                    a.memoizedState !== null &&
                      a.memoizedState.cachePool !== null &&
                      ((a = a.memoizedState.cachePool.pool),
                      a != null && Xi(a));
                    break;
                  case 24:
                    Qs(a.memoizedState.cache);
                }
                if (((a = n.child), a !== null)) ((a.return = n), (At = a));
                else
                  e: for (n = e; At !== null; ) {
                    a = At;
                    var s = a.sibling,
                      c = a.return;
                    if ((Jg(a), a === n)) {
                      At = null;
                      break e;
                    }
                    if (s !== null) {
                      ((s.return = c), (At = s));
                      break e;
                    }
                    At = c;
                  }
              }
            }
            function sx() {
              Sw.forEach(function (e) {
                return e();
              });
            }
            function mb() {
              var e =
                typeof IS_REACT_ACT_ENVIRONMENT < 'u'
                  ? IS_REACT_ACT_ENVIRONMENT
                  : void 0;
              return (
                e ||
                  z.actQueue === null ||
                  console.error(
                    'The current testing environment is not configured to support act(...)'
                  ),
                e
              );
            }
            function hn(e) {
              if ((Pe & Xt) !== yn && _e !== 0) return _e & -_e;
              var t = z.T;
              return t !== null
                ? (t._updatedFibers || (t._updatedFibers = new Set()),
                  t._updatedFibers.add(e),
                  (e = ll),
                  e !== 0 ? e : hf())
                : Ls();
            }
            function pb() {
              Sn === 0 &&
                (Sn = (_e & 536870912) === 0 || He ? Me() : 536870912);
              var e = Un.current;
              return (e !== null && (e.flags |= 32), Sn);
            }
            function mt(e, t, n) {
              if (
                (Es &&
                  console.error(
                    'useInsertionEffect must not schedule updates.'
                  ),
                Pm && (Zc = !0),
                ((e === Ze && (Ge === ul || Ge === dl)) ||
                  e.cancelPendingCommit !== null) &&
                  (Hl(e, 0), oi(e, _e, Sn, !1)),
                Ka(e, n),
                (Pe & Xt) !== 0 && e === Ze)
              ) {
                if (fa)
                  switch (t.tag) {
                    case 0:
                    case 11:
                    case 15:
                      ((e = (Oe && J(Oe)) || 'Unknown'),
                        T1.has(e) ||
                          (T1.add(e),
                          (t = J(t) || 'Unknown'),
                          console.error(
                            'Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render',
                            t,
                            e,
                            e
                          )));
                      break;
                    case 1:
                      D1 ||
                        (console.error(
                          'Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.'
                        ),
                        (D1 = !0));
                  }
              } else
                (Xn && Vs(e, t, n),
                  gx(t),
                  e === Ze &&
                    ((Pe & Xt) === yn && (Ni |= n),
                    ct === cl && oi(e, _e, Sn, !1)),
                  sa(e));
            }
            function hb(e, t, n) {
              if ((Pe & (Xt | Jn)) !== yn)
                throw Error('Should not already be working.');
              var a =
                  (!n && (t & 124) === 0 && (t & e.expiredLanes) === 0) ||
                  Fa(e, t),
                s = a ? rx(e, t) : cf(e, t, !0),
                c = a;
              do {
                if (s === Wa) {
                  Ns && !a && oi(e, t, 0, !1);
                  break;
                } else {
                  if (((n = e.current.alternate), c && !ox(n))) {
                    ((s = cf(e, t, !1)), (c = !1));
                    continue;
                  }
                  if (s === Ss) {
                    if (((c = t), e.errorRecoveryDisabledLanes & c)) var f = 0;
                    else
                      ((f = e.pendingLanes & -536870913),
                        (f = f !== 0 ? f : f & 536870912 ? 536870912 : 0));
                    if (f !== 0) {
                      t = f;
                      e: {
                        s = e;
                        var b = f;
                        f = Zo;
                        var w = s.current.memoizedState.isDehydrated;
                        if (
                          (w && (Hl(s, b).flags |= 256),
                          (b = cf(s, b, !1)),
                          b !== Ss)
                        ) {
                          if (Lm && !w) {
                            ((s.errorRecoveryDisabledLanes |= c),
                              (Ni |= c),
                              (s = cl));
                            break e;
                          }
                          ((s = Qt),
                            (Qt = f),
                            s !== null &&
                              (Qt === null ? (Qt = s) : Qt.push.apply(Qt, s)));
                        }
                        s = b;
                      }
                      if (((c = !1), s !== Ss)) continue;
                    }
                  }
                  if (s === qo) {
                    (Hl(e, 0), oi(e, t, 0, !0));
                    break;
                  }
                  e: {
                    switch (((a = e), s)) {
                      case Wa:
                      case qo:
                        throw Error(
                          'Root did not complete. This is a bug in React.'
                        );
                      case cl:
                        if ((t & 4194048) !== t) break;
                      case Yc:
                        oi(a, t, Sn, !Si);
                        break e;
                      case Ss:
                        Qt = null;
                        break;
                      case jm:
                      case b1:
                        break;
                      default:
                        throw Error('Unknown root exit status.');
                    }
                    if (z.actQueue !== null)
                      uf(a, n, t, Qt, Fo, Xc, Sn, Ni, fl);
                    else {
                      if (
                        (t & 62914560) === t &&
                        ((c = Hm + v1 - ca()), 10 < c)
                      ) {
                        if ((oi(a, t, Sn, !Si), xa(a, 0, !0) !== 0)) break e;
                        a.timeoutHandle = j1(
                          gb.bind(
                            null,
                            a,
                            n,
                            Qt,
                            Fo,
                            Xc,
                            t,
                            Sn,
                            Ni,
                            fl,
                            Si,
                            s,
                            Ew,
                            xv,
                            0
                          ),
                          c
                        );
                        break e;
                      }
                      gb(a, n, Qt, Fo, Xc, t, Sn, Ni, fl, Si, s, Nw, xv, 0);
                    }
                  }
                }
                break;
              } while (!0);
              sa(e);
            }
            function gb(e, t, n, a, s, c, f, b, w, T, j, H, _, I) {
              if (
                ((e.timeoutHandle = bl),
                (H = t.subtreeFlags),
                (H & 8192 || (H & 16785408) === 16785408) &&
                  ((ar = { stylesheets: null, count: 0, unsuspend: Ix }),
                  rb(t),
                  (H = $x()),
                  H !== null))
              ) {
                ((e.cancelPendingCommit = H(
                  uf.bind(null, e, t, c, n, a, s, f, b, w, j, ww, _, I)
                )),
                  oi(e, c, f, !T));
                return;
              }
              uf(e, t, c, n, a, s, f, b, w);
            }
            function ox(e) {
              for (var t = e; ; ) {
                var n = t.tag;
                if (
                  (n === 0 || n === 11 || n === 15) &&
                  t.flags & 16384 &&
                  ((n = t.updateQueue),
                  n !== null && ((n = n.stores), n !== null))
                )
                  for (var a = 0; a < n.length; a++) {
                    var s = n[a],
                      c = s.getSnapshot;
                    s = s.value;
                    try {
                      if (!Gt(c(), s)) return !1;
                    } catch {
                      return !1;
                    }
                  }
                if (((n = t.child), t.subtreeFlags & 16384 && n !== null))
                  ((n.return = t), (t = n));
                else {
                  if (t === e) break;
                  for (; t.sibling === null; ) {
                    if (t.return === null || t.return === e) return !0;
                    t = t.return;
                  }
                  ((t.sibling.return = t.return), (t = t.sibling));
                }
              }
              return !0;
            }
            function oi(e, t, n, a) {
              ((t &= ~zm),
                (t &= ~Ni),
                (e.suspendedLanes |= t),
                (e.pingedLanes &= ~t),
                a && (e.warmLanes |= t),
                (a = e.expirationTimes));
              for (var s = t; 0 < s; ) {
                var c = 31 - $t(s),
                  f = 1 << c;
                ((a[c] = -1), (s &= ~f));
              }
              n !== 0 && _s(e, n, t);
            }
            function zl() {
              return (Pe & (Xt | Jn)) === yn ? (fo(0), !1) : !0;
            }
            function of() {
              if (Oe !== null) {
                if (Ge === on) var e = Oe.return;
                else ((e = Oe), kr(), bd(e), (ms = null), (Wo = 0), (e = Oe));
                for (; e !== null; ) ($g(e.alternate, e), (e = e.return));
                Oe = null;
              }
            }
            function Hl(e, t) {
              var n = e.timeoutHandle;
              (n !== bl && ((e.timeoutHandle = bl), Lw(n)),
                (n = e.cancelPendingCommit),
                n !== null && ((e.cancelPendingCommit = null), n()),
                of(),
                (Ze = e),
                (Oe = n = wa(e.current, null)),
                (_e = t),
                (Ge = on),
                (vn = null),
                (Si = !1),
                (Ns = Fa(e, t)),
                (Lm = !1),
                (ct = Wa),
                (fl = Sn = zm = Ni = xi = 0),
                (Qt = Zo = null),
                (Xc = !1),
                (t & 8) !== 0 && (t |= t & 32));
              var a = e.entangledLanes;
              if (a !== 0)
                for (e = e.entanglements, a &= t; 0 < a; ) {
                  var s = 31 - $t(a),
                    c = 1 << s;
                  ((t |= e[s]), (a &= ~c));
                }
              return (
                (ba = t),
                Ar(),
                (t = vv()),
                1e3 < t - yv && ((z.recentlyCreatedOwnerStacks = 0), (yv = t)),
                Zn.discardPendingWarnings(),
                n
              );
            }
            function bb(e, t) {
              ((ye = null),
                (z.H = Gc),
                (z.getCurrentStack = null),
                (fa = !1),
                (bn = null),
                t === zo || t === Uc
                  ? ((t = Ph()), (Ge = Xo))
                  : t === Ev
                    ? ((t = Ph()), (Ge = y1))
                    : (Ge =
                        t === r1
                          ? Bm
                          : t !== null &&
                              typeof t == 'object' &&
                              typeof t.then == 'function'
                            ? xs
                            : Yo),
                (vn = t));
              var n = Oe;
              if (n === null) ((ct = qo), nc(e, fn(t, e.current)));
              else
                switch ((n.mode & Vt && sd(n), Dn(), Ge)) {
                  case Yo:
                    oe !== null &&
                      typeof oe.markComponentErrored == 'function' &&
                      oe.markComponentErrored(n, t, _e);
                    break;
                  case ul:
                  case dl:
                  case Xo:
                  case xs:
                  case Qo:
                    oe !== null &&
                      typeof oe.markComponentSuspended == 'function' &&
                      oe.markComponentSuspended(n, t, _e);
                }
            }
            function yb() {
              var e = z.H;
              return ((z.H = Gc), e === null ? Gc : e);
            }
            function vb() {
              var e = z.A;
              return ((z.A = vw), e);
            }
            function rf() {
              ((ct = cl),
                Si ||
                  ((_e & 4194048) !== _e && Un.current !== null) ||
                  (Ns = !0),
                ((xi & 134217727) === 0 && (Ni & 134217727) === 0) ||
                  Ze === null ||
                  oi(Ze, _e, Sn, !1));
            }
            function cf(e, t, n) {
              var a = Pe;
              Pe |= Xt;
              var s = yb(),
                c = vb();
              if (Ze !== e || _e !== t) {
                if (Xn) {
                  var f = e.memoizedUpdaters;
                  (0 < f.size && (uo(e, _e), f.clear()), Bs(e, t));
                }
                ((Fo = null), Hl(e, t));
              }
              (Bi(t), (t = !1), (f = ct));
              e: do
                try {
                  if (Ge !== on && Oe !== null) {
                    var b = Oe,
                      w = vn;
                    switch (Ge) {
                      case Bm:
                        (of(), (f = Yc));
                        break e;
                      case Xo:
                      case ul:
                      case dl:
                      case xs:
                        Un.current === null && (t = !0);
                        var T = Ge;
                        if (((Ge = on), (vn = null), Ul(e, b, w, T), n && Ns)) {
                          f = Wa;
                          break e;
                        }
                        break;
                      default:
                        ((T = Ge), (Ge = on), (vn = null), Ul(e, b, w, T));
                    }
                  }
                  (Sb(), (f = ct));
                  break;
                } catch (j) {
                  bb(e, j);
                }
              while (!0);
              return (
                t && e.shellSuspendCounter++,
                kr(),
                (Pe = a),
                (z.H = s),
                (z.A = c),
                Os(),
                Oe === null && ((Ze = null), (_e = 0), Ar()),
                f
              );
            }
            function Sb() {
              for (; Oe !== null; ) xb(Oe);
            }
            function rx(e, t) {
              var n = Pe;
              Pe |= Xt;
              var a = yb(),
                s = vb();
              if (Ze !== e || _e !== t) {
                if (Xn) {
                  var c = e.memoizedUpdaters;
                  (0 < c.size && (uo(e, _e), c.clear()), Bs(e, t));
                }
                ((Fo = null), (Qc = ca() + S1), Hl(e, t));
              } else Ns = Fa(e, t);
              Bi(t);
              e: do
                try {
                  if (Ge !== on && Oe !== null)
                    t: switch (((t = Oe), (c = vn), Ge)) {
                      case Yo:
                        ((Ge = on), (vn = null), Ul(e, t, c, Yo));
                        break;
                      case ul:
                      case dl:
                        if (Wh(c)) {
                          ((Ge = on), (vn = null), Nb(t));
                          break;
                        }
                        ((t = function () {
                          ((Ge !== ul && Ge !== dl) || Ze !== e || (Ge = Qo),
                            sa(e));
                        }),
                          c.then(t, t));
                        break e;
                      case Xo:
                        Ge = Qo;
                        break e;
                      case y1:
                        Ge = Vm;
                        break e;
                      case Qo:
                        Wh(c)
                          ? ((Ge = on), (vn = null), Nb(t))
                          : ((Ge = on), (vn = null), Ul(e, t, c, Qo));
                        break;
                      case Vm:
                        var f = null;
                        switch (Oe.tag) {
                          case 26:
                            f = Oe.memoizedState;
                          case 5:
                          case 27:
                            var b = Oe;
                            if (!f || dy(f)) {
                              ((Ge = on), (vn = null));
                              var w = b.sibling;
                              if (w !== null) Oe = w;
                              else {
                                var T = b.return;
                                T !== null ? ((Oe = T), rc(T)) : (Oe = null);
                              }
                              break t;
                            }
                            break;
                          default:
                            console.error(
                              'Unexpected type of fiber triggered a suspensey commit. This is a bug in React.'
                            );
                        }
                        ((Ge = on), (vn = null), Ul(e, t, c, Vm));
                        break;
                      case xs:
                        ((Ge = on), (vn = null), Ul(e, t, c, xs));
                        break;
                      case Bm:
                        (of(), (ct = Yc));
                        break e;
                      default:
                        throw Error(
                          'Unexpected SuspendedReason. This is a bug in React.'
                        );
                    }
                  z.actQueue !== null ? Sb() : cx();
                  break;
                } catch (j) {
                  bb(e, j);
                }
              while (!0);
              return (
                kr(),
                (z.H = a),
                (z.A = s),
                (Pe = n),
                Oe !== null
                  ? (oe !== null &&
                      typeof oe.markRenderYielded == 'function' &&
                      oe.markRenderYielded(),
                    Wa)
                  : (Os(), (Ze = null), (_e = 0), Ar(), ct)
              );
            }
            function cx() {
              for (; Oe !== null && !lN(); ) xb(Oe);
            }
            function xb(e) {
              var t = e.alternate;
              ((e.mode & Vt) !== Ke
                ? (ld(e), (t = he(e, Fd, t, e, ba)), sd(e))
                : (t = he(e, Fd, t, e, ba)),
                (e.memoizedProps = e.pendingProps),
                t === null ? rc(e) : (Oe = t));
            }
            function Nb(e) {
              var t = he(e, ux, e);
              ((e.memoizedProps = e.pendingProps),
                t === null ? rc(e) : (Oe = t));
            }
            function ux(e) {
              var t = e.alternate,
                n = (e.mode & Vt) !== Ke;
              switch ((n && ld(e), e.tag)) {
                case 15:
                case 0:
                  t = Vg(t, e, e.pendingProps, e.type, void 0, _e);
                  break;
                case 11:
                  t = Vg(t, e, e.pendingProps, e.type.render, e.ref, _e);
                  break;
                case 5:
                  bd(e);
                default:
                  ($g(t, e), (e = Oe = Oh(e, ba)), (t = Fd(t, e, ba)));
              }
              return (n && sd(e), t);
            }
            function Ul(e, t, n, a) {
              (kr(), bd(t), (ms = null), (Wo = 0));
              var s = t.return;
              try {
                if (QS(e, s, t, n, _e)) {
                  ((ct = qo), nc(e, fn(n, e.current)), (Oe = null));
                  return;
                }
              } catch (c) {
                if (s !== null) throw ((Oe = s), c);
                ((ct = qo), nc(e, fn(n, e.current)), (Oe = null));
                return;
              }
              t.flags & 32768
                ? (He || a === Yo
                    ? (e = !0)
                    : Ns || (_e & 536870912) !== 0
                      ? (e = !1)
                      : ((Si = e = !0),
                        (a === ul || a === dl || a === Xo || a === xs) &&
                          ((a = Un.current),
                          a !== null && a.tag === 13 && (a.flags |= 16384))),
                  wb(t, e))
                : rc(t);
            }
            function rc(e) {
              var t = e;
              do {
                if ((t.flags & 32768) !== 0) {
                  wb(t, Si);
                  return;
                }
                var n = t.alternate;
                if (
                  ((e = t.return),
                  ld(t),
                  (n = he(t, FS, n, t, ba)),
                  (t.mode & Vt) !== Ke && zh(t),
                  n !== null)
                ) {
                  Oe = n;
                  return;
                }
                if (((t = t.sibling), t !== null)) {
                  Oe = t;
                  return;
                }
                Oe = t = e;
              } while (t !== null);
              ct === Wa && (ct = b1);
            }
            function wb(e, t) {
              do {
                var n = KS(e.alternate, e);
                if (n !== null) {
                  ((n.flags &= 32767), (Oe = n));
                  return;
                }
                if ((e.mode & Vt) !== Ke) {
                  (zh(e), (n = e.actualDuration));
                  for (var a = e.child; a !== null; )
                    ((n += a.actualDuration), (a = a.sibling));
                  e.actualDuration = n;
                }
                if (
                  ((n = e.return),
                  n !== null &&
                    ((n.flags |= 32768),
                    (n.subtreeFlags = 0),
                    (n.deletions = null)),
                  !t && ((e = e.sibling), e !== null))
                ) {
                  Oe = e;
                  return;
                }
                Oe = e = n;
              } while (e !== null);
              ((ct = Yc), (Oe = null));
            }
            function uf(e, t, n, a, s, c, f, b, w) {
              e.cancelPendingCommit = null;
              do co();
              while (Lt !== ml);
              if (
                (Zn.flushLegacyContextWarning(),
                Zn.flushPendingUnsafeLifecycleWarnings(),
                (Pe & (Xt | Jn)) !== yn)
              )
                throw Error('Should not already be working.');
              if (
                (oe !== null &&
                  typeof oe.markCommitStarted == 'function' &&
                  oe.markCommitStarted(n),
                t === null)
              )
                lt();
              else {
                if (
                  (n === 0 &&
                    console.error(
                      'finishedLanes should not be empty during a commit. This is a bug in React.'
                    ),
                  t === e.current)
                )
                  throw Error(
                    'Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.'
                  );
                if (
                  ((c = t.lanes | t.childLanes),
                  (c |= mm),
                  yr(e, n, c, f, b, w),
                  e === Ze && ((Oe = Ze = null), (_e = 0)),
                  (ws = t),
                  (Ei = e),
                  (Di = n),
                  (Im = c),
                  (Wm = s),
                  (E1 = a),
                  (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
                    ? ((e.callbackNode = null),
                      (e.callbackPriority = 0),
                      hx(ql, function () {
                        return (Ab(), null);
                      }))
                    : ((e.callbackNode = null), (e.callbackPriority = 0)),
                  (Bc = rs()),
                  (a = (t.flags & 13878) !== 0),
                  (t.subtreeFlags & 13878) !== 0 || a)
                ) {
                  ((a = z.T),
                    (z.T = null),
                    (s = $e.p),
                    ($e.p = On),
                    (f = Pe),
                    (Pe |= Jn));
                  try {
                    ix(e, t);
                  } finally {
                    ((Pe = f), ($e.p = s), (z.T = a));
                  }
                }
                ((Lt = x1), Eb(), Db(), Tb());
              }
            }
            function Eb() {
              if (Lt === x1) {
                Lt = ml;
                var e = Ei,
                  t = ws,
                  n = Di,
                  a = (t.flags & 13878) !== 0;
                if ((t.subtreeFlags & 13878) !== 0 || a) {
                  ((a = z.T), (z.T = null));
                  var s = $e.p;
                  $e.p = On;
                  var c = Pe;
                  Pe |= Jn;
                  try {
                    ((ys = n), (vs = e), nb(t, e), (vs = ys = null), (n = Jm));
                    var f = Th(e.containerInfo),
                      b = n.focusedElem,
                      w = n.selectionRange;
                    if (
                      f !== b &&
                      b &&
                      b.ownerDocument &&
                      Dh(b.ownerDocument.documentElement, b)
                    ) {
                      if (w !== null && Gu(b)) {
                        var T = w.start,
                          j = w.end;
                        if ((j === void 0 && (j = T), 'selectionStart' in b))
                          ((b.selectionStart = T),
                            (b.selectionEnd = Math.min(j, b.value.length)));
                        else {
                          var H = b.ownerDocument || document,
                            _ = (H && H.defaultView) || window;
                          if (_.getSelection) {
                            var I = _.getSelection(),
                              fe = b.textContent.length,
                              be = Math.min(w.start, fe),
                              Fe = w.end === void 0 ? be : Math.min(w.end, fe);
                            !I.extend &&
                              be > Fe &&
                              ((f = Fe), (Fe = be), (be = f));
                            var Ve = Eh(b, be),
                              C = Eh(b, Fe);
                            if (
                              Ve &&
                              C &&
                              (I.rangeCount !== 1 ||
                                I.anchorNode !== Ve.node ||
                                I.anchorOffset !== Ve.offset ||
                                I.focusNode !== C.node ||
                                I.focusOffset !== C.offset)
                            ) {
                              var A = H.createRange();
                              (A.setStart(Ve.node, Ve.offset),
                                I.removeAllRanges(),
                                be > Fe
                                  ? (I.addRange(A), I.extend(C.node, C.offset))
                                  : (A.setEnd(C.node, C.offset),
                                    I.addRange(A)));
                            }
                          }
                        }
                      }
                      for (H = [], I = b; (I = I.parentNode); )
                        I.nodeType === 1 &&
                          H.push({
                            element: I,
                            left: I.scrollLeft,
                            top: I.scrollTop,
                          });
                      for (
                        typeof b.focus == 'function' && b.focus(), b = 0;
                        b < H.length;
                        b++
                      ) {
                        var R = H[b];
                        ((R.element.scrollLeft = R.left),
                          (R.element.scrollTop = R.top));
                      }
                    }
                    ((du = !!Km), (Jm = Km = null));
                  } finally {
                    ((Pe = c), ($e.p = s), (z.T = a));
                  }
                }
                ((e.current = t), (Lt = N1));
              }
            }
            function Db() {
              if (Lt === N1) {
                Lt = ml;
                var e = Ei,
                  t = ws,
                  n = Di,
                  a = (t.flags & 8772) !== 0;
                if ((t.subtreeFlags & 8772) !== 0 || a) {
                  ((a = z.T), (z.T = null));
                  var s = $e.p;
                  $e.p = On;
                  var c = Pe;
                  Pe |= Jn;
                  try {
                    (oe !== null &&
                      typeof oe.markLayoutEffectsStarted == 'function' &&
                      oe.markLayoutEffectsStarted(n),
                      (ys = n),
                      (vs = e),
                      Kg(e, t.alternate, t),
                      (vs = ys = null),
                      oe !== null &&
                        typeof oe.markLayoutEffectsStopped == 'function' &&
                        oe.markLayoutEffectsStopped());
                  } finally {
                    ((Pe = c), ($e.p = s), (z.T = a));
                  }
                }
                Lt = w1;
              }
            }
            function Tb() {
              if (Lt === Dw || Lt === w1) {
                ((Lt = ml), sN());
                var e = Ei,
                  t = ws,
                  n = Di,
                  a = E1,
                  s = (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0;
                s
                  ? (Lt = Um)
                  : ((Lt = ml),
                    (ws = Ei = null),
                    Cb(e, e.pendingLanes),
                    (pl = 0),
                    (Jo = null));
                var c = e.pendingLanes;
                if (
                  (c === 0 && (wi = null),
                  s || kb(e),
                  (s = Tl(n)),
                  (t = t.stateNode),
                  Ht && typeof Ht.onCommitFiberRoot == 'function')
                )
                  try {
                    var f = (t.current.flags & 128) === 128;
                    switch (s) {
                      case On:
                        var b = Gf;
                        break;
                      case da:
                        b = qf;
                        break;
                      case ja:
                        b = ql;
                        break;
                      case Dc:
                        b = Yf;
                        break;
                      default:
                        b = ql;
                    }
                    Ht.onCommitFiberRoot(Yl, t, b, f);
                  } catch (H) {
                    ua ||
                      ((ua = !0),
                      console.error(
                        'React instrumentation encountered an error: %s',
                        H
                      ));
                  }
                if ((Xn && e.memoizedUpdaters.clear(), sx(), a !== null)) {
                  ((f = z.T), (b = $e.p), ($e.p = On), (z.T = null));
                  try {
                    var w = e.onRecoverableError;
                    for (t = 0; t < a.length; t++) {
                      var T = a[t],
                        j = dx(T.stack);
                      he(T.source, w, T.value, j);
                    }
                  } finally {
                    ((z.T = f), ($e.p = b));
                  }
                }
                ((Di & 3) !== 0 && co(),
                  sa(e),
                  (c = e.pendingLanes),
                  (n & 4194090) !== 0 && (c & 42) !== 0
                    ? ((zc = !0), e === $m ? Ko++ : ((Ko = 0), ($m = e)))
                    : (Ko = 0),
                  fo(0),
                  lt());
              }
            }
            function dx(e) {
              return (
                (e = { componentStack: e }),
                Object.defineProperty(e, 'digest', {
                  get: function () {
                    console.error(
                      'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
                    );
                  },
                }),
                e
              );
            }
            function Cb(e, t) {
              (e.pooledCacheLanes &= t) === 0 &&
                ((t = e.pooledCache),
                t != null && ((e.pooledCache = null), Qs(t)));
            }
            function co(e) {
              return (Eb(), Db(), Tb(), Ab());
            }
            function Ab() {
              if (Lt !== Um) return !1;
              var e = Ei,
                t = Im;
              Im = 0;
              var n = Tl(Di),
                a = ja > n ? ja : n;
              n = z.T;
              var s = $e.p;
              try {
                (($e.p = a), (z.T = null), (a = Wm), (Wm = null));
                var c = Ei,
                  f = Di;
                if (
                  ((Lt = ml),
                  (ws = Ei = null),
                  (Di = 0),
                  (Pe & (Xt | Jn)) !== yn)
                )
                  throw Error(
                    'Cannot flush passive effects while already rendering.'
                  );
                ((Pm = !0),
                  (Zc = !1),
                  oe !== null &&
                    typeof oe.markPassiveEffectsStarted == 'function' &&
                    oe.markPassiveEffectsStarted(f));
                var b = Pe;
                if (
                  ((Pe |= Jn),
                  ub(c.current),
                  sb(c, c.current, f, a),
                  oe !== null &&
                    typeof oe.markPassiveEffectsStopped == 'function' &&
                    oe.markPassiveEffectsStopped(),
                  kb(c),
                  (Pe = b),
                  fo(0),
                  Zc ? (c === Jo ? pl++ : ((pl = 0), (Jo = c))) : (pl = 0),
                  (Zc = Pm = !1),
                  Ht && typeof Ht.onPostCommitFiberRoot == 'function')
                )
                  try {
                    Ht.onPostCommitFiberRoot(Yl, c);
                  } catch (T) {
                    ua ||
                      ((ua = !0),
                      console.error(
                        'React instrumentation encountered an error: %s',
                        T
                      ));
                  }
                var w = c.current.stateNode;
                return (
                  (w.effectDuration = 0),
                  (w.passiveEffectDuration = 0),
                  !0
                );
              } finally {
                (($e.p = s), (z.T = n), Cb(e, t));
              }
            }
            function Rb(e, t, n) {
              ((t = fn(n, t)),
                (t = Ud(e.stateNode, t, 2)),
                (e = ai(e, t, 2)),
                e !== null && (Ka(e, 2), sa(e)));
            }
            function Ye(e, t, n) {
              if (((Es = !1), e.tag === 3)) Rb(e, e, n);
              else {
                for (; t !== null; ) {
                  if (t.tag === 3) {
                    Rb(t, e, n);
                    return;
                  }
                  if (t.tag === 1) {
                    var a = t.stateNode;
                    if (
                      typeof t.type.getDerivedStateFromError == 'function' ||
                      (typeof a.componentDidCatch == 'function' &&
                        (wi === null || !wi.has(a)))
                    ) {
                      ((e = fn(n, e)),
                        (n = Id(2)),
                        (a = ai(t, n, 2)),
                        a !== null && (Wd(n, a, t, e), Ka(a, 2), sa(a)));
                      return;
                    }
                  }
                  t = t.return;
                }
                console.error(
                  `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
                  n
                );
              }
            }
            function df(e, t, n) {
              var a = e.pingCache;
              if (a === null) {
                a = e.pingCache = new xw();
                var s = new Set();
                a.set(t, s);
              } else
                ((s = a.get(t)),
                  s === void 0 && ((s = new Set()), a.set(t, s)));
              s.has(n) ||
                ((Lm = !0),
                s.add(n),
                (a = fx.bind(null, e, t, n)),
                Xn && uo(e, n),
                t.then(a, a));
            }
            function fx(e, t, n) {
              var a = e.pingCache;
              (a !== null && a.delete(t),
                (e.pingedLanes |= e.suspendedLanes & n),
                (e.warmLanes &= ~n),
                mb() &&
                  z.actQueue === null &&
                  console.error(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`),
                Ze === e &&
                  (_e & n) === n &&
                  (ct === cl ||
                  (ct === jm && (_e & 62914560) === _e && ca() - Hm < v1)
                    ? (Pe & Xt) === yn && Hl(e, 0)
                    : (zm |= n),
                  fl === _e && (fl = 0)),
                sa(e));
            }
            function Mb(e, t) {
              (t === 0 && (t = Li()),
                (e = en(e, t)),
                e !== null && (Ka(e, t), sa(e)));
            }
            function mx(e) {
              var t = e.memoizedState,
                n = 0;
              (t !== null && (n = t.retryLane), Mb(e, n));
            }
            function px(e, t) {
              var n = 0;
              switch (e.tag) {
                case 13:
                  var a = e.stateNode,
                    s = e.memoizedState;
                  s !== null && (n = s.retryLane);
                  break;
                case 19:
                  a = e.stateNode;
                  break;
                case 22:
                  a = e.stateNode._retryCache;
                  break;
                default:
                  throw Error(
                    'Pinged unknown suspense boundary type. This is probably a bug in React.'
                  );
              }
              (a !== null && a.delete(t), Mb(e, n));
            }
            function ff(e, t, n) {
              if ((t.subtreeFlags & 67117056) !== 0)
                for (t = t.child; t !== null; ) {
                  var a = e,
                    s = t,
                    c = s.type === Sc;
                  ((c = n || c),
                    s.tag !== 22
                      ? s.flags & 67108864
                        ? c && he(s, Ob, a, s, (s.mode & gv) === Ke)
                        : ff(a, s, c)
                      : s.memoizedState === null &&
                        (c && s.flags & 8192
                          ? he(s, Ob, a, s)
                          : s.subtreeFlags & 67108864 && he(s, ff, a, s, c)),
                    (t = t.sibling));
                }
            }
            function Ob(e, t) {
              var n =
                2 < arguments.length && arguments[2] !== void 0
                  ? arguments[2]
                  : !0;
              Le(!0);
              try {
                (ib(t),
                  n && db(t),
                  lb(e, t.alternate, t, !1),
                  n && ob(e, t, 0, null, !1));
              } finally {
                Le(!1);
              }
            }
            function kb(e) {
              var t = !0;
              (e.current.mode & (It | Qn) || (t = !1), ff(e, e.current, t));
            }
            function _b(e) {
              if ((Pe & Xt) === yn) {
                var t = e.tag;
                if (
                  t === 3 ||
                  t === 1 ||
                  t === 0 ||
                  t === 11 ||
                  t === 14 ||
                  t === 15
                ) {
                  if (((t = J(e) || 'ReactComponent'), Fc !== null)) {
                    if (Fc.has(t)) return;
                    Fc.add(t);
                  } else Fc = new Set([t]);
                  he(e, function () {
                    console.error(
                      "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead."
                    );
                  });
                }
              }
            }
            function uo(e, t) {
              Xn &&
                e.memoizedUpdaters.forEach(function (n) {
                  Vs(e, n, t);
                });
            }
            function hx(e, t) {
              var n = z.actQueue;
              return n !== null ? (n.push(t), Aw) : Pf(e, t);
            }
            function gx(e) {
              mb() &&
                z.actQueue === null &&
                he(e, function () {
                  console.error(
                    `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
                    J(e)
                  );
                });
            }
            function sa(e) {
              (e !== Ds &&
                e.next === null &&
                (Ds === null ? (Kc = Ds = e) : (Ds = Ds.next = e)),
                (Jc = !0),
                z.actQueue !== null
                  ? qm || ((qm = !0), Lb())
                  : Gm || ((Gm = !0), Lb()));
            }
            function fo(e, t) {
              if (!Ym && Jc) {
                Ym = !0;
                do
                  for (var n = !1, a = Kc; a !== null; ) {
                    if (e !== 0) {
                      var s = a.pendingLanes;
                      if (s === 0) var c = 0;
                      else {
                        var f = a.suspendedLanes,
                          b = a.pingedLanes;
                        ((c = (1 << (31 - $t(42 | e) + 1)) - 1),
                          (c &= s & ~(f & ~b)),
                          (c =
                            c & 201326741
                              ? (c & 201326741) | 1
                              : c
                                ? c | 2
                                : 0));
                      }
                      c !== 0 && ((n = !0), Bb(a, c));
                    } else
                      ((c = _e),
                        (c = xa(
                          a,
                          a === Ze ? c : 0,
                          a.cancelPendingCommit !== null ||
                            a.timeoutHandle !== bl
                        )),
                        (c & 3) === 0 || Fa(a, c) || ((n = !0), Bb(a, c)));
                    a = a.next;
                  }
                while (n);
                Ym = !1;
              }
            }
            function bx() {
              mf();
            }
            function mf() {
              Jc = qm = Gm = !1;
              var e = 0;
              hl !== 0 && (Nx() && (e = hl), (hl = 0));
              for (var t = ca(), n = null, a = Kc; a !== null; ) {
                var s = a.next,
                  c = jb(a, t);
                (c === 0
                  ? ((a.next = null),
                    n === null ? (Kc = s) : (n.next = s),
                    s === null && (Ds = n))
                  : ((n = a), (e !== 0 || (c & 3) !== 0) && (Jc = !0)),
                  (a = s));
              }
              fo(e);
            }
            function jb(e, t) {
              for (
                var n = e.suspendedLanes,
                  a = e.pingedLanes,
                  s = e.expirationTimes,
                  c = e.pendingLanes & -62914561;
                0 < c;
              ) {
                var f = 31 - $t(c),
                  b = 1 << f,
                  w = s[f];
                (w === -1
                  ? ((b & n) === 0 || (b & a) !== 0) && (s[f] = Ou(b, t))
                  : w <= t && (e.expiredLanes |= b),
                  (c &= ~b));
              }
              if (
                ((t = Ze),
                (n = _e),
                (n = xa(
                  e,
                  e === t ? n : 0,
                  e.cancelPendingCommit !== null || e.timeoutHandle !== bl
                )),
                (a = e.callbackNode),
                n === 0 ||
                  (e === t && (Ge === ul || Ge === dl)) ||
                  e.cancelPendingCommit !== null)
              )
                return (
                  a !== null && pf(a),
                  (e.callbackNode = null),
                  (e.callbackPriority = 0)
                );
              if ((n & 3) === 0 || Fa(e, n)) {
                if (
                  ((t = n & -n),
                  t !== e.callbackPriority || (z.actQueue !== null && a !== Xm))
                )
                  pf(a);
                else return t;
                switch (Tl(n)) {
                  case On:
                  case da:
                    n = qf;
                    break;
                  case ja:
                    n = ql;
                    break;
                  case Dc:
                    n = Yf;
                    break;
                  default:
                    n = ql;
                }
                return (
                  (a = Vb.bind(null, e)),
                  z.actQueue !== null
                    ? (z.actQueue.push(a), (n = Xm))
                    : (n = Pf(n, a)),
                  (e.callbackPriority = t),
                  (e.callbackNode = n),
                  t
                );
              }
              return (
                a !== null && pf(a),
                (e.callbackPriority = 2),
                (e.callbackNode = null),
                2
              );
            }
            function Vb(e, t) {
              if (((zc = Lc = !1), Lt !== ml && Lt !== Um))
                return (
                  (e.callbackNode = null),
                  (e.callbackPriority = 0),
                  null
                );
              var n = e.callbackNode;
              if (co() && e.callbackNode !== n) return null;
              var a = _e;
              return (
                (a = xa(
                  e,
                  e === Ze ? a : 0,
                  e.cancelPendingCommit !== null || e.timeoutHandle !== bl
                )),
                a === 0
                  ? null
                  : (hb(e, a, t),
                    jb(e, ca()),
                    e.callbackNode != null && e.callbackNode === n
                      ? Vb.bind(null, e)
                      : null)
              );
            }
            function Bb(e, t) {
              if (co()) return null;
              ((Lc = zc), (zc = !1), hb(e, t, !0));
            }
            function pf(e) {
              e !== Xm && e !== null && iN(e);
            }
            function Lb() {
              (z.actQueue !== null &&
                z.actQueue.push(function () {
                  return (mf(), null);
                }),
                zw(function () {
                  (Pe & (Xt | Jn)) !== yn ? Pf(Gf, bx) : mf();
                }));
            }
            function hf() {
              return (hl === 0 && (hl = Me()), hl);
            }
            function zb(e) {
              return e == null || typeof e == 'symbol' || typeof e == 'boolean'
                ? null
                : typeof e == 'function'
                  ? e
                  : (ue(e, 'action'), Ws('' + e));
            }
            function Hb(e, t) {
              var n = t.ownerDocument.createElement('input');
              return (
                (n.name = t.name),
                (n.value = t.value),
                e.id && n.setAttribute('form', e.id),
                t.parentNode.insertBefore(n, t),
                (e = new FormData(e)),
                n.parentNode.removeChild(n),
                e
              );
            }
            function yx(e, t, n, a, s) {
              if (t === 'submit' && n && n.stateNode === s) {
                var c = zb((s[an] || null).action),
                  f = a.submitter;
                f &&
                  ((t = (t = f[an] || null)
                    ? zb(t.formAction)
                    : f.getAttribute('formAction')),
                  t !== null && ((c = t), (f = null)));
                var b = new Mc('action', 'action', null, a, s);
                e.push({
                  event: b,
                  listeners: [
                    {
                      instance: null,
                      listener: function () {
                        if (a.defaultPrevented) {
                          if (hl !== 0) {
                            var w = f ? Hb(s, f) : new FormData(s),
                              T = {
                                pending: !0,
                                data: w,
                                method: s.method,
                                action: c,
                              };
                            (Object.freeze(T), _d(n, T, null, w));
                          }
                        } else
                          typeof c == 'function' &&
                            (b.preventDefault(),
                            (w = f ? Hb(s, f) : new FormData(s)),
                            (T = {
                              pending: !0,
                              data: w,
                              method: s.method,
                              action: c,
                            }),
                            Object.freeze(T),
                            _d(n, T, c, w));
                      },
                      currentTarget: s,
                    },
                  ],
                });
              }
            }
            function cc(e, t, n) {
              e.currentTarget = n;
              try {
                t(e);
              } catch (a) {
                Rm(a);
              }
              e.currentTarget = null;
            }
            function Ub(e, t) {
              t = (t & 4) !== 0;
              for (var n = 0; n < e.length; n++) {
                var a = e[n];
                e: {
                  var s = void 0,
                    c = a.event;
                  if (((a = a.listeners), t))
                    for (var f = a.length - 1; 0 <= f; f--) {
                      var b = a[f],
                        w = b.instance,
                        T = b.currentTarget;
                      if (
                        ((b = b.listener), w !== s && c.isPropagationStopped())
                      )
                        break e;
                      (w !== null ? he(w, cc, c, b, T) : cc(c, b, T), (s = w));
                    }
                  else
                    for (f = 0; f < a.length; f++) {
                      if (
                        ((b = a[f]),
                        (w = b.instance),
                        (T = b.currentTarget),
                        (b = b.listener),
                        w !== s && c.isPropagationStopped())
                      )
                        break e;
                      (w !== null ? he(w, cc, c, b, T) : cc(c, b, T), (s = w));
                    }
                }
              }
            }
            function je(e, t) {
              Qm.has(e) ||
                console.error(
                  'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
                  e
                );
              var n = t[Xf];
              n === void 0 && (n = t[Xf] = new Set());
              var a = e + '__bubble';
              n.has(a) || (Ib(t, e, 2, !1), n.add(a));
            }
            function gf(e, t, n) {
              Qm.has(e) &&
                !t &&
                console.error(
                  'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
                  e
                );
              var a = 0;
              (t && (a |= 4), Ib(n, e, a, t));
            }
            function bf(e) {
              if (!e[eu]) {
                ((e[eu] = !0),
                  Ey.forEach(function (n) {
                    n !== 'selectionchange' &&
                      (Qm.has(n) || gf(n, !1, e), gf(n, !0, e));
                  }));
                var t = e.nodeType === 9 ? e : e.ownerDocument;
                t === null ||
                  t[eu] ||
                  ((t[eu] = !0), gf('selectionchange', !1, t));
              }
            }
            function Ib(e, t, n, a) {
              switch (gy(t)) {
                case On:
                  var s = Xx;
                  break;
                case da:
                  s = Qx;
                  break;
                default:
                  s = kf;
              }
              ((n = s.bind(null, t, n, e)),
                (s = void 0),
                !nm ||
                  (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') ||
                  (s = !0),
                a
                  ? s !== void 0
                    ? e.addEventListener(t, n, { capture: !0, passive: s })
                    : e.addEventListener(t, n, !0)
                  : s !== void 0
                    ? e.addEventListener(t, n, { passive: s })
                    : e.addEventListener(t, n, !1));
            }
            function yf(e, t, n, a, s) {
              var c = a;
              if ((t & 1) === 0 && (t & 2) === 0 && a !== null)
                e: for (;;) {
                  if (a === null) return;
                  var f = a.tag;
                  if (f === 3 || f === 4) {
                    var b = a.stateNode.containerInfo;
                    if (b === s) break;
                    if (f === 4)
                      for (f = a.return; f !== null; ) {
                        var w = f.tag;
                        if (
                          (w === 3 || w === 4) &&
                          f.stateNode.containerInfo === s
                        )
                          return;
                        f = f.return;
                      }
                    for (; b !== null; ) {
                      if (((f = Pn(b)), f === null)) return;
                      if (
                        ((w = f.tag),
                        w === 5 || w === 6 || w === 26 || w === 27)
                      ) {
                        a = c = f;
                        continue e;
                      }
                      b = b.parentNode;
                    }
                  }
                  a = a.return;
                }
              mh(function () {
                var T = c,
                  j = $u(n),
                  H = [];
                e: {
                  var _ = hv.get(e);
                  if (_ !== void 0) {
                    var I = Mc,
                      fe = e;
                    switch (e) {
                      case 'keypress':
                        if (Dr(n) === 0) break e;
                      case 'keydown':
                      case 'keyup':
                        I = GN;
                        break;
                      case 'focusin':
                        ((fe = 'focus'), (I = sm));
                        break;
                      case 'focusout':
                        ((fe = 'blur'), (I = sm));
                        break;
                      case 'beforeblur':
                      case 'afterblur':
                        I = sm;
                        break;
                      case 'click':
                        if (n.button === 2) break e;
                      case 'auxclick':
                      case 'dblclick':
                      case 'mousedown':
                      case 'mousemove':
                      case 'mouseup':
                      case 'mouseout':
                      case 'mouseover':
                      case 'contextmenu':
                        I = tv;
                        break;
                      case 'drag':
                      case 'dragend':
                      case 'dragenter':
                      case 'dragexit':
                      case 'dragleave':
                      case 'dragover':
                      case 'dragstart':
                      case 'drop':
                        I = _N;
                        break;
                      case 'touchcancel':
                      case 'touchend':
                      case 'touchmove':
                      case 'touchstart':
                        I = XN;
                        break;
                      case dv:
                      case fv:
                      case mv:
                        I = BN;
                        break;
                      case pv:
                        I = ZN;
                        break;
                      case 'scroll':
                      case 'scrollend':
                        I = ON;
                        break;
                      case 'wheel':
                        I = KN;
                        break;
                      case 'copy':
                      case 'cut':
                      case 'paste':
                        I = zN;
                        break;
                      case 'gotpointercapture':
                      case 'lostpointercapture':
                      case 'pointercancel':
                      case 'pointerdown':
                      case 'pointermove':
                      case 'pointerout':
                      case 'pointerover':
                      case 'pointerup':
                        I = av;
                        break;
                      case 'toggle':
                      case 'beforetoggle':
                        I = ew;
                    }
                    var be = (t & 4) !== 0,
                      Fe = !be && (e === 'scroll' || e === 'scrollend'),
                      Ve = be ? (_ !== null ? _ + 'Capture' : null) : _;
                    be = [];
                    for (var C = T, A; C !== null; ) {
                      var R = C;
                      if (
                        ((A = R.stateNode),
                        (R = R.tag),
                        (R !== 5 && R !== 26 && R !== 27) ||
                          A === null ||
                          Ve === null ||
                          ((R = $s(C, Ve)), R != null && be.push(mo(C, R, A))),
                        Fe)
                      )
                        break;
                      C = C.return;
                    }
                    0 < be.length &&
                      ((_ = new I(_, fe, null, n, j)),
                      H.push({ event: _, listeners: be }));
                  }
                }
                if ((t & 7) === 0) {
                  e: {
                    if (
                      ((_ = e === 'mouseover' || e === 'pointerover'),
                      (I = e === 'mouseout' || e === 'pointerout'),
                      _ &&
                        n !== wo &&
                        (fe = n.relatedTarget || n.fromElement) &&
                        (Pn(fe) || fe[pi]))
                    )
                      break e;
                    if (
                      (I || _) &&
                      ((_ =
                        j.window === j
                          ? j
                          : (_ = j.ownerDocument)
                            ? _.defaultView || _.parentWindow
                            : window),
                      I
                        ? ((fe = n.relatedTarget || n.toElement),
                          (I = T),
                          (fe = fe ? Pn(fe) : null),
                          fe !== null &&
                            ((Fe = V(fe)),
                            (be = fe.tag),
                            fe !== Fe || (be !== 5 && be !== 27 && be !== 6)) &&
                            (fe = null))
                        : ((I = null), (fe = T)),
                      I !== fe)
                    ) {
                      if (
                        ((be = tv),
                        (R = 'onMouseLeave'),
                        (Ve = 'onMouseEnter'),
                        (C = 'mouse'),
                        (e === 'pointerout' || e === 'pointerover') &&
                          ((be = av),
                          (R = 'onPointerLeave'),
                          (Ve = 'onPointerEnter'),
                          (C = 'pointer')),
                        (Fe = I == null ? _ : ei(I)),
                        (A = fe == null ? _ : ei(fe)),
                        (_ = new be(R, C + 'leave', I, n, j)),
                        (_.target = Fe),
                        (_.relatedTarget = A),
                        (R = null),
                        Pn(j) === T &&
                          ((be = new be(Ve, C + 'enter', fe, n, j)),
                          (be.target = A),
                          (be.relatedTarget = Fe),
                          (R = be)),
                        (Fe = R),
                        I && fe)
                      )
                        t: {
                          for (be = I, Ve = fe, C = 0, A = be; A; A = Il(A))
                            C++;
                          for (A = 0, R = Ve; R; R = Il(R)) A++;
                          for (; 0 < C - A; ) ((be = Il(be)), C--);
                          for (; 0 < A - C; ) ((Ve = Il(Ve)), A--);
                          for (; C--; ) {
                            if (
                              be === Ve ||
                              (Ve !== null && be === Ve.alternate)
                            )
                              break t;
                            ((be = Il(be)), (Ve = Il(Ve)));
                          }
                          be = null;
                        }
                      else be = null;
                      (I !== null && Wb(H, _, I, be, !1),
                        fe !== null && Fe !== null && Wb(H, Fe, fe, be, !0));
                    }
                  }
                  e: {
                    if (
                      ((_ = T ? ei(T) : window),
                      (I = _.nodeName && _.nodeName.toLowerCase()),
                      I === 'select' || (I === 'input' && _.type === 'file'))
                    )
                      var $ = Sh;
                    else if (yh(_))
                      if (cv) $ = zS;
                      else {
                        $ = BS;
                        var ae = VS;
                      }
                    else
                      ((I = _.nodeName),
                        !I ||
                        I.toLowerCase() !== 'input' ||
                        (_.type !== 'checkbox' && _.type !== 'radio')
                          ? T && Is(T.elementType) && ($ = Sh)
                          : ($ = LS));
                    if ($ && ($ = $(e, T))) {
                      vh(H, $, n, j);
                      break e;
                    }
                    (ae && ae(e, _, T),
                      e === 'focusout' &&
                        T &&
                        _.type === 'number' &&
                        T.memoizedProps.value != null &&
                        Lu(_, 'number', _.value));
                  }
                  switch (((ae = T ? ei(T) : window), e)) {
                    case 'focusin':
                      (yh(ae) || ae.contentEditable === 'true') &&
                        ((es = ae), (rm = T), (Mo = null));
                      break;
                    case 'focusout':
                      Mo = rm = es = null;
                      break;
                    case 'mousedown':
                      cm = !0;
                      break;
                    case 'contextmenu':
                    case 'mouseup':
                    case 'dragend':
                      ((cm = !1), Ch(H, n, j));
                      break;
                    case 'selectionchange':
                      if (iw) break;
                    case 'keydown':
                    case 'keyup':
                      Ch(H, n, j);
                  }
                  var xe;
                  if (om)
                    e: {
                      switch (e) {
                        case 'compositionstart':
                          var de = 'onCompositionStart';
                          break e;
                        case 'compositionend':
                          de = 'onCompositionEnd';
                          break e;
                        case 'compositionupdate':
                          de = 'onCompositionUpdate';
                          break e;
                      }
                      de = void 0;
                    }
                  else
                    Jl
                      ? gh(e, n) && (de = 'onCompositionEnd')
                      : e === 'keydown' &&
                        n.keyCode === iv &&
                        (de = 'onCompositionStart');
                  (de &&
                    (lv &&
                      n.locale !== 'ko' &&
                      (Jl || de !== 'onCompositionStart'
                        ? de === 'onCompositionEnd' && Jl && (xe = ph())
                        : ((hi = j),
                          (am = 'value' in hi ? hi.value : hi.textContent),
                          (Jl = !0))),
                    (ae = uc(T, de)),
                    0 < ae.length &&
                      ((de = new nv(de, e, null, n, j)),
                      H.push({ event: de, listeners: ae }),
                      xe
                        ? (de.data = xe)
                        : ((xe = bh(n)), xe !== null && (de.data = xe)))),
                    (xe = nw ? OS(e, n) : kS(e, n)) &&
                      ((de = uc(T, 'onBeforeInput')),
                      0 < de.length &&
                        ((ae = new UN(
                          'onBeforeInput',
                          'beforeinput',
                          null,
                          n,
                          j
                        )),
                        H.push({ event: ae, listeners: de }),
                        (ae.data = xe))),
                    yx(H, e, T, n, j));
                }
                Ub(H, t);
              });
            }
            function mo(e, t, n) {
              return { instance: e, listener: t, currentTarget: n };
            }
            function uc(e, t) {
              for (var n = t + 'Capture', a = []; e !== null; ) {
                var s = e,
                  c = s.stateNode;
                if (
                  ((s = s.tag),
                  (s !== 5 && s !== 26 && s !== 27) ||
                    c === null ||
                    ((s = $s(e, n)),
                    s != null && a.unshift(mo(e, s, c)),
                    (s = $s(e, t)),
                    s != null && a.push(mo(e, s, c))),
                  e.tag === 3)
                )
                  return a;
                e = e.return;
              }
              return [];
            }
            function Il(e) {
              if (e === null) return null;
              do e = e.return;
              while (e && e.tag !== 5 && e.tag !== 27);
              return e || null;
            }
            function Wb(e, t, n, a, s) {
              for (var c = t._reactName, f = []; n !== null && n !== a; ) {
                var b = n,
                  w = b.alternate,
                  T = b.stateNode;
                if (((b = b.tag), w !== null && w === a)) break;
                ((b !== 5 && b !== 26 && b !== 27) ||
                  T === null ||
                  ((w = T),
                  s
                    ? ((T = $s(n, c)), T != null && f.unshift(mo(n, T, w)))
                    : s || ((T = $s(n, c)), T != null && f.push(mo(n, T, w)))),
                  (n = n.return));
              }
              f.length !== 0 && e.push({ event: t, listeners: f });
            }
            function vf(e, t) {
              (CS(e, t),
                (e !== 'input' && e !== 'textarea' && e !== 'select') ||
                  t == null ||
                  t.value !== null ||
                  Jy ||
                  ((Jy = !0),
                  e === 'select' && t.multiple
                    ? console.error(
                        '`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.',
                        e
                      )
                    : console.error(
                        '`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.',
                        e
                      )));
              var n = {
                registrationNameDependencies: el,
                possibleRegistrationNames: Qf,
              };
              (Is(e) || typeof t.is == 'string' || RS(e, t, n),
                t.contentEditable &&
                  !t.suppressContentEditableWarning &&
                  t.children != null &&
                  console.error(
                    'A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.'
                  ));
            }
            function Tt(e, t, n, a) {
              t !== n && ((n = ri(n)), ri(t) !== n && (a[e] = t));
            }
            function vx(e, t, n) {
              t.forEach(function (a) {
                n[Gb(a)] = a === 'style' ? xf(e) : e.getAttribute(a);
              });
            }
            function oa(e, t) {
              t === !1
                ? console.error(
                    'Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                    e,
                    e,
                    e
                  )
                : console.error(
                    'Expected `%s` listener to be a function, instead got a value of `%s` type.',
                    e,
                    typeof t
                  );
            }
            function $b(e, t) {
              return (
                (e =
                  e.namespaceURI === Cc || e.namespaceURI === Ql
                    ? e.ownerDocument.createElementNS(e.namespaceURI, e.tagName)
                    : e.ownerDocument.createElement(e.tagName)),
                (e.innerHTML = t),
                e.innerHTML
              );
            }
            function ri(e) {
              return (
                W() &&
                  (console.error(
                    'The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.',
                    me(e)
                  ),
                  re(e)),
                (typeof e == 'string' ? e : '' + e)
                  .replace(
                    Rw,
                    `
`
                  )
                  .replace(Mw, '')
              );
            }
            function Pb(e, t) {
              return ((t = ri(t)), ri(e) === t);
            }
            function dc() {}
            function Xe(e, t, n, a, s, c) {
              switch (n) {
                case 'children':
                  typeof a == 'string'
                    ? (Er(a, t, !1),
                      t === 'body' ||
                        (t === 'textarea' && a === '') ||
                        Us(e, a))
                    : (typeof a == 'number' || typeof a == 'bigint') &&
                      (Er('' + a, t, !1), t !== 'body' && Us(e, '' + a));
                  break;
                case 'className':
                  Te(e, 'class', a);
                  break;
                case 'tabIndex':
                  Te(e, 'tabindex', a);
                  break;
                case 'dir':
                case 'role':
                case 'viewBox':
                case 'width':
                case 'height':
                  Te(e, n, a);
                  break;
                case 'style':
                  uh(e, a, c);
                  break;
                case 'data':
                  if (t !== 'object') {
                    Te(e, 'data', a);
                    break;
                  }
                case 'src':
                case 'href':
                  if (a === '' && (t !== 'a' || n !== 'href')) {
                    (console.error(
                      n === 'src'
                        ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.'
                        : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      n,
                      n
                    ),
                      e.removeAttribute(n));
                    break;
                  }
                  if (
                    a == null ||
                    typeof a == 'function' ||
                    typeof a == 'symbol' ||
                    typeof a == 'boolean'
                  ) {
                    e.removeAttribute(n);
                    break;
                  }
                  (ue(a, n), (a = Ws('' + a)), e.setAttribute(n, a));
                  break;
                case 'action':
                case 'formAction':
                  if (
                    (a != null &&
                      (t === 'form'
                        ? n === 'formAction'
                          ? console.error(
                              'You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.'
                            )
                          : typeof a == 'function' &&
                            ((s.encType == null && s.method == null) ||
                              au ||
                              ((au = !0),
                              console.error(
                                'Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.'
                              )),
                            s.target == null ||
                              nu ||
                              ((nu = !0),
                              console.error(
                                'Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window.'
                              )))
                        : t === 'input' || t === 'button'
                          ? n === 'action'
                            ? console.error(
                                'You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.'
                              )
                            : t !== 'input' ||
                                s.type === 'submit' ||
                                s.type === 'image' ||
                                tu
                              ? t !== 'button' ||
                                s.type == null ||
                                s.type === 'submit' ||
                                tu
                                ? typeof a == 'function' &&
                                  (s.name == null ||
                                    R1 ||
                                    ((R1 = !0),
                                    console.error(
                                      'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
                                    )),
                                  (s.formEncType == null &&
                                    s.formMethod == null) ||
                                    au ||
                                    ((au = !0),
                                    console.error(
                                      'Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.'
                                    )),
                                  s.formTarget == null ||
                                    nu ||
                                    ((nu = !0),
                                    console.error(
                                      'Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window.'
                                    )))
                                : ((tu = !0),
                                  console.error(
                                    'A button can only specify a formAction along with type="submit" or no type.'
                                  ))
                              : ((tu = !0),
                                console.error(
                                  'An input can only specify a formAction along with type="submit" or type="image".'
                                ))
                          : console.error(
                              n === 'action'
                                ? 'You can only pass the action prop to <form>.'
                                : 'You can only pass the formAction prop to <input> or <button>.'
                            )),
                    typeof a == 'function')
                  ) {
                    e.setAttribute(
                      n,
                      "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                    );
                    break;
                  } else
                    typeof c == 'function' &&
                      (n === 'formAction'
                        ? (t !== 'input' && Xe(e, t, 'name', s.name, s, null),
                          Xe(e, t, 'formEncType', s.formEncType, s, null),
                          Xe(e, t, 'formMethod', s.formMethod, s, null),
                          Xe(e, t, 'formTarget', s.formTarget, s, null))
                        : (Xe(e, t, 'encType', s.encType, s, null),
                          Xe(e, t, 'method', s.method, s, null),
                          Xe(e, t, 'target', s.target, s, null)));
                  if (
                    a == null ||
                    typeof a == 'symbol' ||
                    typeof a == 'boolean'
                  ) {
                    e.removeAttribute(n);
                    break;
                  }
                  (ue(a, n), (a = Ws('' + a)), e.setAttribute(n, a));
                  break;
                case 'onClick':
                  a != null &&
                    (typeof a != 'function' && oa(n, a), (e.onclick = dc));
                  break;
                case 'onScroll':
                  a != null &&
                    (typeof a != 'function' && oa(n, a), je('scroll', e));
                  break;
                case 'onScrollEnd':
                  a != null &&
                    (typeof a != 'function' && oa(n, a), je('scrollend', e));
                  break;
                case 'dangerouslySetInnerHTML':
                  if (a != null) {
                    if (typeof a != 'object' || !('__html' in a))
                      throw Error(
                        '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.'
                      );
                    if (((n = a.__html), n != null)) {
                      if (s.children != null)
                        throw Error(
                          'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
                        );
                      e.innerHTML = n;
                    }
                  }
                  break;
                case 'multiple':
                  e.multiple =
                    a && typeof a != 'function' && typeof a != 'symbol';
                  break;
                case 'muted':
                  e.muted = a && typeof a != 'function' && typeof a != 'symbol';
                  break;
                case 'suppressContentEditableWarning':
                case 'suppressHydrationWarning':
                case 'defaultValue':
                case 'defaultChecked':
                case 'innerHTML':
                case 'ref':
                  break;
                case 'autoFocus':
                  break;
                case 'xlinkHref':
                  if (
                    a == null ||
                    typeof a == 'function' ||
                    typeof a == 'boolean' ||
                    typeof a == 'symbol'
                  ) {
                    e.removeAttribute('xlink:href');
                    break;
                  }
                  (ue(a, n),
                    (n = Ws('' + a)),
                    e.setAttributeNS(gl, 'xlink:href', n));
                  break;
                case 'contentEditable':
                case 'spellCheck':
                case 'draggable':
                case 'value':
                case 'autoReverse':
                case 'externalResourcesRequired':
                case 'focusable':
                case 'preserveAlpha':
                  a != null && typeof a != 'function' && typeof a != 'symbol'
                    ? (ue(a, n), e.setAttribute(n, '' + a))
                    : e.removeAttribute(n);
                  break;
                case 'inert':
                  a !== '' ||
                    iu[n] ||
                    ((iu[n] = !0),
                    console.error(
                      'Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.',
                      n
                    ));
                case 'allowFullScreen':
                case 'async':
                case 'autoPlay':
                case 'controls':
                case 'default':
                case 'defer':
                case 'disabled':
                case 'disablePictureInPicture':
                case 'disableRemotePlayback':
                case 'formNoValidate':
                case 'hidden':
                case 'loop':
                case 'noModule':
                case 'noValidate':
                case 'open':
                case 'playsInline':
                case 'readOnly':
                case 'required':
                case 'reversed':
                case 'scoped':
                case 'seamless':
                case 'itemScope':
                  a && typeof a != 'function' && typeof a != 'symbol'
                    ? e.setAttribute(n, '')
                    : e.removeAttribute(n);
                  break;
                case 'capture':
                case 'download':
                  a === !0
                    ? e.setAttribute(n, '')
                    : a !== !1 &&
                        a != null &&
                        typeof a != 'function' &&
                        typeof a != 'symbol'
                      ? (ue(a, n), e.setAttribute(n, a))
                      : e.removeAttribute(n);
                  break;
                case 'cols':
                case 'rows':
                case 'size':
                case 'span':
                  a != null &&
                  typeof a != 'function' &&
                  typeof a != 'symbol' &&
                  !isNaN(a) &&
                  1 <= a
                    ? (ue(a, n), e.setAttribute(n, a))
                    : e.removeAttribute(n);
                  break;
                case 'rowSpan':
                case 'start':
                  a == null ||
                  typeof a == 'function' ||
                  typeof a == 'symbol' ||
                  isNaN(a)
                    ? e.removeAttribute(n)
                    : (ue(a, n), e.setAttribute(n, a));
                  break;
                case 'popover':
                  (je('beforetoggle', e), je('toggle', e), ze(e, 'popover', a));
                  break;
                case 'xlinkActuate':
                  Dt(e, gl, 'xlink:actuate', a);
                  break;
                case 'xlinkArcrole':
                  Dt(e, gl, 'xlink:arcrole', a);
                  break;
                case 'xlinkRole':
                  Dt(e, gl, 'xlink:role', a);
                  break;
                case 'xlinkShow':
                  Dt(e, gl, 'xlink:show', a);
                  break;
                case 'xlinkTitle':
                  Dt(e, gl, 'xlink:title', a);
                  break;
                case 'xlinkType':
                  Dt(e, gl, 'xlink:type', a);
                  break;
                case 'xmlBase':
                  Dt(e, Zm, 'xml:base', a);
                  break;
                case 'xmlLang':
                  Dt(e, Zm, 'xml:lang', a);
                  break;
                case 'xmlSpace':
                  Dt(e, Zm, 'xml:space', a);
                  break;
                case 'is':
                  (c != null &&
                    console.error(
                      'Cannot update the "is" prop after it has been initialized.'
                    ),
                    ze(e, 'is', a));
                  break;
                case 'innerText':
                case 'textContent':
                  break;
                case 'popoverTarget':
                  M1 ||
                    a == null ||
                    typeof a != 'object' ||
                    ((M1 = !0),
                    console.error(
                      'The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.',
                      a
                    ));
                default:
                  !(2 < n.length) ||
                  (n[0] !== 'o' && n[0] !== 'O') ||
                  (n[1] !== 'n' && n[1] !== 'N')
                    ? ((n = dh(n)), ze(e, n, a))
                    : el.hasOwnProperty(n) &&
                      a != null &&
                      typeof a != 'function' &&
                      oa(n, a);
              }
            }
            function Sf(e, t, n, a, s, c) {
              switch (n) {
                case 'style':
                  uh(e, a, c);
                  break;
                case 'dangerouslySetInnerHTML':
                  if (a != null) {
                    if (typeof a != 'object' || !('__html' in a))
                      throw Error(
                        '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.'
                      );
                    if (((n = a.__html), n != null)) {
                      if (s.children != null)
                        throw Error(
                          'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
                        );
                      e.innerHTML = n;
                    }
                  }
                  break;
                case 'children':
                  typeof a == 'string'
                    ? Us(e, a)
                    : (typeof a == 'number' || typeof a == 'bigint') &&
                      Us(e, '' + a);
                  break;
                case 'onScroll':
                  a != null &&
                    (typeof a != 'function' && oa(n, a), je('scroll', e));
                  break;
                case 'onScrollEnd':
                  a != null &&
                    (typeof a != 'function' && oa(n, a), je('scrollend', e));
                  break;
                case 'onClick':
                  a != null &&
                    (typeof a != 'function' && oa(n, a), (e.onclick = dc));
                  break;
                case 'suppressContentEditableWarning':
                case 'suppressHydrationWarning':
                case 'innerHTML':
                case 'ref':
                  break;
                case 'innerText':
                case 'textContent':
                  break;
                default:
                  if (el.hasOwnProperty(n))
                    a != null && typeof a != 'function' && oa(n, a);
                  else
                    e: {
                      if (
                        n[0] === 'o' &&
                        n[1] === 'n' &&
                        ((s = n.endsWith('Capture')),
                        (t = n.slice(2, s ? n.length - 7 : void 0)),
                        (c = e[an] || null),
                        (c = c != null ? c[n] : null),
                        typeof c == 'function' &&
                          e.removeEventListener(t, c, s),
                        typeof a == 'function')
                      ) {
                        (typeof c != 'function' &&
                          c !== null &&
                          (n in e
                            ? (e[n] = null)
                            : e.hasAttribute(n) && e.removeAttribute(n)),
                          e.addEventListener(t, a, s));
                        break e;
                      }
                      n in e
                        ? (e[n] = a)
                        : a === !0
                          ? e.setAttribute(n, '')
                          : ze(e, n, a);
                    }
              }
            }
            function _t(e, t, n) {
              switch ((vf(t, n), t)) {
                case 'div':
                case 'span':
                case 'svg':
                case 'path':
                case 'a':
                case 'g':
                case 'p':
                case 'li':
                  break;
                case 'img':
                  (je('error', e), je('load', e));
                  var a = !1,
                    s = !1,
                    c;
                  for (c in n)
                    if (n.hasOwnProperty(c)) {
                      var f = n[c];
                      if (f != null)
                        switch (c) {
                          case 'src':
                            a = !0;
                            break;
                          case 'srcSet':
                            s = !0;
                            break;
                          case 'children':
                          case 'dangerouslySetInnerHTML':
                            throw Error(
                              t +
                                ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                            );
                          default:
                            Xe(e, t, c, f, n, null);
                        }
                    }
                  (s && Xe(e, t, 'srcSet', n.srcSet, n, null),
                    a && Xe(e, t, 'src', n.src, n, null));
                  return;
                case 'input':
                  (pe('input', n), je('invalid', e));
                  var b = (c = f = s = null),
                    w = null,
                    T = null;
                  for (a in n)
                    if (n.hasOwnProperty(a)) {
                      var j = n[a];
                      if (j != null)
                        switch (a) {
                          case 'name':
                            s = j;
                            break;
                          case 'type':
                            f = j;
                            break;
                          case 'checked':
                            w = j;
                            break;
                          case 'defaultChecked':
                            T = j;
                            break;
                          case 'value':
                            c = j;
                            break;
                          case 'defaultValue':
                            b = j;
                            break;
                          case 'children':
                          case 'dangerouslySetInnerHTML':
                            if (j != null)
                              throw Error(
                                t +
                                  ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                              );
                            break;
                          default:
                            Xe(e, t, a, j, n, null);
                        }
                    }
                  (Xp(e, n), Qp(e, c, b, w, T, f, s, !1), xr(e));
                  return;
                case 'select':
                  (pe('select', n), je('invalid', e), (a = f = c = null));
                  for (s in n)
                    if (n.hasOwnProperty(s) && ((b = n[s]), b != null))
                      switch (s) {
                        case 'value':
                          c = b;
                          break;
                        case 'defaultValue':
                          f = b;
                          break;
                        case 'multiple':
                          a = b;
                        default:
                          Xe(e, t, s, b, n, null);
                      }
                  (Kp(e, n),
                    (t = c),
                    (n = f),
                    (e.multiple = !!a),
                    t != null
                      ? Al(e, !!a, t, !1)
                      : n != null && Al(e, !!a, n, !0));
                  return;
                case 'textarea':
                  (pe('textarea', n), je('invalid', e), (c = s = a = null));
                  for (f in n)
                    if (n.hasOwnProperty(f) && ((b = n[f]), b != null))
                      switch (f) {
                        case 'value':
                          a = b;
                          break;
                        case 'defaultValue':
                          s = b;
                          break;
                        case 'children':
                          c = b;
                          break;
                        case 'dangerouslySetInnerHTML':
                          if (b != null)
                            throw Error(
                              '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
                            );
                          break;
                        default:
                          Xe(e, t, f, b, n, null);
                      }
                  (Jp(e, n), th(e, a, s, c), xr(e));
                  return;
                case 'option':
                  Zp(e, n);
                  for (w in n)
                    if (n.hasOwnProperty(w) && ((a = n[w]), a != null))
                      switch (w) {
                        case 'selected':
                          e.selected =
                            a && typeof a != 'function' && typeof a != 'symbol';
                          break;
                        default:
                          Xe(e, t, w, a, n, null);
                      }
                  return;
                case 'dialog':
                  (je('beforetoggle', e),
                    je('toggle', e),
                    je('cancel', e),
                    je('close', e));
                  break;
                case 'iframe':
                case 'object':
                  je('load', e);
                  break;
                case 'video':
                case 'audio':
                  for (a = 0; a < er.length; a++) je(er[a], e);
                  break;
                case 'image':
                  (je('error', e), je('load', e));
                  break;
                case 'details':
                  je('toggle', e);
                  break;
                case 'embed':
                case 'source':
                case 'link':
                  (je('error', e), je('load', e));
                case 'area':
                case 'base':
                case 'br':
                case 'col':
                case 'hr':
                case 'keygen':
                case 'meta':
                case 'param':
                case 'track':
                case 'wbr':
                case 'menuitem':
                  for (T in n)
                    if (n.hasOwnProperty(T) && ((a = n[T]), a != null))
                      switch (T) {
                        case 'children':
                        case 'dangerouslySetInnerHTML':
                          throw Error(
                            t +
                              ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                          );
                        default:
                          Xe(e, t, T, a, n, null);
                      }
                  return;
                default:
                  if (Is(t)) {
                    for (j in n)
                      n.hasOwnProperty(j) &&
                        ((a = n[j]), a !== void 0 && Sf(e, t, j, a, n, void 0));
                    return;
                  }
              }
              for (b in n)
                n.hasOwnProperty(b) &&
                  ((a = n[b]), a != null && Xe(e, t, b, a, n, null));
            }
            function Sx(e, t, n, a) {
              switch ((vf(t, a), t)) {
                case 'div':
                case 'span':
                case 'svg':
                case 'path':
                case 'a':
                case 'g':
                case 'p':
                case 'li':
                  break;
                case 'input':
                  var s = null,
                    c = null,
                    f = null,
                    b = null,
                    w = null,
                    T = null,
                    j = null;
                  for (I in n) {
                    var H = n[I];
                    if (n.hasOwnProperty(I) && H != null)
                      switch (I) {
                        case 'checked':
                          break;
                        case 'value':
                          break;
                        case 'defaultValue':
                          w = H;
                        default:
                          a.hasOwnProperty(I) || Xe(e, t, I, null, a, H);
                      }
                  }
                  for (var _ in a) {
                    var I = a[_];
                    if (
                      ((H = n[_]),
                      a.hasOwnProperty(_) && (I != null || H != null))
                    )
                      switch (_) {
                        case 'type':
                          c = I;
                          break;
                        case 'name':
                          s = I;
                          break;
                        case 'checked':
                          T = I;
                          break;
                        case 'defaultChecked':
                          j = I;
                          break;
                        case 'value':
                          f = I;
                          break;
                        case 'defaultValue':
                          b = I;
                          break;
                        case 'children':
                        case 'dangerouslySetInnerHTML':
                          if (I != null)
                            throw Error(
                              t +
                                ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                            );
                          break;
                        default:
                          I !== H && Xe(e, t, _, I, a, H);
                      }
                  }
                  ((t =
                    n.type === 'checkbox' || n.type === 'radio'
                      ? n.checked != null
                      : n.value != null),
                    (a =
                      a.type === 'checkbox' || a.type === 'radio'
                        ? a.checked != null
                        : a.value != null),
                    t ||
                      !a ||
                      A1 ||
                      (console.error(
                        'A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components'
                      ),
                      (A1 = !0)),
                    !t ||
                      a ||
                      C1 ||
                      (console.error(
                        'A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components'
                      ),
                      (C1 = !0)),
                    Bu(e, f, b, w, T, j, c, s));
                  return;
                case 'select':
                  I = f = b = _ = null;
                  for (c in n)
                    if (((w = n[c]), n.hasOwnProperty(c) && w != null))
                      switch (c) {
                        case 'value':
                          break;
                        case 'multiple':
                          I = w;
                        default:
                          a.hasOwnProperty(c) || Xe(e, t, c, null, a, w);
                      }
                  for (s in a)
                    if (
                      ((c = a[s]),
                      (w = n[s]),
                      a.hasOwnProperty(s) && (c != null || w != null))
                    )
                      switch (s) {
                        case 'value':
                          _ = c;
                          break;
                        case 'defaultValue':
                          b = c;
                          break;
                        case 'multiple':
                          f = c;
                        default:
                          c !== w && Xe(e, t, s, c, a, w);
                      }
                  ((a = b),
                    (t = f),
                    (n = I),
                    _ != null
                      ? Al(e, !!t, _, !1)
                      : !!n != !!t &&
                        (a != null
                          ? Al(e, !!t, a, !0)
                          : Al(e, !!t, t ? [] : '', !1)));
                  return;
                case 'textarea':
                  I = _ = null;
                  for (b in n)
                    if (
                      ((s = n[b]),
                      n.hasOwnProperty(b) && s != null && !a.hasOwnProperty(b))
                    )
                      switch (b) {
                        case 'value':
                          break;
                        case 'children':
                          break;
                        default:
                          Xe(e, t, b, null, a, s);
                      }
                  for (f in a)
                    if (
                      ((s = a[f]),
                      (c = n[f]),
                      a.hasOwnProperty(f) && (s != null || c != null))
                    )
                      switch (f) {
                        case 'value':
                          _ = s;
                          break;
                        case 'defaultValue':
                          I = s;
                          break;
                        case 'children':
                          break;
                        case 'dangerouslySetInnerHTML':
                          if (s != null)
                            throw Error(
                              '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
                            );
                          break;
                        default:
                          s !== c && Xe(e, t, f, s, a, c);
                      }
                  eh(e, _, I);
                  return;
                case 'option':
                  for (var fe in n)
                    if (
                      ((_ = n[fe]),
                      n.hasOwnProperty(fe) &&
                        _ != null &&
                        !a.hasOwnProperty(fe))
                    )
                      switch (fe) {
                        case 'selected':
                          e.selected = !1;
                          break;
                        default:
                          Xe(e, t, fe, null, a, _);
                      }
                  for (w in a)
                    if (
                      ((_ = a[w]),
                      (I = n[w]),
                      a.hasOwnProperty(w) &&
                        _ !== I &&
                        (_ != null || I != null))
                    )
                      switch (w) {
                        case 'selected':
                          e.selected =
                            _ && typeof _ != 'function' && typeof _ != 'symbol';
                          break;
                        default:
                          Xe(e, t, w, _, a, I);
                      }
                  return;
                case 'img':
                case 'link':
                case 'area':
                case 'base':
                case 'br':
                case 'col':
                case 'embed':
                case 'hr':
                case 'keygen':
                case 'meta':
                case 'param':
                case 'source':
                case 'track':
                case 'wbr':
                case 'menuitem':
                  for (var be in n)
                    ((_ = n[be]),
                      n.hasOwnProperty(be) &&
                        _ != null &&
                        !a.hasOwnProperty(be) &&
                        Xe(e, t, be, null, a, _));
                  for (T in a)
                    if (
                      ((_ = a[T]),
                      (I = n[T]),
                      a.hasOwnProperty(T) &&
                        _ !== I &&
                        (_ != null || I != null))
                    )
                      switch (T) {
                        case 'children':
                        case 'dangerouslySetInnerHTML':
                          if (_ != null)
                            throw Error(
                              t +
                                ' is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.'
                            );
                          break;
                        default:
                          Xe(e, t, T, _, a, I);
                      }
                  return;
                default:
                  if (Is(t)) {
                    for (var Fe in n)
                      ((_ = n[Fe]),
                        n.hasOwnProperty(Fe) &&
                          _ !== void 0 &&
                          !a.hasOwnProperty(Fe) &&
                          Sf(e, t, Fe, void 0, a, _));
                    for (j in a)
                      ((_ = a[j]),
                        (I = n[j]),
                        !a.hasOwnProperty(j) ||
                          _ === I ||
                          (_ === void 0 && I === void 0) ||
                          Sf(e, t, j, _, a, I));
                    return;
                  }
              }
              for (var Ve in n)
                ((_ = n[Ve]),
                  n.hasOwnProperty(Ve) &&
                    _ != null &&
                    !a.hasOwnProperty(Ve) &&
                    Xe(e, t, Ve, null, a, _));
              for (H in a)
                ((_ = a[H]),
                  (I = n[H]),
                  !a.hasOwnProperty(H) ||
                    _ === I ||
                    (_ == null && I == null) ||
                    Xe(e, t, H, _, a, I));
            }
            function Gb(e) {
              switch (e) {
                case 'class':
                  return 'className';
                case 'for':
                  return 'htmlFor';
                default:
                  return e;
              }
            }
            function xf(e) {
              var t = {};
              e = e.style;
              for (var n = 0; n < e.length; n++) {
                var a = e[n];
                t[a] = e.getPropertyValue(a);
              }
              return t;
            }
            function qb(e, t, n) {
              if (t != null && typeof t != 'object')
                console.error(
                  "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
                );
              else {
                var a,
                  s = (a = ''),
                  c;
                for (c in t)
                  if (t.hasOwnProperty(c)) {
                    var f = t[c];
                    f != null &&
                      typeof f != 'boolean' &&
                      f !== '' &&
                      (c.indexOf('--') === 0
                        ? (Ue(f, c), (a += s + c + ':' + ('' + f).trim()))
                        : typeof f != 'number' || f === 0 || Fy.has(c)
                          ? (Ue(f, c),
                            (a +=
                              s +
                              c
                                .replace(qy, '-$1')
                                .toLowerCase()
                                .replace(Yy, '-ms-') +
                              ':' +
                              ('' + f).trim()))
                          : (a +=
                              s +
                              c
                                .replace(qy, '-$1')
                                .toLowerCase()
                                .replace(Yy, '-ms-') +
                              ':' +
                              f +
                              'px'),
                      (s = ';'));
                  }
                ((a = a || null),
                  (t = e.getAttribute('style')),
                  t !== a && ((a = ri(a)), ri(t) !== a && (n.style = xf(e))));
              }
            }
            function Rn(e, t, n, a, s, c) {
              if ((s.delete(n), (e = e.getAttribute(n)), e === null))
                switch (typeof a) {
                  case 'undefined':
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    return;
                }
              else if (a != null)
                switch (typeof a) {
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    break;
                  default:
                    if ((ue(a, t), e === '' + a)) return;
                }
              Tt(t, e, a, c);
            }
            function Yb(e, t, n, a, s, c) {
              if ((s.delete(n), (e = e.getAttribute(n)), e === null)) {
                switch (typeof a) {
                  case 'function':
                  case 'symbol':
                    return;
                }
                if (!a) return;
              } else
                switch (typeof a) {
                  case 'function':
                  case 'symbol':
                    break;
                  default:
                    if (a) return;
                }
              Tt(t, e, a, c);
            }
            function Nf(e, t, n, a, s, c) {
              if ((s.delete(n), (e = e.getAttribute(n)), e === null))
                switch (typeof a) {
                  case 'undefined':
                  case 'function':
                  case 'symbol':
                    return;
                }
              else if (a != null)
                switch (typeof a) {
                  case 'function':
                  case 'symbol':
                    break;
                  default:
                    if ((ue(a, n), e === '' + a)) return;
                }
              Tt(t, e, a, c);
            }
            function Xb(e, t, n, a, s, c) {
              if ((s.delete(n), (e = e.getAttribute(n)), e === null))
                switch (typeof a) {
                  case 'undefined':
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    return;
                  default:
                    if (isNaN(a)) return;
                }
              else if (a != null)
                switch (typeof a) {
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    break;
                  default:
                    if (!isNaN(a) && (ue(a, t), e === '' + a)) return;
                }
              Tt(t, e, a, c);
            }
            function wf(e, t, n, a, s, c) {
              if ((s.delete(n), (e = e.getAttribute(n)), e === null))
                switch (typeof a) {
                  case 'undefined':
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    return;
                }
              else if (a != null)
                switch (typeof a) {
                  case 'function':
                  case 'symbol':
                  case 'boolean':
                    break;
                  default:
                    if ((ue(a, t), (n = Ws('' + a)), e === n)) return;
                }
              Tt(t, e, a, c);
            }
            function Qb(e, t, n, a) {
              for (
                var s = {}, c = new Set(), f = e.attributes, b = 0;
                b < f.length;
                b++
              )
                switch (f[b].name.toLowerCase()) {
                  case 'value':
                    break;
                  case 'checked':
                    break;
                  case 'selected':
                    break;
                  default:
                    c.add(f[b].name);
                }
              if (Is(t)) {
                for (var w in n)
                  if (n.hasOwnProperty(w)) {
                    var T = n[w];
                    if (T != null) {
                      if (el.hasOwnProperty(w))
                        typeof T != 'function' && oa(w, T);
                      else if (n.suppressHydrationWarning !== !0)
                        switch (w) {
                          case 'children':
                            (typeof T != 'string' && typeof T != 'number') ||
                              Tt('children', e.textContent, T, s);
                            continue;
                          case 'suppressContentEditableWarning':
                          case 'suppressHydrationWarning':
                          case 'defaultValue':
                          case 'defaultChecked':
                          case 'innerHTML':
                          case 'ref':
                            continue;
                          case 'dangerouslySetInnerHTML':
                            ((f = e.innerHTML),
                              (T = T ? T.__html : void 0),
                              T != null && ((T = $b(e, T)), Tt(w, f, T, s)));
                            continue;
                          case 'style':
                            (c.delete(w), qb(e, T, s));
                            continue;
                          case 'offsetParent':
                          case 'offsetTop':
                          case 'offsetLeft':
                          case 'offsetWidth':
                          case 'offsetHeight':
                          case 'isContentEditable':
                          case 'outerText':
                          case 'outerHTML':
                            (c.delete(w.toLowerCase()),
                              console.error(
                                'Assignment to read-only property will result in a no-op: `%s`',
                                w
                              ));
                            continue;
                          case 'className':
                            (c.delete('class'),
                              (f = De(e, 'class', T)),
                              Tt('className', f, T, s));
                            continue;
                          default:
                            (a.context === Pa && t !== 'svg' && t !== 'math'
                              ? c.delete(w.toLowerCase())
                              : c.delete(w),
                              (f = De(e, w, T)),
                              Tt(w, f, T, s));
                        }
                    }
                  }
              } else
                for (T in n)
                  if (n.hasOwnProperty(T) && ((w = n[T]), w != null)) {
                    if (el.hasOwnProperty(T))
                      typeof w != 'function' && oa(T, w);
                    else if (n.suppressHydrationWarning !== !0)
                      switch (T) {
                        case 'children':
                          (typeof w != 'string' && typeof w != 'number') ||
                            Tt('children', e.textContent, w, s);
                          continue;
                        case 'suppressContentEditableWarning':
                        case 'suppressHydrationWarning':
                        case 'value':
                        case 'checked':
                        case 'selected':
                        case 'defaultValue':
                        case 'defaultChecked':
                        case 'innerHTML':
                        case 'ref':
                          continue;
                        case 'dangerouslySetInnerHTML':
                          ((f = e.innerHTML),
                            (w = w ? w.__html : void 0),
                            w != null &&
                              ((w = $b(e, w)),
                              f !== w && (s[T] = { __html: f })));
                          continue;
                        case 'className':
                          Rn(e, T, 'class', w, c, s);
                          continue;
                        case 'tabIndex':
                          Rn(e, T, 'tabindex', w, c, s);
                          continue;
                        case 'style':
                          (c.delete(T), qb(e, w, s));
                          continue;
                        case 'multiple':
                          (c.delete(T), Tt(T, e.multiple, w, s));
                          continue;
                        case 'muted':
                          (c.delete(T), Tt(T, e.muted, w, s));
                          continue;
                        case 'autoFocus':
                          (c.delete('autofocus'), Tt(T, e.autofocus, w, s));
                          continue;
                        case 'data':
                          if (t !== 'object') {
                            (c.delete(T),
                              (f = e.getAttribute('data')),
                              Tt(T, f, w, s));
                            continue;
                          }
                        case 'src':
                        case 'href':
                          if (
                            !(
                              w !== '' ||
                              (t === 'a' && T === 'href') ||
                              (t === 'object' && T === 'data')
                            )
                          ) {
                            console.error(
                              T === 'src'
                                ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.'
                                : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                              T,
                              T
                            );
                            continue;
                          }
                          wf(e, T, T, w, c, s);
                          continue;
                        case 'action':
                        case 'formAction':
                          if (
                            ((f = e.getAttribute(T)), typeof w == 'function')
                          ) {
                            (c.delete(T.toLowerCase()),
                              T === 'formAction'
                                ? (c.delete('name'),
                                  c.delete('formenctype'),
                                  c.delete('formmethod'),
                                  c.delete('formtarget'))
                                : (c.delete('enctype'),
                                  c.delete('method'),
                                  c.delete('target')));
                            continue;
                          } else if (f === Ow) {
                            (c.delete(T.toLowerCase()),
                              Tt(T, 'function', w, s));
                            continue;
                          }
                          wf(e, T, T.toLowerCase(), w, c, s);
                          continue;
                        case 'xlinkHref':
                          wf(e, T, 'xlink:href', w, c, s);
                          continue;
                        case 'contentEditable':
                          Nf(e, T, 'contenteditable', w, c, s);
                          continue;
                        case 'spellCheck':
                          Nf(e, T, 'spellcheck', w, c, s);
                          continue;
                        case 'draggable':
                        case 'autoReverse':
                        case 'externalResourcesRequired':
                        case 'focusable':
                        case 'preserveAlpha':
                          Nf(e, T, T, w, c, s);
                          continue;
                        case 'allowFullScreen':
                        case 'async':
                        case 'autoPlay':
                        case 'controls':
                        case 'default':
                        case 'defer':
                        case 'disabled':
                        case 'disablePictureInPicture':
                        case 'disableRemotePlayback':
                        case 'formNoValidate':
                        case 'hidden':
                        case 'loop':
                        case 'noModule':
                        case 'noValidate':
                        case 'open':
                        case 'playsInline':
                        case 'readOnly':
                        case 'required':
                        case 'reversed':
                        case 'scoped':
                        case 'seamless':
                        case 'itemScope':
                          Yb(e, T, T.toLowerCase(), w, c, s);
                          continue;
                        case 'capture':
                        case 'download':
                          e: {
                            b = e;
                            var j = (f = T),
                              H = s;
                            if (
                              (c.delete(j), (b = b.getAttribute(j)), b === null)
                            )
                              switch (typeof w) {
                                case 'undefined':
                                case 'function':
                                case 'symbol':
                                  break e;
                                default:
                                  if (w === !1) break e;
                              }
                            else if (w != null)
                              switch (typeof w) {
                                case 'function':
                                case 'symbol':
                                  break;
                                case 'boolean':
                                  if (w === !0 && b === '') break e;
                                  break;
                                default:
                                  if ((ue(w, f), b === '' + w)) break e;
                              }
                            Tt(f, b, w, H);
                          }
                          continue;
                        case 'cols':
                        case 'rows':
                        case 'size':
                        case 'span':
                          e: {
                            if (
                              ((b = e),
                              (j = f = T),
                              (H = s),
                              c.delete(j),
                              (b = b.getAttribute(j)),
                              b === null)
                            )
                              switch (typeof w) {
                                case 'undefined':
                                case 'function':
                                case 'symbol':
                                case 'boolean':
                                  break e;
                                default:
                                  if (isNaN(w) || 1 > w) break e;
                              }
                            else if (w != null)
                              switch (typeof w) {
                                case 'function':
                                case 'symbol':
                                case 'boolean':
                                  break;
                                default:
                                  if (
                                    !(isNaN(w) || 1 > w) &&
                                    (ue(w, f), b === '' + w)
                                  )
                                    break e;
                              }
                            Tt(f, b, w, H);
                          }
                          continue;
                        case 'rowSpan':
                          Xb(e, T, 'rowspan', w, c, s);
                          continue;
                        case 'start':
                          Xb(e, T, T, w, c, s);
                          continue;
                        case 'xHeight':
                          Rn(e, T, 'x-height', w, c, s);
                          continue;
                        case 'xlinkActuate':
                          Rn(e, T, 'xlink:actuate', w, c, s);
                          continue;
                        case 'xlinkArcrole':
                          Rn(e, T, 'xlink:arcrole', w, c, s);
                          continue;
                        case 'xlinkRole':
                          Rn(e, T, 'xlink:role', w, c, s);
                          continue;
                        case 'xlinkShow':
                          Rn(e, T, 'xlink:show', w, c, s);
                          continue;
                        case 'xlinkTitle':
                          Rn(e, T, 'xlink:title', w, c, s);
                          continue;
                        case 'xlinkType':
                          Rn(e, T, 'xlink:type', w, c, s);
                          continue;
                        case 'xmlBase':
                          Rn(e, T, 'xml:base', w, c, s);
                          continue;
                        case 'xmlLang':
                          Rn(e, T, 'xml:lang', w, c, s);
                          continue;
                        case 'xmlSpace':
                          Rn(e, T, 'xml:space', w, c, s);
                          continue;
                        case 'inert':
                          (w !== '' ||
                            iu[T] ||
                            ((iu[T] = !0),
                            console.error(
                              'Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.',
                              T
                            )),
                            Yb(e, T, T, w, c, s));
                          continue;
                        default:
                          if (
                            !(2 < T.length) ||
                            (T[0] !== 'o' && T[0] !== 'O') ||
                            (T[1] !== 'n' && T[1] !== 'N')
                          ) {
                            ((b = dh(T)),
                              (f = !1),
                              a.context === Pa && t !== 'svg' && t !== 'math'
                                ? c.delete(b.toLowerCase())
                                : ((j = T.toLowerCase()),
                                  (j = (Ac.hasOwnProperty(j) && Ac[j]) || null),
                                  j !== null &&
                                    j !== T &&
                                    ((f = !0), c.delete(j)),
                                  c.delete(b)));
                            e: if (((j = e), (H = b), (b = w), Ae(H)))
                              if (j.hasAttribute(H))
                                ((j = j.getAttribute(H)),
                                  ue(b, H),
                                  (b = j === '' + b ? b : j));
                              else {
                                switch (typeof b) {
                                  case 'function':
                                  case 'symbol':
                                    break e;
                                  case 'boolean':
                                    if (
                                      ((j = H.toLowerCase().slice(0, 5)),
                                      j !== 'data-' && j !== 'aria-')
                                    )
                                      break e;
                                }
                                b = b === void 0 ? void 0 : null;
                              }
                            else b = void 0;
                            f || Tt(T, b, w, s);
                          }
                      }
                  }
              return (
                0 < c.size && n.suppressHydrationWarning !== !0 && vx(e, c, s),
                Object.keys(s).length === 0 ? null : s
              );
            }
            function xx(e, t) {
              switch (e.length) {
                case 0:
                  return '';
                case 1:
                  return e[0];
                case 2:
                  return e[0] + ' ' + t + ' ' + e[1];
                default:
                  return (
                    e.slice(0, -1).join(', ') + ', ' + t + ' ' + e[e.length - 1]
                  );
              }
            }
            function fc(e) {
              return e.nodeType === 9 ? e : e.ownerDocument;
            }
            function Zb(e) {
              switch (e) {
                case Ql:
                  return Ts;
                case Cc:
                  return ou;
                default:
                  return Pa;
              }
            }
            function Fb(e, t) {
              if (e === Pa)
                switch (t) {
                  case 'svg':
                    return Ts;
                  case 'math':
                    return ou;
                  default:
                    return Pa;
                }
              return e === Ts && t === 'foreignObject' ? Pa : e;
            }
            function Ef(e, t) {
              return (
                e === 'textarea' ||
                e === 'noscript' ||
                typeof t.children == 'string' ||
                typeof t.children == 'number' ||
                typeof t.children == 'bigint' ||
                (typeof t.dangerouslySetInnerHTML == 'object' &&
                  t.dangerouslySetInnerHTML !== null &&
                  t.dangerouslySetInnerHTML.__html != null)
              );
            }
            function Nx() {
              var e = window.event;
              return e && e.type === 'popstate'
                ? e === ep
                  ? !1
                  : ((ep = e), !0)
                : ((ep = null), !1);
            }
            function wx(e) {
              setTimeout(function () {
                throw e;
              });
            }
            function Ex(e, t, n) {
              switch (t) {
                case 'button':
                case 'input':
                case 'select':
                case 'textarea':
                  n.autoFocus && e.focus();
                  break;
                case 'img':
                  n.src ? (e.src = n.src) : n.srcSet && (e.srcset = n.srcSet);
              }
            }
            function Dx(e, t, n, a) {
              (Sx(e, t, n, a), (e[an] = a));
            }
            function Kb(e) {
              Us(e, '');
            }
            function Tx(e, t, n) {
              e.nodeValue = n;
            }
            function ci(e) {
              return e === 'head';
            }
            function Cx(e, t) {
              e.removeChild(t);
            }
            function Ax(e, t) {
              (e.nodeType === 9
                ? e.body
                : e.nodeName === 'HTML'
                  ? e.ownerDocument.body
                  : e
              ).removeChild(t);
            }
            function Jb(e, t) {
              var n = t,
                a = 0,
                s = 0;
              do {
                var c = n.nextSibling;
                if ((e.removeChild(n), c && c.nodeType === 8))
                  if (((n = c.data), n === su)) {
                    if (0 < a && 8 > a) {
                      n = a;
                      var f = e.ownerDocument;
                      if (
                        (n & _w && po(f.documentElement),
                        n & jw && po(f.body),
                        n & Vw)
                      )
                        for (n = f.head, po(n), f = n.firstChild; f; ) {
                          var b = f.nextSibling,
                            w = f.nodeName;
                          (f[xo] ||
                            w === 'SCRIPT' ||
                            w === 'STYLE' ||
                            (w === 'LINK' &&
                              f.rel.toLowerCase() === 'stylesheet') ||
                            n.removeChild(f),
                            (f = b));
                        }
                    }
                    if (s === 0) {
                      (e.removeChild(c), yo(t));
                      return;
                    }
                    s--;
                  } else
                    n === lu || n === $a || n === tr
                      ? s++
                      : (a = n.charCodeAt(0) - 48);
                else a = 0;
                n = c;
              } while (n);
              yo(t);
            }
            function Rx(e) {
              ((e = e.style),
                typeof e.setProperty == 'function'
                  ? e.setProperty('display', 'none', 'important')
                  : (e.display = 'none'));
            }
            function Mx(e) {
              e.nodeValue = '';
            }
            function Ox(e, t) {
              ((t = t[Bw]),
                (t =
                  t != null && t.hasOwnProperty('display') ? t.display : null),
                (e.style.display =
                  t == null || typeof t == 'boolean' ? '' : ('' + t).trim()));
            }
            function kx(e, t) {
              e.nodeValue = t;
            }
            function Df(e) {
              var t = e.firstChild;
              for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
                var n = t;
                switch (((t = t.nextSibling), n.nodeName)) {
                  case 'HTML':
                  case 'HEAD':
                  case 'BODY':
                    (Df(n), Ja(n));
                    continue;
                  case 'SCRIPT':
                  case 'STYLE':
                    continue;
                  case 'LINK':
                    if (n.rel.toLowerCase() === 'stylesheet') continue;
                }
                e.removeChild(n);
              }
            }
            function _x(e, t, n, a) {
              for (; e.nodeType === 1; ) {
                var s = n;
                if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
                  if (!a && (e.nodeName !== 'INPUT' || e.type !== 'hidden'))
                    break;
                } else if (a) {
                  if (!e[xo])
                    switch (t) {
                      case 'meta':
                        if (!e.hasAttribute('itemprop')) break;
                        return e;
                      case 'link':
                        if (
                          ((c = e.getAttribute('rel')),
                          c === 'stylesheet' &&
                            e.hasAttribute('data-precedence'))
                        )
                          break;
                        if (
                          c !== s.rel ||
                          e.getAttribute('href') !==
                            (s.href == null || s.href === '' ? null : s.href) ||
                          e.getAttribute('crossorigin') !==
                            (s.crossOrigin == null ? null : s.crossOrigin) ||
                          e.getAttribute('title') !==
                            (s.title == null ? null : s.title)
                        )
                          break;
                        return e;
                      case 'style':
                        if (e.hasAttribute('data-precedence')) break;
                        return e;
                      case 'script':
                        if (
                          ((c = e.getAttribute('src')),
                          (c !== (s.src == null ? null : s.src) ||
                            e.getAttribute('type') !==
                              (s.type == null ? null : s.type) ||
                            e.getAttribute('crossorigin') !==
                              (s.crossOrigin == null ? null : s.crossOrigin)) &&
                            c &&
                            e.hasAttribute('async') &&
                            !e.hasAttribute('itemprop'))
                        )
                          break;
                        return e;
                      default:
                        return e;
                    }
                } else if (t === 'input' && e.type === 'hidden') {
                  ue(s.name, 'name');
                  var c = s.name == null ? null : '' + s.name;
                  if (s.type === 'hidden' && e.getAttribute('name') === c)
                    return e;
                } else return e;
                if (((e = Mn(e.nextSibling)), e === null)) break;
              }
              return null;
            }
            function jx(e, t, n) {
              if (t === '') return null;
              for (; e.nodeType !== 3; )
                if (
                  ((e.nodeType !== 1 ||
                    e.nodeName !== 'INPUT' ||
                    e.type !== 'hidden') &&
                    !n) ||
                  ((e = Mn(e.nextSibling)), e === null)
                )
                  return null;
              return e;
            }
            function Tf(e) {
              return (
                e.data === tr ||
                (e.data === $a && e.ownerDocument.readyState === k1)
              );
            }
            function Vx(e, t) {
              var n = e.ownerDocument;
              if (e.data !== $a || n.readyState === k1) t();
              else {
                var a = function () {
                  (t(), n.removeEventListener('DOMContentLoaded', a));
                };
                (n.addEventListener('DOMContentLoaded', a),
                  (e._reactRetry = a));
              }
            }
            function Mn(e) {
              for (; e != null; e = e.nextSibling) {
                var t = e.nodeType;
                if (t === 1 || t === 3) break;
                if (t === 8) {
                  if (
                    ((t = e.data),
                    t === lu || t === tr || t === $a || t === Fm || t === O1)
                  )
                    break;
                  if (t === su) return null;
                }
              }
              return e;
            }
            function ey(e) {
              if (e.nodeType === 1) {
                for (
                  var t = e.nodeName.toLowerCase(),
                    n = {},
                    a = e.attributes,
                    s = 0;
                  s < a.length;
                  s++
                ) {
                  var c = a[s];
                  n[Gb(c.name)] =
                    c.name.toLowerCase() === 'style' ? xf(e) : c.value;
                }
                return { type: t, props: n };
              }
              return e.nodeType === 8
                ? { type: 'Suspense', props: {} }
                : e.nodeValue;
            }
            function ty(e, t, n) {
              return n === null || n[kw] !== !0
                ? (e.nodeValue === t
                    ? (e = null)
                    : ((t = ri(t)),
                      (e = ri(e.nodeValue) === t ? null : e.nodeValue)),
                  e)
                : null;
            }
            function ny(e) {
              e = e.nextSibling;
              for (var t = 0; e; ) {
                if (e.nodeType === 8) {
                  var n = e.data;
                  if (n === su) {
                    if (t === 0) return Mn(e.nextSibling);
                    t--;
                  } else (n !== lu && n !== tr && n !== $a) || t++;
                }
                e = e.nextSibling;
              }
              return null;
            }
            function ay(e) {
              e = e.previousSibling;
              for (var t = 0; e; ) {
                if (e.nodeType === 8) {
                  var n = e.data;
                  if (n === lu || n === tr || n === $a) {
                    if (t === 0) return e;
                    t--;
                  } else n === su && t++;
                }
                e = e.previousSibling;
              }
              return null;
            }
            function Bx(e) {
              yo(e);
            }
            function Lx(e) {
              yo(e);
            }
            function iy(e, t, n, a, s) {
              switch ((s && Wu(e, a.ancestorInfo), (t = fc(n)), e)) {
                case 'html':
                  if (((e = t.documentElement), !e))
                    throw Error(
                      'React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.'
                    );
                  return e;
                case 'head':
                  if (((e = t.head), !e))
                    throw Error(
                      'React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.'
                    );
                  return e;
                case 'body':
                  if (((e = t.body), !e))
                    throw Error(
                      'React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.'
                    );
                  return e;
                default:
                  throw Error(
                    'resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.'
                  );
              }
            }
            function zx(e, t, n, a) {
              if (!n[pi] && Gn(n)) {
                var s = n.tagName.toLowerCase();
                console.error(
                  'You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.',
                  s,
                  s,
                  s
                );
              }
              switch (e) {
                case 'html':
                case 'head':
                case 'body':
                  break;
                default:
                  console.error(
                    'acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.'
                  );
              }
              for (s = n.attributes; s.length; ) n.removeAttributeNode(s[0]);
              (_t(n, e, t), (n[Ut] = a), (n[an] = t));
            }
            function po(e) {
              for (var t = e.attributes; t.length; )
                e.removeAttributeNode(t[0]);
              Ja(e);
            }
            function mc(e) {
              return typeof e.getRootNode == 'function'
                ? e.getRootNode()
                : e.nodeType === 9
                  ? e
                  : e.ownerDocument;
            }
            function ly(e, t, n) {
              var a = Cs;
              if (a && typeof t == 'string' && t) {
                var s = An(t);
                ((s = 'link[rel="' + e + '"][href="' + s + '"]'),
                  typeof n == 'string' && (s += '[crossorigin="' + n + '"]'),
                  z1.has(s) ||
                    (z1.add(s),
                    (e = { rel: e, crossOrigin: n, href: t }),
                    a.querySelector(s) === null &&
                      ((t = a.createElement('link')),
                      _t(t, 'link', e),
                      O(t),
                      a.head.appendChild(t))));
              }
            }
            function sy(e, t, n, a) {
              var s = (s = fi.current) ? mc(s) : null;
              if (!s)
                throw Error(
                  '"resourceRoot" was expected to exist. This is a bug in React.'
                );
              switch (e) {
                case 'meta':
                case 'title':
                  return null;
                case 'style':
                  return typeof n.precedence == 'string' &&
                    typeof n.href == 'string'
                    ? ((n = Wl(n.href)),
                      (t = N(s).hoistableStyles),
                      (a = t.get(n)),
                      a ||
                        ((a = {
                          type: 'style',
                          instance: null,
                          count: 0,
                          state: null,
                        }),
                        t.set(n, a)),
                      a)
                    : { type: 'void', instance: null, count: 0, state: null };
                case 'link':
                  if (
                    n.rel === 'stylesheet' &&
                    typeof n.href == 'string' &&
                    typeof n.precedence == 'string'
                  ) {
                    e = Wl(n.href);
                    var c = N(s).hoistableStyles,
                      f = c.get(e);
                    if (
                      !f &&
                      ((s = s.ownerDocument || s),
                      (f = {
                        type: 'stylesheet',
                        instance: null,
                        count: 0,
                        state: { loading: yl, preload: null },
                      }),
                      c.set(e, f),
                      (c = s.querySelector(ho(e))) &&
                        !c._p &&
                        ((f.instance = c), (f.state.loading = nr | In)),
                      !Wn.has(e))
                    ) {
                      var b = {
                        rel: 'preload',
                        as: 'style',
                        href: n.href,
                        crossOrigin: n.crossOrigin,
                        integrity: n.integrity,
                        media: n.media,
                        hrefLang: n.hrefLang,
                        referrerPolicy: n.referrerPolicy,
                      };
                      (Wn.set(e, b), c || Hx(s, e, b, f.state));
                    }
                    if (t && a === null)
                      throw (
                        (n =
                          `

  - ` +
                          pc(t) +
                          `
  + ` +
                          pc(n)),
                        Error(
                          'Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key.' +
                            n
                        )
                      );
                    return f;
                  }
                  if (t && a !== null)
                    throw (
                      (n =
                        `

  - ` +
                        pc(t) +
                        `
  + ` +
                        pc(n)),
                      Error(
                        'Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key.' +
                          n
                      )
                    );
                  return null;
                case 'script':
                  return (
                    (t = n.async),
                    (n = n.src),
                    typeof n == 'string' &&
                    t &&
                    typeof t != 'function' &&
                    typeof t != 'symbol'
                      ? ((n = $l(n)),
                        (t = N(s).hoistableScripts),
                        (a = t.get(n)),
                        a ||
                          ((a = {
                            type: 'script',
                            instance: null,
                            count: 0,
                            state: null,
                          }),
                          t.set(n, a)),
                        a)
                      : { type: 'void', instance: null, count: 0, state: null }
                  );
                default:
                  throw Error(
                    'getResource encountered a type it did not expect: "' +
                      e +
                      '". this is a bug in React.'
                  );
              }
            }
            function pc(e) {
              var t = 0,
                n = '<link';
              return (
                typeof e.rel == 'string'
                  ? (t++, (n += ' rel="' + e.rel + '"'))
                  : _a.call(e, 'rel') &&
                    (t++,
                    (n +=
                      ' rel="' +
                      (e.rel === null
                        ? 'null'
                        : 'invalid type ' + typeof e.rel) +
                      '"')),
                typeof e.href == 'string'
                  ? (t++, (n += ' href="' + e.href + '"'))
                  : _a.call(e, 'href') &&
                    (t++,
                    (n +=
                      ' href="' +
                      (e.href === null
                        ? 'null'
                        : 'invalid type ' + typeof e.href) +
                      '"')),
                typeof e.precedence == 'string'
                  ? (t++, (n += ' precedence="' + e.precedence + '"'))
                  : _a.call(e, 'precedence') &&
                    (t++,
                    (n +=
                      ' precedence={' +
                      (e.precedence === null
                        ? 'null'
                        : 'invalid type ' + typeof e.precedence) +
                      '}')),
                Object.getOwnPropertyNames(e).length > t && (n += ' ...'),
                n + ' />'
              );
            }
            function Wl(e) {
              return 'href="' + An(e) + '"';
            }
            function ho(e) {
              return 'link[rel="stylesheet"][' + e + ']';
            }
            function oy(e) {
              return Re({}, e, {
                'data-precedence': e.precedence,
                precedence: null,
              });
            }
            function Hx(e, t, n, a) {
              e.querySelector('link[rel="preload"][as="style"][' + t + ']')
                ? (a.loading = nr)
                : ((t = e.createElement('link')),
                  (a.preload = t),
                  t.addEventListener('load', function () {
                    return (a.loading |= nr);
                  }),
                  t.addEventListener('error', function () {
                    return (a.loading |= B1);
                  }),
                  _t(t, 'link', n),
                  O(t),
                  e.head.appendChild(t));
            }
            function $l(e) {
              return '[src="' + An(e) + '"]';
            }
            function go(e) {
              return 'script[async]' + e;
            }
            function ry(e, t, n) {
              if ((t.count++, t.instance === null))
                switch (t.type) {
                  case 'style':
                    var a = e.querySelector(
                      'style[data-href~="' + An(n.href) + '"]'
                    );
                    if (a) return ((t.instance = a), O(a), a);
                    var s = Re({}, n, {
                      'data-href': n.href,
                      'data-precedence': n.precedence,
                      href: null,
                      precedence: null,
                    });
                    return (
                      (a = (e.ownerDocument || e).createElement('style')),
                      O(a),
                      _t(a, 'style', s),
                      hc(a, n.precedence, e),
                      (t.instance = a)
                    );
                  case 'stylesheet':
                    s = Wl(n.href);
                    var c = e.querySelector(ho(s));
                    if (c)
                      return (
                        (t.state.loading |= In),
                        (t.instance = c),
                        O(c),
                        c
                      );
                    ((a = oy(n)),
                      (s = Wn.get(s)) && Cf(a, s),
                      (c = (e.ownerDocument || e).createElement('link')),
                      O(c));
                    var f = c;
                    return (
                      (f._p = new Promise(function (b, w) {
                        ((f.onload = b), (f.onerror = w));
                      })),
                      _t(c, 'link', a),
                      (t.state.loading |= In),
                      hc(c, n.precedence, e),
                      (t.instance = c)
                    );
                  case 'script':
                    return (
                      (c = $l(n.src)),
                      (s = e.querySelector(go(c)))
                        ? ((t.instance = s), O(s), s)
                        : ((a = n),
                          (s = Wn.get(c)) && ((a = Re({}, n)), Af(a, s)),
                          (e = e.ownerDocument || e),
                          (s = e.createElement('script')),
                          O(s),
                          _t(s, 'link', a),
                          e.head.appendChild(s),
                          (t.instance = s))
                    );
                  case 'void':
                    return null;
                  default:
                    throw Error(
                      'acquireResource encountered a resource type it did not expect: "' +
                        t.type +
                        '". this is a bug in React.'
                    );
                }
              else
                t.type === 'stylesheet' &&
                  (t.state.loading & In) === yl &&
                  ((a = t.instance),
                  (t.state.loading |= In),
                  hc(a, n.precedence, e));
              return t.instance;
            }
            function hc(e, t, n) {
              for (
                var a = n.querySelectorAll(
                    'link[rel="stylesheet"][data-precedence],style[data-precedence]'
                  ),
                  s = a.length ? a[a.length - 1] : null,
                  c = s,
                  f = 0;
                f < a.length;
                f++
              ) {
                var b = a[f];
                if (b.dataset.precedence === t) c = b;
                else if (c !== s) break;
              }
              c
                ? c.parentNode.insertBefore(e, c.nextSibling)
                : ((t = n.nodeType === 9 ? n.head : n),
                  t.insertBefore(e, t.firstChild));
            }
            function Cf(e, t) {
              (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
                e.referrerPolicy == null &&
                  (e.referrerPolicy = t.referrerPolicy),
                e.title == null && (e.title = t.title));
            }
            function Af(e, t) {
              (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
                e.referrerPolicy == null &&
                  (e.referrerPolicy = t.referrerPolicy),
                e.integrity == null && (e.integrity = t.integrity));
            }
            function cy(e, t, n) {
              if (ru === null) {
                var a = new Map(),
                  s = (ru = new Map());
                s.set(n, a);
              } else
                ((s = ru), (a = s.get(n)), a || ((a = new Map()), s.set(n, a)));
              if (a.has(e)) return a;
              for (
                a.set(e, null), n = n.getElementsByTagName(e), s = 0;
                s < n.length;
                s++
              ) {
                var c = n[s];
                if (
                  !(
                    c[xo] ||
                    c[Ut] ||
                    (e === 'link' && c.getAttribute('rel') === 'stylesheet')
                  ) &&
                  c.namespaceURI !== Ql
                ) {
                  var f = c.getAttribute(t) || '';
                  f = e + f;
                  var b = a.get(f);
                  b ? b.push(c) : a.set(f, [c]);
                }
              }
              return a;
            }
            function uy(e, t, n) {
              ((e = e.ownerDocument || e),
                e.head.insertBefore(
                  n,
                  t === 'title' ? e.querySelector('head > title') : null
                ));
            }
            function Ux(e, t, n) {
              var a = !n.ancestorInfo.containerTagInScope;
              if (n.context === Ts || t.itemProp != null)
                return (
                  !a ||
                    t.itemProp == null ||
                    (e !== 'meta' &&
                      e !== 'title' &&
                      e !== 'style' &&
                      e !== 'link' &&
                      e !== 'script') ||
                    console.error(
                      'Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.',
                      e,
                      e
                    ),
                  !1
                );
              switch (e) {
                case 'meta':
                case 'title':
                  return !0;
                case 'style':
                  if (
                    typeof t.precedence != 'string' ||
                    typeof t.href != 'string' ||
                    t.href === ''
                  ) {
                    a &&
                      console.error(
                        'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
                      );
                    break;
                  }
                  return !0;
                case 'link':
                  if (
                    typeof t.rel != 'string' ||
                    typeof t.href != 'string' ||
                    t.href === '' ||
                    t.onLoad ||
                    t.onError
                  ) {
                    if (
                      t.rel === 'stylesheet' &&
                      typeof t.precedence == 'string'
                    ) {
                      e = t.href;
                      var s = t.onError,
                        c = t.disabled;
                      ((n = []),
                        t.onLoad && n.push('`onLoad`'),
                        s && n.push('`onError`'),
                        c != null && n.push('`disabled`'),
                        (s = xx(n, 'and')),
                        (s += n.length === 1 ? ' prop' : ' props'),
                        (c = n.length === 1 ? 'an ' + s : 'the ' + s),
                        n.length &&
                          console.error(
                            'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                            e,
                            c,
                            s
                          ));
                    }
                    a &&
                      (typeof t.rel != 'string' ||
                      typeof t.href != 'string' ||
                      t.href === ''
                        ? console.error(
                            'Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag'
                          )
                        : (t.onError || t.onLoad) &&
                          console.error(
                            'Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.'
                          ));
                    break;
                  }
                  switch (t.rel) {
                    case 'stylesheet':
                      return (
                        (e = t.precedence),
                        (t = t.disabled),
                        typeof e != 'string' &&
                          a &&
                          console.error(
                            'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
                          ),
                        typeof e == 'string' && t == null
                      );
                    default:
                      return !0;
                  }
                case 'script':
                  if (
                    ((e =
                      t.async &&
                      typeof t.async != 'function' &&
                      typeof t.async != 'symbol'),
                    !e ||
                      t.onLoad ||
                      t.onError ||
                      !t.src ||
                      typeof t.src != 'string')
                  ) {
                    a &&
                      (e
                        ? t.onLoad || t.onError
                          ? console.error(
                              'Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.'
                            )
                          : console.error(
                              'Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.'
                            )
                        : console.error(
                            'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
                          ));
                    break;
                  }
                  return !0;
                case 'noscript':
                case 'template':
                  a &&
                    console.error(
                      'Cannot render <%s> outside the main document. Try moving it into the root <head> tag.',
                      e
                    );
              }
              return !1;
            }
            function dy(e) {
              return !(
                e.type === 'stylesheet' && (e.state.loading & L1) === yl
              );
            }
            function Ix() {}
            function Wx(e, t, n) {
              if (ar === null)
                throw Error(
                  'Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug.'
                );
              var a = ar;
              if (
                t.type === 'stylesheet' &&
                (typeof n.media != 'string' ||
                  matchMedia(n.media).matches !== !1) &&
                (t.state.loading & In) === yl
              ) {
                if (t.instance === null) {
                  var s = Wl(n.href),
                    c = e.querySelector(ho(s));
                  if (c) {
                    ((e = c._p),
                      e !== null &&
                        typeof e == 'object' &&
                        typeof e.then == 'function' &&
                        (a.count++, (a = gc.bind(a)), e.then(a, a)),
                      (t.state.loading |= In),
                      (t.instance = c),
                      O(c));
                    return;
                  }
                  ((c = e.ownerDocument || e),
                    (n = oy(n)),
                    (s = Wn.get(s)) && Cf(n, s),
                    (c = c.createElement('link')),
                    O(c));
                  var f = c;
                  ((f._p = new Promise(function (b, w) {
                    ((f.onload = b), (f.onerror = w));
                  })),
                    _t(c, 'link', n),
                    (t.instance = c));
                }
                (a.stylesheets === null && (a.stylesheets = new Map()),
                  a.stylesheets.set(t, e),
                  (e = t.state.preload) &&
                    (t.state.loading & L1) === yl &&
                    (a.count++,
                    (t = gc.bind(a)),
                    e.addEventListener('load', t),
                    e.addEventListener('error', t)));
              }
            }
            function $x() {
              if (ar === null)
                throw Error(
                  'Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug.'
                );
              var e = ar;
              return (
                e.stylesheets && e.count === 0 && Rf(e, e.stylesheets),
                0 < e.count
                  ? function (t) {
                      var n = setTimeout(function () {
                        if (
                          (e.stylesheets && Rf(e, e.stylesheets), e.unsuspend)
                        ) {
                          var a = e.unsuspend;
                          ((e.unsuspend = null), a());
                        }
                      }, 6e4);
                      return (
                        (e.unsuspend = t),
                        function () {
                          ((e.unsuspend = null), clearTimeout(n));
                        }
                      );
                    }
                  : null
              );
            }
            function gc() {
              if ((this.count--, this.count === 0)) {
                if (this.stylesheets) Rf(this, this.stylesheets);
                else if (this.unsuspend) {
                  var e = this.unsuspend;
                  ((this.unsuspend = null), e());
                }
              }
            }
            function Rf(e, t) {
              ((e.stylesheets = null),
                e.unsuspend !== null &&
                  (e.count++,
                  (cu = new Map()),
                  t.forEach(Px, e),
                  (cu = null),
                  gc.call(e)));
            }
            function Px(e, t) {
              if (!(t.state.loading & In)) {
                var n = cu.get(e);
                if (n) var a = n.get(np);
                else {
                  ((n = new Map()), cu.set(e, n));
                  for (
                    var s = e.querySelectorAll(
                        'link[data-precedence],style[data-precedence]'
                      ),
                      c = 0;
                    c < s.length;
                    c++
                  ) {
                    var f = s[c];
                    (f.nodeName === 'LINK' ||
                      f.getAttribute('media') !== 'not all') &&
                      (n.set(f.dataset.precedence, f), (a = f));
                  }
                  a && n.set(np, a);
                }
                ((s = t.instance),
                  (f = s.getAttribute('data-precedence')),
                  (c = n.get(f) || a),
                  c === a && n.set(np, s),
                  n.set(f, s),
                  this.count++,
                  (a = gc.bind(this)),
                  s.addEventListener('load', a),
                  s.addEventListener('error', a),
                  c
                    ? c.parentNode.insertBefore(s, c.nextSibling)
                    : ((e = e.nodeType === 9 ? e.head : e),
                      e.insertBefore(s, e.firstChild)),
                  (t.state.loading |= In));
              }
            }
            function Gx(e, t, n, a, s, c, f, b) {
              for (
                this.tag = 1,
                  this.containerInfo = e,
                  this.pingCache = this.current = this.pendingChildren = null,
                  this.timeoutHandle = bl,
                  this.callbackNode =
                    this.next =
                    this.pendingContext =
                    this.context =
                    this.cancelPendingCommit =
                      null,
                  this.callbackPriority = 0,
                  this.expirationTimes = Dl(-1),
                  this.entangledLanes =
                    this.shellSuspendCounter =
                    this.errorRecoveryDisabledLanes =
                    this.expiredLanes =
                    this.warmLanes =
                    this.pingedLanes =
                    this.suspendedLanes =
                    this.pendingLanes =
                      0,
                  this.entanglements = Dl(0),
                  this.hiddenUpdates = Dl(null),
                  this.identifierPrefix = a,
                  this.onUncaughtError = s,
                  this.onCaughtError = c,
                  this.onRecoverableError = f,
                  this.pooledCache = null,
                  this.pooledCacheLanes = 0,
                  this.formState = b,
                  this.incompleteTransitions = new Map(),
                  this.passiveEffectDuration = this.effectDuration = -0,
                  this.memoizedUpdaters = new Set(),
                  e = this.pendingUpdatersLaneMap = [],
                  t = 0;
                31 > t;
                t++
              )
                e.push(new Set());
              this._debugRootType = n ? 'hydrateRoot()' : 'createRoot()';
            }
            function fy(e, t, n, a, s, c, f, b, w, T, j, H) {
              return (
                (e = new Gx(e, t, n, f, b, w, T, H)),
                (t = rw),
                c === !0 && (t |= It | Qn),
                Xn && (t |= Vt),
                (c = S(3, null, null, t)),
                (e.current = c),
                (c.stateNode = e),
                (t = id()),
                Xi(t),
                (e.pooledCache = t),
                Xi(t),
                (c.memoizedState = { element: a, isDehydrated: n, cache: t }),
                rd(c),
                e
              );
            }
            function my(e) {
              return e ? ((e = gi), e) : gi;
            }
            function Mf(e, t, n, a, s, c) {
              if (Ht && typeof Ht.onScheduleFiberRoot == 'function')
                try {
                  Ht.onScheduleFiberRoot(Yl, a, n);
                } catch (f) {
                  ua ||
                    ((ua = !0),
                    console.error(
                      'React instrumentation encountered an error: %s',
                      f
                    ));
                }
              (oe !== null &&
                typeof oe.markRenderScheduled == 'function' &&
                oe.markRenderScheduled(t),
                (s = my(s)),
                a.context === null ? (a.context = s) : (a.pendingContext = s),
                fa &&
                  bn !== null &&
                  !W1 &&
                  ((W1 = !0),
                  console.error(
                    `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
                    J(bn) || 'Unknown'
                  )),
                (a = ni(t)),
                (a.payload = { element: n }),
                (c = c === void 0 ? null : c),
                c !== null &&
                  (typeof c != 'function' &&
                    console.error(
                      'Expected the last optional `callback` argument to be a function. Instead received: %s.',
                      c
                    ),
                  (a.callback = c)),
                (n = ai(e, a, t)),
                n !== null && (mt(n, e, t), Fs(n, e, t)));
            }
            function py(e, t) {
              if (
                ((e = e.memoizedState), e !== null && e.dehydrated !== null)
              ) {
                var n = e.retryLane;
                e.retryLane = n !== 0 && n < t ? n : t;
              }
            }
            function Of(e, t) {
              (py(e, t), (e = e.alternate) && py(e, t));
            }
            function hy(e) {
              if (e.tag === 13) {
                var t = en(e, 67108864);
                (t !== null && mt(t, e, 67108864), Of(e, 67108864));
              }
            }
            function qx() {
              return bn;
            }
            function Yx() {
              for (var e = new Map(), t = 1, n = 0; 31 > n; n++) {
                var a = ks(t);
                (e.set(t, a), (t *= 2));
              }
              return e;
            }
            function Xx(e, t, n, a) {
              var s = z.T;
              z.T = null;
              var c = $e.p;
              try {
                (($e.p = On), kf(e, t, n, a));
              } finally {
                (($e.p = c), (z.T = s));
              }
            }
            function Qx(e, t, n, a) {
              var s = z.T;
              z.T = null;
              var c = $e.p;
              try {
                (($e.p = da), kf(e, t, n, a));
              } finally {
                (($e.p = c), (z.T = s));
              }
            }
            function kf(e, t, n, a) {
              if (du) {
                var s = _f(a);
                if (s === null) (yf(e, t, a, fu, n), by(e, a));
                else if (Zx(s, e, t, n, a)) a.stopPropagation();
                else if ((by(e, a), t & 4 && -1 < Uw.indexOf(e))) {
                  for (; s !== null; ) {
                    var c = Gn(s);
                    if (c !== null)
                      switch (c.tag) {
                        case 3:
                          if (
                            ((c = c.stateNode),
                            c.current.memoizedState.isDehydrated)
                          ) {
                            var f = bt(c.pendingLanes);
                            if (f !== 0) {
                              var b = c;
                              for (
                                b.pendingLanes |= 2, b.entangledLanes |= 2;
                                f;
                              ) {
                                var w = 1 << (31 - $t(f));
                                ((b.entanglements[1] |= w), (f &= ~w));
                              }
                              (sa(c),
                                (Pe & (Xt | Jn)) === yn &&
                                  ((Qc = ca() + S1), fo(0)));
                            }
                          }
                          break;
                        case 13:
                          ((b = en(c, 2)),
                            b !== null && mt(b, c, 2),
                            zl(),
                            Of(c, 2));
                      }
                    if (
                      ((c = _f(a)), c === null && yf(e, t, a, fu, n), c === s)
                    )
                      break;
                    s = c;
                  }
                  s !== null && a.stopPropagation();
                } else yf(e, t, a, null, n);
              }
            }
            function _f(e) {
              return ((e = $u(e)), jf(e));
            }
            function jf(e) {
              if (((fu = null), (e = Pn(e)), e !== null)) {
                var t = V(e);
                if (t === null) e = null;
                else {
                  var n = t.tag;
                  if (n === 13) {
                    if (((e = L(t)), e !== null)) return e;
                    e = null;
                  } else if (n === 3) {
                    if (t.stateNode.current.memoizedState.isDehydrated)
                      return t.tag === 3 ? t.stateNode.containerInfo : null;
                    e = null;
                  } else t !== e && (e = null);
                }
              }
              return ((fu = e), null);
            }
            function gy(e) {
              switch (e) {
                case 'beforetoggle':
                case 'cancel':
                case 'click':
                case 'close':
                case 'contextmenu':
                case 'copy':
                case 'cut':
                case 'auxclick':
                case 'dblclick':
                case 'dragend':
                case 'dragstart':
                case 'drop':
                case 'focusin':
                case 'focusout':
                case 'input':
                case 'invalid':
                case 'keydown':
                case 'keypress':
                case 'keyup':
                case 'mousedown':
                case 'mouseup':
                case 'paste':
                case 'pause':
                case 'play':
                case 'pointercancel':
                case 'pointerdown':
                case 'pointerup':
                case 'ratechange':
                case 'reset':
                case 'resize':
                case 'seeked':
                case 'submit':
                case 'toggle':
                case 'touchcancel':
                case 'touchend':
                case 'touchstart':
                case 'volumechange':
                case 'change':
                case 'selectionchange':
                case 'textInput':
                case 'compositionstart':
                case 'compositionend':
                case 'compositionupdate':
                case 'beforeblur':
                case 'afterblur':
                case 'beforeinput':
                case 'blur':
                case 'fullscreenchange':
                case 'focus':
                case 'hashchange':
                case 'popstate':
                case 'select':
                case 'selectstart':
                  return On;
                case 'drag':
                case 'dragenter':
                case 'dragexit':
                case 'dragleave':
                case 'dragover':
                case 'mousemove':
                case 'mouseout':
                case 'mouseover':
                case 'pointermove':
                case 'pointerout':
                case 'pointerover':
                case 'scroll':
                case 'touchmove':
                case 'wheel':
                case 'mouseenter':
                case 'mouseleave':
                case 'pointerenter':
                case 'pointerleave':
                  return da;
                case 'message':
                  switch (oN()) {
                    case Gf:
                      return On;
                    case qf:
                      return da;
                    case ql:
                    case rN:
                      return ja;
                    case Yf:
                      return Dc;
                    default:
                      return ja;
                  }
                default:
                  return ja;
              }
            }
            function by(e, t) {
              switch (e) {
                case 'focusin':
                case 'focusout':
                  Ti = null;
                  break;
                case 'dragenter':
                case 'dragleave':
                  Ci = null;
                  break;
                case 'mouseover':
                case 'mouseout':
                  Ai = null;
                  break;
                case 'pointerover':
                case 'pointerout':
                  lr.delete(t.pointerId);
                  break;
                case 'gotpointercapture':
                case 'lostpointercapture':
                  sr.delete(t.pointerId);
              }
            }
            function bo(e, t, n, a, s, c) {
              return e === null || e.nativeEvent !== c
                ? ((e = {
                    blockedOn: t,
                    domEventName: n,
                    eventSystemFlags: a,
                    nativeEvent: c,
                    targetContainers: [s],
                  }),
                  t !== null && ((t = Gn(t)), t !== null && hy(t)),
                  e)
                : ((e.eventSystemFlags |= a),
                  (t = e.targetContainers),
                  s !== null && t.indexOf(s) === -1 && t.push(s),
                  e);
            }
            function Zx(e, t, n, a, s) {
              switch (t) {
                case 'focusin':
                  return ((Ti = bo(Ti, e, t, n, a, s)), !0);
                case 'dragenter':
                  return ((Ci = bo(Ci, e, t, n, a, s)), !0);
                case 'mouseover':
                  return ((Ai = bo(Ai, e, t, n, a, s)), !0);
                case 'pointerover':
                  var c = s.pointerId;
                  return (lr.set(c, bo(lr.get(c) || null, e, t, n, a, s)), !0);
                case 'gotpointercapture':
                  return (
                    (c = s.pointerId),
                    sr.set(c, bo(sr.get(c) || null, e, t, n, a, s)),
                    !0
                  );
              }
              return !1;
            }
            function yy(e) {
              var t = Pn(e.target);
              if (t !== null) {
                var n = V(t);
                if (n !== null) {
                  if (((t = n.tag), t === 13)) {
                    if (((t = L(n)), t !== null)) {
                      ((e.blockedOn = t),
                        Cl(e.priority, function () {
                          if (n.tag === 13) {
                            var a = hn(n);
                            a = js(a);
                            var s = en(n, a);
                            (s !== null && mt(s, n, a), Of(n, a));
                          }
                        }));
                      return;
                    }
                  } else if (
                    t === 3 &&
                    n.stateNode.current.memoizedState.isDehydrated
                  ) {
                    e.blockedOn =
                      n.tag === 3 ? n.stateNode.containerInfo : null;
                    return;
                  }
                }
              }
              e.blockedOn = null;
            }
            function bc(e) {
              if (e.blockedOn !== null) return !1;
              for (var t = e.targetContainers; 0 < t.length; ) {
                var n = _f(e.nativeEvent);
                if (n === null) {
                  n = e.nativeEvent;
                  var a = new n.constructor(n.type, n),
                    s = a;
                  (wo !== null &&
                    console.error(
                      'Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.'
                    ),
                    (wo = s),
                    n.target.dispatchEvent(a),
                    wo === null &&
                      console.error(
                        'Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.'
                      ),
                    (wo = null));
                } else
                  return (
                    (t = Gn(n)),
                    t !== null && hy(t),
                    (e.blockedOn = n),
                    !1
                  );
                t.shift();
              }
              return !0;
            }
            function vy(e, t, n) {
              bc(e) && n.delete(t);
            }
            function Fx() {
              ((ap = !1),
                Ti !== null && bc(Ti) && (Ti = null),
                Ci !== null && bc(Ci) && (Ci = null),
                Ai !== null && bc(Ai) && (Ai = null),
                lr.forEach(vy),
                sr.forEach(vy));
            }
            function yc(e, t) {
              e.blockedOn === t &&
                ((e.blockedOn = null),
                ap ||
                  ((ap = !0),
                  yt.unstable_scheduleCallback(
                    yt.unstable_NormalPriority,
                    Fx
                  )));
            }
            function Sy(e) {
              mu !== e &&
                ((mu = e),
                yt.unstable_scheduleCallback(
                  yt.unstable_NormalPriority,
                  function () {
                    mu === e && (mu = null);
                    for (var t = 0; t < e.length; t += 3) {
                      var n = e[t],
                        a = e[t + 1],
                        s = e[t + 2];
                      if (typeof a != 'function') {
                        if (jf(a || n) === null) continue;
                        break;
                      }
                      var c = Gn(n);
                      c !== null &&
                        (e.splice(t, 3),
                        (t -= 3),
                        (n = {
                          pending: !0,
                          data: s,
                          method: n.method,
                          action: a,
                        }),
                        Object.freeze(n),
                        _d(c, n, a, s));
                    }
                  }
                ));
            }
            function yo(e) {
              function t(w) {
                return yc(w, e);
              }
              (Ti !== null && yc(Ti, e),
                Ci !== null && yc(Ci, e),
                Ai !== null && yc(Ai, e),
                lr.forEach(t),
                sr.forEach(t));
              for (var n = 0; n < Ri.length; n++) {
                var a = Ri[n];
                a.blockedOn === e && (a.blockedOn = null);
              }
              for (; 0 < Ri.length && ((n = Ri[0]), n.blockedOn === null); )
                (yy(n), n.blockedOn === null && Ri.shift());
              if (((n = (e.ownerDocument || e).$$reactFormReplay), n != null))
                for (a = 0; a < n.length; a += 3) {
                  var s = n[a],
                    c = n[a + 1],
                    f = s[an] || null;
                  if (typeof c == 'function') f || Sy(n);
                  else if (f) {
                    var b = null;
                    if (c && c.hasAttribute('formAction')) {
                      if (((s = c), (f = c[an] || null))) b = f.formAction;
                      else if (jf(s) !== null) continue;
                    } else b = f.action;
                    (typeof b == 'function'
                      ? (n[a + 1] = b)
                      : (n.splice(a, 3), (a -= 3)),
                      Sy(n));
                  }
                }
            }
            function Vf(e) {
              this._internalRoot = e;
            }
            function vc(e) {
              this._internalRoot = e;
            }
            function xy(e) {
              e[pi] &&
                (e._reactRootContainer
                  ? console.error(
                      'You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.'
                    )
                  : console.error(
                      'You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.'
                    ));
            }
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ==
                'function' &&
              __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(
                Error()
              );
            var yt = Yw(),
              Bf = Au(),
              Kx = W0(),
              Re = Object.assign,
              Jx = Symbol.for('react.element'),
              ui = Symbol.for('react.transitional.element'),
              Pl = Symbol.for('react.portal'),
              Gl = Symbol.for('react.fragment'),
              Sc = Symbol.for('react.strict_mode'),
              Lf = Symbol.for('react.profiler'),
              eN = Symbol.for('react.provider'),
              zf = Symbol.for('react.consumer'),
              ra = Symbol.for('react.context'),
              vo = Symbol.for('react.forward_ref'),
              Hf = Symbol.for('react.suspense'),
              Uf = Symbol.for('react.suspense_list'),
              xc = Symbol.for('react.memo'),
              gn = Symbol.for('react.lazy'),
              If = Symbol.for('react.activity'),
              tN = Symbol.for('react.memo_cache_sentinel'),
              Ny = Symbol.iterator,
              nN = Symbol.for('react.client.reference'),
              jt = Array.isArray,
              z =
                Bf.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
              $e =
                Kx.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
              aN = Object.freeze({
                pending: !1,
                data: null,
                method: null,
                action: null,
              }),
              Wf = [],
              $f = [],
              ka = -1,
              di = ee(null),
              So = ee(null),
              fi = ee(null),
              Nc = ee(null),
              _a = Object.prototype.hasOwnProperty,
              Pf = yt.unstable_scheduleCallback,
              iN = yt.unstable_cancelCallback,
              lN = yt.unstable_shouldYield,
              sN = yt.unstable_requestPaint,
              ca = yt.unstable_now,
              oN = yt.unstable_getCurrentPriorityLevel,
              Gf = yt.unstable_ImmediatePriority,
              qf = yt.unstable_UserBlockingPriority,
              ql = yt.unstable_NormalPriority,
              rN = yt.unstable_LowPriority,
              Yf = yt.unstable_IdlePriority,
              cN = yt.log,
              uN = yt.unstable_setDisableYieldValue,
              Yl = null,
              Ht = null,
              oe = null,
              ua = !1,
              Xn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u',
              $t = Math.clz32 ? Math.clz32 : br,
              dN = Math.log,
              fN = Math.LN2,
              wc = 256,
              Ec = 4194304,
              On = 2,
              da = 8,
              ja = 32,
              Dc = 268435456,
              mi = Math.random().toString(36).slice(2),
              Ut = '__reactFiber$' + mi,
              an = '__reactProps$' + mi,
              pi = '__reactContainer$' + mi,
              Xf = '__reactEvents$' + mi,
              mN = '__reactListeners$' + mi,
              pN = '__reactHandles$' + mi,
              wy = '__reactResources$' + mi,
              xo = '__reactMarker$' + mi,
              Ey = new Set(),
              el = {},
              Qf = {},
              hN = {
                button: !0,
                checkbox: !0,
                image: !0,
                hidden: !0,
                radio: !0,
                reset: !0,
                submit: !0,
              },
              gN = RegExp(
                '^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
              ),
              Dy = {},
              Ty = {},
              No = 0,
              Cy,
              Ay,
              Ry,
              My,
              Oy,
              ky,
              _y;
            Na.__reactDisabledLog = !0;
            var Zf,
              jy,
              Ff = !1,
              Kf = new (typeof WeakMap == 'function' ? WeakMap : Map)(),
              bn = null,
              fa = !1,
              bN = /[\n"\\]/g,
              Vy = !1,
              By = !1,
              Ly = !1,
              zy = !1,
              Hy = !1,
              Uy = !1,
              Iy = ['value', 'defaultValue'],
              Wy = !1,
              $y = /["'&<>\n\t]|^\s|\s$/,
              yN =
                'address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp'.split(
                  ' '
                ),
              Py =
                'applet caption html table td th marquee object template foreignObject desc title'.split(
                  ' '
                ),
              vN = Py.concat(['button']),
              SN = 'dd dt li option optgroup p rp rt'.split(' '),
              Gy = {
                current: null,
                formTag: null,
                aTagInScope: null,
                buttonTagInScope: null,
                nobrTagInScope: null,
                pTagInButtonScope: null,
                listItemTagAutoclosing: null,
                dlItemTagAutoclosing: null,
                containerTagInScope: null,
                implicitRootScope: !1,
              },
              Tc = {},
              Jf = {
                animation:
                  'animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction'.split(
                    ' '
                  ),
                background:
                  'backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize'.split(
                    ' '
                  ),
                backgroundPosition: [
                  'backgroundPositionX',
                  'backgroundPositionY',
                ],
                border:
                  'borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth'.split(
                    ' '
                  ),
                borderBlockEnd: [
                  'borderBlockEndColor',
                  'borderBlockEndStyle',
                  'borderBlockEndWidth',
                ],
                borderBlockStart: [
                  'borderBlockStartColor',
                  'borderBlockStartStyle',
                  'borderBlockStartWidth',
                ],
                borderBottom: [
                  'borderBottomColor',
                  'borderBottomStyle',
                  'borderBottomWidth',
                ],
                borderColor: [
                  'borderBottomColor',
                  'borderLeftColor',
                  'borderRightColor',
                  'borderTopColor',
                ],
                borderImage: [
                  'borderImageOutset',
                  'borderImageRepeat',
                  'borderImageSlice',
                  'borderImageSource',
                  'borderImageWidth',
                ],
                borderInlineEnd: [
                  'borderInlineEndColor',
                  'borderInlineEndStyle',
                  'borderInlineEndWidth',
                ],
                borderInlineStart: [
                  'borderInlineStartColor',
                  'borderInlineStartStyle',
                  'borderInlineStartWidth',
                ],
                borderLeft: [
                  'borderLeftColor',
                  'borderLeftStyle',
                  'borderLeftWidth',
                ],
                borderRadius: [
                  'borderBottomLeftRadius',
                  'borderBottomRightRadius',
                  'borderTopLeftRadius',
                  'borderTopRightRadius',
                ],
                borderRight: [
                  'borderRightColor',
                  'borderRightStyle',
                  'borderRightWidth',
                ],
                borderStyle: [
                  'borderBottomStyle',
                  'borderLeftStyle',
                  'borderRightStyle',
                  'borderTopStyle',
                ],
                borderTop: [
                  'borderTopColor',
                  'borderTopStyle',
                  'borderTopWidth',
                ],
                borderWidth: [
                  'borderBottomWidth',
                  'borderLeftWidth',
                  'borderRightWidth',
                  'borderTopWidth',
                ],
                columnRule: [
                  'columnRuleColor',
                  'columnRuleStyle',
                  'columnRuleWidth',
                ],
                columns: ['columnCount', 'columnWidth'],
                flex: ['flexBasis', 'flexGrow', 'flexShrink'],
                flexFlow: ['flexDirection', 'flexWrap'],
                font: 'fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight'.split(
                  ' '
                ),
                fontVariant:
                  'fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition'.split(
                    ' '
                  ),
                gap: ['columnGap', 'rowGap'],
                grid: 'gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows'.split(
                  ' '
                ),
                gridArea: [
                  'gridColumnEnd',
                  'gridColumnStart',
                  'gridRowEnd',
                  'gridRowStart',
                ],
                gridColumn: ['gridColumnEnd', 'gridColumnStart'],
                gridColumnGap: ['columnGap'],
                gridGap: ['columnGap', 'rowGap'],
                gridRow: ['gridRowEnd', 'gridRowStart'],
                gridRowGap: ['rowGap'],
                gridTemplate: [
                  'gridTemplateAreas',
                  'gridTemplateColumns',
                  'gridTemplateRows',
                ],
                listStyle: [
                  'listStyleImage',
                  'listStylePosition',
                  'listStyleType',
                ],
                margin: [
                  'marginBottom',
                  'marginLeft',
                  'marginRight',
                  'marginTop',
                ],
                marker: ['markerEnd', 'markerMid', 'markerStart'],
                mask: 'maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize'.split(
                  ' '
                ),
                maskPosition: ['maskPositionX', 'maskPositionY'],
                outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
                overflow: ['overflowX', 'overflowY'],
                padding: [
                  'paddingBottom',
                  'paddingLeft',
                  'paddingRight',
                  'paddingTop',
                ],
                placeContent: ['alignContent', 'justifyContent'],
                placeItems: ['alignItems', 'justifyItems'],
                placeSelf: ['alignSelf', 'justifySelf'],
                textDecoration: [
                  'textDecorationColor',
                  'textDecorationLine',
                  'textDecorationStyle',
                ],
                textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
                transition: [
                  'transitionDelay',
                  'transitionDuration',
                  'transitionProperty',
                  'transitionTimingFunction',
                ],
                wordWrap: ['overflowWrap'],
              },
              qy = /([A-Z])/g,
              Yy = /^ms-/,
              xN = /^(?:webkit|moz|o)[A-Z]/,
              NN = /^-ms-/,
              wN = /-(.)/g,
              Xy = /;\s*$/,
              Xl = {},
              em = {},
              Qy = !1,
              Zy = !1,
              Fy = new Set(
                'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp'.split(
                  ' '
                )
              ),
              Cc = 'http://www.w3.org/1998/Math/MathML',
              Ql = 'http://www.w3.org/2000/svg',
              EN = new Map([
                ['acceptCharset', 'accept-charset'],
                ['htmlFor', 'for'],
                ['httpEquiv', 'http-equiv'],
                ['crossOrigin', 'crossorigin'],
                ['accentHeight', 'accent-height'],
                ['alignmentBaseline', 'alignment-baseline'],
                ['arabicForm', 'arabic-form'],
                ['baselineShift', 'baseline-shift'],
                ['capHeight', 'cap-height'],
                ['clipPath', 'clip-path'],
                ['clipRule', 'clip-rule'],
                ['colorInterpolation', 'color-interpolation'],
                ['colorInterpolationFilters', 'color-interpolation-filters'],
                ['colorProfile', 'color-profile'],
                ['colorRendering', 'color-rendering'],
                ['dominantBaseline', 'dominant-baseline'],
                ['enableBackground', 'enable-background'],
                ['fillOpacity', 'fill-opacity'],
                ['fillRule', 'fill-rule'],
                ['floodColor', 'flood-color'],
                ['floodOpacity', 'flood-opacity'],
                ['fontFamily', 'font-family'],
                ['fontSize', 'font-size'],
                ['fontSizeAdjust', 'font-size-adjust'],
                ['fontStretch', 'font-stretch'],
                ['fontStyle', 'font-style'],
                ['fontVariant', 'font-variant'],
                ['fontWeight', 'font-weight'],
                ['glyphName', 'glyph-name'],
                ['glyphOrientationHorizontal', 'glyph-orientation-horizontal'],
                ['glyphOrientationVertical', 'glyph-orientation-vertical'],
                ['horizAdvX', 'horiz-adv-x'],
                ['horizOriginX', 'horiz-origin-x'],
                ['imageRendering', 'image-rendering'],
                ['letterSpacing', 'letter-spacing'],
                ['lightingColor', 'lighting-color'],
                ['markerEnd', 'marker-end'],
                ['markerMid', 'marker-mid'],
                ['markerStart', 'marker-start'],
                ['overlinePosition', 'overline-position'],
                ['overlineThickness', 'overline-thickness'],
                ['paintOrder', 'paint-order'],
                ['panose-1', 'panose-1'],
                ['pointerEvents', 'pointer-events'],
                ['renderingIntent', 'rendering-intent'],
                ['shapeRendering', 'shape-rendering'],
                ['stopColor', 'stop-color'],
                ['stopOpacity', 'stop-opacity'],
                ['strikethroughPosition', 'strikethrough-position'],
                ['strikethroughThickness', 'strikethrough-thickness'],
                ['strokeDasharray', 'stroke-dasharray'],
                ['strokeDashoffset', 'stroke-dashoffset'],
                ['strokeLinecap', 'stroke-linecap'],
                ['strokeLinejoin', 'stroke-linejoin'],
                ['strokeMiterlimit', 'stroke-miterlimit'],
                ['strokeOpacity', 'stroke-opacity'],
                ['strokeWidth', 'stroke-width'],
                ['textAnchor', 'text-anchor'],
                ['textDecoration', 'text-decoration'],
                ['textRendering', 'text-rendering'],
                ['transformOrigin', 'transform-origin'],
                ['underlinePosition', 'underline-position'],
                ['underlineThickness', 'underline-thickness'],
                ['unicodeBidi', 'unicode-bidi'],
                ['unicodeRange', 'unicode-range'],
                ['unitsPerEm', 'units-per-em'],
                ['vAlphabetic', 'v-alphabetic'],
                ['vHanging', 'v-hanging'],
                ['vIdeographic', 'v-ideographic'],
                ['vMathematical', 'v-mathematical'],
                ['vectorEffect', 'vector-effect'],
                ['vertAdvY', 'vert-adv-y'],
                ['vertOriginX', 'vert-origin-x'],
                ['vertOriginY', 'vert-origin-y'],
                ['wordSpacing', 'word-spacing'],
                ['writingMode', 'writing-mode'],
                ['xmlnsXlink', 'xmlns:xlink'],
                ['xHeight', 'x-height'],
              ]),
              Ac = {
                accept: 'accept',
                acceptcharset: 'acceptCharset',
                'accept-charset': 'acceptCharset',
                accesskey: 'accessKey',
                action: 'action',
                allowfullscreen: 'allowFullScreen',
                alt: 'alt',
                as: 'as',
                async: 'async',
                autocapitalize: 'autoCapitalize',
                autocomplete: 'autoComplete',
                autocorrect: 'autoCorrect',
                autofocus: 'autoFocus',
                autoplay: 'autoPlay',
                autosave: 'autoSave',
                capture: 'capture',
                cellpadding: 'cellPadding',
                cellspacing: 'cellSpacing',
                challenge: 'challenge',
                charset: 'charSet',
                checked: 'checked',
                children: 'children',
                cite: 'cite',
                class: 'className',
                classid: 'classID',
                classname: 'className',
                cols: 'cols',
                colspan: 'colSpan',
                content: 'content',
                contenteditable: 'contentEditable',
                contextmenu: 'contextMenu',
                controls: 'controls',
                controlslist: 'controlsList',
                coords: 'coords',
                crossorigin: 'crossOrigin',
                dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
                data: 'data',
                datetime: 'dateTime',
                default: 'default',
                defaultchecked: 'defaultChecked',
                defaultvalue: 'defaultValue',
                defer: 'defer',
                dir: 'dir',
                disabled: 'disabled',
                disablepictureinpicture: 'disablePictureInPicture',
                disableremoteplayback: 'disableRemotePlayback',
                download: 'download',
                draggable: 'draggable',
                enctype: 'encType',
                enterkeyhint: 'enterKeyHint',
                fetchpriority: 'fetchPriority',
                for: 'htmlFor',
                form: 'form',
                formmethod: 'formMethod',
                formaction: 'formAction',
                formenctype: 'formEncType',
                formnovalidate: 'formNoValidate',
                formtarget: 'formTarget',
                frameborder: 'frameBorder',
                headers: 'headers',
                height: 'height',
                hidden: 'hidden',
                high: 'high',
                href: 'href',
                hreflang: 'hrefLang',
                htmlfor: 'htmlFor',
                httpequiv: 'httpEquiv',
                'http-equiv': 'httpEquiv',
                icon: 'icon',
                id: 'id',
                imagesizes: 'imageSizes',
                imagesrcset: 'imageSrcSet',
                inert: 'inert',
                innerhtml: 'innerHTML',
                inputmode: 'inputMode',
                integrity: 'integrity',
                is: 'is',
                itemid: 'itemID',
                itemprop: 'itemProp',
                itemref: 'itemRef',
                itemscope: 'itemScope',
                itemtype: 'itemType',
                keyparams: 'keyParams',
                keytype: 'keyType',
                kind: 'kind',
                label: 'label',
                lang: 'lang',
                list: 'list',
                loop: 'loop',
                low: 'low',
                manifest: 'manifest',
                marginwidth: 'marginWidth',
                marginheight: 'marginHeight',
                max: 'max',
                maxlength: 'maxLength',
                media: 'media',
                mediagroup: 'mediaGroup',
                method: 'method',
                min: 'min',
                minlength: 'minLength',
                multiple: 'multiple',
                muted: 'muted',
                name: 'name',
                nomodule: 'noModule',
                nonce: 'nonce',
                novalidate: 'noValidate',
                open: 'open',
                optimum: 'optimum',
                pattern: 'pattern',
                placeholder: 'placeholder',
                playsinline: 'playsInline',
                poster: 'poster',
                preload: 'preload',
                profile: 'profile',
                radiogroup: 'radioGroup',
                readonly: 'readOnly',
                referrerpolicy: 'referrerPolicy',
                rel: 'rel',
                required: 'required',
                reversed: 'reversed',
                role: 'role',
                rows: 'rows',
                rowspan: 'rowSpan',
                sandbox: 'sandbox',
                scope: 'scope',
                scoped: 'scoped',
                scrolling: 'scrolling',
                seamless: 'seamless',
                selected: 'selected',
                shape: 'shape',
                size: 'size',
                sizes: 'sizes',
                span: 'span',
                spellcheck: 'spellCheck',
                src: 'src',
                srcdoc: 'srcDoc',
                srclang: 'srcLang',
                srcset: 'srcSet',
                start: 'start',
                step: 'step',
                style: 'style',
                summary: 'summary',
                tabindex: 'tabIndex',
                target: 'target',
                title: 'title',
                type: 'type',
                usemap: 'useMap',
                value: 'value',
                width: 'width',
                wmode: 'wmode',
                wrap: 'wrap',
                about: 'about',
                accentheight: 'accentHeight',
                'accent-height': 'accentHeight',
                accumulate: 'accumulate',
                additive: 'additive',
                alignmentbaseline: 'alignmentBaseline',
                'alignment-baseline': 'alignmentBaseline',
                allowreorder: 'allowReorder',
                alphabetic: 'alphabetic',
                amplitude: 'amplitude',
                arabicform: 'arabicForm',
                'arabic-form': 'arabicForm',
                ascent: 'ascent',
                attributename: 'attributeName',
                attributetype: 'attributeType',
                autoreverse: 'autoReverse',
                azimuth: 'azimuth',
                basefrequency: 'baseFrequency',
                baselineshift: 'baselineShift',
                'baseline-shift': 'baselineShift',
                baseprofile: 'baseProfile',
                bbox: 'bbox',
                begin: 'begin',
                bias: 'bias',
                by: 'by',
                calcmode: 'calcMode',
                capheight: 'capHeight',
                'cap-height': 'capHeight',
                clip: 'clip',
                clippath: 'clipPath',
                'clip-path': 'clipPath',
                clippathunits: 'clipPathUnits',
                cliprule: 'clipRule',
                'clip-rule': 'clipRule',
                color: 'color',
                colorinterpolation: 'colorInterpolation',
                'color-interpolation': 'colorInterpolation',
                colorinterpolationfilters: 'colorInterpolationFilters',
                'color-interpolation-filters': 'colorInterpolationFilters',
                colorprofile: 'colorProfile',
                'color-profile': 'colorProfile',
                colorrendering: 'colorRendering',
                'color-rendering': 'colorRendering',
                contentscripttype: 'contentScriptType',
                contentstyletype: 'contentStyleType',
                cursor: 'cursor',
                cx: 'cx',
                cy: 'cy',
                d: 'd',
                datatype: 'datatype',
                decelerate: 'decelerate',
                descent: 'descent',
                diffuseconstant: 'diffuseConstant',
                direction: 'direction',
                display: 'display',
                divisor: 'divisor',
                dominantbaseline: 'dominantBaseline',
                'dominant-baseline': 'dominantBaseline',
                dur: 'dur',
                dx: 'dx',
                dy: 'dy',
                edgemode: 'edgeMode',
                elevation: 'elevation',
                enablebackground: 'enableBackground',
                'enable-background': 'enableBackground',
                end: 'end',
                exponent: 'exponent',
                externalresourcesrequired: 'externalResourcesRequired',
                fill: 'fill',
                fillopacity: 'fillOpacity',
                'fill-opacity': 'fillOpacity',
                fillrule: 'fillRule',
                'fill-rule': 'fillRule',
                filter: 'filter',
                filterres: 'filterRes',
                filterunits: 'filterUnits',
                floodopacity: 'floodOpacity',
                'flood-opacity': 'floodOpacity',
                floodcolor: 'floodColor',
                'flood-color': 'floodColor',
                focusable: 'focusable',
                fontfamily: 'fontFamily',
                'font-family': 'fontFamily',
                fontsize: 'fontSize',
                'font-size': 'fontSize',
                fontsizeadjust: 'fontSizeAdjust',
                'font-size-adjust': 'fontSizeAdjust',
                fontstretch: 'fontStretch',
                'font-stretch': 'fontStretch',
                fontstyle: 'fontStyle',
                'font-style': 'fontStyle',
                fontvariant: 'fontVariant',
                'font-variant': 'fontVariant',
                fontweight: 'fontWeight',
                'font-weight': 'fontWeight',
                format: 'format',
                from: 'from',
                fx: 'fx',
                fy: 'fy',
                g1: 'g1',
                g2: 'g2',
                glyphname: 'glyphName',
                'glyph-name': 'glyphName',
                glyphorientationhorizontal: 'glyphOrientationHorizontal',
                'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
                glyphorientationvertical: 'glyphOrientationVertical',
                'glyph-orientation-vertical': 'glyphOrientationVertical',
                glyphref: 'glyphRef',
                gradienttransform: 'gradientTransform',
                gradientunits: 'gradientUnits',
                hanging: 'hanging',
                horizadvx: 'horizAdvX',
                'horiz-adv-x': 'horizAdvX',
                horizoriginx: 'horizOriginX',
                'horiz-origin-x': 'horizOriginX',
                ideographic: 'ideographic',
                imagerendering: 'imageRendering',
                'image-rendering': 'imageRendering',
                in2: 'in2',
                in: 'in',
                inlist: 'inlist',
                intercept: 'intercept',
                k1: 'k1',
                k2: 'k2',
                k3: 'k3',
                k4: 'k4',
                k: 'k',
                kernelmatrix: 'kernelMatrix',
                kernelunitlength: 'kernelUnitLength',
                kerning: 'kerning',
                keypoints: 'keyPoints',
                keysplines: 'keySplines',
                keytimes: 'keyTimes',
                lengthadjust: 'lengthAdjust',
                letterspacing: 'letterSpacing',
                'letter-spacing': 'letterSpacing',
                lightingcolor: 'lightingColor',
                'lighting-color': 'lightingColor',
                limitingconeangle: 'limitingConeAngle',
                local: 'local',
                markerend: 'markerEnd',
                'marker-end': 'markerEnd',
                markerheight: 'markerHeight',
                markermid: 'markerMid',
                'marker-mid': 'markerMid',
                markerstart: 'markerStart',
                'marker-start': 'markerStart',
                markerunits: 'markerUnits',
                markerwidth: 'markerWidth',
                mask: 'mask',
                maskcontentunits: 'maskContentUnits',
                maskunits: 'maskUnits',
                mathematical: 'mathematical',
                mode: 'mode',
                numoctaves: 'numOctaves',
                offset: 'offset',
                opacity: 'opacity',
                operator: 'operator',
                order: 'order',
                orient: 'orient',
                orientation: 'orientation',
                origin: 'origin',
                overflow: 'overflow',
                overlineposition: 'overlinePosition',
                'overline-position': 'overlinePosition',
                overlinethickness: 'overlineThickness',
                'overline-thickness': 'overlineThickness',
                paintorder: 'paintOrder',
                'paint-order': 'paintOrder',
                panose1: 'panose1',
                'panose-1': 'panose1',
                pathlength: 'pathLength',
                patterncontentunits: 'patternContentUnits',
                patterntransform: 'patternTransform',
                patternunits: 'patternUnits',
                pointerevents: 'pointerEvents',
                'pointer-events': 'pointerEvents',
                points: 'points',
                pointsatx: 'pointsAtX',
                pointsaty: 'pointsAtY',
                pointsatz: 'pointsAtZ',
                popover: 'popover',
                popovertarget: 'popoverTarget',
                popovertargetaction: 'popoverTargetAction',
                prefix: 'prefix',
                preservealpha: 'preserveAlpha',
                preserveaspectratio: 'preserveAspectRatio',
                primitiveunits: 'primitiveUnits',
                property: 'property',
                r: 'r',
                radius: 'radius',
                refx: 'refX',
                refy: 'refY',
                renderingintent: 'renderingIntent',
                'rendering-intent': 'renderingIntent',
                repeatcount: 'repeatCount',
                repeatdur: 'repeatDur',
                requiredextensions: 'requiredExtensions',
                requiredfeatures: 'requiredFeatures',
                resource: 'resource',
                restart: 'restart',
                result: 'result',
                results: 'results',
                rotate: 'rotate',
                rx: 'rx',
                ry: 'ry',
                scale: 'scale',
                security: 'security',
                seed: 'seed',
                shaperendering: 'shapeRendering',
                'shape-rendering': 'shapeRendering',
                slope: 'slope',
                spacing: 'spacing',
                specularconstant: 'specularConstant',
                specularexponent: 'specularExponent',
                speed: 'speed',
                spreadmethod: 'spreadMethod',
                startoffset: 'startOffset',
                stddeviation: 'stdDeviation',
                stemh: 'stemh',
                stemv: 'stemv',
                stitchtiles: 'stitchTiles',
                stopcolor: 'stopColor',
                'stop-color': 'stopColor',
                stopopacity: 'stopOpacity',
                'stop-opacity': 'stopOpacity',
                strikethroughposition: 'strikethroughPosition',
                'strikethrough-position': 'strikethroughPosition',
                strikethroughthickness: 'strikethroughThickness',
                'strikethrough-thickness': 'strikethroughThickness',
                string: 'string',
                stroke: 'stroke',
                strokedasharray: 'strokeDasharray',
                'stroke-dasharray': 'strokeDasharray',
                strokedashoffset: 'strokeDashoffset',
                'stroke-dashoffset': 'strokeDashoffset',
                strokelinecap: 'strokeLinecap',
                'stroke-linecap': 'strokeLinecap',
                strokelinejoin: 'strokeLinejoin',
                'stroke-linejoin': 'strokeLinejoin',
                strokemiterlimit: 'strokeMiterlimit',
                'stroke-miterlimit': 'strokeMiterlimit',
                strokewidth: 'strokeWidth',
                'stroke-width': 'strokeWidth',
                strokeopacity: 'strokeOpacity',
                'stroke-opacity': 'strokeOpacity',
                suppresscontenteditablewarning:
                  'suppressContentEditableWarning',
                suppresshydrationwarning: 'suppressHydrationWarning',
                surfacescale: 'surfaceScale',
                systemlanguage: 'systemLanguage',
                tablevalues: 'tableValues',
                targetx: 'targetX',
                targety: 'targetY',
                textanchor: 'textAnchor',
                'text-anchor': 'textAnchor',
                textdecoration: 'textDecoration',
                'text-decoration': 'textDecoration',
                textlength: 'textLength',
                textrendering: 'textRendering',
                'text-rendering': 'textRendering',
                to: 'to',
                transform: 'transform',
                transformorigin: 'transformOrigin',
                'transform-origin': 'transformOrigin',
                typeof: 'typeof',
                u1: 'u1',
                u2: 'u2',
                underlineposition: 'underlinePosition',
                'underline-position': 'underlinePosition',
                underlinethickness: 'underlineThickness',
                'underline-thickness': 'underlineThickness',
                unicode: 'unicode',
                unicodebidi: 'unicodeBidi',
                'unicode-bidi': 'unicodeBidi',
                unicoderange: 'unicodeRange',
                'unicode-range': 'unicodeRange',
                unitsperem: 'unitsPerEm',
                'units-per-em': 'unitsPerEm',
                unselectable: 'unselectable',
                valphabetic: 'vAlphabetic',
                'v-alphabetic': 'vAlphabetic',
                values: 'values',
                vectoreffect: 'vectorEffect',
                'vector-effect': 'vectorEffect',
                version: 'version',
                vertadvy: 'vertAdvY',
                'vert-adv-y': 'vertAdvY',
                vertoriginx: 'vertOriginX',
                'vert-origin-x': 'vertOriginX',
                vertoriginy: 'vertOriginY',
                'vert-origin-y': 'vertOriginY',
                vhanging: 'vHanging',
                'v-hanging': 'vHanging',
                videographic: 'vIdeographic',
                'v-ideographic': 'vIdeographic',
                viewbox: 'viewBox',
                viewtarget: 'viewTarget',
                visibility: 'visibility',
                vmathematical: 'vMathematical',
                'v-mathematical': 'vMathematical',
                vocab: 'vocab',
                widths: 'widths',
                wordspacing: 'wordSpacing',
                'word-spacing': 'wordSpacing',
                writingmode: 'writingMode',
                'writing-mode': 'writingMode',
                x1: 'x1',
                x2: 'x2',
                x: 'x',
                xchannelselector: 'xChannelSelector',
                xheight: 'xHeight',
                'x-height': 'xHeight',
                xlinkactuate: 'xlinkActuate',
                'xlink:actuate': 'xlinkActuate',
                xlinkarcrole: 'xlinkArcrole',
                'xlink:arcrole': 'xlinkArcrole',
                xlinkhref: 'xlinkHref',
                'xlink:href': 'xlinkHref',
                xlinkrole: 'xlinkRole',
                'xlink:role': 'xlinkRole',
                xlinkshow: 'xlinkShow',
                'xlink:show': 'xlinkShow',
                xlinktitle: 'xlinkTitle',
                'xlink:title': 'xlinkTitle',
                xlinktype: 'xlinkType',
                'xlink:type': 'xlinkType',
                xmlbase: 'xmlBase',
                'xml:base': 'xmlBase',
                xmllang: 'xmlLang',
                'xml:lang': 'xmlLang',
                xmlns: 'xmlns',
                'xml:space': 'xmlSpace',
                xmlnsxlink: 'xmlnsXlink',
                'xmlns:xlink': 'xmlnsXlink',
                xmlspace: 'xmlSpace',
                y1: 'y1',
                y2: 'y2',
                y: 'y',
                ychannelselector: 'yChannelSelector',
                z: 'z',
                zoomandpan: 'zoomAndPan',
              },
              Ky = {
                'aria-current': 0,
                'aria-description': 0,
                'aria-details': 0,
                'aria-disabled': 0,
                'aria-hidden': 0,
                'aria-invalid': 0,
                'aria-keyshortcuts': 0,
                'aria-label': 0,
                'aria-roledescription': 0,
                'aria-autocomplete': 0,
                'aria-checked': 0,
                'aria-expanded': 0,
                'aria-haspopup': 0,
                'aria-level': 0,
                'aria-modal': 0,
                'aria-multiline': 0,
                'aria-multiselectable': 0,
                'aria-orientation': 0,
                'aria-placeholder': 0,
                'aria-pressed': 0,
                'aria-readonly': 0,
                'aria-required': 0,
                'aria-selected': 0,
                'aria-sort': 0,
                'aria-valuemax': 0,
                'aria-valuemin': 0,
                'aria-valuenow': 0,
                'aria-valuetext': 0,
                'aria-atomic': 0,
                'aria-busy': 0,
                'aria-live': 0,
                'aria-relevant': 0,
                'aria-dropeffect': 0,
                'aria-grabbed': 0,
                'aria-activedescendant': 0,
                'aria-colcount': 0,
                'aria-colindex': 0,
                'aria-colspan': 0,
                'aria-controls': 0,
                'aria-describedby': 0,
                'aria-errormessage': 0,
                'aria-flowto': 0,
                'aria-labelledby': 0,
                'aria-owns': 0,
                'aria-posinset': 0,
                'aria-rowcount': 0,
                'aria-rowindex': 0,
                'aria-rowspan': 0,
                'aria-setsize': 0,
              },
              Zl = {},
              DN = RegExp(
                '^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
              ),
              TN = RegExp(
                '^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
              ),
              Jy = !1,
              Pt = {},
              ev = /^on./,
              CN = /^on[^A-Z]/,
              AN = RegExp(
                '^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
              ),
              RN = RegExp(
                '^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
              ),
              MN =
                /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i,
              wo = null,
              Fl = null,
              Kl = null,
              tm = !1,
              ma = !(
                typeof window > 'u' ||
                typeof window.document > 'u' ||
                typeof window.document.createElement > 'u'
              ),
              nm = !1;
            if (ma)
              try {
                var Eo = {};
                (Object.defineProperty(Eo, 'passive', {
                  get: function () {
                    nm = !0;
                  },
                }),
                  window.addEventListener('test', Eo, Eo),
                  window.removeEventListener('test', Eo, Eo));
              } catch {
                nm = !1;
              }
            var hi = null,
              am = null,
              Rc = null,
              tl = {
                eventPhase: 0,
                bubbles: 0,
                cancelable: 0,
                timeStamp: function (e) {
                  return e.timeStamp || Date.now();
                },
                defaultPrevented: 0,
                isTrusted: 0,
              },
              Mc = Jt(tl),
              Do = Re({}, tl, { view: 0, detail: 0 }),
              ON = Jt(Do),
              im,
              lm,
              To,
              Oc = Re({}, Do, {
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                getModifierState: Pu,
                button: 0,
                buttons: 0,
                relatedTarget: function (e) {
                  return e.relatedTarget === void 0
                    ? e.fromElement === e.srcElement
                      ? e.toElement
                      : e.fromElement
                    : e.relatedTarget;
                },
                movementX: function (e) {
                  return 'movementX' in e
                    ? e.movementX
                    : (e !== To &&
                        (To && e.type === 'mousemove'
                          ? ((im = e.screenX - To.screenX),
                            (lm = e.screenY - To.screenY))
                          : (lm = im = 0),
                        (To = e)),
                      im);
                },
                movementY: function (e) {
                  return 'movementY' in e ? e.movementY : lm;
                },
              }),
              tv = Jt(Oc),
              kN = Re({}, Oc, { dataTransfer: 0 }),
              _N = Jt(kN),
              jN = Re({}, Do, { relatedTarget: 0 }),
              sm = Jt(jN),
              VN = Re({}, tl, {
                animationName: 0,
                elapsedTime: 0,
                pseudoElement: 0,
              }),
              BN = Jt(VN),
              LN = Re({}, tl, {
                clipboardData: function (e) {
                  return 'clipboardData' in e
                    ? e.clipboardData
                    : window.clipboardData;
                },
              }),
              zN = Jt(LN),
              HN = Re({}, tl, { data: 0 }),
              nv = Jt(HN),
              UN = nv,
              IN = {
                Esc: 'Escape',
                Spacebar: ' ',
                Left: 'ArrowLeft',
                Up: 'ArrowUp',
                Right: 'ArrowRight',
                Down: 'ArrowDown',
                Del: 'Delete',
                Win: 'OS',
                Menu: 'ContextMenu',
                Apps: 'ContextMenu',
                Scroll: 'ScrollLock',
                MozPrintableKey: 'Unidentified',
              },
              WN = {
                8: 'Backspace',
                9: 'Tab',
                12: 'Clear',
                13: 'Enter',
                16: 'Shift',
                17: 'Control',
                18: 'Alt',
                19: 'Pause',
                20: 'CapsLock',
                27: 'Escape',
                32: ' ',
                33: 'PageUp',
                34: 'PageDown',
                35: 'End',
                36: 'Home',
                37: 'ArrowLeft',
                38: 'ArrowUp',
                39: 'ArrowRight',
                40: 'ArrowDown',
                45: 'Insert',
                46: 'Delete',
                112: 'F1',
                113: 'F2',
                114: 'F3',
                115: 'F4',
                116: 'F5',
                117: 'F6',
                118: 'F7',
                119: 'F8',
                120: 'F9',
                121: 'F10',
                122: 'F11',
                123: 'F12',
                144: 'NumLock',
                145: 'ScrollLock',
                224: 'Meta',
              },
              $N = {
                Alt: 'altKey',
                Control: 'ctrlKey',
                Meta: 'metaKey',
                Shift: 'shiftKey',
              },
              PN = Re({}, Do, {
                key: function (e) {
                  if (e.key) {
                    var t = IN[e.key] || e.key;
                    if (t !== 'Unidentified') return t;
                  }
                  return e.type === 'keypress'
                    ? ((e = Dr(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
                    : e.type === 'keydown' || e.type === 'keyup'
                      ? WN[e.keyCode] || 'Unidentified'
                      : '';
                },
                code: 0,
                location: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                repeat: 0,
                locale: 0,
                getModifierState: Pu,
                charCode: function (e) {
                  return e.type === 'keypress' ? Dr(e) : 0;
                },
                keyCode: function (e) {
                  return e.type === 'keydown' || e.type === 'keyup'
                    ? e.keyCode
                    : 0;
                },
                which: function (e) {
                  return e.type === 'keypress'
                    ? Dr(e)
                    : e.type === 'keydown' || e.type === 'keyup'
                      ? e.keyCode
                      : 0;
                },
              }),
              GN = Jt(PN),
              qN = Re({}, Oc, {
                pointerId: 0,
                width: 0,
                height: 0,
                pressure: 0,
                tangentialPressure: 0,
                tiltX: 0,
                tiltY: 0,
                twist: 0,
                pointerType: 0,
                isPrimary: 0,
              }),
              av = Jt(qN),
              YN = Re({}, Do, {
                touches: 0,
                targetTouches: 0,
                changedTouches: 0,
                altKey: 0,
                metaKey: 0,
                ctrlKey: 0,
                shiftKey: 0,
                getModifierState: Pu,
              }),
              XN = Jt(YN),
              QN = Re({}, tl, {
                propertyName: 0,
                elapsedTime: 0,
                pseudoElement: 0,
              }),
              ZN = Jt(QN),
              FN = Re({}, Oc, {
                deltaX: function (e) {
                  return 'deltaX' in e
                    ? e.deltaX
                    : 'wheelDeltaX' in e
                      ? -e.wheelDeltaX
                      : 0;
                },
                deltaY: function (e) {
                  return 'deltaY' in e
                    ? e.deltaY
                    : 'wheelDeltaY' in e
                      ? -e.wheelDeltaY
                      : 'wheelDelta' in e
                        ? -e.wheelDelta
                        : 0;
                },
                deltaZ: 0,
                deltaMode: 0,
              }),
              KN = Jt(FN),
              JN = Re({}, tl, { newState: 0, oldState: 0 }),
              ew = Jt(JN),
              tw = [9, 13, 27, 32],
              iv = 229,
              om = ma && 'CompositionEvent' in window,
              Co = null;
            ma && 'documentMode' in document && (Co = document.documentMode);
            var nw = ma && 'TextEvent' in window && !Co,
              lv = ma && (!om || (Co && 8 < Co && 11 >= Co)),
              sv = 32,
              ov = String.fromCharCode(sv),
              rv = !1,
              Jl = !1,
              aw = {
                color: !0,
                date: !0,
                datetime: !0,
                'datetime-local': !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0,
              },
              Ao = null,
              Ro = null,
              cv = !1;
            ma &&
              (cv =
                _S('input') &&
                (!document.documentMode || 9 < document.documentMode));
            var Gt = typeof Object.is == 'function' ? Object.is : HS,
              iw =
                ma && 'documentMode' in document && 11 >= document.documentMode,
              es = null,
              rm = null,
              Mo = null,
              cm = !1,
              ts = {
                animationend: Hi('Animation', 'AnimationEnd'),
                animationiteration: Hi('Animation', 'AnimationIteration'),
                animationstart: Hi('Animation', 'AnimationStart'),
                transitionrun: Hi('Transition', 'TransitionRun'),
                transitionstart: Hi('Transition', 'TransitionStart'),
                transitioncancel: Hi('Transition', 'TransitionCancel'),
                transitionend: Hi('Transition', 'TransitionEnd'),
              },
              um = {},
              uv = {};
            ma &&
              ((uv = document.createElement('div').style),
              'AnimationEvent' in window ||
                (delete ts.animationend.animation,
                delete ts.animationiteration.animation,
                delete ts.animationstart.animation),
              'TransitionEvent' in window ||
                delete ts.transitionend.transition);
            var dv = Ui('animationend'),
              fv = Ui('animationiteration'),
              mv = Ui('animationstart'),
              lw = Ui('transitionrun'),
              sw = Ui('transitionstart'),
              ow = Ui('transitioncancel'),
              pv = Ui('transitionend'),
              hv = new Map(),
              dm =
                'abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
                  ' '
                );
            dm.push('scrollEnd');
            var fm = new WeakMap(),
              kc = 1,
              Va = 2,
              kn = [],
              ns = 0,
              mm = 0,
              gi = {};
            Object.freeze(gi);
            var _n = null,
              as = null,
              Ke = 0,
              rw = 1,
              Vt = 2,
              It = 8,
              Qn = 16,
              gv = 64,
              bv = !1;
            try {
              Object.preventExtensions({});
            } catch {
              bv = !0;
            }
            var is = [],
              ls = 0,
              _c = null,
              jc = 0,
              jn = [],
              Vn = 0,
              nl = null,
              Ba = 1,
              La = '',
              qt = null,
              rt = null,
              He = !1,
              za = !1,
              Bn = null,
              al = null,
              pa = !1,
              pm = Error(
                "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
              ),
              yv = 0;
            if (
              typeof performance == 'object' &&
              typeof performance.now == 'function'
            )
              var cw = performance,
                vv = function () {
                  return cw.now();
                };
            else {
              var uw = Date;
              vv = function () {
                return uw.now();
              };
            }
            var hm = ee(null),
              gm = ee(null),
              Sv = {},
              Vc = null,
              ss = null,
              os = !1,
              dw =
                typeof AbortController < 'u'
                  ? AbortController
                  : function () {
                      var e = [],
                        t = (this.signal = {
                          aborted: !1,
                          addEventListener: function (n, a) {
                            e.push(a);
                          },
                        });
                      this.abort = function () {
                        ((t.aborted = !0),
                          e.forEach(function (n) {
                            return n();
                          }));
                      };
                    },
              fw = yt.unstable_scheduleCallback,
              mw = yt.unstable_NormalPriority,
              xt = {
                $$typeof: ra,
                Consumer: null,
                Provider: null,
                _currentValue: null,
                _currentValue2: null,
                _threadCount: 0,
                _currentRenderer: null,
                _currentRenderer2: null,
              },
              rs = yt.unstable_now,
              xv = -0,
              Bc = -0,
              ln = -1.1,
              il = -0,
              Lc = !1,
              zc = !1,
              Oo = null,
              bm = 0,
              ll = 0,
              cs = null,
              Nv = z.S;
            z.S = function (e, t) {
              (typeof t == 'object' &&
                t !== null &&
                typeof t.then == 'function' &&
                IS(e, t),
                Nv !== null && Nv(e, t));
            };
            var sl = ee(null),
              Zn = {
                recordUnsafeLifecycleWarnings: function () {},
                flushPendingUnsafeLifecycleWarnings: function () {},
                recordLegacyContextWarning: function () {},
                flushLegacyContextWarning: function () {},
                discardPendingWarnings: function () {},
              },
              ko = [],
              _o = [],
              jo = [],
              Vo = [],
              Bo = [],
              Lo = [],
              ol = new Set();
            ((Zn.recordUnsafeLifecycleWarnings = function (e, t) {
              ol.has(e.type) ||
                (typeof t.componentWillMount == 'function' &&
                  t.componentWillMount.__suppressDeprecationWarning !== !0 &&
                  ko.push(e),
                e.mode & It &&
                  typeof t.UNSAFE_componentWillMount == 'function' &&
                  _o.push(e),
                typeof t.componentWillReceiveProps == 'function' &&
                  t.componentWillReceiveProps.__suppressDeprecationWarning !==
                    !0 &&
                  jo.push(e),
                e.mode & It &&
                  typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
                  Vo.push(e),
                typeof t.componentWillUpdate == 'function' &&
                  t.componentWillUpdate.__suppressDeprecationWarning !== !0 &&
                  Bo.push(e),
                e.mode & It &&
                  typeof t.UNSAFE_componentWillUpdate == 'function' &&
                  Lo.push(e));
            }),
              (Zn.flushPendingUnsafeLifecycleWarnings = function () {
                var e = new Set();
                0 < ko.length &&
                  (ko.forEach(function (b) {
                    (e.add(J(b) || 'Component'), ol.add(b.type));
                  }),
                  (ko = []));
                var t = new Set();
                0 < _o.length &&
                  (_o.forEach(function (b) {
                    (t.add(J(b) || 'Component'), ol.add(b.type));
                  }),
                  (_o = []));
                var n = new Set();
                0 < jo.length &&
                  (jo.forEach(function (b) {
                    (n.add(J(b) || 'Component'), ol.add(b.type));
                  }),
                  (jo = []));
                var a = new Set();
                0 < Vo.length &&
                  (Vo.forEach(function (b) {
                    (a.add(J(b) || 'Component'), ol.add(b.type));
                  }),
                  (Vo = []));
                var s = new Set();
                0 < Bo.length &&
                  (Bo.forEach(function (b) {
                    (s.add(J(b) || 'Component'), ol.add(b.type));
                  }),
                  (Bo = []));
                var c = new Set();
                if (
                  (0 < Lo.length &&
                    (Lo.forEach(function (b) {
                      (c.add(J(b) || 'Component'), ol.add(b.type));
                    }),
                    (Lo = [])),
                  0 < t.size)
                ) {
                  var f = v(t);
                  console.error(
                    `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
                    f
                  );
                }
                (0 < a.size &&
                  ((f = v(a)),
                  console.error(
                    `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
                    f
                  )),
                  0 < c.size &&
                    ((f = v(c)),
                    console.error(
                      `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
                      f
                    )),
                  0 < e.size &&
                    ((f = v(e)),
                    console.warn(
                      `componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                      f
                    )),
                  0 < n.size &&
                    ((f = v(n)),
                    console.warn(
                      `componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                      f
                    )),
                  0 < s.size &&
                    ((f = v(s)),
                    console.warn(
                      `componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,
                      f
                    )));
              }));
            var Hc = new Map(),
              wv = new Set();
            ((Zn.recordLegacyContextWarning = function (e, t) {
              for (var n = null, a = e; a !== null; )
                (a.mode & It && (n = a), (a = a.return));
              n === null
                ? console.error(
                    'Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.'
                  )
                : !wv.has(e.type) &&
                  ((a = Hc.get(n)),
                  e.type.contextTypes != null ||
                    e.type.childContextTypes != null ||
                    (t !== null && typeof t.getChildContext == 'function')) &&
                  (a === void 0 && ((a = []), Hc.set(n, a)), a.push(e));
            }),
              (Zn.flushLegacyContextWarning = function () {
                Hc.forEach(function (e) {
                  if (e.length !== 0) {
                    var t = e[0],
                      n = new Set();
                    e.forEach(function (s) {
                      (n.add(J(s) || 'Component'), wv.add(s.type));
                    });
                    var a = v(n);
                    he(t, function () {
                      console.error(
                        `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
                        a
                      );
                    });
                  }
                });
              }),
              (Zn.discardPendingWarnings = function () {
                ((ko = []),
                  (_o = []),
                  (jo = []),
                  (Vo = []),
                  (Bo = []),
                  (Lo = []),
                  (Hc = new Map()));
              }));
            var zo = Error(
                "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
              ),
              Ev = Error(
                "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
              ),
              Uc = Error(
                "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
              ),
              ym = {
                then: function () {
                  console.error(
                    'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
                  );
                },
              },
              Ho = null,
              Ic = !1,
              Ln = 0,
              zn = 1,
              Yt = 2,
              Bt = 4,
              Nt = 8,
              Dv = 0,
              Tv = 1,
              Cv = 2,
              vm = 3,
              bi = !1,
              Av = !1,
              Sm = null,
              xm = !1,
              us = ee(null),
              Wc = ee(0),
              ds,
              Rv = new Set(),
              Mv = new Set(),
              Nm = new Set(),
              Ov = new Set(),
              yi = 0,
              ye = null,
              Qe = null,
              vt = null,
              $c = !1,
              fs = !1,
              rl = !1,
              Pc = 0,
              Uo = 0,
              Ha = null,
              pw = 0,
              hw = 25,
              B = null,
              Hn = null,
              Ua = -1,
              Io = !1,
              Gc = {
                readContext: tt,
                use: ii,
                useCallback: ft,
                useContext: ft,
                useEffect: ft,
                useImperativeHandle: ft,
                useLayoutEffect: ft,
                useInsertionEffect: ft,
                useMemo: ft,
                useReducer: ft,
                useRef: ft,
                useState: ft,
                useDebugValue: ft,
                useDeferredValue: ft,
                useTransition: ft,
                useSyncExternalStore: ft,
                useId: ft,
                useHostTransitionStatus: ft,
                useFormState: ft,
                useActionState: ft,
                useOptimistic: ft,
                useMemoCache: ft,
                useCacheRefresh: ft,
              },
              wm = null,
              kv = null,
              Em = null,
              _v = null,
              ha = null,
              Fn = null,
              qc = null;
            ((wm = {
              readContext: function (e) {
                return tt(e);
              },
              use: ii,
              useCallback: function (e, t) {
                return ((B = 'useCallback'), ke(), Ol(t), Rd(e, t));
              },
              useContext: function (e) {
                return ((B = 'useContext'), ke(), tt(e));
              },
              useEffect: function (e, t) {
                return ((B = 'useEffect'), ke(), Ol(t), Gr(e, t));
              },
              useImperativeHandle: function (e, t, n) {
                return ((B = 'useImperativeHandle'), ke(), Ol(n), Ad(e, t, n));
              },
              useInsertionEffect: function (e, t) {
                ((B = 'useInsertionEffect'), ke(), Ol(t), Zi(4, Yt, e, t));
              },
              useLayoutEffect: function (e, t) {
                return ((B = 'useLayoutEffect'), ke(), Ol(t), Cd(e, t));
              },
              useMemo: function (e, t) {
                ((B = 'useMemo'), ke(), Ol(t));
                var n = z.H;
                z.H = ha;
                try {
                  return Md(e, t);
                } finally {
                  z.H = n;
                }
              },
              useReducer: function (e, t, n) {
                ((B = 'useReducer'), ke());
                var a = z.H;
                z.H = ha;
                try {
                  return vd(e, t, n);
                } finally {
                  z.H = a;
                }
              },
              useRef: function (e) {
                return ((B = 'useRef'), ke(), Td(e));
              },
              useState: function (e) {
                ((B = 'useState'), ke());
                var t = z.H;
                z.H = ha;
                try {
                  return wd(e);
                } finally {
                  z.H = t;
                }
              },
              useDebugValue: function () {
                ((B = 'useDebugValue'), ke());
              },
              useDeferredValue: function (e, t) {
                return ((B = 'useDeferredValue'), ke(), Od(e, t));
              },
              useTransition: function () {
                return ((B = 'useTransition'), ke(), jd());
              },
              useSyncExternalStore: function (e, t, n) {
                return ((B = 'useSyncExternalStore'), ke(), xd(e, t, n));
              },
              useId: function () {
                return ((B = 'useId'), ke(), Vd());
              },
              useFormState: function (e, t) {
                return ((B = 'useFormState'), ke(), Ur(), _l(e, t));
              },
              useActionState: function (e, t) {
                return ((B = 'useActionState'), ke(), _l(e, t));
              },
              useOptimistic: function (e) {
                return ((B = 'useOptimistic'), ke(), Ed(e));
              },
              useHostTransitionStatus: Fi,
              useMemoCache: Qi,
              useCacheRefresh: function () {
                return ((B = 'useCacheRefresh'), ke(), Bd());
              },
            }),
              (kv = {
                readContext: function (e) {
                  return tt(e);
                },
                use: ii,
                useCallback: function (e, t) {
                  return ((B = 'useCallback'), te(), Rd(e, t));
                },
                useContext: function (e) {
                  return ((B = 'useContext'), te(), tt(e));
                },
                useEffect: function (e, t) {
                  return ((B = 'useEffect'), te(), Gr(e, t));
                },
                useImperativeHandle: function (e, t, n) {
                  return ((B = 'useImperativeHandle'), te(), Ad(e, t, n));
                },
                useInsertionEffect: function (e, t) {
                  ((B = 'useInsertionEffect'), te(), Zi(4, Yt, e, t));
                },
                useLayoutEffect: function (e, t) {
                  return ((B = 'useLayoutEffect'), te(), Cd(e, t));
                },
                useMemo: function (e, t) {
                  ((B = 'useMemo'), te());
                  var n = z.H;
                  z.H = ha;
                  try {
                    return Md(e, t);
                  } finally {
                    z.H = n;
                  }
                },
                useReducer: function (e, t, n) {
                  ((B = 'useReducer'), te());
                  var a = z.H;
                  z.H = ha;
                  try {
                    return vd(e, t, n);
                  } finally {
                    z.H = a;
                  }
                },
                useRef: function (e) {
                  return ((B = 'useRef'), te(), Td(e));
                },
                useState: function (e) {
                  ((B = 'useState'), te());
                  var t = z.H;
                  z.H = ha;
                  try {
                    return wd(e);
                  } finally {
                    z.H = t;
                  }
                },
                useDebugValue: function () {
                  ((B = 'useDebugValue'), te());
                },
                useDeferredValue: function (e, t) {
                  return ((B = 'useDeferredValue'), te(), Od(e, t));
                },
                useTransition: function () {
                  return ((B = 'useTransition'), te(), jd());
                },
                useSyncExternalStore: function (e, t, n) {
                  return ((B = 'useSyncExternalStore'), te(), xd(e, t, n));
                },
                useId: function () {
                  return ((B = 'useId'), te(), Vd());
                },
                useActionState: function (e, t) {
                  return ((B = 'useActionState'), te(), _l(e, t));
                },
                useFormState: function (e, t) {
                  return ((B = 'useFormState'), te(), Ur(), _l(e, t));
                },
                useOptimistic: function (e) {
                  return ((B = 'useOptimistic'), te(), Ed(e));
                },
                useHostTransitionStatus: Fi,
                useMemoCache: Qi,
                useCacheRefresh: function () {
                  return ((B = 'useCacheRefresh'), te(), Bd());
                },
              }),
              (Em = {
                readContext: function (e) {
                  return tt(e);
                },
                use: ii,
                useCallback: function (e, t) {
                  return ((B = 'useCallback'), te(), Yr(e, t));
                },
                useContext: function (e) {
                  return ((B = 'useContext'), te(), tt(e));
                },
                useEffect: function (e, t) {
                  ((B = 'useEffect'), te(), nn(2048, Nt, e, t));
                },
                useImperativeHandle: function (e, t, n) {
                  return ((B = 'useImperativeHandle'), te(), qr(e, t, n));
                },
                useInsertionEffect: function (e, t) {
                  return ((B = 'useInsertionEffect'), te(), nn(4, Yt, e, t));
                },
                useLayoutEffect: function (e, t) {
                  return ((B = 'useLayoutEffect'), te(), nn(4, Bt, e, t));
                },
                useMemo: function (e, t) {
                  ((B = 'useMemo'), te());
                  var n = z.H;
                  z.H = Fn;
                  try {
                    return Xr(e, t);
                  } finally {
                    z.H = n;
                  }
                },
                useReducer: function (e, t, n) {
                  ((B = 'useReducer'), te());
                  var a = z.H;
                  z.H = Fn;
                  try {
                    return kl(e);
                  } finally {
                    z.H = a;
                  }
                },
                useRef: function () {
                  return ((B = 'useRef'), te(), qe().memoizedState);
                },
                useState: function () {
                  ((B = 'useState'), te());
                  var e = z.H;
                  z.H = Fn;
                  try {
                    return kl(Yn);
                  } finally {
                    z.H = e;
                  }
                },
                useDebugValue: function () {
                  ((B = 'useDebugValue'), te());
                },
                useDeferredValue: function (e, t) {
                  return ((B = 'useDeferredValue'), te(), dg(e, t));
                },
                useTransition: function () {
                  return ((B = 'useTransition'), te(), bg());
                },
                useSyncExternalStore: function (e, t, n) {
                  return ((B = 'useSyncExternalStore'), te(), Ir(e, t, n));
                },
                useId: function () {
                  return ((B = 'useId'), te(), qe().memoizedState);
                },
                useFormState: function (e) {
                  return ((B = 'useFormState'), te(), Ur(), Wr(e));
                },
                useActionState: function (e) {
                  return ((B = 'useActionState'), te(), Wr(e));
                },
                useOptimistic: function (e, t) {
                  return ((B = 'useOptimistic'), te(), tg(e, t));
                },
                useHostTransitionStatus: Fi,
                useMemoCache: Qi,
                useCacheRefresh: function () {
                  return ((B = 'useCacheRefresh'), te(), qe().memoizedState);
                },
              }),
              (_v = {
                readContext: function (e) {
                  return tt(e);
                },
                use: ii,
                useCallback: function (e, t) {
                  return ((B = 'useCallback'), te(), Yr(e, t));
                },
                useContext: function (e) {
                  return ((B = 'useContext'), te(), tt(e));
                },
                useEffect: function (e, t) {
                  ((B = 'useEffect'), te(), nn(2048, Nt, e, t));
                },
                useImperativeHandle: function (e, t, n) {
                  return ((B = 'useImperativeHandle'), te(), qr(e, t, n));
                },
                useInsertionEffect: function (e, t) {
                  return ((B = 'useInsertionEffect'), te(), nn(4, Yt, e, t));
                },
                useLayoutEffect: function (e, t) {
                  return ((B = 'useLayoutEffect'), te(), nn(4, Bt, e, t));
                },
                useMemo: function (e, t) {
                  ((B = 'useMemo'), te());
                  var n = z.H;
                  z.H = qc;
                  try {
                    return Xr(e, t);
                  } finally {
                    z.H = n;
                  }
                },
                useReducer: function (e, t, n) {
                  ((B = 'useReducer'), te());
                  var a = z.H;
                  z.H = qc;
                  try {
                    return to(e);
                  } finally {
                    z.H = a;
                  }
                },
                useRef: function () {
                  return ((B = 'useRef'), te(), qe().memoizedState);
                },
                useState: function () {
                  ((B = 'useState'), te());
                  var e = z.H;
                  z.H = qc;
                  try {
                    return to(Yn);
                  } finally {
                    z.H = e;
                  }
                },
                useDebugValue: function () {
                  ((B = 'useDebugValue'), te());
                },
                useDeferredValue: function (e, t) {
                  return ((B = 'useDeferredValue'), te(), fg(e, t));
                },
                useTransition: function () {
                  return ((B = 'useTransition'), te(), yg());
                },
                useSyncExternalStore: function (e, t, n) {
                  return ((B = 'useSyncExternalStore'), te(), Ir(e, t, n));
                },
                useId: function () {
                  return ((B = 'useId'), te(), qe().memoizedState);
                },
                useFormState: function (e) {
                  return ((B = 'useFormState'), te(), Ur(), $r(e));
                },
                useActionState: function (e) {
                  return ((B = 'useActionState'), te(), $r(e));
                },
                useOptimistic: function (e, t) {
                  return ((B = 'useOptimistic'), te(), ag(e, t));
                },
                useHostTransitionStatus: Fi,
                useMemoCache: Qi,
                useCacheRefresh: function () {
                  return ((B = 'useCacheRefresh'), te(), qe().memoizedState);
                },
              }),
              (ha = {
                readContext: function (e) {
                  return (y(), tt(e));
                },
                use: function (e) {
                  return (m(), ii(e));
                },
                useCallback: function (e, t) {
                  return ((B = 'useCallback'), m(), ke(), Rd(e, t));
                },
                useContext: function (e) {
                  return ((B = 'useContext'), m(), ke(), tt(e));
                },
                useEffect: function (e, t) {
                  return ((B = 'useEffect'), m(), ke(), Gr(e, t));
                },
                useImperativeHandle: function (e, t, n) {
                  return ((B = 'useImperativeHandle'), m(), ke(), Ad(e, t, n));
                },
                useInsertionEffect: function (e, t) {
                  ((B = 'useInsertionEffect'), m(), ke(), Zi(4, Yt, e, t));
                },
                useLayoutEffect: function (e, t) {
                  return ((B = 'useLayoutEffect'), m(), ke(), Cd(e, t));
                },
                useMemo: function (e, t) {
                  ((B = 'useMemo'), m(), ke());
                  var n = z.H;
                  z.H = ha;
                  try {
                    return Md(e, t);
                  } finally {
                    z.H = n;
                  }
                },
                useReducer: function (e, t, n) {
                  ((B = 'useReducer'), m(), ke());
                  var a = z.H;
                  z.H = ha;
                  try {
                    return vd(e, t, n);
                  } finally {
                    z.H = a;
                  }
                },
                useRef: function (e) {
                  return ((B = 'useRef'), m(), ke(), Td(e));
                },
                useState: function (e) {
                  ((B = 'useState'), m(), ke());
                  var t = z.H;
                  z.H = ha;
                  try {
                    return wd(e);
                  } finally {
                    z.H = t;
                  }
                },
                useDebugValue: function () {
                  ((B = 'useDebugValue'), m(), ke());
                },
                useDeferredValue: function (e, t) {
                  return ((B = 'useDeferredValue'), m(), ke(), Od(e, t));
                },
                useTransition: function () {
                  return ((B = 'useTransition'), m(), ke(), jd());
                },
                useSyncExternalStore: function (e, t, n) {
                  return ((B = 'useSyncExternalStore'), m(), ke(), xd(e, t, n));
                },
                useId: function () {
                  return ((B = 'useId'), m(), ke(), Vd());
                },
                useFormState: function (e, t) {
                  return ((B = 'useFormState'), m(), ke(), _l(e, t));
                },
                useActionState: function (e, t) {
                  return ((B = 'useActionState'), m(), ke(), _l(e, t));
                },
                useOptimistic: function (e) {
                  return ((B = 'useOptimistic'), m(), ke(), Ed(e));
                },
                useMemoCache: function (e) {
                  return (m(), Qi(e));
                },
                useHostTransitionStatus: Fi,
                useCacheRefresh: function () {
                  return ((B = 'useCacheRefresh'), ke(), Bd());
                },
              }),
              (Fn = {
                readContext: function (e) {
                  return (y(), tt(e));
                },
                use: function (e) {
                  return (m(), ii(e));
                },
                useCallback: function (e, t) {
                  return ((B = 'useCallback'), m(), te(), Yr(e, t));
                },
                useContext: function (e) {
                  return ((B = 'useContext'), m(), te(), tt(e));
                },
                useEffect: function (e, t) {
                  ((B = 'useEffect'), m(), te(), nn(2048, Nt, e, t));
                },
                useImperativeHandle: function (e, t, n) {
                  return ((B = 'useImperativeHandle'), m(), te(), qr(e, t, n));
                },
                useInsertionEffect: function (e, t) {
                  return (
                    (B = 'useInsertionEffect'),
                    m(),
                    te(),
                    nn(4, Yt, e, t)
                  );
                },
                useLayoutEffect: function (e, t) {
                  return ((B = 'useLayoutEffect'), m(), te(), nn(4, Bt, e, t));
                },
                useMemo: function (e, t) {
                  ((B = 'useMemo'), m(), te());
                  var n = z.H;
                  z.H = Fn;
                  try {
                    return Xr(e, t);
                  } finally {
                    z.H = n;
                  }
                },
                useReducer: function (e, t, n) {
                  ((B = 'useReducer'), m(), te());
                  var a = z.H;
                  z.H = Fn;
                  try {
                    return kl(e);
                  } finally {
                    z.H = a;
                  }
                },
                useRef: function () {
                  return ((B = 'useRef'), m(), te(), qe().memoizedState);
                },
                useState: function () {
                  ((B = 'useState'), m(), te());
                  var e = z.H;
                  z.H = Fn;
                  try {
                    return kl(Yn);
                  } finally {
                    z.H = e;
                  }
                },
                useDebugValue: function () {
                  ((B = 'useDebugValue'), m(), te());
                },
                useDeferredValue: function (e, t) {
                  return ((B = 'useDeferredValue'), m(), te(), dg(e, t));
                },
                useTransition: function () {
                  return ((B = 'useTransition'), m(), te(), bg());
                },
                useSyncExternalStore: function (e, t, n) {
                  return ((B = 'useSyncExternalStore'), m(), te(), Ir(e, t, n));
                },
                useId: function () {
                  return ((B = 'useId'), m(), te(), qe().memoizedState);
                },
                useFormState: function (e) {
                  return ((B = 'useFormState'), m(), te(), Wr(e));
                },
                useActionState: function (e) {
                  return ((B = 'useActionState'), m(), te(), Wr(e));
                },
                useOptimistic: function (e, t) {
                  return ((B = 'useOptimistic'), m(), te(), tg(e, t));
                },
                useMemoCache: function (e) {
                  return (m(), Qi(e));
                },
                useHostTransitionStatus: Fi,
                useCacheRefresh: function () {
                  return ((B = 'useCacheRefresh'), te(), qe().memoizedState);
                },
              }),
              (qc = {
                readContext: function (e) {
                  return (y(), tt(e));
                },
                use: function (e) {
                  return (m(), ii(e));
                },
                useCallback: function (e, t) {
                  return ((B = 'useCallback'), m(), te(), Yr(e, t));
                },
                useContext: function (e) {
                  return ((B = 'useContext'), m(), te(), tt(e));
                },
                useEffect: function (e, t) {
                  ((B = 'useEffect'), m(), te(), nn(2048, Nt, e, t));
                },
                useImperativeHandle: function (e, t, n) {
                  return ((B = 'useImperativeHandle'), m(), te(), qr(e, t, n));
                },
                useInsertionEffect: function (e, t) {
                  return (
                    (B = 'useInsertionEffect'),
                    m(),
                    te(),
                    nn(4, Yt, e, t)
                  );
                },
                useLayoutEffect: function (e, t) {
                  return ((B = 'useLayoutEffect'), m(), te(), nn(4, Bt, e, t));
                },
                useMemo: function (e, t) {
                  ((B = 'useMemo'), m(), te());
                  var n = z.H;
                  z.H = Fn;
                  try {
                    return Xr(e, t);
                  } finally {
                    z.H = n;
                  }
                },
                useReducer: function (e, t, n) {
                  ((B = 'useReducer'), m(), te());
                  var a = z.H;
                  z.H = Fn;
                  try {
                    return to(e);
                  } finally {
                    z.H = a;
                  }
                },
                useRef: function () {
                  return ((B = 'useRef'), m(), te(), qe().memoizedState);
                },
                useState: function () {
                  ((B = 'useState'), m(), te());
                  var e = z.H;
                  z.H = Fn;
                  try {
                    return to(Yn);
                  } finally {
                    z.H = e;
                  }
                },
                useDebugValue: function () {
                  ((B = 'useDebugValue'), m(), te());
                },
                useDeferredValue: function (e, t) {
                  return ((B = 'useDeferredValue'), m(), te(), fg(e, t));
                },
                useTransition: function () {
                  return ((B = 'useTransition'), m(), te(), yg());
                },
                useSyncExternalStore: function (e, t, n) {
                  return ((B = 'useSyncExternalStore'), m(), te(), Ir(e, t, n));
                },
                useId: function () {
                  return ((B = 'useId'), m(), te(), qe().memoizedState);
                },
                useFormState: function (e) {
                  return ((B = 'useFormState'), m(), te(), $r(e));
                },
                useActionState: function (e) {
                  return ((B = 'useActionState'), m(), te(), $r(e));
                },
                useOptimistic: function (e, t) {
                  return ((B = 'useOptimistic'), m(), te(), ag(e, t));
                },
                useMemoCache: function (e) {
                  return (m(), Qi(e));
                },
                useHostTransitionStatus: Fi,
                useCacheRefresh: function () {
                  return ((B = 'useCacheRefresh'), te(), qe().memoizedState);
                },
              }));
            var jv = {
                react_stack_bottom_frame: function (e, t, n) {
                  var a = fa;
                  fa = !0;
                  try {
                    return e(t, n);
                  } finally {
                    fa = a;
                  }
                },
              },
              Dm = jv.react_stack_bottom_frame.bind(jv),
              Vv = {
                react_stack_bottom_frame: function (e) {
                  var t = fa;
                  fa = !0;
                  try {
                    return e.render();
                  } finally {
                    fa = t;
                  }
                },
              },
              Bv = Vv.react_stack_bottom_frame.bind(Vv),
              Lv = {
                react_stack_bottom_frame: function (e, t) {
                  try {
                    t.componentDidMount();
                  } catch (n) {
                    Ye(e, e.return, n);
                  }
                },
              },
              Tm = Lv.react_stack_bottom_frame.bind(Lv),
              zv = {
                react_stack_bottom_frame: function (e, t, n, a, s) {
                  try {
                    t.componentDidUpdate(n, a, s);
                  } catch (c) {
                    Ye(e, e.return, c);
                  }
                },
              },
              Hv = zv.react_stack_bottom_frame.bind(zv),
              Uv = {
                react_stack_bottom_frame: function (e, t) {
                  var n = t.stack;
                  e.componentDidCatch(t.value, {
                    componentStack: n !== null ? n : '',
                  });
                },
              },
              gw = Uv.react_stack_bottom_frame.bind(Uv),
              Iv = {
                react_stack_bottom_frame: function (e, t, n) {
                  try {
                    n.componentWillUnmount();
                  } catch (a) {
                    Ye(e, t, a);
                  }
                },
              },
              Wv = Iv.react_stack_bottom_frame.bind(Iv),
              $v = {
                react_stack_bottom_frame: function (e) {
                  e.resourceKind != null &&
                    console.error(
                      'Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s',
                      e.resourceKind
                    );
                  var t = e.create;
                  return ((e = e.inst), (t = t()), (e.destroy = t));
                },
              },
              bw = $v.react_stack_bottom_frame.bind($v),
              Pv = {
                react_stack_bottom_frame: function (e, t, n) {
                  try {
                    n();
                  } catch (a) {
                    Ye(e, t, a);
                  }
                },
              },
              yw = Pv.react_stack_bottom_frame.bind(Pv),
              Gv = {
                react_stack_bottom_frame: function (e) {
                  var t = e._init;
                  return t(e._payload);
                },
              },
              vi = Gv.react_stack_bottom_frame.bind(Gv),
              ms = null,
              Wo = 0,
              Ce = null,
              Cm,
              qv = (Cm = !1),
              Yv = {},
              Xv = {},
              Qv = {};
            h = function (e, t, n) {
              if (
                n !== null &&
                typeof n == 'object' &&
                n._store &&
                ((!n._store.validated && n.key == null) ||
                  n._store.validated === 2)
              ) {
                if (typeof n._store != 'object')
                  throw Error(
                    'React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.'
                  );
                n._store.validated = 1;
                var a = J(e),
                  s = a || 'null';
                if (!Yv[s]) {
                  ((Yv[s] = !0), (n = n._owner), (e = e._debugOwner));
                  var c = '';
                  (e &&
                    typeof e.tag == 'number' &&
                    (s = J(e)) &&
                    (c =
                      `

Check the render method of \`` +
                      s +
                      '`.'),
                    c ||
                      (a &&
                        (c =
                          `

Check the top-level render call using <` +
                          a +
                          '>.')));
                  var f = '';
                  (n != null &&
                    e !== n &&
                    ((a = null),
                    typeof n.tag == 'number'
                      ? (a = J(n))
                      : typeof n.name == 'string' && (a = n.name),
                    a && (f = ' It was passed a child from ' + a + '.')),
                    he(t, function () {
                      console.error(
                        'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
                        c,
                        f
                      );
                    }));
                }
              }
            };
            var ps = Ng(!0),
              Zv = Ng(!1),
              Un = ee(null),
              ga = null,
              hs = 1,
              $o = 2,
              wt = ee(0),
              Fv = {},
              Kv = new Set(),
              Jv = new Set(),
              e1 = new Set(),
              t1 = new Set(),
              n1 = new Set(),
              a1 = new Set(),
              i1 = new Set(),
              l1 = new Set(),
              s1 = new Set(),
              o1 = new Set();
            Object.freeze(Fv);
            var Am = {
                enqueueSetState: function (e, t, n) {
                  e = e._reactInternals;
                  var a = hn(e),
                    s = ni(a);
                  ((s.payload = t),
                    n != null && (zd(n), (s.callback = n)),
                    (t = ai(e, s, a)),
                    t !== null && (mt(t, e, a), Fs(t, e, a)),
                    Za(e, a));
                },
                enqueueReplaceState: function (e, t, n) {
                  e = e._reactInternals;
                  var a = hn(e),
                    s = ni(a);
                  ((s.tag = Tv),
                    (s.payload = t),
                    n != null && (zd(n), (s.callback = n)),
                    (t = ai(e, s, a)),
                    t !== null && (mt(t, e, a), Fs(t, e, a)),
                    Za(e, a));
                },
                enqueueForceUpdate: function (e, t) {
                  e = e._reactInternals;
                  var n = hn(e),
                    a = ni(n);
                  ((a.tag = Cv),
                    t != null && (zd(t), (a.callback = t)),
                    (t = ai(e, a, n)),
                    t !== null && (mt(t, e, n), Fs(t, e, n)),
                    oe !== null &&
                      typeof oe.markForceUpdateScheduled == 'function' &&
                      oe.markForceUpdateScheduled(e, n));
                },
              },
              Rm =
                typeof reportError == 'function'
                  ? reportError
                  : function (e) {
                      if (
                        typeof window == 'object' &&
                        typeof window.ErrorEvent == 'function'
                      ) {
                        var t = new window.ErrorEvent('error', {
                          bubbles: !0,
                          cancelable: !0,
                          message:
                            typeof e == 'object' &&
                            e !== null &&
                            typeof e.message == 'string'
                              ? String(e.message)
                              : String(e),
                          error: e,
                        });
                        if (!window.dispatchEvent(t)) return;
                      } else if (
                        typeof process == 'object' &&
                        typeof process.emit == 'function'
                      ) {
                        process.emit('uncaughtException', e);
                        return;
                      }
                      console.error(e);
                    },
              gs = null,
              Mm = null,
              r1 = Error(
                "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
              ),
              Ct = !1,
              c1 = {},
              u1 = {},
              d1 = {},
              f1 = {},
              bs = !1,
              m1 = {},
              Om = {},
              km = {
                dehydrated: null,
                treeContext: null,
                retryLane: 0,
                hydrationErrors: null,
              },
              p1 = !1,
              h1 = null;
            h1 = new Set();
            var Ia = !1,
              pt = !1,
              _m = !1,
              g1 = typeof WeakSet == 'function' ? WeakSet : Set,
              At = null,
              ys = null,
              vs = null,
              St = null,
              sn = !1,
              Kn = null,
              Po = 8192,
              vw = {
                getCacheForType: function (e) {
                  var t = tt(xt),
                    n = t.data.get(e);
                  return (n === void 0 && ((n = e()), t.data.set(e, n)), n);
                },
                getOwner: function () {
                  return bn;
                },
              };
            if (typeof Symbol == 'function' && Symbol.for) {
              var Go = Symbol.for;
              (Go('selector.component'),
                Go('selector.has_pseudo_class'),
                Go('selector.role'),
                Go('selector.test_id'),
                Go('selector.text'));
            }
            var Sw = [],
              xw = typeof WeakMap == 'function' ? WeakMap : Map,
              yn = 0,
              Xt = 2,
              Jn = 4,
              Wa = 0,
              qo = 1,
              Ss = 2,
              jm = 3,
              cl = 4,
              Yc = 6,
              b1 = 5,
              Pe = yn,
              Ze = null,
              Oe = null,
              _e = 0,
              on = 0,
              Yo = 1,
              ul = 2,
              Xo = 3,
              y1 = 4,
              Vm = 5,
              xs = 6,
              Qo = 7,
              Bm = 8,
              dl = 9,
              Ge = on,
              vn = null,
              Si = !1,
              Ns = !1,
              Lm = !1,
              ba = 0,
              ct = Wa,
              xi = 0,
              Ni = 0,
              zm = 0,
              Sn = 0,
              fl = 0,
              Zo = null,
              Qt = null,
              Xc = !1,
              Hm = 0,
              v1 = 300,
              Qc = 1 / 0,
              S1 = 500,
              Fo = null,
              wi = null,
              Nw = 0,
              ww = 1,
              Ew = 2,
              ml = 0,
              x1 = 1,
              N1 = 2,
              w1 = 3,
              Dw = 4,
              Um = 5,
              Lt = 0,
              Ei = null,
              ws = null,
              Di = 0,
              Im = 0,
              Wm = null,
              E1 = null,
              Tw = 50,
              Ko = 0,
              $m = null,
              Pm = !1,
              Zc = !1,
              Cw = 50,
              pl = 0,
              Jo = null,
              Es = !1,
              Fc = null,
              D1 = !1,
              T1 = new Set(),
              Aw = {},
              Kc = null,
              Ds = null,
              Gm = !1,
              qm = !1,
              Jc = !1,
              Ym = !1,
              hl = 0,
              Xm = {};
            ((function () {
              for (var e = 0; e < dm.length; e++) {
                var t = dm[e],
                  n = t.toLowerCase();
                ((t = t[0].toUpperCase() + t.slice(1)), qn(n, 'on' + t));
              }
              (qn(dv, 'onAnimationEnd'),
                qn(fv, 'onAnimationIteration'),
                qn(mv, 'onAnimationStart'),
                qn('dblclick', 'onDoubleClick'),
                qn('focusin', 'onFocus'),
                qn('focusout', 'onBlur'),
                qn(lw, 'onTransitionRun'),
                qn(sw, 'onTransitionStart'),
                qn(ow, 'onTransitionCancel'),
                qn(pv, 'onTransitionEnd'));
            })(),
              ie('onMouseEnter', ['mouseout', 'mouseover']),
              ie('onMouseLeave', ['mouseout', 'mouseover']),
              ie('onPointerEnter', ['pointerout', 'pointerover']),
              ie('onPointerLeave', ['pointerout', 'pointerover']),
              ne(
                'onChange',
                'change click focusin focusout input keydown keyup selectionchange'.split(
                  ' '
                )
              ),
              ne(
                'onSelect',
                'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(
                  ' '
                )
              ),
              ne('onBeforeInput', [
                'compositionend',
                'keypress',
                'textInput',
                'paste',
              ]),
              ne(
                'onCompositionEnd',
                'compositionend focusout keydown keypress keyup mousedown'.split(
                  ' '
                )
              ),
              ne(
                'onCompositionStart',
                'compositionstart focusout keydown keypress keyup mousedown'.split(
                  ' '
                )
              ),
              ne(
                'onCompositionUpdate',
                'compositionupdate focusout keydown keypress keyup mousedown'.split(
                  ' '
                )
              ));
            var er =
                'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
                  ' '
                ),
              Qm = new Set(
                'beforetoggle cancel close invalid load scroll scrollend toggle'
                  .split(' ')
                  .concat(er)
              ),
              eu = '_reactListening' + Math.random().toString(36).slice(2),
              C1 = !1,
              A1 = !1,
              tu = !1,
              R1 = !1,
              nu = !1,
              au = !1,
              M1 = !1,
              iu = {},
              Rw = /\r\n?/g,
              Mw = /\u0000|\uFFFD/g,
              gl = 'http://www.w3.org/1999/xlink',
              Zm = 'http://www.w3.org/XML/1998/namespace',
              Ow =
                "javascript:throw new Error('React form unexpectedly submitted.')",
              kw = 'suppressHydrationWarning',
              lu = '$',
              su = '/$',
              $a = '$?',
              tr = '$!',
              _w = 1,
              jw = 2,
              Vw = 4,
              Fm = 'F!',
              O1 = 'F',
              k1 = 'complete',
              Bw = 'style',
              Pa = 0,
              Ts = 1,
              ou = 2,
              Km = null,
              Jm = null,
              _1 = { dialog: !0, webview: !0 },
              ep = null,
              j1 = typeof setTimeout == 'function' ? setTimeout : void 0,
              Lw = typeof clearTimeout == 'function' ? clearTimeout : void 0,
              bl = -1,
              V1 = typeof Promise == 'function' ? Promise : void 0,
              zw =
                typeof queueMicrotask == 'function'
                  ? queueMicrotask
                  : typeof V1 < 'u'
                    ? function (e) {
                        return V1.resolve(null).then(e).catch(wx);
                      }
                    : j1,
              tp = null,
              yl = 0,
              nr = 1,
              B1 = 2,
              L1 = 3,
              In = 4,
              Wn = new Map(),
              z1 = new Set(),
              Ga = $e.d;
            $e.d = {
              f: function () {
                var e = Ga.f(),
                  t = zl();
                return e || t;
              },
              r: function (e) {
                var t = Gn(e);
                t !== null && t.tag === 5 && t.type === 'form'
                  ? gg(t)
                  : Ga.r(e);
              },
              D: function (e) {
                (Ga.D(e), ly('dns-prefetch', e, null));
              },
              C: function (e, t) {
                (Ga.C(e, t), ly('preconnect', e, t));
              },
              L: function (e, t, n) {
                Ga.L(e, t, n);
                var a = Cs;
                if (a && e && t) {
                  var s = 'link[rel="preload"][as="' + An(t) + '"]';
                  t === 'image' && n && n.imageSrcSet
                    ? ((s += '[imagesrcset="' + An(n.imageSrcSet) + '"]'),
                      typeof n.imageSizes == 'string' &&
                        (s += '[imagesizes="' + An(n.imageSizes) + '"]'))
                    : (s += '[href="' + An(e) + '"]');
                  var c = s;
                  switch (t) {
                    case 'style':
                      c = Wl(e);
                      break;
                    case 'script':
                      c = $l(e);
                  }
                  Wn.has(c) ||
                    ((e = Re(
                      {
                        rel: 'preload',
                        href: t === 'image' && n && n.imageSrcSet ? void 0 : e,
                        as: t,
                      },
                      n
                    )),
                    Wn.set(c, e),
                    a.querySelector(s) !== null ||
                      (t === 'style' && a.querySelector(ho(c))) ||
                      (t === 'script' && a.querySelector(go(c))) ||
                      ((t = a.createElement('link')),
                      _t(t, 'link', e),
                      O(t),
                      a.head.appendChild(t)));
                }
              },
              m: function (e, t) {
                Ga.m(e, t);
                var n = Cs;
                if (n && e) {
                  var a = t && typeof t.as == 'string' ? t.as : 'script',
                    s =
                      'link[rel="modulepreload"][as="' +
                      An(a) +
                      '"][href="' +
                      An(e) +
                      '"]',
                    c = s;
                  switch (a) {
                    case 'audioworklet':
                    case 'paintworklet':
                    case 'serviceworker':
                    case 'sharedworker':
                    case 'worker':
                    case 'script':
                      c = $l(e);
                  }
                  if (
                    !Wn.has(c) &&
                    ((e = Re({ rel: 'modulepreload', href: e }, t)),
                    Wn.set(c, e),
                    n.querySelector(s) === null)
                  ) {
                    switch (a) {
                      case 'audioworklet':
                      case 'paintworklet':
                      case 'serviceworker':
                      case 'sharedworker':
                      case 'worker':
                      case 'script':
                        if (n.querySelector(go(c))) return;
                    }
                    ((a = n.createElement('link')),
                      _t(a, 'link', e),
                      O(a),
                      n.head.appendChild(a));
                  }
                }
              },
              X: function (e, t) {
                Ga.X(e, t);
                var n = Cs;
                if (n && e) {
                  var a = N(n).hoistableScripts,
                    s = $l(e),
                    c = a.get(s);
                  c ||
                    ((c = n.querySelector(go(s))),
                    c ||
                      ((e = Re({ src: e, async: !0 }, t)),
                      (t = Wn.get(s)) && Af(e, t),
                      (c = n.createElement('script')),
                      O(c),
                      _t(c, 'link', e),
                      n.head.appendChild(c)),
                    (c = {
                      type: 'script',
                      instance: c,
                      count: 1,
                      state: null,
                    }),
                    a.set(s, c));
                }
              },
              S: function (e, t, n) {
                Ga.S(e, t, n);
                var a = Cs;
                if (a && e) {
                  var s = N(a).hoistableStyles,
                    c = Wl(e);
                  t = t || 'default';
                  var f = s.get(c);
                  if (!f) {
                    var b = { loading: yl, preload: null };
                    if ((f = a.querySelector(ho(c)))) b.loading = nr | In;
                    else {
                      ((e = Re(
                        { rel: 'stylesheet', href: e, 'data-precedence': t },
                        n
                      )),
                        (n = Wn.get(c)) && Cf(e, n));
                      var w = (f = a.createElement('link'));
                      (O(w),
                        _t(w, 'link', e),
                        (w._p = new Promise(function (T, j) {
                          ((w.onload = T), (w.onerror = j));
                        })),
                        w.addEventListener('load', function () {
                          b.loading |= nr;
                        }),
                        w.addEventListener('error', function () {
                          b.loading |= B1;
                        }),
                        (b.loading |= In),
                        hc(f, t, a));
                    }
                    ((f = {
                      type: 'stylesheet',
                      instance: f,
                      count: 1,
                      state: b,
                    }),
                      s.set(c, f));
                  }
                }
              },
              M: function (e, t) {
                Ga.M(e, t);
                var n = Cs;
                if (n && e) {
                  var a = N(n).hoistableScripts,
                    s = $l(e),
                    c = a.get(s);
                  c ||
                    ((c = n.querySelector(go(s))),
                    c ||
                      ((e = Re({ src: e, async: !0, type: 'module' }, t)),
                      (t = Wn.get(s)) && Af(e, t),
                      (c = n.createElement('script')),
                      O(c),
                      _t(c, 'link', e),
                      n.head.appendChild(c)),
                    (c = {
                      type: 'script',
                      instance: c,
                      count: 1,
                      state: null,
                    }),
                    a.set(s, c));
                }
              },
            };
            var Cs = typeof document > 'u' ? null : document,
              ru = null,
              ar = null,
              np = null,
              cu = null,
              vl = aN,
              ir = {
                $$typeof: ra,
                Provider: null,
                Consumer: null,
                _currentValue: vl,
                _currentValue2: vl,
                _threadCount: 0,
              },
              H1 = '%c%s%c ',
              U1 =
                'background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px',
              I1 = '',
              uu = ' ',
              Hw = Function.prototype.bind,
              W1 = !1,
              $1 = null,
              P1 = null,
              G1 = null,
              q1 = null,
              Y1 = null,
              X1 = null,
              Q1 = null,
              Z1 = null,
              F1 = null;
            (($1 = function (e, t, n, a) {
              ((t = i(e, t)),
                t !== null &&
                  ((n = l(t.memoizedState, n, 0, a)),
                  (t.memoizedState = n),
                  (t.baseState = n),
                  (e.memoizedProps = Re({}, e.memoizedProps)),
                  (n = en(e, 2)),
                  n !== null && mt(n, e, 2)));
            }),
              (P1 = function (e, t, n) {
                ((t = i(e, t)),
                  t !== null &&
                    ((n = u(t.memoizedState, n, 0)),
                    (t.memoizedState = n),
                    (t.baseState = n),
                    (e.memoizedProps = Re({}, e.memoizedProps)),
                    (n = en(e, 2)),
                    n !== null && mt(n, e, 2)));
              }),
              (G1 = function (e, t, n, a) {
                ((t = i(e, t)),
                  t !== null &&
                    ((n = o(t.memoizedState, n, a)),
                    (t.memoizedState = n),
                    (t.baseState = n),
                    (e.memoizedProps = Re({}, e.memoizedProps)),
                    (n = en(e, 2)),
                    n !== null && mt(n, e, 2)));
              }),
              (q1 = function (e, t, n) {
                ((e.pendingProps = l(e.memoizedProps, t, 0, n)),
                  e.alternate && (e.alternate.pendingProps = e.pendingProps),
                  (t = en(e, 2)),
                  t !== null && mt(t, e, 2));
              }),
              (Y1 = function (e, t) {
                ((e.pendingProps = u(e.memoizedProps, t, 0)),
                  e.alternate && (e.alternate.pendingProps = e.pendingProps),
                  (t = en(e, 2)),
                  t !== null && mt(t, e, 2));
              }),
              (X1 = function (e, t, n) {
                ((e.pendingProps = o(e.memoizedProps, t, n)),
                  e.alternate && (e.alternate.pendingProps = e.pendingProps),
                  (t = en(e, 2)),
                  t !== null && mt(t, e, 2));
              }),
              (Q1 = function (e) {
                var t = en(e, 2);
                t !== null && mt(t, e, 2);
              }),
              (Z1 = function (e) {
                p = e;
              }),
              (F1 = function (e) {
                d = e;
              }));
            var du = !0,
              fu = null,
              ap = !1,
              Ti = null,
              Ci = null,
              Ai = null,
              lr = new Map(),
              sr = new Map(),
              Ri = [],
              Uw =
                'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset'.split(
                  ' '
                ),
              mu = null;
            if (
              ((vc.prototype.render = Vf.prototype.render =
                function (e) {
                  var t = this._internalRoot;
                  if (t === null)
                    throw Error('Cannot update an unmounted root.');
                  var n = arguments;
                  (typeof n[1] == 'function'
                    ? console.error(
                        'does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().'
                      )
                    : k(n[1])
                      ? console.error(
                          "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
                        )
                      : typeof n[1] < 'u' &&
                        console.error(
                          'You passed a second argument to root.render(...) but it only accepts one argument.'
                        ),
                    (n = e));
                  var a = t.current,
                    s = hn(a);
                  Mf(a, s, n, t, null, null);
                }),
              (vc.prototype.unmount = Vf.prototype.unmount =
                function () {
                  var e = arguments;
                  if (
                    (typeof e[0] == 'function' &&
                      console.error(
                        'does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().'
                      ),
                    (e = this._internalRoot),
                    e !== null)
                  ) {
                    this._internalRoot = null;
                    var t = e.containerInfo;
                    ((Pe & (Xt | Jn)) !== yn &&
                      console.error(
                        'Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.'
                      ),
                      Mf(e.current, 2, null, e, null, null),
                      zl(),
                      (t[pi] = null));
                  }
                }),
              (vc.prototype.unstable_scheduleHydration = function (e) {
                if (e) {
                  var t = Ls();
                  e = { blockedOn: null, target: e, priority: t };
                  for (
                    var n = 0;
                    n < Ri.length && t !== 0 && t < Ri[n].priority;
                    n++
                  );
                  (Ri.splice(n, 0, e), n === 0 && yy(e));
                }
              }),
              (function () {
                var e = Bf.version;
                if (e !== '19.1.1')
                  throw Error(
                    `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` +
                      (e +
                        `
  - react-dom:  19.1.1
Learn more: https://react.dev/warnings/version-mismatch`)
                  );
              })(),
              (typeof Map == 'function' &&
                Map.prototype != null &&
                typeof Map.prototype.forEach == 'function' &&
                typeof Set == 'function' &&
                Set.prototype != null &&
                typeof Set.prototype.clear == 'function' &&
                typeof Set.prototype.forEach == 'function') ||
                console.error(
                  'React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills'
                ),
              ($e.findDOMNode = function (e) {
                var t = e._reactInternals;
                if (t === void 0)
                  throw typeof e.render == 'function'
                    ? Error('Unable to find node on an unmounted component.')
                    : ((e = Object.keys(e).join(',')),
                      Error(
                        'Argument appears to not be a ReactComponent. Keys: ' +
                          e
                      ));
                return (
                  (e = Y(t)),
                  (e = e !== null ? G(e) : null),
                  (e = e === null ? null : e.stateNode),
                  e
                );
              }),
              !(function () {
                var e = {
                  bundleType: 1,
                  version: '19.1.1',
                  rendererPackageName: 'react-dom',
                  currentDispatcherRef: z,
                  reconcilerVersion: '19.1.1',
                };
                return (
                  (e.overrideHookState = $1),
                  (e.overrideHookStateDeletePath = P1),
                  (e.overrideHookStateRenamePath = G1),
                  (e.overrideProps = q1),
                  (e.overridePropsDeletePath = Y1),
                  (e.overridePropsRenamePath = X1),
                  (e.scheduleUpdate = Q1),
                  (e.setErrorHandler = Z1),
                  (e.setSuspenseHandler = F1),
                  (e.scheduleRefresh = D),
                  (e.scheduleRoot = x),
                  (e.setRefreshHandler = M),
                  (e.getCurrentFiber = qx),
                  (e.getLaneLabelMap = Yx),
                  (e.injectProfilingHooks = Vi),
                  zt(e)
                );
              })() &&
                ma &&
                window.top === window.self &&
                ((-1 < navigator.userAgent.indexOf('Chrome') &&
                  navigator.userAgent.indexOf('Edge') === -1) ||
                  -1 < navigator.userAgent.indexOf('Firefox')))
            ) {
              var K1 = window.location.protocol;
              /^(https?|file):$/.test(K1) &&
                console.info(
                  '%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools' +
                    (K1 === 'file:'
                      ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq`
                      : ''),
                  'font-weight:bold'
                );
            }
            ((or.createRoot = function (e, t) {
              if (!k(e)) throw Error('Target container is not a DOM element.');
              xy(e);
              var n = !1,
                a = '',
                s = Tg,
                c = Cg,
                f = Ag,
                b = null;
              return (
                t != null &&
                  (t.hydrate
                    ? console.warn(
                        'hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.'
                      )
                    : typeof t == 'object' &&
                      t !== null &&
                      t.$$typeof === ui &&
                      console.error(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`),
                  t.unstable_strictMode === !0 && (n = !0),
                  t.identifierPrefix !== void 0 && (a = t.identifierPrefix),
                  t.onUncaughtError !== void 0 && (s = t.onUncaughtError),
                  t.onCaughtError !== void 0 && (c = t.onCaughtError),
                  t.onRecoverableError !== void 0 && (f = t.onRecoverableError),
                  t.unstable_transitionCallbacks !== void 0 &&
                    (b = t.unstable_transitionCallbacks)),
                (t = fy(e, 1, !1, null, null, n, a, s, c, f, b, null)),
                (e[pi] = t.current),
                bf(e),
                new Vf(t)
              );
            }),
              (or.hydrateRoot = function (e, t, n) {
                if (!k(e))
                  throw Error('Target container is not a DOM element.');
                (xy(e),
                  t === void 0 &&
                    console.error(
                      'Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)'
                    ));
                var a = !1,
                  s = '',
                  c = Tg,
                  f = Cg,
                  b = Ag,
                  w = null,
                  T = null;
                return (
                  n != null &&
                    (n.unstable_strictMode === !0 && (a = !0),
                    n.identifierPrefix !== void 0 && (s = n.identifierPrefix),
                    n.onUncaughtError !== void 0 && (c = n.onUncaughtError),
                    n.onCaughtError !== void 0 && (f = n.onCaughtError),
                    n.onRecoverableError !== void 0 &&
                      (b = n.onRecoverableError),
                    n.unstable_transitionCallbacks !== void 0 &&
                      (w = n.unstable_transitionCallbacks),
                    n.formState !== void 0 && (T = n.formState)),
                  (t = fy(e, 1, !0, t, n ?? null, a, s, c, f, b, w, T)),
                  (t.context = my(null)),
                  (n = t.current),
                  (a = hn(n)),
                  (a = js(a)),
                  (s = ni(a)),
                  (s.callback = null),
                  ai(n, s, a),
                  (n = a),
                  (t.current.lanes = n),
                  Ka(t, n),
                  sa(t),
                  (e[pi] = t.current),
                  bf(e),
                  new vc(t)
                );
              }),
              (or.version = '19.1.1'),
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u' &&
                typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ==
                  'function' &&
                __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(
                  Error()
                ));
          })(),
          or
        );
      }
      var r0;
      function Zw() {
        return (r0 || ((r0 = 1), (sp.exports = Qw())), sp.exports);
      }
      var c0 = Zw();
      const ve = i => typeof i == 'string',
        rr = () => {
          let i, l;
          const o = new Promise((r, u) => {
            ((i = r), (l = u));
          });
          return ((o.resolve = i), (o.reject = l), o);
        },
        u0 = i => (i == null ? '' : '' + i),
        Fw = (i, l, o) => {
          i.forEach(r => {
            l[r] && (o[r] = l[r]);
          });
        },
        Kw = /###/g,
        d0 = i => (i && i.indexOf('###') > -1 ? i.replace(Kw, '.') : i),
        f0 = i => !i || ve(i),
        dr = (i, l, o) => {
          const r = ve(l) ? l.split('.') : l;
          let u = 0;
          for (; u < r.length - 1; ) {
            if (f0(i)) return {};
            const d = d0(r[u]);
            (!i[d] && o && (i[d] = new o()),
              Object.prototype.hasOwnProperty.call(i, d)
                ? (i = i[d])
                : (i = {}),
              ++u);
          }
          return f0(i) ? {} : { obj: i, k: d0(r[u]) };
        },
        m0 = (i, l, o) => {
          const { obj: r, k: u } = dr(i, l, Object);
          if (r !== void 0 || l.length === 1) {
            r[u] = o;
            return;
          }
          let d = l[l.length - 1],
            p = l.slice(0, l.length - 1),
            h = dr(i, p, Object);
          for (; h.obj === void 0 && p.length; )
            ((d = `${p[p.length - 1]}.${d}`),
              (p = p.slice(0, p.length - 1)),
              (h = dr(i, p, Object)),
              h?.obj && typeof h.obj[`${h.k}.${d}`] < 'u' && (h.obj = void 0));
          h.obj[`${h.k}.${d}`] = o;
        },
        Jw = (i, l, o, r) => {
          const { obj: u, k: d } = dr(i, l, Object);
          ((u[d] = u[d] || []), u[d].push(o));
        },
        xu = (i, l) => {
          const { obj: o, k: r } = dr(i, l);
          if (o && Object.prototype.hasOwnProperty.call(o, r)) return o[r];
        },
        eE = (i, l, o) => {
          const r = xu(i, o);
          return r !== void 0 ? r : xu(l, o);
        },
        $0 = (i, l, o) => {
          for (const r in l)
            r !== '__proto__' &&
              r !== 'constructor' &&
              (r in i
                ? ve(i[r]) ||
                  i[r] instanceof String ||
                  ve(l[r]) ||
                  l[r] instanceof String
                  ? o && (i[r] = l[r])
                  : $0(i[r], l[r], o)
                : (i[r] = l[r]));
          return i;
        },
        As = i => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      var tE = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
      };
      const nE = i => (ve(i) ? i.replace(/[&<>"'\/]/g, l => tE[l]) : i);
      class aE {
        constructor(l) {
          ((this.capacity = l),
            (this.regExpMap = new Map()),
            (this.regExpQueue = []));
        }
        getRegExp(l) {
          const o = this.regExpMap.get(l);
          if (o !== void 0) return o;
          const r = new RegExp(l);
          return (
            this.regExpQueue.length === this.capacity &&
              this.regExpMap.delete(this.regExpQueue.shift()),
            this.regExpMap.set(l, r),
            this.regExpQueue.push(l),
            r
          );
        }
      }
      const iE = [' ', ',', '?', '!', ';'],
        lE = new aE(20),
        sE = (i, l, o) => {
          ((l = l || ''), (o = o || ''));
          const r = iE.filter(p => l.indexOf(p) < 0 && o.indexOf(p) < 0);
          if (r.length === 0) return !0;
          const u = lE.getRegExp(
            `(${r.map(p => (p === '?' ? '\\?' : p)).join('|')})`
          );
          let d = !u.test(i);
          if (!d) {
            const p = i.indexOf(o);
            p > 0 && !u.test(i.substring(0, p)) && (d = !0);
          }
          return d;
        },
        Np = (i, l, o = '.') => {
          if (!i) return;
          if (i[l])
            return Object.prototype.hasOwnProperty.call(i, l) ? i[l] : void 0;
          const r = l.split(o);
          let u = i;
          for (let d = 0; d < r.length; ) {
            if (!u || typeof u != 'object') return;
            let p,
              h = '';
            for (let m = d; m < r.length; ++m)
              if (
                (m !== d && (h += o), (h += r[m]), (p = u[h]), p !== void 0)
              ) {
                if (
                  ['string', 'number', 'boolean'].indexOf(typeof p) > -1 &&
                  m < r.length - 1
                )
                  continue;
                d += m - d + 1;
                break;
              }
            u = p;
          }
          return u;
        },
        pr = i => i?.replace('_', '-'),
        oE = {
          type: 'logger',
          log(i) {
            this.output('log', i);
          },
          warn(i) {
            this.output('warn', i);
          },
          error(i) {
            this.output('error', i);
          },
          output(i, l) {
            console?.[i]?.apply?.(console, l);
          },
        };
      class Nu {
        constructor(l, o = {}) {
          this.init(l, o);
        }
        init(l, o = {}) {
          ((this.prefix = o.prefix || 'i18next:'),
            (this.logger = l || oE),
            (this.options = o),
            (this.debug = o.debug));
        }
        log(...l) {
          return this.forward(l, 'log', '', !0);
        }
        warn(...l) {
          return this.forward(l, 'warn', '', !0);
        }
        error(...l) {
          return this.forward(l, 'error', '');
        }
        deprecate(...l) {
          return this.forward(l, 'warn', 'WARNING DEPRECATED: ', !0);
        }
        forward(l, o, r, u) {
          return u && !this.debug
            ? null
            : (ve(l[0]) && (l[0] = `${r}${this.prefix} ${l[0]}`),
              this.logger[o](l));
        }
        create(l) {
          return new Nu(this.logger, {
            prefix: `${this.prefix}:${l}:`,
            ...this.options,
          });
        }
        clone(l) {
          return (
            (l = l || this.options),
            (l.prefix = l.prefix || this.prefix),
            new Nu(this.logger, l)
          );
        }
      }
      var va = new Nu();
      class Ru {
        constructor() {
          this.observers = {};
        }
        on(l, o) {
          return (
            l.split(' ').forEach(r => {
              this.observers[r] || (this.observers[r] = new Map());
              const u = this.observers[r].get(o) || 0;
              this.observers[r].set(o, u + 1);
            }),
            this
          );
        }
        off(l, o) {
          if (this.observers[l]) {
            if (!o) {
              delete this.observers[l];
              return;
            }
            this.observers[l].delete(o);
          }
        }
        emit(l, ...o) {
          (this.observers[l] &&
            Array.from(this.observers[l].entries()).forEach(([u, d]) => {
              for (let p = 0; p < d; p++) u(...o);
            }),
            this.observers['*'] &&
              Array.from(this.observers['*'].entries()).forEach(([u, d]) => {
                for (let p = 0; p < d; p++) u.apply(u, [l, ...o]);
              }));
        }
      }
      class p0 extends Ru {
        constructor(l, o = { ns: ['translation'], defaultNS: 'translation' }) {
          (super(),
            (this.data = l || {}),
            (this.options = o),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            this.options.ignoreJSONStructure === void 0 &&
              (this.options.ignoreJSONStructure = !0));
        }
        addNamespaces(l) {
          this.options.ns.indexOf(l) < 0 && this.options.ns.push(l);
        }
        removeNamespaces(l) {
          const o = this.options.ns.indexOf(l);
          o > -1 && this.options.ns.splice(o, 1);
        }
        getResource(l, o, r, u = {}) {
          const d =
              u.keySeparator !== void 0
                ? u.keySeparator
                : this.options.keySeparator,
            p =
              u.ignoreJSONStructure !== void 0
                ? u.ignoreJSONStructure
                : this.options.ignoreJSONStructure;
          let h;
          l.indexOf('.') > -1
            ? (h = l.split('.'))
            : ((h = [l, o]),
              r &&
                (Array.isArray(r)
                  ? h.push(...r)
                  : ve(r) && d
                    ? h.push(...r.split(d))
                    : h.push(r)));
          const m = xu(this.data, h);
          return (
            !m &&
              !o &&
              !r &&
              l.indexOf('.') > -1 &&
              ((l = h[0]), (o = h[1]), (r = h.slice(2).join('.'))),
            m || !p || !ve(r) ? m : Np(this.data?.[l]?.[o], r, d)
          );
        }
        addResource(l, o, r, u, d = { silent: !1 }) {
          const p =
            d.keySeparator !== void 0
              ? d.keySeparator
              : this.options.keySeparator;
          let h = [l, o];
          (r && (h = h.concat(p ? r.split(p) : r)),
            l.indexOf('.') > -1 && ((h = l.split('.')), (u = o), (o = h[1])),
            this.addNamespaces(o),
            m0(this.data, h, u),
            d.silent || this.emit('added', l, o, r, u));
        }
        addResources(l, o, r, u = { silent: !1 }) {
          for (const d in r)
            (ve(r[d]) || Array.isArray(r[d])) &&
              this.addResource(l, o, d, r[d], { silent: !0 });
          u.silent || this.emit('added', l, o, r);
        }
        addResourceBundle(l, o, r, u, d, p = { silent: !1, skipCopy: !1 }) {
          let h = [l, o];
          (l.indexOf('.') > -1 &&
            ((h = l.split('.')), (u = r), (r = o), (o = h[1])),
            this.addNamespaces(o));
          let m = xu(this.data, h) || {};
          (p.skipCopy || (r = JSON.parse(JSON.stringify(r))),
            u ? $0(m, r, d) : (m = { ...m, ...r }),
            m0(this.data, h, m),
            p.silent || this.emit('added', l, o, r));
        }
        removeResourceBundle(l, o) {
          (this.hasResourceBundle(l, o) && delete this.data[l][o],
            this.removeNamespaces(o),
            this.emit('removed', l, o));
        }
        hasResourceBundle(l, o) {
          return this.getResource(l, o) !== void 0;
        }
        getResourceBundle(l, o) {
          return (o || (o = this.options.defaultNS), this.getResource(l, o));
        }
        getDataByLanguage(l) {
          return this.data[l];
        }
        hasLanguageSomeTranslations(l) {
          const o = this.getDataByLanguage(l);
          return !!((o && Object.keys(o)) || []).find(
            u => o[u] && Object.keys(o[u]).length > 0
          );
        }
        toJSON() {
          return this.data;
        }
      }
      var P0 = {
        processors: {},
        addPostProcessor(i) {
          this.processors[i.name] = i;
        },
        handle(i, l, o, r, u) {
          return (
            i.forEach(d => {
              l = this.processors[d]?.process(l, o, r, u) ?? l;
            }),
            l
          );
        },
      };
      const G0 = Symbol('i18next/PATH_KEY');
      function rE() {
        const i = [],
          l = Object.create(null);
        let o;
        return (
          (l.get = (r, u) => (
            o?.revoke?.(),
            u === G0 ? i : (i.push(u), (o = Proxy.revocable(r, l)), o.proxy)
          )),
          Proxy.revocable(Object.create(null), l).proxy
        );
      }
      function wp(i, l) {
        const { [G0]: o } = i(rE());
        return o.join(l?.keySeparator ?? '.');
      }
      const h0 = {},
        up = i => !ve(i) && typeof i != 'boolean' && typeof i != 'number';
      class wu extends Ru {
        constructor(l, o = {}) {
          (super(),
            Fw(
              [
                'resourceStore',
                'languageUtils',
                'pluralResolver',
                'interpolator',
                'backendConnector',
                'i18nFormat',
                'utils',
              ],
              l,
              this
            ),
            (this.options = o),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            (this.logger = va.create('translator')));
        }
        changeLanguage(l) {
          l && (this.language = l);
        }
        exists(l, o = { interpolation: {} }) {
          const r = { ...o };
          if (l == null) return !1;
          const u = this.resolve(l, r);
          if (u?.res === void 0) return !1;
          const d = up(u.res);
          return !(r.returnObjects === !1 && d);
        }
        extractFromKey(l, o) {
          let r =
            o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
          r === void 0 && (r = ':');
          const u =
            o.keySeparator !== void 0
              ? o.keySeparator
              : this.options.keySeparator;
          let d = o.ns || this.options.defaultNS || [];
          const p = r && l.indexOf(r) > -1,
            h =
              !this.options.userDefinedKeySeparator &&
              !o.keySeparator &&
              !this.options.userDefinedNsSeparator &&
              !o.nsSeparator &&
              !sE(l, r, u);
          if (p && !h) {
            const m = l.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0)
              return { key: l, namespaces: ve(d) ? [d] : d };
            const y = l.split(r);
            ((r !== u || (r === u && this.options.ns.indexOf(y[0]) > -1)) &&
              (d = y.shift()),
              (l = y.join(u)));
          }
          return { key: l, namespaces: ve(d) ? [d] : d };
        }
        translate(l, o, r) {
          let u = typeof o == 'object' ? { ...o } : o;
          if (
            (typeof u != 'object' &&
              this.options.overloadTranslationOptionHandler &&
              (u = this.options.overloadTranslationOptionHandler(arguments)),
            typeof u == 'object' && (u = { ...u }),
            u || (u = {}),
            l == null)
          )
            return '';
          (typeof l == 'function' && (l = wp(l, { ...this.options, ...u })),
            Array.isArray(l) || (l = [String(l)]));
          const d =
              u.returnDetails !== void 0
                ? u.returnDetails
                : this.options.returnDetails,
            p =
              u.keySeparator !== void 0
                ? u.keySeparator
                : this.options.keySeparator,
            { key: h, namespaces: m } = this.extractFromKey(l[l.length - 1], u),
            y = m[m.length - 1];
          let E =
            u.nsSeparator !== void 0 ? u.nsSeparator : this.options.nsSeparator;
          E === void 0 && (E = ':');
          const v = u.lng || this.language,
            S =
              u.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
          if (v?.toLowerCase() === 'cimode')
            return S
              ? d
                ? {
                    res: `${y}${E}${h}`,
                    usedKey: h,
                    exactUsedKey: h,
                    usedLng: v,
                    usedNS: y,
                    usedParams: this.getUsedParamsDetails(u),
                  }
                : `${y}${E}${h}`
              : d
                ? {
                    res: h,
                    usedKey: h,
                    exactUsedKey: h,
                    usedLng: v,
                    usedNS: y,
                    usedParams: this.getUsedParamsDetails(u),
                  }
                : h;
          const x = this.resolve(l, u);
          let D = x?.res;
          const M = x?.usedKey || h,
            k = x?.exactUsedKey || h,
            V = ['[object Number]', '[object Function]', '[object RegExp]'],
            L =
              u.joinArrays !== void 0 ? u.joinArrays : this.options.joinArrays,
            U = !this.i18nFormat || this.i18nFormat.handleAsObject,
            Y = u.count !== void 0 && !ve(u.count),
            G = wu.hasDefaultValue(u),
            P = Y ? this.pluralResolver.getSuffix(v, u.count, u) : '',
            Q =
              u.ordinal && Y
                ? this.pluralResolver.getSuffix(v, u.count, { ordinal: !1 })
                : '',
            X = Y && !u.ordinal && u.count === 0,
            J =
              (X && u[`defaultValue${this.options.pluralSeparator}zero`]) ||
              u[`defaultValue${P}`] ||
              u[`defaultValue${Q}`] ||
              u.defaultValue;
          let ee = D;
          U && !D && G && (ee = J);
          const q = up(ee),
            se = Object.prototype.toString.apply(ee);
          if (
            U &&
            ee &&
            q &&
            V.indexOf(se) < 0 &&
            !(ve(L) && Array.isArray(ee))
          ) {
            if (!u.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler ||
                this.logger.warn(
                  'accessing an object - but returnObjects options is not enabled!'
                );
              const ge = this.options.returnedObjectHandler
                ? this.options.returnedObjectHandler(M, ee, { ...u, ns: m })
                : `key '${h} (${this.language})' returned an object instead of string.`;
              return d
                ? ((x.res = ge),
                  (x.usedParams = this.getUsedParamsDetails(u)),
                  x)
                : ge;
            }
            if (p) {
              const ge = Array.isArray(ee),
                we = ge ? [] : {},
                We = ge ? k : M;
              for (const K in ee)
                if (Object.prototype.hasOwnProperty.call(ee, K)) {
                  const ce = `${We}${p}${K}`;
                  (G && !D
                    ? (we[K] = this.translate(ce, {
                        ...u,
                        defaultValue: up(J) ? J[K] : void 0,
                        joinArrays: !1,
                        ns: m,
                      }))
                    : (we[K] = this.translate(ce, {
                        ...u,
                        joinArrays: !1,
                        ns: m,
                      })),
                    we[K] === ce && (we[K] = ee[K]));
                }
              D = we;
            }
          } else if (U && ve(L) && Array.isArray(D))
            ((D = D.join(L)), D && (D = this.extendTranslation(D, l, u, r)));
          else {
            let ge = !1,
              we = !1;
            (!this.isValidLookup(D) && G && ((ge = !0), (D = J)),
              this.isValidLookup(D) || ((we = !0), (D = h)));
            const K =
                (u.missingKeyNoValueFallbackToKey ||
                  this.options.missingKeyNoValueFallbackToKey) &&
                we
                  ? void 0
                  : D,
              ce = G && J !== D && this.options.updateMissing;
            if (we || ge || ce) {
              if (
                (this.logger.log(
                  ce ? 'updateKey' : 'missingKey',
                  v,
                  y,
                  h,
                  ce ? J : D
                ),
                p)
              ) {
                const re = this.resolve(h, { ...u, keySeparator: !1 });
                re &&
                  re.res &&
                  this.logger.warn(
                    'Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.'
                  );
              }
              let F = [];
              const me = this.languageUtils.getFallbackCodes(
                this.options.fallbackLng,
                u.lng || this.language
              );
              if (this.options.saveMissingTo === 'fallback' && me && me[0])
                for (let re = 0; re < me.length; re++) F.push(me[re]);
              else
                this.options.saveMissingTo === 'all'
                  ? (F = this.languageUtils.toResolveHierarchy(
                      u.lng || this.language
                    ))
                  : F.push(u.lng || this.language);
              const W = (re, ue, Ue) => {
                const et = G && Ue !== D ? Ue : K;
                (this.options.missingKeyHandler
                  ? this.options.missingKeyHandler(re, y, ue, et, ce, u)
                  : this.backendConnector?.saveMissing &&
                    this.backendConnector.saveMissing(re, y, ue, et, ce, u),
                  this.emit('missingKey', re, y, ue, D));
              };
              this.options.saveMissing &&
                (this.options.saveMissingPlurals && Y
                  ? F.forEach(re => {
                      const ue = this.pluralResolver.getSuffixes(re, u);
                      (X &&
                        u[`defaultValue${this.options.pluralSeparator}zero`] &&
                        ue.indexOf(`${this.options.pluralSeparator}zero`) < 0 &&
                        ue.push(`${this.options.pluralSeparator}zero`),
                        ue.forEach(Ue => {
                          W([re], h + Ue, u[`defaultValue${Ue}`] || J);
                        }));
                    })
                  : W(F, h, J));
            }
            ((D = this.extendTranslation(D, l, u, x, r)),
              we &&
                D === h &&
                this.options.appendNamespaceToMissingKey &&
                (D = `${y}${E}${h}`),
              (we || ge) &&
                this.options.parseMissingKeyHandler &&
                (D = this.options.parseMissingKeyHandler(
                  this.options.appendNamespaceToMissingKey ? `${y}${E}${h}` : h,
                  ge ? D : void 0,
                  u
                )));
          }
          return d
            ? ((x.res = D), (x.usedParams = this.getUsedParamsDetails(u)), x)
            : D;
        }
        extendTranslation(l, o, r, u, d) {
          if (this.i18nFormat?.parse)
            l = this.i18nFormat.parse(
              l,
              { ...this.options.interpolation.defaultVariables, ...r },
              r.lng || this.language || u.usedLng,
              u.usedNS,
              u.usedKey,
              { resolved: u }
            );
          else if (!r.skipInterpolation) {
            r.interpolation &&
              this.interpolator.init({
                ...r,
                interpolation: {
                  ...this.options.interpolation,
                  ...r.interpolation,
                },
              });
            const m =
              ve(l) &&
              (r?.interpolation?.skipOnVariables !== void 0
                ? r.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables);
            let y;
            if (m) {
              const v = l.match(this.interpolator.nestingRegexp);
              y = v && v.length;
            }
            let E = r.replace && !ve(r.replace) ? r.replace : r;
            if (
              (this.options.interpolation.defaultVariables &&
                (E = { ...this.options.interpolation.defaultVariables, ...E }),
              (l = this.interpolator.interpolate(
                l,
                E,
                r.lng || this.language || u.usedLng,
                r
              )),
              m)
            ) {
              const v = l.match(this.interpolator.nestingRegexp),
                S = v && v.length;
              y < S && (r.nest = !1);
            }
            (!r.lng && u && u.res && (r.lng = this.language || u.usedLng),
              r.nest !== !1 &&
                (l = this.interpolator.nest(
                  l,
                  (...v) =>
                    d?.[0] === v[0] && !r.context
                      ? (this.logger.warn(
                          `It seems you are nesting recursively key: ${v[0]} in key: ${o[0]}`
                        ),
                        null)
                      : this.translate(...v, o),
                  r
                )),
              r.interpolation && this.interpolator.reset());
          }
          const p = r.postProcess || this.options.postProcess,
            h = ve(p) ? [p] : p;
          return (
            l != null &&
              h?.length &&
              r.applyPostProcessor !== !1 &&
              (l = P0.handle(
                h,
                l,
                o,
                this.options && this.options.postProcessPassResolved
                  ? {
                      i18nResolved: {
                        ...u,
                        usedParams: this.getUsedParamsDetails(r),
                      },
                      ...r,
                    }
                  : r,
                this
              )),
            l
          );
        }
        resolve(l, o = {}) {
          let r, u, d, p, h;
          return (
            ve(l) && (l = [l]),
            l.forEach(m => {
              if (this.isValidLookup(r)) return;
              const y = this.extractFromKey(m, o),
                E = y.key;
              u = E;
              let v = y.namespaces;
              this.options.fallbackNS &&
                (v = v.concat(this.options.fallbackNS));
              const S = o.count !== void 0 && !ve(o.count),
                x = S && !o.ordinal && o.count === 0,
                D =
                  o.context !== void 0 &&
                  (ve(o.context) || typeof o.context == 'number') &&
                  o.context !== '',
                M = o.lngs
                  ? o.lngs
                  : this.languageUtils.toResolveHierarchy(
                      o.lng || this.language,
                      o.fallbackLng
                    );
              v.forEach(k => {
                this.isValidLookup(r) ||
                  ((h = k),
                  !h0[`${M[0]}-${k}`] &&
                    this.utils?.hasLoadedNamespace &&
                    !this.utils?.hasLoadedNamespace(h) &&
                    ((h0[`${M[0]}-${k}`] = !0),
                    this.logger.warn(
                      `key "${u}" for languages "${M.join(', ')}" won't get resolved as namespace "${h}" was not yet loaded`,
                      'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                    )),
                  M.forEach(V => {
                    if (this.isValidLookup(r)) return;
                    p = V;
                    const L = [E];
                    if (this.i18nFormat?.addLookupKeys)
                      this.i18nFormat.addLookupKeys(L, E, V, k, o);
                    else {
                      let Y;
                      S && (Y = this.pluralResolver.getSuffix(V, o.count, o));
                      const G = `${this.options.pluralSeparator}zero`,
                        P = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                      if (
                        (S &&
                          (o.ordinal &&
                            Y.indexOf(P) === 0 &&
                            L.push(
                              E + Y.replace(P, this.options.pluralSeparator)
                            ),
                          L.push(E + Y),
                          x && L.push(E + G)),
                        D)
                      ) {
                        const Q = `${E}${this.options.contextSeparator || '_'}${o.context}`;
                        (L.push(Q),
                          S &&
                            (o.ordinal &&
                              Y.indexOf(P) === 0 &&
                              L.push(
                                Q + Y.replace(P, this.options.pluralSeparator)
                              ),
                            L.push(Q + Y),
                            x && L.push(Q + G)));
                      }
                    }
                    let U;
                    for (; (U = L.pop()); )
                      this.isValidLookup(r) ||
                        ((d = U), (r = this.getResource(V, k, U, o)));
                  }));
              });
            }),
            { res: r, usedKey: u, exactUsedKey: d, usedLng: p, usedNS: h }
          );
        }
        isValidLookup(l) {
          return (
            l !== void 0 &&
            !(!this.options.returnNull && l === null) &&
            !(!this.options.returnEmptyString && l === '')
          );
        }
        getResource(l, o, r, u = {}) {
          return this.i18nFormat?.getResource
            ? this.i18nFormat.getResource(l, o, r, u)
            : this.resourceStore.getResource(l, o, r, u);
        }
        getUsedParamsDetails(l = {}) {
          const o = [
              'defaultValue',
              'ordinal',
              'context',
              'replace',
              'lng',
              'lngs',
              'fallbackLng',
              'ns',
              'keySeparator',
              'nsSeparator',
              'returnObjects',
              'returnDetails',
              'joinArrays',
              'postProcess',
              'interpolation',
            ],
            r = l.replace && !ve(l.replace);
          let u = r ? l.replace : l;
          if (
            (r && typeof l.count < 'u' && (u.count = l.count),
            this.options.interpolation.defaultVariables &&
              (u = { ...this.options.interpolation.defaultVariables, ...u }),
            !r)
          ) {
            u = { ...u };
            for (const d of o) delete u[d];
          }
          return u;
        }
        static hasDefaultValue(l) {
          const o = 'defaultValue';
          for (const r in l)
            if (
              Object.prototype.hasOwnProperty.call(l, r) &&
              o === r.substring(0, o.length) &&
              l[r] !== void 0
            )
              return !0;
          return !1;
        }
      }
      class g0 {
        constructor(l) {
          ((this.options = l),
            (this.supportedLngs = this.options.supportedLngs || !1),
            (this.logger = va.create('languageUtils')));
        }
        getScriptPartFromCode(l) {
          if (((l = pr(l)), !l || l.indexOf('-') < 0)) return null;
          const o = l.split('-');
          return o.length === 2 ||
            (o.pop(), o[o.length - 1].toLowerCase() === 'x')
            ? null
            : this.formatLanguageCode(o.join('-'));
        }
        getLanguagePartFromCode(l) {
          if (((l = pr(l)), !l || l.indexOf('-') < 0)) return l;
          const o = l.split('-');
          return this.formatLanguageCode(o[0]);
        }
        formatLanguageCode(l) {
          if (ve(l) && l.indexOf('-') > -1) {
            let o;
            try {
              o = Intl.getCanonicalLocales(l)[0];
            } catch {}
            return (
              o && this.options.lowerCaseLng && (o = o.toLowerCase()),
              o || (this.options.lowerCaseLng ? l.toLowerCase() : l)
            );
          }
          return this.options.cleanCode || this.options.lowerCaseLng
            ? l.toLowerCase()
            : l;
        }
        isSupportedCode(l) {
          return (
            (this.options.load === 'languageOnly' ||
              this.options.nonExplicitSupportedLngs) &&
              (l = this.getLanguagePartFromCode(l)),
            !this.supportedLngs ||
              !this.supportedLngs.length ||
              this.supportedLngs.indexOf(l) > -1
          );
        }
        getBestMatchFromCodes(l) {
          if (!l) return null;
          let o;
          return (
            l.forEach(r => {
              if (o) return;
              const u = this.formatLanguageCode(r);
              (!this.options.supportedLngs || this.isSupportedCode(u)) &&
                (o = u);
            }),
            !o &&
              this.options.supportedLngs &&
              l.forEach(r => {
                if (o) return;
                const u = this.getScriptPartFromCode(r);
                if (this.isSupportedCode(u)) return (o = u);
                const d = this.getLanguagePartFromCode(r);
                if (this.isSupportedCode(d)) return (o = d);
                o = this.options.supportedLngs.find(p => {
                  if (p === d) return p;
                  if (
                    !(p.indexOf('-') < 0 && d.indexOf('-') < 0) &&
                    ((p.indexOf('-') > 0 &&
                      d.indexOf('-') < 0 &&
                      p.substring(0, p.indexOf('-')) === d) ||
                      (p.indexOf(d) === 0 && d.length > 1))
                  )
                    return p;
                });
              }),
            o || (o = this.getFallbackCodes(this.options.fallbackLng)[0]),
            o
          );
        }
        getFallbackCodes(l, o) {
          if (!l) return [];
          if (
            (typeof l == 'function' && (l = l(o)),
            ve(l) && (l = [l]),
            Array.isArray(l))
          )
            return l;
          if (!o) return l.default || [];
          let r = l[o];
          return (
            r || (r = l[this.getScriptPartFromCode(o)]),
            r || (r = l[this.formatLanguageCode(o)]),
            r || (r = l[this.getLanguagePartFromCode(o)]),
            r || (r = l.default),
            r || []
          );
        }
        toResolveHierarchy(l, o) {
          const r = this.getFallbackCodes(
              (o === !1 ? [] : o) || this.options.fallbackLng || [],
              l
            ),
            u = [],
            d = p => {
              p &&
                (this.isSupportedCode(p)
                  ? u.push(p)
                  : this.logger.warn(
                      `rejecting language code not found in supportedLngs: ${p}`
                    ));
            };
          return (
            ve(l) && (l.indexOf('-') > -1 || l.indexOf('_') > -1)
              ? (this.options.load !== 'languageOnly' &&
                  d(this.formatLanguageCode(l)),
                this.options.load !== 'languageOnly' &&
                  this.options.load !== 'currentOnly' &&
                  d(this.getScriptPartFromCode(l)),
                this.options.load !== 'currentOnly' &&
                  d(this.getLanguagePartFromCode(l)))
              : ve(l) && d(this.formatLanguageCode(l)),
            r.forEach(p => {
              u.indexOf(p) < 0 && d(this.formatLanguageCode(p));
            }),
            u
          );
        }
      }
      const b0 = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        y0 = {
          select: i => (i === 1 ? 'one' : 'other'),
          resolvedOptions: () => ({ pluralCategories: ['one', 'other'] }),
        };
      class cE {
        constructor(l, o = {}) {
          ((this.languageUtils = l),
            (this.options = o),
            (this.logger = va.create('pluralResolver')),
            (this.pluralRulesCache = {}));
        }
        addRule(l, o) {
          this.rules[l] = o;
        }
        clearCache() {
          this.pluralRulesCache = {};
        }
        getRule(l, o = {}) {
          const r = pr(l === 'dev' ? 'en' : l),
            u = o.ordinal ? 'ordinal' : 'cardinal',
            d = JSON.stringify({ cleanedCode: r, type: u });
          if (d in this.pluralRulesCache) return this.pluralRulesCache[d];
          let p;
          try {
            p = new Intl.PluralRules(r, { type: u });
          } catch {
            if (!Intl)
              return (
                this.logger.error(
                  'No Intl support, please use an Intl polyfill!'
                ),
                y0
              );
            if (!l.match(/-|_/)) return y0;
            const m = this.languageUtils.getLanguagePartFromCode(l);
            p = this.getRule(m, o);
          }
          return ((this.pluralRulesCache[d] = p), p);
        }
        needsPlural(l, o = {}) {
          let r = this.getRule(l, o);
          return (
            r || (r = this.getRule('dev', o)),
            r?.resolvedOptions().pluralCategories.length > 1
          );
        }
        getPluralFormsOfKey(l, o, r = {}) {
          return this.getSuffixes(l, r).map(u => `${o}${u}`);
        }
        getSuffixes(l, o = {}) {
          let r = this.getRule(l, o);
          return (
            r || (r = this.getRule('dev', o)),
            r
              ? r
                  .resolvedOptions()
                  .pluralCategories.sort((u, d) => b0[u] - b0[d])
                  .map(
                    u =>
                      `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ''}${u}`
                  )
              : []
          );
        }
        getSuffix(l, o, r = {}) {
          const u = this.getRule(l, r);
          return u
            ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ''}${u.select(o)}`
            : (this.logger.warn(`no plural rule found for: ${l}`),
              this.getSuffix('dev', o, r));
        }
      }
      const v0 = (i, l, o, r = '.', u = !0) => {
          let d = eE(i, l, o);
          return (
            !d &&
              u &&
              ve(o) &&
              ((d = Np(i, o, r)), d === void 0 && (d = Np(l, o, r))),
            d
          );
        },
        dp = i => i.replace(/\$/g, '$$$$');
      class uE {
        constructor(l = {}) {
          ((this.logger = va.create('interpolator')),
            (this.options = l),
            (this.format = l?.interpolation?.format || (o => o)),
            this.init(l));
        }
        init(l = {}) {
          l.interpolation || (l.interpolation = { escapeValue: !0 });
          const {
            escape: o,
            escapeValue: r,
            useRawValueToEscape: u,
            prefix: d,
            prefixEscaped: p,
            suffix: h,
            suffixEscaped: m,
            formatSeparator: y,
            unescapeSuffix: E,
            unescapePrefix: v,
            nestingPrefix: S,
            nestingPrefixEscaped: x,
            nestingSuffix: D,
            nestingSuffixEscaped: M,
            nestingOptionsSeparator: k,
            maxReplaces: V,
            alwaysFormat: L,
          } = l.interpolation;
          ((this.escape = o !== void 0 ? o : nE),
            (this.escapeValue = r !== void 0 ? r : !0),
            (this.useRawValueToEscape = u !== void 0 ? u : !1),
            (this.prefix = d ? As(d) : p || '{{'),
            (this.suffix = h ? As(h) : m || '}}'),
            (this.formatSeparator = y || ','),
            (this.unescapePrefix = E ? '' : v || '-'),
            (this.unescapeSuffix = this.unescapePrefix ? '' : E || ''),
            (this.nestingPrefix = S ? As(S) : x || As('$t(')),
            (this.nestingSuffix = D ? As(D) : M || As(')')),
            (this.nestingOptionsSeparator = k || ','),
            (this.maxReplaces = V || 1e3),
            (this.alwaysFormat = L !== void 0 ? L : !1),
            this.resetRegExp());
        }
        reset() {
          this.options && this.init(this.options);
        }
        resetRegExp() {
          const l = (o, r) =>
            o?.source === r ? ((o.lastIndex = 0), o) : new RegExp(r, 'g');
          ((this.regexp = l(this.regexp, `${this.prefix}(.+?)${this.suffix}`)),
            (this.regexpUnescape = l(
              this.regexpUnescape,
              `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`
            )),
            (this.nestingRegexp = l(
              this.nestingRegexp,
              `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`
            )));
        }
        interpolate(l, o, r, u) {
          let d, p, h;
          const m =
              (this.options &&
                this.options.interpolation &&
                this.options.interpolation.defaultVariables) ||
              {},
            y = x => {
              if (x.indexOf(this.formatSeparator) < 0) {
                const V = v0(
                  o,
                  m,
                  x,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                );
                return this.alwaysFormat
                  ? this.format(V, void 0, r, {
                      ...u,
                      ...o,
                      interpolationkey: x,
                    })
                  : V;
              }
              const D = x.split(this.formatSeparator),
                M = D.shift().trim(),
                k = D.join(this.formatSeparator).trim();
              return this.format(
                v0(
                  o,
                  m,
                  M,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                ),
                k,
                r,
                { ...u, ...o, interpolationkey: M }
              );
            };
          this.resetRegExp();
          const E =
              u?.missingInterpolationHandler ||
              this.options.missingInterpolationHandler,
            v =
              u?.interpolation?.skipOnVariables !== void 0
                ? u.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables;
          return (
            [
              { regex: this.regexpUnescape, safeValue: x => dp(x) },
              {
                regex: this.regexp,
                safeValue: x => (this.escapeValue ? dp(this.escape(x)) : dp(x)),
              },
            ].forEach(x => {
              for (h = 0; (d = x.regex.exec(l)); ) {
                const D = d[1].trim();
                if (((p = y(D)), p === void 0))
                  if (typeof E == 'function') {
                    const k = E(l, d, u);
                    p = ve(k) ? k : '';
                  } else if (u && Object.prototype.hasOwnProperty.call(u, D))
                    p = '';
                  else if (v) {
                    p = d[0];
                    continue;
                  } else
                    (this.logger.warn(
                      `missed to pass in variable ${D} for interpolating ${l}`
                    ),
                      (p = ''));
                else !ve(p) && !this.useRawValueToEscape && (p = u0(p));
                const M = x.safeValue(p);
                if (
                  ((l = l.replace(d[0], M)),
                  v
                    ? ((x.regex.lastIndex += p.length),
                      (x.regex.lastIndex -= d[0].length))
                    : (x.regex.lastIndex = 0),
                  h++,
                  h >= this.maxReplaces)
                )
                  break;
              }
            }),
            l
          );
        }
        nest(l, o, r = {}) {
          let u, d, p;
          const h = (m, y) => {
            const E = this.nestingOptionsSeparator;
            if (m.indexOf(E) < 0) return m;
            const v = m.split(new RegExp(`${E}[ ]*{`));
            let S = `{${v[1]}`;
            ((m = v[0]), (S = this.interpolate(S, p)));
            const x = S.match(/'/g),
              D = S.match(/"/g);
            (((x?.length ?? 0) % 2 === 0 && !D) || D.length % 2 !== 0) &&
              (S = S.replace(/'/g, '"'));
            try {
              ((p = JSON.parse(S)), y && (p = { ...y, ...p }));
            } catch (M) {
              return (
                this.logger.warn(
                  `failed parsing options string in nesting for key ${m}`,
                  M
                ),
                `${m}${E}${S}`
              );
            }
            return (
              p.defaultValue &&
                p.defaultValue.indexOf(this.prefix) > -1 &&
                delete p.defaultValue,
              m
            );
          };
          for (; (u = this.nestingRegexp.exec(l)); ) {
            let m = [];
            ((p = { ...r }),
              (p = p.replace && !ve(p.replace) ? p.replace : p),
              (p.applyPostProcessor = !1),
              delete p.defaultValue);
            const y = /{.*}/.test(u[1])
              ? u[1].lastIndexOf('}') + 1
              : u[1].indexOf(this.formatSeparator);
            if (
              (y !== -1 &&
                ((m = u[1]
                  .slice(y)
                  .split(this.formatSeparator)
                  .map(E => E.trim())
                  .filter(Boolean)),
                (u[1] = u[1].slice(0, y))),
              (d = o(h.call(this, u[1].trim(), p), p)),
              d && u[0] === l && !ve(d))
            )
              return d;
            (ve(d) || (d = u0(d)),
              d ||
                (this.logger.warn(`missed to resolve ${u[1]} for nesting ${l}`),
                (d = '')),
              m.length &&
                (d = m.reduce(
                  (E, v) =>
                    this.format(E, v, r.lng, {
                      ...r,
                      interpolationkey: u[1].trim(),
                    }),
                  d.trim()
                )),
              (l = l.replace(u[0], d)),
              (this.regexp.lastIndex = 0));
          }
          return l;
        }
      }
      const dE = i => {
          let l = i.toLowerCase().trim();
          const o = {};
          if (i.indexOf('(') > -1) {
            const r = i.split('(');
            l = r[0].toLowerCase().trim();
            const u = r[1].substring(0, r[1].length - 1);
            l === 'currency' && u.indexOf(':') < 0
              ? o.currency || (o.currency = u.trim())
              : l === 'relativetime' && u.indexOf(':') < 0
                ? o.range || (o.range = u.trim())
                : u.split(';').forEach(p => {
                    if (p) {
                      const [h, ...m] = p.split(':'),
                        y = m
                          .join(':')
                          .trim()
                          .replace(/^'+|'+$/g, ''),
                        E = h.trim();
                      (o[E] || (o[E] = y),
                        y === 'false' && (o[E] = !1),
                        y === 'true' && (o[E] = !0),
                        isNaN(y) || (o[E] = parseInt(y, 10)));
                    }
                  });
          }
          return { formatName: l, formatOptions: o };
        },
        S0 = i => {
          const l = {};
          return (o, r, u) => {
            let d = u;
            u &&
              u.interpolationkey &&
              u.formatParams &&
              u.formatParams[u.interpolationkey] &&
              u[u.interpolationkey] &&
              (d = { ...d, [u.interpolationkey]: void 0 });
            const p = r + JSON.stringify(d);
            let h = l[p];
            return (h || ((h = i(pr(r), u)), (l[p] = h)), h(o));
          };
        },
        fE = i => (l, o, r) => i(pr(o), r)(l);
      class mE {
        constructor(l = {}) {
          ((this.logger = va.create('formatter')),
            (this.options = l),
            this.init(l));
        }
        init(l, o = { interpolation: {} }) {
          this.formatSeparator = o.interpolation.formatSeparator || ',';
          const r = o.cacheInBuiltFormats ? S0 : fE;
          this.formats = {
            number: r((u, d) => {
              const p = new Intl.NumberFormat(u, { ...d });
              return h => p.format(h);
            }),
            currency: r((u, d) => {
              const p = new Intl.NumberFormat(u, { ...d, style: 'currency' });
              return h => p.format(h);
            }),
            datetime: r((u, d) => {
              const p = new Intl.DateTimeFormat(u, { ...d });
              return h => p.format(h);
            }),
            relativetime: r((u, d) => {
              const p = new Intl.RelativeTimeFormat(u, { ...d });
              return h => p.format(h, d.range || 'day');
            }),
            list: r((u, d) => {
              const p = new Intl.ListFormat(u, { ...d });
              return h => p.format(h);
            }),
          };
        }
        add(l, o) {
          this.formats[l.toLowerCase().trim()] = o;
        }
        addCached(l, o) {
          this.formats[l.toLowerCase().trim()] = S0(o);
        }
        format(l, o, r, u = {}) {
          const d = o.split(this.formatSeparator);
          if (
            d.length > 1 &&
            d[0].indexOf('(') > 1 &&
            d[0].indexOf(')') < 0 &&
            d.find(h => h.indexOf(')') > -1)
          ) {
            const h = d.findIndex(m => m.indexOf(')') > -1);
            d[0] = [d[0], ...d.splice(1, h)].join(this.formatSeparator);
          }
          return d.reduce((h, m) => {
            const { formatName: y, formatOptions: E } = dE(m);
            if (this.formats[y]) {
              let v = h;
              try {
                const S = u?.formatParams?.[u.interpolationkey] || {},
                  x = S.locale || S.lng || u.locale || u.lng || r;
                v = this.formats[y](h, x, { ...E, ...u, ...S });
              } catch (S) {
                this.logger.warn(S);
              }
              return v;
            } else this.logger.warn(`there was no format function for ${y}`);
            return h;
          }, l);
        }
      }
      const pE = (i, l) => {
        i.pending[l] !== void 0 && (delete i.pending[l], i.pendingCount--);
      };
      class hE extends Ru {
        constructor(l, o, r, u = {}) {
          (super(),
            (this.backend = l),
            (this.store = o),
            (this.services = r),
            (this.languageUtils = r.languageUtils),
            (this.options = u),
            (this.logger = va.create('backendConnector')),
            (this.waitingReads = []),
            (this.maxParallelReads = u.maxParallelReads || 10),
            (this.readingCalls = 0),
            (this.maxRetries = u.maxRetries >= 0 ? u.maxRetries : 5),
            (this.retryTimeout = u.retryTimeout >= 1 ? u.retryTimeout : 350),
            (this.state = {}),
            (this.queue = []),
            this.backend?.init?.(r, u.backend, u));
        }
        queueLoad(l, o, r, u) {
          const d = {},
            p = {},
            h = {},
            m = {};
          return (
            l.forEach(y => {
              let E = !0;
              (o.forEach(v => {
                const S = `${y}|${v}`;
                !r.reload && this.store.hasResourceBundle(y, v)
                  ? (this.state[S] = 2)
                  : this.state[S] < 0 ||
                    (this.state[S] === 1
                      ? p[S] === void 0 && (p[S] = !0)
                      : ((this.state[S] = 1),
                        (E = !1),
                        p[S] === void 0 && (p[S] = !0),
                        d[S] === void 0 && (d[S] = !0),
                        m[v] === void 0 && (m[v] = !0)));
              }),
                E || (h[y] = !0));
            }),
            (Object.keys(d).length || Object.keys(p).length) &&
              this.queue.push({
                pending: p,
                pendingCount: Object.keys(p).length,
                loaded: {},
                errors: [],
                callback: u,
              }),
            {
              toLoad: Object.keys(d),
              pending: Object.keys(p),
              toLoadLanguages: Object.keys(h),
              toLoadNamespaces: Object.keys(m),
            }
          );
        }
        loaded(l, o, r) {
          const u = l.split('|'),
            d = u[0],
            p = u[1];
          (o && this.emit('failedLoading', d, p, o),
            !o &&
              r &&
              this.store.addResourceBundle(d, p, r, void 0, void 0, {
                skipCopy: !0,
              }),
            (this.state[l] = o ? -1 : 2),
            o && r && (this.state[l] = 0));
          const h = {};
          (this.queue.forEach(m => {
            (Jw(m.loaded, [d], p),
              pE(m, l),
              o && m.errors.push(o),
              m.pendingCount === 0 &&
                !m.done &&
                (Object.keys(m.loaded).forEach(y => {
                  h[y] || (h[y] = {});
                  const E = m.loaded[y];
                  E.length &&
                    E.forEach(v => {
                      h[y][v] === void 0 && (h[y][v] = !0);
                    });
                }),
                (m.done = !0),
                m.errors.length ? m.callback(m.errors) : m.callback()));
          }),
            this.emit('loaded', h),
            (this.queue = this.queue.filter(m => !m.done)));
        }
        read(l, o, r, u = 0, d = this.retryTimeout, p) {
          if (!l.length) return p(null, {});
          if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
              lng: l,
              ns: o,
              fcName: r,
              tried: u,
              wait: d,
              callback: p,
            });
            return;
          }
          this.readingCalls++;
          const h = (y, E) => {
              if ((this.readingCalls--, this.waitingReads.length > 0)) {
                const v = this.waitingReads.shift();
                this.read(v.lng, v.ns, v.fcName, v.tried, v.wait, v.callback);
              }
              if (y && E && u < this.maxRetries) {
                setTimeout(() => {
                  this.read.call(this, l, o, r, u + 1, d * 2, p);
                }, d);
                return;
              }
              p(y, E);
            },
            m = this.backend[r].bind(this.backend);
          if (m.length === 2) {
            try {
              const y = m(l, o);
              y && typeof y.then == 'function'
                ? y.then(E => h(null, E)).catch(h)
                : h(null, y);
            } catch (y) {
              h(y);
            }
            return;
          }
          return m(l, o, h);
        }
        prepareLoading(l, o, r = {}, u) {
          if (!this.backend)
            return (
              this.logger.warn(
                'No backend was added via i18next.use. Will not load resources.'
              ),
              u && u()
            );
          (ve(l) && (l = this.languageUtils.toResolveHierarchy(l)),
            ve(o) && (o = [o]));
          const d = this.queueLoad(l, o, r, u);
          if (!d.toLoad.length) return (d.pending.length || u(), null);
          d.toLoad.forEach(p => {
            this.loadOne(p);
          });
        }
        load(l, o, r) {
          this.prepareLoading(l, o, {}, r);
        }
        reload(l, o, r) {
          this.prepareLoading(l, o, { reload: !0 }, r);
        }
        loadOne(l, o = '') {
          const r = l.split('|'),
            u = r[0],
            d = r[1];
          this.read(u, d, 'read', void 0, void 0, (p, h) => {
            (p &&
              this.logger.warn(
                `${o}loading namespace ${d} for language ${u} failed`,
                p
              ),
              !p &&
                h &&
                this.logger.log(
                  `${o}loaded namespace ${d} for language ${u}`,
                  h
                ),
              this.loaded(l, p, h));
          });
        }
        saveMissing(l, o, r, u, d, p = {}, h = () => {}) {
          if (
            this.services?.utils?.hasLoadedNamespace &&
            !this.services?.utils?.hasLoadedNamespace(o)
          ) {
            this.logger.warn(
              `did not save key "${r}" as the namespace "${o}" was not yet loaded`,
              'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
            );
            return;
          }
          if (!(r == null || r === '')) {
            if (this.backend?.create) {
              const m = { ...p, isUpdate: d },
                y = this.backend.create.bind(this.backend);
              if (y.length < 6)
                try {
                  let E;
                  (y.length === 5
                    ? (E = y(l, o, r, u, m))
                    : (E = y(l, o, r, u)),
                    E && typeof E.then == 'function'
                      ? E.then(v => h(null, v)).catch(h)
                      : h(null, E));
                } catch (E) {
                  h(E);
                }
              else y(l, o, r, u, h, m);
            }
            !l || !l[0] || this.store.addResource(l[0], o, r, u);
          }
        }
      }
      const x0 = () => ({
          debug: !1,
          initAsync: !0,
          ns: ['translation'],
          defaultNS: ['translation'],
          fallbackLng: ['dev'],
          fallbackNS: !1,
          supportedLngs: !1,
          nonExplicitSupportedLngs: !1,
          load: 'all',
          preload: !1,
          simplifyPluralSuffix: !0,
          keySeparator: '.',
          nsSeparator: ':',
          pluralSeparator: '_',
          contextSeparator: '_',
          partialBundledLanguages: !1,
          saveMissing: !1,
          updateMissing: !1,
          saveMissingTo: 'fallback',
          saveMissingPlurals: !0,
          missingKeyHandler: !1,
          missingInterpolationHandler: !1,
          postProcess: !1,
          postProcessPassResolved: !1,
          returnNull: !1,
          returnEmptyString: !0,
          returnObjects: !1,
          joinArrays: !1,
          returnedObjectHandler: !1,
          parseMissingKeyHandler: !1,
          appendNamespaceToMissingKey: !1,
          appendNamespaceToCIMode: !1,
          overloadTranslationOptionHandler: i => {
            let l = {};
            if (
              (typeof i[1] == 'object' && (l = i[1]),
              ve(i[1]) && (l.defaultValue = i[1]),
              ve(i[2]) && (l.tDescription = i[2]),
              typeof i[2] == 'object' || typeof i[3] == 'object')
            ) {
              const o = i[3] || i[2];
              Object.keys(o).forEach(r => {
                l[r] = o[r];
              });
            }
            return l;
          },
          interpolation: {
            escapeValue: !0,
            format: i => i,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1e3,
            skipOnVariables: !0,
          },
          cacheInBuiltFormats: !0,
        }),
        N0 = i => (
          ve(i.ns) && (i.ns = [i.ns]),
          ve(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]),
          ve(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]),
          i.supportedLngs?.indexOf?.('cimode') < 0 &&
            (i.supportedLngs = i.supportedLngs.concat(['cimode'])),
          typeof i.initImmediate == 'boolean' &&
            (i.initAsync = i.initImmediate),
          i
        ),
        gu = () => {},
        gE = i => {
          Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach(o => {
            typeof i[o] == 'function' && (i[o] = i[o].bind(i));
          });
        };
      class hr extends Ru {
        constructor(l = {}, o) {
          if (
            (super(),
            (this.options = N0(l)),
            (this.services = {}),
            (this.logger = va),
            (this.modules = { external: [] }),
            gE(this),
            o && !this.isInitialized && !l.isClone)
          ) {
            if (!this.options.initAsync) return (this.init(l, o), this);
            setTimeout(() => {
              this.init(l, o);
            }, 0);
          }
        }
        init(l = {}, o) {
          ((this.isInitializing = !0),
            typeof l == 'function' && ((o = l), (l = {})),
            l.defaultNS == null &&
              l.ns &&
              (ve(l.ns)
                ? (l.defaultNS = l.ns)
                : l.ns.indexOf('translation') < 0 && (l.defaultNS = l.ns[0])));
          const r = x0();
          ((this.options = { ...r, ...this.options, ...N0(l) }),
            (this.options.interpolation = {
              ...r.interpolation,
              ...this.options.interpolation,
            }),
            l.keySeparator !== void 0 &&
              (this.options.userDefinedKeySeparator = l.keySeparator),
            l.nsSeparator !== void 0 &&
              (this.options.userDefinedNsSeparator = l.nsSeparator));
          const u = y => (y ? (typeof y == 'function' ? new y() : y) : null);
          if (!this.options.isClone) {
            this.modules.logger
              ? va.init(u(this.modules.logger), this.options)
              : va.init(null, this.options);
            let y;
            this.modules.formatter ? (y = this.modules.formatter) : (y = mE);
            const E = new g0(this.options);
            this.store = new p0(this.options.resources, this.options);
            const v = this.services;
            ((v.logger = va),
              (v.resourceStore = this.store),
              (v.languageUtils = E),
              (v.pluralResolver = new cE(E, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix,
              })),
              this.options.interpolation.format &&
                this.options.interpolation.format !== r.interpolation.format &&
                this.logger.deprecate(
                  'init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting'
                ),
              y &&
                (!this.options.interpolation.format ||
                  this.options.interpolation.format ===
                    r.interpolation.format) &&
                ((v.formatter = u(y)),
                v.formatter.init && v.formatter.init(v, this.options),
                (this.options.interpolation.format = v.formatter.format.bind(
                  v.formatter
                ))),
              (v.interpolator = new uE(this.options)),
              (v.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
              }),
              (v.backendConnector = new hE(
                u(this.modules.backend),
                v.resourceStore,
                v,
                this.options
              )),
              v.backendConnector.on('*', (x, ...D) => {
                this.emit(x, ...D);
              }),
              this.modules.languageDetector &&
                ((v.languageDetector = u(this.modules.languageDetector)),
                v.languageDetector.init &&
                  v.languageDetector.init(
                    v,
                    this.options.detection,
                    this.options
                  )),
              this.modules.i18nFormat &&
                ((v.i18nFormat = u(this.modules.i18nFormat)),
                v.i18nFormat.init && v.i18nFormat.init(this)),
              (this.translator = new wu(this.services, this.options)),
              this.translator.on('*', (x, ...D) => {
                this.emit(x, ...D);
              }),
              this.modules.external.forEach(x => {
                x.init && x.init(this);
              }));
          }
          if (
            ((this.format = this.options.interpolation.format),
            o || (o = gu),
            this.options.fallbackLng &&
              !this.services.languageDetector &&
              !this.options.lng)
          ) {
            const y = this.services.languageUtils.getFallbackCodes(
              this.options.fallbackLng
            );
            y.length > 0 && y[0] !== 'dev' && (this.options.lng = y[0]);
          }
          (!this.services.languageDetector &&
            !this.options.lng &&
            this.logger.warn(
              'init: no languageDetector is used and no lng is defined'
            ),
            [
              'getResource',
              'hasResourceBundle',
              'getResourceBundle',
              'getDataByLanguage',
            ].forEach(y => {
              this[y] = (...E) => this.store[y](...E);
            }),
            [
              'addResource',
              'addResources',
              'addResourceBundle',
              'removeResourceBundle',
            ].forEach(y => {
              this[y] = (...E) => (this.store[y](...E), this);
            }));
          const h = rr(),
            m = () => {
              const y = (E, v) => {
                ((this.isInitializing = !1),
                  this.isInitialized &&
                    !this.initializedStoreOnce &&
                    this.logger.warn(
                      'init: i18next is already initialized. You should call init just once!'
                    ),
                  (this.isInitialized = !0),
                  this.options.isClone ||
                    this.logger.log('initialized', this.options),
                  this.emit('initialized', this.options),
                  h.resolve(v),
                  o(E, v));
              };
              if (this.languages && !this.isInitialized)
                return y(null, this.t.bind(this));
              this.changeLanguage(this.options.lng, y);
            };
          return (
            this.options.resources || !this.options.initAsync
              ? m()
              : setTimeout(m, 0),
            h
          );
        }
        loadResources(l, o = gu) {
          let r = o;
          const u = ve(l) ? l : this.language;
          if (
            (typeof l == 'function' && (r = l),
            !this.options.resources || this.options.partialBundledLanguages)
          ) {
            if (
              u?.toLowerCase() === 'cimode' &&
              (!this.options.preload || this.options.preload.length === 0)
            )
              return r();
            const d = [],
              p = h => {
                if (!h || h === 'cimode') return;
                this.services.languageUtils.toResolveHierarchy(h).forEach(y => {
                  y !== 'cimode' && d.indexOf(y) < 0 && d.push(y);
                });
              };
            (u
              ? p(u)
              : this.services.languageUtils
                  .getFallbackCodes(this.options.fallbackLng)
                  .forEach(m => p(m)),
              this.options.preload?.forEach?.(h => p(h)),
              this.services.backendConnector.load(d, this.options.ns, h => {
                (!h &&
                  !this.resolvedLanguage &&
                  this.language &&
                  this.setResolvedLanguage(this.language),
                  r(h));
              }));
          } else r(null);
        }
        reloadResources(l, o, r) {
          const u = rr();
          return (
            typeof l == 'function' && ((r = l), (l = void 0)),
            typeof o == 'function' && ((r = o), (o = void 0)),
            l || (l = this.languages),
            o || (o = this.options.ns),
            r || (r = gu),
            this.services.backendConnector.reload(l, o, d => {
              (u.resolve(), r(d));
            }),
            u
          );
        }
        use(l) {
          if (!l)
            throw new Error(
              'You are passing an undefined module! Please check the object you are passing to i18next.use()'
            );
          if (!l.type)
            throw new Error(
              'You are passing a wrong module! Please check the object you are passing to i18next.use()'
            );
          return (
            l.type === 'backend' && (this.modules.backend = l),
            (l.type === 'logger' || (l.log && l.warn && l.error)) &&
              (this.modules.logger = l),
            l.type === 'languageDetector' &&
              (this.modules.languageDetector = l),
            l.type === 'i18nFormat' && (this.modules.i18nFormat = l),
            l.type === 'postProcessor' && P0.addPostProcessor(l),
            l.type === 'formatter' && (this.modules.formatter = l),
            l.type === '3rdParty' && this.modules.external.push(l),
            this
          );
        }
        setResolvedLanguage(l) {
          if (
            !(!l || !this.languages) &&
            !(['cimode', 'dev'].indexOf(l) > -1)
          ) {
            for (let o = 0; o < this.languages.length; o++) {
              const r = this.languages[o];
              if (
                !(['cimode', 'dev'].indexOf(r) > -1) &&
                this.store.hasLanguageSomeTranslations(r)
              ) {
                this.resolvedLanguage = r;
                break;
              }
            }
            !this.resolvedLanguage &&
              this.languages.indexOf(l) < 0 &&
              this.store.hasLanguageSomeTranslations(l) &&
              ((this.resolvedLanguage = l), this.languages.unshift(l));
          }
        }
        changeLanguage(l, o) {
          this.isLanguageChangingTo = l;
          const r = rr();
          this.emit('languageChanging', l);
          const u = h => {
              ((this.language = h),
                (this.languages =
                  this.services.languageUtils.toResolveHierarchy(h)),
                (this.resolvedLanguage = void 0),
                this.setResolvedLanguage(h));
            },
            d = (h, m) => {
              (m
                ? this.isLanguageChangingTo === l &&
                  (u(m),
                  this.translator.changeLanguage(m),
                  (this.isLanguageChangingTo = void 0),
                  this.emit('languageChanged', m),
                  this.logger.log('languageChanged', m))
                : (this.isLanguageChangingTo = void 0),
                r.resolve((...y) => this.t(...y)),
                o && o(h, (...y) => this.t(...y)));
            },
            p = h => {
              !l && !h && this.services.languageDetector && (h = []);
              const m = ve(h) ? h : h && h[0],
                y = this.store.hasLanguageSomeTranslations(m)
                  ? m
                  : this.services.languageUtils.getBestMatchFromCodes(
                      ve(h) ? [h] : h
                    );
              (y &&
                (this.language || u(y),
                this.translator.language || this.translator.changeLanguage(y),
                this.services.languageDetector?.cacheUserLanguage?.(y)),
                this.loadResources(y, E => {
                  d(E, y);
                }));
            };
          return (
            !l &&
            this.services.languageDetector &&
            !this.services.languageDetector.async
              ? p(this.services.languageDetector.detect())
              : !l &&
                  this.services.languageDetector &&
                  this.services.languageDetector.async
                ? this.services.languageDetector.detect.length === 0
                  ? this.services.languageDetector.detect().then(p)
                  : this.services.languageDetector.detect(p)
                : p(l),
            r
          );
        }
        getFixedT(l, o, r) {
          const u = (d, p, ...h) => {
            let m;
            (typeof p != 'object'
              ? (m = this.options.overloadTranslationOptionHandler(
                  [d, p].concat(h)
                ))
              : (m = { ...p }),
              (m.lng = m.lng || u.lng),
              (m.lngs = m.lngs || u.lngs),
              (m.ns = m.ns || u.ns),
              m.keyPrefix !== '' &&
                (m.keyPrefix = m.keyPrefix || r || u.keyPrefix));
            const y = this.options.keySeparator || '.';
            let E;
            return (
              m.keyPrefix && Array.isArray(d)
                ? (E = d.map(
                    v => (
                      typeof v == 'function' &&
                        (v = wp(v, { ...this.options, ...p })),
                      `${m.keyPrefix}${y}${v}`
                    )
                  ))
                : (typeof d == 'function' &&
                    (d = wp(d, { ...this.options, ...p })),
                  (E = m.keyPrefix ? `${m.keyPrefix}${y}${d}` : d)),
              this.t(E, m)
            );
          };
          return (
            ve(l) ? (u.lng = l) : (u.lngs = l),
            (u.ns = o),
            (u.keyPrefix = r),
            u
          );
        }
        t(...l) {
          return this.translator?.translate(...l);
        }
        exists(...l) {
          return this.translator?.exists(...l);
        }
        setDefaultNamespace(l) {
          this.options.defaultNS = l;
        }
        hasLoadedNamespace(l, o = {}) {
          if (!this.isInitialized)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18next was not initialized',
                this.languages
              ),
              !1
            );
          if (!this.languages || !this.languages.length)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18n.languages were undefined or empty',
                this.languages
              ),
              !1
            );
          const r = o.lng || this.resolvedLanguage || this.languages[0],
            u = this.options ? this.options.fallbackLng : !1,
            d = this.languages[this.languages.length - 1];
          if (r.toLowerCase() === 'cimode') return !0;
          const p = (h, m) => {
            const y = this.services.backendConnector.state[`${h}|${m}`];
            return y === -1 || y === 0 || y === 2;
          };
          if (o.precheck) {
            const h = o.precheck(this, p);
            if (h !== void 0) return h;
          }
          return !!(
            this.hasResourceBundle(r, l) ||
            !this.services.backendConnector.backend ||
            (this.options.resources && !this.options.partialBundledLanguages) ||
            (p(r, l) && (!u || p(d, l)))
          );
        }
        loadNamespaces(l, o) {
          const r = rr();
          return this.options.ns
            ? (ve(l) && (l = [l]),
              l.forEach(u => {
                this.options.ns.indexOf(u) < 0 && this.options.ns.push(u);
              }),
              this.loadResources(u => {
                (r.resolve(), o && o(u));
              }),
              r)
            : (o && o(), Promise.resolve());
        }
        loadLanguages(l, o) {
          const r = rr();
          ve(l) && (l = [l]);
          const u = this.options.preload || [],
            d = l.filter(
              p =>
                u.indexOf(p) < 0 &&
                this.services.languageUtils.isSupportedCode(p)
            );
          return d.length
            ? ((this.options.preload = u.concat(d)),
              this.loadResources(p => {
                (r.resolve(), o && o(p));
              }),
              r)
            : (o && o(), Promise.resolve());
        }
        dir(l) {
          if (
            (l ||
              (l =
                this.resolvedLanguage ||
                (this.languages?.length > 0
                  ? this.languages[0]
                  : this.language)),
            !l)
          )
            return 'rtl';
          try {
            const u = new Intl.Locale(l);
            if (u && u.getTextInfo) {
              const d = u.getTextInfo();
              if (d && d.direction) return d.direction;
            }
          } catch {}
          const o = [
              'ar',
              'shu',
              'sqr',
              'ssh',
              'xaa',
              'yhd',
              'yud',
              'aao',
              'abh',
              'abv',
              'acm',
              'acq',
              'acw',
              'acx',
              'acy',
              'adf',
              'ads',
              'aeb',
              'aec',
              'afb',
              'ajp',
              'apc',
              'apd',
              'arb',
              'arq',
              'ars',
              'ary',
              'arz',
              'auz',
              'avl',
              'ayh',
              'ayl',
              'ayn',
              'ayp',
              'bbz',
              'pga',
              'he',
              'iw',
              'ps',
              'pbt',
              'pbu',
              'pst',
              'prp',
              'prd',
              'ug',
              'ur',
              'ydd',
              'yds',
              'yih',
              'ji',
              'yi',
              'hbo',
              'men',
              'xmn',
              'fa',
              'jpr',
              'peo',
              'pes',
              'prs',
              'dv',
              'sam',
              'ckb',
            ],
            r = this.services?.languageUtils || new g0(x0());
          return l.toLowerCase().indexOf('-latn') > 1
            ? 'ltr'
            : o.indexOf(r.getLanguagePartFromCode(l)) > -1 ||
                l.toLowerCase().indexOf('-arab') > 1
              ? 'rtl'
              : 'ltr';
        }
        static createInstance(l = {}, o) {
          return new hr(l, o);
        }
        cloneInstance(l = {}, o = gu) {
          const r = l.forkResourceStore;
          r && delete l.forkResourceStore;
          const u = { ...this.options, ...l, isClone: !0 },
            d = new hr(u);
          if (
            ((l.debug !== void 0 || l.prefix !== void 0) &&
              (d.logger = d.logger.clone(l)),
            ['store', 'services', 'language'].forEach(h => {
              d[h] = this[h];
            }),
            (d.services = { ...this.services }),
            (d.services.utils = {
              hasLoadedNamespace: d.hasLoadedNamespace.bind(d),
            }),
            r)
          ) {
            const h = Object.keys(this.store.data).reduce(
              (m, y) => (
                (m[y] = { ...this.store.data[y] }),
                (m[y] = Object.keys(m[y]).reduce(
                  (E, v) => ((E[v] = { ...m[y][v] }), E),
                  m[y]
                )),
                m
              ),
              {}
            );
            ((d.store = new p0(h, u)), (d.services.resourceStore = d.store));
          }
          return (
            (d.translator = new wu(d.services, u)),
            d.translator.on('*', (h, ...m) => {
              d.emit(h, ...m);
            }),
            d.init(u, o),
            (d.translator.options = u),
            (d.translator.backendConnector.services.utils = {
              hasLoadedNamespace: d.hasLoadedNamespace.bind(d),
            }),
            d
          );
        }
        toJSON() {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage,
          };
        }
      }
      const Mu = hr.createInstance();
      Mu.createInstance = hr.createInstance;
      const bE = (i, l, o, r) => {
          const u = [o, { code: l, ...(r || {}) }];
          if (i?.services?.logger?.forward)
            return i.services.logger.forward(u, 'warn', 'react-i18next::', !0);
          (Sl(u[0]) && (u[0] = `react-i18next:: ${u[0]}`),
            i?.services?.logger?.warn
              ? i.services.logger.warn(...u)
              : console?.warn && console.warn(...u));
        },
        w0 = {},
        Ep = (i, l, o, r) => {
          (Sl(o) && w0[o]) || (Sl(o) && (w0[o] = new Date()), bE(i, l, o, r));
        },
        q0 = (i, l) => () => {
          if (i.isInitialized) l();
          else {
            const o = () => {
              (setTimeout(() => {
                i.off('initialized', o);
              }, 0),
                l());
            };
            i.on('initialized', o);
          }
        },
        Dp = (i, l, o) => {
          i.loadNamespaces(l, q0(i, o));
        },
        E0 = (i, l, o, r) => {
          if (
            (Sl(o) && (o = [o]),
            i.options.preload && i.options.preload.indexOf(l) > -1)
          )
            return Dp(i, o, r);
          (o.forEach(u => {
            i.options.ns.indexOf(u) < 0 && i.options.ns.push(u);
          }),
            i.loadLanguages(l, q0(i, r)));
        },
        yE = (i, l, o = {}) =>
          !l.languages || !l.languages.length
            ? (Ep(l, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
                languages: l.languages,
              }),
              !0)
            : l.hasLoadedNamespace(i, {
                lng: o.lng,
                precheck: (r, u) => {
                  if (
                    o.bindI18n &&
                    o.bindI18n.indexOf('languageChanging') > -1 &&
                    r.services.backendConnector.backend &&
                    r.isLanguageChangingTo &&
                    !u(r.isLanguageChangingTo, i)
                  )
                    return !1;
                },
              }),
        Sl = i => typeof i == 'string',
        vE = i => typeof i == 'object' && i !== null,
        SE =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        xE = {
          '&amp;': '&',
          '&#38;': '&',
          '&lt;': '<',
          '&#60;': '<',
          '&gt;': '>',
          '&#62;': '>',
          '&apos;': "'",
          '&#39;': "'",
          '&quot;': '"',
          '&#34;': '"',
          '&nbsp;': ' ',
          '&#160;': ' ',
          '&copy;': '©',
          '&#169;': '©',
          '&reg;': '®',
          '&#174;': '®',
          '&hellip;': '…',
          '&#8230;': '…',
          '&#x2F;': '/',
          '&#47;': '/',
        },
        NE = i => xE[i],
        wE = i => i.replace(SE, NE);
      let Tp = {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        useSuspense: !0,
        unescape: wE,
      };
      const EE = (i = {}) => {
          Tp = { ...Tp, ...i };
        },
        DE = () => Tp;
      let Y0;
      const TE = i => {
          Y0 = i;
        },
        CE = () => Y0,
        AE = {
          type: '3rdParty',
          init(i) {
            (EE(i.options.react), TE(i));
          },
        },
        X0 = Z.createContext();
      class RE {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(l) {
          l.forEach(o => {
            this.usedNamespaces[o] || (this.usedNamespaces[o] = !0);
          });
        }
        getUsedNamespaces() {
          return Object.keys(this.usedNamespaces);
        }
      }
      const ME = (i, l) => {
          const o = Z.useRef();
          return (
            Z.useEffect(() => {
              o.current = i;
            }, [i, l]),
            o.current
          );
        },
        Q0 = (i, l, o, r) => i.getFixedT(l, o, r),
        OE = (i, l, o, r) => Z.useCallback(Q0(i, l, o, r), [i, l, o, r]),
        Se = (i, l = {}) => {
          const { i18n: o } = l,
            { i18n: r, defaultNS: u } = Z.useContext(X0) || {},
            d = o || r || CE();
          if (
            (d && !d.reportNamespaces && (d.reportNamespaces = new RE()), !d)
          ) {
            Ep(
              d,
              'NO_I18NEXT_INSTANCE',
              'useTranslation: You will need to pass in an i18next instance by using initReactI18next'
            );
            const Y = (P, Q) =>
                Sl(Q)
                  ? Q
                  : vE(Q) && Sl(Q.defaultValue)
                    ? Q.defaultValue
                    : Array.isArray(P)
                      ? P[P.length - 1]
                      : P,
              G = [Y, {}, !1];
            return ((G.t = Y), (G.i18n = {}), (G.ready = !1), G);
          }
          d.options.react?.wait &&
            Ep(
              d,
              'DEPRECATED_OPTION',
              'useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.'
            );
          const p = { ...DE(), ...d.options.react, ...l },
            { useSuspense: h, keyPrefix: m } = p;
          let y = i || u || d.options?.defaultNS;
          ((y = Sl(y) ? [y] : y || ['translation']),
            d.reportNamespaces.addUsedNamespaces?.(y));
          const E =
              (d.isInitialized || d.initializedStoreOnce) &&
              y.every(Y => yE(Y, d, p)),
            v = OE(d, l.lng || null, p.nsMode === 'fallback' ? y : y[0], m),
            S = () => v,
            x = () =>
              Q0(d, l.lng || null, p.nsMode === 'fallback' ? y : y[0], m),
            [D, M] = Z.useState(S);
          let k = y.join();
          l.lng && (k = `${l.lng}${k}`);
          const V = ME(k),
            L = Z.useRef(!0);
          (Z.useEffect(() => {
            const { bindI18n: Y, bindI18nStore: G } = p;
            ((L.current = !0),
              !E &&
                !h &&
                (l.lng
                  ? E0(d, l.lng, y, () => {
                      L.current && M(x);
                    })
                  : Dp(d, y, () => {
                      L.current && M(x);
                    })),
              E && V && V !== k && L.current && M(x));
            const P = () => {
              L.current && M(x);
            };
            return (
              Y && d?.on(Y, P),
              G && d?.store.on(G, P),
              () => {
                ((L.current = !1),
                  d && Y && Y?.split(' ').forEach(Q => d.off(Q, P)),
                  G && d && G.split(' ').forEach(Q => d.store.off(Q, P)));
              }
            );
          }, [d, k]),
            Z.useEffect(() => {
              L.current && E && M(S);
            }, [d, m, E]));
          const U = [D, d, E];
          if (((U.t = D), (U.i18n = d), (U.ready = E), E || (!E && !h)))
            return U;
          throw new Promise(Y => {
            l.lng ? E0(d, l.lng, y, () => Y()) : Dp(d, y, () => Y());
          });
        };
      function kE({ i18n: i, defaultNS: l, children: o }) {
        const r = Z.useMemo(() => ({ i18n: i, defaultNS: l }), [i, l]);
        return Z.createElement(X0.Provider, { value: r }, o);
      }
      const _E = 'page_RDvY3',
        jE = { page: _E };
      function ea(i = 768) {
        const l = `(max-width: ${i}px)`,
          [o, r] = Z.useState(() =>
            typeof window > 'u' ? !1 : window.matchMedia(l).matches
          );
        return (
          Z.useEffect(() => {
            const u = window.matchMedia(l),
              d = () => r(u.matches);
            return (
              d(),
              u.addEventListener('change', d),
              () => u.removeEventListener('change', d)
            );
          }, [l]),
          o
        );
      }
      function wl(i, l, o, r) {
        return i(r ? o : l);
      }
      const VE = 'scrollWrap_uhIeG',
        BE = 'stickyHero_Sn5KP',
        LE = 'heroBg_Szc6F',
        zE = 'initialContent_KwoSN',
        HE = 'initialInner_GVX4d',
        UE = 'mask_O84gu',
        IE = 'maskFull_JljpA',
        WE = 'scrollContent_9kv4j',
        $E = 'badge_4Pdu3',
        PE = 'title_-xubZ',
        GE = 'subtitle_QJUVl',
        qE = 'scrollTitle_90Hft',
        YE = 'scrollSubtitle_FiqPQ',
        xn = {
          scrollWrap: VE,
          stickyHero: BE,
          heroBg: LE,
          initialContent: zE,
          initialInner: HE,
          mask: UE,
          maskFull: IE,
          scrollContent: WE,
          badge: $E,
          title: PE,
          subtitle: GE,
          scrollTitle: qE,
          scrollSubtitle: YE,
        };
      function XE({ heroBg: i }) {
        const { t: l } = Se(),
          o = Z.useRef(null),
          r = Z.useRef(null),
          [u, d] = Z.useState(0);
        Z.useEffect(() => {
          const S = () => {
            const x = o.current,
              D = r.current;
            if (!x || !D) return;
            const M = x.offsetHeight - D.offsetHeight;
            if (M <= 0) {
              d(0);
              return;
            }
            const k = Math.min(M, Math.max(0, -x.getBoundingClientRect().top));
            d(k / M);
          };
          return (
            S(),
            window.addEventListener('scroll', S, { passive: !0 }),
            window.addEventListener('resize', S),
            () => {
              (window.removeEventListener('scroll', S),
                window.removeEventListener('resize', S));
            }
          );
        }, []);
        const h = Math.min(1, u / 0.65),
          m = h >= 0.99,
          y = Math.max(0, 1 - h * 1.4),
          E = `${h * 100}%`,
          v = Math.max(0, Math.min(1, (h - 0.25) / 0.55));
        return g.jsxDEV(
          'section',
          {
            ref: o,
            className: xn.scrollWrap,
            children: g.jsxDEV(
              'div',
              {
                ref: r,
                className: xn.stickyHero,
                children: [
                  g.jsxDEV(
                    'div',
                    {
                      className: xn.heroBg,
                      style: { backgroundImage: `url(${i})` },
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                      lineNumber: 49,
                      columnNumber: 9,
                    },
                    this
                  ),
                  g.jsxDEV(
                    'div',
                    {
                      className: xn.initialContent,
                      style: { opacity: y },
                      children: g.jsxDEV(
                        'div',
                        {
                          className: xn.initialInner,
                          children: [
                            g.jsxDEV(
                              'span',
                              {
                                className: xn.badge,
                                children: l('section1.badge'),
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                                lineNumber: 53,
                                columnNumber: 13,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'h1',
                              {
                                className: xn.title,
                                children: l('section1.title'),
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                                lineNumber: 54,
                                columnNumber: 13,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'p',
                              {
                                className: xn.subtitle,
                                dangerouslySetInnerHTML: {
                                  __html: l('section1.subtitle'),
                                },
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                                lineNumber: 55,
                                columnNumber: 13,
                              },
                              this
                            ),
                          ],
                        },
                        void 0,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                          lineNumber: 52,
                          columnNumber: 11,
                        },
                        this
                      ),
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                      lineNumber: 51,
                      columnNumber: 9,
                    },
                    this
                  ),
                  g.jsxDEV(
                    'div',
                    {
                      className: `${xn.mask} ${m ? xn.maskFull : ''}`,
                      style: { height: E },
                      'aria-hidden': 'true',
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                      lineNumber: 62,
                      columnNumber: 9,
                    },
                    this
                  ),
                  g.jsxDEV(
                    'div',
                    {
                      className: xn.scrollContent,
                      style: { opacity: v },
                      children: [
                        g.jsxDEV(
                          'p',
                          {
                            className: xn.scrollTitle,
                            dangerouslySetInnerHTML: {
                              __html: l('section1.scrollTitle'),
                            },
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                            lineNumber: 69,
                            columnNumber: 11,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'p',
                          {
                            className: xn.scrollSubtitle,
                            dangerouslySetInnerHTML: {
                              __html: l('section1.scrollSubtitle'),
                            },
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                            lineNumber: 73,
                            columnNumber: 11,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                      lineNumber: 68,
                      columnNumber: 9,
                    },
                    this
                  ),
                ],
              },
              void 0,
              !0,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
                lineNumber: 48,
                columnNumber: 7,
              },
              this
            ),
          },
          void 0,
          !1,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
            lineNumber: 47,
            columnNumber: 5,
          },
          this
        );
      }
      function QE() {
        const { t: i } = Se('imageUrl'),
          l = ea(),
          o = wl(i, 'heroBg', 'heroBgMobile', l);
        return g.jsxDEV(
          XE,
          { heroBg: o },
          void 0,
          !1,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section1/index.tsx',
            lineNumber: 88,
            columnNumber: 10,
          },
          this
        );
      }
      const Rt = ({ name: i, className: l = '', style: o, size: r, ...u }) => {
        const d = { lineHeight: '1', fontSize: r, ...o };
        return g.jsxDEV(
          'i',
          {
            className: `creality-product-info-iconfont ${i} ${l}`,
            style: d,
            ...u,
          },
          void 0,
          !1,
          {
            fileName:
              'D:/works/creality-offical-product/src/components/Icon.tsx',
            lineNumber: 29,
            columnNumber: 5,
          },
          void 0
        );
      };
      /*! lozad.js - v1.16.0 - 2020-09-06
       * https://github.com/ApoorvSaxena/lozad.js
       * Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ const ZE =
          typeof document < 'u' && document.documentMode,
        FE = {
          rootMargin: '0px',
          threshold: 0,
          load(i) {
            if (i.nodeName.toLowerCase() === 'picture') {
              let o = i.querySelector('img'),
                r = !1;
              (o === null && ((o = document.createElement('img')), (r = !0)),
                ZE &&
                  i.getAttribute('data-iesrc') &&
                  (o.src = i.getAttribute('data-iesrc')),
                i.getAttribute('data-alt') &&
                  (o.alt = i.getAttribute('data-alt')),
                r && i.append(o));
            }
            if (
              i.nodeName.toLowerCase() === 'video' &&
              !i.getAttribute('data-src') &&
              i.children
            ) {
              const o = i.children;
              let r;
              for (let u = 0; u <= o.length - 1; u++)
                ((r = o[u].getAttribute('data-src')), r && (o[u].src = r));
              i.load();
            }
            (i.getAttribute('data-poster') &&
              (i.poster = i.getAttribute('data-poster')),
              i.getAttribute('data-src') &&
                (i.src = i.getAttribute('data-src')),
              i.getAttribute('data-srcset') &&
                i.setAttribute('srcset', i.getAttribute('data-srcset')));
            let l = ',';
            if (
              (i.getAttribute('data-background-delimiter') &&
                (l = i.getAttribute('data-background-delimiter')),
              i.getAttribute('data-background-image'))
            )
              i.style.backgroundImage = `url('${i.getAttribute('data-background-image').split(l).join("'),url('")}')`;
            else if (i.getAttribute('data-background-image-set')) {
              const o = i.getAttribute('data-background-image-set').split(l);
              let r = o[0].substr(0, o[0].indexOf(' ')) || o[0];
              ((r = r.indexOf('url(') === -1 ? `url(${r})` : r),
                o.length === 1
                  ? (i.style.backgroundImage = r)
                  : i.setAttribute(
                      'style',
                      (i.getAttribute('style') || '') +
                        `background-image: ${r}; background-image: -webkit-image-set(${o}); background-image: image-set(${o})`
                    ));
            }
            i.getAttribute('data-toggle-class') &&
              i.classList.toggle(i.getAttribute('data-toggle-class'));
          },
          loaded() {},
        };
      function Cp(i) {
        i.setAttribute('data-loaded', !0);
      }
      function KE(i) {
        i.getAttribute('data-placeholder-background') &&
          (i.style.background = i.getAttribute('data-placeholder-background'));
      }
      const Ap = i => i.getAttribute('data-loaded') === 'true',
        JE = (i, l) => (o, r) => {
          o.forEach(u => {
            (u.intersectionRatio > 0 || u.isIntersecting) &&
              (r.unobserve(u.target),
              Ap(u.target) || (i(u.target), Cp(u.target), l(u.target)));
          });
        },
        D0 = (i, l = document) =>
          i instanceof Element
            ? [i]
            : i instanceof NodeList
              ? i
              : l.querySelectorAll(i);
      function eD(i = '.lozad', l = {}) {
        const {
          root: o,
          rootMargin: r,
          threshold: u,
          load: d,
          loaded: p,
        } = Object.assign({}, FE, l);
        let h;
        typeof window < 'u' &&
          window.IntersectionObserver &&
          (h = new IntersectionObserver(JE(d, p), {
            root: o,
            rootMargin: r,
            threshold: u,
          }));
        const m = D0(i, o);
        for (let y = 0; y < m.length; y++) KE(m[y]);
        return {
          observe() {
            const y = D0(i, o);
            for (let E = 0; E < y.length; E++)
              if (!Ap(y[E])) {
                if (h) {
                  h.observe(y[E]);
                  continue;
                }
                (d(y[E]), Cp(y[E]), p(y[E]));
              }
          },
          triggerLoad(y) {
            Ap(y) || (d(y), Cp(y), p(y));
          },
          observer: h,
        };
      }
      const tD = 'safaImage_VwBX8',
        nD = { safaImage: tD };
      function Z0(...i) {
        const l = [];
        for (const o of i)
          if (o) {
            if (typeof o == 'string' || typeof o == 'number') l.push(o);
            else if (Array.isArray(o)) {
              const r = Z0(...o);
              r && l.push(r);
            } else if (typeof o == 'object')
              for (const r in o) o.hasOwnProperty(r) && o[r] && l.push(r);
          }
        return l.join(' ');
      }
      const aD = () => {
        if (typeof window > 'u') {
          const i = globalThis.__SSR_LANG__;
          if (i) return i;
        }
        if (typeof window < 'u') {
          const i = window.location.pathname.match(/\/([^\/]+)\/?$/),
            l = i ? i[1] : '';
          return [
            'cn',
            'en',
            'br',
            'de',
            'es',
            'fr',
            'it',
            'jp',
            'kr',
            'ru',
            'au',
            'ar',
            'mx',
          ].includes(l)
            ? l
            : 'en';
        }
        return 'en';
      };
      function Ft({
        src: i,
        fallback: l,
        showFallbackText: o = !0,
        aspectRatio: r,
        alt: u = '',
        enableLazyLoad: d = !1,
        rootMargin: p = '400px',
        threshold: h = 0,
        ...m
      }) {
        const [y, E] = Z.useState(!1),
          [v, S] = Z.useState(!1),
          x = Z.useRef(null);
        (Z.useEffect(() => {
          S(!0);
        }, []),
          Z.useEffect(() => {
            E(!1);
          }, [i]),
          Z.useEffect(
            () =>
              !d || !v || !x.current
                ? void 0
                : (eD(x.current, {
                    rootMargin: p,
                    threshold: h,
                    loaded: L => {
                      L.classList.add('lozad-loaded');
                    },
                  }).observe(),
                  () => {}),
            [v, d, p, h, i]
          ));
        let D = i;
        (typeof D == 'object' && D !== null && 'src' in D && (D = D.src),
          typeof D == 'string' && D.startsWith('//') && (D = 'https:' + D));
        const M = typeof D == 'string' && D.trim() !== '',
          k = g.jsxDEV(
            'div',
            {
              style: {
                width: m.width || '100%',
                height: m.height || '100%',
                aspectRatio: r,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(243,244,246)',
                ...m.style,
              },
              children: g.jsxDEV(
                Rt,
                {
                  name: 'icon-zhanweifu',
                  style: {
                    fontSize: '36px',
                    lineHeight: '40px',
                    color: 'rgba(156,163,175)',
                    opacity: 0.2,
                  },
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                  lineNumber: 91,
                  columnNumber: 7,
                },
                this
              ),
            },
            void 0,
            !1,
            {
              fileName:
                'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
              lineNumber: 78,
              columnNumber: 5,
            },
            this
          );
        return M
          ? v && y
            ? l
              ? g.jsxDEV(
                  g.Fragment,
                  { children: l },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                    lineNumber: 119,
                    columnNumber: 14,
                  },
                  this
                )
              : o
                ? k
                : null
            : g.jsxDEV(
                'img',
                {
                  ref: x,
                  'data-src': d ? D : void 0,
                  src: d ? void 0 : D,
                  alt: u || '',
                  className: Z0('lozad', nD.safaImage, m.className),
                  onError: () => E(!0),
                  ...m,
                  style: {
                    ...(m.width ? { width: m.width } : {}),
                    ...(m.height ? { height: m.height } : {}),
                    ...(r ? { aspectRatio: r } : {}),
                    objectFit: 'cover',
                    display: 'block',
                    ...m.style,
                  },
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                  lineNumber: 131,
                  columnNumber: 5,
                },
                this
              )
          : l
            ? g.jsxDEV(
                g.Fragment,
                { children: l },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/components/SafaImage/index.tsx',
                  lineNumber: 106,
                  columnNumber: 14,
                },
                this
              )
            : o
              ? k
              : null;
      }
      const iD = 'section2_-xdS0',
        lD = 'title_OHW7n',
        sD = 'mbGrid_ArJ4j',
        oD = 'mbLaserModules_CTz5P',
        rD = 'mbRowTall_42Q4L',
        cD = 'mbRowLifting_RyLj5',
        uD = 'mbRowBottom_tOwHb',
        dD = 'mbAutoFocus_-LQoy',
        fD = 'mbLifting_D9Lcb',
        mD = 'mbHighSpeed_FlHVH',
        pD = 'mbAiExperience_vR92T',
        hD = 'mbIoT_EQaxB',
        gD = 'mbSafety_rDmYA',
        bD = 'cardTitle_3-QDb',
        yD = 'cardAccent_U9vPc',
        vD = 'iotTitle_CzLqL',
        SD = 'iotDesc_r2Mzx',
        xD = 'workingAreaLabel_G-rFi',
        ND = 'workingAreaValue_B9mJS',
        wD = 'upTo_gVNQ-',
        ED = 'speedNum_eNTj1',
        DD = 'speedUnit_2VfFQ',
        TD = 'aiExperienceTitle_E7O1d',
        CD = 'laserBadge_5w1lR',
        AD = 'laserModulesTitle_FYSVk',
        RD = 'laserRow_6kOxN',
        MD = 'laserPower_-1rfE',
        OD = 'laserType_dHHNA',
        kD = 'materialsIcon_zbcHz',
        _D = 'materialsLabel_MRlgh',
        jD = 'speedBlock_AckId',
        VD = 'speedValue_bTr-F',
        BD = 'workingArea_WIzAe',
        LD = 'safetyTitle_o0XOD',
        zD = 'class1_TORh6',
        HD = 'grid_V0VDc',
        UD = 'colLeft_-fjEW',
        ID = 'colMiddle_j6of-',
        WD = 'colRight_UOYXY',
        $D = 'cardAutoFocus_Px5lI',
        PD = 'cardLifting_-C4It',
        GD = 'cardLaserModules_AJKPw',
        qD = 'materialsBlock_IW5W6',
        YD = 'bottomRow_YSBIT',
        XD = 'cardSafety_-baOJ',
        QD = 'cardIoT_xtT7P',
        ZD = 'cardHighSpeed_Ft0zF',
        FD = 'cardAiExperience_RkDDt',
        le = {
          section2: iD,
          title: lD,
          mbGrid: sD,
          mbLaserModules: oD,
          mbRowTall: rD,
          mbRowLifting: cD,
          mbRowBottom: uD,
          mbAutoFocus: dD,
          mbLifting: fD,
          mbHighSpeed: mD,
          mbAiExperience: pD,
          mbIoT: hD,
          mbSafety: gD,
          cardTitle: bD,
          cardAccent: yD,
          iotTitle: vD,
          iotDesc: SD,
          workingAreaLabel: xD,
          workingAreaValue: ND,
          upTo: wD,
          speedNum: ED,
          speedUnit: DD,
          aiExperienceTitle: TD,
          laserBadge: CD,
          laserModulesTitle: AD,
          laserRow: RD,
          laserPower: MD,
          laserType: OD,
          materialsIcon: kD,
          materialsLabel: _D,
          speedBlock: jD,
          speedValue: VD,
          workingArea: BD,
          safetyTitle: LD,
          class1: zD,
          grid: HD,
          colLeft: UD,
          colMiddle: ID,
          colRight: WD,
          cardAutoFocus: $D,
          cardLifting: PD,
          cardLaserModules: GD,
          materialsBlock: qD,
          bottomRow: YD,
          cardSafety: XD,
          cardIoT: QD,
          cardHighSpeed: ZD,
          cardAiExperience: FD,
        };
      function KD() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          r = [
            { power: 'section2.laser5w', type: 'section2.laser5wType' },
            { power: 'section2.laser10w', type: 'section2.laser10wType' },
            { power: 'section2.laserIR', type: 'section2.laserIRType' },
          ],
          u = h => ({ backgroundImage: `url(${l(h)})` }),
          d = h => ({ backgroundImage: `url(${l(`${h}Mobile`)})` }),
          p = wl(l, 'materialsIcon', 'materialsIconMobile', o);
        return o
          ? g.jsxDEV(
              'section',
              {
                className: le.section2,
                children: [
                  g.jsxDEV(
                    'h2',
                    { className: le.title, children: i('section2.title') },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                      lineNumber: 31,
                      columnNumber: 9,
                    },
                    this
                  ),
                  g.jsxDEV(
                    'div',
                    {
                      className: le.mbGrid,
                      children: [
                        g.jsxDEV(
                          'div',
                          {
                            className: le.mbLaserModules,
                            style: d('highlight2'),
                            children: [
                              g.jsxDEV(
                                'h3',
                                {
                                  className: le.laserModulesTitle,
                                  children: i('section2.laserModulesTitle'),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 35,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.laserRow,
                                  children: r.map(h =>
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.laserBadge,
                                        children: [
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.laserPower,
                                              children: i(h.power),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 39,
                                              columnNumber: 19,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.laserType,
                                              children: i(h.type),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 40,
                                              columnNumber: 19,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      h.power,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 38,
                                        columnNumber: 17,
                                      },
                                      this
                                    )
                                  ),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 36,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.materialsBlock,
                                  children: [
                                    g.jsxDEV(
                                      Ft,
                                      {
                                        className: le.materialsIcon,
                                        src: p,
                                        alt: '',
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 45,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.materialsLabel,
                                        children: i('section2.materials'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 46,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 44,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                            lineNumber: 34,
                            columnNumber: 11,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: le.mbRowTall,
                            children: [
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.mbAutoFocus,
                                  style: d('highlight1'),
                                  children: g.jsxDEV(
                                    'span',
                                    {
                                      className: le.cardTitle,
                                      children: i('section2.autoFocus'),
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                      lineNumber: 52,
                                      columnNumber: 15,
                                    },
                                    this
                                  ),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 51,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.mbHighSpeed,
                                  style: d('highlight3'),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.cardTitle,
                                        children: i('section2.highSpeed'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 55,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.speedBlock,
                                        children: [
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.upTo,
                                              children: i('section2.upTo'),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 57,
                                              columnNumber: 17,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'div',
                                            {
                                              className: le.speedValue,
                                              children: [
                                                g.jsxDEV(
                                                  'span',
                                                  {
                                                    className: le.speedNum,
                                                    children: i(
                                                      'section2.speedValue'
                                                    ),
                                                  },
                                                  void 0,
                                                  !1,
                                                  {
                                                    fileName:
                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                                    lineNumber: 59,
                                                    columnNumber: 19,
                                                  },
                                                  this
                                                ),
                                                g.jsxDEV(
                                                  'span',
                                                  {
                                                    className: le.speedUnit,
                                                    children:
                                                      i('section2.speedUnit'),
                                                  },
                                                  void 0,
                                                  !1,
                                                  {
                                                    fileName:
                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                                    lineNumber: 60,
                                                    columnNumber: 19,
                                                  },
                                                  this
                                                ),
                                              ],
                                            },
                                            void 0,
                                            !0,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 58,
                                              columnNumber: 17,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 56,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 54,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                            lineNumber: 50,
                            columnNumber: 11,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: le.mbRowLifting,
                            children: [
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.mbLifting,
                                  style: d('highlight4'),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.cardTitle,
                                        children: i('section2.liftingPlatform'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 68,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.workingArea,
                                        children: [
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.workingAreaLabel,
                                              children: i(
                                                'section2.workingAreaLabel'
                                              ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 70,
                                              columnNumber: 17,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.workingAreaValue,
                                              dangerouslySetInnerHTML: {
                                                __html: i(
                                                  'section2.workingAreaValue'
                                                ),
                                              },
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 71,
                                              columnNumber: 17,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 69,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 67,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.mbAiExperience,
                                  style: d('highlight8'),
                                  children: g.jsxDEV(
                                    'div',
                                    {
                                      className: le.aiExperienceTitle,
                                      children: [
                                        g.jsxDEV(
                                          'span',
                                          {
                                            className: le.cardAccent,
                                            dangerouslySetInnerHTML: {
                                              __html: i('section2.aiPowered'),
                                            },
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                            lineNumber: 79,
                                            columnNumber: 17,
                                          },
                                          this
                                        ),
                                        g.jsxDEV(
                                          'span',
                                          {
                                            children: i(
                                              'section2.smartExperience'
                                            ),
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                            lineNumber: 83,
                                            columnNumber: 17,
                                          },
                                          this
                                        ),
                                      ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                      lineNumber: 78,
                                      columnNumber: 15,
                                    },
                                    this
                                  ),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 77,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                            lineNumber: 66,
                            columnNumber: 11,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: le.mbRowBottom,
                            children: [
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.mbIoT,
                                  style: d('highlight6'),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.iotTitle,
                                        children: i('section2.smartIoT'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 90,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'p',
                                      {
                                        className: le.iotDesc,
                                        children: i('section2.smartIoTDesc'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 91,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 89,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.mbSafety,
                                  style: d('highlight5'),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.safetyTitle,
                                        dangerouslySetInnerHTML: {
                                          __html: i('section2.laserSafety'),
                                        },
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 94,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.class1,
                                        children: i('section2.class1'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 98,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 93,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                            lineNumber: 88,
                            columnNumber: 11,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                      lineNumber: 33,
                      columnNumber: 9,
                    },
                    this
                  ),
                ],
              },
              void 0,
              !0,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                lineNumber: 30,
                columnNumber: 7,
              },
              this
            )
          : g.jsxDEV(
              'section',
              {
                className: le.section2,
                children: [
                  g.jsxDEV(
                    'h2',
                    { className: le.title, children: i('section2.title') },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                      lineNumber: 108,
                      columnNumber: 7,
                    },
                    this
                  ),
                  g.jsxDEV(
                    'div',
                    {
                      className: le.grid,
                      children: [
                        g.jsxDEV(
                          'div',
                          {
                            className: le.colLeft,
                            children: [
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.cardAutoFocus,
                                  style: u('highlight1'),
                                  children: g.jsxDEV(
                                    'span',
                                    {
                                      className: le.cardTitle,
                                      children: i('section2.autoFocus'),
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                      lineNumber: 113,
                                      columnNumber: 13,
                                    },
                                    this
                                  ),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 112,
                                  columnNumber: 11,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.cardLifting,
                                  style: u('highlight4'),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.cardAccent,
                                        children: i('section2.liftingPlatform'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 116,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.workingArea,
                                        children: [
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.workingAreaLabel,
                                              children: i(
                                                'section2.workingAreaLabel'
                                              ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 118,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.workingAreaValue,
                                              dangerouslySetInnerHTML: {
                                                __html: i(
                                                  'section2.workingAreaValue'
                                                ),
                                              },
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 119,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 117,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 115,
                                  columnNumber: 11,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                            lineNumber: 111,
                            columnNumber: 9,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: le.colMiddle,
                            children: [
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.cardLaserModules,
                                  style: u('highlight2'),
                                  children: [
                                    g.jsxDEV(
                                      'h3',
                                      {
                                        className: le.laserModulesTitle,
                                        children: i(
                                          'section2.laserModulesTitle'
                                        ),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 129,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.laserRow,
                                        children: r.map(h =>
                                          g.jsxDEV(
                                            'div',
                                            {
                                              className: le.laserBadge,
                                              children: [
                                                g.jsxDEV(
                                                  'span',
                                                  {
                                                    className: le.laserPower,
                                                    children: i(h.power),
                                                  },
                                                  void 0,
                                                  !1,
                                                  {
                                                    fileName:
                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                                    lineNumber: 133,
                                                    columnNumber: 19,
                                                  },
                                                  this
                                                ),
                                                g.jsxDEV(
                                                  'span',
                                                  {
                                                    className: le.laserType,
                                                    children: i(h.type),
                                                  },
                                                  void 0,
                                                  !1,
                                                  {
                                                    fileName:
                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                                    lineNumber: 134,
                                                    columnNumber: 19,
                                                  },
                                                  this
                                                ),
                                              ],
                                            },
                                            h.power,
                                            !0,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 132,
                                              columnNumber: 17,
                                            },
                                            this
                                          )
                                        ),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 130,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.materialsBlock,
                                        children: [
                                          g.jsxDEV(
                                            Ft,
                                            {
                                              className: le.materialsIcon,
                                              src: p,
                                              alt: '',
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 139,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.materialsLabel,
                                              children: i('section2.materials'),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 140,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 138,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 128,
                                  columnNumber: 11,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.bottomRow,
                                  children: [
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.cardSafety,
                                        style: u('highlight5'),
                                        children: [
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.safetyTitle,
                                              dangerouslySetInnerHTML: {
                                                __html: i(
                                                  'section2.laserSafety'
                                                ),
                                              },
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 146,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.class1,
                                              children: i('section2.class1'),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 150,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 145,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.cardIoT,
                                        style: u('highlight6'),
                                        children: [
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.iotTitle,
                                              children: i('section2.smartIoT'),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 153,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'p',
                                            {
                                              className: le.iotDesc,
                                              children: i(
                                                'section2.smartIoTDesc'
                                              ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 154,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 152,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 144,
                                  columnNumber: 11,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                            lineNumber: 127,
                            columnNumber: 9,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: le.colRight,
                            children: [
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.cardHighSpeed,
                                  style: u('highlight3'),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: le.cardTitle,
                                        children: i('section2.highSpeed'),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 161,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: le.speedBlock,
                                        children: [
                                          g.jsxDEV(
                                            'span',
                                            {
                                              className: le.upTo,
                                              children: i('section2.upTo'),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 163,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'div',
                                            {
                                              className: le.speedValue,
                                              children: [
                                                g.jsxDEV(
                                                  'span',
                                                  {
                                                    className: le.speedNum,
                                                    children: i(
                                                      'section2.speedValue'
                                                    ),
                                                  },
                                                  void 0,
                                                  !1,
                                                  {
                                                    fileName:
                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                                    lineNumber: 165,
                                                    columnNumber: 17,
                                                  },
                                                  this
                                                ),
                                                g.jsxDEV(
                                                  'span',
                                                  {
                                                    className: le.speedUnit,
                                                    children:
                                                      i('section2.speedUnit'),
                                                  },
                                                  void 0,
                                                  !1,
                                                  {
                                                    fileName:
                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                                    lineNumber: 166,
                                                    columnNumber: 17,
                                                  },
                                                  this
                                                ),
                                              ],
                                            },
                                            void 0,
                                            !0,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                              lineNumber: 164,
                                              columnNumber: 15,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                        lineNumber: 162,
                                        columnNumber: 13,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 160,
                                  columnNumber: 11,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: le.cardAiExperience,
                                  style: u('highlight8'),
                                  children: g.jsxDEV(
                                    'div',
                                    {
                                      className: le.aiExperienceTitle,
                                      children: [
                                        g.jsxDEV(
                                          'span',
                                          {
                                            className: le.cardAccent,
                                            dangerouslySetInnerHTML: {
                                              __html: i('section2.aiPowered'),
                                            },
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                            lineNumber: 172,
                                            columnNumber: 15,
                                          },
                                          this
                                        ),
                                        g.jsxDEV(
                                          'span',
                                          {
                                            children: i(
                                              'section2.smartExperience'
                                            ),
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                            lineNumber: 176,
                                            columnNumber: 15,
                                          },
                                          this
                                        ),
                                      ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                      lineNumber: 171,
                                      columnNumber: 13,
                                    },
                                    this
                                  ),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                                  lineNumber: 170,
                                  columnNumber: 11,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                            lineNumber: 159,
                            columnNumber: 9,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                      lineNumber: 110,
                      columnNumber: 7,
                    },
                    this
                  ),
                ],
              },
              void 0,
              !0,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section2/index.tsx',
                lineNumber: 107,
                columnNumber: 5,
              },
              this
            );
      }
      const JD = 'section3_oc4BD',
        eT = 'title_kumR7',
        tT = 'subtitle_JRLno',
        nT = 'list_R8dQ0',
        aT = 'row_O-any',
        iT = 'image_i1fz4',
        lT = 'text_ZiGbr',
        Mi = {
          section3: JD,
          title: eT,
          subtitle: tT,
          list: nT,
          row: aT,
          image: iT,
          text: lT,
        },
        T0 = ['scenario1', 'scenario2', 'scenario3', 'scenario4'];
      function sT() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = i('section3.scenarios', { returnObjects: !0 });
        return g.jsxDEV(
          'section',
          {
            className: Mi.section3,
            children: [
              g.jsxDEV(
                'h2',
                {
                  className: Mi.title,
                  dangerouslySetInnerHTML: { __html: i('section3.title') },
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                  lineNumber: 18,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'p',
                { className: Mi.subtitle, children: i('section3.subtitle') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                  lineNumber: 19,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Mi.list,
                  children: o.map((r, u) =>
                    g.jsxDEV(
                      'div',
                      {
                        className: Mi.row,
                        style: { backgroundColor: r.bgColor },
                        'data-reverse': r.imagePosition === 'left',
                        children: [
                          r.imagePosition === 'left' &&
                            g.jsxDEV(
                              'div',
                              {
                                className: Mi.image,
                                style: { backgroundImage: `url(${l(T0[u])})` },
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                                lineNumber: 29,
                                columnNumber: 15,
                              },
                              this
                            ),
                          g.jsxDEV(
                            'div',
                            {
                              className: Mi.text,
                              children: [
                                g.jsxDEV(
                                  'h3',
                                  {
                                    dangerouslySetInnerHTML: {
                                      __html: r.title,
                                    },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                                    lineNumber: 35,
                                    columnNumber: 15,
                                  },
                                  this
                                ),
                                g.jsxDEV(
                                  'p',
                                  {
                                    dangerouslySetInnerHTML: {
                                      __html: r.description,
                                    },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                                    lineNumber: 36,
                                    columnNumber: 15,
                                  },
                                  this
                                ),
                              ],
                            },
                            void 0,
                            !0,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                              lineNumber: 34,
                              columnNumber: 13,
                            },
                            this
                          ),
                          r.imagePosition === 'right' &&
                            g.jsxDEV(
                              'div',
                              {
                                className: Mi.image,
                                style: { backgroundImage: `url(${l(T0[u])})` },
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                                lineNumber: 39,
                                columnNumber: 15,
                              },
                              this
                            ),
                        ],
                      },
                      u,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                        lineNumber: 22,
                        columnNumber: 11,
                      },
                      this
                    )
                  ),
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
                  lineNumber: 20,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section3/index.tsx',
            lineNumber: 17,
            columnNumber: 5,
          },
          this
        );
      }
      const oT = 'carousel_bWdNO',
        rT = 'media_00bWU',
        cT = 'mediaInner_3UTk0',
        uT = 'mediaAsset_knRI-',
        dT = 'mediaPlaceholder_00KoW',
        fT = 'mediaNavBtn_GO3S0',
        mT = 'mediaNavBtnPrev_KDycK',
        pT = 'mediaNavBtnNext_gdk7r',
        hT = 'panel_EE08B',
        gT = 'sideBtn_udfye',
        bT = 'sideBtnLeft_d-ge-',
        yT = 'sidePill_BNyq1',
        vT = 'sidePlus_mPhWt',
        ST = 'sideBtnRight_A69nC',
        xT = 'sideBtnDisabled_3yrWd',
        NT = 'card_Npmfw',
        wT = 'cardTitle_5d-Kk',
        ET = 'cardDesc_CQD6a',
        at = {
          carousel: oT,
          media: rT,
          mediaInner: cT,
          mediaAsset: uT,
          mediaPlaceholder: dT,
          mediaNavBtn: fT,
          mediaNavBtnPrev: mT,
          mediaNavBtnNext: pT,
          panel: hT,
          sideBtn: gT,
          sideBtnLeft: bT,
          sidePill: yT,
          sidePlus: vT,
          sideBtnRight: ST,
          sideBtnDisabled: xT,
          card: NT,
          cardTitle: wT,
          cardDesc: ET,
        };
      function C0(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const o = l(i);
        return o && o !== i ? o : '';
      }
      function DT() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          [o, r] = Z.useState(0),
          u = Z.useRef(null),
          d = i('section4.easyUseTabs', { returnObjects: !0 }),
          p = d[o],
          h = C0(p?.video, l),
          m = C0(p?.image, l),
          y = o <= 0,
          E = o >= d.length - 1,
          v = () => {
            y || r(x => Math.max(0, x - 1));
          },
          S = () => {
            E || r(x => Math.min(d.length - 1, x + 1));
          };
        return (
          Z.useEffect(() => {
            const x = u.current;
            if (!x || !h) return;
            const D = requestAnimationFrame(() => {
              x.src !== h && ((x.src = h), x.load(), x.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(D);
          }, [h]),
          g.jsxDEV(
            'div',
            {
              className: at.carousel,
              children: [
                g.jsxDEV(
                  'div',
                  {
                    className: at.media,
                    children: [
                      g.jsxDEV(
                        'div',
                        {
                          className: at.mediaInner,
                          children: h
                            ? g.jsxDEV(
                                'video',
                                {
                                  ref: u,
                                  className: at.mediaAsset,
                                  src: h,
                                  autoPlay: !0,
                                  loop: !0,
                                  muted: !0,
                                  playsInline: !0,
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                  lineNumber: 63,
                                  columnNumber: 13,
                                },
                                this
                              )
                            : m
                              ? g.jsxDEV(
                                  'div',
                                  {
                                    className: at.mediaAsset,
                                    style: { backgroundImage: `url(${m})` },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                    lineNumber: 73,
                                    columnNumber: 13,
                                  },
                                  this
                                )
                              : g.jsxDEV(
                                  'div',
                                  { className: at.mediaPlaceholder },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                    lineNumber: 78,
                                    columnNumber: 13,
                                  },
                                  this
                                ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                          lineNumber: 61,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${at.mediaNavBtn} ${at.mediaNavBtnPrev}`,
                          onClick: v,
                          disabled: y,
                          'aria-label': 'Previous slide',
                          children: g.jsxDEV(
                            Rt,
                            { name: 'icon-left' },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                              lineNumber: 89,
                              columnNumber: 11,
                            },
                            this
                          ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                          lineNumber: 82,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${at.mediaNavBtn} ${at.mediaNavBtnNext}`,
                          onClick: S,
                          disabled: E,
                          'aria-label': 'Next slide',
                          children: g.jsxDEV(
                            Rt,
                            { name: 'icon-More' },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                              lineNumber: 98,
                              columnNumber: 11,
                            },
                            this
                          ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                          lineNumber: 91,
                          columnNumber: 9,
                        },
                        this
                      ),
                    ],
                  },
                  void 0,
                  !0,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                    lineNumber: 60,
                    columnNumber: 7,
                  },
                  this
                ),
                g.jsxDEV(
                  'div',
                  {
                    className: at.panel,
                    children: [
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${at.sideBtn} ${at.sideBtnLeft} ${y ? at.sideBtnDisabled : ''}`,
                          onClick: v,
                          disabled: y,
                          'aria-label': 'Previous feature',
                          children: [
                            g.jsxDEV(
                              'span',
                              { className: at.sidePill },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 110,
                                columnNumber: 11,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'span',
                              { className: at.sidePlus, 'aria-hidden': 'true' },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 111,
                                columnNumber: 11,
                              },
                              this
                            ),
                          ],
                        },
                        void 0,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                          lineNumber: 103,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'div',
                        {
                          className: at.card,
                          children: [
                            g.jsxDEV(
                              'h3',
                              {
                                className: at.cardTitle,
                                dangerouslySetInnerHTML: { __html: p.title },
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 115,
                                columnNumber: 11,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'p',
                              {
                                className: at.cardDesc,
                                dangerouslySetInnerHTML: {
                                  __html: p.description,
                                },
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 119,
                                columnNumber: 11,
                              },
                              this
                            ),
                          ],
                        },
                        void 0,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                          lineNumber: 114,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${at.sideBtn} ${at.sideBtnRight} ${E ? at.sideBtnDisabled : ''}`,
                          onClick: S,
                          disabled: E,
                          'aria-label': 'Next feature',
                          children: [
                            g.jsxDEV(
                              'span',
                              { className: at.sidePill },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 132,
                                columnNumber: 11,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'span',
                              { className: at.sidePlus, 'aria-hidden': 'true' },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                                lineNumber: 133,
                                columnNumber: 11,
                              },
                              this
                            ),
                          ],
                        },
                        void 0,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                          lineNumber: 125,
                          columnNumber: 9,
                        },
                        this
                      ),
                    ],
                  },
                  void 0,
                  !0,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
                    lineNumber: 102,
                    columnNumber: 7,
                  },
                  this
                ),
              ],
            },
            void 0,
            !0,
            {
              fileName:
                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/EasyUseMobileCarousel.tsx',
              lineNumber: 59,
              columnNumber: 5,
            },
            this
          )
        );
      }
      const TT = 'section4_OLp40',
        CT = 'title_8hgSQ',
        AT = 'subtitle_-Y9c1',
        RT = 'content_NnVkM',
        MT = 'features_voHBc',
        OT = 'tabItem_Akquf',
        kT = 'tabCollapsed_UYZRk',
        _T = 'plus_BzR-3',
        jT = 'tabContent_3IMli',
        VT = 'tabActive_ia-k2',
        BT = 'tabTitle_dwKji',
        LT = 'tabDesc_mKivj',
        zT = 'tabDescWrap_CMnB9',
        HT = 'tabDescOpen_0w6rV',
        UT = 'plusHidden_a0SqE',
        IT = 'image_lwGCk',
        WT = 'imageBg_tynbW',
        $T = 'imagePlaceholder_8Cp5l',
        PT = 'video_9anBW',
        GT = 'playPauseBtn_05GuV',
        qT = 'pauseIcon_6PtpC',
        YT = 'playIcon_EkuFV',
        ut = {
          section4: TT,
          title: CT,
          subtitle: AT,
          content: RT,
          features: MT,
          tabItem: OT,
          tabCollapsed: kT,
          plus: _T,
          tabContent: jT,
          tabActive: VT,
          tabTitle: BT,
          tabDesc: LT,
          tabDescWrap: zT,
          tabDescOpen: HT,
          plusHidden: UT,
          image: IT,
          imageBg: WT,
          imagePlaceholder: $T,
          video: PT,
          playPauseBtn: GT,
          pauseIcon: qT,
          playIcon: YT,
        };
      function bu(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const o = l(i);
        return o && o !== i ? o : '';
      }
      function fp(i, l = 3e3) {
        return typeof window.requestIdleCallback == 'function'
          ? window.requestIdleCallback(i, { timeout: l })
          : window.setTimeout(i, 1500);
      }
      function XT(i) {
        if (typeof window.cancelIdleCallback == 'function') {
          window.cancelIdleCallback(i);
          return;
        }
        window.clearTimeout(i);
      }
      function QT(i) {
        const l = document.createElement('video');
        ((l.preload = 'auto'), (l.muted = !0), (l.src = i), l.load());
      }
      function ZT(i) {
        const l = new Image();
        l.src = i;
      }
      function FT() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          [r, u] = Z.useState(0),
          [d, p] = Z.useState(!0),
          h = Z.useRef(null),
          m = Z.useRef(new Set()),
          y = i('section4.easyUseTabs', { returnObjects: !0 }),
          E = y[r],
          v = bu(E?.video, l),
          S = bu(E?.image, l);
        (Z.useEffect(() => {
          p(!0);
        }, [r, v]),
          Z.useEffect(() => {
            const D = h.current;
            if (!D || !v) return;
            const M = requestAnimationFrame(() => {
              D.src !== v && ((D.src = v), D.load(), D.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(M);
          }, [v]),
          Z.useEffect(() => {
            const D = v || S,
              M = y.flatMap(U => {
                const Y = bu(U.video, l),
                  G = bu(U.image, l);
                return [
                  Y && Y !== D ? { url: Y, type: 'video' } : null,
                  G && G !== D ? { url: G, type: 'image' } : null,
                ].filter(Boolean);
              });
            let k = !1,
              V;
            const L = U => {
              if (k || U >= M.length) return;
              const Y = M[U];
              if (!Y || m.current.has(Y.url)) {
                V = fp(() => L(U + 1));
                return;
              }
              (m.current.add(Y.url),
                Y.type === 'video' ? QT(Y.url) : ZT(Y.url),
                (V = fp(() => L(U + 1))));
            };
            return (
              (V = fp(() => L(0))),
              () => {
                ((k = !0), V !== void 0 && XT(V));
              }
            );
          }, [y, v, S, l]));
        const x = () => {
          const D = h.current;
          if (D) {
            if (D.paused) {
              (D.play(), p(!0));
              return;
            }
            (D.pause(), p(!1));
          }
        };
        return g.jsxDEV(
          'section',
          {
            className: ut.section4,
            children: [
              g.jsxDEV(
                'h2',
                { className: ut.title, children: i('section4.title') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                  lineNumber: 143,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'p',
                { className: ut.subtitle, children: i('section4.subtitle') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                  lineNumber: 144,
                  columnNumber: 7,
                },
                this
              ),
              o
                ? g.jsxDEV(
                    DT,
                    {},
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                      lineNumber: 147,
                      columnNumber: 9,
                    },
                    this
                  )
                : g.jsxDEV(
                    'div',
                    {
                      className: ut.content,
                      children: [
                        g.jsxDEV(
                          'div',
                          {
                            className: ut.features,
                            children: y.map((D, M) => {
                              const k = r === M;
                              return g.jsxDEV(
                                'button',
                                {
                                  type: 'button',
                                  className: `${ut.tabItem} ${k ? ut.tabActive : ut.tabCollapsed}`,
                                  onClick: () => u(M),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: `${ut.plus} ${k ? ut.plusHidden : ''}`,
                                        'aria-hidden': 'true',
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                        lineNumber: 161,
                                        columnNumber: 17,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: ut.tabContent,
                                        children: [
                                          g.jsxDEV(
                                            'h3',
                                            {
                                              className: ut.tabTitle,
                                              dangerouslySetInnerHTML: {
                                                __html: D.title,
                                              },
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                              lineNumber: 166,
                                              columnNumber: 19,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'div',
                                            {
                                              className: `${ut.tabDescWrap} ${k ? ut.tabDescOpen : ''}`,
                                              children: g.jsxDEV(
                                                'p',
                                                {
                                                  className: ut.tabDesc,
                                                  dangerouslySetInnerHTML: {
                                                    __html: D.description,
                                                  },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                                  lineNumber: 168,
                                                  columnNumber: 21,
                                                },
                                                this
                                              ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                              lineNumber: 167,
                                              columnNumber: 19,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                        lineNumber: 165,
                                        columnNumber: 17,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                D.title,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                  lineNumber: 155,
                                  columnNumber: 15,
                                },
                                this
                              );
                            }),
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                            lineNumber: 150,
                            columnNumber: 9,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: ut.image,
                            children: v
                              ? g.jsxDEV(
                                  g.Fragment,
                                  {
                                    children: [
                                      g.jsxDEV(
                                        'video',
                                        {
                                          ref: h,
                                          className: ut.video,
                                          src: v,
                                          autoPlay: !0,
                                          loop: !0,
                                          muted: !0,
                                          playsInline: !0,
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                          lineNumber: 182,
                                          columnNumber: 15,
                                        },
                                        this
                                      ),
                                      g.jsxDEV(
                                        'button',
                                        {
                                          type: 'button',
                                          className: ut.playPauseBtn,
                                          onClick: x,
                                          'aria-label': d
                                            ? 'Pause video'
                                            : 'Play video',
                                          children: d
                                            ? g.jsxDEV(
                                                'span',
                                                {
                                                  className: ut.pauseIcon,
                                                  'aria-hidden': 'true',
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                                  lineNumber: 198,
                                                  columnNumber: 19,
                                                },
                                                this
                                              )
                                            : g.jsxDEV(
                                                'span',
                                                {
                                                  className: ut.playIcon,
                                                  'aria-hidden': 'true',
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                                  lineNumber: 200,
                                                  columnNumber: 19,
                                                },
                                                this
                                              ),
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                          lineNumber: 191,
                                          columnNumber: 15,
                                        },
                                        this
                                      ),
                                    ],
                                  },
                                  void 0,
                                  !0,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                    lineNumber: 181,
                                    columnNumber: 13,
                                  },
                                  this
                                )
                              : S
                                ? g.jsxDEV(
                                    'div',
                                    {
                                      className: ut.imageBg,
                                      style: { backgroundImage: `url(${S})` },
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                      lineNumber: 205,
                                      columnNumber: 13,
                                    },
                                    this
                                  )
                                : g.jsxDEV(
                                    'div',
                                    { className: ut.imagePlaceholder },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                                      lineNumber: 210,
                                      columnNumber: 13,
                                    },
                                    this
                                  ),
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                            lineNumber: 179,
                            columnNumber: 9,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
                      lineNumber: 149,
                      columnNumber: 7,
                    },
                    this
                  ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section4/index.tsx',
            lineNumber: 142,
            columnNumber: 5,
          },
          this
        );
      }
      function A0(i) {
        return (
          i !== null &&
          typeof i == 'object' &&
          'constructor' in i &&
          i.constructor === Object
        );
      }
      function kp(i = {}, l = {}) {
        const o = ['__proto__', 'constructor', 'prototype'];
        Object.keys(l)
          .filter(r => o.indexOf(r) < 0)
          .forEach(r => {
            typeof i[r] > 'u'
              ? (i[r] = l[r])
              : A0(l[r]) &&
                A0(i[r]) &&
                Object.keys(l[r]).length > 0 &&
                kp(i[r], l[r]);
          });
      }
      const F0 = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: '' },
        querySelector() {
          return null;
        },
        querySelectorAll() {
          return [];
        },
        getElementById() {
          return null;
        },
        createEvent() {
          return { initEvent() {} };
        },
        createElement() {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() {},
            getElementsByTagName() {
              return [];
            },
          };
        },
        createElementNS() {
          return {};
        },
        importNode() {
          return null;
        },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
      };
      function El() {
        const i = typeof document < 'u' ? document : {};
        return (kp(i, F0), i);
      }
      const KT = {
        document: F0,
        navigator: { userAgent: '' },
        location: {
          hash: '',
          host: '',
          hostname: '',
          href: '',
          origin: '',
          pathname: '',
          protocol: '',
          search: '',
        },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle() {
          return {
            getPropertyValue() {
              return '';
            },
          };
        },
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia() {
          return {};
        },
        requestAnimationFrame(i) {
          return typeof setTimeout > 'u' ? (i(), null) : setTimeout(i, 0);
        },
        cancelAnimationFrame(i) {
          typeof setTimeout > 'u' || clearTimeout(i);
        },
      };
      function Kt() {
        const i = typeof window < 'u' ? window : {};
        return (kp(i, KT), i);
      }
      function JT(i = '') {
        return i
          .trim()
          .split(' ')
          .filter(l => !!l.trim());
      }
      function eC(i) {
        const l = i;
        Object.keys(l).forEach(o => {
          try {
            l[o] = null;
          } catch {}
          try {
            delete l[o];
          } catch {}
        });
      }
      function K0(i, l = 0) {
        return setTimeout(i, l);
      }
      function Eu() {
        return Date.now();
      }
      function tC(i) {
        const l = Kt();
        let o;
        return (
          l.getComputedStyle && (o = l.getComputedStyle(i, null)),
          !o && i.currentStyle && (o = i.currentStyle),
          o || (o = i.style),
          o
        );
      }
      function nC(i, l = 'x') {
        const o = Kt();
        let r, u, d;
        const p = tC(i);
        return (
          o.WebKitCSSMatrix
            ? ((u = p.transform || p.webkitTransform),
              u.split(',').length > 6 &&
                (u = u
                  .split(', ')
                  .map(h => h.replace(',', '.'))
                  .join(', ')),
              (d = new o.WebKitCSSMatrix(u === 'none' ? '' : u)))
            : ((d =
                p.MozTransform ||
                p.OTransform ||
                p.MsTransform ||
                p.msTransform ||
                p.transform ||
                p
                  .getPropertyValue('transform')
                  .replace('translate(', 'matrix(1, 0, 0, 1,')),
              (r = d.toString().split(','))),
          l === 'x' &&
            (o.WebKitCSSMatrix
              ? (u = d.m41)
              : r.length === 16
                ? (u = parseFloat(r[12]))
                : (u = parseFloat(r[4]))),
          l === 'y' &&
            (o.WebKitCSSMatrix
              ? (u = d.m42)
              : r.length === 16
                ? (u = parseFloat(r[13]))
                : (u = parseFloat(r[5]))),
          u || 0
        );
      }
      function yu(i) {
        return (
          typeof i == 'object' &&
          i !== null &&
          i.constructor &&
          Object.prototype.toString.call(i).slice(8, -1) === 'Object'
        );
      }
      function aC(i) {
        return typeof window < 'u' && typeof window.HTMLElement < 'u'
          ? i instanceof HTMLElement
          : i && (i.nodeType === 1 || i.nodeType === 11);
      }
      function En(...i) {
        const l = Object(i[0]),
          o = ['__proto__', 'constructor', 'prototype'];
        for (let r = 1; r < i.length; r += 1) {
          const u = i[r];
          if (u != null && !aC(u)) {
            const d = Object.keys(Object(u)).filter(p => o.indexOf(p) < 0);
            for (let p = 0, h = d.length; p < h; p += 1) {
              const m = d[p],
                y = Object.getOwnPropertyDescriptor(u, m);
              y !== void 0 &&
                y.enumerable &&
                (yu(l[m]) && yu(u[m])
                  ? u[m].__swiper__
                    ? (l[m] = u[m])
                    : En(l[m], u[m])
                  : !yu(l[m]) && yu(u[m])
                    ? ((l[m] = {}),
                      u[m].__swiper__ ? (l[m] = u[m]) : En(l[m], u[m]))
                    : (l[m] = u[m]));
            }
          }
        }
        return l;
      }
      function vu(i, l, o) {
        i.style.setProperty(l, o);
      }
      function J0({ swiper: i, targetPosition: l, side: o }) {
        const r = Kt(),
          u = -i.translate;
        let d = null,
          p;
        const h = i.params.speed;
        ((i.wrapperEl.style.scrollSnapType = 'none'),
          r.cancelAnimationFrame(i.cssModeFrameID));
        const m = l > u ? 'next' : 'prev',
          y = (v, S) => (m === 'next' && v >= S) || (m === 'prev' && v <= S),
          E = () => {
            ((p = new Date().getTime()), d === null && (d = p));
            const v = Math.max(Math.min((p - d) / h, 1), 0),
              S = 0.5 - Math.cos(v * Math.PI) / 2;
            let x = u + S * (l - u);
            if (
              (y(x, l) && (x = l), i.wrapperEl.scrollTo({ [o]: x }), y(x, l))
            ) {
              ((i.wrapperEl.style.overflow = 'hidden'),
                (i.wrapperEl.style.scrollSnapType = ''),
                setTimeout(() => {
                  ((i.wrapperEl.style.overflow = ''),
                    i.wrapperEl.scrollTo({ [o]: x }));
                }),
                r.cancelAnimationFrame(i.cssModeFrameID));
              return;
            }
            i.cssModeFrameID = r.requestAnimationFrame(E);
          };
        E();
      }
      function Sa(i, l = '') {
        const o = Kt(),
          r = [...i.children];
        return (
          o.HTMLSlotElement &&
            i instanceof HTMLSlotElement &&
            r.push(...i.assignedElements()),
          l ? r.filter(u => u.matches(l)) : r
        );
      }
      function iC(i, l) {
        const o = [l];
        for (; o.length > 0; ) {
          const r = o.shift();
          if (i === r) return !0;
          o.push(
            ...r.children,
            ...(r.shadowRoot ? r.shadowRoot.children : []),
            ...(r.assignedElements ? r.assignedElements() : [])
          );
        }
      }
      function lC(i, l) {
        const o = Kt();
        let r = l.contains(i);
        return (
          !r &&
            o.HTMLSlotElement &&
            l instanceof HTMLSlotElement &&
            ((r = [...l.assignedElements()].includes(i)), r || (r = iC(i, l))),
          r
        );
      }
      function Du(i) {
        try {
          console.warn(i);
          return;
        } catch {}
      }
      function Tu(i, l = []) {
        const o = document.createElement(i);
        return (o.classList.add(...(Array.isArray(l) ? l : JT(l))), o);
      }
      function sC(i, l) {
        const o = [];
        for (; i.previousElementSibling; ) {
          const r = i.previousElementSibling;
          (l ? r.matches(l) && o.push(r) : o.push(r), (i = r));
        }
        return o;
      }
      function oC(i, l) {
        const o = [];
        for (; i.nextElementSibling; ) {
          const r = i.nextElementSibling;
          (l ? r.matches(l) && o.push(r) : o.push(r), (i = r));
        }
        return o;
      }
      function ki(i, l) {
        return Kt().getComputedStyle(i, null).getPropertyValue(l);
      }
      function R0(i) {
        let l = i,
          o;
        if (l) {
          for (o = 0; (l = l.previousSibling) !== null; )
            l.nodeType === 1 && (o += 1);
          return o;
        }
      }
      function rC(i, l) {
        const o = [];
        let r = i.parentElement;
        for (; r; ) (o.push(r), (r = r.parentElement));
        return o;
      }
      function M0(i, l, o) {
        const r = Kt();
        return (
          i[l === 'width' ? 'offsetWidth' : 'offsetHeight'] +
          parseFloat(
            r
              .getComputedStyle(i, null)
              .getPropertyValue(l === 'width' ? 'margin-right' : 'margin-top')
          ) +
          parseFloat(
            r
              .getComputedStyle(i, null)
              .getPropertyValue(l === 'width' ? 'margin-left' : 'margin-bottom')
          )
        );
      }
      function Ya(i) {
        return (Array.isArray(i) ? i : [i]).filter(l => !!l);
      }
      function Rp(i, l = '') {
        typeof trustedTypes < 'u'
          ? (i.innerHTML = trustedTypes
              .createPolicy('html', { createHTML: o => o })
              .createHTML(l))
          : (i.innerHTML = l);
      }
      let mp;
      function cC() {
        const i = Kt(),
          l = El();
        return {
          smoothScroll:
            l.documentElement &&
            l.documentElement.style &&
            'scrollBehavior' in l.documentElement.style,
          touch: !!(
            'ontouchstart' in i ||
            (i.DocumentTouch && l instanceof i.DocumentTouch)
          ),
        };
      }
      function eS() {
        return (mp || (mp = cC()), mp);
      }
      let pp;
      function uC({ userAgent: i } = {}) {
        const l = eS(),
          o = Kt(),
          r = o.navigator.platform,
          u = i || o.navigator.userAgent,
          d = { ios: !1, android: !1 },
          p = o.screen.width,
          h = o.screen.height,
          m = u.match(/(Android);?[\s\/]+([\d.]+)?/);
        let y = u.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
        const E = u.match(/(iPod)(.*OS\s([\d_]+))?/),
          v = !y && u.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
          S = r === 'Win32';
        let x = r === 'MacIntel';
        const D = [
          '1024x1366',
          '1366x1024',
          '834x1194',
          '1194x834',
          '834x1112',
          '1112x834',
          '768x1024',
          '1024x768',
          '820x1180',
          '1180x820',
          '810x1080',
          '1080x810',
        ];
        return (
          !y &&
            x &&
            l.touch &&
            D.indexOf(`${p}x${h}`) >= 0 &&
            ((y = u.match(/(Version)\/([\d.]+)/)),
            y || (y = [0, 1, '13_0_0']),
            (x = !1)),
          m && !S && ((d.os = 'android'), (d.android = !0)),
          (y || v || E) && ((d.os = 'ios'), (d.ios = !0)),
          d
        );
      }
      function tS(i = {}) {
        return (pp || (pp = uC(i)), pp);
      }
      let hp;
      function dC() {
        const i = Kt(),
          l = tS();
        let o = !1;
        function r() {
          const h = i.navigator.userAgent.toLowerCase();
          return (
            h.indexOf('safari') >= 0 &&
            h.indexOf('chrome') < 0 &&
            h.indexOf('android') < 0
          );
        }
        if (r()) {
          const h = String(i.navigator.userAgent);
          if (h.includes('Version/')) {
            const [m, y] = h
              .split('Version/')[1]
              .split(' ')[0]
              .split('.')
              .map(E => Number(E));
            o = m < 16 || (m === 16 && y < 2);
          }
        }
        const u = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            i.navigator.userAgent
          ),
          d = r(),
          p = d || (u && l.ios);
        return {
          isSafari: o || d,
          needPerspectiveFix: o,
          need3dFix: p,
          isWebView: u,
        };
      }
      function nS() {
        return (hp || (hp = dC()), hp);
      }
      function fC({ swiper: i, on: l, emit: o }) {
        const r = Kt();
        let u = null,
          d = null;
        const p = () => {
            !i ||
              i.destroyed ||
              !i.initialized ||
              (o('beforeResize'), o('resize'));
          },
          h = () => {
            !i ||
              i.destroyed ||
              !i.initialized ||
              ((u = new ResizeObserver(E => {
                d = r.requestAnimationFrame(() => {
                  const { width: v, height: S } = i;
                  let x = v,
                    D = S;
                  (E.forEach(
                    ({ contentBoxSize: M, contentRect: k, target: V }) => {
                      (V && V !== i.el) ||
                        ((x = k ? k.width : (M[0] || M).inlineSize),
                        (D = k ? k.height : (M[0] || M).blockSize));
                    }
                  ),
                    (x !== v || D !== S) && p());
                });
              })),
              u.observe(i.el));
          },
          m = () => {
            (d && r.cancelAnimationFrame(d),
              u && u.unobserve && i.el && (u.unobserve(i.el), (u = null)));
          },
          y = () => {
            !i || i.destroyed || !i.initialized || o('orientationchange');
          };
        (l('init', () => {
          if (i.params.resizeObserver && typeof r.ResizeObserver < 'u') {
            h();
            return;
          }
          (r.addEventListener('resize', p),
            r.addEventListener('orientationchange', y));
        }),
          l('destroy', () => {
            (m(),
              r.removeEventListener('resize', p),
              r.removeEventListener('orientationchange', y));
          }));
      }
      function mC({ swiper: i, extendParams: l, on: o, emit: r }) {
        const u = [],
          d = Kt(),
          p = (y, E = {}) => {
            const v = d.MutationObserver || d.WebkitMutationObserver,
              S = new v(x => {
                if (i.__preventObserver__) return;
                if (x.length === 1) {
                  r('observerUpdate', x[0]);
                  return;
                }
                const D = function () {
                  r('observerUpdate', x[0]);
                };
                d.requestAnimationFrame
                  ? d.requestAnimationFrame(D)
                  : d.setTimeout(D, 0);
              });
            (S.observe(y, {
              attributes: typeof E.attributes > 'u' ? !0 : E.attributes,
              childList:
                i.isElement || (typeof E.childList > 'u' ? !0 : E).childList,
              characterData:
                typeof E.characterData > 'u' ? !0 : E.characterData,
            }),
              u.push(S));
          },
          h = () => {
            if (i.params.observer) {
              if (i.params.observeParents) {
                const y = rC(i.hostEl);
                for (let E = 0; E < y.length; E += 1) p(y[E]);
              }
              (p(i.hostEl, { childList: i.params.observeSlideChildren }),
                p(i.wrapperEl, { attributes: !1 }));
            }
          },
          m = () => {
            (u.forEach(y => {
              y.disconnect();
            }),
              u.splice(0, u.length));
          };
        (l({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          o('init', h),
          o('destroy', m));
      }
      var pC = {
        on(i, l, o) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof l != 'function')
            return r;
          const u = o ? 'unshift' : 'push';
          return (
            i.split(' ').forEach(d => {
              (r.eventsListeners[d] || (r.eventsListeners[d] = []),
                r.eventsListeners[d][u](l));
            }),
            r
          );
        },
        once(i, l, o) {
          const r = this;
          if (!r.eventsListeners || r.destroyed || typeof l != 'function')
            return r;
          function u(...d) {
            (r.off(i, u),
              u.__emitterProxy && delete u.__emitterProxy,
              l.apply(r, d));
          }
          return ((u.__emitterProxy = l), r.on(i, u, o));
        },
        onAny(i, l) {
          const o = this;
          if (!o.eventsListeners || o.destroyed || typeof i != 'function')
            return o;
          const r = l ? 'unshift' : 'push';
          return (
            o.eventsAnyListeners.indexOf(i) < 0 && o.eventsAnyListeners[r](i),
            o
          );
        },
        offAny(i) {
          const l = this;
          if (!l.eventsListeners || l.destroyed || !l.eventsAnyListeners)
            return l;
          const o = l.eventsAnyListeners.indexOf(i);
          return (o >= 0 && l.eventsAnyListeners.splice(o, 1), l);
        },
        off(i, l) {
          const o = this;
          return (
            !o.eventsListeners ||
              o.destroyed ||
              !o.eventsListeners ||
              i.split(' ').forEach(r => {
                typeof l > 'u'
                  ? (o.eventsListeners[r] = [])
                  : o.eventsListeners[r] &&
                    o.eventsListeners[r].forEach((u, d) => {
                      (u === l ||
                        (u.__emitterProxy && u.__emitterProxy === l)) &&
                        o.eventsListeners[r].splice(d, 1);
                    });
              }),
            o
          );
        },
        emit(...i) {
          const l = this;
          if (!l.eventsListeners || l.destroyed || !l.eventsListeners) return l;
          let o, r, u;
          return (
            typeof i[0] == 'string' || Array.isArray(i[0])
              ? ((o = i[0]), (r = i.slice(1, i.length)), (u = l))
              : ((o = i[0].events), (r = i[0].data), (u = i[0].context || l)),
            r.unshift(u),
            (Array.isArray(o) ? o : o.split(' ')).forEach(p => {
              (l.eventsAnyListeners &&
                l.eventsAnyListeners.length &&
                l.eventsAnyListeners.forEach(h => {
                  h.apply(u, [p, ...r]);
                }),
                l.eventsListeners &&
                  l.eventsListeners[p] &&
                  l.eventsListeners[p].forEach(h => {
                    h.apply(u, r);
                  }));
            }),
            l
          );
        },
      };
      function hC() {
        const i = this;
        let l, o;
        const r = i.el;
        (typeof i.params.width < 'u' && i.params.width !== null
          ? (l = i.params.width)
          : (l = r.clientWidth),
          typeof i.params.height < 'u' && i.params.height !== null
            ? (o = i.params.height)
            : (o = r.clientHeight),
          !((l === 0 && i.isHorizontal()) || (o === 0 && i.isVertical())) &&
            ((l =
              l -
              parseInt(ki(r, 'padding-left') || 0, 10) -
              parseInt(ki(r, 'padding-right') || 0, 10)),
            (o =
              o -
              parseInt(ki(r, 'padding-top') || 0, 10) -
              parseInt(ki(r, 'padding-bottom') || 0, 10)),
            Number.isNaN(l) && (l = 0),
            Number.isNaN(o) && (o = 0),
            Object.assign(i, {
              width: l,
              height: o,
              size: i.isHorizontal() ? l : o,
            })));
      }
      function gC() {
        const i = this;
        function l(ee, q) {
          return parseFloat(ee.getPropertyValue(i.getDirectionLabel(q)) || 0);
        }
        const o = i.params,
          { wrapperEl: r, slidesEl: u, rtlTranslate: d, wrongRTL: p } = i,
          h = i.virtual && o.virtual.enabled,
          m = h ? i.virtual.slides.length : i.slides.length,
          y = Sa(u, `.${i.params.slideClass}, swiper-slide`),
          E = h ? i.virtual.slides.length : y.length;
        let v = [];
        const S = [],
          x = [];
        let D = o.slidesOffsetBefore;
        typeof D == 'function' && (D = o.slidesOffsetBefore.call(i));
        let M = o.slidesOffsetAfter;
        typeof M == 'function' && (M = o.slidesOffsetAfter.call(i));
        const k = i.snapGrid.length,
          V = i.slidesGrid.length,
          L = i.size - D - M;
        let U = o.spaceBetween,
          Y = -D,
          G = 0,
          P = 0;
        if (typeof L > 'u') return;
        (typeof U == 'string' && U.indexOf('%') >= 0
          ? (U = (parseFloat(U.replace('%', '')) / 100) * L)
          : typeof U == 'string' && (U = parseFloat(U)),
          (i.virtualSize = -U - D - M),
          y.forEach(ee => {
            (d ? (ee.style.marginLeft = '') : (ee.style.marginRight = ''),
              (ee.style.marginBottom = ''),
              (ee.style.marginTop = ''));
          }),
          o.centeredSlides &&
            o.cssMode &&
            (vu(r, '--swiper-centered-offset-before', ''),
            vu(r, '--swiper-centered-offset-after', '')));
        const Q = o.grid && o.grid.rows > 1 && i.grid;
        Q ? i.grid.initSlides(y) : i.grid && i.grid.unsetSlides();
        let X;
        const J =
          o.slidesPerView === 'auto' &&
          o.breakpoints &&
          Object.keys(o.breakpoints).filter(
            ee => typeof o.breakpoints[ee].slidesPerView < 'u'
          ).length > 0;
        for (let ee = 0; ee < E; ee += 1) {
          X = 0;
          const q = y[ee];
          if (
            !(
              q &&
              (Q && i.grid.updateSlide(ee, q, y), ki(q, 'display') === 'none')
            )
          ) {
            if (h && o.slidesPerView === 'auto')
              (o.virtual.slidesPerViewAutoSlideSize &&
                (X = o.virtual.slidesPerViewAutoSlideSize),
                X &&
                  q &&
                  (o.roundLengths && (X = Math.floor(X)),
                  (q.style[i.getDirectionLabel('width')] = `${X}px`)));
            else if (o.slidesPerView === 'auto') {
              J && (q.style[i.getDirectionLabel('width')] = '');
              const se = getComputedStyle(q),
                ge = q.style.transform,
                we = q.style.webkitTransform;
              if (
                (ge && (q.style.transform = 'none'),
                we && (q.style.webkitTransform = 'none'),
                o.roundLengths)
              )
                X = i.isHorizontal() ? M0(q, 'width') : M0(q, 'height');
              else {
                const We = l(se, 'width'),
                  K = l(se, 'padding-left'),
                  ce = l(se, 'padding-right'),
                  F = l(se, 'margin-left'),
                  me = l(se, 'margin-right'),
                  W = se.getPropertyValue('box-sizing');
                if (W && W === 'border-box') X = We + F + me;
                else {
                  const { clientWidth: re, offsetWidth: ue } = q;
                  X = We + K + ce + F + me + (ue - re);
                }
              }
              (ge && (q.style.transform = ge),
                we && (q.style.webkitTransform = we),
                o.roundLengths && (X = Math.floor(X)));
            } else
              ((X = (L - (o.slidesPerView - 1) * U) / o.slidesPerView),
                o.roundLengths && (X = Math.floor(X)),
                q && (q.style[i.getDirectionLabel('width')] = `${X}px`));
            (q && (q.swiperSlideSize = X),
              x.push(X),
              o.centeredSlides
                ? ((Y = Y + X / 2 + G / 2 + U),
                  G === 0 && ee !== 0 && (Y = Y - L / 2 - U),
                  ee === 0 && (Y = Y - L / 2 - U),
                  Math.abs(Y) < 1 / 1e3 && (Y = 0),
                  o.roundLengths && (Y = Math.floor(Y)),
                  P % o.slidesPerGroup === 0 && v.push(Y),
                  S.push(Y))
                : (o.roundLengths && (Y = Math.floor(Y)),
                  (P - Math.min(i.params.slidesPerGroupSkip, P)) %
                    i.params.slidesPerGroup ===
                    0 && v.push(Y),
                  S.push(Y),
                  (Y = Y + X + U)),
              (i.virtualSize += X + U),
              (G = X),
              (P += 1));
          }
        }
        if (
          ((i.virtualSize = Math.max(i.virtualSize, L) + M),
          d &&
            p &&
            (o.effect === 'slide' || o.effect === 'coverflow') &&
            (r.style.width = `${i.virtualSize + U}px`),
          o.setWrapperSize &&
            (r.style[i.getDirectionLabel('width')] = `${i.virtualSize + U}px`),
          Q && i.grid.updateWrapperSize(X, v),
          !o.centeredSlides)
        ) {
          const ee = [];
          for (let q = 0; q < v.length; q += 1) {
            let se = v[q];
            (o.roundLengths && (se = Math.floor(se)),
              v[q] <= i.virtualSize - L && ee.push(se));
          }
          ((v = ee),
            Math.floor(i.virtualSize - L) - Math.floor(v[v.length - 1]) > 1 &&
              v.push(i.virtualSize - L));
        }
        if (h && o.loop) {
          const ee = x[0] + U;
          if (o.slidesPerGroup > 1) {
            const q = Math.ceil(
                (i.virtual.slidesBefore + i.virtual.slidesAfter) /
                  o.slidesPerGroup
              ),
              se = ee * o.slidesPerGroup;
            for (let ge = 0; ge < q; ge += 1) v.push(v[v.length - 1] + se);
          }
          for (
            let q = 0;
            q < i.virtual.slidesBefore + i.virtual.slidesAfter;
            q += 1
          )
            (o.slidesPerGroup === 1 && v.push(v[v.length - 1] + ee),
              S.push(S[S.length - 1] + ee),
              (i.virtualSize += ee));
        }
        if ((v.length === 0 && (v = [0]), U !== 0)) {
          const ee =
            i.isHorizontal() && d
              ? 'marginLeft'
              : i.getDirectionLabel('marginRight');
          y.filter((q, se) =>
            !o.cssMode || o.loop ? !0 : se !== y.length - 1
          ).forEach(q => {
            q.style[ee] = `${U}px`;
          });
        }
        if (o.centeredSlides && o.centeredSlidesBounds) {
          let ee = 0;
          (x.forEach(se => {
            ee += se + (U || 0);
          }),
            (ee -= U));
          const q = ee > L ? ee - L : 0;
          v = v.map(se => (se <= 0 ? -D : se > q ? q + M : se));
        }
        if (o.centerInsufficientSlides) {
          let ee = 0;
          (x.forEach(se => {
            ee += se + (U || 0);
          }),
            (ee -= U));
          const q = (D || 0) + (M || 0);
          if (ee + q < L) {
            const se = (L - ee - q) / 2;
            (v.forEach((ge, we) => {
              v[we] = ge - se;
            }),
              S.forEach((ge, we) => {
                S[we] = ge + se;
              }));
          }
        }
        if (
          (Object.assign(i, {
            slides: y,
            snapGrid: v,
            slidesGrid: S,
            slidesSizesGrid: x,
          }),
          o.centeredSlides && o.cssMode && !o.centeredSlidesBounds)
        ) {
          (vu(r, '--swiper-centered-offset-before', `${-v[0]}px`),
            vu(
              r,
              '--swiper-centered-offset-after',
              `${i.size / 2 - x[x.length - 1] / 2}px`
            ));
          const ee = -i.snapGrid[0],
            q = -i.slidesGrid[0];
          ((i.snapGrid = i.snapGrid.map(se => se + ee)),
            (i.slidesGrid = i.slidesGrid.map(se => se + q)));
        }
        if (
          (E !== m && i.emit('slidesLengthChange'),
          v.length !== k &&
            (i.params.watchOverflow && i.checkOverflow(),
            i.emit('snapGridLengthChange')),
          S.length !== V && i.emit('slidesGridLengthChange'),
          o.watchSlidesProgress && i.updateSlidesOffset(),
          i.emit('slidesUpdated'),
          !h && !o.cssMode && (o.effect === 'slide' || o.effect === 'fade'))
        ) {
          const ee = `${o.containerModifierClass}backface-hidden`,
            q = i.el.classList.contains(ee);
          E <= o.maxBackfaceHiddenSlides
            ? q || i.el.classList.add(ee)
            : q && i.el.classList.remove(ee);
        }
      }
      function bC(i) {
        const l = this,
          o = [],
          r = l.virtual && l.params.virtual.enabled;
        let u = 0,
          d;
        typeof i == 'number'
          ? l.setTransition(i)
          : i === !0 && l.setTransition(l.params.speed);
        const p = h => (r ? l.slides[l.getSlideIndexByData(h)] : l.slides[h]);
        if (l.params.slidesPerView !== 'auto' && l.params.slidesPerView > 1)
          if (l.params.centeredSlides)
            (l.visibleSlides || []).forEach(h => {
              o.push(h);
            });
          else
            for (d = 0; d < Math.ceil(l.params.slidesPerView); d += 1) {
              const h = l.activeIndex + d;
              if (h > l.slides.length && !r) break;
              o.push(p(h));
            }
        else o.push(p(l.activeIndex));
        for (d = 0; d < o.length; d += 1)
          if (typeof o[d] < 'u') {
            const h = o[d].offsetHeight;
            u = h > u ? h : u;
          }
        (u || u === 0) && (l.wrapperEl.style.height = `${u}px`);
      }
      function yC() {
        const i = this,
          l = i.slides,
          o = i.isElement
            ? i.isHorizontal()
              ? i.wrapperEl.offsetLeft
              : i.wrapperEl.offsetTop
            : 0;
        for (let r = 0; r < l.length; r += 1)
          l[r].swiperSlideOffset =
            (i.isHorizontal() ? l[r].offsetLeft : l[r].offsetTop) -
            o -
            i.cssOverflowAdjustment();
      }
      const O0 = (i, l, o) => {
        l && !i.classList.contains(o)
          ? i.classList.add(o)
          : !l && i.classList.contains(o) && i.classList.remove(o);
      };
      function vC(i = (this && this.translate) || 0) {
        const l = this,
          o = l.params,
          { slides: r, rtlTranslate: u, snapGrid: d } = l;
        if (r.length === 0) return;
        typeof r[0].swiperSlideOffset > 'u' && l.updateSlidesOffset();
        let p = -i;
        (u && (p = i), (l.visibleSlidesIndexes = []), (l.visibleSlides = []));
        let h = o.spaceBetween;
        typeof h == 'string' && h.indexOf('%') >= 0
          ? (h = (parseFloat(h.replace('%', '')) / 100) * l.size)
          : typeof h == 'string' && (h = parseFloat(h));
        for (let m = 0; m < r.length; m += 1) {
          const y = r[m];
          let E = y.swiperSlideOffset;
          o.cssMode && o.centeredSlides && (E -= r[0].swiperSlideOffset);
          const v =
              (p + (o.centeredSlides ? l.minTranslate() : 0) - E) /
              (y.swiperSlideSize + h),
            S =
              (p - d[0] + (o.centeredSlides ? l.minTranslate() : 0) - E) /
              (y.swiperSlideSize + h),
            x = -(p - E),
            D = x + l.slidesSizesGrid[m],
            M = x >= 0 && x <= l.size - l.slidesSizesGrid[m],
            k =
              (x >= 0 && x < l.size - 1) ||
              (D > 1 && D <= l.size) ||
              (x <= 0 && D >= l.size);
          (k && (l.visibleSlides.push(y), l.visibleSlidesIndexes.push(m)),
            O0(y, k, o.slideVisibleClass),
            O0(y, M, o.slideFullyVisibleClass),
            (y.progress = u ? -v : v),
            (y.originalProgress = u ? -S : S));
        }
      }
      function SC(i) {
        const l = this;
        if (typeof i > 'u') {
          const E = l.rtlTranslate ? -1 : 1;
          i = (l && l.translate && l.translate * E) || 0;
        }
        const o = l.params,
          r = l.maxTranslate() - l.minTranslate();
        let { progress: u, isBeginning: d, isEnd: p, progressLoop: h } = l;
        const m = d,
          y = p;
        if (r === 0) ((u = 0), (d = !0), (p = !0));
        else {
          u = (i - l.minTranslate()) / r;
          const E = Math.abs(i - l.minTranslate()) < 1,
            v = Math.abs(i - l.maxTranslate()) < 1;
          ((d = E || u <= 0), (p = v || u >= 1), E && (u = 0), v && (u = 1));
        }
        if (o.loop) {
          const E = l.getSlideIndexByData(0),
            v = l.getSlideIndexByData(l.slides.length - 1),
            S = l.slidesGrid[E],
            x = l.slidesGrid[v],
            D = l.slidesGrid[l.slidesGrid.length - 1],
            M = Math.abs(i);
          (M >= S ? (h = (M - S) / D) : (h = (M + D - x) / D),
            h > 1 && (h -= 1));
        }
        (Object.assign(l, {
          progress: u,
          progressLoop: h,
          isBeginning: d,
          isEnd: p,
        }),
          (o.watchSlidesProgress || (o.centeredSlides && o.autoHeight)) &&
            l.updateSlidesProgress(i),
          d && !m && l.emit('reachBeginning toEdge'),
          p && !y && l.emit('reachEnd toEdge'),
          ((m && !d) || (y && !p)) && l.emit('fromEdge'),
          l.emit('progress', u));
      }
      const gp = (i, l, o) => {
        l && !i.classList.contains(o)
          ? i.classList.add(o)
          : !l && i.classList.contains(o) && i.classList.remove(o);
      };
      function xC() {
        const i = this,
          { slides: l, params: o, slidesEl: r, activeIndex: u } = i,
          d = i.virtual && o.virtual.enabled,
          p = i.grid && o.grid && o.grid.rows > 1,
          h = v => Sa(r, `.${o.slideClass}${v}, swiper-slide${v}`)[0];
        let m, y, E;
        if (d)
          if (o.loop) {
            let v = u - i.virtual.slidesBefore;
            (v < 0 && (v = i.virtual.slides.length + v),
              v >= i.virtual.slides.length && (v -= i.virtual.slides.length),
              (m = h(`[data-swiper-slide-index="${v}"]`)));
          } else m = h(`[data-swiper-slide-index="${u}"]`);
        else
          p
            ? ((m = l.find(v => v.column === u)),
              (E = l.find(v => v.column === u + 1)),
              (y = l.find(v => v.column === u - 1)))
            : (m = l[u]);
        (m &&
          (p ||
            ((E = oC(m, `.${o.slideClass}, swiper-slide`)[0]),
            o.loop && !E && (E = l[0]),
            (y = sC(m, `.${o.slideClass}, swiper-slide`)[0]),
            o.loop && !y === 0 && (y = l[l.length - 1]))),
          l.forEach(v => {
            (gp(v, v === m, o.slideActiveClass),
              gp(v, v === E, o.slideNextClass),
              gp(v, v === y, o.slidePrevClass));
          }),
          i.emitSlidesClasses());
      }
      const Su = (i, l) => {
          if (!i || i.destroyed || !i.params) return;
          const o = () =>
              i.isElement ? 'swiper-slide' : `.${i.params.slideClass}`,
            r = l.closest(o());
          if (r) {
            let u = r.querySelector(`.${i.params.lazyPreloaderClass}`);
            (!u &&
              i.isElement &&
              (r.shadowRoot
                ? (u = r.shadowRoot.querySelector(
                    `.${i.params.lazyPreloaderClass}`
                  ))
                : requestAnimationFrame(() => {
                    r.shadowRoot &&
                      ((u = r.shadowRoot.querySelector(
                        `.${i.params.lazyPreloaderClass}`
                      )),
                      u && u.remove());
                  })),
              u && u.remove());
          }
        },
        bp = (i, l) => {
          if (!i.slides[l]) return;
          const o = i.slides[l].querySelector('[loading="lazy"]');
          o && o.removeAttribute('loading');
        },
        Mp = i => {
          if (!i || i.destroyed || !i.params) return;
          let l = i.params.lazyPreloadPrevNext;
          const o = i.slides.length;
          if (!o || !l || l < 0) return;
          l = Math.min(l, o);
          const r =
              i.params.slidesPerView === 'auto'
                ? i.slidesPerViewDynamic()
                : Math.ceil(i.params.slidesPerView),
            u = i.activeIndex;
          if (i.params.grid && i.params.grid.rows > 1) {
            const p = u,
              h = [p - l];
            (h.push(...Array.from({ length: l }).map((m, y) => p + r + y)),
              i.slides.forEach((m, y) => {
                h.includes(m.column) && bp(i, y);
              }));
            return;
          }
          const d = u + r - 1;
          if (i.params.rewind || i.params.loop)
            for (let p = u - l; p <= d + l; p += 1) {
              const h = ((p % o) + o) % o;
              (h < u || h > d) && bp(i, h);
            }
          else
            for (
              let p = Math.max(u - l, 0);
              p <= Math.min(d + l, o - 1);
              p += 1
            )
              p !== u && (p > d || p < u) && bp(i, p);
        };
      function NC(i) {
        const { slidesGrid: l, params: o } = i,
          r = i.rtlTranslate ? i.translate : -i.translate;
        let u;
        for (let d = 0; d < l.length; d += 1)
          typeof l[d + 1] < 'u'
            ? r >= l[d] && r < l[d + 1] - (l[d + 1] - l[d]) / 2
              ? (u = d)
              : r >= l[d] && r < l[d + 1] && (u = d + 1)
            : r >= l[d] && (u = d);
        return (
          o.normalizeSlideIndex && (u < 0 || typeof u > 'u') && (u = 0),
          u
        );
      }
      function wC(i) {
        const l = this,
          o = l.rtlTranslate ? l.translate : -l.translate,
          {
            snapGrid: r,
            params: u,
            activeIndex: d,
            realIndex: p,
            snapIndex: h,
          } = l;
        let m = i,
          y;
        const E = x => {
          let D = x - l.virtual.slidesBefore;
          return (
            D < 0 && (D = l.virtual.slides.length + D),
            D >= l.virtual.slides.length && (D -= l.virtual.slides.length),
            D
          );
        };
        if ((typeof m > 'u' && (m = NC(l)), r.indexOf(o) >= 0))
          y = r.indexOf(o);
        else {
          const x = Math.min(u.slidesPerGroupSkip, m);
          y = x + Math.floor((m - x) / u.slidesPerGroup);
        }
        if ((y >= r.length && (y = r.length - 1), m === d && !l.params.loop)) {
          y !== h && ((l.snapIndex = y), l.emit('snapIndexChange'));
          return;
        }
        if (m === d && l.params.loop && l.virtual && l.params.virtual.enabled) {
          l.realIndex = E(m);
          return;
        }
        const v = l.grid && u.grid && u.grid.rows > 1;
        let S;
        if (l.virtual && u.virtual.enabled && u.loop) S = E(m);
        else if (v) {
          const x = l.slides.find(M => M.column === m);
          let D = parseInt(x.getAttribute('data-swiper-slide-index'), 10);
          (Number.isNaN(D) && (D = Math.max(l.slides.indexOf(x), 0)),
            (S = Math.floor(D / u.grid.rows)));
        } else if (l.slides[m]) {
          const x = l.slides[m].getAttribute('data-swiper-slide-index');
          x ? (S = parseInt(x, 10)) : (S = m);
        } else S = m;
        (Object.assign(l, {
          previousSnapIndex: h,
          snapIndex: y,
          previousRealIndex: p,
          realIndex: S,
          previousIndex: d,
          activeIndex: m,
        }),
          l.initialized && Mp(l),
          l.emit('activeIndexChange'),
          l.emit('snapIndexChange'),
          (l.initialized || l.params.runCallbacksOnInit) &&
            (p !== S && l.emit('realIndexChange'), l.emit('slideChange')));
      }
      function EC(i, l) {
        const o = this,
          r = o.params;
        let u = i.closest(`.${r.slideClass}, swiper-slide`);
        !u &&
          o.isElement &&
          l &&
          l.length > 1 &&
          l.includes(i) &&
          [...l.slice(l.indexOf(i) + 1, l.length)].forEach(h => {
            !u &&
              h.matches &&
              h.matches(`.${r.slideClass}, swiper-slide`) &&
              (u = h);
          });
        let d = !1,
          p;
        if (u) {
          for (let h = 0; h < o.slides.length; h += 1)
            if (o.slides[h] === u) {
              ((d = !0), (p = h));
              break;
            }
        }
        if (u && d)
          ((o.clickedSlide = u),
            o.virtual && o.params.virtual.enabled
              ? (o.clickedIndex = parseInt(
                  u.getAttribute('data-swiper-slide-index'),
                  10
                ))
              : (o.clickedIndex = p));
        else {
          ((o.clickedSlide = void 0), (o.clickedIndex = void 0));
          return;
        }
        r.slideToClickedSlide &&
          o.clickedIndex !== void 0 &&
          o.clickedIndex !== o.activeIndex &&
          o.slideToClickedSlide();
      }
      var DC = {
        updateSize: hC,
        updateSlides: gC,
        updateAutoHeight: bC,
        updateSlidesOffset: yC,
        updateSlidesProgress: vC,
        updateProgress: SC,
        updateSlidesClasses: xC,
        updateActiveIndex: wC,
        updateClickedSlide: EC,
      };
      function TC(i = this.isHorizontal() ? 'x' : 'y') {
        const l = this,
          { params: o, rtlTranslate: r, translate: u, wrapperEl: d } = l;
        if (o.virtualTranslate) return r ? -u : u;
        if (o.cssMode) return u;
        let p = nC(d, i);
        return ((p += l.cssOverflowAdjustment()), r && (p = -p), p || 0);
      }
      function CC(i, l) {
        const o = this,
          { rtlTranslate: r, params: u, wrapperEl: d, progress: p } = o;
        let h = 0,
          m = 0;
        const y = 0;
        (o.isHorizontal() ? (h = r ? -i : i) : (m = i),
          u.roundLengths && ((h = Math.floor(h)), (m = Math.floor(m))),
          (o.previousTranslate = o.translate),
          (o.translate = o.isHorizontal() ? h : m),
          u.cssMode
            ? (d[o.isHorizontal() ? 'scrollLeft' : 'scrollTop'] =
                o.isHorizontal() ? -h : -m)
            : u.virtualTranslate ||
              (o.isHorizontal()
                ? (h -= o.cssOverflowAdjustment())
                : (m -= o.cssOverflowAdjustment()),
              (d.style.transform = `translate3d(${h}px, ${m}px, ${y}px)`)));
        let E;
        const v = o.maxTranslate() - o.minTranslate();
        (v === 0 ? (E = 0) : (E = (i - o.minTranslate()) / v),
          E !== p && o.updateProgress(i),
          o.emit('setTranslate', o.translate, l));
      }
      function AC() {
        return -this.snapGrid[0];
      }
      function RC() {
        return -this.snapGrid[this.snapGrid.length - 1];
      }
      function MC(i = 0, l = this.params.speed, o = !0, r = !0, u) {
        const d = this,
          { params: p, wrapperEl: h } = d;
        if (d.animating && p.preventInteractionOnTransition) return !1;
        const m = d.minTranslate(),
          y = d.maxTranslate();
        let E;
        if (
          (r && i > m ? (E = m) : r && i < y ? (E = y) : (E = i),
          d.updateProgress(E),
          p.cssMode)
        ) {
          const v = d.isHorizontal();
          if (l === 0) h[v ? 'scrollLeft' : 'scrollTop'] = -E;
          else {
            if (!d.support.smoothScroll)
              return (
                J0({ swiper: d, targetPosition: -E, side: v ? 'left' : 'top' }),
                !0
              );
            h.scrollTo({ [v ? 'left' : 'top']: -E, behavior: 'smooth' });
          }
          return !0;
        }
        return (
          l === 0
            ? (d.setTransition(0),
              d.setTranslate(E),
              o &&
                (d.emit('beforeTransitionStart', l, u),
                d.emit('transitionEnd')))
            : (d.setTransition(l),
              d.setTranslate(E),
              o &&
                (d.emit('beforeTransitionStart', l, u),
                d.emit('transitionStart')),
              d.animating ||
                ((d.animating = !0),
                d.onTranslateToWrapperTransitionEnd ||
                  (d.onTranslateToWrapperTransitionEnd = function (S) {
                    !d ||
                      d.destroyed ||
                      (S.target === this &&
                        (d.wrapperEl.removeEventListener(
                          'transitionend',
                          d.onTranslateToWrapperTransitionEnd
                        ),
                        (d.onTranslateToWrapperTransitionEnd = null),
                        delete d.onTranslateToWrapperTransitionEnd,
                        (d.animating = !1),
                        o && d.emit('transitionEnd')));
                  }),
                d.wrapperEl.addEventListener(
                  'transitionend',
                  d.onTranslateToWrapperTransitionEnd
                ))),
          !0
        );
      }
      var OC = {
        getTranslate: TC,
        setTranslate: CC,
        minTranslate: AC,
        maxTranslate: RC,
        translateTo: MC,
      };
      function kC(i, l) {
        const o = this;
        (o.params.cssMode ||
          ((o.wrapperEl.style.transitionDuration = `${i}ms`),
          (o.wrapperEl.style.transitionDelay = i === 0 ? '0ms' : '')),
          o.emit('setTransition', i, l));
      }
      function aS({ swiper: i, runCallbacks: l, direction: o, step: r }) {
        const { activeIndex: u, previousIndex: d } = i;
        let p = o;
        (p || (u > d ? (p = 'next') : u < d ? (p = 'prev') : (p = 'reset')),
          i.emit(`transition${r}`),
          l && p === 'reset'
            ? i.emit(`slideResetTransition${r}`)
            : l &&
              u !== d &&
              (i.emit(`slideChangeTransition${r}`),
              p === 'next'
                ? i.emit(`slideNextTransition${r}`)
                : i.emit(`slidePrevTransition${r}`)));
      }
      function _C(i = !0, l) {
        const o = this,
          { params: r } = o;
        r.cssMode ||
          (r.autoHeight && o.updateAutoHeight(),
          aS({ swiper: o, runCallbacks: i, direction: l, step: 'Start' }));
      }
      function jC(i = !0, l) {
        const o = this,
          { params: r } = o;
        ((o.animating = !1),
          !r.cssMode &&
            (o.setTransition(0),
            aS({ swiper: o, runCallbacks: i, direction: l, step: 'End' })));
      }
      var VC = { setTransition: kC, transitionStart: _C, transitionEnd: jC };
      function BC(i = 0, l, o = !0, r, u) {
        typeof i == 'string' && (i = parseInt(i, 10));
        const d = this;
        let p = i;
        p < 0 && (p = 0);
        const {
          params: h,
          snapGrid: m,
          slidesGrid: y,
          previousIndex: E,
          activeIndex: v,
          rtlTranslate: S,
          wrapperEl: x,
          enabled: D,
        } = d;
        if (
          (!D && !r && !u) ||
          d.destroyed ||
          (d.animating && h.preventInteractionOnTransition)
        )
          return !1;
        typeof l > 'u' && (l = d.params.speed);
        const M = Math.min(d.params.slidesPerGroupSkip, p);
        let k = M + Math.floor((p - M) / d.params.slidesPerGroup);
        k >= m.length && (k = m.length - 1);
        const V = -m[k];
        if (h.normalizeSlideIndex)
          for (let Q = 0; Q < y.length; Q += 1) {
            const X = -Math.floor(V * 100),
              J = Math.floor(y[Q] * 100),
              ee = Math.floor(y[Q + 1] * 100);
            typeof y[Q + 1] < 'u'
              ? X >= J && X < ee - (ee - J) / 2
                ? (p = Q)
                : X >= J && X < ee && (p = Q + 1)
              : X >= J && (p = Q);
          }
        if (
          d.initialized &&
          p !== v &&
          ((!d.allowSlideNext &&
            (S
              ? V > d.translate && V > d.minTranslate()
              : V < d.translate && V < d.minTranslate())) ||
            (!d.allowSlidePrev &&
              V > d.translate &&
              V > d.maxTranslate() &&
              (v || 0) !== p))
        )
          return !1;
        (p !== (E || 0) && o && d.emit('beforeSlideChangeStart'),
          d.updateProgress(V));
        let L;
        p > v ? (L = 'next') : p < v ? (L = 'prev') : (L = 'reset');
        const U = d.virtual && d.params.virtual.enabled;
        if (
          !(U && u) &&
          ((S && -V === d.translate) || (!S && V === d.translate))
        )
          return (
            d.updateActiveIndex(p),
            h.autoHeight && d.updateAutoHeight(),
            d.updateSlidesClasses(),
            h.effect !== 'slide' && d.setTranslate(V),
            L !== 'reset' && (d.transitionStart(o, L), d.transitionEnd(o, L)),
            !1
          );
        if (h.cssMode) {
          const Q = d.isHorizontal(),
            X = S ? V : -V;
          if (l === 0)
            (U &&
              ((d.wrapperEl.style.scrollSnapType = 'none'),
              (d._immediateVirtual = !0)),
              U && !d._cssModeVirtualInitialSet && d.params.initialSlide > 0
                ? ((d._cssModeVirtualInitialSet = !0),
                  requestAnimationFrame(() => {
                    x[Q ? 'scrollLeft' : 'scrollTop'] = X;
                  }))
                : (x[Q ? 'scrollLeft' : 'scrollTop'] = X),
              U &&
                requestAnimationFrame(() => {
                  ((d.wrapperEl.style.scrollSnapType = ''),
                    (d._immediateVirtual = !1));
                }));
          else {
            if (!d.support.smoothScroll)
              return (
                J0({ swiper: d, targetPosition: X, side: Q ? 'left' : 'top' }),
                !0
              );
            x.scrollTo({ [Q ? 'left' : 'top']: X, behavior: 'smooth' });
          }
          return !0;
        }
        const P = nS().isSafari;
        return (
          U && !u && P && d.isElement && d.virtual.update(!1, !1, p),
          d.setTransition(l),
          d.setTranslate(V),
          d.updateActiveIndex(p),
          d.updateSlidesClasses(),
          d.emit('beforeTransitionStart', l, r),
          d.transitionStart(o, L),
          l === 0
            ? d.transitionEnd(o, L)
            : d.animating ||
              ((d.animating = !0),
              d.onSlideToWrapperTransitionEnd ||
                (d.onSlideToWrapperTransitionEnd = function (X) {
                  !d ||
                    d.destroyed ||
                    (X.target === this &&
                      (d.wrapperEl.removeEventListener(
                        'transitionend',
                        d.onSlideToWrapperTransitionEnd
                      ),
                      (d.onSlideToWrapperTransitionEnd = null),
                      delete d.onSlideToWrapperTransitionEnd,
                      d.transitionEnd(o, L)));
                }),
              d.wrapperEl.addEventListener(
                'transitionend',
                d.onSlideToWrapperTransitionEnd
              )),
          !0
        );
      }
      function LC(i = 0, l, o = !0, r) {
        typeof i == 'string' && (i = parseInt(i, 10));
        const u = this;
        if (u.destroyed) return;
        typeof l > 'u' && (l = u.params.speed);
        const d = u.grid && u.params.grid && u.params.grid.rows > 1;
        let p = i;
        if (u.params.loop)
          if (u.virtual && u.params.virtual.enabled)
            p = p + u.virtual.slidesBefore;
          else {
            let h;
            if (d) {
              const M = p * u.params.grid.rows;
              h = u.slides.find(
                k => k.getAttribute('data-swiper-slide-index') * 1 === M
              ).column;
            } else h = u.getSlideIndexByData(p);
            const m = d
                ? Math.ceil(u.slides.length / u.params.grid.rows)
                : u.slides.length,
              {
                centeredSlides: y,
                slidesOffsetBefore: E,
                slidesOffsetAfter: v,
              } = u.params,
              S = y || !!E || !!v;
            let x = u.params.slidesPerView;
            x === 'auto'
              ? (x = u.slidesPerViewDynamic())
              : ((x = Math.ceil(parseFloat(u.params.slidesPerView, 10))),
                S && x % 2 === 0 && (x = x + 1));
            let D = m - h < x;
            if (
              (S && (D = D || h < Math.ceil(x / 2)),
              r && S && u.params.slidesPerView !== 'auto' && !d && (D = !1),
              D)
            ) {
              const M = S
                ? h < u.activeIndex
                  ? 'prev'
                  : 'next'
                : h - u.activeIndex - 1 < u.params.slidesPerView
                  ? 'next'
                  : 'prev';
              u.loopFix({
                direction: M,
                slideTo: !0,
                activeSlideIndex: M === 'next' ? h + 1 : h - m + 1,
                slideRealIndex: M === 'next' ? u.realIndex : void 0,
              });
            }
            if (d) {
              const M = p * u.params.grid.rows;
              p = u.slides.find(
                k => k.getAttribute('data-swiper-slide-index') * 1 === M
              ).column;
            } else p = u.getSlideIndexByData(p);
          }
        return (
          requestAnimationFrame(() => {
            u.slideTo(p, l, o, r);
          }),
          u
        );
      }
      function zC(i, l = !0, o) {
        const r = this,
          { enabled: u, params: d, animating: p } = r;
        if (!u || r.destroyed) return r;
        typeof i > 'u' && (i = r.params.speed);
        let h = d.slidesPerGroup;
        d.slidesPerView === 'auto' &&
          d.slidesPerGroup === 1 &&
          d.slidesPerGroupAuto &&
          (h = Math.max(r.slidesPerViewDynamic('current', !0), 1));
        const m = r.activeIndex < d.slidesPerGroupSkip ? 1 : h,
          y = r.virtual && d.virtual.enabled;
        if (d.loop) {
          if (p && !y && d.loopPreventsSliding) return !1;
          if (
            (r.loopFix({ direction: 'next' }),
            (r._clientLeft = r.wrapperEl.clientLeft),
            r.activeIndex === r.slides.length - 1 && d.cssMode)
          )
            return (
              requestAnimationFrame(() => {
                r.slideTo(r.activeIndex + m, i, l, o);
              }),
              !0
            );
        }
        return d.rewind && r.isEnd
          ? r.slideTo(0, i, l, o)
          : r.slideTo(r.activeIndex + m, i, l, o);
      }
      function HC(i, l = !0, o) {
        const r = this,
          {
            params: u,
            snapGrid: d,
            slidesGrid: p,
            rtlTranslate: h,
            enabled: m,
            animating: y,
          } = r;
        if (!m || r.destroyed) return r;
        typeof i > 'u' && (i = r.params.speed);
        const E = r.virtual && u.virtual.enabled;
        if (u.loop) {
          if (y && !E && u.loopPreventsSliding) return !1;
          (r.loopFix({ direction: 'prev' }),
            (r._clientLeft = r.wrapperEl.clientLeft));
        }
        const v = h ? r.translate : -r.translate;
        function S(L) {
          return L < 0 ? -Math.floor(Math.abs(L)) : Math.floor(L);
        }
        const x = S(v),
          D = d.map(L => S(L)),
          M = u.freeMode && u.freeMode.enabled;
        let k = d[D.indexOf(x) - 1];
        if (typeof k > 'u' && (u.cssMode || M)) {
          let L;
          (d.forEach((U, Y) => {
            x >= U && (L = Y);
          }),
            typeof L < 'u' && (k = M ? d[L] : d[L > 0 ? L - 1 : L]));
        }
        let V = 0;
        if (
          (typeof k < 'u' &&
            ((V = p.indexOf(k)),
            V < 0 && (V = r.activeIndex - 1),
            u.slidesPerView === 'auto' &&
              u.slidesPerGroup === 1 &&
              u.slidesPerGroupAuto &&
              ((V = V - r.slidesPerViewDynamic('previous', !0) + 1),
              (V = Math.max(V, 0)))),
          u.rewind && r.isBeginning)
        ) {
          const L =
            r.params.virtual && r.params.virtual.enabled && r.virtual
              ? r.virtual.slides.length - 1
              : r.slides.length - 1;
          return r.slideTo(L, i, l, o);
        } else if (u.loop && r.activeIndex === 0 && u.cssMode)
          return (
            requestAnimationFrame(() => {
              r.slideTo(V, i, l, o);
            }),
            !0
          );
        return r.slideTo(V, i, l, o);
      }
      function UC(i, l = !0, o) {
        const r = this;
        if (!r.destroyed)
          return (
            typeof i > 'u' && (i = r.params.speed),
            r.slideTo(r.activeIndex, i, l, o)
          );
      }
      function IC(i, l = !0, o, r = 0.5) {
        const u = this;
        if (u.destroyed) return;
        typeof i > 'u' && (i = u.params.speed);
        let d = u.activeIndex;
        const p = Math.min(u.params.slidesPerGroupSkip, d),
          h = p + Math.floor((d - p) / u.params.slidesPerGroup),
          m = u.rtlTranslate ? u.translate : -u.translate;
        if (m >= u.snapGrid[h]) {
          const y = u.snapGrid[h],
            E = u.snapGrid[h + 1];
          m - y > (E - y) * r && (d += u.params.slidesPerGroup);
        } else {
          const y = u.snapGrid[h - 1],
            E = u.snapGrid[h];
          m - y <= (E - y) * r && (d -= u.params.slidesPerGroup);
        }
        return (
          (d = Math.max(d, 0)),
          (d = Math.min(d, u.slidesGrid.length - 1)),
          u.slideTo(d, i, l, o)
        );
      }
      function WC() {
        const i = this;
        if (i.destroyed) return;
        const { params: l, slidesEl: o } = i,
          r =
            l.slidesPerView === 'auto'
              ? i.slidesPerViewDynamic()
              : l.slidesPerView;
        let u = i.getSlideIndexWhenGrid(i.clickedIndex),
          d;
        const p = i.isElement ? 'swiper-slide' : `.${l.slideClass}`,
          h = i.grid && i.params.grid && i.params.grid.rows > 1;
        if (l.loop) {
          if (i.animating) return;
          ((d = parseInt(
            i.clickedSlide.getAttribute('data-swiper-slide-index'),
            10
          )),
            l.centeredSlides
              ? i.slideToLoop(d)
              : u >
                  (h
                    ? (i.slides.length - r) / 2 - (i.params.grid.rows - 1)
                    : i.slides.length - r)
                ? (i.loopFix(),
                  (u = i.getSlideIndex(
                    Sa(o, `${p}[data-swiper-slide-index="${d}"]`)[0]
                  )),
                  K0(() => {
                    i.slideTo(u);
                  }))
                : i.slideTo(u));
        } else i.slideTo(u);
      }
      var $C = {
        slideTo: BC,
        slideToLoop: LC,
        slideNext: zC,
        slidePrev: HC,
        slideReset: UC,
        slideToClosest: IC,
        slideToClickedSlide: WC,
      };
      function PC(i, l) {
        const o = this,
          { params: r, slidesEl: u } = o;
        if (!r.loop || (o.virtual && o.params.virtual.enabled)) return;
        const d = () => {
            Sa(u, `.${r.slideClass}, swiper-slide`).forEach((D, M) => {
              D.setAttribute('data-swiper-slide-index', M);
            });
          },
          p = () => {
            const x = Sa(u, `.${r.slideBlankClass}`);
            (x.forEach(D => {
              D.remove();
            }),
              x.length > 0 && (o.recalcSlides(), o.updateSlides()));
          },
          h = o.grid && r.grid && r.grid.rows > 1;
        r.loopAddBlankSlides && (r.slidesPerGroup > 1 || h) && p();
        const m = r.slidesPerGroup * (h ? r.grid.rows : 1),
          y = o.slides.length % m !== 0,
          E = h && o.slides.length % r.grid.rows !== 0,
          v = x => {
            for (let D = 0; D < x; D += 1) {
              const M = o.isElement
                ? Tu('swiper-slide', [r.slideBlankClass])
                : Tu('div', [r.slideClass, r.slideBlankClass]);
              o.slidesEl.append(M);
            }
          };
        if (y) {
          if (r.loopAddBlankSlides) {
            const x = m - (o.slides.length % m);
            (v(x), o.recalcSlides(), o.updateSlides());
          } else
            Du(
              'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          d();
        } else if (E) {
          if (r.loopAddBlankSlides) {
            const x = r.grid.rows - (o.slides.length % r.grid.rows);
            (v(x), o.recalcSlides(), o.updateSlides());
          } else
            Du(
              'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)'
            );
          d();
        } else d();
        const S =
          r.centeredSlides || !!r.slidesOffsetBefore || !!r.slidesOffsetAfter;
        o.loopFix({
          slideRealIndex: i,
          direction: S ? void 0 : 'next',
          initial: l,
        });
      }
      function GC({
        slideRealIndex: i,
        slideTo: l = !0,
        direction: o,
        setTranslate: r,
        activeSlideIndex: u,
        initial: d,
        byController: p,
        byMousewheel: h,
      } = {}) {
        const m = this;
        if (!m.params.loop) return;
        m.emit('beforeLoopFix');
        const {
            slides: y,
            allowSlidePrev: E,
            allowSlideNext: v,
            slidesEl: S,
            params: x,
          } = m,
          {
            centeredSlides: D,
            slidesOffsetBefore: M,
            slidesOffsetAfter: k,
            initialSlide: V,
          } = x,
          L = D || !!M || !!k;
        if (
          ((m.allowSlidePrev = !0),
          (m.allowSlideNext = !0),
          m.virtual && x.virtual.enabled)
        ) {
          (l &&
            (!L && m.snapIndex === 0
              ? m.slideTo(m.virtual.slides.length, 0, !1, !0)
              : L && m.snapIndex < x.slidesPerView
                ? m.slideTo(m.virtual.slides.length + m.snapIndex, 0, !1, !0)
                : m.snapIndex === m.snapGrid.length - 1 &&
                  m.slideTo(m.virtual.slidesBefore, 0, !1, !0)),
            (m.allowSlidePrev = E),
            (m.allowSlideNext = v),
            m.emit('loopFix'));
          return;
        }
        let U = x.slidesPerView;
        U === 'auto'
          ? (U = m.slidesPerViewDynamic())
          : ((U = Math.ceil(parseFloat(x.slidesPerView, 10))),
            L && U % 2 === 0 && (U = U + 1));
        const Y = x.slidesPerGroupAuto ? U : x.slidesPerGroup;
        let G = L ? Math.max(Y, Math.ceil(U / 2)) : Y;
        (G % Y !== 0 && (G += Y - (G % Y)),
          (G += x.loopAdditionalSlides),
          (m.loopedSlides = G));
        const P = m.grid && x.grid && x.grid.rows > 1;
        y.length < U + G ||
        (m.params.effect === 'cards' && y.length < U + G * 2)
          ? Du(
              'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters'
            )
          : P &&
            x.grid.fill === 'row' &&
            Du(
              'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`'
            );
        const Q = [],
          X = [],
          J = P ? Math.ceil(y.length / x.grid.rows) : y.length,
          ee = d && J - V < U && !L;
        let q = ee ? V : m.activeIndex;
        typeof u > 'u'
          ? (u = m.getSlideIndex(
              y.find(F => F.classList.contains(x.slideActiveClass))
            ))
          : (q = u);
        const se = o === 'next' || !o,
          ge = o === 'prev' || !o;
        let we = 0,
          We = 0;
        const ce =
          (P ? y[u].column : u) + (L && typeof r > 'u' ? -U / 2 + 0.5 : 0);
        if (ce < G) {
          we = Math.max(G - ce, Y);
          for (let F = 0; F < G - ce; F += 1) {
            const me = F - Math.floor(F / J) * J;
            if (P) {
              const W = J - me - 1;
              for (let re = y.length - 1; re >= 0; re -= 1)
                y[re].column === W && Q.push(re);
            } else Q.push(J - me - 1);
          }
        } else if (ce + U > J - G) {
          ((We = Math.max(ce - (J - G * 2), Y)),
            ee && (We = Math.max(We, U - J + V + 1)));
          for (let F = 0; F < We; F += 1) {
            const me = F - Math.floor(F / J) * J;
            P
              ? y.forEach((W, re) => {
                  W.column === me && X.push(re);
                })
              : X.push(me);
          }
        }
        if (
          ((m.__preventObserver__ = !0),
          requestAnimationFrame(() => {
            m.__preventObserver__ = !1;
          }),
          m.params.effect === 'cards' &&
            y.length < U + G * 2 &&
            (X.includes(u) && X.splice(X.indexOf(u), 1),
            Q.includes(u) && Q.splice(Q.indexOf(u), 1)),
          ge &&
            Q.forEach(F => {
              ((y[F].swiperLoopMoveDOM = !0),
                S.prepend(y[F]),
                (y[F].swiperLoopMoveDOM = !1));
            }),
          se &&
            X.forEach(F => {
              ((y[F].swiperLoopMoveDOM = !0),
                S.append(y[F]),
                (y[F].swiperLoopMoveDOM = !1));
            }),
          m.recalcSlides(),
          x.slidesPerView === 'auto'
            ? m.updateSlides()
            : P &&
              ((Q.length > 0 && ge) || (X.length > 0 && se)) &&
              m.slides.forEach((F, me) => {
                m.grid.updateSlide(me, F, m.slides);
              }),
          x.watchSlidesProgress && m.updateSlidesOffset(),
          l)
        ) {
          if (Q.length > 0 && ge) {
            if (typeof i > 'u') {
              const F = m.slidesGrid[q],
                W = m.slidesGrid[q + we] - F;
              h
                ? m.setTranslate(m.translate - W)
                : (m.slideTo(q + Math.ceil(we), 0, !1, !0),
                  r &&
                    ((m.touchEventsData.startTranslate =
                      m.touchEventsData.startTranslate - W),
                    (m.touchEventsData.currentTranslate =
                      m.touchEventsData.currentTranslate - W)));
            } else if (r) {
              const F = P ? Q.length / x.grid.rows : Q.length;
              (m.slideTo(m.activeIndex + F, 0, !1, !0),
                (m.touchEventsData.currentTranslate = m.translate));
            }
          } else if (X.length > 0 && se)
            if (typeof i > 'u') {
              const F = m.slidesGrid[q],
                W = m.slidesGrid[q - We] - F;
              h
                ? m.setTranslate(m.translate - W)
                : (m.slideTo(q - We, 0, !1, !0),
                  r &&
                    ((m.touchEventsData.startTranslate =
                      m.touchEventsData.startTranslate - W),
                    (m.touchEventsData.currentTranslate =
                      m.touchEventsData.currentTranslate - W)));
            } else {
              const F = P ? X.length / x.grid.rows : X.length;
              m.slideTo(m.activeIndex - F, 0, !1, !0);
            }
        }
        if (
          ((m.allowSlidePrev = E),
          (m.allowSlideNext = v),
          m.controller && m.controller.control && !p)
        ) {
          const F = {
            slideRealIndex: i,
            direction: o,
            setTranslate: r,
            activeSlideIndex: u,
            byController: !0,
          };
          Array.isArray(m.controller.control)
            ? m.controller.control.forEach(me => {
                !me.destroyed &&
                  me.params.loop &&
                  me.loopFix({
                    ...F,
                    slideTo:
                      me.params.slidesPerView === x.slidesPerView ? l : !1,
                  });
              })
            : m.controller.control instanceof m.constructor &&
              m.controller.control.params.loop &&
              m.controller.control.loopFix({
                ...F,
                slideTo:
                  m.controller.control.params.slidesPerView === x.slidesPerView
                    ? l
                    : !1,
              });
        }
        m.emit('loopFix');
      }
      function qC() {
        const i = this,
          { params: l, slidesEl: o } = i;
        if (!l.loop || !o || (i.virtual && i.params.virtual.enabled)) return;
        i.recalcSlides();
        const r = [];
        (i.slides.forEach(u => {
          const d =
            typeof u.swiperSlideIndex > 'u'
              ? u.getAttribute('data-swiper-slide-index') * 1
              : u.swiperSlideIndex;
          r[d] = u;
        }),
          i.slides.forEach(u => {
            u.removeAttribute('data-swiper-slide-index');
          }),
          r.forEach(u => {
            o.append(u);
          }),
          i.recalcSlides(),
          i.slideTo(i.realIndex, 0));
      }
      var YC = { loopCreate: PC, loopFix: GC, loopDestroy: qC };
      function XC(i) {
        const l = this;
        if (
          !l.params.simulateTouch ||
          (l.params.watchOverflow && l.isLocked) ||
          l.params.cssMode
        )
          return;
        const o =
          l.params.touchEventsTarget === 'container' ? l.el : l.wrapperEl;
        (l.isElement && (l.__preventObserver__ = !0),
          (o.style.cursor = 'move'),
          (o.style.cursor = i ? 'grabbing' : 'grab'),
          l.isElement &&
            requestAnimationFrame(() => {
              l.__preventObserver__ = !1;
            }));
      }
      function QC() {
        const i = this;
        (i.params.watchOverflow && i.isLocked) ||
          i.params.cssMode ||
          (i.isElement && (i.__preventObserver__ = !0),
          (i[
            i.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'
          ].style.cursor = ''),
          i.isElement &&
            requestAnimationFrame(() => {
              i.__preventObserver__ = !1;
            }));
      }
      var ZC = { setGrabCursor: XC, unsetGrabCursor: QC };
      function FC(i, l = this) {
        function o(r) {
          if (!r || r === El() || r === Kt()) return null;
          r.assignedSlot && (r = r.assignedSlot);
          const u = r.closest(i);
          return !u && !r.getRootNode ? null : u || o(r.getRootNode().host);
        }
        return o(l);
      }
      function k0(i, l, o) {
        const r = Kt(),
          { params: u } = i,
          d = u.edgeSwipeDetection,
          p = u.edgeSwipeThreshold;
        return d && (o <= p || o >= r.innerWidth - p)
          ? d === 'prevent'
            ? (l.preventDefault(), !0)
            : !1
          : !0;
      }
      function KC(i) {
        const l = this,
          o = El();
        let r = i;
        r.originalEvent && (r = r.originalEvent);
        const u = l.touchEventsData;
        if (r.type === 'pointerdown') {
          if (u.pointerId !== null && u.pointerId !== r.pointerId) return;
          u.pointerId = r.pointerId;
        } else
          r.type === 'touchstart' &&
            r.targetTouches.length === 1 &&
            (u.touchId = r.targetTouches[0].identifier);
        if (r.type === 'touchstart') {
          k0(l, r, r.targetTouches[0].pageX);
          return;
        }
        const { params: d, touches: p, enabled: h } = l;
        if (
          !h ||
          (!d.simulateTouch && r.pointerType === 'mouse') ||
          (l.animating && d.preventInteractionOnTransition)
        )
          return;
        !l.animating && d.cssMode && d.loop && l.loopFix();
        let m = r.target;
        if (
          (d.touchEventsTarget === 'wrapper' && !lC(m, l.wrapperEl)) ||
          ('which' in r && r.which === 3) ||
          ('button' in r && r.button > 0) ||
          (u.isTouched && u.isMoved)
        )
          return;
        const y = !!d.noSwipingClass && d.noSwipingClass !== '',
          E = r.composedPath ? r.composedPath() : r.path;
        y && r.target && r.target.shadowRoot && E && (m = E[0]);
        const v = d.noSwipingSelector
            ? d.noSwipingSelector
            : `.${d.noSwipingClass}`,
          S = !!(r.target && r.target.shadowRoot);
        if (d.noSwiping && (S ? FC(v, m) : m.closest(v))) {
          l.allowClick = !0;
          return;
        }
        if (d.swipeHandler && !m.closest(d.swipeHandler)) return;
        ((p.currentX = r.pageX), (p.currentY = r.pageY));
        const x = p.currentX,
          D = p.currentY;
        if (!k0(l, r, x)) return;
        (Object.assign(u, {
          isTouched: !0,
          isMoved: !1,
          allowTouchCallbacks: !0,
          isScrolling: void 0,
          startMoving: void 0,
        }),
          (p.startX = x),
          (p.startY = D),
          (u.touchStartTime = Eu()),
          (l.allowClick = !0),
          l.updateSize(),
          (l.swipeDirection = void 0),
          d.threshold > 0 && (u.allowThresholdMove = !1));
        let M = !0;
        (m.matches(u.focusableElements) &&
          ((M = !1), m.nodeName === 'SELECT' && (u.isTouched = !1)),
          o.activeElement &&
            o.activeElement.matches(u.focusableElements) &&
            o.activeElement !== m &&
            (r.pointerType === 'mouse' ||
              (r.pointerType !== 'mouse' && !m.matches(u.focusableElements))) &&
            o.activeElement.blur());
        const k = M && l.allowTouchMove && d.touchStartPreventDefault;
        ((d.touchStartForcePreventDefault || k) &&
          !m.isContentEditable &&
          r.preventDefault(),
          d.freeMode &&
            d.freeMode.enabled &&
            l.freeMode &&
            l.animating &&
            !d.cssMode &&
            l.freeMode.onTouchStart(),
          l.emit('touchStart', r));
      }
      function JC(i) {
        const l = El(),
          o = this,
          r = o.touchEventsData,
          { params: u, touches: d, rtlTranslate: p, enabled: h } = o;
        if (!h || (!u.simulateTouch && i.pointerType === 'mouse')) return;
        let m = i;
        if (
          (m.originalEvent && (m = m.originalEvent),
          m.type === 'pointermove' &&
            (r.touchId !== null || m.pointerId !== r.pointerId))
        )
          return;
        let y;
        if (m.type === 'touchmove') {
          if (
            ((y = [...m.changedTouches].find(G => G.identifier === r.touchId)),
            !y || y.identifier !== r.touchId)
          )
            return;
        } else y = m;
        if (!r.isTouched) {
          r.startMoving && r.isScrolling && o.emit('touchMoveOpposite', m);
          return;
        }
        const E = y.pageX,
          v = y.pageY;
        if (m.preventedByNestedSwiper) {
          ((d.startX = E), (d.startY = v));
          return;
        }
        if (!o.allowTouchMove) {
          (m.target.matches(r.focusableElements) || (o.allowClick = !1),
            r.isTouched &&
              (Object.assign(d, {
                startX: E,
                startY: v,
                currentX: E,
                currentY: v,
              }),
              (r.touchStartTime = Eu())));
          return;
        }
        if (u.touchReleaseOnEdges && !u.loop)
          if (o.isVertical()) {
            if (
              (v < d.startY && o.translate <= o.maxTranslate()) ||
              (v > d.startY && o.translate >= o.minTranslate())
            ) {
              ((r.isTouched = !1), (r.isMoved = !1));
              return;
            }
          } else {
            if (
              p &&
              ((E > d.startX && -o.translate <= o.maxTranslate()) ||
                (E < d.startX && -o.translate >= o.minTranslate()))
            )
              return;
            if (
              !p &&
              ((E < d.startX && o.translate <= o.maxTranslate()) ||
                (E > d.startX && o.translate >= o.minTranslate()))
            )
              return;
          }
        if (
          (l.activeElement &&
            l.activeElement.matches(r.focusableElements) &&
            l.activeElement !== m.target &&
            m.pointerType !== 'mouse' &&
            l.activeElement.blur(),
          l.activeElement &&
            m.target === l.activeElement &&
            m.target.matches(r.focusableElements))
        ) {
          ((r.isMoved = !0), (o.allowClick = !1));
          return;
        }
        (r.allowTouchCallbacks && o.emit('touchMove', m),
          (d.previousX = d.currentX),
          (d.previousY = d.currentY),
          (d.currentX = E),
          (d.currentY = v));
        const S = d.currentX - d.startX,
          x = d.currentY - d.startY;
        if (
          o.params.threshold &&
          Math.sqrt(S ** 2 + x ** 2) < o.params.threshold
        )
          return;
        if (typeof r.isScrolling > 'u') {
          let G;
          (o.isHorizontal() && d.currentY === d.startY) ||
          (o.isVertical() && d.currentX === d.startX)
            ? (r.isScrolling = !1)
            : S * S + x * x >= 25 &&
              ((G = (Math.atan2(Math.abs(x), Math.abs(S)) * 180) / Math.PI),
              (r.isScrolling = o.isHorizontal()
                ? G > u.touchAngle
                : 90 - G > u.touchAngle));
        }
        if (
          (r.isScrolling && o.emit('touchMoveOpposite', m),
          typeof r.startMoving > 'u' &&
            (d.currentX !== d.startX || d.currentY !== d.startY) &&
            (r.startMoving = !0),
          r.isScrolling ||
            (m.type === 'touchmove' && r.preventTouchMoveFromPointerMove))
        ) {
          r.isTouched = !1;
          return;
        }
        if (!r.startMoving) return;
        ((o.allowClick = !1),
          !u.cssMode && m.cancelable && m.preventDefault(),
          u.touchMoveStopPropagation && !u.nested && m.stopPropagation());
        let D = o.isHorizontal() ? S : x,
          M = o.isHorizontal()
            ? d.currentX - d.previousX
            : d.currentY - d.previousY;
        (u.oneWayMovement &&
          ((D = Math.abs(D) * (p ? 1 : -1)), (M = Math.abs(M) * (p ? 1 : -1))),
          (d.diff = D),
          (D *= u.touchRatio),
          p && ((D = -D), (M = -M)));
        const k = o.touchesDirection;
        ((o.swipeDirection = D > 0 ? 'prev' : 'next'),
          (o.touchesDirection = M > 0 ? 'prev' : 'next'));
        const V = o.params.loop && !u.cssMode,
          L =
            (o.touchesDirection === 'next' && o.allowSlideNext) ||
            (o.touchesDirection === 'prev' && o.allowSlidePrev);
        if (!r.isMoved) {
          if (
            (V && L && o.loopFix({ direction: o.swipeDirection }),
            (r.startTranslate = o.getTranslate()),
            o.setTransition(0),
            o.animating)
          ) {
            const G = new window.CustomEvent('transitionend', {
              bubbles: !0,
              cancelable: !0,
              detail: { bySwiperTouchMove: !0 },
            });
            o.wrapperEl.dispatchEvent(G);
          }
          ((r.allowMomentumBounce = !1),
            u.grabCursor &&
              (o.allowSlideNext === !0 || o.allowSlidePrev === !0) &&
              o.setGrabCursor(!0),
            o.emit('sliderFirstMove', m));
        }
        if (
          (new Date().getTime(),
          u._loopSwapReset !== !1 &&
            r.isMoved &&
            r.allowThresholdMove &&
            k !== o.touchesDirection &&
            V &&
            L &&
            Math.abs(D) >= 1)
        ) {
          (Object.assign(d, {
            startX: E,
            startY: v,
            currentX: E,
            currentY: v,
            startTranslate: r.currentTranslate,
          }),
            (r.loopSwapReset = !0),
            (r.startTranslate = r.currentTranslate));
          return;
        }
        (o.emit('sliderMove', m),
          (r.isMoved = !0),
          (r.currentTranslate = D + r.startTranslate));
        let U = !0,
          Y = u.resistanceRatio;
        if (
          (u.touchReleaseOnEdges && (Y = 0),
          D > 0
            ? (V &&
                L &&
                r.allowThresholdMove &&
                r.currentTranslate >
                  (u.centeredSlides
                    ? o.minTranslate() -
                      o.slidesSizesGrid[o.activeIndex + 1] -
                      (u.slidesPerView !== 'auto' &&
                      o.slides.length - u.slidesPerView >= 2
                        ? o.slidesSizesGrid[o.activeIndex + 1] +
                          o.params.spaceBetween
                        : 0) -
                      o.params.spaceBetween
                    : o.minTranslate()) &&
                o.loopFix({
                  direction: 'prev',
                  setTranslate: !0,
                  activeSlideIndex: 0,
                }),
              r.currentTranslate > o.minTranslate() &&
                ((U = !1),
                u.resistance &&
                  (r.currentTranslate =
                    o.minTranslate() -
                    1 +
                    (-o.minTranslate() + r.startTranslate + D) ** Y)))
            : D < 0 &&
              (V &&
                L &&
                r.allowThresholdMove &&
                r.currentTranslate <
                  (u.centeredSlides
                    ? o.maxTranslate() +
                      o.slidesSizesGrid[o.slidesSizesGrid.length - 1] +
                      o.params.spaceBetween +
                      (u.slidesPerView !== 'auto' &&
                      o.slides.length - u.slidesPerView >= 2
                        ? o.slidesSizesGrid[o.slidesSizesGrid.length - 1] +
                          o.params.spaceBetween
                        : 0)
                    : o.maxTranslate()) &&
                o.loopFix({
                  direction: 'next',
                  setTranslate: !0,
                  activeSlideIndex:
                    o.slides.length -
                    (u.slidesPerView === 'auto'
                      ? o.slidesPerViewDynamic()
                      : Math.ceil(parseFloat(u.slidesPerView, 10))),
                }),
              r.currentTranslate < o.maxTranslate() &&
                ((U = !1),
                u.resistance &&
                  (r.currentTranslate =
                    o.maxTranslate() +
                    1 -
                    (o.maxTranslate() - r.startTranslate - D) ** Y))),
          U && (m.preventedByNestedSwiper = !0),
          !o.allowSlideNext &&
            o.swipeDirection === 'next' &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !o.allowSlidePrev &&
            o.swipeDirection === 'prev' &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !o.allowSlidePrev &&
            !o.allowSlideNext &&
            (r.currentTranslate = r.startTranslate),
          u.threshold > 0)
        )
          if (Math.abs(D) > u.threshold || r.allowThresholdMove) {
            if (!r.allowThresholdMove) {
              ((r.allowThresholdMove = !0),
                (d.startX = d.currentX),
                (d.startY = d.currentY),
                (r.currentTranslate = r.startTranslate),
                (d.diff = o.isHorizontal()
                  ? d.currentX - d.startX
                  : d.currentY - d.startY));
              return;
            }
          } else {
            r.currentTranslate = r.startTranslate;
            return;
          }
        !u.followFinger ||
          u.cssMode ||
          (((u.freeMode && u.freeMode.enabled && o.freeMode) ||
            u.watchSlidesProgress) &&
            (o.updateActiveIndex(), o.updateSlidesClasses()),
          u.freeMode &&
            u.freeMode.enabled &&
            o.freeMode &&
            o.freeMode.onTouchMove(),
          o.updateProgress(r.currentTranslate),
          o.setTranslate(r.currentTranslate));
      }
      function eA(i) {
        const l = this,
          o = l.touchEventsData;
        let r = i;
        r.originalEvent && (r = r.originalEvent);
        let u;
        if (r.type === 'touchend' || r.type === 'touchcancel') {
          if (
            ((u = [...r.changedTouches].find(G => G.identifier === o.touchId)),
            !u || u.identifier !== o.touchId)
          )
            return;
        } else {
          if (o.touchId !== null || r.pointerId !== o.pointerId) return;
          u = r;
        }
        if (
          [
            'pointercancel',
            'pointerout',
            'pointerleave',
            'contextmenu',
          ].includes(r.type) &&
          !(
            ['pointercancel', 'contextmenu'].includes(r.type) &&
            (l.browser.isSafari || l.browser.isWebView)
          )
        )
          return;
        ((o.pointerId = null), (o.touchId = null));
        const {
          params: p,
          touches: h,
          rtlTranslate: m,
          slidesGrid: y,
          enabled: E,
        } = l;
        if (!E || (!p.simulateTouch && r.pointerType === 'mouse')) return;
        if (
          (o.allowTouchCallbacks && l.emit('touchEnd', r),
          (o.allowTouchCallbacks = !1),
          !o.isTouched)
        ) {
          (o.isMoved && p.grabCursor && l.setGrabCursor(!1),
            (o.isMoved = !1),
            (o.startMoving = !1));
          return;
        }
        p.grabCursor &&
          o.isMoved &&
          o.isTouched &&
          (l.allowSlideNext === !0 || l.allowSlidePrev === !0) &&
          l.setGrabCursor(!1);
        const v = Eu(),
          S = v - o.touchStartTime;
        if (l.allowClick) {
          const G = r.path || (r.composedPath && r.composedPath());
          (l.updateClickedSlide((G && G[0]) || r.target, G),
            l.emit('tap click', r),
            S < 300 &&
              v - o.lastClickTime < 300 &&
              l.emit('doubleTap doubleClick', r));
        }
        if (
          ((o.lastClickTime = Eu()),
          K0(() => {
            l.destroyed || (l.allowClick = !0);
          }),
          !o.isTouched ||
            !o.isMoved ||
            !l.swipeDirection ||
            (h.diff === 0 && !o.loopSwapReset) ||
            (o.currentTranslate === o.startTranslate && !o.loopSwapReset))
        ) {
          ((o.isTouched = !1), (o.isMoved = !1), (o.startMoving = !1));
          return;
        }
        ((o.isTouched = !1), (o.isMoved = !1), (o.startMoving = !1));
        let x;
        if (
          (p.followFinger
            ? (x = m ? l.translate : -l.translate)
            : (x = -o.currentTranslate),
          p.cssMode)
        )
          return;
        if (p.freeMode && p.freeMode.enabled) {
          l.freeMode.onTouchEnd({ currentPos: x });
          return;
        }
        const D = x >= -l.maxTranslate() && !l.params.loop;
        let M = 0,
          k = l.slidesSizesGrid[0];
        for (
          let G = 0;
          G < y.length;
          G += G < p.slidesPerGroupSkip ? 1 : p.slidesPerGroup
        ) {
          const P = G < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
          typeof y[G + P] < 'u'
            ? (D || (x >= y[G] && x < y[G + P])) &&
              ((M = G), (k = y[G + P] - y[G]))
            : (D || x >= y[G]) &&
              ((M = G), (k = y[y.length - 1] - y[y.length - 2]));
        }
        let V = null,
          L = null;
        p.rewind &&
          (l.isBeginning
            ? (L =
                p.virtual && p.virtual.enabled && l.virtual
                  ? l.virtual.slides.length - 1
                  : l.slides.length - 1)
            : l.isEnd && (V = 0));
        const U = (x - y[M]) / k,
          Y = M < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
        if (S > p.longSwipesMs) {
          if (!p.longSwipes) {
            l.slideTo(l.activeIndex);
            return;
          }
          (l.swipeDirection === 'next' &&
            (U >= p.longSwipesRatio
              ? l.slideTo(p.rewind && l.isEnd ? V : M + Y)
              : l.slideTo(M)),
            l.swipeDirection === 'prev' &&
              (U > 1 - p.longSwipesRatio
                ? l.slideTo(M + Y)
                : L !== null && U < 0 && Math.abs(U) > p.longSwipesRatio
                  ? l.slideTo(L)
                  : l.slideTo(M)));
        } else {
          if (!p.shortSwipes) {
            l.slideTo(l.activeIndex);
            return;
          }
          l.navigation &&
          (r.target === l.navigation.nextEl || r.target === l.navigation.prevEl)
            ? r.target === l.navigation.nextEl
              ? l.slideTo(M + Y)
              : l.slideTo(M)
            : (l.swipeDirection === 'next' && l.slideTo(V !== null ? V : M + Y),
              l.swipeDirection === 'prev' && l.slideTo(L !== null ? L : M));
        }
      }
      function _0() {
        const i = this,
          { params: l, el: o } = i;
        if (o && o.offsetWidth === 0) return;
        l.breakpoints && i.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: u, snapGrid: d } = i,
          p = i.virtual && i.params.virtual.enabled;
        ((i.allowSlideNext = !0),
          (i.allowSlidePrev = !0),
          i.updateSize(),
          i.updateSlides(),
          i.updateSlidesClasses());
        const h = p && l.loop;
        ((l.slidesPerView === 'auto' || l.slidesPerView > 1) &&
        i.isEnd &&
        !i.isBeginning &&
        !i.params.centeredSlides &&
        !h
          ? i.slideTo(i.slides.length - 1, 0, !1, !0)
          : i.params.loop && !p
            ? i.slideToLoop(i.realIndex, 0, !1, !0)
            : i.slideTo(i.activeIndex, 0, !1, !0),
          i.autoplay &&
            i.autoplay.running &&
            i.autoplay.paused &&
            (clearTimeout(i.autoplay.resizeTimeout),
            (i.autoplay.resizeTimeout = setTimeout(() => {
              i.autoplay &&
                i.autoplay.running &&
                i.autoplay.paused &&
                i.autoplay.resume();
            }, 500))),
          (i.allowSlidePrev = u),
          (i.allowSlideNext = r),
          i.params.watchOverflow && d !== i.snapGrid && i.checkOverflow());
      }
      function tA(i) {
        const l = this;
        l.enabled &&
          (l.allowClick ||
            (l.params.preventClicks && i.preventDefault(),
            l.params.preventClicksPropagation &&
              l.animating &&
              (i.stopPropagation(), i.stopImmediatePropagation())));
      }
      function nA() {
        const i = this,
          { wrapperEl: l, rtlTranslate: o, enabled: r } = i;
        if (!r) return;
        ((i.previousTranslate = i.translate),
          i.isHorizontal()
            ? (i.translate = -l.scrollLeft)
            : (i.translate = -l.scrollTop),
          i.translate === 0 && (i.translate = 0),
          i.updateActiveIndex(),
          i.updateSlidesClasses());
        let u;
        const d = i.maxTranslate() - i.minTranslate();
        (d === 0 ? (u = 0) : (u = (i.translate - i.minTranslate()) / d),
          u !== i.progress && i.updateProgress(o ? -i.translate : i.translate),
          i.emit('setTranslate', i.translate, !1));
      }
      function aA(i) {
        const l = this;
        (Su(l, i.target),
          !(
            l.params.cssMode ||
            (l.params.slidesPerView !== 'auto' && !l.params.autoHeight)
          ) && l.update());
      }
      function iA() {
        const i = this;
        i.documentTouchHandlerProceeded ||
          ((i.documentTouchHandlerProceeded = !0),
          i.params.touchReleaseOnEdges && (i.el.style.touchAction = 'auto'));
      }
      const iS = (i, l) => {
        const o = El(),
          { params: r, el: u, wrapperEl: d, device: p } = i,
          h = !!r.nested,
          m = l === 'on' ? 'addEventListener' : 'removeEventListener',
          y = l;
        !u ||
          typeof u == 'string' ||
          (o[m]('touchstart', i.onDocumentTouchStart, {
            passive: !1,
            capture: h,
          }),
          u[m]('touchstart', i.onTouchStart, { passive: !1 }),
          u[m]('pointerdown', i.onTouchStart, { passive: !1 }),
          o[m]('touchmove', i.onTouchMove, { passive: !1, capture: h }),
          o[m]('pointermove', i.onTouchMove, { passive: !1, capture: h }),
          o[m]('touchend', i.onTouchEnd, { passive: !0 }),
          o[m]('pointerup', i.onTouchEnd, { passive: !0 }),
          o[m]('pointercancel', i.onTouchEnd, { passive: !0 }),
          o[m]('touchcancel', i.onTouchEnd, { passive: !0 }),
          o[m]('pointerout', i.onTouchEnd, { passive: !0 }),
          o[m]('pointerleave', i.onTouchEnd, { passive: !0 }),
          o[m]('contextmenu', i.onTouchEnd, { passive: !0 }),
          (r.preventClicks || r.preventClicksPropagation) &&
            u[m]('click', i.onClick, !0),
          r.cssMode && d[m]('scroll', i.onScroll),
          r.updateOnWindowResize
            ? i[y](
                p.ios || p.android
                  ? 'resize orientationchange observerUpdate'
                  : 'resize observerUpdate',
                _0,
                !0
              )
            : i[y]('observerUpdate', _0, !0),
          u[m]('load', i.onLoad, { capture: !0 }));
      };
      function lA() {
        const i = this,
          { params: l } = i;
        ((i.onTouchStart = KC.bind(i)),
          (i.onTouchMove = JC.bind(i)),
          (i.onTouchEnd = eA.bind(i)),
          (i.onDocumentTouchStart = iA.bind(i)),
          l.cssMode && (i.onScroll = nA.bind(i)),
          (i.onClick = tA.bind(i)),
          (i.onLoad = aA.bind(i)),
          iS(i, 'on'));
      }
      function sA() {
        iS(this, 'off');
      }
      var oA = { attachEvents: lA, detachEvents: sA };
      const j0 = (i, l) => i.grid && l.grid && l.grid.rows > 1;
      function rA() {
        const i = this,
          { realIndex: l, initialized: o, params: r, el: u } = i,
          d = r.breakpoints;
        if (!d || (d && Object.keys(d).length === 0)) return;
        const p = El(),
          h =
            r.breakpointsBase === 'window' || !r.breakpointsBase
              ? r.breakpointsBase
              : 'container',
          m =
            ['window', 'container'].includes(r.breakpointsBase) ||
            !r.breakpointsBase
              ? i.el
              : p.querySelector(r.breakpointsBase),
          y = i.getBreakpoint(d, h, m);
        if (!y || i.currentBreakpoint === y) return;
        const v = (y in d ? d[y] : void 0) || i.originalParams,
          S = j0(i, r),
          x = j0(i, v),
          D = i.params.grabCursor,
          M = v.grabCursor,
          k = r.enabled;
        (S && !x
          ? (u.classList.remove(
              `${r.containerModifierClass}grid`,
              `${r.containerModifierClass}grid-column`
            ),
            i.emitContainerClasses())
          : !S &&
            x &&
            (u.classList.add(`${r.containerModifierClass}grid`),
            ((v.grid.fill && v.grid.fill === 'column') ||
              (!v.grid.fill && r.grid.fill === 'column')) &&
              u.classList.add(`${r.containerModifierClass}grid-column`),
            i.emitContainerClasses()),
          D && !M ? i.unsetGrabCursor() : !D && M && i.setGrabCursor(),
          ['navigation', 'pagination', 'scrollbar'].forEach(P => {
            if (typeof v[P] > 'u') return;
            const Q = r[P] && r[P].enabled,
              X = v[P] && v[P].enabled;
            (Q && !X && i[P].disable(), !Q && X && i[P].enable());
          }));
        const V = v.direction && v.direction !== r.direction,
          L = r.loop && (v.slidesPerView !== r.slidesPerView || V),
          U = r.loop;
        (V && o && i.changeDirection(), En(i.params, v));
        const Y = i.params.enabled,
          G = i.params.loop;
        (Object.assign(i, {
          allowTouchMove: i.params.allowTouchMove,
          allowSlideNext: i.params.allowSlideNext,
          allowSlidePrev: i.params.allowSlidePrev,
        }),
          k && !Y ? i.disable() : !k && Y && i.enable(),
          (i.currentBreakpoint = y),
          i.emit('_beforeBreakpoint', v),
          o &&
            (L
              ? (i.loopDestroy(), i.loopCreate(l), i.updateSlides())
              : !U && G
                ? (i.loopCreate(l), i.updateSlides())
                : U && !G && i.loopDestroy()),
          i.emit('breakpoint', v));
      }
      function cA(i, l = 'window', o) {
        if (!i || (l === 'container' && !o)) return;
        let r = !1;
        const u = Kt(),
          d = l === 'window' ? u.innerHeight : o.clientHeight,
          p = Object.keys(i).map(h => {
            if (typeof h == 'string' && h.indexOf('@') === 0) {
              const m = parseFloat(h.substr(1));
              return { value: d * m, point: h };
            }
            return { value: h, point: h };
          });
        p.sort((h, m) => parseInt(h.value, 10) - parseInt(m.value, 10));
        for (let h = 0; h < p.length; h += 1) {
          const { point: m, value: y } = p[h];
          l === 'window'
            ? u.matchMedia(`(min-width: ${y}px)`).matches && (r = m)
            : y <= o.clientWidth && (r = m);
        }
        return r || 'max';
      }
      var uA = { setBreakpoint: rA, getBreakpoint: cA };
      function dA(i, l) {
        const o = [];
        return (
          i.forEach(r => {
            typeof r == 'object'
              ? Object.keys(r).forEach(u => {
                  r[u] && o.push(l + u);
                })
              : typeof r == 'string' && o.push(l + r);
          }),
          o
        );
      }
      function fA() {
        const i = this,
          { classNames: l, params: o, rtl: r, el: u, device: d } = i,
          p = dA(
            [
              'initialized',
              o.direction,
              { 'free-mode': i.params.freeMode && o.freeMode.enabled },
              { autoheight: o.autoHeight },
              { rtl: r },
              { grid: o.grid && o.grid.rows > 1 },
              {
                'grid-column':
                  o.grid && o.grid.rows > 1 && o.grid.fill === 'column',
              },
              { android: d.android },
              { ios: d.ios },
              { 'css-mode': o.cssMode },
              { centered: o.cssMode && o.centeredSlides },
              { 'watch-progress': o.watchSlidesProgress },
            ],
            o.containerModifierClass
          );
        (l.push(...p), u.classList.add(...l), i.emitContainerClasses());
      }
      function mA() {
        const i = this,
          { el: l, classNames: o } = i;
        !l ||
          typeof l == 'string' ||
          (l.classList.remove(...o), i.emitContainerClasses());
      }
      var pA = { addClasses: fA, removeClasses: mA };
      function hA() {
        const i = this,
          { isLocked: l, params: o } = i,
          { slidesOffsetBefore: r } = o;
        if (r) {
          const u = i.slides.length - 1,
            d = i.slidesGrid[u] + i.slidesSizesGrid[u] + r * 2;
          i.isLocked = i.size > d;
        } else i.isLocked = i.snapGrid.length === 1;
        (o.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked),
          o.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked),
          l && l !== i.isLocked && (i.isEnd = !1),
          l !== i.isLocked && i.emit(i.isLocked ? 'lock' : 'unlock'));
      }
      var gA = { checkOverflow: hA },
        Op = {
          init: !0,
          direction: 'horizontal',
          oneWayMovement: !1,
          swiperElementNodeName: 'SWIPER-CONTAINER',
          touchEventsTarget: 'wrapper',
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          eventsPrefix: 'swiper',
          enabled: !0,
          focusableElements:
            'input, select, option, textarea, button, video, label',
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: 'slide',
          breakpoints: void 0,
          breakpointsBase: 'window',
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 5,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          loop: !1,
          loopAddBlankSlides: !0,
          loopAdditionalSlides: 0,
          loopPreventsSliding: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: 'swiper-no-swiping',
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: 'swiper-',
          slideClass: 'swiper-slide',
          slideBlankClass: 'swiper-slide-blank',
          slideActiveClass: 'swiper-slide-active',
          slideVisibleClass: 'swiper-slide-visible',
          slideFullyVisibleClass: 'swiper-slide-fully-visible',
          slideNextClass: 'swiper-slide-next',
          slidePrevClass: 'swiper-slide-prev',
          wrapperClass: 'swiper-wrapper',
          lazyPreloaderClass: 'swiper-lazy-preloader',
          lazyPreloadPrevNext: 0,
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function bA(i, l) {
        return function (r = {}) {
          const u = Object.keys(r)[0],
            d = r[u];
          if (typeof d != 'object' || d === null) {
            En(l, r);
            return;
          }
          if (
            (i[u] === !0 && (i[u] = { enabled: !0 }),
            u === 'navigation' &&
              i[u] &&
              i[u].enabled &&
              !i[u].prevEl &&
              !i[u].nextEl &&
              (i[u].auto = !0),
            ['pagination', 'scrollbar'].indexOf(u) >= 0 &&
              i[u] &&
              i[u].enabled &&
              !i[u].el &&
              (i[u].auto = !0),
            !(u in i && 'enabled' in d))
          ) {
            En(l, r);
            return;
          }
          (typeof i[u] == 'object' &&
            !('enabled' in i[u]) &&
            (i[u].enabled = !0),
            i[u] || (i[u] = { enabled: !1 }),
            En(l, r));
        };
      }
      const yp = {
          eventsEmitter: pC,
          update: DC,
          translate: OC,
          transition: VC,
          slide: $C,
          loop: YC,
          grabCursor: ZC,
          events: oA,
          breakpoints: uA,
          checkOverflow: gA,
          classes: pA,
        },
        vp = {};
      let _p = class Qa {
        constructor(...l) {
          let o, r;
          (l.length === 1 &&
          l[0].constructor &&
          Object.prototype.toString.call(l[0]).slice(8, -1) === 'Object'
            ? (r = l[0])
            : ([o, r] = l),
            r || (r = {}),
            (r = En({}, r)),
            o && !r.el && (r.el = o));
          const u = El();
          if (
            r.el &&
            typeof r.el == 'string' &&
            u.querySelectorAll(r.el).length > 1
          ) {
            const m = [];
            return (
              u.querySelectorAll(r.el).forEach(y => {
                const E = En({}, r, { el: y });
                m.push(new Qa(E));
              }),
              m
            );
          }
          const d = this;
          ((d.__swiper__ = !0),
            (d.support = eS()),
            (d.device = tS({ userAgent: r.userAgent })),
            (d.browser = nS()),
            (d.eventsListeners = {}),
            (d.eventsAnyListeners = []),
            (d.modules = [...d.__modules__]),
            r.modules &&
              Array.isArray(r.modules) &&
              d.modules.push(...r.modules));
          const p = {};
          d.modules.forEach(m => {
            m({
              params: r,
              swiper: d,
              extendParams: bA(r, p),
              on: d.on.bind(d),
              once: d.once.bind(d),
              off: d.off.bind(d),
              emit: d.emit.bind(d),
            });
          });
          const h = En({}, Op, p);
          return (
            (d.params = En({}, h, vp, r)),
            (d.originalParams = En({}, d.params)),
            (d.passedParams = En({}, r)),
            d.params &&
              d.params.on &&
              Object.keys(d.params.on).forEach(m => {
                d.on(m, d.params.on[m]);
              }),
            d.params && d.params.onAny && d.onAny(d.params.onAny),
            Object.assign(d, {
              enabled: d.params.enabled,
              el: o,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return d.params.direction === 'horizontal';
              },
              isVertical() {
                return d.params.direction === 'vertical';
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
              },
              allowSlideNext: d.params.allowSlideNext,
              allowSlidePrev: d.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: d.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null,
              },
              allowClick: !0,
              allowTouchMove: d.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            d.emit('_swiper'),
            d.params.init && d.init(),
            d
          );
        }
        getDirectionLabel(l) {
          return this.isHorizontal()
            ? l
            : {
                width: 'height',
                'margin-top': 'margin-left',
                'margin-bottom ': 'margin-right',
                'margin-left': 'margin-top',
                'margin-right': 'margin-bottom',
                'padding-left': 'padding-top',
                'padding-right': 'padding-bottom',
                marginRight: 'marginBottom',
              }[l];
        }
        getSlideIndex(l) {
          const { slidesEl: o, params: r } = this,
            u = Sa(o, `.${r.slideClass}, swiper-slide`),
            d = R0(u[0]);
          return R0(l) - d;
        }
        getSlideIndexByData(l) {
          return this.getSlideIndex(
            this.slides.find(
              o => o.getAttribute('data-swiper-slide-index') * 1 === l
            )
          );
        }
        getSlideIndexWhenGrid(l) {
          return (
            this.grid &&
              this.params.grid &&
              this.params.grid.rows > 1 &&
              (this.params.grid.fill === 'column'
                ? (l = Math.floor(l / this.params.grid.rows))
                : this.params.grid.fill === 'row' &&
                  (l =
                    l % Math.ceil(this.slides.length / this.params.grid.rows))),
            l
          );
        }
        recalcSlides() {
          const l = this,
            { slidesEl: o, params: r } = l;
          l.slides = Sa(o, `.${r.slideClass}, swiper-slide`);
        }
        enable() {
          const l = this;
          l.enabled ||
            ((l.enabled = !0),
            l.params.grabCursor && l.setGrabCursor(),
            l.emit('enable'));
        }
        disable() {
          const l = this;
          l.enabled &&
            ((l.enabled = !1),
            l.params.grabCursor && l.unsetGrabCursor(),
            l.emit('disable'));
        }
        setProgress(l, o) {
          const r = this;
          l = Math.min(Math.max(l, 0), 1);
          const u = r.minTranslate(),
            p = (r.maxTranslate() - u) * l + u;
          (r.translateTo(p, typeof o > 'u' ? 0 : o),
            r.updateActiveIndex(),
            r.updateSlidesClasses());
        }
        emitContainerClasses() {
          const l = this;
          if (!l.params._emitClasses || !l.el) return;
          const o = l.el.className
            .split(' ')
            .filter(
              r =>
                r.indexOf('swiper') === 0 ||
                r.indexOf(l.params.containerModifierClass) === 0
            );
          l.emit('_containerClasses', o.join(' '));
        }
        getSlideClasses(l) {
          const o = this;
          return o.destroyed
            ? ''
            : l.className
                .split(' ')
                .filter(
                  r =>
                    r.indexOf('swiper-slide') === 0 ||
                    r.indexOf(o.params.slideClass) === 0
                )
                .join(' ');
        }
        emitSlidesClasses() {
          const l = this;
          if (!l.params._emitClasses || !l.el) return;
          const o = [];
          (l.slides.forEach(r => {
            const u = l.getSlideClasses(r);
            (o.push({ slideEl: r, classNames: u }),
              l.emit('_slideClass', r, u));
          }),
            l.emit('_slideClasses', o));
        }
        slidesPerViewDynamic(l = 'current', o = !1) {
          const r = this,
            {
              params: u,
              slides: d,
              slidesGrid: p,
              slidesSizesGrid: h,
              size: m,
              activeIndex: y,
            } = r;
          let E = 1;
          if (typeof u.slidesPerView == 'number') return u.slidesPerView;
          if (u.centeredSlides) {
            let v = d[y] ? Math.ceil(d[y].swiperSlideSize) : 0,
              S;
            for (let x = y + 1; x < d.length; x += 1)
              d[x] &&
                !S &&
                ((v += Math.ceil(d[x].swiperSlideSize)),
                (E += 1),
                v > m && (S = !0));
            for (let x = y - 1; x >= 0; x -= 1)
              d[x] &&
                !S &&
                ((v += d[x].swiperSlideSize), (E += 1), v > m && (S = !0));
          } else if (l === 'current')
            for (let v = y + 1; v < d.length; v += 1)
              (o ? p[v] + h[v] - p[y] < m : p[v] - p[y] < m) && (E += 1);
          else for (let v = y - 1; v >= 0; v -= 1) p[y] - p[v] < m && (E += 1);
          return E;
        }
        update() {
          const l = this;
          if (!l || l.destroyed) return;
          const { snapGrid: o, params: r } = l;
          (r.breakpoints && l.setBreakpoint(),
            [...l.el.querySelectorAll('[loading="lazy"]')].forEach(p => {
              p.complete && Su(l, p);
            }),
            l.updateSize(),
            l.updateSlides(),
            l.updateProgress(),
            l.updateSlidesClasses());
          function u() {
            const p = l.rtlTranslate ? l.translate * -1 : l.translate,
              h = Math.min(Math.max(p, l.maxTranslate()), l.minTranslate());
            (l.setTranslate(h), l.updateActiveIndex(), l.updateSlidesClasses());
          }
          let d;
          if (r.freeMode && r.freeMode.enabled && !r.cssMode)
            (u(), r.autoHeight && l.updateAutoHeight());
          else {
            if (
              (r.slidesPerView === 'auto' || r.slidesPerView > 1) &&
              l.isEnd &&
              !r.centeredSlides
            ) {
              const p =
                l.virtual && r.virtual.enabled ? l.virtual.slides : l.slides;
              d = l.slideTo(p.length - 1, 0, !1, !0);
            } else d = l.slideTo(l.activeIndex, 0, !1, !0);
            d || u();
          }
          (r.watchOverflow && o !== l.snapGrid && l.checkOverflow(),
            l.emit('update'));
        }
        changeDirection(l, o = !0) {
          const r = this,
            u = r.params.direction;
          return (
            l || (l = u === 'horizontal' ? 'vertical' : 'horizontal'),
            l === u ||
              (l !== 'horizontal' && l !== 'vertical') ||
              (r.el.classList.remove(`${r.params.containerModifierClass}${u}`),
              r.el.classList.add(`${r.params.containerModifierClass}${l}`),
              r.emitContainerClasses(),
              (r.params.direction = l),
              r.slides.forEach(d => {
                l === 'vertical' ? (d.style.width = '') : (d.style.height = '');
              }),
              r.emit('changeDirection'),
              o && r.update()),
            r
          );
        }
        changeLanguageDirection(l) {
          const o = this;
          (o.rtl && l === 'rtl') ||
            (!o.rtl && l === 'ltr') ||
            ((o.rtl = l === 'rtl'),
            (o.rtlTranslate = o.params.direction === 'horizontal' && o.rtl),
            o.rtl
              ? (o.el.classList.add(`${o.params.containerModifierClass}rtl`),
                (o.el.dir = 'rtl'))
              : (o.el.classList.remove(`${o.params.containerModifierClass}rtl`),
                (o.el.dir = 'ltr')),
            o.update());
        }
        mount(l) {
          const o = this;
          if (o.mounted) return !0;
          let r = l || o.params.el;
          if ((typeof r == 'string' && (r = document.querySelector(r)), !r))
            return !1;
          ((r.swiper = o),
            r.parentNode &&
              r.parentNode.host &&
              r.parentNode.host.nodeName ===
                o.params.swiperElementNodeName.toUpperCase() &&
              (o.isElement = !0));
          const u = () =>
            `.${(o.params.wrapperClass || '').trim().split(' ').join('.')}`;
          let p =
            r && r.shadowRoot && r.shadowRoot.querySelector
              ? r.shadowRoot.querySelector(u())
              : Sa(r, u())[0];
          return (
            !p &&
              o.params.createElements &&
              ((p = Tu('div', o.params.wrapperClass)),
              r.append(p),
              Sa(r, `.${o.params.slideClass}`).forEach(h => {
                p.append(h);
              })),
            Object.assign(o, {
              el: r,
              wrapperEl: p,
              slidesEl:
                o.isElement && !r.parentNode.host.slideSlots
                  ? r.parentNode.host
                  : p,
              hostEl: o.isElement ? r.parentNode.host : r,
              mounted: !0,
              rtl:
                r.dir.toLowerCase() === 'rtl' || ki(r, 'direction') === 'rtl',
              rtlTranslate:
                o.params.direction === 'horizontal' &&
                (r.dir.toLowerCase() === 'rtl' || ki(r, 'direction') === 'rtl'),
              wrongRTL: ki(p, 'display') === '-webkit-box',
            }),
            !0
          );
        }
        init(l) {
          const o = this;
          if (o.initialized || o.mount(l) === !1) return o;
          (o.emit('beforeInit'),
            o.params.breakpoints && o.setBreakpoint(),
            o.addClasses(),
            o.updateSize(),
            o.updateSlides(),
            o.params.watchOverflow && o.checkOverflow(),
            o.params.grabCursor && o.enabled && o.setGrabCursor(),
            o.params.loop && o.virtual && o.params.virtual.enabled
              ? o.slideTo(
                  o.params.initialSlide + o.virtual.slidesBefore,
                  0,
                  o.params.runCallbacksOnInit,
                  !1,
                  !0
                )
              : o.slideTo(
                  o.params.initialSlide,
                  0,
                  o.params.runCallbacksOnInit,
                  !1,
                  !0
                ),
            o.params.loop && o.loopCreate(void 0, !0),
            o.attachEvents());
          const u = [...o.el.querySelectorAll('[loading="lazy"]')];
          return (
            o.isElement &&
              u.push(...o.hostEl.querySelectorAll('[loading="lazy"]')),
            u.forEach(d => {
              d.complete
                ? Su(o, d)
                : d.addEventListener('load', p => {
                    Su(o, p.target);
                  });
            }),
            Mp(o),
            (o.initialized = !0),
            Mp(o),
            o.emit('init'),
            o.emit('afterInit'),
            o
          );
        }
        destroy(l = !0, o = !0) {
          const r = this,
            { params: u, el: d, wrapperEl: p, slides: h } = r;
          return (
            typeof r.params > 'u' ||
              r.destroyed ||
              (r.emit('beforeDestroy'),
              (r.initialized = !1),
              r.detachEvents(),
              u.loop && r.loopDestroy(),
              o &&
                (r.removeClasses(),
                d && typeof d != 'string' && d.removeAttribute('style'),
                p && p.removeAttribute('style'),
                h &&
                  h.length &&
                  h.forEach(m => {
                    (m.classList.remove(
                      u.slideVisibleClass,
                      u.slideFullyVisibleClass,
                      u.slideActiveClass,
                      u.slideNextClass,
                      u.slidePrevClass
                    ),
                      m.removeAttribute('style'),
                      m.removeAttribute('data-swiper-slide-index'));
                  })),
              r.emit('destroy'),
              Object.keys(r.eventsListeners).forEach(m => {
                r.off(m);
              }),
              l !== !1 &&
                (r.el && typeof r.el != 'string' && (r.el.swiper = null),
                eC(r)),
              (r.destroyed = !0)),
            null
          );
        }
        static extendDefaults(l) {
          En(vp, l);
        }
        static get extendedDefaults() {
          return vp;
        }
        static get defaults() {
          return Op;
        }
        static installModule(l) {
          Qa.prototype.__modules__ || (Qa.prototype.__modules__ = []);
          const o = Qa.prototype.__modules__;
          typeof l == 'function' && o.indexOf(l) < 0 && o.push(l);
        }
        static use(l) {
          return Array.isArray(l)
            ? (l.forEach(o => Qa.installModule(o)), Qa)
            : (Qa.installModule(l), Qa);
        }
      };
      Object.keys(yp).forEach(i => {
        Object.keys(yp[i]).forEach(l => {
          _p.prototype[l] = yp[i][l];
        });
      });
      _p.use([fC, mC]);
      const lS = [
        'eventsPrefix',
        'injectStyles',
        'injectStylesUrls',
        'modules',
        'init',
        '_direction',
        'oneWayMovement',
        'swiperElementNodeName',
        'touchEventsTarget',
        'initialSlide',
        '_speed',
        'cssMode',
        'updateOnWindowResize',
        'resizeObserver',
        'nested',
        'focusableElements',
        '_enabled',
        '_width',
        '_height',
        'preventInteractionOnTransition',
        'userAgent',
        'url',
        '_edgeSwipeDetection',
        '_edgeSwipeThreshold',
        '_freeMode',
        '_autoHeight',
        'setWrapperSize',
        'virtualTranslate',
        '_effect',
        'breakpoints',
        'breakpointsBase',
        '_spaceBetween',
        '_slidesPerView',
        'maxBackfaceHiddenSlides',
        '_grid',
        '_slidesPerGroup',
        '_slidesPerGroupSkip',
        '_slidesPerGroupAuto',
        '_centeredSlides',
        '_centeredSlidesBounds',
        '_slidesOffsetBefore',
        '_slidesOffsetAfter',
        'normalizeSlideIndex',
        '_centerInsufficientSlides',
        '_watchOverflow',
        'roundLengths',
        'touchRatio',
        'touchAngle',
        'simulateTouch',
        '_shortSwipes',
        '_longSwipes',
        'longSwipesRatio',
        'longSwipesMs',
        '_followFinger',
        'allowTouchMove',
        '_threshold',
        'touchMoveStopPropagation',
        'touchStartPreventDefault',
        'touchStartForcePreventDefault',
        'touchReleaseOnEdges',
        'uniqueNavElements',
        '_resistance',
        '_resistanceRatio',
        '_watchSlidesProgress',
        '_grabCursor',
        'preventClicks',
        'preventClicksPropagation',
        '_slideToClickedSlide',
        '_loop',
        'loopAdditionalSlides',
        'loopAddBlankSlides',
        'loopPreventsSliding',
        '_rewind',
        '_allowSlidePrev',
        '_allowSlideNext',
        '_swipeHandler',
        '_noSwiping',
        'noSwipingClass',
        'noSwipingSelector',
        'passiveListeners',
        'containerModifierClass',
        'slideClass',
        'slideActiveClass',
        'slideVisibleClass',
        'slideFullyVisibleClass',
        'slideNextClass',
        'slidePrevClass',
        'slideBlankClass',
        'wrapperClass',
        'lazyPreloaderClass',
        'lazyPreloadPrevNext',
        'runCallbacksOnInit',
        'observer',
        'observeParents',
        'observeSlideChildren',
        'a11y',
        '_autoplay',
        '_controller',
        'coverflowEffect',
        'cubeEffect',
        'fadeEffect',
        'flipEffect',
        'creativeEffect',
        'cardsEffect',
        'hashNavigation',
        'history',
        'keyboard',
        'mousewheel',
        '_navigation',
        '_pagination',
        'parallax',
        '_scrollbar',
        '_thumbs',
        'virtual',
        'zoom',
        'control',
      ];
      function xl(i) {
        return (
          typeof i == 'object' &&
          i !== null &&
          i.constructor &&
          Object.prototype.toString.call(i).slice(8, -1) === 'Object' &&
          !i.__swiper__
        );
      }
      function Rs(i, l) {
        const o = ['__proto__', 'constructor', 'prototype'];
        Object.keys(l)
          .filter(r => o.indexOf(r) < 0)
          .forEach(r => {
            typeof i[r] > 'u'
              ? (i[r] = l[r])
              : xl(l[r]) && xl(i[r]) && Object.keys(l[r]).length > 0
                ? l[r].__swiper__
                  ? (i[r] = l[r])
                  : Rs(i[r], l[r])
                : (i[r] = l[r]);
          });
      }
      function sS(i = {}) {
        return (
          i.navigation &&
          typeof i.navigation.nextEl > 'u' &&
          typeof i.navigation.prevEl > 'u'
        );
      }
      function oS(i = {}) {
        return i.pagination && typeof i.pagination.el > 'u';
      }
      function rS(i = {}) {
        return i.scrollbar && typeof i.scrollbar.el > 'u';
      }
      function cS(i = '') {
        const l = i
            .split(' ')
            .map(r => r.trim())
            .filter(r => !!r),
          o = [];
        return (
          l.forEach(r => {
            o.indexOf(r) < 0 && o.push(r);
          }),
          o.join(' ')
        );
      }
      function yA(i = '') {
        return i
          ? i.includes('swiper-wrapper')
            ? i
            : `swiper-wrapper ${i}`
          : 'swiper-wrapper';
      }
      function vA({
        swiper: i,
        slides: l,
        passedParams: o,
        changedParams: r,
        nextEl: u,
        prevEl: d,
        scrollbarEl: p,
        paginationEl: h,
      }) {
        const m = r.filter(
            X => X !== 'children' && X !== 'direction' && X !== 'wrapperClass'
          ),
          {
            params: y,
            pagination: E,
            navigation: v,
            scrollbar: S,
            virtual: x,
            thumbs: D,
          } = i;
        let M, k, V, L, U, Y, G, P;
        (r.includes('thumbs') &&
          o.thumbs &&
          o.thumbs.swiper &&
          !o.thumbs.swiper.destroyed &&
          y.thumbs &&
          (!y.thumbs.swiper || y.thumbs.swiper.destroyed) &&
          (M = !0),
          r.includes('controller') &&
            o.controller &&
            o.controller.control &&
            y.controller &&
            !y.controller.control &&
            (k = !0),
          r.includes('pagination') &&
            o.pagination &&
            (o.pagination.el || h) &&
            (y.pagination || y.pagination === !1) &&
            E &&
            !E.el &&
            (V = !0),
          r.includes('scrollbar') &&
            o.scrollbar &&
            (o.scrollbar.el || p) &&
            (y.scrollbar || y.scrollbar === !1) &&
            S &&
            !S.el &&
            (L = !0),
          r.includes('navigation') &&
            o.navigation &&
            (o.navigation.prevEl || d) &&
            (o.navigation.nextEl || u) &&
            (y.navigation || y.navigation === !1) &&
            v &&
            !v.prevEl &&
            !v.nextEl &&
            (U = !0));
        const Q = X => {
          i[X] &&
            (i[X].destroy(),
            X === 'navigation'
              ? (i.isElement && (i[X].prevEl.remove(), i[X].nextEl.remove()),
                (y[X].prevEl = void 0),
                (y[X].nextEl = void 0),
                (i[X].prevEl = void 0),
                (i[X].nextEl = void 0))
              : (i.isElement && i[X].el.remove(),
                (y[X].el = void 0),
                (i[X].el = void 0)));
        };
        (r.includes('loop') &&
          i.isElement &&
          (y.loop && !o.loop
            ? (Y = !0)
            : !y.loop && o.loop
              ? (G = !0)
              : (P = !0)),
          m.forEach(X => {
            if (xl(y[X]) && xl(o[X]))
              (Object.assign(y[X], o[X]),
                (X === 'navigation' ||
                  X === 'pagination' ||
                  X === 'scrollbar') &&
                  'enabled' in o[X] &&
                  !o[X].enabled &&
                  Q(X));
            else {
              const J = o[X];
              (J === !0 || J === !1) &&
              (X === 'navigation' || X === 'pagination' || X === 'scrollbar')
                ? J === !1 && Q(X)
                : (y[X] = o[X]);
            }
          }),
          m.includes('controller') &&
            !k &&
            i.controller &&
            i.controller.control &&
            y.controller &&
            y.controller.control &&
            (i.controller.control = y.controller.control),
          r.includes('children') && l && x && y.virtual.enabled
            ? ((x.slides = l), x.update(!0))
            : r.includes('virtual') &&
              x &&
              y.virtual.enabled &&
              (l && (x.slides = l), x.update(!0)),
          r.includes('children') && l && y.loop && (P = !0),
          M && D.init() && D.update(!0),
          k && (i.controller.control = y.controller.control),
          V &&
            (i.isElement &&
              (!h || typeof h == 'string') &&
              ((h = document.createElement('div')),
              h.classList.add('swiper-pagination'),
              h.part.add('pagination'),
              i.el.appendChild(h)),
            h && (y.pagination.el = h),
            E.init(),
            E.render(),
            E.update()),
          L &&
            (i.isElement &&
              (!p || typeof p == 'string') &&
              ((p = document.createElement('div')),
              p.classList.add('swiper-scrollbar'),
              p.part.add('scrollbar'),
              i.el.appendChild(p)),
            p && (y.scrollbar.el = p),
            S.init(),
            S.updateSize(),
            S.setTranslate()),
          U &&
            (i.isElement &&
              ((!u || typeof u == 'string') &&
                ((u = document.createElement('div')),
                u.classList.add('swiper-button-next'),
                Rp(u, i.hostEl.constructor.nextButtonSvg),
                u.part.add('button-next'),
                i.el.appendChild(u)),
              (!d || typeof d == 'string') &&
                ((d = document.createElement('div')),
                d.classList.add('swiper-button-prev'),
                Rp(d, i.hostEl.constructor.prevButtonSvg),
                d.part.add('button-prev'),
                i.el.appendChild(d))),
            u && (y.navigation.nextEl = u),
            d && (y.navigation.prevEl = d),
            v.init(),
            v.update()),
          r.includes('allowSlideNext') && (i.allowSlideNext = o.allowSlideNext),
          r.includes('allowSlidePrev') && (i.allowSlidePrev = o.allowSlidePrev),
          r.includes('direction') && i.changeDirection(o.direction, !1),
          (Y || P) && i.loopDestroy(),
          (G || P) && i.loopCreate(),
          i.update());
      }
      function SA(i = {}, l = !0) {
        const o = { on: {} },
          r = {},
          u = {};
        (Rs(o, Op), (o._emitClasses = !0), (o.init = !1));
        const d = {},
          p = lS.map(m => m.replace(/_/, '')),
          h = Object.assign({}, i);
        return (
          Object.keys(h).forEach(m => {
            typeof i[m] > 'u' ||
              (p.indexOf(m) >= 0
                ? xl(i[m])
                  ? ((o[m] = {}), (u[m] = {}), Rs(o[m], i[m]), Rs(u[m], i[m]))
                  : ((o[m] = i[m]), (u[m] = i[m]))
                : m.search(/on[A-Z]/) === 0 && typeof i[m] == 'function'
                  ? l
                    ? (r[`${m[2].toLowerCase()}${m.substr(3)}`] = i[m])
                    : (o.on[`${m[2].toLowerCase()}${m.substr(3)}`] = i[m])
                  : (d[m] = i[m]));
          }),
          ['navigation', 'pagination', 'scrollbar'].forEach(m => {
            (o[m] === !0 && (o[m] = {}), o[m] === !1 && delete o[m]);
          }),
          { params: o, passedParams: u, rest: d, events: r }
        );
      }
      function xA(
        {
          el: i,
          nextEl: l,
          prevEl: o,
          paginationEl: r,
          scrollbarEl: u,
          swiper: d,
        },
        p
      ) {
        (sS(p) &&
          l &&
          o &&
          ((d.params.navigation.nextEl = l),
          (d.originalParams.navigation.nextEl = l),
          (d.params.navigation.prevEl = o),
          (d.originalParams.navigation.prevEl = o)),
          oS(p) &&
            r &&
            ((d.params.pagination.el = r),
            (d.originalParams.pagination.el = r)),
          rS(p) &&
            u &&
            ((d.params.scrollbar.el = u), (d.originalParams.scrollbar.el = u)),
          d.init(i));
      }
      function NA(i, l, o, r, u) {
        const d = [];
        if (!l) return d;
        const p = m => {
          d.indexOf(m) < 0 && d.push(m);
        };
        if (o && r) {
          const m = r.map(u),
            y = o.map(u);
          (m.join('') !== y.join('') && p('children'),
            r.length !== o.length && p('children'));
        }
        return (
          lS
            .filter(m => m[0] === '_')
            .map(m => m.replace(/_/, ''))
            .forEach(m => {
              if (m in i && m in l)
                if (xl(i[m]) && xl(l[m])) {
                  const y = Object.keys(i[m]),
                    E = Object.keys(l[m]);
                  y.length !== E.length
                    ? p(m)
                    : (y.forEach(v => {
                        i[m][v] !== l[m][v] && p(m);
                      }),
                      E.forEach(v => {
                        i[m][v] !== l[m][v] && p(m);
                      }));
                } else i[m] !== l[m] && p(m);
            }),
          d
        );
      }
      const wA = i => {
        !i ||
          i.destroyed ||
          !i.params.virtual ||
          (i.params.virtual && !i.params.virtual.enabled) ||
          (i.updateSlides(),
          i.updateProgress(),
          i.updateSlidesClasses(),
          i.emit('_virtualUpdated'),
          i.parallax &&
            i.params.parallax &&
            i.params.parallax.enabled &&
            i.parallax.setTranslate());
      };
      function Cu() {
        return (
          (Cu = Object.assign
            ? Object.assign.bind()
            : function (i) {
                for (var l = 1; l < arguments.length; l++) {
                  var o = arguments[l];
                  for (var r in o)
                    Object.prototype.hasOwnProperty.call(o, r) && (i[r] = o[r]);
                }
                return i;
              }),
          Cu.apply(this, arguments)
        );
      }
      function uS(i) {
        return (
          i.type &&
          i.type.displayName &&
          i.type.displayName.includes('SwiperSlide')
        );
      }
      function dS(i) {
        const l = [];
        return (
          Et.Children.toArray(i).forEach(o => {
            uS(o)
              ? l.push(o)
              : o.props &&
                o.props.children &&
                dS(o.props.children).forEach(r => l.push(r));
          }),
          l
        );
      }
      function EA(i) {
        const l = [],
          o = {
            'container-start': [],
            'container-end': [],
            'wrapper-start': [],
            'wrapper-end': [],
          };
        return (
          Et.Children.toArray(i).forEach(r => {
            if (uS(r)) l.push(r);
            else if (r.props && r.props.slot && o[r.props.slot])
              o[r.props.slot].push(r);
            else if (r.props && r.props.children) {
              const u = dS(r.props.children);
              u.length > 0
                ? u.forEach(d => l.push(d))
                : o['container-end'].push(r);
            } else o['container-end'].push(r);
          }),
          { slides: l, slots: o }
        );
      }
      function DA(i, l, o) {
        if (!o) return null;
        const r = E => {
            let v = E;
            return (
              E < 0 ? (v = l.length + E) : v >= l.length && (v = v - l.length),
              v
            );
          },
          u = i.isHorizontal()
            ? { [i.rtlTranslate ? 'right' : 'left']: `${o.offset}px` }
            : { top: `${o.offset}px` },
          { from: d, to: p } = o,
          h = i.params.loop ? -l.length : 0,
          m = i.params.loop ? l.length * 2 : l.length,
          y = [];
        for (let E = h; E < m; E += 1) E >= d && E <= p && y.push(l[r(E)]);
        return y.map((E, v) =>
          Et.cloneElement(E, {
            swiper: i,
            style: u,
            key: E.props.virtualIndex || E.key || `slide-${v}`,
          })
        );
      }
      function fr(i, l) {
        return typeof window > 'u'
          ? Z.useEffect(i, l)
          : Z.useLayoutEffect(i, l);
      }
      const V0 = Z.createContext(null),
        TA = Z.createContext(null),
        _i = Z.forwardRef(
          (
            {
              className: i,
              tag: l = 'div',
              wrapperTag: o = 'div',
              children: r,
              onSwiper: u,
              ...d
            } = {},
            p
          ) => {
            let h = !1;
            const [m, y] = Z.useState('swiper'),
              [E, v] = Z.useState(null),
              [S, x] = Z.useState(!1),
              D = Z.useRef(!1),
              M = Z.useRef(null),
              k = Z.useRef(null),
              V = Z.useRef(null),
              L = Z.useRef(null),
              U = Z.useRef(null),
              Y = Z.useRef(null),
              G = Z.useRef(null),
              P = Z.useRef(null),
              { params: Q, passedParams: X, rest: J, events: ee } = SA(d),
              { slides: q, slots: se } = EA(r),
              ge = () => {
                x(!S);
              };
            Object.assign(Q.on, {
              _containerClasses(F, me) {
                y(me);
              },
            });
            const we = () => {
              (Object.assign(Q.on, ee), (h = !0));
              const F = { ...Q };
              if (
                (delete F.wrapperClass,
                (k.current = new _p(F)),
                k.current.virtual && k.current.params.virtual.enabled)
              ) {
                k.current.virtual.slides = q;
                const me = {
                  cache: !1,
                  slides: q,
                  renderExternal: v,
                  renderExternalUpdate: !1,
                };
                (Rs(k.current.params.virtual, me),
                  Rs(k.current.originalParams.virtual, me));
              }
            };
            (M.current || we(),
              k.current && k.current.on('_beforeBreakpoint', ge));
            const We = () => {
                h ||
                  !ee ||
                  !k.current ||
                  Object.keys(ee).forEach(F => {
                    k.current.on(F, ee[F]);
                  });
              },
              K = () => {
                !ee ||
                  !k.current ||
                  Object.keys(ee).forEach(F => {
                    k.current.off(F, ee[F]);
                  });
              };
            (Z.useEffect(() => () => {
              k.current && k.current.off('_beforeBreakpoint', ge);
            }),
              Z.useEffect(() => {
                !D.current &&
                  k.current &&
                  (k.current.emitSlidesClasses(), (D.current = !0));
              }),
              fr(() => {
                if ((p && (p.current = M.current), !!M.current))
                  return (
                    k.current.destroyed && we(),
                    xA(
                      {
                        el: M.current,
                        nextEl: U.current,
                        prevEl: Y.current,
                        paginationEl: G.current,
                        scrollbarEl: P.current,
                        swiper: k.current,
                      },
                      Q
                    ),
                    u && !k.current.destroyed && u(k.current),
                    () => {
                      k.current &&
                        !k.current.destroyed &&
                        k.current.destroy(!0, !1);
                    }
                  );
              }, []),
              fr(() => {
                We();
                const F = NA(X, V.current, q, L.current, me => me.key);
                return (
                  (V.current = X),
                  (L.current = q),
                  F.length &&
                    k.current &&
                    !k.current.destroyed &&
                    vA({
                      swiper: k.current,
                      slides: q,
                      passedParams: X,
                      changedParams: F,
                      nextEl: U.current,
                      prevEl: Y.current,
                      scrollbarEl: P.current,
                      paginationEl: G.current,
                    }),
                  () => {
                    K();
                  }
                );
              }),
              fr(() => {
                wA(k.current);
              }, [E]));
            function ce() {
              return Q.virtual
                ? DA(k.current, q, E)
                : q.map((F, me) =>
                    Et.cloneElement(F, {
                      swiper: k.current,
                      swiperSlideIndex: me,
                    })
                  );
            }
            return Et.createElement(
              l,
              Cu({ ref: M, className: cS(`${m}${i ? ` ${i}` : ''}`) }, J),
              Et.createElement(
                TA.Provider,
                { value: k.current },
                se['container-start'],
                Et.createElement(
                  o,
                  { className: yA(Q.wrapperClass) },
                  se['wrapper-start'],
                  ce(),
                  se['wrapper-end']
                ),
                sS(Q) &&
                  Et.createElement(
                    Et.Fragment,
                    null,
                    Et.createElement('div', {
                      ref: Y,
                      className: 'swiper-button-prev',
                    }),
                    Et.createElement('div', {
                      ref: U,
                      className: 'swiper-button-next',
                    })
                  ),
                rS(Q) &&
                  Et.createElement('div', {
                    ref: P,
                    className: 'swiper-scrollbar',
                  }),
                oS(Q) &&
                  Et.createElement('div', {
                    ref: G,
                    className: 'swiper-pagination',
                  }),
                se['container-end']
              )
            );
          }
        );
      _i.displayName = 'Swiper';
      const ji = Z.forwardRef(
        (
          {
            tag: i = 'div',
            children: l,
            className: o = '',
            swiper: r,
            zoom: u,
            lazy: d,
            virtualIndex: p,
            swiperSlideIndex: h,
            ...m
          } = {},
          y
        ) => {
          const E = Z.useRef(null),
            [v, S] = Z.useState('swiper-slide'),
            [x, D] = Z.useState(!1);
          function M(U, Y, G) {
            Y === E.current && S(G);
          }
          (fr(() => {
            if (
              (typeof h < 'u' && (E.current.swiperSlideIndex = h),
              y && (y.current = E.current),
              !(!E.current || !r))
            ) {
              if (r.destroyed) {
                v !== 'swiper-slide' && S('swiper-slide');
                return;
              }
              return (
                r.on('_slideClass', M),
                () => {
                  r && r.off('_slideClass', M);
                }
              );
            }
          }),
            fr(() => {
              r && E.current && !r.destroyed && S(r.getSlideClasses(E.current));
            }, [r]));
          const k = {
              isActive: v.indexOf('swiper-slide-active') >= 0,
              isVisible: v.indexOf('swiper-slide-visible') >= 0,
              isPrev: v.indexOf('swiper-slide-prev') >= 0,
              isNext: v.indexOf('swiper-slide-next') >= 0,
            },
            V = () => (typeof l == 'function' ? l(k) : l),
            L = () => {
              D(!0);
            };
          return Et.createElement(
            i,
            Cu(
              {
                ref: E,
                className: cS(`${v}${o ? ` ${o}` : ''}`),
                'data-swiper-slide-index': p,
                onLoad: L,
              },
              m
            ),
            u &&
              Et.createElement(
                V0.Provider,
                { value: k },
                Et.createElement(
                  'div',
                  {
                    className: 'swiper-zoom-container',
                    'data-swiper-zoom': typeof u == 'number' ? u : void 0,
                  },
                  V(),
                  d &&
                    !x &&
                    Et.createElement('div', {
                      className: 'swiper-lazy-preloader',
                    })
                )
              ),
            !u &&
              Et.createElement(
                V0.Provider,
                { value: k },
                V(),
                d &&
                  !x &&
                  Et.createElement('div', {
                    className: 'swiper-lazy-preloader',
                  })
              )
          );
        }
      );
      ji.displayName = 'SwiperSlide';
      function CA(i, l, o, r) {
        return (
          i.params.createElements &&
            Object.keys(r).forEach(u => {
              if (!o[u] && o.auto === !0) {
                let d = Sa(i.el, `.${r[u]}`)[0];
                (d ||
                  ((d = Tu('div', r[u])), (d.className = r[u]), i.el.append(d)),
                  (o[u] = d),
                  (l[u] = d));
              }
            }),
          o
        );
      }
      const AA =
        '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
      function RA({ swiper: i, extendParams: l, on: o, emit: r }) {
        (l({
          navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: !0,
            hideOnClick: !1,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled',
          },
        }),
          (i.navigation = { nextEl: null, prevEl: null }));
        function u(x) {
          let D;
          return x &&
            typeof x == 'string' &&
            i.isElement &&
            ((D = i.el.querySelector(x) || i.hostEl.querySelector(x)), D)
            ? D
            : (x &&
                (typeof x == 'string' &&
                  (D = [...document.querySelectorAll(x)]),
                i.params.uniqueNavElements &&
                typeof x == 'string' &&
                D &&
                D.length > 1 &&
                i.el.querySelectorAll(x).length === 1
                  ? (D = i.el.querySelector(x))
                  : D && D.length === 1 && (D = D[0])),
              x && !D ? x : D);
        }
        function d(x, D) {
          const M = i.params.navigation;
          ((x = Ya(x)),
            x.forEach(k => {
              k &&
                (k.classList[D ? 'add' : 'remove'](
                  ...M.disabledClass.split(' ')
                ),
                k.tagName === 'BUTTON' && (k.disabled = D),
                i.params.watchOverflow &&
                  i.enabled &&
                  k.classList[i.isLocked ? 'add' : 'remove'](M.lockClass));
            }));
        }
        function p() {
          const { nextEl: x, prevEl: D } = i.navigation;
          if (i.params.loop) {
            (d(D, !1), d(x, !1));
            return;
          }
          (d(D, i.isBeginning && !i.params.rewind),
            d(x, i.isEnd && !i.params.rewind));
        }
        function h(x) {
          (x.preventDefault(),
            !(i.isBeginning && !i.params.loop && !i.params.rewind) &&
              (i.slidePrev(), r('navigationPrev')));
        }
        function m(x) {
          (x.preventDefault(),
            !(i.isEnd && !i.params.loop && !i.params.rewind) &&
              (i.slideNext(), r('navigationNext')));
        }
        function y() {
          const x = i.params.navigation;
          if (
            ((i.params.navigation = CA(
              i,
              i.originalParams.navigation,
              i.params.navigation,
              { nextEl: 'swiper-button-next', prevEl: 'swiper-button-prev' }
            )),
            !(x.nextEl || x.prevEl))
          )
            return;
          let D = u(x.nextEl),
            M = u(x.prevEl);
          (Object.assign(i.navigation, { nextEl: D, prevEl: M }),
            (D = Ya(D)),
            (M = Ya(M)));
          const k = (V, L) => {
            if (V) {
              if (
                x.addIcons &&
                V.matches('.swiper-button-next,.swiper-button-prev') &&
                !V.querySelector('svg')
              ) {
                const U = document.createElement('div');
                (Rp(U, AA), V.appendChild(U.querySelector('svg')), U.remove());
              }
              V.addEventListener('click', L === 'next' ? m : h);
            }
            !i.enabled && V && V.classList.add(...x.lockClass.split(' '));
          };
          (D.forEach(V => k(V, 'next')), M.forEach(V => k(V, 'prev')));
        }
        function E() {
          let { nextEl: x, prevEl: D } = i.navigation;
          ((x = Ya(x)), (D = Ya(D)));
          const M = (k, V) => {
            (k.removeEventListener('click', V === 'next' ? m : h),
              k.classList.remove(
                ...i.params.navigation.disabledClass.split(' ')
              ));
          };
          (x.forEach(k => M(k, 'next')), D.forEach(k => M(k, 'prev')));
        }
        (o('init', () => {
          i.params.navigation.enabled === !1 ? S() : (y(), p());
        }),
          o('toEdge fromEdge lock unlock', () => {
            p();
          }),
          o('destroy', () => {
            E();
          }),
          o('enable disable', () => {
            let { nextEl: x, prevEl: D } = i.navigation;
            if (((x = Ya(x)), (D = Ya(D)), i.enabled)) {
              p();
              return;
            }
            [...x, ...D]
              .filter(M => !!M)
              .forEach(M => M.classList.add(i.params.navigation.lockClass));
          }),
          o('click', (x, D) => {
            let { nextEl: M, prevEl: k } = i.navigation;
            ((M = Ya(M)), (k = Ya(k)));
            const V = D.target;
            let L = k.includes(V) || M.includes(V);
            if (i.isElement && !L) {
              const U = D.path || (D.composedPath && D.composedPath());
              U && (L = U.find(Y => M.includes(Y) || k.includes(Y)));
            }
            if (i.params.navigation.hideOnClick && !L) {
              if (
                i.pagination &&
                i.params.pagination &&
                i.params.pagination.clickable &&
                (i.pagination.el === V || i.pagination.el.contains(V))
              )
                return;
              let U;
              (M.length
                ? (U = M[0].classList.contains(i.params.navigation.hiddenClass))
                : k.length &&
                  (U = k[0].classList.contains(
                    i.params.navigation.hiddenClass
                  )),
                r(U === !0 ? 'navigationShow' : 'navigationHide'),
                [...M, ...k]
                  .filter(Y => !!Y)
                  .forEach(Y =>
                    Y.classList.toggle(i.params.navigation.hiddenClass)
                  ));
            }
          }));
        const v = () => {
            (i.el.classList.remove(
              ...i.params.navigation.navigationDisabledClass.split(' ')
            ),
              y(),
              p());
          },
          S = () => {
            (i.el.classList.add(
              ...i.params.navigation.navigationDisabledClass.split(' ')
            ),
              E());
          };
        Object.assign(i.navigation, {
          enable: v,
          disable: S,
          update: p,
          init: y,
          destroy: E,
        });
      }
      const jp = 2,
        gr = 300;
      function ya(i) {
        return !!(
          i &&
          i.el &&
          i.wrapperEl &&
          Array.isArray(i.slides) &&
          i.slides.length > 0 &&
          !i.destroyed
        );
      }
      function Vp(i) {
        const l = i.el;
        if (!l) return null;
        let o = l;
        for (; o; ) {
          const { overflow: r, overflowX: u } = getComputedStyle(o);
          if (r === 'hidden' || u === 'hidden') return o;
          o = o.parentElement;
        }
        return l;
      }
      function MA(i) {
        const { params: l } = i,
          o = l.breakpoints ?? {},
          r = Object.keys(o)
            .map(Number)
            .filter(u => i.width >= u)
            .sort((u, d) => d - u);
        if (r.length > 0) {
          const u = o[r[0]];
          if (u?.slidesPerView !== void 0) return u.slidesPerView;
        }
        return l.slidesPerView;
      }
      function Bp(i) {
        const l = MA(i);
        return l === 1 || Number(l) === 1;
      }
      function Lp(i) {
        const { params: l } = i,
          o = l.breakpoints ?? {},
          r = Object.keys(o)
            .map(Number)
            .filter(u => i.width >= u)
            .sort((u, d) => d - u);
        if (r.length > 0) {
          const u = o[r[0]];
          if (u && typeof u.spaceBetween == 'number') return u.spaceBetween;
        }
        return typeof l.spaceBetween == 'number' ? l.spaceBetween : 0;
      }
      function zp(i) {
        const l = Vp(i),
          o = i.slides;
        if (!l || !o.length)
          return { viewportRect: null, firstRect: void 0, lastRect: void 0 };
        const r = l.getBoundingClientRect(),
          u = o[0]?.getBoundingClientRect(),
          d = o[o.length - 1]?.getBoundingClientRect();
        return { viewportRect: r, firstRect: u, lastRect: d };
      }
      function Hp(i) {
        const l = Vp(i);
        if (!l) return i.getTranslate();
        (i.updateSize(), i.updateSlides());
        const o = l.clientWidth,
          r = i.slides.length - 1;
        if (r < 0) return i.getTranslate();
        const u = i.slidesGrid[r] ?? 0,
          d = i.slidesSizesGrid[r] ?? 0,
          p = u + d,
          h = Lp(i);
        return p <= o
          ? i.minTranslate()
          : Math.min(i.minTranslate(), o - p - h);
      }
      function Up(i) {
        if (Bp(i)) return i.activeIndex >= i.slides.length - 1;
        const l = Hp(i);
        return Math.abs(i.getTranslate() - l) <= jp * 2;
      }
      function OA(i) {
        const l = i.slidesSizesGrid[0] ?? 0;
        if (!l) return 1;
        const o = Lp(i);
        return Math.max(1, Math.ceil((i.width + o) / (l + o)));
      }
      function Ip(i) {
        if (Bp(i)) return i.activeIndex <= 0;
        const { viewportRect: l, firstRect: o } = zp(i);
        return !l || !o ? !0 : o.left >= l.left - jp;
      }
      function Wp(i) {
        return Up(i);
      }
      function kA(i) {
        return { isBeginning: Ip(i), isEnd: Wp(i) };
      }
      function _A(i, l) {
        const o = i;
        i.wrapperEl &&
          (o.setTransition(gr),
          (i.translate = l),
          (i.wrapperEl.style.transitionDuration = `${gr}ms`),
          (i.wrapperEl.style.transform = `translate3d(${l}px, 0px, 0px)`),
          o.updateActiveIndex(),
          i.updateProgress(),
          i.updateSlidesClasses());
      }
      function fS(i) {
        const l = i;
        if (!i.wrapperEl) return;
        const o = i.getTranslate();
        (i.wrapperEl.style.removeProperty('transition-duration'),
          i.wrapperEl.style.removeProperty('transform'),
          l.setTransition(0),
          i.setTranslate(o),
          i.update());
      }
      function jA(i) {
        const { viewportRect: l, lastRect: o } = zp(i);
        if (!l) return;
        const r = Hp(i);
        let u = r;
        if (o) {
          const p = o.right - l.right;
          if (p > jp) {
            const h = i.getTranslate() - p;
            u = Math.min(h, r, i.minTranslate());
          }
        }
        _A(i, u);
        const d = i.slides.length - 1;
        d >= 0 &&
          ((i.activeIndex = d), (i.realIndex = d), i.updateSlidesClasses());
      }
      function VA(i) {
        if (Up(i)) return !1;
        const l = i.slides.length - 1;
        if (OA(i) <= 2 && i.activeIndex < l - 1) return !1;
        const { viewportRect: r, lastRect: u } = zp(i);
        if (!r || !u) return !1;
        if (u.left < r.right) return !0;
        const d = Hp(i),
          p = Math.abs(d - i.getTranslate()),
          h = i.activeIndex,
          m = (i.slidesSizesGrid[h + 1] ?? i.slidesSizesGrid[h] ?? 0) + Lp(i);
        return p <= m * 1.5;
      }
      function BA(i) {
        if (!Wp(i)) {
          if (!Bp(i) && VA(i)) {
            jA(i);
            return;
          }
          (mS(i) && (fS(i), i.updateSize(), i.updateSlides()), i.slideNext());
        }
      }
      function LA(i) {
        return Up(i) && !Ip(i);
      }
      function mS(i) {
        if (!i.wrapperEl) return !1;
        const { transform: l, transitionDuration: o } = i.wrapperEl.style;
        return l !== '' || o !== '';
      }
      function zA(i, l) {
        const o = Math.max(0, Math.min(l, i.slides.length - 1));
        i.slideTo(o, gr);
      }
      function HA(i) {
        if (!Ip(i)) {
          if ((mS(i) && (fS(i), i.updateSize(), i.updateSlides()), LA(i))) {
            zA(i, Math.max(0, i.slides.length - 2));
            return;
          }
          i.slidePrev();
        }
      }
      function Nl() {
        const i = Z.useRef(null),
          l = Z.useRef(null),
          [o, r] = Z.useState(!0),
          [u, d] = Z.useState(!1),
          p = Z.useCallback(x => {
            if (!ya(x)) return;
            const D = kA(x);
            (r(D.isBeginning), d(D.isEnd));
          }, []),
          h = Z.useCallback(
            x => {
              ya(x) &&
                (p(x),
                requestAnimationFrame(() => {
                  ya(x) && p(x);
                }));
            },
            [p]
          ),
          m = Z.useCallback(
            x => {
              if ((l.current?.disconnect(), !ya(x))) return;
              const D = Vp(x);
              if (!D) return;
              const M = new ResizeObserver(() => {
                ya(i.current) && h(i.current);
              });
              (M.observe(D),
                x.wrapperEl && M.observe(x.wrapperEl),
                (l.current = M));
            },
            [h]
          ),
          y = Z.useCallback(
            x => {
              ya(x) && ((i.current = x), m(x), h(x));
            },
            [m, h]
          );
        Z.useEffect(
          () => () => {
            (l.current?.disconnect(), (i.current = null));
          },
          []
        );
        const E = Z.useCallback(() => {
            const x = i.current;
            !ya(x) ||
              Wp(x) ||
              (BA(x),
              window.setTimeout(() => {
                ya(i.current) && h(i.current);
              }, gr + 50));
          }, [h]),
          v = Z.useCallback(() => {
            const x = i.current;
            ya(x) &&
              (HA(x),
              window.setTimeout(() => {
                ya(i.current) && h(i.current);
              }, gr + 50));
          }, [h]);
        return {
          swiperRef: i,
          isBeginning: o,
          isEnd: u,
          goNext: E,
          goPrev: v,
          swiperNavHandlers: {
            onSwiper: y,
            onSlideChange: h,
            onTransitionEnd: p,
            onSetTranslate: p,
            onResize: h,
            onUpdate: h,
            onDestroy: () => {
              (l.current?.disconnect(), (i.current = null));
            },
          },
          applyNavState: p,
        };
      }
      function Ms(i, l = 3e3) {
        return typeof window.requestIdleCallback == 'function'
          ? window.requestIdleCallback(i, { timeout: l })
          : window.setTimeout(i, 1500);
      }
      function pS(i) {
        if (typeof window.cancelIdleCallback == 'function') {
          window.cancelIdleCallback(i);
          return;
        }
        window.clearTimeout(i);
      }
      function UA(i) {
        const l = document.createElement('video');
        ((l.preload = 'auto'), (l.muted = !0), (l.src = i), l.load());
      }
      function hS(i) {
        const l = new Image();
        l.src = i;
      }
      function gS(i, l, o) {
        const r = Z.useRef(new Set()),
          u = i.map(d => `${d.video ?? ''}|${d.image ?? ''}`).join(',');
        Z.useEffect(() => {
          const d = i.flatMap(y => {
            const E = o(y.video),
              v = o(y.image);
            return [
              E && E !== l ? { url: E, type: 'video' } : null,
              v && v !== l ? { url: v, type: 'image' } : null,
            ].filter(S => !!S);
          });
          let p = !1,
            h;
          const m = y => {
            if (p || y >= d.length) return;
            const E = d[y];
            if (!E || r.current.has(E.url)) {
              h = Ms(() => m(y + 1));
              return;
            }
            (r.current.add(E.url),
              E.type === 'video' ? UA(E.url) : hS(E.url),
              (h = Ms(() => m(y + 1))));
          };
          return (
            (h = Ms(() => m(0))),
            () => {
              ((p = !0), h !== void 0 && pS(h));
            }
          );
        }, [u, l, o]);
      }
      function bS(i) {
        const l = Z.useRef(new Set()),
          o = i.filter(Boolean).join('|');
        Z.useEffect(() => {
          const r = i.filter(h => h && !l.current.has(h));
          let u = !1,
            d;
          const p = h => {
            if (u || h >= r.length) return;
            const m = r[h];
            if (!m) {
              d = Ms(() => p(h + 1));
              return;
            }
            (l.current.add(m), hS(m), (d = Ms(() => p(h + 1))));
          };
          return (
            r.length > 0 && (d = Ms(() => p(0))),
            () => {
              ((u = !0), d !== void 0 && pS(d));
            }
          );
        }, [o]);
      }
      function yS(i) {
        return Z.useCallback(
          l => {
            if (!l) return '';
            if (l.startsWith('http://') || l.startsWith('https://')) return l;
            const o = i(l);
            return o && o !== l ? o : '';
          },
          [i]
        );
      }
      const IA = 'carousel_LvofU',
        WA = 'title_hN-aN',
        $A = 'subtitle_IOmhU',
        PA = 'tabs_e8BP4',
        GA = 'tab_agWkr',
        qA = 'tabActive_Ok-9o',
        YA = 'mbSwiperArea_HK6be',
        XA = 'mbNavBtn_sPxn1',
        QA = 'mbSwiperWrap_akCDa',
        ZA = 'mbSwiper_98H2D',
        FA = 'mbSlideImage_f9Uuy',
        KA = 'swiperArea_eL1Xy',
        JA = 'swiper_U3ncM',
        eR = 'slideLayout_YK3S-',
        tR = 'slideImage_6N1wV',
        nR = 'slideLeft_Fwu9b',
        aR = 'slideRight_nzb2z',
        iR = 'slideMiddle_GnFFp',
        lR = 'navBtn_D-bm6',
        sR = 'navPrev_vCGeK',
        oR = 'navNext_wuzwj',
        rR = 'indicators_bBwa5',
        cR = 'indicatorScroller_Ul-4U',
        uR = 'indicatorTrackWrap_DOmDP',
        dR = 'indicatorTrack_F0Agt',
        fR = 'indicator_4SW7b',
        mR = 'indicatorActive_0v52-',
        pR = 'indicatorLabel_c8MDR',
        hR = 'indicatorDot_8flWE',
        gR = 'indicatorBar_dJz1j',
        Be = {
          carousel: IA,
          title: WA,
          subtitle: $A,
          tabs: PA,
          tab: GA,
          tabActive: qA,
          mbSwiperArea: YA,
          mbNavBtn: XA,
          mbSwiperWrap: QA,
          mbSwiper: ZA,
          mbSlideImage: FA,
          swiperArea: KA,
          swiper: JA,
          slideLayout: eR,
          slideImage: tR,
          slideLeft: nR,
          slideRight: aR,
          slideMiddle: iR,
          navBtn: lR,
          navPrev: sR,
          navNext: oR,
          indicators: rR,
          indicatorScroller: cR,
          indicatorTrackWrap: uR,
          indicatorTrack: dR,
          indicator: fR,
          indicatorActive: mR,
          indicatorLabel: pR,
          indicatorDot: hR,
          indicatorBar: gR,
        };
      function mr(i, l, o) {
        if (!i) return '';
        const r = l === 'mb' ? `${i}Mobile` : i,
          u = o(r);
        return u && u !== r ? u : '';
      }
      function B0(i, l) {
        const o = [];
        for (const r of i) {
          if (r.image) {
            const u = mr(r.image, 'pc', l),
              d = mr(r.image, 'mb', l);
            (u && o.push(u), d && o.push(d));
          }
          if (r.indicator) {
            const u = mr(r.indicator, 'pc', l);
            u && o.push(u);
          }
        }
        return o;
      }
      function bR() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          [o, r] = Z.useState('diode'),
          [u, d] = Z.useState(0),
          [p, h] = Z.useState({ left: 0, width: 0 }),
          m = Nl(),
          y = Nl(),
          E = Z.useRef(null),
          v = Z.useRef(null),
          S = Z.useRef([]),
          x = i('section5.materialCarousel', { returnObjects: !0 }),
          D = x[o]?.slides ?? [],
          M = x.ir?.slides ?? [],
          k = Z.useMemo(() => {
            const P = B0(M, l);
            if (o === 'diode') return P;
            if (o === 'ir') {
              const Q = M[u];
              if (!Q) return P;
              const X = new Set(B0([Q], l));
              return P.filter(J => !X.has(J));
            }
            return [];
          }, [o, u, M, l]);
        bS(k);
        const V = P => o !== 'ir' || P === u,
          L = Z.useCallback(() => {
            const P = E.current,
              Q = S.current[u];
            if (!P || !Q) {
              h({ left: 0, width: 0 });
              return;
            }
            const J = Q.querySelector(`.${Be.indicatorLabel}`) ?? Q;
            let ee = 0,
              q = J;
            for (; q && q !== P; ) ((ee += q.offsetLeft), (q = q.offsetParent));
            h({ left: ee, width: J.offsetWidth });
          }, [u]);
        (Z.useLayoutEffect(() => {
          (L(), window.addEventListener('resize', L));
          const P = v.current;
          return (
            P?.addEventListener('scroll', L, { passive: !0 }),
            () => {
              (window.removeEventListener('resize', L),
                P?.removeEventListener('scroll', L));
            }
          );
        }, [u, o, D.length, L]),
          Z.useEffect(() => {
            const P = v.current,
              Q = S.current[u];
            if (!Q) return;
            if (P && P.scrollWidth > P.clientWidth) {
              const J = P.getBoundingClientRect(),
                ee = Q.getBoundingClientRect(),
                q =
                  P.scrollLeft +
                  (ee.left - J.left) -
                  P.clientWidth / 2 +
                  ee.width / 2,
                se = P.scrollWidth - P.clientWidth;
              P.scrollTo({
                left: Math.max(0, Math.min(q, se)),
                behavior: 'smooth',
              });
            }
            const X = window.setTimeout(L, 320);
            return () => window.clearTimeout(X);
          }, [u, o, L]));
        const U = P => {
            P !== o &&
              (r(P),
              d(0),
              m.swiperRef.current?.slideTo(0),
              y.swiperRef.current?.slideTo(0));
          },
          Y = P => {
            d(P);
          },
          G = P => {
            (d(P),
              m.swiperRef.current?.slideTo(P),
              y.swiperRef.current?.slideTo(P));
          };
        return g.jsxDEV(
          'div',
          {
            className: Be.carousel,
            children: [
              g.jsxDEV(
                'h2',
                {
                  className: Be.title,
                  dangerouslySetInnerHTML: {
                    __html: i('section5.materialsTitle'),
                  },
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                  lineNumber: 184,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'p',
                {
                  className: Be.subtitle,
                  children: i('section5.materialsSubtitle'),
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                  lineNumber: 188,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Be.tabs,
                  children: [
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${Be.tab} ${o === 'diode' ? Be.tabActive : ''}`,
                        onClick: () => U('diode'),
                        children: i('section5.tabDiode'),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 191,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${Be.tab} ${o === 'ir' ? Be.tabActive : ''}`,
                        onClick: () => U('ir'),
                        children: i('section5.tabIR'),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 198,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                  lineNumber: 190,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Be.mbSwiperArea,
                  children: [
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${Be.mbNavBtn} ${Be.mbNavPrev}`,
                        onClick: y.goPrev,
                        disabled: y.isBeginning,
                        'aria-label': 'Previous slide',
                        children: g.jsxDEV(
                          Rt,
                          { name: 'icon-left' },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 215,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 208,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: Be.mbSwiperWrap,
                        children: g.jsxDEV(
                          _i,
                          {
                            className: Be.mbSwiper,
                            slidesPerView: 1,
                            spaceBetween: 0,
                            watchOverflow: !0,
                            observer: !0,
                            observeParents: !0,
                            ...y.swiperNavHandlers,
                            onSlideChange: P => {
                              (y.swiperNavHandlers.onSlideChange(P),
                                Y(P.activeIndex));
                            },
                            children: D.map((P, Q) =>
                              g.jsxDEV(
                                ji,
                                {
                                  children: P.image
                                    ? g.jsxDEV(
                                        'div',
                                        {
                                          className: Be.mbSlideImage,
                                          style: V(Q)
                                            ? {
                                                backgroundImage: `url(${mr(P.image, 'mb', l)})`,
                                              }
                                            : void 0,
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                          lineNumber: 236,
                                          columnNumber: 19,
                                        },
                                        this
                                      )
                                    : null,
                                },
                                `mb-${o}-${P.label}-${Q}`,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                  lineNumber: 234,
                                  columnNumber: 15,
                                },
                                this
                              )
                            ),
                          },
                          `mb-${o}`,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 219,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 218,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${Be.mbNavBtn} ${Be.mbNavNext}`,
                        onClick: y.goNext,
                        disabled: y.isEnd,
                        'aria-label': 'Next slide',
                        children: g.jsxDEV(
                          Rt,
                          { name: 'icon-More' },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 259,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 252,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                  lineNumber: 207,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Be.swiperArea,
                  children: [
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${Be.navBtn} ${Be.navPrev}`,
                        onClick: m.goPrev,
                        disabled: m.isBeginning,
                        'aria-label': 'Previous slide',
                        children: g.jsxDEV(
                          Rt,
                          { name: 'icon-left' },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 271,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 264,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      _i,
                      {
                        className: Be.swiper,
                        modules: [RA],
                        slidesPerView: 1,
                        spaceBetween: 0,
                        ...m.swiperNavHandlers,
                        onSlideChange: P => {
                          (m.swiperNavHandlers.onSlideChange(P),
                            Y(P.activeIndex));
                        },
                        children: D.map((P, Q) =>
                          g.jsxDEV(
                            ji,
                            {
                              children: P.image
                                ? g.jsxDEV(
                                    'div',
                                    {
                                      className: Be.slideImage,
                                      style: V(Q)
                                        ? {
                                            backgroundImage: `url(${mr(P.image, 'pc', l)})`,
                                          }
                                        : void 0,
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                      lineNumber: 289,
                                      columnNumber: 17,
                                    },
                                    this
                                  )
                                : g.jsxDEV(
                                    'div',
                                    {
                                      className: Be.slideLayout,
                                      children: [
                                        g.jsxDEV(
                                          'div',
                                          {
                                            className: Be.slideLeft,
                                            style: {
                                              backgroundImage: `url(${l(P.left)})`,
                                            },
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                            lineNumber: 301,
                                            columnNumber: 19,
                                          },
                                          this
                                        ),
                                        g.jsxDEV(
                                          'div',
                                          {
                                            className: Be.slideMiddle,
                                            children: [
                                              g.jsxDEV(
                                                Ft,
                                                {
                                                  src: l(P.midTop),
                                                  width: '100%',
                                                  height: '100%',
                                                  alt: '',
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                                  lineNumber: 306,
                                                  columnNumber: 21,
                                                },
                                                this
                                              ),
                                              g.jsxDEV(
                                                Ft,
                                                {
                                                  src: l(P.midBottom),
                                                  width: '100%',
                                                  height: '100%',
                                                  alt: '',
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                                  lineNumber: 307,
                                                  columnNumber: 21,
                                                },
                                                this
                                              ),
                                            ],
                                          },
                                          void 0,
                                          !0,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                            lineNumber: 305,
                                            columnNumber: 19,
                                          },
                                          this
                                        ),
                                        g.jsxDEV(
                                          'div',
                                          {
                                            className: Be.slideRight,
                                            style: {
                                              backgroundImage: `url(${l(P.right)})`,
                                            },
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                            lineNumber: 309,
                                            columnNumber: 19,
                                          },
                                          this
                                        ),
                                      ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                      lineNumber: 300,
                                      columnNumber: 17,
                                    },
                                    this
                                  ),
                            },
                            `pc-${o}-${P.label}-${Q}`,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                              lineNumber: 287,
                              columnNumber: 13,
                            },
                            this
                          )
                        ),
                      },
                      `pc-${o}`,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 274,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${Be.navBtn} ${Be.navNext}`,
                        onClick: m.goNext,
                        disabled: m.isEnd,
                        'aria-label': 'Next slide',
                        children: g.jsxDEV(
                          Rt,
                          { name: 'icon-More' },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                            lineNumber: 326,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                        lineNumber: 319,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                  lineNumber: 263,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Be.indicators,
                  children: g.jsxDEV(
                    'div',
                    {
                      className: Be.indicatorScroller,
                      ref: v,
                      children: g.jsxDEV(
                        'div',
                        {
                          className: Be.indicatorTrackWrap,
                          children: g.jsxDEV(
                            'div',
                            {
                              className: Be.indicatorTrack,
                              ref: E,
                              children: [
                                D.map((P, Q) =>
                                  g.jsxDEV(
                                    'button',
                                    {
                                      ref: X => {
                                        S.current[Q] = X;
                                      },
                                      type: 'button',
                                      className: `${Be.indicator} ${u === Q ? Be.indicatorActive : ''}`,
                                      onClick: () => G(Q),
                                      children: [
                                        g.jsxDEV(
                                          'span',
                                          {
                                            className: Be.indicatorDot,
                                            style: P.indicator
                                              ? {
                                                  backgroundImage: `url(${l(P.indicator)})`,
                                                }
                                              : void 0,
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                            lineNumber: 344,
                                            columnNumber: 17,
                                          },
                                          this
                                        ),
                                        g.jsxDEV(
                                          'span',
                                          {
                                            className: Be.indicatorLabel,
                                            children: P.label,
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                            lineNumber: 352,
                                            columnNumber: 17,
                                          },
                                          this
                                        ),
                                      ],
                                    },
                                    `${o}-indicator-${P.label}`,
                                    !0,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                      lineNumber: 335,
                                      columnNumber: 15,
                                    },
                                    this
                                  )
                                ),
                                g.jsxDEV(
                                  'span',
                                  {
                                    className: Be.indicatorBar,
                                    style: { left: p.left, width: p.width },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                                    lineNumber: 355,
                                    columnNumber: 13,
                                  },
                                  this
                                ),
                              ],
                            },
                            void 0,
                            !0,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                              lineNumber: 333,
                              columnNumber: 13,
                            },
                            this
                          ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                          lineNumber: 332,
                          columnNumber: 11,
                        },
                        this
                      ),
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                      lineNumber: 331,
                      columnNumber: 9,
                    },
                    this
                  ),
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
                  lineNumber: 330,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/MaterialCarousel.tsx',
            lineNumber: 183,
            columnNumber: 5,
          },
          this
        );
      }
      const yR = 'gallery_R6rnd',
        vR = 'title_-960h',
        SR = 'swiperWrap_VjnvV',
        xR = 'swiper_Foqi1',
        NR = 'slide_pFsJS',
        wR = 'card_uPRwT',
        ER = 'cardImage_hYiPs',
        DR = 'cardLabel_JQrng',
        TR = 'footer_lF3vL',
        CR = 'dots_fWU81',
        AR = 'dot_eOumJ',
        RR = 'dotActive_Xglla',
        MR = 'navBtns_KmL5D',
        OR = 'navBtn_19Ows',
        Zt = {
          gallery: yR,
          title: vR,
          swiperWrap: SR,
          swiper: xR,
          slide: NR,
          card: wR,
          cardImage: ER,
          cardLabel: DR,
          footer: TR,
          dots: CR,
          dot: AR,
          dotActive: RR,
          navBtns: MR,
          navBtn: OR,
        };
      function kR(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const o = l(i);
        return o && o !== i ? o : '';
      }
      function _R() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          [o, r] = Z.useState(0),
          {
            swiperRef: u,
            isBeginning: d,
            isEnd: p,
            goNext: h,
            goPrev: m,
            swiperNavHandlers: y,
          } = Nl(),
          E = i('section5.gallerySlides', { returnObjects: !0 }),
          v = D => {
            (y.onSwiper(D), r(D.activeIndex));
          },
          S = D => {
            (y.onSlideChange(D), r(D.activeIndex));
          },
          x = D => {
            u.current?.slideTo(D);
          };
        return g.jsxDEV(
          'div',
          {
            className: Zt.gallery,
            children: [
              g.jsxDEV(
                'h3',
                { className: Zt.title, children: i('section5.galleryTitle') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                  lineNumber: 46,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Zt.swiperWrap,
                  children: g.jsxDEV(
                    _i,
                    {
                      className: Zt.swiper,
                      slidesPerView: 'auto',
                      spaceBetween: 12,
                      watchOverflow: !0,
                      observer: !0,
                      observeParents: !0,
                      breakpoints: { 769: { spaceBetween: 19 } },
                      onSwiper: v,
                      onSlideChange: S,
                      onTransitionEnd: y.onTransitionEnd,
                      onSetTranslate: y.onSetTranslate,
                      onResize: y.onResize,
                      onUpdate: y.onUpdate,
                      onDestroy: y.onDestroy,
                      children: E.map((D, M) => {
                        const k = kR(D.image, l);
                        return g.jsxDEV(
                          ji,
                          {
                            className: Zt.slide,
                            children: g.jsxDEV(
                              'div',
                              {
                                className: Zt.card,
                                children: [
                                  g.jsxDEV(
                                    'div',
                                    {
                                      className: Zt.cardImage,
                                      style: k
                                        ? { backgroundImage: `url(${k})` }
                                        : void 0,
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                                      lineNumber: 73,
                                      columnNumber: 19,
                                    },
                                    this
                                  ),
                                  g.jsxDEV(
                                    'span',
                                    {
                                      className: Zt.cardLabel,
                                      children: D.label,
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                                      lineNumber: 77,
                                      columnNumber: 19,
                                    },
                                    this
                                  ),
                                ],
                              },
                              void 0,
                              !0,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                                lineNumber: 72,
                                columnNumber: 17,
                              },
                              this
                            ),
                          },
                          `${D.label}-${M}`,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                            lineNumber: 71,
                            columnNumber: 15,
                          },
                          this
                        );
                      }),
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                      lineNumber: 49,
                      columnNumber: 9,
                    },
                    this
                  ),
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                  lineNumber: 48,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Zt.footer,
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: Zt.dots,
                        'aria-hidden': E.length <= 1,
                        children: E.map((D, M) =>
                          g.jsxDEV(
                            'button',
                            {
                              type: 'button',
                              className: `${Zt.dot} ${M === o ? Zt.dotActive : ''}`,
                              onClick: () => x(M),
                              'aria-label': `Go to ${D.label}`,
                              'aria-current': M === o ? 'true' : void 0,
                            },
                            `dot-${D.label}-${M}`,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                              lineNumber: 88,
                              columnNumber: 13,
                            },
                            this
                          )
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                        lineNumber: 86,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: Zt.navBtns,
                        children: [
                          g.jsxDEV(
                            'button',
                            {
                              type: 'button',
                              className: Zt.navBtn,
                              onClick: m,
                              disabled: d,
                              'aria-label': 'Previous',
                              children: g.jsxDEV(
                                Rt,
                                { name: 'icon-left' },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                                  lineNumber: 107,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                              lineNumber: 100,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'button',
                            {
                              type: 'button',
                              className: Zt.navBtn,
                              onClick: h,
                              disabled: p,
                              'aria-label': 'Next',
                              children: g.jsxDEV(
                                Rt,
                                { name: 'icon-More' },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                                  lineNumber: 116,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                              lineNumber: 109,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                        lineNumber: 99,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
                  lineNumber: 85,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/GalleryCarousel.tsx',
            lineNumber: 45,
            columnNumber: 5,
          },
          this
        );
      }
      const jR = 'carousel_xwq7o',
        VR = 'swiperWrap_gWo4U',
        BR = 'swiper_7ukWf',
        LR = 'slide_cNj4O',
        zR = 'card_4uwbg',
        HR = 'cardImage_jHVBU',
        UR = 'cardTitle_Bq5Yt',
        IR = 'cardDesc_sktHs',
        Oi = {
          carousel: jR,
          swiperWrap: VR,
          swiper: BR,
          slide: LR,
          card: zR,
          cardImage: HR,
          cardTitle: UR,
          cardDesc: IR,
        },
        WR = ['stability1', 'stability2', 'stability3'];
      function $R() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          { swiperNavHandlers: o } = Nl(),
          r = i('section5.stabilityCards', { returnObjects: !0 });
        return g.jsxDEV(
          'div',
          {
            className: Oi.carousel,
            children: g.jsxDEV(
              'div',
              {
                className: Oi.swiperWrap,
                children: g.jsxDEV(
                  _i,
                  {
                    className: Oi.swiper,
                    slidesPerView: 'auto',
                    spaceBetween: 8,
                    watchOverflow: !0,
                    observer: !0,
                    observeParents: !0,
                    ...o,
                    children: r.map((u, d) =>
                      g.jsxDEV(
                        ji,
                        {
                          className: Oi.slide,
                          children: g.jsxDEV(
                            'div',
                            {
                              className: Oi.card,
                              children: [
                                g.jsxDEV(
                                  'div',
                                  {
                                    className: Oi.cardImage,
                                    style: {
                                      backgroundImage: `url(${l(WR[d])})`,
                                    },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
                                    lineNumber: 34,
                                    columnNumber: 17,
                                  },
                                  this
                                ),
                                g.jsxDEV(
                                  'h3',
                                  {
                                    className: Oi.cardTitle,
                                    children: u.title,
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
                                    lineNumber: 38,
                                    columnNumber: 17,
                                  },
                                  this
                                ),
                                g.jsxDEV(
                                  'p',
                                  {
                                    className: Oi.cardDesc,
                                    dangerouslySetInnerHTML: {
                                      __html: u.description,
                                    },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
                                    lineNumber: 39,
                                    columnNumber: 17,
                                  },
                                  this
                                ),
                              ],
                            },
                            void 0,
                            !0,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
                              lineNumber: 33,
                              columnNumber: 15,
                            },
                            this
                          ),
                        },
                        u.title,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
                          lineNumber: 32,
                          columnNumber: 13,
                        },
                        this
                      )
                    ),
                  },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
                    lineNumber: 22,
                    columnNumber: 9,
                  },
                  this
                ),
              },
              void 0,
              !1,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
                lineNumber: 21,
                columnNumber: 7,
              },
              this
            ),
          },
          void 0,
          !1,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/StabilityMobileCarousel.tsx',
            lineNumber: 20,
            columnNumber: 5,
          },
          this
        );
      }
      const PR = 'section5_3PilT',
        GR = 'hero_tDE-u',
        qR = 'section5Body_RcwTT',
        YR = 'stabilityMobile_yXdGE',
        XR = 'stabilityDesktop_4fLYG',
        QR = 'stabilityImages_iM22f',
        ZR = 'stabilityImage_u36NI',
        FR = 'stabilityTexts_q5hrJ',
        KR = 'stabilityText_28tAB',
        Xa = {
          section5: PR,
          hero: GR,
          section5Body: qR,
          stabilityMobile: YR,
          stabilityDesktop: XR,
          stabilityImages: QR,
          stabilityImage: ZR,
          stabilityTexts: FR,
          stabilityText: KR,
        },
        JR = ['stability1', 'stability2', 'stability3'];
      function eM() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          r = wl(l, 'stabilityHero', 'stabilityHeroMobile', o),
          u = i('section5.stabilityCards', { returnObjects: !0 });
        return g.jsxDEV(
          'section',
          {
            className: Xa.section5,
            children: [
              g.jsxDEV(
                'div',
                {
                  className: Xa.hero,
                  style: { backgroundImage: `url(${r})` },
                  children: g.jsxDEV(
                    'h2',
                    {
                      dangerouslySetInnerHTML: {
                        __html: i('section5.heroTitle'),
                      },
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                      lineNumber: 27,
                      columnNumber: 9,
                    },
                    this
                  ),
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                  lineNumber: 23,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Xa.section5Body,
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: Xa.stabilityMobile,
                        children: g.jsxDEV(
                          $R,
                          {},
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                            lineNumber: 32,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                        lineNumber: 31,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: Xa.stabilityDesktop,
                        children: [
                          g.jsxDEV(
                            'div',
                            {
                              className: Xa.stabilityImages,
                              children: JR.map(d =>
                                g.jsxDEV(
                                  'div',
                                  {
                                    className: Xa.stabilityImage,
                                    style: { backgroundImage: `url(${l(d)})` },
                                  },
                                  d,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                                    lineNumber: 38,
                                    columnNumber: 15,
                                  },
                                  this
                                )
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                              lineNumber: 36,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'div',
                            {
                              className: Xa.stabilityTexts,
                              children: u.map((d, p) =>
                                g.jsxDEV(
                                  'div',
                                  {
                                    className: Xa.stabilityText,
                                    children: [
                                      g.jsxDEV(
                                        'h3',
                                        { children: d.title },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                                          lineNumber: 49,
                                          columnNumber: 17,
                                        },
                                        this
                                      ),
                                      g.jsxDEV(
                                        'p',
                                        {
                                          dangerouslySetInnerHTML: {
                                            __html: d.description,
                                          },
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                                          lineNumber: 50,
                                          columnNumber: 17,
                                        },
                                        this
                                      ),
                                    ],
                                  },
                                  p,
                                  !0,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                                    lineNumber: 48,
                                    columnNumber: 15,
                                  },
                                  this
                                )
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                              lineNumber: 46,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                        lineNumber: 35,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      bR,
                      {},
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                        lineNumber: 56,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      _R,
                      {},
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                        lineNumber: 58,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
                  lineNumber: 30,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section5/index.tsx',
            lineNumber: 22,
            columnNumber: 5,
          },
          this
        );
      }
      const tM = 'carousel_-p4SC',
        nM = 'swiperWrap_npjbi',
        aM = 'swiper_MyDDB',
        iM = 'slide_-X2BZ',
        lM = 'cardImage_xMCmV',
        cr = {
          carousel: tM,
          swiperWrap: nM,
          swiper: aM,
          slide: iM,
          cardImage: lM,
        },
        sM = ['workspaceCard1', 'workspaceCard2', 'workspaceCard3'];
      function oM() {
        const { t: i } = Se('imageUrl'),
          { swiperNavHandlers: l } = Nl();
        return g.jsxDEV(
          'div',
          {
            className: cr.carousel,
            children: g.jsxDEV(
              'div',
              {
                className: cr.swiperWrap,
                children: g.jsxDEV(
                  _i,
                  {
                    className: cr.swiper,
                    slidesPerView: 'auto',
                    spaceBetween: 14,
                    watchOverflow: !0,
                    observer: !0,
                    observeParents: !0,
                    ...l,
                    children: sM.map(o =>
                      g.jsxDEV(
                        ji,
                        {
                          className: cr.slide,
                          children: g.jsxDEV(
                            'div',
                            {
                              className: cr.cardImage,
                              style: { backgroundImage: `url(${i(o)})` },
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/WorkspaceMobileCarousel.tsx',
                              lineNumber: 27,
                              columnNumber: 15,
                            },
                            this
                          ),
                        },
                        o,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/WorkspaceMobileCarousel.tsx',
                          lineNumber: 26,
                          columnNumber: 13,
                        },
                        this
                      )
                    ),
                  },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/WorkspaceMobileCarousel.tsx',
                    lineNumber: 16,
                    columnNumber: 9,
                  },
                  this
                ),
              },
              void 0,
              !1,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/WorkspaceMobileCarousel.tsx',
                lineNumber: 15,
                columnNumber: 7,
              },
              this
            ),
          },
          void 0,
          !1,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/WorkspaceMobileCarousel.tsx',
            lineNumber: 14,
            columnNumber: 5,
          },
          this
        );
      }
      const rM = 'section6_e9TEq',
        cM = 'textBlock_UnAYk',
        uM = 'title_QoVWP',
        dM = 'subtitleRow_iCfKz',
        fM = 'workspace_iI7Ee',
        mM = 'subtitle_CXU3M',
        pM = 'description_o-9zM',
        hM = 'emDash_MxFFd',
        gM = 'visualPanel_5BxTO',
        bM = 'visual_xNOGZ',
        yM = 'cardsMobile_1QsGQ',
        vM = 'cardsDesktop_KXH-O',
        SM = 'card_ZicBz',
        Nn = {
          section6: rM,
          textBlock: cM,
          title: uM,
          subtitleRow: dM,
          workspace: fM,
          subtitle: mM,
          description: pM,
          emDash: hM,
          visualPanel: gM,
          visual: bM,
          cardsMobile: yM,
          cardsDesktop: vM,
          card: SM,
        },
        xM = ['workspaceCard1', 'workspaceCard2', 'workspaceCard3'];
      function NM() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          r = wl(l, 'workspaceBg', 'workspaceBgMobile', o);
        return g.jsxDEV(
          'section',
          {
            className: Nn.section6,
            style: o ? void 0 : { backgroundImage: `url(${r})` },
            children: [
              g.jsxDEV(
                'div',
                {
                  className: Nn.textBlock,
                  children: [
                    g.jsxDEV(
                      'h2',
                      { className: Nn.title, children: i('section6.title') },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                        lineNumber: 21,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: Nn.subtitleRow,
                        children: [
                          g.jsxDEV(
                            'span',
                            {
                              className: Nn.workspace,
                              children: i('section6.workspace'),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                              lineNumber: 23,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'span',
                            {
                              className: Nn.subtitle,
                              children: i('section6.subtitle'),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                              lineNumber: 24,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                        lineNumber: 22,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'p',
                      {
                        className: Nn.description,
                        children: [
                          i('section6.description'),
                          g.jsxDEV(
                            'span',
                            {
                              className: Nn.emDash,
                              children: i('section6.emDash'),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                              lineNumber: 28,
                              columnNumber: 11,
                            },
                            this
                          ),
                          i('section6.descriptionEnd'),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                        lineNumber: 26,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                  lineNumber: 20,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Nn.visualPanel,
                  children: [
                    o
                      ? g.jsxDEV(
                          'div',
                          {
                            className: Nn.visual,
                            style: { backgroundImage: `url(${r})` },
                            role: 'img',
                            'aria-hidden': !0,
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                            lineNumber: 35,
                            columnNumber: 11,
                          },
                          this
                        )
                      : null,
                    g.jsxDEV(
                      'div',
                      {
                        className: Nn.cardsMobile,
                        children: g.jsxDEV(
                          oM,
                          {},
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                            lineNumber: 44,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                        lineNumber: 43,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                  lineNumber: 33,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: Nn.cardsDesktop,
                  children: xM.map(u =>
                    g.jsxDEV(
                      'div',
                      {
                        className: Nn.card,
                        style: { backgroundImage: `url(${l(u)})` },
                      },
                      u,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                        lineNumber: 50,
                        columnNumber: 11,
                      },
                      this
                    )
                  ),
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
                  lineNumber: 48,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section6/index.tsx',
            lineNumber: 16,
            columnNumber: 5,
          },
          this
        );
      }
      const wM = 'section7_-lobQ',
        EM = 'textBlock_np-f0',
        DM = 'title_TjISs',
        TM = 'subtitle_PifQH',
        CM = 'visual_yUhoy',
        ur = {
          section7: wM,
          textBlock: EM,
          title: DM,
          subtitle: TM,
          visual: CM,
        };
      function AM() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          r = wl(l, 'speedBg', 'speedBgMobile', o);
        return g.jsxDEV(
          'section',
          {
            className: ur.section7,
            style: o ? void 0 : { backgroundImage: `url(${r})` },
            children: [
              g.jsxDEV(
                'div',
                {
                  className: ur.textBlock,
                  children: [
                    g.jsxDEV(
                      'h2',
                      {
                        className: ur.title,
                        dangerouslySetInnerHTML: {
                          __html: i('section7.title'),
                        },
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section7/index.tsx',
                        lineNumber: 18,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'p',
                      {
                        className: ur.subtitle,
                        dangerouslySetInnerHTML: {
                          __html: i('section7.subtitle'),
                        },
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section7/index.tsx',
                        lineNumber: 22,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section7/index.tsx',
                  lineNumber: 17,
                  columnNumber: 7,
                },
                this
              ),
              o
                ? g.jsxDEV(
                    'div',
                    {
                      className: ur.visual,
                      style: { backgroundImage: `url(${r})` },
                      role: 'img',
                      'aria-hidden': !0,
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section7/index.tsx',
                      lineNumber: 29,
                      columnNumber: 9,
                    },
                    this
                  )
                : null,
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section7/index.tsx',
            lineNumber: 13,
            columnNumber: 5,
          },
          this
        );
      }
      const RM = 'carousel_JJrB1',
        MM = 'media_lyFMt',
        OM = 'mediaInner_JLXST',
        kM = 'mediaAsset_VaikP',
        _M = 'mediaPlaceholder_afY7Q',
        jM = 'mediaNavBtn_SzuP4',
        VM = 'mediaNavBtnPrev_MtMAG',
        BM = 'mediaNavBtnNext_JyJl-',
        LM = 'panel_tMtU8',
        zM = 'sideBtn_7WNEC',
        HM = 'sideBtnLeft_6pPV2',
        UM = 'sidePill_BvFyE',
        IM = 'sidePlus_1o0lE',
        WM = 'sideBtnRight_GPpHt',
        $M = 'sideBtnDisabled_GLs91',
        PM = 'card_XDmz-',
        GM = 'cardTitle_RAvkf',
        qM = 'cardDesc_KA-km',
        st = {
          carousel: RM,
          media: MM,
          mediaInner: OM,
          mediaAsset: kM,
          mediaPlaceholder: _M,
          mediaNavBtn: jM,
          mediaNavBtnPrev: VM,
          mediaNavBtnNext: BM,
          panel: LM,
          sideBtn: zM,
          sideBtnLeft: HM,
          sidePill: UM,
          sidePlus: IM,
          sideBtnRight: WM,
          sideBtnDisabled: $M,
          card: PM,
          cardTitle: GM,
          cardDesc: qM,
        };
      function YM(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const o = l(i);
        return o && o !== i ? o : '';
      }
      function XM() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          [o, r] = Z.useState(0),
          u = i('section8.safetyTabs', { returnObjects: !0 }),
          d = u[o],
          p = YM(d?.image ? `${d.image}Mobile` : void 0, l),
          h = o <= 0,
          m = o >= u.length - 1,
          y = () => {
            h || r(v => Math.max(0, v - 1));
          },
          E = () => {
            m || r(v => Math.min(u.length - 1, v + 1));
          };
        return g.jsxDEV(
          'div',
          {
            className: st.carousel,
            children: [
              g.jsxDEV(
                'div',
                {
                  className: st.media,
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: st.mediaInner,
                        children: p
                          ? g.jsxDEV(
                              'div',
                              {
                                className: st.mediaAsset,
                                style: { backgroundImage: `url(${p})` },
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                                lineNumber: 48,
                                columnNumber: 13,
                              },
                              this
                            )
                          : g.jsxDEV(
                              'div',
                              { className: st.mediaPlaceholder },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                                lineNumber: 53,
                                columnNumber: 13,
                              },
                              this
                            ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                        lineNumber: 46,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${st.mediaNavBtn} ${st.mediaNavBtnPrev}`,
                        onClick: y,
                        disabled: h,
                        'aria-label': 'Previous slide',
                        children: g.jsxDEV(
                          Rt,
                          { name: 'icon-left' },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                            lineNumber: 64,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                        lineNumber: 57,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${st.mediaNavBtn} ${st.mediaNavBtnNext}`,
                        onClick: E,
                        disabled: m,
                        'aria-label': 'Next slide',
                        children: g.jsxDEV(
                          Rt,
                          { name: 'icon-More' },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                            lineNumber: 73,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                        lineNumber: 66,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                  lineNumber: 45,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: st.panel,
                  children: [
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${st.sideBtn} ${st.sideBtnLeft} ${h ? st.sideBtnDisabled : ''}`,
                        onClick: y,
                        disabled: h,
                        'aria-label': 'Previous feature',
                        children: [
                          g.jsxDEV(
                            'span',
                            { className: st.sidePill },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                              lineNumber: 85,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'span',
                            { className: st.sidePlus, 'aria-hidden': 'true' },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                              lineNumber: 86,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                        lineNumber: 78,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: st.card,
                        children: [
                          g.jsxDEV(
                            'h3',
                            { className: st.cardTitle, children: d.title },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                              lineNumber: 90,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'p',
                            {
                              className: st.cardDesc,
                              dangerouslySetInnerHTML: {
                                __html: d.description,
                              },
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                              lineNumber: 91,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                        lineNumber: 89,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'button',
                      {
                        type: 'button',
                        className: `${st.sideBtn} ${st.sideBtnRight} ${m ? st.sideBtnDisabled : ''}`,
                        onClick: E,
                        disabled: m,
                        'aria-label': 'Next feature',
                        children: [
                          g.jsxDEV(
                            'span',
                            { className: st.sidePill },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                              lineNumber: 104,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'span',
                            { className: st.sidePlus, 'aria-hidden': 'true' },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                              lineNumber: 105,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                        lineNumber: 97,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
                  lineNumber: 77,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/SafetyMobileCarousel.tsx',
            lineNumber: 44,
            columnNumber: 5,
          },
          this
        );
      }
      const QM = 'section8_OHj58',
        ZM = 'header_gTdNS',
        FM = 'title_oi728',
        KM = 'class1_igQpK',
        JM = 'subtitle_mRt4u',
        eO = 'highlight_KaRB6',
        tO = 'content_uBnor',
        nO = 'leftPanel_-zYAd',
        aO = 'tabs_MMCnJ',
        iO = 'tab_t99hE',
        lO = 'tabActive_crUSf',
        sO = 'tabTitle_DlUgO',
        oO = 'tabDesc_9ThOY',
        rO = 'mediaPanel_PdX5h',
        cO = 'mediaPlaceholder_W2vag',
        uO = 'mediaImage_YTPZe',
        dO = 'mbBody_-D2jr',
        fO = 'mbHeader_ASC95',
        ot = {
          section8: QM,
          header: ZM,
          title: FM,
          class1: KM,
          subtitle: JM,
          highlight: eO,
          content: tO,
          leftPanel: nO,
          tabs: aO,
          tab: iO,
          tabActive: lO,
          tabTitle: sO,
          tabDesc: oO,
          mediaPanel: rO,
          mediaPlaceholder: cO,
          mediaImage: uO,
          mbBody: dO,
          mbHeader: fO,
        };
      function mO(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const o = l(i);
        return o && o !== i ? o : '';
      }
      function pO() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          [r, u] = Z.useState(0),
          d = wl(l, 'safetyHeaderBg', 'safetyHeaderMobile', o),
          p = i('section8.safetyTabs', { returnObjects: !0 }),
          h = p[r],
          m = mO(h?.image, l);
        return o
          ? g.jsxDEV(
              'section',
              {
                className: ot.section8,
                style: { backgroundImage: `url(${d})` },
                children: [
                  g.jsxDEV(
                    'div',
                    {
                      className: ot.mbHeader,
                      children: [
                        g.jsxDEV(
                          'h2',
                          {
                            className: ot.title,
                            children: [
                              g.jsxDEV(
                                'span',
                                {
                                  className: ot.class1,
                                  children: i('section8.class1'),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                  lineNumber: 37,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              i('section8.eyeSafe'),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                            lineNumber: 36,
                            columnNumber: 11,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'p',
                          {
                            className: ot.subtitle,
                            children: [
                              g.jsxDEV(
                                'span',
                                {
                                  className: ot.highlight,
                                  children: i('section8.noGoggles'),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                  lineNumber: 41,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              i('section8.noGogglesEnd'),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                            lineNumber: 40,
                            columnNumber: 11,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                      lineNumber: 35,
                      columnNumber: 9,
                    },
                    this
                  ),
                  g.jsxDEV(
                    'div',
                    {
                      className: ot.mbBody,
                      children: g.jsxDEV(
                        XM,
                        {},
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                          lineNumber: 47,
                          columnNumber: 11,
                        },
                        this
                      ),
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                      lineNumber: 46,
                      columnNumber: 9,
                    },
                    this
                  ),
                ],
              },
              void 0,
              !0,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                lineNumber: 34,
                columnNumber: 7,
              },
              this
            )
          : g.jsxDEV(
              'section',
              {
                className: ot.section8,
                style: { backgroundImage: `url(${d})` },
                children: [
                  g.jsxDEV(
                    'div',
                    {
                      className: ot.header,
                      children: [
                        g.jsxDEV(
                          'h2',
                          {
                            className: ot.title,
                            children: [
                              g.jsxDEV(
                                'span',
                                {
                                  className: ot.class1,
                                  children: i('section8.class1'),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                  lineNumber: 57,
                                  columnNumber: 11,
                                },
                                this
                              ),
                              i('section8.eyeSafe'),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                            lineNumber: 56,
                            columnNumber: 9,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'p',
                          {
                            className: ot.subtitle,
                            children: [
                              g.jsxDEV(
                                'span',
                                {
                                  className: ot.highlight,
                                  children: i('section8.noGoggles'),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                  lineNumber: 61,
                                  columnNumber: 11,
                                },
                                this
                              ),
                              i('section8.noGogglesEnd'),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                            lineNumber: 60,
                            columnNumber: 9,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                      lineNumber: 55,
                      columnNumber: 7,
                    },
                    this
                  ),
                  g.jsxDEV(
                    'div',
                    {
                      className: ot.content,
                      children: [
                        g.jsxDEV(
                          'div',
                          {
                            className: ot.leftPanel,
                            children: g.jsxDEV(
                              'div',
                              {
                                className: ot.tabs,
                                children: p.map((y, E) =>
                                  g.jsxDEV(
                                    'button',
                                    {
                                      type: 'button',
                                      className: `${ot.tab} ${r === E ? ot.tabActive : ''}`,
                                      onClick: () => u(E),
                                      children: [
                                        g.jsxDEV(
                                          'h3',
                                          {
                                            className: ot.tabTitle,
                                            children: y.title,
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                            lineNumber: 76,
                                            columnNumber: 17,
                                          },
                                          this
                                        ),
                                        r === E &&
                                          g.jsxDEV(
                                            'p',
                                            {
                                              className: ot.tabDesc,
                                              dangerouslySetInnerHTML: {
                                                __html: y.description,
                                              },
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                              lineNumber: 78,
                                              columnNumber: 19,
                                            },
                                            this
                                          ),
                                      ],
                                    },
                                    y.title,
                                    !0,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                      lineNumber: 70,
                                      columnNumber: 15,
                                    },
                                    this
                                  )
                                ),
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                lineNumber: 68,
                                columnNumber: 11,
                              },
                              this
                            ),
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                            lineNumber: 67,
                            columnNumber: 9,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: ot.mediaPanel,
                            children: m
                              ? g.jsxDEV(
                                  'div',
                                  {
                                    className: ot.mediaImage,
                                    style: { backgroundImage: `url(${m})` },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                    lineNumber: 90,
                                    columnNumber: 13,
                                  },
                                  this
                                )
                              : g.jsxDEV(
                                  'div',
                                  { className: ot.mediaPlaceholder },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                                    lineNumber: 92,
                                    columnNumber: 13,
                                  },
                                  this
                                ),
                          },
                          r,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                            lineNumber: 88,
                            columnNumber: 9,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                      lineNumber: 66,
                      columnNumber: 7,
                    },
                    this
                  ),
                ],
              },
              void 0,
              !0,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section8/index.tsx',
                lineNumber: 54,
                columnNumber: 5,
              },
              this
            );
      }
      const hO = 'section9_-CFvs',
        gO = 'header_NnZPb',
        bO = 'title_kaGZQ',
        yO = 'subtitle_3bAaC',
        vO = 'fdsTitle_XLZok',
        SO = 'fdsDesc_S-219',
        xO = 'mainImage_lRras',
        NO = 'card_6BHu7',
        wO = 'cardTop_zj3SG',
        EO = 'pcImage_Q5tYN',
        DO = 'appImage_f5grC',
        TO = 'features_fNr4M',
        CO = 'feature_1-Ful',
        wn = {
          section9: hO,
          header: gO,
          title: bO,
          subtitle: yO,
          fdsTitle: vO,
          fdsDesc: SO,
          mainImage: xO,
          card: NO,
          cardTop: wO,
          pcImage: EO,
          appImage: DO,
          features: TO,
          feature: CO,
        };
      function AO() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          r = wl(l, 'softwareMain', 'softwareMainMobile', o),
          u = l('softwarePC'),
          d = l('softwareDevices'),
          p = i('section9.features', { returnObjects: !0 });
        return g.jsxDEV(
          'section',
          {
            className: wn.section9,
            children: [
              g.jsxDEV(
                'div',
                {
                  className: wn.header,
                  children: [
                    g.jsxDEV(
                      'h2',
                      { className: wn.title, children: i('section9.title') },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                        lineNumber: 22,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'p',
                      {
                        className: wn.subtitle,
                        children: i('section9.subtitle'),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                        lineNumber: 23,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                  lineNumber: 21,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'h3',
                { className: wn.fdsTitle, children: i('section9.fdsTitle') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                  lineNumber: 25,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'p',
                {
                  className: wn.fdsDesc,
                  dangerouslySetInnerHTML: { __html: i('section9.fdsDesc') },
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                  lineNumber: 26,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                Ft,
                { className: wn.mainImage, src: r, alt: '' },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                  lineNumber: 27,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: wn.card,
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: wn.cardTop,
                        children: [
                          g.jsxDEV(
                            Ft,
                            {
                              className: wn.pcImage,
                              src: u,
                              alt: '',
                              style: { objectFit: 'contain' },
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                              lineNumber: 30,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            Ft,
                            {
                              className: wn.appImage,
                              src: d,
                              alt: '',
                              style: { objectFit: 'contain' },
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                              lineNumber: 36,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                        lineNumber: 29,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: wn.features,
                        children: p.map((h, m) =>
                          g.jsxDEV(
                            'div',
                            {
                              className: wn.feature,
                              children: [
                                g.jsxDEV(
                                  'h4',
                                  { children: h.title },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                                    lineNumber: 46,
                                    columnNumber: 15,
                                  },
                                  this
                                ),
                                g.jsxDEV(
                                  'p',
                                  {
                                    dangerouslySetInnerHTML: {
                                      __html: h.description,
                                    },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                                    lineNumber: 47,
                                    columnNumber: 15,
                                  },
                                  this
                                ),
                              ],
                            },
                            m,
                            !0,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                              lineNumber: 45,
                              columnNumber: 13,
                            },
                            this
                          )
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                        lineNumber: 43,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
                  lineNumber: 28,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section9/index.tsx',
            lineNumber: 20,
            columnNumber: 5,
          },
          this
        );
      }
      const RO = 'carousel_1WARC',
        MO = 'media_k85qi',
        OO = 'mediaInner_h95lZ',
        kO = 'mediaAsset_UBou3',
        _O = 'mediaPlaceholder_hZNxv',
        jO = 'mediaNavBtn_H2EPj',
        VO = 'mediaNavBtnPrev_z7qLC',
        BO = 'mediaNavBtnNext_YDXm1',
        LO = 'panel_PZCv8',
        zO = 'sideBtn_Lhesf',
        HO = 'sideBtnLeft_TiW5K',
        UO = 'sidePill_XCg8U',
        IO = 'sidePlus_oMX1Q',
        WO = 'sideBtnRight_rigs1',
        $O = 'sideBtnDisabled_wkWz2',
        PO = 'card_1MZDF',
        GO = 'cardTitle_eJcTi',
        qO = 'cardDesc_J9g96',
        it = {
          carousel: RO,
          media: MO,
          mediaInner: OO,
          mediaAsset: kO,
          mediaPlaceholder: _O,
          mediaNavBtn: jO,
          mediaNavBtnPrev: VO,
          mediaNavBtnNext: BO,
          panel: LO,
          sideBtn: zO,
          sideBtnLeft: HO,
          sidePill: UO,
          sidePlus: IO,
          sideBtnRight: WO,
          sideBtnDisabled: $O,
          card: PO,
          cardTitle: GO,
          cardDesc: qO,
        };
      function YO() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          [o, r] = Z.useState(0),
          u = Z.useRef(null),
          d = yS(l),
          p = i('section10.aiTabs', { returnObjects: !0 }),
          h = p[o],
          m = d(h?.video),
          y = d(h?.image);
        gS(p, m || y, d);
        const E = o <= 0,
          v = o >= p.length - 1,
          S = () => {
            E || r(D => Math.max(0, D - 1));
          },
          x = () => {
            v || r(D => Math.min(p.length - 1, D + 1));
          };
        return (
          Z.useEffect(() => {
            const D = u.current;
            if (!D || !m) return;
            const M = requestAnimationFrame(() => {
              D.src !== m && ((D.src = m), D.load(), D.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(M);
          }, [m]),
          g.jsxDEV(
            'div',
            {
              className: it.carousel,
              children: [
                g.jsxDEV(
                  'div',
                  {
                    className: it.media,
                    children: [
                      g.jsxDEV(
                        'div',
                        {
                          className: it.mediaInner,
                          children: m
                            ? g.jsxDEV(
                                'video',
                                {
                                  ref: u,
                                  className: it.mediaAsset,
                                  src: m,
                                  autoPlay: !0,
                                  loop: !0,
                                  muted: !0,
                                  playsInline: !0,
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                  lineNumber: 60,
                                  columnNumber: 13,
                                },
                                this
                              )
                            : y
                              ? g.jsxDEV(
                                  'div',
                                  {
                                    className: it.mediaAsset,
                                    style: { backgroundImage: `url(${y})` },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                    lineNumber: 70,
                                    columnNumber: 13,
                                  },
                                  this
                                )
                              : g.jsxDEV(
                                  'div',
                                  { className: it.mediaPlaceholder },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                    lineNumber: 75,
                                    columnNumber: 13,
                                  },
                                  this
                                ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                          lineNumber: 58,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${it.mediaNavBtn} ${it.mediaNavBtnPrev}`,
                          onClick: S,
                          disabled: E,
                          'aria-label': 'Previous slide',
                          children: g.jsxDEV(
                            Rt,
                            { name: 'icon-left' },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                              lineNumber: 86,
                              columnNumber: 11,
                            },
                            this
                          ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                          lineNumber: 79,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${it.mediaNavBtn} ${it.mediaNavBtnNext}`,
                          onClick: x,
                          disabled: v,
                          'aria-label': 'Next slide',
                          children: g.jsxDEV(
                            Rt,
                            { name: 'icon-More' },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                              lineNumber: 95,
                              columnNumber: 11,
                            },
                            this
                          ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                          lineNumber: 88,
                          columnNumber: 9,
                        },
                        this
                      ),
                    ],
                  },
                  void 0,
                  !0,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                    lineNumber: 57,
                    columnNumber: 7,
                  },
                  this
                ),
                g.jsxDEV(
                  'div',
                  {
                    className: it.panel,
                    children: [
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${it.sideBtn} ${it.sideBtnLeft} ${E ? it.sideBtnDisabled : ''}`,
                          onClick: S,
                          disabled: E,
                          'aria-label': 'Previous feature',
                          children: [
                            g.jsxDEV(
                              'span',
                              { className: it.sidePill },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                lineNumber: 107,
                                columnNumber: 11,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'span',
                              { className: it.sidePlus, 'aria-hidden': 'true' },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                lineNumber: 108,
                                columnNumber: 11,
                              },
                              this
                            ),
                          ],
                        },
                        void 0,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                          lineNumber: 100,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'div',
                        {
                          className: it.card,
                          children: [
                            g.jsxDEV(
                              'h3',
                              { className: it.cardTitle, children: h.title },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                lineNumber: 112,
                                columnNumber: 11,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'p',
                              {
                                className: it.cardDesc,
                                dangerouslySetInnerHTML: {
                                  __html: h.description,
                                },
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                lineNumber: 113,
                                columnNumber: 11,
                              },
                              this
                            ),
                          ],
                        },
                        void 0,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                          lineNumber: 111,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'button',
                        {
                          type: 'button',
                          className: `${it.sideBtn} ${it.sideBtnRight} ${v ? it.sideBtnDisabled : ''}`,
                          onClick: x,
                          disabled: v,
                          'aria-label': 'Next feature',
                          children: [
                            g.jsxDEV(
                              'span',
                              { className: it.sidePill },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                lineNumber: 126,
                                columnNumber: 11,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'span',
                              { className: it.sidePlus, 'aria-hidden': 'true' },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                                lineNumber: 127,
                                columnNumber: 11,
                              },
                              this
                            ),
                          ],
                        },
                        void 0,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                          lineNumber: 119,
                          columnNumber: 9,
                        },
                        this
                      ),
                    ],
                  },
                  void 0,
                  !0,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
                    lineNumber: 99,
                    columnNumber: 7,
                  },
                  this
                ),
              ],
            },
            void 0,
            !0,
            {
              fileName:
                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/AiMobileCarousel.tsx',
              lineNumber: 56,
              columnNumber: 5,
            },
            this
          )
        );
      }
      const XO = 'carousel_W48uZ',
        QO = 'swiperWrap_P-fRd',
        ZO = 'swiper_xCUJw',
        FO = 'card_cdxVB',
        KO = 'thumb_aEHlg',
        JO = 'cardTitle_WmlKO',
        ek = 'cardDesc_NGC84',
        tk = 'footer_Fdt4h',
        nk = 'dots_Aj3jX',
        ak = 'dot_zFYYS',
        ik = 'dotActive_mloeb',
        lk = 'navBtns_XDNqq',
        sk = 'navBtn_jHltu',
        rn = {
          carousel: XO,
          swiperWrap: QO,
          swiper: ZO,
          card: FO,
          thumb: KO,
          cardTitle: JO,
          cardDesc: ek,
          footer: tk,
          dots: nk,
          dot: ak,
          dotActive: ik,
          navBtns: lk,
          navBtn: sk,
        };
      function ok(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const o = l(i);
        return o && o !== i ? o : '';
      }
      function rk(i, l) {
        if (!i || l <= 1) return l;
        (i.updateSize(), i.updateSlides());
        const o = i.slidesSizesGrid[0] ?? 0;
        if (!o) return l;
        const r =
            typeof i.params.spaceBetween == 'number'
              ? i.params.spaceBetween
              : 0,
          u = Math.max(1, Math.ceil((i.width + r) / (o + r)));
        return Math.max(1, l - u + 1);
      }
      function ck() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          [r, u] = Z.useState(0),
          [d, p] = Z.useState(0),
          {
            swiperRef: h,
            isBeginning: m,
            isEnd: y,
            goNext: E,
            goPrev: v,
            swiperNavHandlers: S,
          } = Nl(),
          x = i('section10.featureSlides', { returnObjects: !0 }),
          D = Z.useCallback(
            G => {
              if (!o) {
                p(x.length);
                return;
              }
              p(rk(G, x.length));
            },
            [o, x.length]
          ),
          M = G => {
            (S.onSwiper(G), u(G.activeIndex), D(G));
          },
          k = G => {
            (S.onSlideChange(G), u(G.activeIndex), D(G));
          },
          V = G => {
            (S.onResize(G), D(G));
          },
          L = G => {
            h.current?.slideTo(G);
          },
          U = d || x.length,
          Y = o && y ? U - 1 : Math.min(r, U - 1);
        return g.jsxDEV(
          'div',
          {
            className: rn.carousel,
            children: [
              g.jsxDEV(
                'div',
                {
                  className: rn.swiperWrap,
                  children: g.jsxDEV(
                    _i,
                    {
                      className: rn.swiper,
                      slidesPerView: 'auto',
                      spaceBetween: 6,
                      watchOverflow: !0,
                      observer: !0,
                      observeParents: !0,
                      breakpoints: { 769: { spaceBetween: 12 } },
                      onSwiper: M,
                      onSlideChange: k,
                      onTransitionEnd: S.onTransitionEnd,
                      onSetTranslate: S.onSetTranslate,
                      onResize: V,
                      onUpdate: S.onUpdate,
                      onDestroy: S.onDestroy,
                      children: x.map((G, P) => {
                        const Q = ok(G.image, l);
                        return g.jsxDEV(
                          ji,
                          {
                            children: g.jsxDEV(
                              'div',
                              {
                                className: rn.card,
                                children: [
                                  g.jsxDEV(
                                    'div',
                                    {
                                      className: rn.thumb,
                                      style: Q
                                        ? { backgroundImage: `url(${Q})` }
                                        : void 0,
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                                      lineNumber: 117,
                                      columnNumber: 19,
                                    },
                                    this
                                  ),
                                  g.jsxDEV(
                                    'h4',
                                    {
                                      className: rn.cardTitle,
                                      children: G.title,
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                                      lineNumber: 121,
                                      columnNumber: 19,
                                    },
                                    this
                                  ),
                                  g.jsxDEV(
                                    'p',
                                    {
                                      className: rn.cardDesc,
                                      dangerouslySetInnerHTML: {
                                        __html: G.description,
                                      },
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                                      lineNumber: 122,
                                      columnNumber: 19,
                                    },
                                    this
                                  ),
                                ],
                              },
                              void 0,
                              !0,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                                lineNumber: 116,
                                columnNumber: 17,
                              },
                              this
                            ),
                          },
                          `${G.title}-${P}`,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                            lineNumber: 115,
                            columnNumber: 15,
                          },
                          this
                        );
                      }),
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                      lineNumber: 93,
                      columnNumber: 9,
                    },
                    this
                  ),
                },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                  lineNumber: 92,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: rn.footer,
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: rn.dots,
                        'aria-hidden': U <= 1,
                        children: x
                          .slice(0, U)
                          .map((G, P) =>
                            g.jsxDEV(
                              'button',
                              {
                                type: 'button',
                                className: `${rn.dot} ${P === Y ? rn.dotActive : ''}`,
                                onClick: () => L(P),
                                'aria-label': `Go to slide ${P + 1}`,
                                'aria-current': P === Y ? 'true' : void 0,
                              },
                              `dot-${G.title}-${P}`,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                                lineNumber: 136,
                                columnNumber: 13,
                              },
                              this
                            )
                          ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                        lineNumber: 134,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: rn.navBtns,
                        children: [
                          g.jsxDEV(
                            'button',
                            {
                              type: 'button',
                              className: rn.navBtn,
                              onClick: v,
                              disabled: m,
                              'aria-label': 'Previous',
                              children: g.jsxDEV(
                                Rt,
                                { name: 'icon-left' },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                                  lineNumber: 154,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                              lineNumber: 147,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'button',
                            {
                              type: 'button',
                              className: rn.navBtn,
                              onClick: E,
                              disabled: y,
                              'aria-label': 'Next',
                              children: g.jsxDEV(
                                Rt,
                                { name: 'icon-More' },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                                  lineNumber: 163,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                              lineNumber: 156,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                        lineNumber: 146,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
                  lineNumber: 133,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/FeatureCarousel.tsx',
            lineNumber: 91,
            columnNumber: 15,
          },
          this
        );
      }
      const uk = 'section10_snPFW',
        dk = 'mbBody_zzJyX',
        fk = 'title_KCg4Z',
        mk = 'topRow_AODiQ',
        pk = 'aiPanel_h-xcT',
        hk = 'tabItem_rOPjV',
        gk = 'tabActive_YWH8-',
        bk = 'tabContent_bLc2z',
        yk = 'tabCollapsed_jQqh-',
        vk = 'plus_COkwl',
        Sk = 'tabTitle_9jBDG',
        xk = 'tabDescWrap_-Dx7G',
        Nk = 'tabDescOpen_-R3CM',
        wk = 'tabDesc_uw9Ah',
        Ek = 'plusHidden_R5cJu',
        Dk = 'aiImage_AVjqz',
        Tk = 'aiImageBg_hoV9Z',
        Ck = 'aiImagePlaceholder_Ui12W',
        Ak = 'video_W5taz',
        Rk = 'playPauseBtn_5K-3N',
        Mk = 'pauseIcon_js8px',
        Ok = 'playBtnIcon_8DXY-',
        dt = {
          section10: uk,
          mbBody: dk,
          title: fk,
          topRow: mk,
          aiPanel: pk,
          tabItem: hk,
          tabActive: gk,
          tabContent: bk,
          tabCollapsed: yk,
          plus: vk,
          tabTitle: Sk,
          tabDescWrap: xk,
          tabDescOpen: Nk,
          tabDesc: wk,
          plusHidden: Ek,
          aiImage: Dk,
          aiImageBg: Tk,
          aiImagePlaceholder: Ck,
          video: Ak,
          playPauseBtn: Rk,
          pauseIcon: Mk,
          playBtnIcon: Ok,
        };
      function kk() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          [r, u] = Z.useState(0),
          [d, p] = Z.useState(!0),
          h = Z.useRef(null),
          m = yS(l),
          y = i('section10.aiTabs', { returnObjects: !0 }),
          E = y[r],
          v = m(E?.video),
          S = m(E?.image);
        (gS(o ? [] : y, o ? '' : v || S, m),
          Z.useEffect(() => {
            p(!0);
          }, [r, v]),
          Z.useEffect(() => {
            const D = h.current;
            if (!D || !v) return;
            const M = requestAnimationFrame(() => {
              D.src !== v && ((D.src = v), D.load(), D.play().catch(() => {}));
            });
            return () => cancelAnimationFrame(M);
          }, [v]));
        const x = () => {
          const D = h.current;
          if (D) {
            if (D.paused) {
              (D.play(), p(!0));
              return;
            }
            (D.pause(), p(!1));
          }
        };
        return g.jsxDEV(
          'section',
          {
            className: dt.section10,
            children: [
              g.jsxDEV(
                'h2',
                { className: dt.title, children: i('section10.title') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                  lineNumber: 71,
                  columnNumber: 7,
                },
                this
              ),
              o
                ? g.jsxDEV(
                    'div',
                    {
                      className: dt.mbBody,
                      children: g.jsxDEV(
                        YO,
                        {},
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                          lineNumber: 75,
                          columnNumber: 11,
                        },
                        this
                      ),
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                      lineNumber: 74,
                      columnNumber: 9,
                    },
                    this
                  )
                : g.jsxDEV(
                    'div',
                    {
                      className: dt.topRow,
                      children: [
                        g.jsxDEV(
                          'div',
                          {
                            className: dt.aiPanel,
                            children: y.map((D, M) => {
                              const k = r === M;
                              return g.jsxDEV(
                                'button',
                                {
                                  type: 'button',
                                  className: `${dt.tabItem} ${k ? dt.tabActive : dt.tabCollapsed}`,
                                  onClick: () => u(M),
                                  children: [
                                    g.jsxDEV(
                                      'span',
                                      {
                                        className: `${dt.plus} ${k ? dt.plusHidden : ''}`,
                                        'aria-hidden': 'true',
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                        lineNumber: 90,
                                        columnNumber: 19,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'div',
                                      {
                                        className: dt.tabContent,
                                        children: [
                                          g.jsxDEV(
                                            'h3',
                                            {
                                              className: dt.tabTitle,
                                              children: D.title,
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                              lineNumber: 95,
                                              columnNumber: 21,
                                            },
                                            this
                                          ),
                                          g.jsxDEV(
                                            'div',
                                            {
                                              className: `${dt.tabDescWrap} ${k ? dt.tabDescOpen : ''}`,
                                              children: g.jsxDEV(
                                                'p',
                                                {
                                                  className: dt.tabDesc,
                                                  dangerouslySetInnerHTML: {
                                                    __html: D.description,
                                                  },
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                                  lineNumber: 97,
                                                  columnNumber: 23,
                                                },
                                                this
                                              ),
                                            },
                                            void 0,
                                            !1,
                                            {
                                              fileName:
                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                              lineNumber: 96,
                                              columnNumber: 21,
                                            },
                                            this
                                          ),
                                        ],
                                      },
                                      void 0,
                                      !0,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                        lineNumber: 94,
                                        columnNumber: 19,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                D.title,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                  lineNumber: 84,
                                  columnNumber: 17,
                                },
                                this
                              );
                            }),
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                            lineNumber: 79,
                            columnNumber: 11,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: dt.aiImage,
                            children: v
                              ? g.jsxDEV(
                                  g.Fragment,
                                  {
                                    children: [
                                      g.jsxDEV(
                                        'video',
                                        {
                                          ref: h,
                                          className: dt.video,
                                          src: v,
                                          autoPlay: !0,
                                          loop: !0,
                                          muted: !0,
                                          playsInline: !0,
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                          lineNumber: 111,
                                          columnNumber: 17,
                                        },
                                        this
                                      ),
                                      g.jsxDEV(
                                        'button',
                                        {
                                          type: 'button',
                                          className: dt.playPauseBtn,
                                          onClick: x,
                                          'aria-label': d
                                            ? 'Pause video'
                                            : 'Play video',
                                          children: d
                                            ? g.jsxDEV(
                                                'span',
                                                {
                                                  className: dt.pauseIcon,
                                                  'aria-hidden': 'true',
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                                  lineNumber: 127,
                                                  columnNumber: 21,
                                                },
                                                this
                                              )
                                            : g.jsxDEV(
                                                'span',
                                                {
                                                  className: dt.playBtnIcon,
                                                  'aria-hidden': 'true',
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                                  lineNumber: 129,
                                                  columnNumber: 21,
                                                },
                                                this
                                              ),
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                          lineNumber: 120,
                                          columnNumber: 17,
                                        },
                                        this
                                      ),
                                    ],
                                  },
                                  void 0,
                                  !0,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                    lineNumber: 110,
                                    columnNumber: 15,
                                  },
                                  this
                                )
                              : S
                                ? g.jsxDEV(
                                    'div',
                                    {
                                      className: dt.aiImageBg,
                                      style: { backgroundImage: `url(${S})` },
                                    },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                      lineNumber: 134,
                                      columnNumber: 15,
                                    },
                                    this
                                  )
                                : g.jsxDEV(
                                    'div',
                                    { className: dt.aiImagePlaceholder },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                                      lineNumber: 139,
                                      columnNumber: 15,
                                    },
                                    this
                                  ),
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                            lineNumber: 108,
                            columnNumber: 11,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                      lineNumber: 78,
                      columnNumber: 9,
                    },
                    this
                  ),
              g.jsxDEV(
                ck,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
                  lineNumber: 145,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section10/index.tsx',
            lineNumber: 70,
            columnNumber: 5,
          },
          this
        );
      }
      const _k = 'gallery_CDP-h',
        jk = 'title_Ipi9j',
        Vk = 'desc_oBCei',
        Bk = 'swiperWrap_Mj5uh',
        Lk = 'swiper_N4p39',
        zk = 'slide_Ne51m',
        Hk = 'slideImage_KTCbJ',
        Uk = 'footer_gNQhm',
        Ik = 'dots_eYBHD',
        Wk = 'dot_ptAis',
        $k = 'dotActive_eN4Sb',
        Pk = 'navBtns_puLeL',
        Gk = 'navBtn_y50ou',
        qk = 'panels_qj1TQ',
        Yk = 'panel_8TGI5',
        Xk = 'panelExpanded_8TY1w',
        Qk = 'panelCollapsed_xRYtU',
        Zk = 'panelBg_69xyg',
        Fk = 'playBtn_vkINe',
        Kk = 'playIcon_tp7nI',
        gt = {
          gallery: _k,
          title: jk,
          desc: Vk,
          swiperWrap: Bk,
          swiper: Lk,
          slide: zk,
          slideImage: Hk,
          footer: Uk,
          dots: Ik,
          dot: Wk,
          dotActive: $k,
          navBtns: Pk,
          navBtn: Gk,
          panels: qk,
          panel: Yk,
          panelExpanded: Xk,
          panelCollapsed: Qk,
          panelBg: Zk,
          playBtn: Fk,
          playIcon: Kk,
        };
      function Sp(i, l) {
        if (!i) return '';
        if (i.startsWith('http://') || i.startsWith('https://')) return i;
        const o = l(i);
        return o && o !== i ? o : '';
      }
      function Jk(i, l) {
        return i.playIcon ? i.playIcon : l === 2 ? 'portable2' : 'portable1';
      }
      function e3() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = ea(),
          [r, u] = Z.useState(0),
          [d, p] = Z.useState(0),
          {
            swiperRef: h,
            isBeginning: m,
            isEnd: y,
            goNext: E,
            goPrev: v,
            swiperNavHandlers: S,
          } = Nl(),
          x = i('section11.portablePanels', { returnObjects: !0 }),
          D = V => {
            (S.onSwiper(V), u(V.activeIndex));
          },
          M = V => {
            (S.onSlideChange(V), u(V.activeIndex));
          },
          k = V => {
            h.current?.slideTo(V);
          };
        return g.jsxDEV(
          'div',
          {
            className: gt.gallery,
            children: [
              g.jsxDEV(
                'h3',
                { className: gt.title, children: i('section11.portableTitle') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                  lineNumber: 55,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'p',
                { className: gt.desc, children: i('section11.portableDesc') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                  lineNumber: 56,
                  columnNumber: 7,
                },
                this
              ),
              o
                ? g.jsxDEV(
                    g.Fragment,
                    {
                      children: [
                        g.jsxDEV(
                          'div',
                          {
                            className: gt.swiperWrap,
                            children: g.jsxDEV(
                              _i,
                              {
                                className: gt.swiper,
                                slidesPerView: 'auto',
                                spaceBetween: 7,
                                watchOverflow: !0,
                                observer: !0,
                                observeParents: !0,
                                onSwiper: D,
                                onSlideChange: M,
                                onTransitionEnd: S.onTransitionEnd,
                                onSetTranslate: S.onSetTranslate,
                                onResize: S.onResize,
                                onUpdate: S.onUpdate,
                                onDestroy: S.onDestroy,
                                children: x.map((V, L) => {
                                  const U = Sp(V.image, l);
                                  return g.jsxDEV(
                                    ji,
                                    {
                                      className: gt.slide,
                                      children: g.jsxDEV(
                                        'div',
                                        {
                                          className: gt.slideImage,
                                          style: U
                                            ? { backgroundImage: `url(${U})` }
                                            : void 0,
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                          lineNumber: 81,
                                          columnNumber: 21,
                                        },
                                        this
                                      ),
                                    },
                                    `portable-slide-${L}`,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                      lineNumber: 80,
                                      columnNumber: 19,
                                    },
                                    this
                                  );
                                }),
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                lineNumber: 61,
                                columnNumber: 13,
                              },
                              this
                            ),
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                            lineNumber: 60,
                            columnNumber: 11,
                          },
                          this
                        ),
                        g.jsxDEV(
                          'div',
                          {
                            className: gt.footer,
                            children: [
                              g.jsxDEV(
                                'div',
                                {
                                  className: gt.dots,
                                  'aria-hidden': x.length <= 1,
                                  children: x.map((V, L) =>
                                    g.jsxDEV(
                                      'button',
                                      {
                                        type: 'button',
                                        className: `${gt.dot} ${L === r ? gt.dotActive : ''}`,
                                        onClick: () => k(L),
                                        'aria-label': `Go to slide ${L + 1}`,
                                        'aria-current':
                                          L === r ? 'true' : void 0,
                                      },
                                      `portable-dot-${L}`,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                        lineNumber: 94,
                                        columnNumber: 17,
                                      },
                                      this
                                    )
                                  ),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                  lineNumber: 92,
                                  columnNumber: 13,
                                },
                                this
                              ),
                              g.jsxDEV(
                                'div',
                                {
                                  className: gt.navBtns,
                                  children: [
                                    g.jsxDEV(
                                      'button',
                                      {
                                        type: 'button',
                                        className: gt.navBtn,
                                        onClick: v,
                                        disabled: m,
                                        'aria-label': 'Previous',
                                        children: g.jsxDEV(
                                          Rt,
                                          { name: 'icon-left' },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                            lineNumber: 113,
                                            columnNumber: 17,
                                          },
                                          this
                                        ),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                        lineNumber: 106,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                    g.jsxDEV(
                                      'button',
                                      {
                                        type: 'button',
                                        className: gt.navBtn,
                                        onClick: E,
                                        disabled: y,
                                        'aria-label': 'Next',
                                        children: g.jsxDEV(
                                          Rt,
                                          { name: 'icon-More' },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                            lineNumber: 122,
                                            columnNumber: 17,
                                          },
                                          this
                                        ),
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                        lineNumber: 115,
                                        columnNumber: 15,
                                      },
                                      this
                                    ),
                                  ],
                                },
                                void 0,
                                !0,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                  lineNumber: 105,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            ],
                          },
                          void 0,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                            lineNumber: 91,
                            columnNumber: 11,
                          },
                          this
                        ),
                      ],
                    },
                    void 0,
                    !0,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                      lineNumber: 59,
                      columnNumber: 9,
                    },
                    this
                  )
                : g.jsxDEV(
                    'div',
                    {
                      className: gt.panels,
                      children: x.map((V, L) => {
                        const U = d === L,
                          Y = Sp(V.image, l),
                          G = Sp(Jk(V, L), l);
                        return g.jsxDEV(
                          'button',
                          {
                            type: 'button',
                            className: `${gt.panel} ${U ? gt.panelExpanded : gt.panelCollapsed}`,
                            onClick: () => p(L),
                            'aria-label': U ? void 0 : `Expand panel ${L + 1}`,
                            'aria-pressed': U,
                            children: [
                              Y &&
                                g.jsxDEV(
                                  'div',
                                  {
                                    className: gt.panelBg,
                                    style: { backgroundImage: `url(${Y})` },
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                    lineNumber: 144,
                                    columnNumber: 19,
                                  },
                                  this
                                ),
                              !U &&
                                G &&
                                g.jsxDEV(
                                  'span',
                                  {
                                    className: gt.playBtn,
                                    children: g.jsxDEV(
                                      Ft,
                                      {
                                        src: G,
                                        alt: '',
                                        className: gt.playIcon,
                                        style: { objectFit: 'contain' },
                                      },
                                      void 0,
                                      !1,
                                      {
                                        fileName:
                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                        lineNumber: 151,
                                        columnNumber: 21,
                                      },
                                      this
                                    ),
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                                    lineNumber: 150,
                                    columnNumber: 19,
                                  },
                                  this
                                ),
                            ],
                          },
                          L,
                          !0,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                            lineNumber: 135,
                            columnNumber: 15,
                          },
                          this
                        );
                      }),
                    },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
                      lineNumber: 128,
                      columnNumber: 9,
                    },
                    this
                  ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/PortableGallery.tsx',
            lineNumber: 54,
            columnNumber: 5,
          },
          this
        );
      }
      const t3 = 'section11_eS1QR',
        n3 = 'title_-f-m8',
        a3 = 'row_OZTsP',
        i3 = 'image_vQfqy',
        l3 = 'text_gt4kv',
        cn = { section11: t3, title: n3, row: a3, image: i3, text: l3 };
      function s3() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl');
        return g.jsxDEV(
          'section',
          {
            className: cn.section11,
            children: [
              g.jsxDEV(
                'h2',
                { className: cn.title, children: i('section11.title') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                  lineNumber: 12,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: cn.row,
                  'data-reverse': 'false',
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.text,
                        children: [
                          g.jsxDEV(
                            'h3',
                            { children: i('section11.engraveCups') },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 16,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'p',
                            { children: i('section11.engraveCupsDesc') },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 17,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 15,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.image,
                        children: g.jsxDEV(
                          Ft,
                          {
                            src: l('section11EngraveCups'),
                            width: '100%',
                            height: '100%',
                            alt: '',
                            style: { objectFit: 'cover' },
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                            lineNumber: 20,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 19,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                  lineNumber: 14,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: cn.row,
                  'data-reverse': 'true',
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.image,
                        children: g.jsxDEV(
                          Ft,
                          {
                            src: l('section11Maintenance'),
                            width: '100%',
                            height: '100%',
                            alt: '',
                            style: { objectFit: 'cover' },
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                            lineNumber: 32,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 31,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.text,
                        children: [
                          g.jsxDEV(
                            'h3',
                            {
                              dangerouslySetInnerHTML: {
                                __html: i('section11.maintenanceTitle'),
                              },
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 41,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'p',
                            { children: i('section11.maintenanceDesc') },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 42,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 40,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                  lineNumber: 30,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                e3,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                  lineNumber: 46,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: cn.row,
                  'data-reverse': 'false',
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.text,
                        children: [
                          g.jsxDEV(
                            'h3',
                            {
                              dangerouslySetInnerHTML: {
                                __html: i('section11.airPurifierTitle'),
                              },
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 50,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'p',
                            { children: i('section11.airPurifierDesc') },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 51,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 49,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.image,
                        children: g.jsxDEV(
                          Ft,
                          {
                            src: l('section11AirPurifier'),
                            width: '100%',
                            height: '100%',
                            alt: '',
                            style: { objectFit: 'cover' },
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                            lineNumber: 54,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 53,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                  lineNumber: 48,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: cn.row,
                  'data-reverse': 'true',
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.image,
                        children: g.jsxDEV(
                          Ft,
                          {
                            src: l('section11Fixture'),
                            width: '100%',
                            height: '100%',
                            alt: '',
                            style: { objectFit: 'cover' },
                          },
                          void 0,
                          !1,
                          {
                            fileName:
                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                            lineNumber: 66,
                            columnNumber: 11,
                          },
                          this
                        ),
                      },
                      void 0,
                      !1,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 65,
                        columnNumber: 9,
                      },
                      this
                    ),
                    g.jsxDEV(
                      'div',
                      {
                        className: cn.text,
                        children: [
                          g.jsxDEV(
                            'h3',
                            { children: i('section11.fixtureTitle') },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 75,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'p',
                            { children: i('section11.fixtureDesc') },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                              lineNumber: 76,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                        lineNumber: 74,
                        columnNumber: 9,
                      },
                      this
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
                  lineNumber: 64,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section11/index.tsx',
            lineNumber: 11,
            columnNumber: 5,
          },
          this
        );
      }
      const o3 = [
          'inBoxVariantPg5w',
          'inBoxVariantWhite5w',
          'inBoxVariantPg10w',
          'inBoxVariantWhite10w',
          'inBoxItem1',
          'inBoxItem2',
          'inBoxItem3',
          'inBoxItem4',
          'inBoxItem5',
          'inBoxItem6',
          'inBoxItem7',
          'inBoxItem8',
          'inBoxItem9',
          'inBoxItem10',
          'inBoxItem11',
          'inBoxItem12',
          'inBoxItem13',
          'inBoxItem14',
          'inBoxItem15',
          'inBoxItem16',
          'inBoxItem17',
        ],
        r3 = {
          inBoxVariantPg5w:
            'https://cdn.creality.com/ow/a1c/177723b2-f75d-4158-8e78-ac6fbf80119e.png',
          inBoxVariantWhite5w:
            'https://cdn.creality.com/ow/a1c/4cae0768-105f-47dd-9179-3b026ce58c1b.png',
          inBoxVariantPg10w:
            'https://cdn.creality.com/ow/a1c/177723b2-f75d-4158-8e78-ac6fbf80119e.png',
          inBoxVariantWhite10w:
            'https://cdn.creality.com/ow/a1c/4cae0768-105f-47dd-9179-3b026ce58c1b.png',
          inBoxItem1:
            'https://cdn.creality.com/ow/a1c/94cd0f55-449c-4a66-87a8-7d696d1c2060.png',
          inBoxItem2:
            'https://cdn.creality.com/ow/a1c/d8b231c1-cb07-45ef-bfcb-c754262dc7c3.png',
          inBoxItem3:
            'https://cdn.creality.com/ow/a1c/8c705410-a233-4360-b4b7-81fc5d362632.png',
          inBoxItem4:
            'https://cdn.creality.com/ow/a1c/d9d7febd-a17a-4144-8bfc-d503540f2d79.png',
          inBoxItem5:
            'https://cdn.creality.com/ow/a1c/b38d74b3-c79b-44e0-9264-9dfea82a103a.png',
          inBoxItem6:
            'https://cdn.creality.com/ow/a1c/6a2249db-9137-4c8b-a4e0-984b878c4ced.png',
          inBoxItem7:
            'https://cdn.creality.com/ow/a1c/cb2a9ba7-b031-4412-9395-298b41895a03.png',
          inBoxItem8:
            'https://cdn.creality.com/ow/a1c/bb4f8747-c695-4ed0-bccc-115c16ee2860.png',
          inBoxItem9:
            'https://cdn.creality.com/ow/a1c/64d7de35-c9ea-4d0a-9b8c-26ed7776781b.png',
          inBoxItem10:
            'https://cdn.creality.com/ow/a1c/dcecef01-02dc-40a7-bf4b-897d9207d44e.png',
          inBoxItem11:
            'https://cdn.creality.com/ow/a1c/7bbcc6ca-9873-402c-9170-6e02e3ebaea5.png',
          inBoxItem12:
            'https://cdn.creality.com/ow/a1c/57f05fcf-2979-41b2-8c88-272af7a587fd.png',
          inBoxItem13:
            'https://cdn.creality.com/ow/a1c/37a6f0e7-7d9f-4e31-ad12-6764eae4c0b5.png',
          inBoxItem14:
            'https://cdn.creality.com/ow/a1c/cf9cf227-4cd6-4022-ac93-ad442131ebe9.png',
          inBoxItem15:
            'https://cdn.creality.com/ow/a1c/11b940e8-ce56-459e-82ba-21ac1b9ac253.png',
          inBoxItem16:
            'https://cdn.creality.com/ow/a1c/c795271b-9ee8-46c7-bf73-c6da69d9436e.png',
          inBoxItem17:
            'https://cdn.creality.com/ow/a1c/33fb660c-eee8-483f-b61c-8e34e5f03227.png',
        };
      var c3 = W0();
      const u3 = 'overlay_j2kLh',
        d3 = 'panel_K3jnh',
        f3 = 'closeBtn_MWlGb',
        m3 = 'closeBtnIcon_n-I5Y',
        p3 = 'scrollArea_xAiB1',
        h3 = 'scaleShell_BOA0I',
        g3 = 'designRoot_I3QFj',
        b3 = 'title_VBvsN',
        y3 = 'compareSection_BtVtj',
        v3 = 'machineRow_ZAYVi',
        S3 = 'tableRow_i45ls',
        x3 = 'machineLabel_F9fkq',
        N3 = 'itemName_V3WCf',
        w3 = 'iconCol_N79Py',
        E3 = 'variantList_ZHunx',
        D3 = 'valueList_zk5hu',
        T3 = 'variantItem_pZWJE',
        C3 = 'variantImageWrap_wQniw',
        A3 = 'variantImage_gFBx0',
        R3 = 'variantLabel_-eX0J',
        M3 = 'table_sHtOB',
        O3 = 'itemIconWrap_bBRIQ',
        k3 = 'itemIcon_iCogq',
        _3 = 'itemValue_0pcwx',
        j3 = 'itemValueHighlight_n-PRJ',
        V3 = 'itemNameHighlight_bDiiF',
        B3 = 'iconNameGap_NBM-J',
        L3 = 'nameValueGap_Y8kF1',
        Ie = {
          overlay: u3,
          panel: d3,
          closeBtn: f3,
          closeBtnIcon: m3,
          scrollArea: p3,
          scaleShell: h3,
          designRoot: g3,
          title: b3,
          compareSection: y3,
          machineRow: v3,
          tableRow: S3,
          machineLabel: x3,
          itemName: N3,
          iconCol: w3,
          variantList: E3,
          valueList: D3,
          variantItem: T3,
          variantImageWrap: C3,
          variantImage: A3,
          variantLabel: R3,
          table: M3,
          itemIconWrap: O3,
          itemIcon: k3,
          itemValue: _3,
          itemValueHighlight: j3,
          itemNameHighlight: V3,
          iconNameGap: B3,
          nameValueGap: L3,
        },
        z3 = 1200,
        H3 = 1031.25,
        U3 = () => (window.matchMedia('(max-width: 768px)').matches ? H3 : z3),
        L0 = [
          { w: 94, h: 86 },
          { w: 112, h: 83 },
          { w: 87, h: 77 },
          { w: 128, h: 68 },
          { w: 127, h: 68 },
          { w: 105, h: 81 },
          { w: 104, h: 81 },
          { w: 77, h: 70 },
          { w: 92, h: 80 },
          { w: 119, h: 67 },
          { w: 118, h: 68 },
          { w: 117, h: 75 },
          { w: 124, h: 74 },
          { w: 56, h: 52 },
          { w: 124, h: 87 },
          { w: 122, h: 78 },
          { w: 114, h: 72 },
        ],
        z0 = { w: 120, h: 111 },
        I3 =
          'https://cdn.creality.com/ow/Feedback/f3a6a6db-dfbc-4b54-852e-8a20ae2d2079.png';
      function W3(i) {
        return i === '√' ? '✓' : i;
      }
      function $3({ open: i, onClose: l }) {
        const o = Z.useRef(null),
          r = Z.useRef(null),
          [u, d] = Z.useState(1),
          [p, h] = Z.useState(0),
          { t: m } = Se(),
          { t: y } = Se('imageUrl'),
          E = m('section12.inBoxModal.variants', { returnObjects: !0 }),
          v = m('section12.inBoxModal.items', { returnObjects: !0 });
        return (
          Z.useEffect(() => {
            if (!i) return;
            const S = document.body.style.overflow;
            return (
              (document.body.style.overflow = 'hidden'),
              () => {
                document.body.style.overflow = S;
              }
            );
          }, [i]),
          Z.useEffect(() => {
            if (!i) return;
            const S = x => {
              x.key === 'Escape' && l();
            };
            return (
              window.addEventListener('keydown', S),
              () => window.removeEventListener('keydown', S)
            );
          }, [i, l]),
          Z.useEffect(() => {
            if (!i) {
              (d(1), h(0));
              return;
            }
            const S = o.current,
              x = r.current;
            if (!S || !x) return;
            const D = () => {
              const k = S.clientWidth / U3();
              (d(k), h(x.offsetHeight * k));
            };
            D();
            const M = new ResizeObserver(D);
            return (
              M.observe(S),
              M.observe(x),
              window.addEventListener('resize', D),
              () => {
                (M.disconnect(), window.removeEventListener('resize', D));
              }
            );
          }, [i, E.length, v.length]),
          i
            ? c3.createPortal(
                g.jsxDEV(
                  'div',
                  {
                    className: Ie.overlay,
                    onClick: S => {
                      S.target === S.currentTarget && l();
                    },
                    role: 'presentation',
                    children: g.jsxDEV(
                      'div',
                      {
                        ref: o,
                        className: Ie.panel,
                        role: 'dialog',
                        'aria-modal': 'true',
                        'aria-labelledby': 'in-box-modal-title',
                        children: [
                          g.jsxDEV(
                            'button',
                            {
                              type: 'button',
                              className: Ie.closeBtn,
                              onClick: l,
                              'aria-label': 'Close',
                              children: g.jsxDEV(
                                'img',
                                {
                                  className: Ie.closeBtnIcon,
                                  src: I3,
                                  alt: '',
                                  'aria-hidden': 'true',
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                  lineNumber: 135,
                                  columnNumber: 11,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                              lineNumber: 134,
                              columnNumber: 9,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'div',
                            {
                              className: Ie.scrollArea,
                              children: g.jsxDEV(
                                'div',
                                {
                                  className: Ie.scaleShell,
                                  style: { height: p || void 0 },
                                  children: g.jsxDEV(
                                    'div',
                                    {
                                      ref: r,
                                      className: Ie.designRoot,
                                      style: { transform: `scale(${u})` },
                                      children: [
                                        g.jsxDEV(
                                          'h2',
                                          {
                                            id: 'in-box-modal-title',
                                            className: Ie.title,
                                            children: m(
                                              'section12.inBoxModal.title'
                                            ),
                                          },
                                          void 0,
                                          !1,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                            lineNumber: 147,
                                            columnNumber: 15,
                                          },
                                          this
                                        ),
                                        g.jsxDEV(
                                          'div',
                                          {
                                            className: Ie.compareSection,
                                            children: [
                                              g.jsxDEV(
                                                'div',
                                                {
                                                  className: Ie.machineRow,
                                                  children: [
                                                    g.jsxDEV(
                                                      'div',
                                                      {
                                                        className: Ie.iconCol,
                                                        'aria-hidden': 'true',
                                                      },
                                                      void 0,
                                                      !1,
                                                      {
                                                        fileName:
                                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                        lineNumber: 153,
                                                        columnNumber: 19,
                                                      },
                                                      this
                                                    ),
                                                    g.jsxDEV(
                                                      'div',
                                                      {
                                                        className:
                                                          Ie.iconNameGap,
                                                        'aria-hidden': 'true',
                                                      },
                                                      void 0,
                                                      !1,
                                                      {
                                                        fileName:
                                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                        lineNumber: 154,
                                                        columnNumber: 19,
                                                      },
                                                      this
                                                    ),
                                                    g.jsxDEV(
                                                      'p',
                                                      {
                                                        className:
                                                          Ie.machineLabel,
                                                        dangerouslySetInnerHTML:
                                                          {
                                                            __html: m(
                                                              'section12.inBoxModal.machineLabel'
                                                            ),
                                                          },
                                                      },
                                                      void 0,
                                                      !1,
                                                      {
                                                        fileName:
                                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                        lineNumber: 155,
                                                        columnNumber: 19,
                                                      },
                                                      this
                                                    ),
                                                    g.jsxDEV(
                                                      'div',
                                                      {
                                                        className:
                                                          Ie.nameValueGap,
                                                        'aria-hidden': 'true',
                                                      },
                                                      void 0,
                                                      !1,
                                                      {
                                                        fileName:
                                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                        lineNumber: 159,
                                                        columnNumber: 19,
                                                      },
                                                      this
                                                    ),
                                                    g.jsxDEV(
                                                      'div',
                                                      {
                                                        className:
                                                          Ie.variantList,
                                                        children: E.map(S =>
                                                          g.jsxDEV(
                                                            'div',
                                                            {
                                                              className:
                                                                Ie.variantItem,
                                                              children: [
                                                                g.jsxDEV(
                                                                  'div',
                                                                  {
                                                                    className:
                                                                      Ie.variantImageWrap,
                                                                    style: {
                                                                      width:
                                                                        z0.w,
                                                                      height:
                                                                        z0.h,
                                                                    },
                                                                    children:
                                                                      g.jsxDEV(
                                                                        'img',
                                                                        {
                                                                          className:
                                                                            Ie.variantImage,
                                                                          src: y(
                                                                            S.imageKey
                                                                          ),
                                                                          alt: '',
                                                                          decoding:
                                                                            'async',
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                          fileName:
                                                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                                          lineNumber: 170,
                                                                          columnNumber: 27,
                                                                        },
                                                                        this
                                                                      ),
                                                                  },
                                                                  void 0,
                                                                  !1,
                                                                  {
                                                                    fileName:
                                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                                    lineNumber: 163,
                                                                    columnNumber: 25,
                                                                  },
                                                                  this
                                                                ),
                                                                g.jsxDEV(
                                                                  'p',
                                                                  {
                                                                    className:
                                                                      Ie.variantLabel,
                                                                    dangerouslySetInnerHTML:
                                                                      {
                                                                        __html:
                                                                          S.label,
                                                                      },
                                                                  },
                                                                  void 0,
                                                                  !1,
                                                                  {
                                                                    fileName:
                                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                                    lineNumber: 177,
                                                                    columnNumber: 25,
                                                                  },
                                                                  this
                                                                ),
                                                              ],
                                                            },
                                                            S.imageKey,
                                                            !0,
                                                            {
                                                              fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                              lineNumber: 162,
                                                              columnNumber: 23,
                                                            },
                                                            this
                                                          )
                                                        ),
                                                      },
                                                      void 0,
                                                      !1,
                                                      {
                                                        fileName:
                                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                        lineNumber: 160,
                                                        columnNumber: 19,
                                                      },
                                                      this
                                                    ),
                                                  ],
                                                },
                                                void 0,
                                                !0,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                  lineNumber: 152,
                                                  columnNumber: 17,
                                                },
                                                this
                                              ),
                                              g.jsxDEV(
                                                'div',
                                                {
                                                  className: Ie.table,
                                                  children: v.map((S, x) => {
                                                    const D = L0[x] ?? L0[0];
                                                    return g.jsxDEV(
                                                      'div',
                                                      {
                                                        className: Ie.tableRow,
                                                        children: [
                                                          g.jsxDEV(
                                                            'div',
                                                            {
                                                              className:
                                                                Ie.iconCol,
                                                              children:
                                                                g.jsxDEV(
                                                                  'div',
                                                                  {
                                                                    className:
                                                                      Ie.itemIconWrap,
                                                                    style: {
                                                                      width:
                                                                        D.w,
                                                                      height:
                                                                        D.h,
                                                                    },
                                                                    children:
                                                                      g.jsxDEV(
                                                                        'img',
                                                                        {
                                                                          className:
                                                                            Ie.itemIcon,
                                                                          src: y(
                                                                            S.imageKey
                                                                          ),
                                                                          alt: '',
                                                                          decoding:
                                                                            'async',
                                                                        },
                                                                        void 0,
                                                                        !1,
                                                                        {
                                                                          fileName:
                                                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                                          lineNumber: 197,
                                                                          columnNumber: 29,
                                                                        },
                                                                        this
                                                                      ),
                                                                  },
                                                                  void 0,
                                                                  !1,
                                                                  {
                                                                    fileName:
                                                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                                    lineNumber: 193,
                                                                    columnNumber: 27,
                                                                  },
                                                                  this
                                                                ),
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                              fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                              lineNumber: 192,
                                                              columnNumber: 25,
                                                            },
                                                            this
                                                          ),
                                                          g.jsxDEV(
                                                            'div',
                                                            {
                                                              className:
                                                                Ie.iconNameGap,
                                                              'aria-hidden':
                                                                'true',
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                              fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                              lineNumber: 205,
                                                              columnNumber: 25,
                                                            },
                                                            this
                                                          ),
                                                          g.jsxDEV(
                                                            'p',
                                                            {
                                                              className:
                                                                S.highlightValues
                                                                  ? `${Ie.itemName} ${Ie.itemNameHighlight}`
                                                                  : Ie.itemName,
                                                              dangerouslySetInnerHTML:
                                                                {
                                                                  __html:
                                                                    S.name,
                                                                },
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                              fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                              lineNumber: 206,
                                                              columnNumber: 25,
                                                            },
                                                            this
                                                          ),
                                                          g.jsxDEV(
                                                            'div',
                                                            {
                                                              className:
                                                                Ie.nameValueGap,
                                                              'aria-hidden':
                                                                'true',
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                              fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                              lineNumber: 214,
                                                              columnNumber: 25,
                                                            },
                                                            this
                                                          ),
                                                          g.jsxDEV(
                                                            'div',
                                                            {
                                                              className:
                                                                Ie.valueList,
                                                              children:
                                                                S.values.map(
                                                                  (M, k) =>
                                                                    g.jsxDEV(
                                                                      'span',
                                                                      {
                                                                        className:
                                                                          S.highlightValues
                                                                            ? Ie.itemValueHighlight
                                                                            : Ie.itemValue,
                                                                        children:
                                                                          W3(M),
                                                                      },
                                                                      `${S.imageKey}-${k}`,
                                                                      !1,
                                                                      {
                                                                        fileName:
                                                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                                        lineNumber: 217,
                                                                        columnNumber: 29,
                                                                      },
                                                                      this
                                                                    )
                                                                ),
                                                            },
                                                            void 0,
                                                            !1,
                                                            {
                                                              fileName:
                                                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                              lineNumber: 215,
                                                              columnNumber: 25,
                                                            },
                                                            this
                                                          ),
                                                        ],
                                                      },
                                                      S.imageKey,
                                                      !0,
                                                      {
                                                        fileName:
                                                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                        lineNumber: 191,
                                                        columnNumber: 23,
                                                      },
                                                      this
                                                    );
                                                  }),
                                                },
                                                void 0,
                                                !1,
                                                {
                                                  fileName:
                                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                                  lineNumber: 186,
                                                  columnNumber: 17,
                                                },
                                                this
                                              ),
                                            ],
                                          },
                                          void 0,
                                          !0,
                                          {
                                            fileName:
                                              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                            lineNumber: 151,
                                            columnNumber: 15,
                                          },
                                          this
                                        ),
                                      ],
                                    },
                                    void 0,
                                    !0,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                      lineNumber: 140,
                                      columnNumber: 13,
                                    },
                                    this
                                  ),
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                                  lineNumber: 139,
                                  columnNumber: 11,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                              lineNumber: 138,
                              columnNumber: 9,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                        lineNumber: 127,
                        columnNumber: 7,
                      },
                      this
                    ),
                  },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/InBoxModal.tsx',
                    lineNumber: 120,
                    columnNumber: 5,
                  },
                  this
                ),
                document.body
              )
            : null
        );
      }
      const P3 = 'section12_OjqAT',
        G3 = 'inBoxBtn_cF23N',
        q3 = 'inBoxIcon_vQHFP',
        Y3 = 'inBoxPlus_pNNRB',
        X3 = 'title_x9P1A',
        Q3 = 'grid_myxIo',
        Z3 = 'card_ix3xB',
        F3 = 'cardImageWrap_R5BFi',
        K3 = 'cardContent_TJK9z',
        J3 = 'btnActive_vydrq',
        e4 = 'btnInactive_FjNNo',
        t4 = 'cardImage_xcsQF',
        $n = {
          section12: P3,
          inBoxBtn: G3,
          inBoxIcon: q3,
          inBoxPlus: Y3,
          title: X3,
          grid: Q3,
          card: Z3,
          cardImageWrap: F3,
          cardContent: K3,
          btnActive: J3,
          btnInactive: e4,
          cardImage: t4,
        },
        n4 = [
          'accessoryAirPurifier',
          'accessoryFixture',
          'accessoryFan',
          'accessoryRotary',
        ],
        H0 = [
          'https://www.crealityfalcon.com/products/creality-falcon-intelligent-air-purifier-ap1-mini',
          'https://www.crealityfalcon.com/products/creality-falcon-flexible-fixture',
          'https://www.crealityfalcon.com/products/creality-falcon-ef1-exhaust-fan',
        ];
      function a4() {
        const [i, l] = Z.useState(!1),
          { t: o } = Se(),
          { t: r } = Se('imageUrl'),
          u = o('section12.accessories', { returnObjects: !0 }),
          d = Z.useMemo(() => o3.map(p => r(p)).filter(Boolean), [r]);
        return (
          bS(d),
          g.jsxDEV(
            'section',
            {
              className: $n.section12,
              children: [
                g.jsxDEV(
                  'button',
                  {
                    type: 'button',
                    className: $n.inBoxBtn,
                    onClick: () => l(!0),
                    children: [
                      g.jsxDEV(
                        'div',
                        {
                          className: $n.inBoxIcon,
                          children: g.jsxDEV(
                            Rt,
                            {
                              name: 'icon-add',
                              className: $n.inBoxPlus,
                              'aria-hidden': 'true',
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                              lineNumber: 43,
                              columnNumber: 11,
                            },
                            this
                          ),
                        },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                          lineNumber: 42,
                          columnNumber: 9,
                        },
                        this
                      ),
                      g.jsxDEV(
                        'span',
                        { children: o('section12.inBox') },
                        void 0,
                        !1,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                          lineNumber: 45,
                          columnNumber: 9,
                        },
                        this
                      ),
                    ],
                  },
                  void 0,
                  !0,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                    lineNumber: 41,
                    columnNumber: 7,
                  },
                  this
                ),
                g.jsxDEV(
                  $3,
                  { open: i, onClose: () => l(!1) },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                    lineNumber: 48,
                    columnNumber: 7,
                  },
                  this
                ),
                g.jsxDEV(
                  'h2',
                  {
                    className: $n.title,
                    dangerouslySetInnerHTML: {
                      __html: o('section12.accessoriesTitle'),
                    },
                  },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                    lineNumber: 50,
                    columnNumber: 7,
                  },
                  this
                ),
                g.jsxDEV(
                  'div',
                  {
                    className: $n.grid,
                    children: u.map((p, h) =>
                      g.jsxDEV(
                        'div',
                        {
                          className: $n.card,
                          children: [
                            g.jsxDEV(
                              'div',
                              {
                                className: $n.cardImageWrap,
                                children: g.jsxDEV(
                                  Ft,
                                  {
                                    className: $n.cardImage,
                                    src: r(n4[h]),
                                    width: 'auto',
                                    height: 'auto',
                                    alt: p.title,
                                  },
                                  void 0,
                                  !1,
                                  {
                                    fileName:
                                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                                    lineNumber: 59,
                                    columnNumber: 15,
                                  },
                                  this
                                ),
                              },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                                lineNumber: 58,
                                columnNumber: 13,
                              },
                              this
                            ),
                            g.jsxDEV(
                              'div',
                              {
                                className: $n.cardContent,
                                children: [
                                  g.jsxDEV(
                                    'h3',
                                    { children: p.title },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                                      lineNumber: 68,
                                      columnNumber: 15,
                                    },
                                    this
                                  ),
                                  g.jsxDEV(
                                    'p',
                                    { children: p.description },
                                    void 0,
                                    !1,
                                    {
                                      fileName:
                                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                                      lineNumber: 69,
                                      columnNumber: 15,
                                    },
                                    this
                                  ),
                                  H0[h]
                                    ? g.jsxDEV(
                                        'a',
                                        {
                                          href: H0[h],
                                          className: $n.btnActive,
                                          target: '_blank',
                                          rel: 'noopener noreferrer',
                                          children: o('section12.learnMore'),
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                                          lineNumber: 71,
                                          columnNumber: 17,
                                        },
                                        this
                                      )
                                    : g.jsxDEV(
                                        'button',
                                        {
                                          type: 'button',
                                          className: $n.btnInactive,
                                          disabled: !0,
                                          children: o('section12.learnMore'),
                                        },
                                        void 0,
                                        !1,
                                        {
                                          fileName:
                                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                                          lineNumber: 80,
                                          columnNumber: 17,
                                        },
                                        this
                                      ),
                                ],
                              },
                              void 0,
                              !0,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                                lineNumber: 67,
                                columnNumber: 13,
                              },
                              this
                            ),
                          ],
                        },
                        p.title,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                          lineNumber: 57,
                          columnNumber: 11,
                        },
                        this
                      )
                    ),
                  },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
                    lineNumber: 55,
                    columnNumber: 7,
                  },
                  this
                ),
              ],
            },
            void 0,
            !0,
            {
              fileName:
                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section12/index.tsx',
              lineNumber: 40,
              columnNumber: 5,
            },
            this
          )
        );
      }
      const i4 = 'section13_AxbJQ',
        l4 = 'title_qj63u',
        s4 = 'specLayout_L1d-U',
        o4 = 'specRow_kXKJp',
        r4 = 'rowTall_uFn9f',
        c4 = 'imageRow_1dMH8',
        u4 = 'colValue_SzflA',
        d4 = 'colLabel_xnvoi',
        f4 = 'valueSymbol_2hW1L',
        un = {
          section13: i4,
          title: l4,
          specLayout: s4,
          specRow: o4,
          rowTall: r4,
          imageRow: c4,
          colValue: u4,
          colLabel: d4,
          valueSymbol: f4,
        };
      function m4() {
        const { t: i } = Se(),
          { t: l } = Se('imageUrl'),
          o = i('section13.labels', { returnObjects: !0 }),
          r = i('section13.variants', { returnObjects: !0 }),
          u = [
            { label: o[0], render: h => h.name },
            { label: o[1], render: h => h.color },
            { label: o[2], render: h => h.laserModules },
            { label: o[3], render: h => h.interchangeable },
            { label: o[4], render: h => h.engravingArea },
            { label: o[5], render: h => h.maxHeight },
            { label: o[6], render: h => h.laserSafety },
            { label: o[7], render: h => h.maxSpeed },
            { label: o[8], render: h => h.focusMode },
            { label: o[9], render: h => h.camera },
            { label: o[10], render: h => h.cameraAssist },
            { label: o[11], render: h => h.aiFill },
            { label: o[12], render: h => h.optionalPackages },
            { label: o[13], render: h => h.iotControl },
            { label: o[14], render: h => h.appControl },
            { label: o[15], render: h => h.machineDim },
            { label: o[16], render: h => h.packageDim },
            { label: o[17], render: h => h.netWeight },
            { label: o[18], render: h => h.grossWeight },
          ],
          d = h =>
            h === !0 || h === '✓'
              ? g.jsxDEV(
                  'span',
                  { className: un.valueSymbol, children: '✓' },
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                    lineNumber: 60,
                    columnNumber: 14,
                  },
                  this
                )
              : h === !1 || h === '×'
                ? g.jsxDEV(
                    'span',
                    { className: un.valueSymbol, children: '×' },
                    void 0,
                    !1,
                    {
                      fileName:
                        'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                      lineNumber: 63,
                      columnNumber: 14,
                    },
                    this
                  )
                : h || ' ',
          p = h =>
            h.includes(`
`)
              ? h
                  .split(
                    `
`
                  )
                  .map((m, y) =>
                    g.jsxDEV(
                      Z.Fragment,
                      {
                        children: [
                          y > 0 &&
                            g.jsxDEV(
                              'br',
                              {},
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                                lineNumber: 77,
                                columnNumber: 23,
                              },
                              this
                            ),
                          m,
                        ],
                      },
                      y,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                        lineNumber: 76,
                        columnNumber: 7,
                      },
                      this
                    )
                  )
              : h;
        return g.jsxDEV(
          'section',
          {
            className: un.section13,
            children: [
              g.jsxDEV(
                'h2',
                { className: un.title, children: i('section13.title') },
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                  lineNumber: 85,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                'div',
                {
                  className: un.specLayout,
                  children: [
                    g.jsxDEV(
                      'div',
                      {
                        className: `${un.specRow} ${un.imageRow}`,
                        children: [
                          g.jsxDEV(
                            'div',
                            { className: un.colLabel },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                              lineNumber: 89,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'div',
                            {
                              className: un.colValue,
                              children: g.jsxDEV(
                                Ft,
                                {
                                  src: l('specTable1'),
                                  width: 'auto',
                                  height: 'auto',
                                  alt: '',
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                                  lineNumber: 91,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                              lineNumber: 90,
                              columnNumber: 11,
                            },
                            this
                          ),
                          g.jsxDEV(
                            'div',
                            {
                              className: un.colValue,
                              children: g.jsxDEV(
                                Ft,
                                {
                                  src: l('specTable2'),
                                  width: 'auto',
                                  height: 'auto',
                                  alt: '',
                                },
                                void 0,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                                  lineNumber: 94,
                                  columnNumber: 13,
                                },
                                this
                              ),
                            },
                            void 0,
                            !1,
                            {
                              fileName:
                                'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                              lineNumber: 93,
                              columnNumber: 11,
                            },
                            this
                          ),
                        ],
                      },
                      void 0,
                      !0,
                      {
                        fileName:
                          'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                        lineNumber: 88,
                        columnNumber: 9,
                      },
                      this
                    ),
                    u.map((h, m) =>
                      g.jsxDEV(
                        'div',
                        {
                          className: `${un.specRow} ${m === 6 || m === 17 ? un.rowTall : ''}`,
                          children: [
                            g.jsxDEV(
                              'div',
                              { className: un.colLabel, children: p(h.label) },
                              void 0,
                              !1,
                              {
                                fileName:
                                  'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                                lineNumber: 103,
                                columnNumber: 13,
                              },
                              this
                            ),
                            r.map(y =>
                              g.jsxDEV(
                                'div',
                                {
                                  className: un.colValue,
                                  children: d(h.render(y)),
                                },
                                y.color,
                                !1,
                                {
                                  fileName:
                                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                                  lineNumber: 105,
                                  columnNumber: 15,
                                },
                                this
                              )
                            ),
                          ],
                        },
                        h.label,
                        !0,
                        {
                          fileName:
                            'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                          lineNumber: 99,
                          columnNumber: 11,
                        },
                        this
                      )
                    ),
                  ],
                },
                void 0,
                !0,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
                  lineNumber: 87,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/components/Section13/index.tsx',
            lineNumber: 84,
            columnNumber: 5,
          },
          this
        );
      }
      function p4() {
        const { i18n: i } = Se();
        return g.jsxDEV(
          'div',
          {
            className: jE.page,
            'data-lang': i.language,
            style: { color: 'var(--a1c-text-dark)' },
            children: [
              g.jsxDEV(
                QE,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 26,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                KD,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 27,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                sT,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 28,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                FT,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 29,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                eM,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 30,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                NM,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 31,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                AM,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 32,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                pO,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 33,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                AO,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 34,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                kk,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 35,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                s3,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 36,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                a4,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 37,
                  columnNumber: 7,
                },
                this
              ),
              g.jsxDEV(
                m4,
                {},
                void 0,
                !1,
                {
                  fileName:
                    'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
                  lineNumber: 38,
                  columnNumber: 7,
                },
                this
              ),
            ],
          },
          void 0,
          !0,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/index.tsx',
            lineNumber: 21,
            columnNumber: 5,
          },
          this
        );
      }
      const h4 = {
          title: 'Creality Falcon A1C',
          section1: {
            badge: 'NEW',
            title: 'Creality Falcon A1C',
            subtitle: 'The Perfect First Laser Engraver<br/>for Your Home.',
            scrollTitle:
              'Lightweight & easy to use,<br/>unlock home creativity for<br/>all beginners.',
            scrollSubtitle: 'Your all-in-one household<br/>creativity engine.',
          },
          section2: {
            title: 'Highlights',
            autoFocus: 'True Auto Focus',
            liftingPlatform: 'Smart Lifting Platform',
            workingAreaLabel: 'Working Area:',
            workingAreaValue: '150 × 150 × <strong>148 mm</strong>',
            laserModulesTitle: '3 Interchangeable Laser Modules',
            laser5w: '5W',
            laser5wType: 'Diode',
            laser10w: '10W',
            laser10wType: 'Diode',
            laserIR: '1.2W',
            laserIRType: 'IR',
            materialsCount: '300+',
            materials: 'Materials',
            laserSafety: 'Laser Safety',
            class1: 'Class 1',
            smartIoT: 'Smart IoT Control',
            smartIoTDesc: `Seamless control
across devices`,
            aiCamera: 'AI Camera Assist',
            aiCameraDesc: 'Easier Positioning and Filling',
            highSpeed: 'High-Speed Engraving',
            upTo: 'up to',
            speedValue: '15,000',
            speedUnit: ' mm/min',
            aiPowered: 'AI-Powered<br/>',
            smartExperience: 'Smart Experience',
          },
          section3: {
            title: 'Experience Fun in<br class="br_mb"/>Various Scenarios',
            subtitle: 'A1C fits perfectly into your lifestyle',
            scenarios: [
              {
                title: 'Everyday DIY &<br class="br_pc"/>Creative Moments',
                description:
                  'Create decorations, gifts, and keepsakes that<br class="br_mb"/>add a personal touch to daily life.',
                imagePosition: 'right',
                bgColor: '#ebedfa',
              },
              {
                title:
                  'Holidays, Parties &<br class="br_pc"/>Special Occasions',
                description:
                  'Make instant, personalized creations for birthdays,<br class="br_mb"/>holidays, and gatherings.',
                imagePosition: 'left',
                bgColor: '#faf5eb',
              },
              {
                title:
                  'Turn Creativity<br class="br_pc"/>into Meaningful Gifts',
                description:
                  'Engrave names, dates, or messages&#8209;make<br class="br_mb"/>every gift truly one of a kind.',
                imagePosition: 'right',
                bgColor: '#ebfaf2',
              },
              {
                title:
                  'Retail & pop-up store<br class="br_pc"/>on-site engraving',
                description:
                  'Instant personalization for customers&#8209;boost<br class="br_mb"/>engagement and sales.',
                imagePosition: 'left',
                bgColor: '#faf0eb',
              },
            ],
          },
          section4: {
            title: 'Simple and Easy to Use',
            subtitle: 'Start creating right away-no experience required.',
            easyUseTabs: [
              {
                title: 'Interchangeable<br class="br_pc"/>Laser Modules',
                description:
                  'Swap <span class="highlight">5W / 10W / 1.2W</span> lasers<br class="br_mb"/>in seconds without tools.',
                video: 'easyUseVideo1',
              },
              {
                title: 'True Autofocus,<br class="br_pc"/>No manual adjustment',
                description:
                  'Just place the material and click. The machine automatically finds the perfect height.',
                video: 'easyUseVideo2',
              },
              {
                title: 'Clear PC/APP control',
                description:
                  'Control the machine with intuitive software, even as a beginner.',
                video: 'easyUseVideo3',
              },
              {
                title: 'Portable and<br class="br_pc"/>Easy to Carry',
                description:
                  'Easy to move between your living room, classroom, studio, or shop counter.',
                image: 'easyUse4',
              },
            ],
          },
          section5: {
            heroTitle: 'Greater Stability,<br/>Sharper Details',
            stabilityCards: [
              {
                title: 'High Motion Accuracy',
                description:
                  'Precise and smooth<br class="br_mb"/>movement delivers cleaner,<br class="br_mb"/>more consistent lines.',
              },
              {
                title: 'Rigid Structural Design',
                description:
                  'Solid construction effectively<br class="br_mb"/>reduces vibration for stable<br class="br_mb"/>engraving performance.',
              },
              {
                title: 'Fine Laser Spot',
                description:
                  'A smaller laser spot<br class="br_mb"/>produces sharper lines<br class="br_mb"/>and more refined details.',
              },
            ],
            materialsTitle:
              'Precise Engraving on<br class="br_mb"/>Various Materials',
            materialsSubtitle: 'One machine, endless possibilities',
            tabDiode: '5W / 10W Diode',
            tabIR: '1.2W IR',
            materialCarousel: {
              diode: {
                slides: [
                  {
                    label: 'Wood',
                    image: 'diodeSlide1',
                    indicator: 'diodeIndicator1',
                  },
                  {
                    label: 'Bamboo',
                    image: 'diodeSlide2',
                    indicator: 'diodeIndicator2',
                  },
                  {
                    label: 'Paper',
                    image: 'diodeSlide3',
                    indicator: 'diodeIndicator3',
                  },
                  {
                    label: 'Cork/Cardboard',
                    image: 'diodeSlide4',
                    indicator: 'diodeIndicator4',
                  },
                  {
                    label: 'Rock',
                    image: 'diodeSlide5',
                    indicator: 'diodeIndicator5',
                  },
                  {
                    label: 'Leather',
                    image: 'diodeSlide6',
                    indicator: 'diodeIndicator6',
                  },
                  {
                    label: 'Glass',
                    image: 'diodeSlide7',
                    indicator: 'diodeIndicator7',
                  },
                  {
                    label: 'Fabric',
                    image: 'diodeSlide8',
                    indicator: 'diodeIndicator8',
                  },
                ],
              },
              ir: {
                slides: [
                  {
                    label: 'Brass & Gold',
                    image: 'irSlide1',
                    indicator: 'irIndicator1',
                  },
                  {
                    label: 'Silver & Platinum',
                    image: 'irSlide2',
                    indicator: 'irIndicator2',
                  },
                  {
                    label: 'Acrylic & Plastic',
                    image: 'irSlide3',
                    indicator: 'irIndicator3',
                  },
                  {
                    label: 'Aluminum & Stainless Steel',
                    image: 'irSlide4',
                    indicator: 'irIndicator4',
                  },
                ],
              },
            },
            galleryTitle: 'Start Creating Today with Falcon A1C',
            gallerySlides: [
              { label: 'Home', image: 'gallerySlide1' },
              { label: 'Gifts', image: 'gallerySlide2' },
              { label: 'Holiday', image: 'gallerySlide3' },
              { label: 'Events', image: 'gallerySlide4' },
              { label: 'Apparel', image: 'gallerySlide5' },
              { label: 'Pet', image: 'gallerySlide6' },
            ],
          },
          section6: {
            title: 'Auto Lifting',
            workspace: '150×150×148 mm',
            subtitle: 'Bigger Workspace in a Compact Body',
            description:
              'Despite its compact size, A1C delivers an impressively large 150 × 150 mm workspace',
            emDash: '—',
            descriptionEnd:
              'big enough for real, practical projects. Create coasters, leather goods, small ornaments, and personalized gifts with ease.',
          },
          section7: {
            title: "15,000 mm/min<br class='br_mb' /> High-Speed Engraving",
            subtitle:
              "Leading speed in its class-less waiting,<br class='br_mb' /> smoother creation.",
          },
          section8: {
            class1: 'Class 1',
            eyeSafe: ' Eye-Safe Design',
            noGoggles: 'No protective goggles',
            noGogglesEnd: ' required for everyday use.',
            safetyTabs: [
              {
                title: 'Fully Enclosed Protective Design',
                description:
                  'Effectively blocks harmful laser exposure while keeping a clear, visible workspace.',
                image: 'safetyTab1',
              },
              {
                title: 'Smart Flame Detection for Safer Engraving',
                description:
                  'Automatically stops operation if flames are detected, with buzzer alerts and instant notifications sent to PC and App.',
                image: 'safetyTab2',
              },
              {
                title: 'Tilt Protection',
                description:
                  'Automatically shuts down the machine if abnormal tilting is detected.',
                image: 'safetyTab3',
              },
              {
                title: 'USB Safety Lock',
                description:
                  'Prevents accidental operation and keeps children safe.',
                image: 'safetyTab4',
              },
            ],
          },
          section9: {
            title: 'Easy Free Software Studio',
            subtitle: 'Powerful tools that stay friendly for beginners',
            fdsTitle: 'Free FDS Studio',
            fdsDesc:
              'Clean interface, intuitive controls, and real-time<br class="br_mb"/>preview for effortless creation.',
            features: [
              {
                title: 'Full LightBurn compatibility',
                description:
                  'Advanced tools for creators who want deeper control and professional results.',
              },
              {
                title: 'Multi-Device Control',
                description:
                  'Operate via PC or mobile<br class="br_mb"/>App, with Wi-Fi, Bluetooth,<br class="br_mb"/>and USB connectivity for<br class="br_mb"/>flexible workflow.',
              },
            ],
          },
          section10: {
            title: 'Smart Tech That Elevates Everything',
            aiTabs: [
              {
                title: 'AI Filter Lab',
                description:
                  'Switch between a variety of professional styles and refresh your creative assets with one click.',
                video: 'aiVideo1',
              },
              {
                title: 'AI Contour Extraction',
                description:
                  'Automatically detects colors and separates layers, converting images into color vector layers ideal for multi-color engraving—making color engraving faster and easier.',
                video: 'aiVideo2',
              },
              {
                title: 'AI Background Removal',
                description:
                  'Automatically identifies object edges to create smooth, high-quality transparent images for faster workflows.',
                video: 'aiVideo3',
              },
            ],
            featureSlides: [
              {
                title: 'Rich Project Library, Endless Inspiration',
                description:
                  'The Caftseek library offers thousands of free, high-quality project designs. Download with one click and start creating—your creativity never runs out!',
                image: 'featureSlide1',
              },
              {
                title: 'APP AI One-Tap Engraving',
                description:
                  'Upload a photo or take one with your phone. AI automatically converts it into engraving-ready styles like line art or illustration, optimizes the image, and matches the right material settings. Start with one tap-beginners can easily create high-quality engravings.',
                image: 'featureSlide2',
              },
              {
                title: 'AI Support Assistant',
                description:
                  'When the device detects an alert, the AI assistant automatically provides the right solution.<br/>AI + human support ensures a worry-free experience from setup to production.',
                image: 'featureSlide3',
              },
              {
                title: 'Cloud Storage',
                description:
                  'Supports cloud-based file storage with seamless access across devices.<br/>Your designs can be downloaded directly to the touchscreen anytime-start engraving whenever inspiration strikes.',
                image: 'featureSlide4',
              },
              {
                title: 'Material Test Array',
                description:
                  'Automatically generates a grid with multiple power and speed combinations in a single job, helping you quickly identify the best settings for new materials while reducing trial and error.',
                image: 'featureSlide5',
              },
              {
                title: 'Intelligent Split & Fill',
                description:
                  'Split oversized designs into joinable parts with precision joints, and use intelligent fill to optimize layouts for efficient material usage.',
                image: 'featureSlide6',
              },
            ],
          },
          section11: {
            title: 'Portable, Flexible & Easy to Maintain',
            engraveCups: 'Engrave Cups & Spheres',
            engraveCupsDesc:
              'Easily engrave tumblers, mugs, spherical ornaments, and various curved or cylindrical items.',
            maintenanceTitle: 'Easy Maintenance,<br/>Easy Cleaning',
            maintenanceDesc:
              'Quick-release fan design makes daily cleaning simple and hassle-free.',
            portableTitle: 'Portable & Ready to Go',
            portableDesc:
              'Lightweight and easy to move-start creating anytime in your living room, garage, or studio.',
            portablePanels: [
              { image: 'portablePanel1', playIcon: 'portable1' },
              { image: 'portablePanel2', playIcon: 'portable1' },
              { image: 'portablePanel3', playIcon: 'portable2' },
            ],
            airPurifierTitle:
              'Optional Air Purifier for<br/>Worry-Free Creation',
            airPurifierDesc:
              'Effectively filters smoke and odors generated during engraving, making it ideal for home and indoor use.',
            fixtureTitle: 'Flexible Fixture Expansion',
            fixtureDesc:
              'Unlock more creative scenarios and explore new possibilities with flexible workholding options.',
          },
          section12: {
            inBox: 'What in box',
            inBoxModal: {
              title: 'What in box',
              machineLabel: 'Laser Cutter and Engraver:',
              variants: [
                { label: 'Purple Gray<br />5W', imageKey: 'inBoxVariantPg5w' },
                { label: 'White<br />5W', imageKey: 'inBoxVariantWhite5w' },
                {
                  label: 'Purple Gray<br />10W',
                  imageKey: 'inBoxVariantPg10w',
                },
                { label: 'White<br />10W', imageKey: 'inBoxVariantWhite10w' },
              ],
              items: [
                {
                  name: 'Power Adapter:',
                  imageKey: 'inBoxItem1',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Power Cord:',
                  imageKey: 'inBoxItem2',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Exhaust Pipe:',
                  imageKey: 'inBoxItem3',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Type-A to<br />Type-C Cable:',
                  imageKey: 'inBoxItem4',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Lint-free Brush:',
                  imageKey: 'inBoxItem5',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'M2/M2.5<br />Hex Key:',
                  imageKey: 'inBoxItem6',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Type-A to<br />Type-C Adapter:',
                  imageKey: 'inBoxItem7',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Hose Clamp:',
                  imageKey: 'inBoxItem8',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Dust-free Cloth:',
                  imageKey: 'inBoxItem9',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Quick Start<br />Guide:',
                  imageKey: 'inBoxItem10',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Safety<br />Instructions:',
                  imageKey: 'inBoxItem11',
                  values: ['√', '√', '√', '√'],
                },
                {
                  name: 'Camera<br />Calibration Card:',
                  imageKey: 'inBoxItem12',
                  values: ['√', '/', '√', '/'],
                  highlightValues: !0,
                },
                {
                  name: 'Cutting Plate:',
                  imageKey: 'inBoxItem13',
                  values: ['/', '/', '√', '√'],
                  highlightValues: !0,
                },
                {
                  name: 'Materials<br />retention screw:',
                  imageKey: 'inBoxItem14',
                  values: ['2', '2', '2', '2'],
                },
                {
                  name: 'Safety Key:',
                  imageKey: 'inBoxItem15',
                  values: ['2', '2', '2', '2'],
                },
                {
                  name: 'Basswood board:',
                  imageKey: 'inBoxItem16',
                  values: ['3', '3', '3', '3'],
                },
                {
                  name: 'Laser Engrave<br />Photo Paper:',
                  imageKey: 'inBoxItem17',
                  values: ['7', '3', '7', '3'],
                  highlightValues: !0,
                },
              ],
            },
            accessoriesTitle:
              'Adapt to Any Job.<br class="br_mb"/>Master Every Objects',
            learnMore: 'Learn More',
            accessories: [
              {
                title: 'Air Purifier',
                description:
                  'Purifies smoke and odors generated during engraving, helps improve engraving quality, and maintains a cleaner indoor environment.',
                active: !0,
              },
              {
                title: 'Flexible Fixture',
                description:
                  'Fast one-step clamping for irregular and specially shaped objects, with no repeated adjustments required for batch engraving.',
                active: !0,
              },
              {
                title: 'Exhaust Fan',
                description:
                  'Powerfully removes fumes generated during engraving, helping improve engraving quality.',
                active: !0,
              },
              {
                title: 'Rotary kits',
                description:
                  'Supports stable rotary engraving for cylindrical and round objects such as cups, rings, bracelets, and more.',
                active: !1,
              },
            ],
          },
          section13: {
            title: 'Specifications',
            labels: [
              'Product Name:',
              'Product Color:',
              'Laser Modules Support:',
              `Interchangeable
Laser Modules:`,
              'Engraving Area:',
              'Max. Processing Height:',
              'Laser Safety:',
              'Max. Working Speed:',
              'Focus Mode:',
              'Camera:',
              `Camera-Assisted
Positioning:`,
              'AI Smart Fill & Layout:',
              'Optional Packages:',
              'IoT Control:',
              'APP Control:',
              'Machine Dimension:',
              'Package Dimension:',
              `Net Weight:
(Machine Only)`,
              'Gross Weight:',
            ],
            variants: [
              {
                name: 'Falcon A1C',
                color: 'Purple-Gray',
                laserModules: '5W Diode | 10W Diode | 1.2W IR',
                interchangeable: '✓',
                engravingArea: '150 × 150 mm',
                maxHeight: '148 mm',
                laserSafety:
                  'Class 1 Laser Safety Flame Detection Tilt Detection USB Safety Lock',
                maxSpeed: '15000mm/min',
                focusMode: 'Auto Focus',
                camera: '✓',
                cameraAssist: '✓',
                aiFill: '✓',
                optionalPackages: 'Rotary Kit, Air Pufier',
                iotControl: 'Wi-Fi + BLE, IoT Control',
                appControl: 'Wireless APP Control',
                machineDim: '336 mm * 377 mm * 341 mm',
                packageDim: '470 mm * 395 mm * 410 mm',
                netWeight: '9.8 kg',
                grossWeight: '13 kg - 13.3 kg',
              },
              {
                name: 'Falcon A1C',
                color: 'White',
                laserModules: '5W Diode | 10W Diode | 1.2W IR',
                interchangeable: '✓',
                engravingArea: '150 × 150 mm',
                maxHeight: '148 mm',
                laserSafety:
                  'Class 1 Laser Safety Flame Detection Tilt Detection USB Safety Lock',
                maxSpeed: '15000mm/min',
                focusMode: 'Auto Focus',
                camera: '×',
                cameraAssist: '×',
                aiFill: '×',
                optionalPackages: 'Rotary Kit, Air Pufier',
                iotControl: 'Wi-Fi + BLE, IoT Control',
                appControl: 'Wireless APP Control',
                machineDim: '336 mm * 377 mm * 341 mm',
                packageDim: '470 mm * 395 mm * 410 mm',
                netWeight: '9.7 kg',
                grossWeight: '12.9 kg - 13.2 kg',
              },
            ],
          },
        },
        g4 = {},
        U0 =
          'https://cdn.creality.com/ow/a1c/d52f62b5-cb48-463a-a676-83b331e1f119.png',
        b4 = {
          heroBg:
            'https://cdn.creality.com/ow/a1c/8ccf5512-f347-4248-8228-7215bd3d5f4d.jpg',
          heroBgMobile:
            'https://cdn.creality.com/ow/a1c/10b1b59a-df96-4a53-87b9-d4c3b910c21c.jpg',
          materialsIcon:
            'https://cdn.creality.com/ow/a1c/4e527187-2a3b-427d-8d2d-4c5c14dd5124.png',
          materialsIconMobile:
            'https://cdn.creality.com/ow/a1c/4e527187-2a3b-427d-8d2d-4c5c14dd5124.png',
          scenario1:
            'https://cdn.creality.com/ow/a1c/9cc27819-5cc3-4a41-adbd-c32577e48bb0.jpg',
          scenario2:
            'https://cdn.creality.com/ow/a1c/3d3a0d26-47a3-4b91-9a2d-7a339a0d2c0b.jpg',
          scenario3:
            'https://cdn.creality.com/ow/a1c/2cea37a7-6797-46f2-a3ed-c44356e5745b.jpg',
          scenario4:
            'https://cdn.creality.com/ow/a1c/f8edc9bc-445d-474d-88ab-fdbed4842363.jpg',
          easyUseVideo1:
            'https://compress-file.creality.com/videos/Agent/a2ff9305-8e10-4443-baf2-366026107bfb.mp4',
          easyUseVideo2:
            'https://compress-file.creality.com/videos/Agent/01a58747-5ddd-4a05-93b7-c9ece7de0a84.mp4',
          easyUseVideo3:
            'https://compress-file.creality.com/videos/Agent/e55e0b03-8280-4cfb-a535-662ee8081d91.mp4',
          easyUse4:
            'https://cdn.creality.com/ow/a1c/631a0239-0648-40d2-9891-945565873af7.jpg',
          stability1:
            'https://cdn.creality.com/ow/a1c/353f2e70-64ad-4764-82ee-47f8fe115a38.jpg',
          stability2:
            'https://cdn.creality.com/ow/a1c/f1d97b36-fdfa-4c8b-a419-da3fdc915d30.jpg',
          stability3:
            'https://cdn.creality.com/ow/a1c/bd6920ac-1265-4f0b-bde6-a50475697617.jpg',
          speedBg:
            'https://cdn.creality.com/ow/a1c/c6f79ae2-1287-4952-bd52-dd1592cd1203.jpg',
          speedBgMobile:
            'https://cdn.creality.com/ow/a1c/19cad58c-b3de-4c8b-aa5c-a937d43f072b.jpg',
          stabilityHero:
            'https://cdn.creality.com/ow/a1c/b4eff893-f97e-47f8-8854-e22f2f7bb9d7.jpg',
          stabilityHeroMobile:
            'https://cdn.creality.com/ow/a1c/8c90d0b4-1d6d-404a-afa1-1abe93e0a60c.jpg',
          workspaceBg:
            'https://cdn.creality.com/ow/a1c/5863db81-c1c2-4fd3-a666-2a42d8167f20.jpg',
          workspaceBgMobile:
            'https://cdn.creality.com/ow/a1c/6384c4ce-4a95-459f-89c2-5857afde290b.jpg',
          workspaceCard1:
            'https://cdn.creality.com/ow/a1c/5c428bfc-0734-4464-ae9b-89e7cecb67cb.jpg',
          workspaceCard2:
            'https://cdn.creality.com/ow/a1c/ddd2c3fd-c9b2-401e-a5d4-944a8674e51b.jpg',
          workspaceCard3:
            'https://cdn.creality.com/ow/a1c/0022432a-34f9-441c-a683-eb50476e46ae.jpg',
          safetyHeaderBg:
            'https://cdn.creality.com/ow/a1c/c23ec81f-39d8-402c-9431-729e19188150.jpg',
          safetyHeaderMobile:
            'https://cdn.creality.com/ow/a1c/fa5e1724-2d84-4545-9fcc-60adba662516.jpg',
          safetyTab1:
            'https://cdn.creality.com/ow/a1c/eeb0395a-b44e-4d11-a758-5b8b1cf61b82.jpg',
          safetyTab2:
            'https://cdn.creality.com/ow/a1c/7337e5f5-7d24-40c6-9c15-88cdf1ee941f.jpg',
          safetyTab3:
            'https://cdn.creality.com/ow/a1c/3c823078-d76b-40f4-8ad6-9d5b8d097acf.jpg',
          safetyTab4:
            'https://cdn.creality.com/ow/a1c/46727a17-c9e3-4d0d-b9af-107f05702479.jpg',
          safetyTab1Mobile:
            'https://cdn.creality.com/ow/a1c/eeb0395a-b44e-4d11-a758-5b8b1cf61b82.jpg',
          safetyTab2Mobile:
            'https://cdn.creality.com/ow/a1c/7337e5f5-7d24-40c6-9c15-88cdf1ee941f.jpg',
          safetyTab3Mobile:
            'https://cdn.creality.com/ow/a1c/3c823078-d76b-40f4-8ad6-9d5b8d097acf.jpg',
          safetyTab4Mobile:
            'https://cdn.creality.com/ow/a1c/46727a17-c9e3-4d0d-b9af-107f05702479.jpg',
          softwareMain:
            'https://cdn.creality.com/ow/a1c/a66ddf29-db1a-4d38-b642-cfa9150deb18.jpg',
          softwareMainMobile:
            'https://cdn.creality.com/ow/a1c/d69acec5-ebd4-440c-bc4a-fee712db354c.jpg',
          softwarePC:
            'https://cdn.creality.com/ow/a1c/ef1fca57-3bc1-43b1-a325-0dff49e2f267.png',
          softwareDevices:
            'https://cdn.creality.com/ow/a1c/b0c3cf8d-2abd-44f8-8462-4ee0a1221301.png',
          aiVideo1:
            'https://compress-file.creality.com/videos/Agent/fca06ac5-2eeb-4659-9397-8495c244ba1e.mp4',
          aiVideo2:
            'https://compress-file.creality.com/videos/Agent/afd606b0-dfe4-4ecb-966f-6e7f3b57f05a.mp4',
          aiVideo3:
            'https://compress-file.creality.com/videos/Agent/d76e59e0-ed81-4a9b-8b88-ba40da79f539.mp4',
          aiVideo4:
            'https://compress-file.creality.com/videos/Agent/5574cae6-8f99-455e-99e8-21a3ab02c96b.mp4',
          featureSlide1:
            'https://cdn.creality.com/ow/a1c/11e77808-8031-4361-9424-ce719703636a.jpg',
          featureSlide2:
            'https://cdn.creality.com/ow/a1c/cfbdf454-7a56-4be9-b1a1-c39c69d28aad.jpg',
          featureSlide3:
            'https://cdn.creality.com/ow/a1c/dba8a26d-1825-420a-9a21-c5cfec80a714.jpg',
          featureSlide4:
            'https://cdn.creality.com/ow/a1c/e5b44e9d-dd11-4918-b549-ec20c838e033.jpg',
          featureSlide5:
            'https://cdn.creality.com/ow/a1c/d90650fa-8860-4865-bc3c-d585add8cb3d.jpg',
          featureSlide6:
            'https://cdn.creality.com/ow/a1c/367fded3-8470-4b54-9c21-0229d59491c2.jpg',
          section11EngraveCups:
            'https://cdn.creality.com/ow/a1c/7ae23e4a-2b37-4e13-acc5-5fd3200f7ef9.jpg',
          section11Maintenance:
            'https://cdn.creality.com/ow/a1c/da697e80-f7c6-4f0c-9f65-58903b65ccf5.jpg',
          section11AirPurifier:
            'https://cdn.creality.com/ow/a1c/9eec2d7d-c279-48bc-9f1a-cae6bb3c1a69.jpg',
          section11Fixture:
            'https://cdn.creality.com/ow/a1c/d699d452-0380-411b-adcb-253b625d7382.jpg',
          portablePanel1:
            'https://cdn.creality.com/ow/a1c/e2ef97f1-6b89-4dc7-855a-3db17c89105a.jpg',
          portablePanel2:
            'https://cdn.creality.com/ow/a1c/1322e478-2e1d-43ec-9a55-026fd842b29a.jpg',
          portablePanel3:
            'https://cdn.creality.com/ow/a1c/81d573c6-ba2f-4826-b16c-889c0c1021d9.jpg',
          portable1: U0,
          portable2: U0,
          accessoryAirPurifier:
            'https://cdn.creality.com/ow/a1c/f3a7416d-7f4c-443a-898d-049c47a93078.png',
          accessoryFixture:
            'https://cdn.creality.com/ow/a1c/0a8e013a-2634-4923-a03e-adadad3a86b2.png',
          accessoryFan:
            'https://cdn.creality.com/ow/a1c/36d185d2-2849-4ad3-b707-bfd91d1d12a8.png',
          accessoryRotary:
            'https://cdn.creality.com/ow/a1c/81729712-207b-45ff-b72d-a557b7abd9d7.png',
          specTable1:
            'https://cdn.creality.com/ow/a1c/f5c423b4-97d1-4aa7-a05c-ad14c73f4d79.png',
          specTable2:
            'https://cdn.creality.com/ow/a1c/4f6d443a-d609-400e-86f8-c6058ba18238.png',
          diodeSlide1:
            'https://compress-file.creality.com/images/Agent/d4a0f0d3-efa4-4845-bd25-e6edfd7adb7a.webp',
          diodeSlide2:
            'https://compress-file.creality.com/images/Agent/79865372-6529-41db-8c73-6e5ccc11e7ff.webp',
          diodeSlide3:
            'https://compress-file.creality.com/images/Agent/252a5f6c-8b04-43f6-ae41-4bde68dcbb51.webp',
          diodeSlide4:
            'https://compress-file.creality.com/images/Agent/f0684c88-0708-4ce4-8c96-5eba50756b5e.webp',
          diodeSlide5:
            'https://compress-file.creality.com/images/Agent/c8d20dc2-fdbc-418e-81b1-5fddc32409f9.webp',
          diodeSlide6:
            'https://compress-file.creality.com/images/Agent/13de810c-e448-48e6-887a-c3c22e57687a.webp',
          diodeSlide7:
            'https://compress-file.creality.com/images/Agent/ee11082d-4043-4536-8a76-f2aeda18409d.webp',
          diodeSlide8:
            'https://compress-file.creality.com/images/Agent/175c1bd8-bd23-41fa-8091-14d1d4bcf428.webp',
          diodeSlide1Mobile:
            'https://compress-file.creality.com/images/Agent/8756a8c5-9178-47a0-a2ba-42eb8e16213f.webp',
          diodeSlide2Mobile:
            'https://compress-file.creality.com/images/Agent/0b9f30a6-3ce6-4284-8ff2-404bae7bfe55.webp',
          diodeSlide3Mobile:
            'https://compress-file.creality.com/images/Agent/6fe5a1f1-d306-45ac-817d-260aa2769433.webp',
          diodeSlide4Mobile:
            'https://compress-file.creality.com/images/Agent/11fb9822-99b7-4f27-86c8-b8b2e51027e9.webp',
          diodeSlide5Mobile:
            'https://compress-file.creality.com/images/Agent/efe3395e-1af5-400c-bddf-d39dd50c8409.webp',
          diodeSlide6Mobile:
            'https://compress-file.creality.com/images/Agent/e69a771b-c69e-435c-9107-dae61b0bcc61.webp',
          diodeSlide7Mobile:
            'https://compress-file.creality.com/images/Agent/e9d1ad31-197b-4b4d-8ed7-6a82f6a4dc5f.webp',
          diodeSlide8Mobile:
            'https://compress-file.creality.com/images/Agent/4d213209-0777-4c94-b02d-1481daed8bb7.webp',
          diodeIndicator1:
            'https://cdn.creality.com/ow/a1c/fb90f520-372c-4920-b131-2825e93e3e08.png',
          diodeIndicator2:
            'https://cdn.creality.com/ow/a1c/222965ef-8ccc-4a03-8ddc-9494ed1f93fb.png',
          diodeIndicator3:
            'https://cdn.creality.com/ow/a1c/399e5b07-e21d-4d49-b3a8-ab4615cb2df8.png',
          diodeIndicator4:
            'https://cdn.creality.com/ow/a1c/430d636c-b9d0-43d3-bc39-78f92de58d52.png',
          diodeIndicator5:
            'https://cdn.creality.com/ow/a1c/83567a72-1096-4df3-a5f6-b93eeec427c9.png',
          diodeIndicator6:
            'https://cdn.creality.com/ow/a1c/ae1c000b-e30c-4f18-8f6c-2a19438727c7.png',
          diodeIndicator7:
            'https://cdn.creality.com/ow/a1c/593c6e0d-0bce-4cf0-bf4c-3a50840ba637.png',
          diodeIndicator8:
            'https://cdn.creality.com/ow/a1c/9d786fc6-e598-44e1-8a79-eb46eb41a7e7.png',
          irSlide1:
            'https://compress-file.creality.com/images/Agent/e48b0397-a764-4a61-9248-f9dbe889a706.webp',
          irSlide2:
            'https://compress-file.creality.com/images/Agent/7d217b1c-0cd9-448d-9aec-62e5ff6d5a8b.webp',
          irSlide3:
            'https://compress-file.creality.com/images/Agent/c3a29818-72ff-4413-8af8-1523175db94a.webp',
          irSlide4:
            'https://compress-file.creality.com/images/Agent/9804a2e4-5af5-437f-b05c-1b446fab4c74.webp',
          irSlide1Mobile:
            'https://compress-file.creality.com/images/Agent/ef5d0a09-793c-453e-930e-de8786d93e02.webp',
          irSlide2Mobile:
            'https://compress-file.creality.com/images/Agent/444de37a-a53d-4c12-85a4-a4e15f6a6856.webp',
          irSlide3Mobile:
            'https://compress-file.creality.com/images/Agent/b6d02949-27d4-474e-959c-b1959775c85f.webp',
          irSlide4Mobile:
            'https://compress-file.creality.com/images/Agent/ca343ea5-6259-44da-8145-aabcefe7ec95.webp',
          irIndicator1:
            'https://cdn.creality.com/ow/a1c/51f4ff6f-98ab-443d-a251-889c5eb3928e.png',
          irIndicator2:
            'https://cdn.creality.com/ow/a1c/f965744e-f0f5-4bee-be31-93033efd1458.png',
          irIndicator3:
            'https://cdn.creality.com/ow/a1c/a31fef0f-3b9b-4acc-afd1-975479ebdf3e.png',
          irIndicator4:
            'https://cdn.creality.com/ow/a1c/69abb35e-3c91-407b-9ce7-bb928b3ae304.png',
          gallerySlide1:
            'https://cdn.creality.com/ow/a1c/9c9b908b-fb5f-4981-8a53-a99a2ce8b2f5.jpg',
          gallerySlide2:
            'https://cdn.creality.com/ow/a1c/fb511449-6cf8-492c-a1db-b71a73723028.jpg',
          gallerySlide3:
            'https://cdn.creality.com/ow/a1c/9990bb06-415b-48c4-8b6a-2803ac98331f.jpg',
          gallerySlide4:
            'https://cdn.creality.com/ow/a1c/2d2b18aa-8cef-4379-8fee-76eb1dc5310c.jpg',
          gallerySlide5:
            'https://cdn.creality.com/ow/a1c/26cd50dd-6634-4308-9b57-93c80d482713.jpg',
          gallerySlide6:
            'https://cdn.creality.com/ow/a1c/25f7fbc7-70b8-41bf-9735-15b81a91be9a.jpg',
          highlight1:
            'https://cdn.creality.com/ow/a1c/85d0a10b-90b7-4191-94ba-6282643384e9.jpg',
          highlight2:
            'https://cdn.creality.com/ow/a1c/a16d4b59-7d97-40c1-bbb2-e7ad7914d56e.jpg',
          highlight3:
            'https://cdn.creality.com/ow/a1c/f8882d2a-1edc-4987-8729-d475ffafc7a4.jpg',
          highlight4:
            'https://cdn.creality.com/ow/a1c/fd101047-4f6c-48c4-99d5-1362dbbc14b9.jpg',
          highlight5:
            'https://cdn.creality.com/ow/a1c/c389a123-2b56-4db5-93d1-2bf5bfb15b35.jpg',
          highlight6:
            'https://cdn.creality.com/ow/a1c/c6efb0ff-5e2c-42ac-aead-57e16c3c6a16.jpg',
          highlight7:
            'https://cdn.creality.com/ow/a1c/e402112e-9ccb-4867-921b-80f948e358be.jpg',
          highlight8:
            'https://cdn.creality.com/ow/a1c/a0c5ae3b-20bc-40f6-8d17-3a8d9132e03f.jpg',
          highlight1Mobile:
            'https://cdn.creality.com/ow/a1c/9db34ded-2f6e-4b91-b700-5aecb6e2b092.jpg',
          highlight2Mobile:
            'https://cdn.creality.com/ow/a1c/9d6e2c53-cc40-4335-b32d-6887fdf85efe.jpg',
          highlight3Mobile:
            'https://cdn.creality.com/ow/a1c/dbe31ebc-3770-4f56-a0ba-90ae6ad8b790.jpg',
          highlight4Mobile:
            'https://cdn.creality.com/ow/a1c/b7a8fc19-05a4-4570-9583-cd02a24aa0d1.jpg',
          highlight5Mobile:
            'https://cdn.creality.com/ow/a1c/8ebae2e4-d23b-429b-9663-b51c9f4a2e59.jpg',
          highlight6Mobile:
            'https://cdn.creality.com/ow/a1c/e14ac5b8-dbae-472b-b517-fa8b9a0e8dc2.jpg',
          highlight7Mobile:
            'https://cdn.creality.com/ow/a1c/e205dcc2-9eb7-4feb-8bab-8678c89920e1.jpg',
          highlight8Mobile:
            'https://cdn.creality.com/ow/a1c/20fcb282-166d-4714-943f-8223870cf891.jpg',
          ...g4,
          ...r3,
        },
        y4 = { en: { translation: h4, imageUrl: b4 } };
      Mu.use(AE).init({
        resources: y4,
        lng: aD(),
        fallbackLng: 'en',
        interpolation: { escapeValue: !1 },
        initImmediate: !1,
      });
      function v4(i) {
        const l = {
          cn: 'zh-CN',
          en: 'en-US',
          br: 'pt-BR',
          de: 'de-DE',
          es: 'es-ES',
          fr: 'fr-FR',
          it: 'it-IT',
          jp: 'ja-JP',
          kr: 'ko-KR',
          ru: 'ru-RU',
        };
        document.documentElement.lang = l[i] || 'en-US';
      }
      v4(Mu.language);
      const xp = document.getElementById('product-detail-a1c'),
        I0 = g.jsxDEV(
          Z.StrictMode,
          {
            children: g.jsxDEV(
              kE,
              {
                i18n: Mu,
                children: g.jsxDEV(
                  p4,
                  {},
                  void 0,
                  !1,
                  {
                    fileName:
                      'D:/works/creality-offical-product/src/pages/A1CWhite/main.tsx',
                    lineNumber: 18,
                    columnNumber: 7,
                  },
                  void 0
                ),
              },
              void 0,
              !1,
              {
                fileName:
                  'D:/works/creality-offical-product/src/pages/A1CWhite/main.tsx',
                lineNumber: 17,
                columnNumber: 5,
              },
              void 0
            ),
          },
          void 0,
          !1,
          {
            fileName:
              'D:/works/creality-offical-product/src/pages/A1CWhite/main.tsx',
            lineNumber: 16,
            columnNumber: 3,
          },
          void 0
        );
      xp.hasChildNodes()
        ? c0.hydrateRoot(xp, I0)
        : c0.createRoot(xp).render(I0);
})();